import { SvgIcon } from '@mui/material';

export function EmptyStateIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 237.57,
    height: 193.748,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 237.57 193.748"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Verify OTP" transform="translate(-43.997 -3)" opacity={0.8}>
        <path
          data-name="Path 4696"
          d="M243.9 4.5a3 3 0 015.2 0l21.218 36.75a3 3 0 01-2.6 4.5h-42.436a3 3 0 01-2.6-4.5z"
          transform="translate(-18)"
          fill="rgba(90,197,179,0.1)"
        />
        <circle
          data-name="Ellipse 39445"
          cx={19}
          cy={19}
          r={19}
          transform="translate(88.529 14)"
          fill="rgba(90,197,179,0.1)"
        />
        <g
          data-name="Group 5436"
          opacity={0.15}
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        >
          <path
            data-name="Path 4735"
            d="M295.75 151.508h-62.435V38.427A30.427 30.427 0 01263.742 8a31.993 31.993 0 0131.994 31.994v111.514z"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4736"
            d="M288.689 151.172V40.244a24.169 24.169 0 00-24.169-24.169h0a24.169 24.169 0 00-24.156 24.169V151.19"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4737"
            d="M264.533 8v143.34"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4738"
            d="M295.414 35.612h-61.682"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4739"
            d="M295.414 55.081h-61.682"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4740"
            d="M295.414 74.549h-61.682"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4741"
            d="M295.414 94.023h-61.682"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4742"
            d="M295.414 113.493h-61.682"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4743"
            d="M295.414 132.962h-61.682"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4744"
            d="M287.167 17.741l-5.591 5.1"
            opacity={0.3}
            transform="translate(-18)"
          />
          <path
            data-name="Path 4745"
            d="M242.13 17.741l5.6 5.1"
            opacity={0.3}
            transform="translate(-18)"
          />
        </g>
        <g
          data-name="Group 5437"
          opacity={0.15}
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        >
          <path
            data-name="Path 4746"
            d="M66.435 151.508H4V38.427A30.427 30.427 0 0134.427 8a31.994 31.994 0 0131.994 31.994v111.514z"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4747"
            d="M59.383 151.172V40.244a24.17 24.17 0 00-24.169-24.187h0a24.169 24.169 0 00-24.188 24.187V151.19"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4748"
            d="M35.214 8v143.34"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4749"
            d="M66.1 35.612H4.413"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4750"
            d="M66.1 55.081H4.413"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4751"
            d="M66.1 74.549H4.413"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4752"
            d="M66.1 94.023H4.413"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4753"
            d="M66.1 113.492H4.413"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4754"
            d="M66.1 132.961H4.413"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4755"
            d="M57.852 17.741l-5.595 5.1"
            opacity={0.3}
            transform="translate(45.529)"
          />
          <path
            data-name="Path 4756"
            d="M12.814 17.741l5.59 5.1"
            opacity={0.3}
            transform="translate(45.529)"
          />
        </g>
        <path
          data-name="Path 4757"
          d="M236.529 196.248h44.538"
          fill="none"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        />
        <path
          data-name="Path 4758"
          d="M44.5 196.248h185.531"
          fill="none"
          stroke="#263238"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1}
        />
        <g data-name="Group 5561">
          <path
            data-name="Path 4344"
            d="M30.275 138.989s0-1.274-1.788-3.062-2.934-2.809-2.934-2.809-.9 2.937.764 4.722a31.408 31.408 0 003.952 3.448z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4345"
            d="M27.684 146.965s0-1.278-1.785-3.066-2.937-2.809-2.937-2.809-.892 2.937.767 4.725a31.446 31.446 0 003.955 3.438z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4346"
            d="M30.163 141.166s.135-1.272 2.1-2.859 3.217-2.483 3.217-2.483.579 3.013-1.261 4.61a31.328 31.328 0 01-4.3 3.01z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4347"
            d="M27.026 150.571s.27-1.248 2.391-2.634 3.461-2.131 3.461-2.131.257 3.059-1.739 4.459a31.542 31.542 0 01-4.61 2.542z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4348"
            d="M27.618 160.848s0-1.278 1.788-3.066 2.937-2.809 2.937-2.809.892 2.938-.767 4.726a31.33 31.33 0 01-3.952 3.447z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4349"
            d="M27.588 163.354s.181-1.265-1.317-3.293-2.506-3.2-2.506-3.2-1.317 2.78.086 4.785a31.456 31.456 0 003.428 3.975z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4350"
            d="M25.826 170.78s0-1.278 1.788-3.063 2.937-2.809 2.937-2.809.892 2.934-.767 4.722a31.337 31.337 0 01-3.952 3.448z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4351"
            d="M27.024 177.514s-.329-1.234.952-3.418 2.131-3.461 2.131-3.461 1.607 2.615.454 4.765a31.206 31.206 0 01-2.964 4.337z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4352"
            d="M30.437 138.663a36.554 36.554 0 01-.487 3.951c-.708 3.649-2.473 6.007-3.181 9.3s1.317 7.544.781 11.779-2.193 6.586-1.722 9.418 2.944 10.479 2.944 10.479"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4353"
            d="M30.147 142.012l1.926-1.475"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4354"
            d="M30.236 140.31l-.807-1.433"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4355"
            d="M26.876 151.78s1.61-1.209 3.27-2.421"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4356"
            d="M27.683 149.254a25.778 25.778 0 00-2.865-4.383"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4357"
            d="M27.683 162.662a19.911 19.911 0 013.448-4.61"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4358"
            d="M27.353 164.457a22.7 22.7 0 00-1.745-3.316c-.942-1.39-1.077-1.568-1.077-1.568"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4359"
            d="M25.826 173.128a21.233 21.233 0 011.452-2.937 18.652 18.652 0 011.88-2.463"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4360"
            d="M27.6 179.737a5.487 5.487 0 01.484-2.823c.659-1.3 1.432-3 1.745-3.671"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4361"
            d="M18.572 156.047a3.184 3.184 0 01.787-2.118c.925-1.317 1.538-2.077 1.538-2.077a3.426 3.426 0 01.033 3.046 19.864 19.864 0 01-2.108 2.588z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4362"
            d="M21.065 160.779a3.177 3.177 0 01.787-2.117c.925-1.314 1.551-2.091 1.551-2.091a3.413 3.413 0 01.03 3.043 19.95 19.95 0 01-2.108 2.591z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4363"
            d="M18.878 157.4s-.224-.781-1.627-1.564-2.289-1.209-2.289-1.209a3.422 3.422 0 001.294 2.76 20.068 20.068 0 003.024 1.413z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4364"
            d="M21.865 162.962s-.3-.754-1.782-1.383-2.4-.961-2.4-.961a3.411 3.411 0 001.574 2.6 19.821 19.821 0 003.158 1.1z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4365"
            d="M22.611 169.463s-.138-.8-1.452-1.725-2.147-1.443-2.147-1.443a3.438 3.438 0 00.988 2.879 19.987 19.987 0 002.855 1.732z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4366"
            d="M22.9 171.033a3.157 3.157 0 01.478-2.206c.731-1.432 1.225-2.279 1.225-2.279a3.429 3.429 0 01.468 3.01 20.059 20.059 0 01-1.719 2.865z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4367"
            d="M25.143 177.491s.092-.807 1.354-1.808 2.058-1.564 2.058-1.564a3.421 3.421 0 01-.826 2.93 19.85 19.85 0 01-2.753 1.894z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4368"
            d="M24.812 175.5s-.138-.8-1.452-1.729-2.147-1.442-2.147-1.442a3.433 3.433 0 00.988 2.878 19.84 19.84 0 002.848 1.732z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4369"
            d="M24.8 179.849a3.165 3.165 0 00-.968-2.038 48.997 48.997 0 00-1.712-1.94 3.427 3.427 0 00.231 3.036 19.993 19.993 0 002.325 2.4z"
            fill="#4cc5b1"
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4370"
            d="M18.434 155.859a23.376 23.376 0 00.738 2.433c.84 2.21 2.2 3.5 3 5.487s0 4.877.79 7.471 2.091 3.9 2.1 5.72-.708 6.889-.708 6.889"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4371"
            d="M18.981 157.928l-1.367-.718"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4372"
            d="M18.74 156.87l.349-.988"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4373"
            d="M22.086 163.7s-1.143-.583-2.305-1.162"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4374"
            d="M21.313 162.205a16.292 16.292 0 011.317-3.059"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4375"
            d="M22.768 170.609a12.783 12.783 0 00-2.657-2.52"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4376"
            d="M23.159 171.7a14.5 14.5 0 01.734-2.269l.5-1.1"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4377"
            d="M25.007 178.354a11.864 11.864 0 011.469-1.528 8.05 8.05 0 00.958-.833"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4378"
            d="M25.066 176.971a13.657 13.657 0 00-1.228-1.686 11.847 11.847 0 00-1.446-1.334"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4379"
            d="M24.671 181.308a3.468 3.468 0 00-.609-1.722c-.563-.741-1.225-1.726-1.495-2.114"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
          <path
            data-name="Path 4380"
            d="M29.93 196.014h-7.462a.585.585 0 01-.586-.586l-1.851-12.355h12.336l-1.851 12.355a.585.585 0 01-.586.586z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(227.457 -.099)"
          />
        </g>
        <g data-name="Sport family-bro">
          <path
            data-name="Path 20843"
            d="M22.344 2.598s-2.9-2.356-3.312-1.354 1.536 2.07 1.536 2.07-4.666-1.159-5.1-.269.977 1.776.977 1.776-3.064.195-3.014 1a1.35 1.35 0 00.559 1.1s-3.9.791-3.618 1.747a1.556 1.556 0 001.416.989s-2.761 1.445-2.683 2.819c.05.915 1.486 1.635 1.747 1.991 0 0-3.039 2.3-.927 4.111s3.548 1.4 3.548 1.4-1.379 1.242-.29 2.232 1.685.166 1.685.166-.145 1.954.679 2.169 1.929-1.093 1.929-1.093.161 1.656 1.35 1.693a2.115 2.115 0 001.739-.7s.5.994 1.085.9a1.693 1.693 0 00.94-.493 5.238 5.238 0 003.726.791c1.805-.493 2.153-.952 2.153-.952s1.975.472 2.6.108a4.525 4.525 0 001.027-.828 1.445 1.445 0 001.739.157 2.356 2.356 0 00.787-2.049s1.076.745 1.557-.153a1.78 1.78 0 00.232-1.474s1.921.472 2.352-.414-.882-1.942-.882-1.942a1.126 1.126 0 001.656-.538c.575-1.172-.7-3.411-.7-3.411s1.37.29 1.507-.907a2.6 2.6 0 00-.828-2.07s1.507-.1.94-1.358a4.053 4.053 0 00-2.169-1.805 2.841 2.841 0 00-.07-2.807c-.9-1.35-4.389-1.014-4.389-1.014s2.012-.671.828-1.565-4.322-.046-4.322-.046.737-1.13-.886-1.134a3.857 3.857 0 00-2.389.638s1.321-2.136-.414-2.07-3.37 2.215-3.37 2.215-.414-1.379-.828-.923-.103 1.297-.103 1.297z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20844"
            d="M21.698 23.645a40.025 40.025 0 01-.542 6.007c-.414 1.3-3.221 2.554-4.831 2.724s-5.225 1.751-5.192 5.465 1.975 12.735 3.209 15.36 1.358 3.337 1.2 5.328-2.761 5.61-3.792 9.522c-2.5 9.522-2.873 20.423 2.008 29.37 1.573 2.9 1.217 5.8 1.2 8.951a32.221 32.221 0 001.987 10.665c1.606 4.43 3.06 14.846 3.271 16.56a5.2 5.2 0 01-1.2 3.548 7.866 7.866 0 01-2.981 2.484c-1.42.642-2.2 1.139-1.35 1.565s10.114-.178 10.292 0 .638-.414.211-2.629a33.093 33.093 0 01-.07-6.529s-.066-9.307.166-16.56a92.114 92.114 0 00-.352-13.41c-.161-.7-.414-15.393.257-17.115a21.356 21.356 0 00.865-4.923 52.436 52.436 0 017.245 3.378c3.892 2.169 15.865 6.624 18.837 6.318s3.544-5.7-1.292-11.394-13.248-10.3-13.642-11.071-.555-4.885-1.611-7.27a8.05 8.05 0 01-1.039-4.372c-.05-1.772 4.931-10.2 4.844-14.9s-1.052-6.848-2.07-7.928-6.185-1.909-7.075-2.484-1.822-5.684-2.087-6.512-6.466-.148-6.466-.148z"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20845"
            d="M26.302 25.629l-5.068 3.233.468-5.217z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20846"
            d="M38.394 45.663l-6.153-14.511-.733-.166a8.837 8.837 0 01-.07 4.774c-1.354 3.312-4.629 3.991-7.754 3.652-2.811-.3-4.707-3.614-4.467-7.841a11.037 11.037 0 01-1.068.414c-1 2.571-4.4 10.247-5.022 12.677a52.207 52.207 0 00-.712 3.126 46.544 46.544 0 001.933 5.4 21.743 21.743 0 01.89 2.1l19.487-.513c.556-1.83 2.465-5.581 3.669-9.112z"
            fill="#92e3d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20847"
            d="M37.211 67.262c-.282-.584-.455-3.089-.981-5.308-11.108 2.778-18.63 1.172-21.98.054a32.822 32.822 0 00-2.484 6.069c-2.5 9.522-2.873 20.423 2.008 29.37 1.573 2.9 1.217 5.8 1.2 8.951a32.223 32.223 0 001.987 10.665 48.115 48.115 0 011.582 6.169l6.624-.174c0-2.459.058-5.121.137-7.56a91.482 91.482 0 00-.352-13.41c-.161-.7-.414-15.393.257-17.115a21.356 21.356 0 00.865-4.923 52.431 52.431 0 017.216 3.358c3.892 2.169 15.865 6.624 18.837 6.318s3.544-5.7-1.292-11.394-13.247-10.304-13.624-11.07z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20848"
            d="M22.451 9.118a19.978 19.978 0 01-1.358 2.956 7.788 7.788 0 01-2.538 2.513s.712 5.751 1.076 6.719a11.942 11.942 0 002.79 4.67c.932.807 2.927 1.888 4.293 1.13 2.741-1.519 4.037-4.442 4.343-7.452.141-1.387-.046-6.078-.046-6.078a7.226 7.226 0 01-1.76-1.553 8.85 8.85 0 01-.526-1s-.464.774-.94.518a26.164 26.164 0 01-2.554-3.163 13.082 13.082 0 01-1.917 2.36c-.611.388-.863-1.62-.863-1.62z"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20849"
            d="M18.97 17.543s-1.242-1.47-1.689-.414.315 2.215.749 2.761a2.7 2.7 0 001.424.712z"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20850"
            d="M31.153 16.632s.919-1.474 1.5-.48a2.935 2.935 0 01-.393 2.836 2.555 2.555 0 01-1.18.89z"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20851"
            d="M23.817 19.862a2.186 2.186 0 001.383.7 1.739 1.739 0 001.557-.758"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20852"
            d="M22.993 21.758s2.178 2.277 4.9-.315"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20853"
            d="M465.973 149.854c.029.46-.141.828-.385.861s-.464-.344-.493-.807.145-.828.385-.861.464.34.493.807z"
            transform="translate(-134.724 -47.971) translate(303.569 102.111) translate(-442.943 -133.102)"
            fill="#263238"
          />
          <path
            data-name="Path 20854"
            d="M477.842 149.084c.033.46-.141.828-.385.861s-.46-.344-.493-.807.145-.828.389-.861.447.348.489.807z"
            transform="translate(-134.724 -47.971) translate(303.569 102.111) translate(-449.897 -132.651)"
            fill="#263238"
          />
          <path
            data-name="Path 20855"
            d="M20.745 15.44s.576-1.317 2.72-.882"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20856"
            d="M25.962 14.355a2.852 2.852 0 012.968.253"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20857"
            d="M16.775 32.617s-4.037-.414-5.9.344-2.6 3.664-2.761 4.906-6.926 12.048-7.038 12.648-.932 2.339 1.081 3.279a4.05 4.05 0 004.993-1.321c.762-1.275 5.15-9.547 5.15-9.547"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20858"
            d="M33.646 32.17s4.008-.609 5.912.033 2.795 3.511 3.018 4.761 7.547 11.667 7.688 12.259 1.052 2.289-.907 3.312a4.075 4.075 0 01-5.055-1.056c-.824-1.234-6.152-9.054-6.152-9.054"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20859"
            d="M5.137 50.15a47.383 47.383 0 006.964 1.275c2.869.368 10.044-.6 10.044-.6a6.259 6.259 0 00.94-2.008c.489-3.225 1.039-3.937 1.242-5.593.356-2.9.795-2.538.882-1.656s0 6.885.07 7.609a15.216 15.216 0 01.219 3.349c-.195.451-.112 1.656-1.76 1.784l-1.4.1s-9.191 1.1-12.366 1.242-7.241.907-8.98.422-.828-4.413-.079-5.556a3.573 3.573 0 011.813-1.441"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20860"
            d="M45.711 49.078a47.726 47.726 0 01-6.889 1.656c-2.844.522-10.06-.066-10.06-.066a6.264 6.264 0 01-1.043-1.958c-.658-3.192-1.242-3.875-1.536-5.519-.509-2.9-.927-2.484-.969-1.627s.377 6.873.327 7.6a14.592 14.592 0 00-.041 3.358c.211.46.2 1.656 1.855 1.689.662 0 1.4.029 1.4.029s9.241.6 12.4.6 7.295.538 9-.037.609-4.451-.215-5.556a3.577 3.577 0 00-1.888-1.337"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20861"
            d="M49.478 84.824s-16.333 1.1-18.784 1.167-5.3-.6-6.322-.058-1.209 2.116-.807 3.312a6.512 6.512 0 01.331 4.008 8.842 8.842 0 00-.178 4.612c.41 1.474 1.047 3.022 1.938 2.927s.567-.981.7-1.507a43.105 43.105 0 011.362-4.794c.625-1.582 1.176-3.378 2.339-4.3s11.158.075 16.916 1.337 9.241.725 10.632-.207 1.623-3.312-1.068-6.591-5.688-6.384-5.688-6.384"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <path
            data-name="Path 20862"
            d="M36.896 85.644c-2.9.182-5.361.323-6.21.348-2.451.062-5.3-.6-6.322-.058s-1.209 2.116-.807 3.312a6.512 6.512 0 01.331 4.008 8.843 8.843 0 00-.178 4.612c.41 1.474 1.047 3.022 1.938 2.927s.567-.981.7-1.507a43.1 43.1 0 011.362-4.794c.625-1.581 1.176-3.378 2.339-4.3.6-.476 3.536-.443 7.038-.124a22.631 22.631 0 01-.191-4.424z"
            fill="#d6d6d6"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            transform="translate(-134.724 -47.971) translate(303.569 102.111)"
          />
          <g transform="translate(-134.724 -47.971) translate(227.25 96.159)">
            <path
              data-name="Path 20863"
              d="M16.425 31.999s-2.364 1.341-4.554 5.349a91.282 91.282 0 01-7.452 11.8C2.096 52.034.693 53.59 2.001 55.383s10.524 8.967 10.524 8.967a8.08 8.08 0 00.625 2.182c.389.625.857 1.325.857 1.325s-1.093.079-.468.7a7.1 7.1 0 002.26 1.4 28.25 28.25 0 002.26-5.924c-.157-.315-4.14-3.275-4.989-5.146s-2.728-5.61-2.728-5.61l3.726-4.525s0-7.949 1.014-11.538 1.814-5.372 1.343-5.215z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20864"
              d="M9.878 52.514s-2.029-2.339-3.275-2.807"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Line 467"
              transform="translate(14.01 67.861)"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              d="M0 0L0.857 0.778"
            />
            <path
              data-name="Path 20865"
              d="M36.031 18.109a31.717 31.717 0 00-1.49 7.523c-.091 3.325 4.111 2.273 6.91 4.107s3.5 3.5 3.585 7.258-6.819 16.788-7.084 18.539.787 8.479.874 10.578a65.907 65.907 0 00.7 8.131 95.4 95.4 0 011.139 17.927c-.261 8.044-.874 9.2-.352 11.265a29.625 29.625 0 01.965 14.515c-1.312 7.87-2.9 15.041-2.9 16.088s.348 4.285.348 4.285h-5.933a24.4 24.4 0 01-.439-5.332c0-3.585.178-6.823-.087-10.056s-1.747-7.171-2.186-11.456a39.3 39.3 0 01.178-8.479l-2.8-12.594s-1.925 13.029-2.012 13.816a16.305 16.305 0 00.613 6.471 20.58 20.58 0 01-.352 10.056c-.613 1.838-2.625 11.642-2.625 11.642l-.352 6.471s-2.186 1.834-3.233 1.656-2.8-1.486-2.9-2.012-.439-22.207-.613-24.567-.261-7.7-.261-7.7a71.365 71.365 0 01-1.656-11.116c-.215-3.556-.414-8.856.969-20.974a91.356 91.356 0 00-.439-19.674c-.526-3.585-2.186-6.384-1.486-13.29s3.672-10.23 6.3-11.282 5.419-.961 6.293-2.534.691-4.629.691-4.629z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20866"
              d="M26.513 24.398c.729-.186 8.139-.294 8.139-.294l1.371-5.995z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20867"
              d="M32.371 134.173h6.028c.025 1.155.348 4.165.348 4.165h-5.958a21.875 21.875 0 01-.418-4.165z"
              fill="#d6d6d6"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20868"
              d="M22.99 134.173l-.257 4.691s-2.186 1.834-3.233 1.656-2.8-1.486-2.9-2.012c-.025-.141-.066-1.863-.12-4.339z"
              fill="#d6d6d6"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20869"
              d="M25.499 5.143s-2.459 9.63-2.968 11.075-.145 2.1.8 4.554 1.375 3.312 3.184 3.618 4.7-.795 6.367-1.88a13.944 13.944 0 003.838-4.343c.65-1.155 2.459-8.255 2.459-8.255a4.914 4.914 0 00-2.1-4.7c-2.6-1.739-4.993-2.534-6.8-2.174a21.258 21.258 0 00-4.78 2.105z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20870"
              d="M27.673 9.63a8.831 8.831 0 01-1.159 3.767c-1.085 1.809-1.461 2.095-1.027 2.749a2.254 2.254 0 003.672-.124"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20871"
              d="M30.492 17.377a4.4 4.4 0 01-4.633 1.809"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20872"
              d="M30.347 9.63a2.712 2.712 0 012.824 1.524"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20873"
              d="M27.453 8.835s-.869-1.519-2.1-.58"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20874"
              d="M301.166 126.617c-.128.414-.041.795.2.874s.542-.186.671-.592.046-.8-.2-.878-.537.19-.671.596z"
              transform="translate(-270.53 -113.649)"
              fill="#263238"
            />
            <path
              data-name="Path 20875"
              d="M290.014 122.843c-.132.414-.041.8.2.878s.542-.19.671-.6.041-.795-.2-.874-.543.194-.671.596z"
              transform="translate(-263.993 -111.44)"
              fill="#263238"
            />
            <path
              data-name="Path 20876"
              d="M38.167 16.652s3.834-7.038 3.184-8.976-9.626-8.467-14.4-7.6-.944 1.954-.944 1.954-3.979 1.954-3.979 3.4 9.771-.414 9.771-.414-1.954 1.59-.869 1.954 3.4.865 3.623.94 2.819 2.169 1.88 2.169-2.025-.414-1.519.509a12.152 12.152 0 001.159 1.735s-.58 3.838-.509 4.2 1.375-.94 1.375-.94z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20877"
              d="M35.659 17.472s1.913-2.716 3.039-2.07-.348 4.2-1.126 4.691-2.952-.414-2.952-.414"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20878"
              d="M38.249 60.608c.24 2.19.534 4.442.576 5.506a65.913 65.913 0 00.7 8.131 95.4 95.4 0 011.139 17.927c-.054 1.606-.12 2.935-.186 4.057H28.749l-1.288-5.8s-.414 2.757-.857 5.8H14.149a32.511 32.511 0 01-.079-1.1c-.215-3.556-.414-8.856.969-20.974a81.089 81.089 0 00.149-13.551z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20879"
              d="M13.29 44.341c1.486-4.894 3.5-6.38 5.25-8.744a36.7 36.7 0 003.192-6.388c.737-.178 1.437-.335 2.049-.534a19.164 19.164 0 00-2.356 7.1c-.878 5.419 1.656 5.419 5.246 4.107s6.558-9.108 7.518-10.843c.414-.737.72-1.288.944-1.681a4.384 4.384 0 002.07.961 20.886 20.886 0 00-5.544 9.551c-1.577 6.384 2.621 11.456 5.68 11.895a7.427 7.427 0 003.225-.385 52.748 52.748 0 00-2.612 6.156 41.925 41.925 0 00.484 6.732H15.31c-.166-3.271-.464-6.127-.708-7.783-.414-2.757-1.478-5.047-1.635-9.108q.178-.494.323-1.036z"
              fill="#92e3d6"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129149"
              cx={8.396}
              cy={8.396}
              r={8.396}
              transform="translate(0 22.742)"
              fill="#878787"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129150"
              cx={8.396}
              cy={8.396}
              r={8.396}
              transform="translate(.874 22.742)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129151"
              cx={2.058}
              cy={2.058}
              r={2.058}
              transform="translate(7.212 29.081)"
              fill="#878787"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20880"
              d="M41.446 29.743s3.672 1.573 4.02 5.337-.609 9.439-4.02 12.5-9.183 12.329-10.764 12.151S15.52 48.092 12.958 45.384s-6.057-5.763-7.2-7.514a16.1 16.1 0 01-1.925-5.159c-.087-.7 2.977-3.585 3.937-3.494s2.36 2.447 2.36 2.447 1.838.613 2.012 1.242-.352 1.4-.352 2.008.352 1.838.087 2.451-.522 1.4-.522 1.4a23.8 23.8 0 004.02 2.621c1.747.787 12.681 4.637 12.681 4.637a37.255 37.255 0 012.186-4.637 10.736 10.736 0 012.621-2.273 9.51 9.51 0 011.052-3.411"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20881"
              d="M28.07 46.005a6.714 6.714 0 001.134 2.621"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20882"
              d="M12.437 39.555a18.274 18.274 0 002.952 1.813c.381.17 1.192.484 2.232.874l-2.869 4.852c-.782-.716-1.408-1.308-1.784-1.71a87.212 87.212 0 00-2.393-2.41z"
              fill="#a7e8de"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129152"
              cx={8.396}
              cy={8.396}
              r={8.396}
              transform="translate(3.407 22.742)"
              fill="#878787"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129153"
              cx={8.396}
              cy={8.396}
              r={8.396}
              transform="translate(4.285 22.742)"
              fill="#878787"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129154"
              cx={2.058}
              cy={2.058}
              r={2.058}
              transform="translate(10.624 29.081)"
              fill="#878787"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20883"
              d="M32.918 136.214s1.358-2.31 3.258-2.1 2.037 2.1 2.037 2.716 1.428 2.712 1.561 3.461a6.624 6.624 0 001.089 2.306 4.554 4.554 0 011.424 1.428 4.45 4.45 0 01.679 2.579c-.149.745-1.018.679-1.764.745s-8.694 0-8.694 0a4.14 4.14 0 01-.882-1.9c-.207-1.155.132-3.055 0-4.616s-.613-3.122-.137-3.8a2.331 2.331 0 011.429-.819z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20884"
              d="M31.746 145.923h11.207a2.2 2.2 0 010 .679c-.137.745-1.018.679-1.764.745s-8.694 0-8.694 0a4.141 4.141 0 01-.749-1.424z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20885"
              d="M23.547 137.166s.2 7.672.137 8.417a1.347 1.347 0 01-.952 1.358c-.613.2-4.885.066-6.04.339a39.353 39.353 0 01-6.79.414c-1.018-.128-2.31.207-2.513-1.018a2.641 2.641 0 01.613-2.306 53.734 53.734 0 004.968-2.579 11.075 11.075 0 002.782-2.919c.34-.679.273-2.65 1.155-2.583s1.7 1.242 1.971 1.834l.269.613a27.5 27.5 0 003.122-.476c.534-.212.464-1.702 1.278-1.094z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20886"
              d="M9.903 147.687c-1.018-.132-2.31.207-2.513-1.018a1.745 1.745 0 010-.207 26.384 26.384 0 007.146-.062c2.422-.368 7.167-.9 9.179-1.122v.306a1.352 1.352 0 01-.952 1.358c-.613.2-4.885.066-6.04.339a38.845 38.845 0 01-6.82.406z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
          </g>
          <g transform="translate(-134.724 -47.971) translate(261.522 121.817)">
            <path
              data-name="Path 20887"
              d="M44.183 30.66s-.393 4.095-.393 7.56.551 9.3.551 9.3.551 6.21.551 10.16a76.493 76.493 0 01-.551 8.28 33.523 33.523 0 01-.236 4.492c-.236.708-1.813 2.128-2.443 2.836s-1.337.708-1.337.472a2.024 2.024 0 01.551-1.18 5.536 5.536 0 001.1-1.656c.079-.315 0-2.679 0-2.679a5.883 5.883 0 00-.944 1.656c-.236.787-.708 2.285-1.105 2.045s-.079-1.809.157-2.36-.157-2.836.476-3.627.944-.472 1.18-1.809-1.577-9.849-1.971-11.977-.629-6.065-.629-6.065l-1.18-11.265z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20888"
              d="M16.841 87.301s-.166 3.238-.414 4.815-1.495 4.649-.749 9.468a122.27 122.27 0 01.915 13.12c0 .5-.166 2.327-.166 2.327h4.483a30.4 30.4 0 001.081-5.316c-.083-1.176.331-9.22.828-10.88a76.355 76.355 0 001.329-8.719c.166-1.743.584-4.815.584-4.815z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20889"
              d="M20.833 113.66s-.965-1.635-2.31-1.495-1.445 1.495-1.445 1.929-1.014 1.925-1.11 2.455a4.729 4.729 0 01-.77 1.656 3.167 3.167 0 00-1.01 1.01 3.275 3.275 0 00-.484 1.83c.1.53.724.484 1.242.53s6.165 0 6.165 0a2.948 2.948 0 00.625-1.35c.145-.828-.1-2.165 0-3.275s.435-2.215.1-2.7a1.656 1.656 0 00-1.003-.59z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20890"
              d="M21.664 120.55h-7.957a1.561 1.561 0 000 .48c.1.53.725.484 1.242.53s6.165 0 6.165 0a2.9 2.9 0 00.551-1.01z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20891"
              d="M32.619 88.274l.253 3.242s-.335 4.9.5 7.8 4.07 17.442 4.07 17.442l4.14-.083s-.828-14.118-.584-17.856-.828-9.3-.828-9.551-.414-3.072-.414-3.072z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20892"
              d="M41.341 113.355s-1.163-1.081-2.244-.331a2.963 2.963 0 00-1.08 2.244s-1.656-.17-1.743.5a27.678 27.678 0 00.58 5.564 23.7 23.7 0 003.726.58c.484.083 4.318.414 5.564-.248s.166-1.495-.5-2.484-2.658-2.484-3.159-3.238a17.3 17.3 0 01-1.144-2.587z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20893"
              d="M39.76 120.576a10.808 10.808 0 00-3.142-.327 3.676 3.676 0 00.236 1.076 23.783 23.783 0 003.726.58c.484.083 4.318.414 5.564-.248.675-.36.667-.77.414-1.242a12.783 12.783 0 01-6.798.161z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20894"
              d="M15.098 67.681l-2.484 19.015a21.363 21.363 0 006.81 2.327 24.012 24.012 0 006.81.083l1.412-10.3.414 10.3a23.849 23.849 0 007.974.58 22.836 22.836 0 007.473-2.571l-3.486-19.516H15.346z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20895"
              d="M39.14 35.549l6.777-5.117s-.869-2.679-2.6-3.627-6.7-2.128-7.564-2.364-2.443-1.1-2.757-1.888a20.664 20.664 0 01-.551-3.391l-6.7-.787s-.509 3.192-1.143 4.057-.944 1.341-4.724 2.364a21.528 21.528 0 00-4.451 1.143 12.883 12.883 0 00-3.548 2.443l2.016 2.07a27.447 27.447 0 01-3.117 5.419c-.219.311-2.993 5.121-2.993 5.121l9.452 8.193s-2.9 17.8-2.993 18.751l-.079.944a69.036 69.036 0 0014.718 1.689 52.253 52.253 0 0011.911-1.611S38.823 46.9 38.823 43.434s.317-7.885.317-7.885z"
              fill="#92e3d6"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20896"
              d="M28.86 31.132c3.221 0 5.933-2.857 6.744-6.74a4.907 4.907 0 01-2.608-1.846 21.882 21.882 0 01-.551-3.391l-6.703-.787s-.509 3.192-1.143 4.057a4.042 4.042 0 01-2.542 1.706c.75 4.016 3.512 7.001 6.803 7.001z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20897"
              d="M33.977 23.568a2.662 2.662 0 01-.981-1.023 20.729 20.729 0 01-.551-3.391l-6.7-.787s-.509 3.192-1.143 4.057a3.234 3.234 0 01-1.118 1.085c1.047 2.2 3.1 5.8 5.332 5.966 2.474.183 4.292-3.684 5.161-5.907z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20898"
              d="M31.24 19.854l-7.216 3.565s1.88-3.229 1.722-5.051 5.494 1.486 5.494 1.486z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20899"
              d="M17.239 49.171l-.551-14.809-2.79-3.925a27.446 27.446 0 01-3.117 5.419c-.219.311-2.993 5.121-2.993 5.121z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <circle
              data-name="Ellipse 129155"
              cx={8.272}
              cy={8.272}
              r={8.272}
              transform="matrix(.974 -.224 .224 .974 0 39.417)"
              fill="#b2b2b2"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20900"
              d="M10.987 37.433a11.876 11.876 0 000 16.387 8.28 8.28 0 000-16.387z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20901"
              d="M1.643 45.626a8.21 8.21 0 002.244 5.655 8.243 8.243 0 00.393-11.7 8.235 8.235 0 00-2.637 6.045z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20902"
              d="M11.165 45.941a8.255 8.255 0 003.312 6.583 8.255 8.255 0 00.435-13.5 8.28 8.28 0 00-3.747 6.917z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20903"
              d="M2.231 42.381a3.54 3.54 0 00-1.2.828 2.335 2.335 0 00.277 2.273c.339.132 1.859 1.718 2.227 1.023s-.65-1.577-.787-1.859-.745-1.242-.745-1.242z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20904"
              d="M.84 44.658s-.882 1.859-.6 2.186 2.227 1.114 2.7.741a.8.8 0 00.137-.973l-1.764-1.118z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20905"
              d="M.653 47.208a1.46 1.46 0 00.232 1.209 2.762 2.762 0 002.182.091c.277-.186-.137-.927-.137-.927a15.268 15.268 0 01-2.277-.373z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20906"
              d="M1.303 48.835s.141.65.6.791a1.775 1.775 0 001.532-.513c.1-.277-.373-.6-.373-.6a7.592 7.592 0 01-1.759.322z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20907"
              d="M28.438 3.383a8.5 8.5 0 00-5.867 2.9 6.36 6.36 0 00-.828 3.312c.257 1.35.584 7.672 1.337 9.009s3.258 3.838 5.933 4.107 5.519-2.766 6.189-4.463.828-8.028.828-8.028-.592-2-.894-2.807-3.005-4.185-6.698-4.03z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20908"
              d="M27.46.975s-1.656-1.366-3.089-.8.451 1.366.451 1.366-3.089-.323-3.614.642.981 1.689.981 1.689-2.186.563-2.186 1.528a1.167 1.167 0 00.977 1.126 2.734 2.734 0 000 1.606c.224 1.192 1.18 4.583 1.18 4.583s.327-.244.48-1.288-.075-1.288.075-1.606 1.2-1.126 1.582-1.689a9.523 9.523 0 011.507-1.449s-1.279 1.288-.451 1.366a9.48 9.48 0 004.219-1.925c.377-.559-.228 1.283.377 1.122s1.354-2.008 1.354-2.008.377 1.689.907 1.689a1.805 1.805 0 00.9-.244 4.2 4.2 0 001.05 1.683 4.808 4.808 0 011.13 1.288l.642 2.869a7.992 7.992 0 001.089-1.743 9.071 9.071 0 00-.075-2.174l.153-1.528a.766.766 0 00.675-.961c-.149-.886-1.805-2.07-1.805-2.07s.9-.8.074-1.449-3.767-.319-3.767-.319.981-2.012-.828-2.252a5.453 5.453 0 00-3.465.965"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20909"
              d="M22.157 12.713s-.753-1.7-1.76-.091 2.26 4.554 2.26 4.554z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20910"
              d="M35.939 12.526s1.184-2.045 1.938-.352-2.174 4.194-2.174 4.194z"
              fill="#e3e3e3"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <ellipse
              data-name="Ellipse 129156"
              cx={0.501}
              cy={0.89}
              rx={0.501}
              ry={0.89}
              transform="translate(26.252 11.823)"
              fill="#263238"
            />
            <path
              data-name="Path 20911"
              d="M385.352 187.574c0 .489-.224.89-.5.89s-.5-.414-.5-.89.224-.894.5-.894.5.402.5.894z"
              transform="translate(-353.582 -174.861)"
              fill="#263238"
            />
            <path
              data-name="Path 20912"
              d="M28.176 14.137s-.505.716-.253.894 1.242.8 1.656.621 1.085-.356 1.085-.712a2.414 2.414 0 00-.5-.981"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20913"
              d="M26.67 16.454a5.426 5.426 0 002.927.981 3.465 3.465 0 002.339-1.6"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20914"
              d="M24.997 11.016s.754-.981 2.674-.534"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20915"
              d="M30.433 10.39a3.312 3.312 0 012.757.538"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 20916"
              d="M28.388 38.448c-1.37 0-2.232.745-2.232 2.708v2.941h-4.082v-2.666c0-4.393 2.2-6.9 6.434-6.9s6.43 2.509 6.43 6.9c0 8.628-8.587 11.841-8.587 16.349a3.164 3.164 0 00.037.592h8.156v3.921h-12.47v-3.374c0-8.048 8.549-9.4 8.549-17.322.001-2.474-.861-3.149-2.235-3.149z"
              fill="#fff"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
export function AwarenessShareIllustration(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width:237.919,
    height: 237.513,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 237.919 237.513"
      {...rest}
      sx={rootSx}
    >
      <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_59738" data-name="Rectangle 59738" width="237.919" height="237.513" fill="#0278a5"/>
    </clipPath>
  </defs>
  <g id="Group_121213" data-name="Group 121213" clip-path="url(#clip-path)">
    <path id="Path_107514" data-name="Path 107514" d="M196.667,13.49c-1.139.164-2.278.389-3.419.615a16.428,16.428,0,0,0-.086-5.946c-.816-3.847-3.555-7.291-7.4-8.033-4.305-.83-7.337,2.558-9.511,5.942-2.209-3.541-6.827-6.248-10.815-4.8-4.409,1.6-6.379,6.47-6.518,11.01a15.184,15.184,0,0,0,1.732,7.958c.119.212.248.418.376.625-.661.186-1.318.379-1.965.586a.133.133,0,0,0,.047.261c.756-.077,1.516-.177,2.278-.285a38.931,38.931,0,0,0,4.342,5.193,56.137,56.137,0,0,0,5.911,5.377c2.116,1.665,4.6,3.764,7.166,4.581a.351.351,0,0,0,.3-.62c-1.642-1.44-3.708-2.424-5.471-3.715a54.178,54.178,0,0,1-5.458-4.572,40.392,40.392,0,0,1-5.74-6.4c3.29-.521,6.6-1.277,9.794-2.029a.418.418,0,0,0,.125-.747c.324-1.334.513-2.7.717-4.06a27.085,27.085,0,0,0,.5-3.486,71.11,71.11,0,0,0,3.5,6.7c.643,1.137,1.331,2.247,1.987,3.376a22.558,22.558,0,0,0,2.079,3.48.274.274,0,0,0,.472-.236c-.018-.085-.041-.169-.062-.253.416-1.372.8-2.76,1.146-4.151a10.7,10.7,0,0,0,.6-3.537,49.189,49.189,0,0,0,7.348-.876c.386-.058.822-.1,1.281-.136a28.366,28.366,0,0,1-4.067,9.318c-1.149,1.76-2.426,3.423-3.694,5.09-1.294,1.7-2.963,3.388-3.795,5.39-.114.276.229.457.427.3,2.063-1.586,3.587-4.282,5.17-6.367a47.429,47.429,0,0,0,4.489-6.773,28.169,28.169,0,0,0,2.6-7.068,5.986,5.986,0,0,0,3.778-1.377.2.2,0,0,0-.159-.343m-6.514,1.181a51.291,51.291,0,0,0-7.085,1.249.234.234,0,0,0-.149.261,21.618,21.618,0,0,0-.912,4.282c-.209.954-.447,1.9-.662,2.853-.782-2.24-2.555-4.354-3.691-6.323-1.331-2.306-2.419-4.929-4.137-6.956a.164.164,0,0,0-.294.023,14.734,14.734,0,0,0-.73,4.009c-.2,1.455-.42,2.914-.483,4.383-3.3.6-6.712,1.261-10.006,2.137a13.678,13.678,0,0,1-1.883-4.725c-.842-4.7.2-10.764,4.616-13.2a6.921,6.921,0,0,1,7.014.309,35.324,35.324,0,0,1,4.243,3.563.176.176,0,0,0,.2.163l.038.031a.189.189,0,0,0,.271-.243c-.01-.019-.023-.038-.033-.057,2.625-3.293,6.02-6.869,10.468-4.912,4.17,1.835,5.749,6.558,5.412,10.966-.047.618-.127,1.231-.23,1.84-.653.125-1.307.245-1.961.346" transform="translate(-105.415 0)" fill="#0278a5"/>
    <path id="Path_107515" data-name="Path 107515" d="M235.988,210.232V208.9a30.881,30.881,0,0,1,.333-4.858,9.222,9.222,0,0,1,.549-2.13,3.423,3.423,0,0,1,.949-1.331,1.981,1.981,0,0,1,1.464-.566,3.371,3.371,0,0,1,1.464.316,3.313,3.313,0,0,1,1.1.815,4.869,4.869,0,0,1,.665,1.231,11.068,11.068,0,0,1,.466,1.464l.266,1.564a73.47,73.47,0,0,1,.8,10.082v.1q0,1.664-.067,3.062a28.885,28.885,0,0,1-.366,3.494,7.721,7.721,0,0,1-.383,1.564,8.147,8.147,0,0,1-.649,1.331,2.171,2.171,0,0,1-1.963,1.2q-4.626,0-4.625-16.006m5.657,14.459a4.686,4.686,0,0,0,.665-1.714,27.935,27.935,0,0,0,.665-4.559q.066-1.8.067-3.494v-.133l-.033-3.327q-.067-1.8-.4-4.659a17.842,17.842,0,0,0-1.1-4.16,3.245,3.245,0,0,0-.882-1.3,1.8,1.8,0,0,0-1.181-.466,1.265,1.265,0,0,0-1,.533,4.09,4.09,0,0,0-.7,1.5,18.482,18.482,0,0,0-.666,4.126q-.1,1.631-.1,3.361v1.631a46.73,46.73,0,0,0,.433,5.657,31.577,31.577,0,0,0,.665,3.76,9.754,9.754,0,0,0,1.065,2.7q.665,1.165,1.531,1.165a1.2,1.2,0,0,0,.965-.616" transform="translate(-156.549 -132.687)" fill="#0278a5"/>
    <path id="Path_107516" data-name="Path 107516" d="M273.557,231.279a51.162,51.162,0,0,0-.815-7.553q-.816-4.992-2.146-10.915l-.266-1.032-.433-1.531a4.755,4.755,0,0,1-.2-.865.408.408,0,0,1,.15-.249.42.42,0,0,1,.283-.15q.466,0,.732,1.031.133.433.25.982t.183.782a4.953,4.953,0,0,0,.1.6q.632,2.563.765,3.261l.333,1.7.3,1.6.3,1.7a11.877,11.877,0,0,0,.266,1.564l.5,3.261q0,.133.233,1.7l.233,1.631a37.642,37.642,0,0,0,1.131-6.589q.466-4.126,1.331-8.286.732-3.594,1.031-5.224l.433-.166a.616.616,0,0,1,.25.133.275.275,0,0,1,.116.2,9.22,9.22,0,0,1-.3,2l-.2.865-.566,2.629q-.5,2.164-.682,3.328t-.416,3.36l-.066.765q-.167,1.8-.25,2.429a10.925,10.925,0,0,1-.383,1.63q-.266,1-.432,1.764l-.066.765a13.042,13.042,0,0,1-.266,2.063q-.267,1.131-1.065,1.131Zm.732-2.4-.033.067.033.067Z" transform="translate(-178.911 -138.326)" fill="#0278a5"/>
    <path id="Path_107517" data-name="Path 107517" d="M308.349,232.356v-.433a2.1,2.1,0,0,0,.033-.4l-.133-.133a3.824,3.824,0,0,0,.266-1.364q0-.766-.1-2.2l-.067-2.2q0-1.664.1-4.991.133-2.961.133-5.025l-.067-2q-.067-.9-.067-2a.939.939,0,0,1,.233-.715,1.048,1.048,0,0,1,.732-.216.721.721,0,0,1,.533.2,8.177,8.177,0,0,0,.965.133,7.325,7.325,0,0,1,1.431.3q.632.2.633.5,0,.333-.633.666a10.068,10.068,0,0,0-2.7-.633l-.166.2q.033.3.033,1.431,0,1.431-.067,2.562-.033,1.165-.033,2.6,0,.932.466.932l.533-.033a4.623,4.623,0,0,1,.566-.033q1.3,0,1.3.6a1.084,1.084,0,0,1-.167.616.56.56,0,0,1-.5.249,1.033,1.033,0,0,1-.765-.266l-1.065-.166h-.166l-.166.166v.1q.067.566.067,2.629,0,1.3-.033,2.363l-.033,2.363q0,1.3.1,2.662a1.382,1.382,0,0,0,.333,1.015,1.775,1.775,0,0,0,1.1.249l.6-.033a6.137,6.137,0,0,1,.665-.033q.965,0,.965.433,0,.6-1.464.6h-2.729q-.6,0-.666-.7" transform="translate(-204.486 -139.769)" fill="#0278a5"/>
    <path id="Path_107518" data-name="Path 107518" d="M339.107,232.5a6.34,6.34,0,0,1-.865-2.3q-.467-1.863-.865-4.193a31.552,31.552,0,0,0-.765-3.76q-.4-1.663-.765-1.664h-.1q-.732,0-.732.466,0,2.4.266,7.288a21.809,21.809,0,0,0,.3,3.494l-.266.566h-.466l-.266-.266q-.532-15.373-.532-20.964a2.942,2.942,0,0,1,.05-.6.992.992,0,0,1,.216-.433.491.491,0,0,1,.466-.233,4.218,4.218,0,0,1,2.729.832,2.9,2.9,0,0,1,1.032,2.4v2.429a5,5,0,0,1-.416,1.7,16.05,16.05,0,0,1-.915,1.963l-.432.832q.366,1.7,1.448,6.106t1.182,4.675a.568.568,0,0,1,.083.167,2.538,2.538,0,0,0,.216.4,1.862,1.862,0,0,1,.233.8q0,.466-.366.466Zm-2.795-13.377a4.859,4.859,0,0,0,.8-1.631,13.514,13.514,0,0,0,.533-3.228A8.041,8.041,0,0,0,337.56,213a6.4,6.4,0,0,0-.283-1.065,1.769,1.769,0,0,0-1.9-1.165c-.111,0-.2.095-.266.283a1.737,1.737,0,0,0-.1.582q0,2.23.066,4.026.033,1.8.033,4.027l.067.066a1.433,1.433,0,0,0,1.131-.632" transform="translate(-221.601 -139.244)" fill="#0278a5"/>
    <path id="Path_107519" data-name="Path 107519" d="M366.376,232.017a1.1,1.1,0,0,1-.2-.615q-.3-2.429-.366-3.028l-.167-1.331a7.553,7.553,0,0,0-1.664-.166l-1.2-.067a10.508,10.508,0,0,0-1.165-.1c-.133,0-.211.056-.233.166,0,.067-.011.1-.034.1l-.066.665a24.017,24.017,0,0,1-.366,2.4,6.042,6.042,0,0,1-.4,1.4q-.266.566-.5.565a.722.722,0,0,1-.433-.183.5.5,0,0,1-.233-.382l.033-.1.033-.1q.6-2.363,1-4.692l.4-2.063.4-2.529.366-2.2q.166-.9.6-2.895.465-2.263.566-3.095.032-.1.133-1.231.133-1.264.233-1.864a3.191,3.191,0,0,1,.2-1h.233a.736.736,0,0,0,.233.033.812.812,0,0,0,.6-.2.642.642,0,0,1,.416.15.444.444,0,0,1,.183.349,32.988,32.988,0,0,0,.233,3.66q.132,1.065.2,1.764.366,4.292,1.863,16.106v.1a.55.55,0,0,1-.266.5,1.089,1.089,0,0,1-.633-.116m-.9-5.873q-.333-4.792-1.264-14.142l-1.8,8.885a34.749,34.749,0,0,0-.765,4.825q0,.167,1.265.3a21.466,21.466,0,0,0,2.229.133Z" transform="translate(-238.388 -138.982)" fill="#0278a5"/>
    <path id="Path_107520" data-name="Path 107520" d="M393.655,232.944a5.019,5.019,0,0,0,.067-1.1q0-3.061.1-9.084.1-5.99.1-8.652l.067-1.2.1-1a.206.206,0,0,1,.233-.233,1.591,1.591,0,0,1,.466.1l.1.033q0,.732-.033,1.331v4.925q.032,1.6.033,3.627a4.859,4.859,0,0,0-.033.732l-.034.7q-.033.666-.033,1.365,0,.765.033,1.4l.034,1.431-.1.266.033-.033a.2.2,0,0,1-.033.133v.133a1.022,1.022,0,0,0,.1.466l-.1,3.195v.2a3.476,3.476,0,0,0,.033.666.147.147,0,0,0,.166.166l1.731.067q.765,0,1.048.016c.188.011.3.017.349.017h.1a.466.466,0,0,1,.333.183.566.566,0,0,1,.167.383q0,.4-.533.433-.566-.034-2.762-.034l.067.034a5.717,5.717,0,0,0-.633.033,2.475,2.475,0,0,1-.6.067q-.467,0-.566-.765" transform="translate(-261.142 -140.425)" fill="#0278a5"/>
    <path id="Path_107521" data-name="Path 107521" d="M418.268,232.944a5.023,5.023,0,0,0,.067-1.1q0-3.061.1-9.084.1-5.99.1-8.652l.067-1.2.1-1a.206.206,0,0,1,.233-.233,1.591,1.591,0,0,1,.466.1l.1.033q0,.732-.033,1.331v4.925q.032,1.6.033,3.627a4.875,4.875,0,0,0-.033.732l-.034.7q-.033.666-.033,1.365,0,.765.033,1.4l.034,1.431-.1.266.033-.033a.2.2,0,0,1-.033.133v.133a1.022,1.022,0,0,0,.1.466l-.1,3.195v.2a3.473,3.473,0,0,0,.033.666.147.147,0,0,0,.166.166l1.731.067q.765,0,1.048.016c.188.011.3.017.349.017h.1a.467.467,0,0,1,.333.183.567.567,0,0,1,.167.383c0,.266-.178.41-.533.433q-.566-.034-2.762-.034l.067.034a5.718,5.718,0,0,0-.633.033,2.475,2.475,0,0,1-.6.067q-.467,0-.566-.765" transform="translate(-277.47 -140.425)" fill="#0278a5"/>
    <path id="Path_107522" data-name="Path 107522" d="M229.116,322.1v-.4a1.427,1.427,0,0,0,.033-.333V321.2l-.6-4.026q-.233-1.264-.3-1.83-.3-2.329-.633-5.191-.267-2.262-.931-7.454l-.1-.765a22.285,22.285,0,0,0-.732-4.126.969.969,0,0,1,.3-.3.719.719,0,0,1,.4-.133,1.039,1.039,0,0,1,.682.166.792.792,0,0,1,.183.6v1q1.031,10.881,2.163,20.365h.067q.1-.964.4-5.291l.066-.965q.233-4.226.266-4.459.1-1,.4-2.928l.4-2.7.1-1.531q.033-.4.05-.682a2.413,2.413,0,0,1,.05-.416l.033-.432a.2.2,0,0,1,.05-.1.607.607,0,0,1,.15-.133q.465,0,.6.233a.5.5,0,0,1,.133.216,1.055,1.055,0,0,1,.034.283l.066.3q.332,1.764,1.431,9.184t1.331,9.783l.1.066,1.231-13.477q.066-1.264.433-3.993a39.259,39.259,0,0,0,.333-4.492l-.033-.333v-.3a.806.806,0,0,1,.2-.616.977.977,0,0,1,.665-.183.692.692,0,0,1,.416.167.467.467,0,0,1,.216.366.834.834,0,0,1-.366.632.35.35,0,0,1,.033.2,1.847,1.847,0,0,1-.05.416c-.033.144-.061.249-.083.316q-.367,2.995-.9,8.818l-.665,6.888-.266,2.629-.4,3.361-.166,1.7a1.219,1.219,0,0,1-.116.6.514.514,0,0,1-.483.2q-.532,0-.632-.4a5.357,5.357,0,0,1-.133-.931l-.033-.5q-.8-5.124-2.4-18.235l-.1-.067-.033.033v.033l-1.664,18.169v.6q0,1.3-.566,1.3-.633,0-.632-.732" transform="translate(-149.827 -196.719)" fill="#0278a5"/>
    <path id="Path_107523" data-name="Path 107523" d="M274.888,329.869v-.433a2.1,2.1,0,0,0,.033-.4l-.133-.133a3.83,3.83,0,0,0,.266-1.365q0-.765-.1-2.2l-.067-2.2q0-1.664.1-4.991.133-2.961.133-5.025l-.067-2q-.067-.9-.067-2a.94.94,0,0,1,.233-.715,1.049,1.049,0,0,1,.732-.216.721.721,0,0,1,.533.2,8.031,8.031,0,0,0,.965.133,7.352,7.352,0,0,1,1.431.3q.632.2.633.5,0,.333-.633.665a10.066,10.066,0,0,0-2.7-.632l-.166.2q.033.3.033,1.431,0,1.431-.067,2.562-.033,1.165-.033,2.6,0,.932.466.932l.533-.034a4.63,4.63,0,0,1,.566-.033q1.3,0,1.3.6a1.084,1.084,0,0,1-.167.616.56.56,0,0,1-.5.249,1.035,1.035,0,0,1-.765-.266l-1.065-.166h-.166l-.166.166v.1q.067.566.067,2.629,0,1.3-.033,2.362l-.033,2.363q0,1.3.1,2.662a1.382,1.382,0,0,0,.333,1.015,1.774,1.774,0,0,0,1.1.249l.6-.033a6.216,6.216,0,0,1,.665-.033q.965,0,.965.433,0,.6-1.464.6h-2.729q-.6,0-.665-.7" transform="translate(-182.288 -204.457)" fill="#0278a5"/>
    <path id="Path_107524" data-name="Path 107524" d="M300.588,330.458a5.043,5.043,0,0,0,.067-1.1q0-3.061.1-9.084.1-5.99.1-8.652l.066-1.2.1-1a.206.206,0,0,1,.233-.233,1.6,1.6,0,0,1,.466.1l.1.033q0,.732-.033,1.331v4.925q.033,1.6.033,3.627a4.807,4.807,0,0,0-.033.732l-.033.7q-.033.667-.033,1.365,0,.766.033,1.4l.033,1.431-.1.266.033-.033a.194.194,0,0,1-.033.133v.133a1.026,1.026,0,0,0,.1.466l-.1,3.195v.2a3.435,3.435,0,0,0,.033.666.147.147,0,0,0,.166.166l1.731.066q.765,0,1.048.017c.188.011.3.016.349.016h.1a.466.466,0,0,1,.333.183.566.566,0,0,1,.166.382c0,.266-.178.41-.533.433q-.566-.034-2.762-.033l.067.033a5.714,5.714,0,0,0-.632.033,2.477,2.477,0,0,1-.6.067q-.467,0-.566-.765" transform="translate(-199.404 -205.113)" fill="#0278a5"/>
    <path id="Path_107525" data-name="Path 107525" d="M325.2,330.458a5.047,5.047,0,0,0,.067-1.1q0-3.061.1-9.084.1-5.99.1-8.652l.066-1.2.1-1a.206.206,0,0,1,.233-.233,1.6,1.6,0,0,1,.466.1l.1.033q0,.732-.033,1.331v4.925q.033,1.6.033,3.627a4.812,4.812,0,0,0-.033.732l-.033.7q-.033.667-.033,1.365,0,.766.033,1.4l.033,1.431-.1.266.033-.033a.193.193,0,0,1-.033.133v.133a1.026,1.026,0,0,0,.1.466l-.1,3.195v.2a3.431,3.431,0,0,0,.033.666.147.147,0,0,0,.166.166l1.731.066q.765,0,1.048.017c.188.011.3.016.349.016h.1a.466.466,0,0,1,.333.183.565.565,0,0,1,.166.382q0,.4-.533.433-.566-.034-2.762-.033l.067.033a5.716,5.716,0,0,0-.632.033,2.476,2.476,0,0,1-.6.067q-.467,0-.566-.765" transform="translate(-215.732 -205.113)" fill="#0278a5"/>
    <path id="Path_107526" data-name="Path 107526" d="M358.082,330.069a2.379,2.379,0,0,1-.216-.6,1.442,1.442,0,0,0-.133-.466l.033-.1a21.043,21.043,0,0,0-1.132-3.827l-.6-1.731a16.458,16.458,0,0,1-.632-1.7l-.266-.8q-2.995-9.251-3.76-10.016a8.4,8.4,0,0,0-.266,2.329q0,.765.033,1.331l.033,1.3-.033.8q-.034.367-.033.8a10.279,10.279,0,0,0,.066,1.264l.067,1.065h-.1a37.153,37.153,0,0,0,.233,6.123v2.995a1.573,1.573,0,0,1,.133.7.67.67,0,0,1-.183.466.587.587,0,0,1-.449.2q-.7,0-.7-1.8l.067-1.065a8.393,8.393,0,0,0,.066-1.1q0-1.6-.1-4.792t-.1-4.791q0-.965.1-2.962.1-1.963.1-2.928v-.433a2.77,2.77,0,0,1,.6-2.129l.1.1.333-.067a.711.711,0,0,1,.3.2.416.416,0,0,1,.133.3l.067.2a.544.544,0,0,0,.033.166,39.878,39.878,0,0,0,2.4,6.622q1.9,4.492,2.362,5.957.332,1.165.533,2.063a16.348,16.348,0,0,0,1.5,4.359l.067-.1a180.523,180.523,0,0,0,.765-18.136l-.033-.4a2.244,2.244,0,0,1-.034-.433q0-.7.466-.7a.627.627,0,0,1,.516.3,1.109,1.109,0,0,1,.216.666v2.229l-.167.266q0,3.161-.366,10.382t-.7,7.853l-.565.133v.033l-.033-.033-.333.1a.407.407,0,0,1-.383-.2" transform="translate(-232.257 -204.457)" fill="#0278a5"/>
    <path id="Path_107527" data-name="Path 107527" d="M394.893,329.869v-.433a2.117,2.117,0,0,0,.033-.4l-.133-.133a3.822,3.822,0,0,0,.266-1.365q0-.765-.1-2.2l-.066-2.2q0-1.664.1-4.991.133-2.961.133-5.025l-.067-2q-.067-.9-.066-2a.939.939,0,0,1,.233-.715,1.051,1.051,0,0,1,.732-.216.721.721,0,0,1,.533.2,8.012,8.012,0,0,0,.965.133,7.351,7.351,0,0,1,1.431.3q.632.2.632.5,0,.333-.632.665a10.066,10.066,0,0,0-2.7-.632l-.166.2q.033.3.033,1.431,0,1.431-.067,2.562-.034,1.165-.033,2.6,0,.932.466.932l.533-.034a4.625,4.625,0,0,1,.566-.033q1.3,0,1.3.6a1.089,1.089,0,0,1-.166.616.561.561,0,0,1-.5.249,1.034,1.034,0,0,1-.765-.266l-1.065-.166h-.166l-.167.166v.1q.067.566.067,2.629,0,1.3-.033,2.362l-.033,2.363q0,1.3.1,2.662a1.382,1.382,0,0,0,.333,1.015,1.775,1.775,0,0,0,1.1.249l.6-.033a6.215,6.215,0,0,1,.665-.033q.965,0,.965.433,0,.6-1.464.6h-2.728q-.6,0-.666-.7" transform="translate(-261.897 -204.457)" fill="#0278a5"/>
    <path id="Path_107528" data-name="Path 107528" d="M418.785,329.333a.712.712,0,0,1-.366-.516l.166-.266a3.933,3.933,0,0,1,.6.1,1.83,1.83,0,0,0,.6.133,1.763,1.763,0,0,0,1.3-.582,3.8,3.8,0,0,0,.865-1.514,12.561,12.561,0,0,0,.466-3.261,10.568,10.568,0,0,0-1.4-4.925q-.866-1.53-1.331-2.429a12.785,12.785,0,0,1-.832-2.063,8.679,8.679,0,0,1-.432-2.629,8.4,8.4,0,0,1,.6-2.829,3.159,3.159,0,0,1,.849-1.248,1.76,1.76,0,0,1,1.181-.482,1.443,1.443,0,0,1,.849.3.818.818,0,0,1,.416.633c0,.178-.145.266-.433.266a.782.782,0,0,1-.333-.1.828.828,0,0,0-.366-.1,1.241,1.241,0,0,0-.9.4,2.488,2.488,0,0,0-.6,1.031,7.386,7.386,0,0,0-.4,2.263,5.334,5.334,0,0,0,.166,1.3c.022.133.044.244.067.333a.932.932,0,0,1,.033.2l.2.665.166.6.266.6a2.835,2.835,0,0,0,.216.416c.077.123.15.239.216.349l.4.7q.132.2.565.948a16.277,16.277,0,0,1,.8,1.58,7.9,7.9,0,0,1,.5,1.315,13.941,13.941,0,0,1,.3,1.48,15.419,15.419,0,0,1,.1,1.83,10.087,10.087,0,0,1-.432,2.995,4.219,4.219,0,0,1-1.73,2.329,2.689,2.689,0,0,1-1.464.4l-.166.067a1.9,1.9,0,0,1-.7-.283m3.361-21.413a.03.03,0,0,0-.033-.033v.033Z" transform="translate(-277.57 -203.539)" fill="#0278a5"/>
    <path id="Path_107529" data-name="Path 107529" d="M441.126,329.333a.712.712,0,0,1-.366-.516l.166-.266a3.933,3.933,0,0,1,.6.1,1.83,1.83,0,0,0,.6.133,1.763,1.763,0,0,0,1.3-.582,3.8,3.8,0,0,0,.865-1.514,12.56,12.56,0,0,0,.466-3.261,10.568,10.568,0,0,0-1.4-4.925q-.866-1.53-1.331-2.429a12.774,12.774,0,0,1-.832-2.063,8.679,8.679,0,0,1-.432-2.629,8.4,8.4,0,0,1,.6-2.829,3.157,3.157,0,0,1,.849-1.248,1.76,1.76,0,0,1,1.181-.482,1.443,1.443,0,0,1,.849.3.818.818,0,0,1,.416.633c0,.178-.145.266-.433.266a.782.782,0,0,1-.333-.1.828.828,0,0,0-.366-.1,1.241,1.241,0,0,0-.9.4,2.488,2.488,0,0,0-.6,1.031,7.384,7.384,0,0,0-.4,2.263,5.335,5.335,0,0,0,.166,1.3c.022.133.044.244.067.333a.932.932,0,0,1,.033.2l.2.665.166.6.266.6a2.835,2.835,0,0,0,.216.416c.077.123.15.239.216.349l.4.7q.132.2.565.948a16.271,16.271,0,0,1,.8,1.58,7.9,7.9,0,0,1,.5,1.315,13.933,13.933,0,0,1,.3,1.48,15.419,15.419,0,0,1,.1,1.83,10.085,10.085,0,0,1-.432,2.995,4.219,4.219,0,0,1-1.73,2.329,2.689,2.689,0,0,1-1.464.4l-.166.067a1.9,1.9,0,0,1-.7-.283m3.361-21.413a.03.03,0,0,0-.033-.033v.033Z" transform="translate(-292.391 -203.539)" fill="#0278a5"/>
    <path id="Path_107530" data-name="Path 107530" d="M468.078,6.919C467.022,5.684,464.95,5,463.408,4.592a10.391,10.391,0,0,0-5.182-.123c-2.224.569-5.182,2.494-5.43,5.03-.05.038-.1.076-.153.114a.161.161,0,0,0-.05.075,3.278,3.278,0,0,0-1.088.662,19.536,19.536,0,0,0,.234-3.225,4.035,4.035,0,0,0-.7-2.7c-.4-.382-1.355-.689-1.725-.154a.2.2,0,0,0-.147.19c-.021,1.823.206,3.644.152,5.471a21.012,21.012,0,0,1-.819,4.749c-1.215-3.251-5.755-5.509-8.959-4.617-4.316,1.2-6.973,5.878-7.654,10.03a19.29,19.29,0,0,0,3.43,13.947,10.754,10.754,0,0,0,4.666,4.015,3,3,0,0,0,1.017.211c.409-.013.741-.322,1.1-.345,2.042-.131,1.771,1.555,3.089,2.33a.409.409,0,0,0,.587-.171.351.351,0,0,0,.277.189c1.993.154,3.853-.8,5.62-1.609a30,30,0,0,0,5.208-2.871,14.524,14.524,0,0,0,5.642-9.539c.481-3.3-.035-7.308-2.752-9.562-2.536-2.1-6.806-2.283-9.936-1.2A14.157,14.157,0,0,0,451.4,10.95c.256-.174.518-.336.789-.49.213-.12.45-.228.66-.365.361,2.526,3.713,3.154,5.883,2.8,3.66-.6,5.987-3.235,9.089-4.943a.351.351,0,0,0,.156-.491.351.351,0,0,0,.1-.541m-18.7,8.732c-.161.064-.322.129-.475.2-.171.08-.04.309.119.283,3.446-.571,8.017-1.21,10.715,1.637,2.515,2.653,2.529,7.165,1.464,10.448a13.7,13.7,0,0,1-6,7.641,26.677,26.677,0,0,1-9.251,3.749.278.278,0,0,0-.167.09.458.458,0,0,0-.082-.131c-.843-.932-1.167-2.671-2.561-3-.688-.161-1.011.326-1.591.43a4.337,4.337,0,0,1-3.472-1.415c-3.22-2.791-5.071-7.4-5.4-11.577-.326-4.113.962-8.555,4.134-11.343a6.176,6.176,0,0,1,6.558-1.435,8.378,8.378,0,0,1,4.876,4.621c.1.257.563.25.523-.071-.013-.109-.032-.217-.053-.325a10.659,10.659,0,0,0,1.329-5.256c.083-1.551.362-3.794-.261-5.343,1.627,1,1.2,3.384.947,5.13-.284,1.933-.995,3.758-1.355,5.661m4.057-5.926A37.182,37.182,0,0,1,457.1,8.331c1.469-.421,2.993-.565,4.466-.96.176-.047.2-.351,0-.381A12.481,12.481,0,0,0,453.8,8.818a6.484,6.484,0,0,1,1.473-1.9A7.654,7.654,0,0,1,459.061,5.2a10.051,10.051,0,0,1,4.627.471c1.225.4,2.309,1.181,3.5,1.624-2.021.537-3.563,2.628-5.364,3.58-2.707,1.43-6.974,2.24-8.384-1.152" transform="translate(-286.359 -2.641)" fill="#0278a5"/>
    <path id="Path_107531" data-name="Path 107531" d="M63.161,74.267A2.859,2.859,0,0,0,59.016,75.4c-.465,1.1.114,3.522,1.616,3.383A20.617,20.617,0,0,1,48.791,93.194a14.971,14.971,0,0,1-3.5,1.047,12.921,12.921,0,0,1-8.647-1.818q.139-.073.276-.148a20.833,20.833,0,0,0,9.936-12.246,10.321,10.321,0,0,0,.465-4.714,5.51,5.51,0,0,0-2.641-3.987,5.031,5.031,0,0,0-3.951-.264A5.905,5.905,0,0,0,38.5,69.216a6.147,6.147,0,0,0-6.95,1.352,8.936,8.936,0,0,0-1.918,3.761,17.359,17.359,0,0,0,2.287,14.749,14.512,14.512,0,0,0,3.2,3.236,20.5,20.5,0,0,1-13.666,1.013,15.291,15.291,0,0,1-6.346-3.35,13.99,13.99,0,0,1-3.216-15.582c.053.014.111.032.16.042A2.528,2.528,0,0,0,15.2,72.454a11.175,11.175,0,0,0,3.048-.112c4.717-.858,8.435-4.26,10.861-8.244a42.6,42.6,0,0,0,3.85-8.917c.882-2.678,1.824-5.706,1.152-8.526a.351.351,0,0,0-.134-.21c-.213-1.186-.782-1.63-2.083-2.253a18.54,18.54,0,0,0-4.737-1.955,1.058,1.058,0,0,0-.025-.143c-.022-.091-.142-.179-.228-.1a4.123,4.123,0,0,0-.75,1.952l-.538-.285c-.39-.206-.577-.262-.436-.743A10.856,10.856,0,0,1,25.9,41.3a3.767,3.767,0,0,1,1.236.654.108.108,0,0,0,.152-.149,2.868,2.868,0,0,0-1.427-1.074.277.277,0,0,0-.351.143c-.255.455-.472.932-.682,1.41a2.537,2.537,0,0,0-.36,1.089.741.741,0,0,0,.458.578c.425.241.868.455,1.3.681a.288.288,0,0,0,.377-.154l.186-.653a9.844,9.844,0,0,0,2.546,1.24,20.819,20.819,0,0,0,3.107,1.1C31.268,52.04,29.927,58,26.527,63.078c-3.2,4.784-8.6,7.71-14.348,5.817-5.311-1.749-8.525-6.837-9.055-12.232-.574-5.841,1.808-10.913,3.6-16.294a19.8,19.8,0,0,0,2.983-.3c1.181-.127,2.381-.2,3.552-.4a.143.143,0,0,0-.021.067c-.03.531.674,1.152,1.2,1.181.6.033.946-.516,1.032-1.042a3.977,3.977,0,0,0-.018-1.069,6.7,6.7,0,0,0-.161-1.334c-.224-.682-1.271-.436-1.813-.433a.212.212,0,0,0-.183.183c-.01.291-.021.58-.029.869a9.978,9.978,0,0,0-3.279.1,25.849,25.849,0,0,0-3.777.634.158.158,0,0,0-.241.019c-4.784,7.645-8.983,20.589-1.6,28.071A20.66,20.66,0,0,0,9.4,70.637a2.778,2.778,0,0,0-.151,2.195,4.01,4.01,0,0,0,1.913,1.321,14.323,14.323,0,0,0,7.755,19.109,19.244,19.244,0,0,0,2.328.8,21.256,21.256,0,0,0,14.6-1.243A13.769,13.769,0,0,0,45.412,95a15.742,15.742,0,0,0,3.678-1.1A21.421,21.421,0,0,0,61.235,79.58c.944.664,2.674-.14,3.2-1.055a3.226,3.226,0,0,0-1.273-4.257M14.839,37.722a2.254,2.254,0,0,1,.056.692c.021.258.051.517.061.776.019.49-.062,1.478-.841.9-.263-.195-.319-.441-.638-.5.123-.707.174-1.416.226-2.132.4-.015.97-.05,1.137.263M1.157,57.535c-.451-6.451,2-12.86,5.05-18.421,1.289-.011,2.571-.233,3.853-.356a23.277,23.277,0,0,0,3.195-.259c0,.283,0,.566.013.849a17.8,17.8,0,0,0-3.423.1,14.3,14.3,0,0,0-3.4.481.227.227,0,0,0-.029.4C3.6,45.505,1.567,52.112,2.52,58.022c.873,5.419,4.565,10.291,9.952,11.825,5.49,1.563,10.695-.876,14.081-5.246a32.305,32.305,0,0,0,4.532-9.061c1.06-2.958,2.194-6.225,2-9.41a.263.263,0,0,0-.24-.26c-1.036-.565-2.141-1-3.214-1.495a10.543,10.543,0,0,0-2.67-1.13l.028-.1c.038-.135.081-.264.115-.391,1.793,1.389,5.536,1.539,6.476,3.723a.345.345,0,0,0-.1.261c.137,10.7-8.312,29.6-21.892,24.032C5.759,68.384,1.606,63.959,1.157,57.535M10,72.975a2.637,2.637,0,0,1-.328-2.193A15.916,15.916,0,0,0,14.749,72.4a4.984,4.984,0,0,1-.326.747,2.078,2.078,0,0,1-2.636.769A4.639,4.639,0,0,1,10,72.975m30.407-.991a5.289,5.289,0,0,1,.735,3.342A3.6,3.6,0,0,1,39.5,78.05a2.18,2.18,0,0,1-2.765-.481c-.757-1.109-.012-2.715,1.062-3.813a7.97,7.97,0,0,1,2.606-1.772M35.9,91.943a13.823,13.823,0,0,1-3.364-3.309,16.59,16.59,0,0,1-2.174-14.1,8.21,8.21,0,0,1,1.744-3.451A5.44,5.44,0,0,1,38,69.831c.058.024.115.05.172.076a5.075,5.075,0,0,1,1.794,1.439,8.742,8.742,0,0,0-2.712,1.875c-1.293,1.322-2.149,3.312-1.148,4.779a2.938,2.938,0,0,0,3.772.716,4.359,4.359,0,0,0,2.02-3.291,6.016,6.016,0,0,0-.744-3.7A4.22,4.22,0,0,1,44.315,72a4.743,4.743,0,0,1,2.25,3.441,9.6,9.6,0,0,1-.443,4.37A20.063,20.063,0,0,1,36.554,91.6q-.322.175-.651.339m24.94-15.107c.114-.317.516-.264.752-.134a.6.6,0,0,1,.324.7.385.385,0,0,1-.356.246.373.373,0,0,0-.294-.244.378.378,0,0,0-.3.087.9.9,0,0,1-.126-.652m2.764,1.406c-.62.925-1.369.8-2.206.614q.065-.313.121-.627a.894.894,0,0,0,.9-.468,1.2,1.2,0,0,0-1.227-1.678.834.834,0,0,0-.807.737,1.029,1.029,0,0,0,.133.6.823.823,0,0,0,.311.313c-.037.237-.088.471-.134.706a2.083,2.083,0,1,1,2.5-3.15,2.382,2.382,0,0,1,.415,2.949" transform="translate(-0.24 -24.542)" fill="#0278a5"/>
    <path id="Path_107532" data-name="Path 107532" d="M268.472,415.411l-.371-2.15c-.454-2.632-1.94-12.786-2.7-18.273a19.481,19.481,0,0,1-1.385,4.375,9.245,9.245,0,0,1-5.253,5.026,13.405,13.405,0,0,1-3.679.473c-3.878.134-7.841.065-11.673,0s-7.773-.134-11.629,0a.417.417,0,0,1-.435-.406.421.421,0,0,1,.406-.435c3.877-.134,7.84-.065,11.673,0s7.773.134,11.629,0a12.779,12.779,0,0,0,3.451-.433A8.409,8.409,0,0,0,263.255,399a25.879,25.879,0,0,0,1.8-6.762l.476-2.782.356,2.8c.406,3.185,1.915,13.638,2.7,18.7.935-4.087,2.609-11.036,3.12-12.755l.443-1.492.369,1.512c.425,1.744,1.675,6.361,2.24,8.436.727-1.393,2.046-3.925,2.524-4.879l.116-.233h.26c.427,0,1.583.01,3.226.024,6.835.057,22.842.19,28.624-.023a.415.415,0,0,1,.436.405.42.42,0,0,1-.4.436c-5.8.214-21.82.081-28.662.024-1.377-.012-2.412-.02-2.96-.023-.792,1.562-2.888,5.567-2.91,5.61l-.5.948-.282-1.032c-.016-.059-1.355-4.955-2.131-7.936-.9,3.5-2.625,10.763-3.167,13.3Z" transform="translate(-153.471 -258.357)" fill="#0278a5"/>
    <path id="Path_107533" data-name="Path 107533" d="M52.423,388.457a184.538,184.538,0,0,1,3.789-19.623c.438-1.673,1.433-3.587-.508-4.442-.987-.435-3.025-1.057-3.979-.25a.248.248,0,0,0-.053.35,8.924,8.924,0,0,0-.793,2.667q-.6,2.544-1.177,5.095-.6,2.7-1.163,5.408c-2.671-.77-9.05-1.8-11.776-2.3-2.781-.508-5.469-1.081-8.361-1.607.292-1.683.548-3.084.816-4.771q.436-2.744.83-5.495a9.616,9.616,0,0,0,.292-3.127.339.339,0,0,0,.052-.378c-.536-1-2.455-1.142-3.426-1.17-1.727-.05-1.954.647-2.216,2.264-1.024,6.317-1.912,12.581-3.331,18.835-.747,3.293-1.624,6.561-2.326,9.863-.409,1.926.058,3.408,2.181,3.758a4.588,4.588,0,0,0,2.579-.117c1.019-.515,1.041-1.964,1.254-2.929q1.092-4.945,2.068-9.917c.108-.552.159-.873.264-1.425,2.718.468,5.484.733,8.187,1.287,2.761.566,9.066,2.182,11.852,2.587-.617,3.248-1.183,6.508-1.719,9.77-.348,2.118-1.457,4.489.986,5.483,1.509.614,3.369.9,4.216-.819a13.474,13.474,0,0,0,.745-3.978c.238-1.672.469-3.345.717-5.016M24.9,388.1c-.382,1.691-.382,4.426-2.491,4.761a2.277,2.277,0,0,1-2.727-2.489c.118-.772.343-1.541.52-2.3,1.438-6.162,3.112-12.28,4.209-18.516.5-2.835.721-5.711,1.222-8.541.049-.279.106-1.069.383-1.264.31-.216,1.228-.058,1.543-.019.6.074,1.907.177,2.335.655a.289.289,0,0,0,.071.054,18.481,18.481,0,0,1-.562,3.909q-.354,2.259-.736,4.514-.819,4.832-1.763,9.642c-.627,3.208-1.286,6.408-2.005,9.6m10.849-8.263c-2.668-.514-5.467-1.09-8.184-1.4.267-1.416.5-2.648.749-4.068q4.155.806,8.31,1.61c2.738.524,9.014,1.967,11.783,2.309q-.415,2.022-.806,4.049c-2.585-.982-9.166-1.985-11.852-2.5m11.834,17.955c-1.259-.41-1.537-.933-1.519-2.269a17.2,17.2,0,0,1,.337-2.263c.491-3.232,1.042-6.452,1.627-9.668s1.209-6.424,1.874-9.623q.5-2.4,1.03-4.793A21.607,21.607,0,0,1,52,364.665a.313.313,0,0,0,.132-.031c.541-.272,1.778.127,2.338.269,1.23.313,1.608.6,1.348,1.882-.571,2.817-1.421,5.574-2,8.394-1.289,6.309-1.978,12.723-2.925,19.087a11.445,11.445,0,0,1-.336,2.132c-.649,1.789-1.559,1.857-2.972,1.4" transform="translate(-12.576 -238.026)" fill="#0278a5"/>
    <path id="Path_107534" data-name="Path 107534" d="M127.151,415.72q.373-1.975.744-3.951a2.972,2.972,0,0,0,3.109-1.92c.442-1.39-.673-3.275-2.222-2.886.069-.379.141-.758.209-1.138.245-1.362.486-2.725.707-4.092a8.739,8.739,0,0,0,.307-2.238c-.19-1.486-3.445-1.624-4.606-1.525a.308.308,0,0,0-.236.144.174.174,0,0,0-.043.071,100.151,100.151,0,0,0-1.988,9.921c-.614,3.317-1.254,6.631-1.824,9.957a.428.428,0,0,0,.318.5,18.483,18.483,0,0,0,3.4.524c.371.038.949.2,1.3-.053.691-.5.684-2.537.829-3.308m3.1-7.216a1.7,1.7,0,0,1-.239,1.511,3.244,3.244,0,0,1-1.995,1.083c.219-1.171.433-2.344.647-3.516a1.77,1.77,0,0,1,1.586.922m-5.639,9.747a9.449,9.449,0,0,1-2.427-.4c.6-3.3,1.162-6.6,1.745-9.9.545-3.085,1.252-6.2,1.506-9.328.989.189,2,.3,2.971.577.906.254.815.157.7,1.055-.256,1.941-.618,3.871-.958,5.8q-.666,3.769-1.372,7.532-.338,1.8-.689,3.593c-.18.928-.459,1.082-1.473,1.073" transform="translate(-80.467 -263.988)" fill="#0278a5"/>
    <path id="Path_107535" data-name="Path 107535" d="M7.965,386.4c.641-3.287,1.479-6.605,1.789-9.943a.286.286,0,0,0-.16-.329c-1.05-.52-4.11-1.585-4.86-.285a8.19,8.19,0,0,0-.534,2.18c-.3,1.352-.571,2.709-.844,4.066-.078.387-.151.775-.228,1.162a2.062,2.062,0,0,0-1.914-.052A2.216,2.216,0,0,0,0,385.142a2.983,2.983,0,0,0,2.188,2.9q-.378,1.962-.753,3.924c-.143.745-.876,2.606-.483,3.331.2.367.566.4.929.518a17.456,17.456,0,0,0,3.63.833.427.427,0,0,0,.5-.318c.689-3.3,1.309-6.622,1.956-9.933M.9,385.775a1.718,1.718,0,0,1,.276-1.62,1.753,1.753,0,0,1,1.832-.295q-.345,1.751-.686,3.5A3.474,3.474,0,0,1,.9,385.775M4.556,395.7q-.423-.082-.838-.2c-.307-.078-1.809-.292-1.946-.525-.159-.271.037-.788.08-1.058.266-1.675.626-3.342.95-5.007.661-3.389,1.323-6.779,2.058-10.152.114-.523.215-2.283.639-2.665s2.981.436,3.8.609c-1.615,5.232-2.344,10.853-3.441,16.209-.117.57-.216,1.35-.319,1.932a1.406,1.406,0,0,1-.214.656.847.847,0,0,1-.765.2" transform="translate(0 -248.912)" fill="#0278a5"/>
    <path id="Path_107536" data-name="Path 107536" d="M595.82,18.882c-5.7-.854-11.75,2.551-13.328,8.212a.258.258,0,0,0,.107.281,11.435,11.435,0,0,0,2.036,14.2,13.246,13.246,0,0,0,21.949-12.008A12.953,12.953,0,0,0,595.82,18.882M605.4,35.625a12.677,12.677,0,0,1-15.753,8.024c-7.084-2.223-9.825-9.922-6.616-16.393a.171.171,0,0,0,.017-.068c2.648-5.387,8.212-8.746,14.237-7.027A12.194,12.194,0,0,1,605.4,35.625" transform="translate(-385.413 -12.439)" fill="#0278a5"/>
    <path id="Path_107537" data-name="Path 107537" d="M602.436,33.523c1.018.87,2.006,1.839,3.1,2.615a.263.263,0,0,0,.431-.1,26.472,26.472,0,0,0,.427-5.168c.055-1.072.331-2.4-.181-3.414-.826-1.631-2.976-1.578-4.358-.785-1.207.692-3.237,2.13-2.54,3.7.524,1.177,2.166,2.336,3.125,3.155m-1.35-5.447c.9-.768,2.149-1.6,3.394-1.12,1.63.625,1.175,2.7,1.111,3.913a33.365,33.365,0,0,0-.162,4.653,19.721,19.721,0,0,0-2.593-2.4c-1.471-1.3-3.878-3.221-1.75-5.047" transform="translate(-397.476 -17.336)" fill="#0278a5"/>
    <path id="Path_107538" data-name="Path 107538" d="M621.947,62.169c-1.19-.93-2.422-1.808-3.634-2.71a.324.324,0,0,0-.418,0,.207.207,0,0,0-.2.175,30.757,30.757,0,0,0-.421,5.008,9.4,9.4,0,0,0,.245,3.654c.835,2.106,2.784,1.612,4.453.824,1.69-.8,3.646-2.182,2.68-4.272a8.512,8.512,0,0,0-2.706-2.674m1.69,4.973a5.707,5.707,0,0,1-2.275,1.435c-1.142.491-2.526,1.145-3.278-1a8.321,8.321,0,0,1-.1-2.591c.024-1.54.166-3.079.192-4.618,1.236.914,2.49,1.806,3.688,2.769,1.019.819,3.094,2.238,1.776,4" transform="translate(-409.449 -39.392)" fill="#0278a5"/>
    <path id="Path_107539" data-name="Path 107539" d="M622.673,51.455a.305.305,0,0,0-.117.2.131.131,0,0,0,0,.142.221.221,0,0,0,.159.174,18.327,18.327,0,0,0,3.656,2.776c.944.593,2.346,1.683,3.506,1.765,1.8.126,2.662-2.474,2.885-3.895.249-1.58-.178-3.97-2.185-4.017a11.083,11.083,0,0,0-3.64,1.064,17.865,17.865,0,0,0-4.267,1.79m6.879-1.815c2.063-.263,2.648,1.247,2.409,2.868a4.356,4.356,0,0,1-.993,2.534c-1.267,1.008-2.59.035-3.652-.569-1.374-.781-2.612-1.82-4-2.578a25.965,25.965,0,0,0,3.845-1.411,11.8,11.8,0,0,1,2.387-.844" transform="translate(-412.977 -32.241)" fill="#0278a5"/>
    <path id="Path_107540" data-name="Path 107540" d="M622.4,36.3a.264.264,0,0,0,.255.438,13.321,13.321,0,0,0,3.733-2.1,10.488,10.488,0,0,0,2.94-2.281c1.249-1.706-.842-2.956-2.19-3.783-1.2-.737-3.223-1.822-4.062-.009-.517,1.118-.415,2.771-.556,3.971a13.163,13.163,0,0,0-.11,3.756l-.01.011m.837-4.9c.079-.538.019-1.811.341-2.244.393-.527,1.956-.527,2.489-.337a5.184,5.184,0,0,1,1.118.719c1.069.767,1.932,1.594.883,2.851a7.808,7.808,0,0,1-1.9,1.282,18.079,18.079,0,0,0-3.466,2.292c.093-1.531.31-3.041.534-4.563" transform="translate(-412.828 -18.286)" fill="#0278a5"/>
    <path id="Path_107541" data-name="Path 107541" d="M596.344,46.894a.26.26,0,0,0-.141-.18,18.377,18.377,0,0,0-3.51-3.018c-.9-.646-2.245-1.832-3.4-1.97-1.848-.222-2.881,2.529-3.141,3.976-.276,1.537.11,3.742,2.009,3.886a11.33,11.33,0,0,0,3.7-.848,17.724,17.724,0,0,0,4.358-1.53.282.282,0,0,0,.13-.236.147.147,0,0,0-.008-.081m-4.706,1.027a13.476,13.476,0,0,1-2.433.7c-2.091.209-2.626-1.159-2.235-2.992.168-.785.724-2.438,1.5-2.875.953-.534,2.55.694,3.3,1.184,1.319.86,2.479,1.965,3.808,2.8a25.823,25.823,0,0,0-3.944,1.184" transform="translate(-388.791 -27.672)" fill="#0278a5"/>
    <path id="Path_107542" data-name="Path 107542" d="M599.97,60.316a13.439,13.439,0,0,0-3.864,1.882,10.19,10.19,0,0,0-3.067,2.1c-1.326,1.63.714,3.006,2,3.9,1.145.8,3.128,2.008,4.039.224.631-1.235.652-3.095.89-4.453a11.43,11.43,0,0,0,.24-3.2l.021-.021a.264.264,0,0,0-.255-.438m-.9,5.3a7.478,7.478,0,0,1-.478,2.221c-1.077,1.581-2.922-.069-3.719-.733-1.036-.863-1.533-2.177-.188-3.06.6-.393,1.258-.7,1.887-1.042a17.07,17.07,0,0,0,3.313-1.922c-.186,1.529-.5,3.027-.815,4.536" transform="translate(-393.123 -40.009)" fill="#0278a5"/>
    <path id="Path_107543" data-name="Path 107543" d="M604.81,25.907a14.915,14.915,0,0,0-12.374-12.881C585.848,12,578.878,15.915,577,22.433a.259.259,0,0,0,.125.292,13.2,13.2,0,0,0,2.171,16.215A15.238,15.238,0,0,0,604.81,25.907m-5.78,12.938a14.71,14.71,0,0,1-17.013,1.3c-6.075-3.733-7.628-11.362-4.459-17.547a.148.148,0,0,0,.013-.108c2.3-4.851,6.836-8.585,12.374-8.7A13.993,13.993,0,0,1,603.362,23.1a14.515,14.515,0,0,1-4.332,15.743" transform="translate(-381.617 -8.532)" fill="#0278a5"/>
    <path id="Path_107544" data-name="Path 107544" d="M585.646,299.536a13.612,13.612,0,0,0,7.236,3.068c.58,2.717,5.11,1.588,6.956,1.241,2.611-.49,6.28-1.954,6.318-5.1a13.935,13.935,0,0,0,4.084-4.47,14.457,14.457,0,0,0,1.677-6.339.122.122,0,0,0,.069.009,4.738,4.738,0,0,0,3.136-6.051,2.773,2.773,0,0,0-2.438-1.92,1.591,1.591,0,0,0-1.5,1.3c-.184-.74-.4-1.467-.629-2.178,1.665-2.441,4.463-.018,5.316,1.481a5.928,5.928,0,0,1,.745,3.39c-.263,3.068-2.473,4.271-4.779,5.692a.156.156,0,0,0,.1.29c3.749-.358,6.038-5.021,5-8.364-.742-2.389-4.548-5.812-6.538-2.951-.224-.649-.464-1.284-.719-1.9a.072.072,0,0,0-.122-.015.315.315,0,0,0-.271-.145,64.161,64.161,0,0,0-16.778,2.826c-2.537.73-5.09,1.486-7.568,2.4-2.082.767-4.451,1.783-5.489,3.877a.22.22,0,0,0,.147.308c.169,4.833,2.321,10.366,6.05,13.549m8.022-19.651a66.709,66.709,0,0,1,15.105-2.539,7.261,7.261,0,0,1-1.078,2.145c-1.2-1.174-3.892-.116-5.282.155a81.609,81.609,0,0,0-7.943,2.179c-2.647.8-5.345,1.179-8.015,1.852a8.775,8.775,0,0,0-4.826,2.74,8.063,8.063,0,0,1-1.5-.835c3.64-3.344,8.861-4.405,13.536-5.7m.255,2.669c2.086-.6,4.141-1.312,6.249-1.838,1-.25,2.016-.456,3.033-.641,1.121-.2,3.141-.843,4.186-.19-2.817,3.461-8.567,5.139-12.4,5.977a56.143,56.143,0,0,1-8.444,1.227,10.951,10.951,0,0,1-4.643-.559c3.128-2.98,8.046-2.826,12.017-3.977m18,5.094a23.359,23.359,0,0,0-.677-6.076.075.075,0,0,0,.072-.057c.445-1.9,2.609-.787,3.152.3a3.594,3.594,0,0,1,.227,2.441c-.411,1.615-1.645,2.349-2.774,3.389m-18.547,15a9.5,9.5,0,0,0,4.739-.859,15.869,15.869,0,0,0,7.575-2.72,6.719,6.719,0,0,1-4.933,4.089,22.721,22.721,0,0,1-3.08.555,8.416,8.416,0,0,1-2.172.177,5.052,5.052,0,0,1-2.128-1.242m-13.534-16.8.021-.02a5.264,5.264,0,0,0,1.436,1.067.116.116,0,0,0,.159.082,10.188,10.188,0,0,0,4.528.763,48.131,48.131,0,0,0,9.488-1.279c5.034-1.134,12.645-3.606,14.113-9.3,1.022,5.68,3.145,11.27.122,16.78-2.07,3.773-6.465,6.2-10.678,7.244,0-.082-.049-.163-.15-.133-4.739,1.4-9.8,1.042-13.474-2.657-3.22-3.24-4.951-8.093-5.564-12.546" transform="translate(-384.379 -183.475)" fill="#0278a5"/>
    <path id="Path_107545" data-name="Path 107545" d="M604.532,311.563c.761,3.011,2.263,7.095,4.913,8.989,1.6,1.141,4.429.978,5.646-.594a.15.15,0,0,0,.013-.026c.025.026.051.049.076.076.183.2.479-.077.307-.282-.267-.317-.547-.637-.839-.955,3.888.03,4.413-5.607,4.934-8.458a.29.29,0,0,0-.273-.3c-3.242.036-5.527,4.564-5.042,7.394a.14.14,0,0,0,.059.095l-.04.063c-.142.226.186.425.344.219.561-.728,1.124-1.452,1.638-2.215a4.565,4.565,0,0,0,.961-2.006.139.139,0,0,0-.23-.109,11.065,11.065,0,0,0-1.3,1.932q-.554.843-1.1,1.693a7.937,7.937,0,0,1,1.187-3.707c.247-.384,2.419-3.206,3.109-2.445.17.187-.344,1.935-.4,2.243a7.968,7.968,0,0,1-.889,2.931,5.373,5.373,0,0,1-3.476,2.125l-.1-.1a.149.149,0,0,0,.046-.1,3.935,3.935,0,0,0-2.049-3.643c-2.13-1.352-4.825-1.989-7.1-3.091-.188-.092-.462.034-.4.277m.668.463c2.939,1.438,8.125,2.241,8.548,5.811a13.578,13.578,0,0,0-6.383-3.861.116.116,0,0,0-.1.207,74.031,74.031,0,0,1,6.319,4.318.143.143,0,0,0,.116.164c.031.006.059.009.089.015.378.328.748.675,1.108,1.046a.106.106,0,0,0-.016,0,6.531,6.531,0,0,1-3.724.835,4.686,4.686,0,0,1-3.015-2.274,18.539,18.539,0,0,1-2.945-6.265" transform="translate(-401.028 -205.653)" fill="#0278a5"/>
    <path id="Path_107546" data-name="Path 107546" d="M261.73,534.1a9.671,9.671,0,0,0,11.145.337,9.823,9.823,0,0,0,3.943-10.3,10.122,10.122,0,0,0-6.565-6.928,15.643,15.643,0,0,0-5.567-.114,10.407,10.407,0,0,0-6.378,5.465c-1.613,3.8.278,9.049,3.423,11.54m5.554-16.467a.116.116,0,0,0,.034.017,9.978,9.978,0,0,1,5.308,2.056,8.45,8.45,0,0,1,3.406,5.836,8.641,8.641,0,0,1-7.733,9.551c-5.157.507-8.895-3.544-9.685-8.376-.82-5.015,3.865-9.264,8.671-9.084" transform="translate(-170.966 -342.891)" fill="#0278a5"/>
    <path id="Path_107547" data-name="Path 107547" d="M280.829,531.438a1.749,1.749,0,0,0-.3.14,1.984,1.984,0,0,0-.7,2.583,1.953,1.953,0,1,0,3.453-1.825,2.052,2.052,0,0,0-2.03-1,17.9,17.9,0,0,0-.5-2.328c-.2-.781-.282-1.854-.927-2.388a.171.171,0,0,0-.282.075c-.224.807.3,1.727.544,2.5.235.746.447,1.517.744,2.245m1.747,1.117a1.169,1.169,0,0,1-.449,1.763,1.213,1.213,0,0,1-1.433-.434,1.126,1.126,0,0,1,.063-1.539,1.3,1.3,0,0,1,1.819.209" transform="translate(-185.405 -349.319)" fill="#0278a5"/>
    <path id="Path_107548" data-name="Path 107548" d="M250.088,523.293c-2.271-1.76-5.68-2.358-8.452-2.926-.022-.12-.038-.241-.064-.36a12.456,12.456,0,0,0-8.3-8.561,15.129,15.129,0,0,0-4.982-.322,12.032,12.032,0,0,0-7.934,5.015c-3.012-1.344-8.631-3.334-10.731.263-1.578,2.7-2.414,5.964-3.3,8.937q-1.825,6.092-3.213,12.309c-.626,2.782-1.738,6.2-1.33,9.089a5,5,0,0,0,3.489,4.148,68.469,68.469,0,0,0,7.565,2.715c4.328,1.241,8.682,2.454,13.069,3.476a83.8,83.8,0,0,0,11.43,2.157c1.944.174,3.822.056,5.125-1.562,1.567-1.945,2.373-4.8,3.217-7.11a136.9,136.9,0,0,0,5.577-21.867c.38-2.033.653-4-1.157-5.4m-26.4,8.617a10.582,10.582,0,0,0,3.681,1.761c-.981,3.415-1.856,6.859-2.767,10.294-.845,3.188-1.94,6.785-2.6,9.787-3.867-1.049-7.48-2.193-11.289-3.436a23.413,23.413,0,0,1-5.235-2.017c-1.55-.964-1.858-2.238-1.6-3.949a154.581,154.581,0,0,1,3.925-16.344c.688-2.575,1.392-5.149,2.149-7.7.732-2.468,1.407-4.337,4.4-4.008,1.8.2,3.532.693,5.311.969-.121.231-.231.462-.327.693-1.926,4.632.452,11.022,4.349,13.955m1.557,12.232c.9-3.444,1.834-6.879,2.544-10.366a11.833,11.833,0,0,0,9.122-1.707,11.644,11.644,0,0,0,4.926-9.529,42.286,42.286,0,0,1,5.261,1.727c1.392.609,2.159,1.283,1.906,2.963-.192,1.269-.426,2.533-.671,3.792-.836,4.292-1.869,8.546-3.026,12.762-.539,1.965-1.085,3.929-1.692,5.874-.67,2.148-1.373,4.891-3.19,6.4-1.894,1.57-6.114.358-8.343-.017-2.454-.413-4.887-.944-7.3-1.547-.732-.183-1.264-.319-1.992-.514.856-3.03,1.62-6.627,2.456-9.834m4.858-32.274a.163.163,0,0,0,.073.033,12.24,12.24,0,0,1,7.059,2.919,10.231,10.231,0,0,1,3.586,7.062,10.493,10.493,0,0,1-9.107,11.169c-6.319.831-10.952-3.927-12.085-9.846-1.177-6.15,4.487-11.637,10.474-11.337m20.018,18.542a146.178,146.178,0,0,1-4.011,16.6,71.626,71.626,0,0,1-3.13,8.326,5.273,5.273,0,0,1-2.41,2.912,6.647,6.647,0,0,1-3.241.26,82.2,82.2,0,0,1-10.016-1.877c-3.2-.706-6.332-1.587-9.5-2.439-2.6-.7-5.226-1.321-7.768-2.221-1.088-.385-2.147-.844-3.229-1.247A8.5,8.5,0,0,1,203.454,549c-2.074-2.249-.631-6.746-.072-9.4.714-3.393,1.547-6.762,2.456-10.108a96.958,96.958,0,0,1,3.285-10.387c.452-1.137.953-2.735,2.037-3.438,1.125-.73,2.629-.532,3.9-.394a26.084,26.084,0,0,1,5.07,1.186c-.1.151-.193.3-.28.455-2.956-.91-7.654-2.684-9.488.387-1.342,2.249-1.815,5.358-2.512,7.856-1.759,6.306-3.945,12.759-4.874,19.255a5.244,5.244,0,0,0,.42,3.372c.746,1.149,2.512,1.867,3.75,2.306,5.485,1.944,11.127,3.637,16.767,5.062,2.831.716,5.689,1.335,8.575,1.789,2.151.339,5.272,1.237,7.359.411,1.671-.661,2.679-2.59,3.357-4.136a59.7,59.7,0,0,0,2.309-6.987,151.869,151.869,0,0,0,4.125-17.451c.3-1.757.945-3.673-.877-4.725a25.082,25.082,0,0,0-6.827-2.357.468.468,0,0,0-.128-.01c-.009-.14-.029-.279-.043-.419a29.274,29.274,0,0,1,6.709,2.007,3.419,3.419,0,0,1,2.265,3.2,20.13,20.13,0,0,1-.622,3.932" transform="translate(-133.793 -339.018)" fill="#0278a5"/>
    <path id="Path_107549" data-name="Path 107549" d="M544.837,386.443a10.016,10.016,0,0,0,.375-8c-.749-2.221-2.52-4.751-5.006-4.965-.006,0-.011,0-.018,0a.142.142,0,0,0-.013-.011c-2.2-1.186-5.065-.041-6.909,1.406a10.019,10.019,0,0,0-4.073,6.893,1.164,1.164,0,0,0-.927.28,3.233,3.233,0,0,0-.7,1.877,1.739,1.739,0,0,0,.3,1.639.932.932,0,0,0,.51.264c-.1.231-.167.479-.26.708a1.04,1.04,0,0,0-.828.044c-.548.268-.653,1.277-.821,1.791-.4,1.211-.749,2.436.62,2.906a4.993,4.993,0,0,0-.3.676,1.382,1.382,0,0,0-1.029-.023c-.6.283-.688,1.409-.834,1.961-.132.5-.494,1.331-.117,1.811a1.232,1.232,0,0,0,.725.4c-.02.045-.039.093-.056.142-.03.087-.06.17-.081.255a1.04,1.04,0,0,0-1.2-.018,2.089,2.089,0,0,0-.413.923,11.576,11.576,0,0,0-.43,1.673c-.081.5-.068.971.427,1.226a2.009,2.009,0,0,0,.384.146.843.843,0,0,0-.089.245,1.256,1.256,0,0,0-.869.043c-.472.237-.605,1.022-.712,1.468a4.389,4.389,0,0,0-.184,1.826,1,1,0,0,0,.737.757,1.681,1.681,0,0,0-.246.493c-1.14-.919-1.835,1.893-1.89,2.641a2.116,2.116,0,0,0,.133,1.08c.123.27.47.437.548.735a16.6,16.6,0,0,1-.095,2.043,5.5,5.5,0,0,0,.4,1.638.2.2,0,0,0,.237.137c1.25,1.365,3.666,1.715,5.447,2.153,1.73.611,3.941,1.643,5.736,1.188a.2.2,0,0,0,.274.016c1.076-.743,1.388-1.719,2.166-2.678.506-.623,1.2-.534,1.671-1.377.369-.664,1.326-3.389-.132-3.244a1.685,1.685,0,0,0,.065-.547.983.983,0,0,0,.961-.167,4.055,4.055,0,0,0,.918-1.689c.151-.42.466-1.137.233-1.585a1.23,1.23,0,0,0-.726-.548.848.848,0,0,0,.06-.256,2.418,2.418,0,0,0,.361.087c.569.093.856-.315,1.069-.785a10.979,10.979,0,0,0,.519-1.5,2.522,2.522,0,0,0,.205-1.1,1.024,1.024,0,0,0-1.016-.679c.029-.082.051-.169.072-.258.012-.05.022-.1.031-.147a1.278,1.278,0,0,0,.758.073c.64-.152.786-1.062.961-1.587s.7-1.5.4-2.067a1.345,1.345,0,0,0-.894-.574,4.948,4.948,0,0,0,.122-.729c1.4.357,1.779-.862,2.113-2.09.143-.525.554-1.327.333-1.859a.993.993,0,0,0-.706-.578c.048-.243.125-.492.172-.738a.946.946,0,0,0,.57.061c.612-.106.927-.689,1.147-1.208a3.239,3.239,0,0,0,.44-1.955,1.163,1.163,0,0,0-.622-.742m-11.847-10.567a7.925,7.925,0,0,1,7.037-2.079.176.176,0,0,0,.066,0,.18.18,0,0,0,.057.034,7.959,7.959,0,0,1,4.744,5.6c.708,2.523.289,4.459-.582,6.892a.214.214,0,0,0,0,.142c-2.426-.7-4.971-.9-7.406-1.681-2.3-.739-5.337-1.4-7.143-3.1a10.11,10.11,0,0,1,3.225-5.806m5.186,32.1a.9.9,0,0,1-.9.463.331.331,0,0,0-.288.406.178.178,0,0,0-.009.021c-.053.2-.142.4-.188.6a.377.377,0,0,0,.069.32.2.2,0,0,0,.122.253c.375.129.318,1.278.246,1.6a3.023,3.023,0,0,1-.458,1.036c-.324.382-.917.336-1.228.626a3.774,3.774,0,0,0-.583,1.03,11.241,11.241,0,0,1-1.634,2.105,20.087,20.087,0,0,1-2.86-.518c-.906-.284-1.783-.649-2.694-.916s-1.823-.444-2.727-.7a20.623,20.623,0,0,1-2.676-1.136,12.2,12.2,0,0,1-.232-2.4,5.262,5.262,0,0,0,.1-1.437,7.561,7.561,0,0,0-.479-.762c-.2-.467-.2-3.074,1.063-2.753a.194.194,0,0,0,.241-.147.364.364,0,0,0,.22-.191c.091-.2.115-.434.187-.643a.155.155,0,0,0,0-.024.329.329,0,0,0-.018-.5,1,1,0,0,1-.511-.737,4.174,4.174,0,0,1,.26-1.455c.027-.093.049-.186.075-.275a20.436,20.436,0,0,0,7.457,3.793,20.867,20.867,0,0,0,7.892,1.292,6.852,6.852,0,0,1-.447,1.05m6.778-20.223a4.308,4.308,0,0,1-.277.81,2.659,2.659,0,0,1-.552,1.042c-.415.352-.586.114-.953.1a.15.15,0,0,0-.136.086.209.209,0,0,0-.081.06,2.981,2.981,0,0,0-.354,1.113.262.262,0,0,0,.014.148.167.167,0,0,0,.036.165c.269.261.553.347.6.763a4.925,4.925,0,0,1-.349,1.241,3.915,3.915,0,0,1-.508,1.43c-.339.373-.714.237-1.109.312l-.02,0c-.017,0-.034.005-.051.009a.236.236,0,0,0-.159.32c-.1.3-.155.61-.232.908a.211.211,0,0,0,0,.114.117.117,0,0,0,.009.1,1.288,1.288,0,0,0,.484.4c.258.165.3.185.3.474a3.691,3.691,0,0,1-.254.842,5.581,5.581,0,0,1-.479,1.386c-.4.575-.506.168-.954.271a.212.212,0,0,0-.159.21.8.8,0,0,0-.234.383,1.132,1.132,0,0,0-.1.538.218.218,0,0,0,.285.151,2.719,2.719,0,0,1,.523.351c.259.3-.048.928-.146,1.245a9.555,9.555,0,0,1-.406,1.13c-.229.5-.431.421-.909.3a.307.307,0,0,0-.371.2.25.25,0,0,0-.011.074,1.247,1.247,0,0,0-.164.689.186.186,0,0,0,0,.138,1.006,1.006,0,0,0,.353.431.614.614,0,0,1,.185.754c-2.53-.487-5.086-.521-7.6-1.29-2.82-.861-5.167-2.368-7.793-3.6a.532.532,0,0,1,.355-.269c.282-.07.392,0,.642-.169a.185.185,0,0,0,.077-.115,1.246,1.246,0,0,0,.241-.669.238.238,0,0,0,.031-.066.308.308,0,0,0-.2-.372c-.356-.125-.608-.139-.629-.562a4.923,4.923,0,0,1,.316-1.357c.088-.307.162-.863.436-1.04a1.612,1.612,0,0,1,.755-.086.218.218,0,0,0,.321.03,1.136,1.136,0,0,0,.211-.5.8.8,0,0,0,.014-.449.21.21,0,0,0-.018-.263c-.233-.243-.447-.136-.585-.508-.169-.458.167-1.2.3-1.663s.151-1.014.673-1.08c.265-.033.46.055.716-.064a.118.118,0,0,0,.06-.075.212.212,0,0,0,.065-.094c.1-.292.223-.586.3-.886a.236.236,0,0,0,.042-.355c-.011-.013-.025-.023-.037-.035a.123.123,0,0,0-.015-.015c-.289-.279-.677-.371-.756-.868a3.921,3.921,0,0,1,.359-1.475,4.931,4.931,0,0,1,.389-1.229c.265-.324.55-.241.918-.311a.166.166,0,0,0,.12-.119.262.262,0,0,0,.093-.116,2.977,2.977,0,0,0,.314-1.125.205.205,0,0,0-.035-.094.151.151,0,0,0-.067-.146c-.314-.19-.588-.085-.742-.606a2.664,2.664,0,0,1,.11-1.174,4.328,4.328,0,0,1,.212-.829c.226-.522.575-.571,1.082-.586a.156.156,0,0,0,.155-.134.24.24,0,0,0,.052-.055c1.524,1.713,4.082,2.338,6.17,3.067,2.575.9,5.849,2.17,8.623,1.64a.923.923,0,0,1,.5,1.02" transform="translate(-345.549 -247.425)" fill="#0278a5"/>
    <path id="Path_107550" data-name="Path 107550" d="M569.1,361.644a.074.074,0,0,0,.049.068c2.015.763,4.169,1.044,6.183,1.854.263.106.42-.192.328-.4a10.216,10.216,0,0,0,.585-1.856c.168-.591.531-1.286.326-1.888a.166.166,0,0,0-.173-.116c-.391-.507-1.412-.651-1.931-.827a11.183,11.183,0,0,0-3.962-.883.148.148,0,0,0-.164.008c-.022,0-.045,0-.067,0a.113.113,0,0,0-.1.156,4.491,4.491,0,0,0-.688,1.6,6.753,6.753,0,0,0-.469,2.154.149.149,0,0,0,.085.126m6.9-1.857a6.808,6.808,0,0,0-.312,1.357,10.517,10.517,0,0,0-.323,1.817c-.181-.071-.364-.141-.549-.211a6.006,6.006,0,0,0,.872-3.057c.1.035.208.066.312.093m-.643-.213c-.188.537-.332,1.089-.5,1.631a14.393,14.393,0,0,0-.445,1.4c-.148-.053-.3-.107-.446-.158a6.037,6.037,0,0,0,.346-1.149c.191-.645.393-1.28.542-1.934.169.074.338.145.507.212m-.855-.366a11.788,11.788,0,0,0-.727,1.788,4.907,4.907,0,0,0-.349,1.276c-.236-.074-.474-.143-.713-.208a5.828,5.828,0,0,0,.424-1.378c.171-.609.328-1.224.5-1.832.282.1.571.224.863.354m-1.257-.481c-.233.594-.463,1.183-.658,1.794a5.116,5.116,0,0,0-.381,1.411c-.226-.055-.452-.106-.68-.151a10.818,10.818,0,0,0,.408-1.527,16.964,16.964,0,0,0,.412-1.779c.3.079.6.161.9.252m-1.311-.36a21.5,21.5,0,0,0-.709,2.3,4.161,4.161,0,0,0-.262,1.02c-.205-.031-.409-.053-.614-.073a.192.192,0,0,0,.021-.023,6.665,6.665,0,0,0,.627-1.711c.169-.546.311-1.094.435-1.65q.25.071.5.137m-1.951,1.305a7.7,7.7,0,0,0,.6-1.715c.16.058.321.113.484.164-.216.475-.416.954-.588,1.45a6.631,6.631,0,0,0-.524,1.894.212.212,0,0,0,.029.111c-.225-.014-.45-.016-.674-.013a14.267,14.267,0,0,0,.676-1.891" transform="translate(-377.471 -237.207)" fill="#0278a5"/>
    <path id="Path_107551" data-name="Path 107551" d="M549.924,415.74a.09.09,0,0,0-.131.028c-1.576,3.318-5.357,5.423-6.3,9.12a4.168,4.168,0,0,0,3.05,5.313c2.814.705,4.682-1.122,5.181-3.762.692-3.671-.879-6.918-1.373-10.466a.33.33,0,0,0-.425-.233m-3.782,13.607c-3.658-1.455-1.847-5.467-.154-7.672.86-1.12,1.762-2.208,2.62-3.33a10.428,10.428,0,0,0,1.053-1.482c.061,1.863,1.068,3.847,1.344,5.637.491,3.193-.27,8.674-4.864,6.847" transform="translate(-360.433 -275.783)" fill="#0278a5"/>
    <path id="Path_107552" data-name="Path 107552" d="M631.384,438.954a70.347,70.347,0,0,0-.507-10.807c-.146-1.815-.321-3.627-.511-5.437a14.84,14.84,0,0,0-.749-4.49c-.026-.06-.245-.27-.323-.368-.409-.512-1.578-.625-2.12-.751a22.806,22.806,0,0,0-9.07-.241c-2.206.383-7.668,1.463-7.362,4.641a.113.113,0,0,0,0,.044c0,.007,0,.015,0,.023-.151.029,2.405,10.512,2.636,11.356.513,1.877,1.062,3.745,1.628,5.606.333,1.093.527,2.52,1.519,3.239,1.82,1.319,5.181,1.2,7.278.93,2.638-.341,5.777-1.38,7.633-3.375a.238.238,0,0,0-.054-.369M620.037,417.38a22.408,22.408,0,0,1,3.69-.034,21.569,21.569,0,0,1,2.943.42c.674.145,2.133.177,1.205,1.515-.645.931-2.816,1.389-3.808,1.716-1.234.407-2.488.774-3.752,1.08a15.272,15.272,0,0,1-8.983-.328c.559-3.385,5.906-4.111,8.7-4.37m-8.846,4.859c3.4,1.91,7.867.954,11.4-.045.786-.222,5.437-1.477,6.653-3.005a29.743,29.743,0,0,0,.4,3.86q.164,1.5.315,3.009c-.66-.867-2.123-1.117-3.078-1.293a17.762,17.762,0,0,0-6.113.036c-2.615.432-6.52,1.258-7.851,3.837-.567-2.135-1.134-4.271-1.729-6.4m16.851,5.537a6.517,6.517,0,0,1-1.132-.214c-1.743-.428-3.477-1.248-5.1-.051-1.318.974-2.07,2-3.825,2.33a11.643,11.643,0,0,1-4.729-.35c1.367-2.747,4.869-3.489,7.707-3.984a17.572,17.572,0,0,1,4.9-.216,10.082,10.082,0,0,1,2.356.479c1.868.873.838,2.185-.185,2.006m-3.828,14.173a14.663,14.663,0,0,1-4.761.036,8.911,8.911,0,0,1-1.614-.358c-1.546-.574-1.6-1.311-2.008-2.613-.945-3.046-1.779-6.119-2.6-9.2a8.3,8.3,0,0,0,4.863.555,6.173,6.173,0,0,0,2.294-.848c1.13-.73,1.868-2.1,3.354-2.118.873-.008,5.411,1.782,6.391.43.032.331.066.661.1.991.319,3.329.348,6.815.959,10.11a.226.226,0,0,0-.042.014c-2.281,1.275-4.3,2.55-6.937,3" transform="translate(-405.145 -276.309)" fill="#0278a5"/>
    <path id="Path_107553" data-name="Path 107553" d="M657.721,118.377c-.878-1.406-3.865,1.071-4.565,1.591a23.314,23.314,0,0,0-2.381,2.017c2.567-4.409,5.426-10.4,3.179-10.866-1.665-.348-3.314,3.684-3.776,4.757a29.9,29.9,0,0,0-1.747,6.173,24.811,24.811,0,0,0-.473-4.265c-.129-.66-.686-4.569-2.019-4.372-1.518.224-1.089,4.594-1,5.429a13.85,13.85,0,0,0,2.519,6.887,5.346,5.346,0,0,0-4.653,1.19c-2.288,1.829-3.207,4.857-4.122,7.518-.689,2-1.331,4.022-1.943,6.05a.235.235,0,0,0-.117.216c0,.045.008.089.012.134-.381,1.274-.754,2.551-1.109,3.832q-.762,2.748-1.439,5.518a24.512,24.512,0,0,0-.986,4.907.122.122,0,0,0,.042.094.175.175,0,0,0,.288.108,68.016,68.016,0,0,0,6.216-7.587q3.191-4.265,6.039-8.779,1.383-2.187,2.69-4.422a14.806,14.806,0,0,0,1.91-3.993c.288-1.258.036-3.244-1.139-3.991a23.98,23.98,0,0,0,6.031-3.852c.821-.707,3.439-2.859,2.54-4.3M651.4,114.75c.337-.615,1.259-2.631,1.937-2.732,1.387-.207.225,2.888-.007,3.567a27.311,27.311,0,0,1-1.745,3.939c-.955,1.8-2.244,3.464-3.292,5.223.462-2.064.907-4.131,1.538-6.152a20.953,20.953,0,0,1,1.569-3.843m-6.01,2.381c-.015-.492,0-3.522,1.032-2.731.518.4.661,1.747.817,2.366a21.924,21.924,0,0,1,.578,3.345c.167,1.8-.029,3.561-.032,5.348a25.012,25.012,0,0,1-2.03-5.289,17.526,17.526,0,0,1-.365-3.039m4.15,13.47a17.559,17.559,0,0,1-2.09,4.071q-2.091,3.538-4.373,6.959c-2.944,4.431-6.354,8.494-9.44,12.808.829-2.274,1.191-4.837,1.816-7.152q.719-2.66,1.516-5.3a2.572,2.572,0,0,0,.337.486,2.362,2.362,0,0,0,1.722.891c.133-.01.267-.166.17-.3a7.134,7.134,0,0,0-1.253-.98,2.19,2.19,0,0,1-.689-1.052q.4-1.291.809-2.576c.21-.651.43-1.39.67-2.171a3.749,3.749,0,0,0,.969,1.6c.625.607,1.941,1.511,2.851,1.156a.23.23,0,0,0,.1-.379,3.081,3.081,0,0,0-1.137-.588,4.938,4.938,0,0,1-1.137-.67,3.974,3.974,0,0,1-1.345-2.08,29.486,29.486,0,0,1,1.945-4.865,5.508,5.508,0,0,0,1.149,2,3.2,3.2,0,0,0,2.41,1.327.14.14,0,0,0,.1-.236c-.558-.6-1.375-.9-1.983-1.46a6.088,6.088,0,0,1-1.438-2.054c1.4-2.439,3.36-4.2,6.281-3.826-.018.038-.039.075-.057.113-.094.2.153.434.325.251.05-.054.116-.134.189-.226a.229.229,0,0,0,.062.022.191.191,0,0,0,0,.048c-.084.213.09.517.353.418l.011,0a3.472,3.472,0,0,1,1.162,3.763m6.026-9.143a22.939,22.939,0,0,1-2.336,1.9,49.9,49.9,0,0,1-4.836,2.785l-.03-.018a26.45,26.45,0,0,1,3.685-4.363c.5-.447,4.408-3.851,5.114-2.921.49.645-1.175,2.228-1.6,2.622" transform="translate(-419.987 -73.7)" fill="#0278a5"/>
    <path id="Path_107554" data-name="Path 107554" d="M413.783,549.461a12.624,12.624,0,0,0-2.419-2.159c-.5-.345-1.276-1.059-1.929-.748a.334.334,0,0,0-.157.171.114.114,0,0,0-.031-.014.662.662,0,0,0-.857.446c-.248.638.314,1.235.7,1.682-.185.188-.344.4-.532.593-.291.292-.6.561-.891.858a7.818,7.818,0,0,0-1.455,1.872,15.175,15.175,0,0,0-3.963-3.469.113.113,0,0,0-.111.01,1.116,1.116,0,0,0-1.241.945c-.267,1.343,1.5,2.83,2.322,3.653,1.48,1.484,3.11,2.828,4.682,4.213.61.537,1.267,1.25,1.977,1.879-1.773,2.1-3.517,4.226-5.313,6.308-.815-1.343-2.511-2.4-3.641-3.471-1.293-1.222-2.528-2.507-3.835-3.713,1.761-1.784,3.539-3.56,5.206-5.427.273-.306-.181-.706-.469-.423-2.274,2.229-4.39,4.631-6.572,6.95-2.149,2.285-4.415,4.523-6.4,6.957a.1.1,0,0,0-.034.041l-.038.045a36.226,36.226,0,0,0-.029,3.893,14.736,14.736,0,0,0,.465,3.784,30.314,30.314,0,0,0-2.732,2.843,12.631,12.631,0,0,0-2.211,2.876c-.055.123.083.278.207.187a15.718,15.718,0,0,0,2.409-2.7c.778-.922,1.727-1.94,2.458-2.9a1.839,1.839,0,0,0,.336-.042c2.15-.461,4.912.177,7.447-.418a.719.719,0,0,0,.2-.1,124.169,124.169,0,0,0,13.02-14.3,4.985,4.985,0,0,0,1.719.946c.679.187,1.839.13,1.7-.865-.178-1.314-2.481-2.574-3.368-3.366-.4-.355-.782-.724-1.158-1.1a7.676,7.676,0,0,0,1.592-1.593c.567-.628,1.146-1.244,1.711-1.873a2.168,2.168,0,0,0,1.4.465c1.928-.212.474-2.208-.164-2.945m-10,17.138c-1.1,1.258-5.489,6.215-7.1,7.22a3.857,3.857,0,0,0-.985-.572,15.563,15.563,0,0,1-2.134-1.219c-1.326-.971-2.01-2.417-3.095-3.6-.073-.08-.192.018-.166.109a7.454,7.454,0,0,0,2.864,4,13.605,13.605,0,0,0,2.071,1.255c-.84-.005-1.7.015-2.528.06a24.646,24.646,0,0,0-3.04.289c-.011-.917-.251-2.193-.354-3.358-.121-1.368.044-2.666-.075-4.034a.075.075,0,0,0,0-.015c2.321-2.084,4.243-4.51,6.413-6.749.4-.411.8-.819,1.2-1.227a34.646,34.646,0,0,0,3.449,3.768c1.143,1.121,2.481,2.848,3.969,3.513-.163.188-.324.378-.488.566m7.969-7.932c.282.249,1.858,1.367.673,1.356-.715-.007-1.477-.88-1.98-1.321-.944-.827-1.882-1.661-2.825-2.491-.922-.812-1.854-1.615-2.762-2.443-.5-.459-1-.926-1.473-1.42q-.5-.514-.948-1.069a1.386,1.386,0,0,1-.161-1.866.306.306,0,0,0,.245-.06c1.324,1.526,2.847,2.933,4.2,4.435a60.211,60.211,0,0,0,5.033,4.878m-1.319-5.218a6.491,6.491,0,0,0-1.3,1.839c-.937-.948-1.825-1.944-2.732-2.921.644-.648,1.216-1.362,1.89-1.985a3.831,3.831,0,0,0,1.094-1.215,16.086,16.086,0,0,0,2.261,2.089c.13.1.267.208.411.321q-.824.923-1.619,1.873m2.267-2.367A17.021,17.021,0,0,1,411.217,550c-.4-.323-.8-.657-1.176-1-.181-.166-1.962-1.748-.779-2a.134.134,0,0,0,.041-.018.23.23,0,0,0,.093.07,10.176,10.176,0,0,1,2.354,1.583c.607.5,1.9,1.48,2.1,2.256.229.9-.788.425-1.148.2" transform="translate(-254.913 -362.522)" fill="#0278a5"/>
    <path id="Path_107555" data-name="Path 107555" d="M542.98,144.334c-.519-1.706-2.323-2.128-3.907-1.773,1-1.666,1.948-4,.685-5.444-1.187-1.354-3.452-.51-4.881.318-.515-1.519-1.661-3.364-3.382-3.246-2.072.14-3.461,3.05-4.225,4.948-1.025-1.878-3.159-3.639-5.345-2.732a3.352,3.352,0,0,0-1.865,4.087c-2.459-.918-5.577-.838-7.155,1.552a4.4,4.4,0,0,0,.627,5.673c-2.829,1.763-3.945,5.991-1.541,8.629a5.617,5.617,0,0,0,5.9,1.424c2.118,1.989,3.148,5.976,4.049,8.648,1.033,3.061,1.567,6.212,2.476,9.293a.252.252,0,0,0,.229.193c1.061,2.134,4.958,2.217,6.94,1.785,2.376-.518,5.13-2.554,4.89-5.242a.248.248,0,0,0-.073-.161c-.131-2.053-.772-4.1-1.02-6.147a45.2,45.2,0,0,1-.178-7.77,5.642,5.642,0,0,0,5.142-2.2,3.961,3.961,0,0,0-1.058-5.726c2.246-1.207,4.544-3.316,3.692-6.111M535.914,172.4c-.968,2.022-1.852,3.595-4.189,4.267-2.032.584-5.519.574-6.835-1.419a.22.22,0,0,0-.026-.026,37.739,37.739,0,0,0-2.564-9.937c-.923-2.472-1.882-5.932-4.082-7.626a6.11,6.11,0,0,0,1.294-.672c.958,1.525,2,2.984,2.894,4.553a25.989,25.989,0,0,0,3.349,5.189.416.416,0,0,0,.724-.219,27.5,27.5,0,0,0,.116-5.253c.051,0,.1.007.152.006a5.083,5.083,0,0,0,2.768-.9,13.855,13.855,0,0,0,1.589,4.983.417.417,0,0,0,.786-.13c.18-1.34.366-2.683.647-4.008.218-1.03.638-2.066.8-3.113a10.985,10.985,0,0,0,1.416.239,28.629,28.629,0,0,0-.2,7.109,21.819,21.819,0,0,0,1.364,6.958m-16.106-15.635a5.737,5.737,0,0,0,.6-.532c1.114,2.278,2.973,4.638,5.579,4.981a27.794,27.794,0,0,0-.278,4.177c-2.111-2.751-3.162-6.423-5.9-8.627m10.231,3.175a4,4,0,0,0,1.28-2.492,14.736,14.736,0,0,0,1.492.508,7.789,7.789,0,0,0-.949,2.636c-.241,1.024-.421,2.06-.581,3.1-.256-.654-.479-1.321-.678-2a12.979,12.979,0,0,0-.563-1.756m8.182-9.837a.4.4,0,0,0,.024.725c3.333,1.095,2.286,5.089-.266,6.316-2.241,1.077-4.741.327-6.881-.622a.388.388,0,0,0-.521.319,3.726,3.726,0,0,1-4.175,3.6.166.166,0,0,0-.2-.013,4.111,4.111,0,0,1-.963-.219c-2.166-.782-3.482-2.869-4.368-4.866a.4.4,0,0,0-.682-.064c-1.7,2.242-5.354,2.809-7.429.712-2.368-2.393-1.233-6.5,1.665-7.858a.4.4,0,0,0,.065-.682,3.637,3.637,0,0,1-.322-5.672c1.825-1.662,4.592-1.207,6.588-.193.333.169.625-.308.406-.567-1.87-2.221.815-4.735,3.151-4.012a4.653,4.653,0,0,1,2.731,2.719s.025.089.026.091a.4.4,0,0,0,.749-.029,16.757,16.757,0,0,1,2.132-3.566c1.9-2.222,3.708-.134,4.237,1.964a.448.448,0,0,0,.717.268c1.108-.761,3.831-2.156,4.534-.082.51,1.507-.972,3.651-1.8,4.812-.234.329.143.864.529.641,1.836-1.064,4.588-.583,4.021,2.347-.389,2.006-2.243,3.133-3.964,3.93" transform="translate(-338.772 -89.015)" fill="#0278a5"/>
    <path id="Path_107556" data-name="Path 107556" d="M539.026,158.312c-1.5-.154-1.571,1.355-1.482,2.539a2.883,2.883,0,0,0-3.912.747,4.137,4.137,0,0,0,.231,5.031.119.119,0,0,0,.2-.115,6.044,6.044,0,0,1-.581-3.42c.44-1.838,2.529-3.028,4.169-1.634.126.107.394.051.371-.153-.11-.96-.425-2.7,1.7-2.348.878.145,1.457,1.374,1.493,2.143a.135.135,0,0,0,.269,0,2.942,2.942,0,0,0-2.457-2.79" transform="translate(-353.505 -105.014)" fill="#0278a5"/>
    <path id="Path_107557" data-name="Path 107557" d="M573.787,169.587a1.656,1.656,0,0,0-.566-2.184,2.615,2.615,0,0,0-3.359.5c-.141.139.065.332.213.213a2.64,2.64,0,0,1,1.7-.691q1.922-.011,1.327,2.23c-.143.159-.056.474.189.456,2.4-.174,2.1,2.828.653,3.835a7.6,7.6,0,0,1-2.868.921c-.121.025-.079.189.027.2,1.924.2,4.22-.633,4.612-2.767a2.268,2.268,0,0,0-1.931-2.714" transform="translate(-378.003 -110.776)" fill="#0278a5"/>
    <path id="Path_107558" data-name="Path 107558" d="M69.545,267.222c-2.865-4.893-10-8.593-15.583-6.3a.294.294,0,0,0,.147.562,18.885,18.885,0,0,1,7.3.429,13.074,13.074,0,0,1,8.355,17.7A11.385,11.385,0,0,1,64.3,285.76c-2.705,1.3-6.184,1.336-9.1.964C49.54,286,44.24,282.277,43.974,276.165c-.249-5.73,3.366-13.858,9.516-15.1a.116.116,0,0,0-.028-.23c-5.789.634-9.058,7.293-9.911,12.427-1.036,6.245,2.531,11.549,8.511,13.41,5.838,1.816,13.13,1.14,16.841-4.192a14.472,14.472,0,0,0,.641-15.253" transform="translate(-28.773 -172.627)" fill="#0278a5"/>
    <path id="Path_107559" data-name="Path 107559" d="M67.625,251.569a17.1,17.1,0,0,0-5.031-5.111,2.793,2.793,0,0,0,.677-2.2c-.238-1.012-1.545-1.572-2.417-1.882-.839-.3-2.137-.847-2.945-.2a2.7,2.7,0,0,0-.787,1.8,19.521,19.521,0,0,0-2.021-.444,2.494,2.494,0,0,0-2.677-1.975c-.339-1.579-2.554-2.709-4-2.625a3.619,3.619,0,0,0-3.333,4.08c-.975.426-1.658,1.059-1.146,2.011a8.032,8.032,0,0,0-2.907,1.912c-.43-.541-1.183-1.284-1.889-1.225-.761.063-1.623,1.068-2.081,1.617a2.738,2.738,0,0,0-.853,2.292,3.164,3.164,0,0,0,1.649,1.709,20.676,20.676,0,0,0-2.775,9.562c-.129,7.524,5.91,13.124,12.782,15.062a17.709,17.709,0,0,0,18.649-5.672,15.959,15.959,0,0,0,1.108-18.709M57.99,243.18c.554-.9,1.574-.5,2.411-.211a7.7,7.7,0,0,1,.836.328c.7.334.811.44.979,1.255a1.544,1.544,0,0,1-.178,1.43l-.045.091a18.969,18.969,0,0,0-4.359-1.949,3.538,3.538,0,0,1,.356-.944m-9.014-3.538a3.566,3.566,0,0,1,1.848.9,4.254,4.254,0,0,1,.76,1.029,26.369,26.369,0,0,0-3.515.646,19.549,19.549,0,0,0-2.429.583,3.041,3.041,0,0,1,3.337-3.157m.291,3.042a14.582,14.582,0,0,1,2.861-.376c.133.006.2.013.238.018a2.231,2.231,0,0,1,1.829,1.078,21.016,21.016,0,0,0-9.684,1.445c-.229-1.714,3.724-1.988,4.757-2.164m-11.832,7.494c-.866-.875-.535-1.684.132-2.46a5.188,5.188,0,0,1,1.2-1.13c.761-.439,1.444.088,2.022.589a18.181,18.181,0,0,0-2.228,2.951q-.193.311-.379.627a5.388,5.388,0,0,1-.75-.578M66.8,268.144c-.248-.1-.5-.186-.746-.3a2.963,2.963,0,0,0-.755-.331.1.1,0,0,0-.11.141,1.8,1.8,0,0,0,1.415.788q-.377.559-.794,1.081c-.269-.113-.546-.214-.809-.336a3.4,3.4,0,0,0-1.045-.42c-.056-.006-.118.053-.087.111a1.87,1.87,0,0,0,.881.715,5.4,5.4,0,0,0,.738.318q-.5.587-1.055,1.12a2.212,2.212,0,0,1-.548-.243c-.263-.164-.475-.466-.769-.567a.108.108,0,0,0-.148.082c-.027.4.371.706.68.884a1.982,1.982,0,0,0,.429.179q-.464.421-.958.8a.147.147,0,0,0-.012-.023,2.319,2.319,0,0,0-1.086-.927c-.081-.02-.126.072-.107.136.135.456.585.738.944,1.012q-.625.464-1.291.865a4,4,0,0,1-.6-.4,6.916,6.916,0,0,0-.759-.674c-.073-.043-.138.038-.138.1a1.49,1.49,0,0,0,.622,1,2.249,2.249,0,0,0,.4.255,16.464,16.464,0,0,1-1.87.9,5.286,5.286,0,0,0-1.087-1.437.078.078,0,0,0-.125.07,2.98,2.98,0,0,0,.806,1.522,16.59,16.59,0,0,1-1.63.514,2.986,2.986,0,0,0-.308-1.024.112.112,0,0,0-.212.026,3.026,3.026,0,0,0,.1,1.1q-.4.094-.815.169a1.916,1.916,0,0,0-.122-1.015.127.127,0,0,0-.24.029,4.059,4.059,0,0,0-.051,1.055q-.625.1-1.26.147a2.253,2.253,0,0,0-.129-1.018.093.093,0,0,0-.176.021c-.038.34-.058.682-.084,1.023-.343.019-.687.03-1.033.028a1.506,1.506,0,0,0,.061-1.01.119.119,0,0,0-.217,0,3.878,3.878,0,0,0-.221.664,2.791,2.791,0,0,1-.12.336c-.232-.008-.463-.02-.7-.037q-.314-.024-.63-.059a2.069,2.069,0,0,0,.1-1.206c-.02-.084-.156-.133-.19-.028-.126.389-.206.791-.316,1.183q-.507-.067-1.016-.161a1.72,1.72,0,0,0,.26-1.085c-.014-.1-.172-.168-.236-.066a9.094,9.094,0,0,0-.507,1.056q-.7-.146-1.393-.345a1.487,1.487,0,0,0,.535-1.246.123.123,0,0,0-.216-.06,4.026,4.026,0,0,0-.424.7,3.466,3.466,0,0,1-.324.478q-.509-.157-1.011-.34a.982.982,0,0,0,.372-.9.116.116,0,0,0-.2-.057,9.931,9.931,0,0,1-.662.77q-.449-.179-.89-.379c.068-.065.137-.128.2-.2.151-.171.368-.445.314-.69a.109.109,0,0,0-.147-.086c-.206.081-.333.331-.462.5a2.818,2.818,0,0,1-.271.305q-.585-.281-1.149-.6c.311-.193.586-.474.541-.809a.127.127,0,0,0-.172-.1,1.54,1.54,0,0,0-.5.4,3.823,3.823,0,0,1-.3.247q-.636-.384-1.236-.818a.871.871,0,0,0,.577-.73.126.126,0,0,0-.172-.1,1.826,1.826,0,0,0-.429.347,1.443,1.443,0,0,1-.333.219q-.509-.389-.984-.816c.278-.143.544-.343.553-.611a.124.124,0,0,0-.1-.138.818.818,0,0,0-.5.207c-.1.072-.2.141-.307.208a14.6,14.6,0,0,1-1.154-1.241,1.183,1.183,0,0,0,.734-.676c.025-.077-.027-.184-.123-.164a1.945,1.945,0,0,0-.633.3c-.092.056-.19.105-.288.154a13.137,13.137,0,0,1-1.023-1.544,1.323,1.323,0,0,0,1.137-.677c.027-.074-.011-.193-.108-.194a1.688,1.688,0,0,0-.715.216c-.18.083-.364.153-.55.223q-.273-.531-.5-1.093c.426-.151.986-.39,1.105-.805a.127.127,0,0,0-.13-.174,1.412,1.412,0,0,0-.609.3c-.166.109-.333.211-.505.306-.093-.259-.181-.52-.257-.787-.028-.1-.049-.2-.075-.3a1.439,1.439,0,0,0,1.071-.661.108.108,0,0,0-.111-.148,2.111,2.111,0,0,0-.721.257,3.209,3.209,0,0,1-.345.129,12.833,12.833,0,0,1-.213-1.3,1.407,1.407,0,0,0,1.244-.208.138.138,0,0,0-.053-.209,1.244,1.244,0,0,0-.734-.065c-.165.012-.332.023-.5.03a14.45,14.45,0,0,1-.031-1.859,1.3,1.3,0,0,0,1.193-.037.145.145,0,0,0-.03-.246,2.094,2.094,0,0,0-.782-.143c-.118-.014-.233-.034-.347-.058a17.048,17.048,0,0,1,.266-1.922c.107.081.213.162.322.241.18.132.424.346.661.294a.153.153,0,0,0,.132-.168c-.045-.249-.3-.376-.5-.5-.173-.1-.348-.2-.523-.306.138-.623.309-1.24.506-1.847.064.047.124.1.192.141a1.028,1.028,0,0,0,.89.2.149.149,0,0,0,.061-.226,1.817,1.817,0,0,0-.7-.4,2.477,2.477,0,0,1-.293-.172c.236-.676.5-1.339.8-1.982l.075-.161a1.086,1.086,0,0,0,.627.286.108.108,0,0,0,.115-.146.75.75,0,0,0-.332-.373l-.235-.14c.216-.45.453-.912.709-1.377a1.9,1.9,0,0,0,.135.161c.157.165.383.372.631.309a.165.165,0,0,0,.141-.18.872.872,0,0,0-.378-.476c-.1-.081-.191-.168-.28-.258.267-.462.555-.922.863-1.371.056.069.112.137.175.2.139.145.295.323.515.294a.154.154,0,0,0,.131-.128c.035-.22-.142-.382-.284-.524a3.251,3.251,0,0,0-.262-.236q.381-.526.8-1.016a1.394,1.394,0,0,0,.607.952c.089.047.181-.043.174-.13a2.464,2.464,0,0,0-.241-.7c-.068-.172-.127-.347-.178-.525a11.138,11.138,0,0,1,1.007-.954,1.326,1.326,0,0,0,.494,1.027.138.138,0,0,0,.219-.124,3.28,3.28,0,0,0-.2-.672,3.075,3.075,0,0,1-.123-.543,7.854,7.854,0,0,1,1.449-.863,1.268,1.268,0,0,0,.388.792.119.119,0,0,0,.19-.075,2.11,2.11,0,0,0-.13-.746c-.011-.046-.017-.093-.027-.139a10.3,10.3,0,0,1,1.64-.433,1.945,1.945,0,0,0,.084.8.082.082,0,0,0,.149,0,2.064,2.064,0,0,0,.031-.844l.041-.007q.927-.19,1.859-.318a2.05,2.05,0,0,0,.045,1.153.1.1,0,0,0,.171.024,2.268,2.268,0,0,0,.218-1.232q.729-.088,1.457-.136a.9.9,0,0,0-.036.539.193.193,0,0,0,.353,0,1.65,1.65,0,0,0,.066-.42c.005-.049.015-.1.023-.145q1.084-.053,2.157-.007a1.456,1.456,0,0,0-.207.757.1.1,0,0,0,.153.065,1.8,1.8,0,0,0,.47-.8q.914.056,1.813.192c-.08.238-.173.471-.246.719-.023.079.068.19.146.114a1.734,1.734,0,0,0,.433-.78,18.7,18.7,0,0,1,1.92.426,3.746,3.746,0,0,0-.6,1.3c-.015.086.1.166.171.1a3.953,3.953,0,0,0,.8-1.286,17.128,17.128,0,0,1,1.9.7,5.328,5.328,0,0,1-.283.524c-.156.254-.5.552-.5.858,0,.074.049.153.135.138.349-.059.554-.5.713-.79a4.2,4.2,0,0,0,.263-.583,16.333,16.333,0,0,1,1.7.909c-.013.012-.028.024-.04.037-.157.155-.489.467-.357.713a.111.111,0,0,0,.086.067c.234,0,.363-.248.5-.4a2.333,2.333,0,0,1,.185-.17q.447.292.88.618l-.511.607c-.208.248-.476.495-.473.837a.122.122,0,0,0,.136.106c.333-.079.509-.4.7-.659l.47-.645q.584.462,1.139.991a7.326,7.326,0,0,1-.615.594c-.185.158-.508.329-.533.592a.117.117,0,0,0,.1.13c.29.063.579-.267.774-.445s.391-.383.573-.587q.506.505.959,1.047l-.7.549c-.187.147-.474.291-.5.549a.128.128,0,0,0,.105.143c.261.035.457-.2.645-.356l.7-.571q.4.5.746,1.017a6.068,6.068,0,0,1-.53.707,5.645,5.645,0,0,0-.681.814.085.085,0,0,0,.088.118,2.264,2.264,0,0,0,1.367-1.264,15.6,15.6,0,0,1,.886,1.6c-.13.164-.265.324-.409.478-.234.249-.516.452-.724.724a.149.149,0,0,0,.134.237,1.846,1.846,0,0,0,1.222-.951,15.231,15.231,0,0,1,.643,1.754,5.736,5.736,0,0,1-.583.3,2.866,2.866,0,0,0-.828.4.112.112,0,0,0,.023.19,1.629,1.629,0,0,0,1.49-.526,14.98,14.98,0,0,1,.327,1.5c-.268.079-.53.187-.8.251a2.208,2.208,0,0,0-.9.324.116.116,0,0,0,.024.2,1.884,1.884,0,0,0,1.741-.329,14.652,14.652,0,0,1,.122,2.241,6.584,6.584,0,0,0-.678.012c-.252.019-.575.025-.679.3a.163.163,0,0,0,.046.183c.191.188.461.079.7.036.2-.036.4-.062.6-.081a14.559,14.559,0,0,1-.194,1.722c-.161,0-.327.017-.481.007-.412-.026-.814-.078-1.222-.137a.093.093,0,0,0-.05.176,3.523,3.523,0,0,0,1.211.375c.138.015.3.039.456.045a14.513,14.513,0,0,1-.4,1.5l-.064-.009a4.475,4.475,0,0,1-.915-.24c-.151-.058-.307.165-.153.258a3.4,3.4,0,0,0,.989.415c-.107.3-.224.6-.352.9-.136-.015-.273-.025-.415-.05a3.169,3.169,0,0,1-.9-.323c-.113-.059-.212.092-.145.185a1.693,1.693,0,0,0,1.239.662c-.117.247-.239.493-.371.737q-.283.522-.6,1.016" transform="translate(-23.274 -158.498)" fill="#0278a5"/>
    <path id="Path_107560" data-name="Path 107560" d="M79.052,270.074a5.3,5.3,0,0,0,.1-1.64c-.022-.435.054-.981-.331-1.262a.2.2,0,0,0-.243,0c-.344.339-.218.8-.182,1.25a5.412,5.412,0,0,0,.332,1.693.173.173,0,0,0,.328-.04" transform="translate(-51.969 -177.209)" fill="#0278a5"/>
    <path id="Path_107561" data-name="Path 107561" d="M117.574,297.684a.275.275,0,0,0,.039-.279.553.553,0,0,0-.036-.063.279.279,0,0,0-.257-.108,2.632,2.632,0,0,0-.779.269c-.265.11-.527.226-.8.315a.178.178,0,0,0,.041.339,2.293,2.293,0,0,0,1.792-.473" transform="translate(-76.71 -197.178)" fill="#0278a5"/>
    <path id="Path_107562" data-name="Path 107562" d="M87.883,324.734a11.763,11.763,0,0,0,.224,1.963,1.438,1.438,0,0,0,.633,1.093.146.146,0,0,0,.189-.075,1.69,1.69,0,0,0-.089-1.33c-.186-.586-.4-1.164-.586-1.749-.071-.218-.381-.109-.371.1" transform="translate(-58.3 -215.278)" fill="#0278a5"/>
    <path id="Path_107563" data-name="Path 107563" d="M52.38,307c-.349.055-.778.077-.975.4a.181.181,0,0,0,.03.248c.319.238.711.1,1.071.013.472-.12.942-.251,1.412-.377.274-.073.147-.513-.125-.477-.471.063-.945.114-1.414.188" transform="translate(-34.078 -203.53)" fill="#0278a5"/>
    <path id="Path_107564" data-name="Path 107564" d="M79.218,284.486a17.778,17.778,0,0,0,.816,3.274.739.739,0,0,0-.2.272.783.783,0,0,0,.161.876.859.859,0,0,0,.806.151.9.9,0,0,0,.36-.154,9.969,9.969,0,0,0,3.122,1.894c1.11.506,2.193,1.255,3.306,1.851-.061.065-.126.127-.184.194a.425.425,0,0,0,.238.659c.988.337,2.5.846,2.774.672.4-.25.212-.722.12-1.1l-.479-1.946a.436.436,0,0,0-.764-.213,10.556,10.556,0,0,1-.845.877c-2.083-1.439-4.859-2.13-7.036-3.372a.771.771,0,0,0-.235-.665.82.82,0,0,0-.461-.205c-.182-1.137-.467-2.272-.7-3.408.263-.1,1.451-.352,1.233-.536a15.973,15.973,0,0,1-1.618-1.678.325.325,0,0,0-.55.067,10.926,10.926,0,0,0-.82,2.648,4.693,4.693,0,0,0,.954-.163m9.978,7.879q.119-.13.233-.263l.119.465c.016.063.036.13.056.2-.131-.134-.266-.263-.406-.386,0,0,0-.008,0-.012m-.632.816c.011.051.023.1.035.153l-.245-.032a1.96,1.96,0,0,0,.21-.121m-8.517-9.853c-.059.01-.117.024-.175.037-.015-.086-.031-.172-.044-.259.071.075.147.147.22.221m.428,5.633c.007,0,.014,0,.021-.008-.034.019-.034.018-.021.008" transform="translate(-51.919 -186.948)" fill="#0278a5"/>
    <path id="Path_107565" data-name="Path 107565" d="M554.046,550.446c-1.418-5.831-4.5-18.383-5.02-18.272-4.77,1.021-9.527,2.094-14.282,3.177a.634.634,0,0,0-.361-.492,1.691,1.691,0,0,0-1.079,0c-.058-.2-.117-.406-.177-.6a43.617,43.617,0,0,0-1.169-4.231c-.057-.1-4.847.775-6.9,1.193a63.768,63.768,0,0,0-6.979,1.77c-.249.262.426,3.712.845,5.131a1.16,1.16,0,0,0-.814.766c-1.677.433-3.348,1-5,1.468-3.778,1.078-6.872,1.9-10.7,3.141-.192.063,2.511,11.327,3.544,16.948.528,2.873,1.024,5.753,1.607,8.616a42.545,42.545,0,0,0,2.151,8.25c.167.389.684.084.63-.266-.44-2.873-1.342-5.713-1.917-8.568s-1.071-5.731-1.6-8.6a134.99,134.99,0,0,0-3.6-15.762c1.593-.476,18.169-4.795,22.163-5.68,7.959-1.765,15.346-3.514,23.332-5.152,1.349,5.66,2.971,11.131,4.324,16.723.695,2.873,1.353,5.755,1.9,8.66.563,3,.839,6.032,1.306,9.042-3.588.486-7.144,1.454-10.679,2.212-4.032.866-8.067,1.72-12.092,2.623-7.81,1.754-15.56,3.682-23.469,4.961-.181.029-.139.332.043.32,7.8-.505,15.416-2.464,23-4.264,3.9-.926,7.814-1.784,11.727-2.649,3.852-.851,12.272-2.5,12.273-2.831.025-5.8-1.631-12.048-2.992-17.643M525.3,532.12c2.058-.357,4.311-1,6.382-1.349a9.822,9.822,0,0,0,.2.989c-2.015.363-4.687.9-6.791,1.373-2,.452-4.1.953-6.127,1.444-.067-.345-.126-.626-.243-1.1,2.2-.342,4.38-.973,6.577-1.354m-.478,5.492q-1.888.429-3.778.85a.913.913,0,0,0-1.093-.661c-.246-.9-.466-1.8-.7-2.7a54.386,54.386,0,0,0,6.033-1.259,61.05,61.05,0,0,0,6.353-1.492,15.806,15.806,0,0,0,.759,2.867,1.02,1.02,0,0,0-.673.825q-3.452.788-6.906,1.574" transform="translate(-333.279 -351.607)" fill="#0278a5"/>
    <path id="Path_107566" data-name="Path 107566" d="M568.671,590.018a13.313,13.313,0,0,0,3.266-14.524c-2.29-5.543-9.639-7.49-14.655-5.783a16.015,16.015,0,0,0-4.03,2.15,9.722,9.722,0,0,0-3.917,5c-1.44,4.974.912,11,5.077,13.954a11.335,11.335,0,0,0,14.259-.8m-18.952-10.884c.221-4.285,3.889-7.392,7.761-8.764l.1-.026c4.358-.984,9.677-.434,12.611,3.936,2.676,3.986,2.173,9.668-.6,13.466A10.48,10.48,0,0,1,556.514,591a12.68,12.68,0,0,1-6.8-11.87" transform="translate(-364.135 -377.537)" fill="#0278a5"/>
    <path id="Path_107567" data-name="Path 107567" d="M572.434,595.782l3.261-.7c-.357-1.5-.762-3.256-1.118-4.752,1.419-.307,2.59-.561,3.911-.863-.379-1.209-.8-3.117-.824-3.221-1.123.236-2.377.537-3.681.824-.332-1.3-.92-4.409-.92-4.409-1.341.239-3.608.8-3.681.824,0,0,.7,2.853.978,4.275,0,0-2.743.6-3.981,1,0,0,.843,3.221.987,3.348,0,0,2.658-.751,3.938-.972,0,0,.71,3.142,1.131,4.649" transform="translate(-375.724 -386.524)" fill="#0278a5"/>
    <path id="Path_107568" data-name="Path 107568" d="M326.3,52.322c-2.035-2.864-4.892-5.272-8.4-5.87a22.7,22.7,0,0,0-9.1.506,12.573,12.573,0,0,0-4.252,2.08c-4.058,2.991-7.257,9.633-6.71,15.166a16.664,16.664,0,0,0,11.92,14.46,16.119,16.119,0,0,0,13.08-1.988.3.3,0,0,0,.282-.191,15.644,15.644,0,0,0,4.105-4.107c4.149-6.079,3.229-14.207-.926-20.057m2.272,14.86a44.506,44.506,0,0,1-7.4,1.437,11.038,11.038,0,0,1,2.966-5.743c1.464-1.657,3.537-4.1,3.377-6.458a17.1,17.1,0,0,1,1.054,10.764m-4.407-15.935a17.553,17.553,0,0,1,2.314,3.119.143.143,0,0,0-.036.144c1.74,5.211-4.281,7.837-5.738,12.241a10.449,10.449,0,0,0-.426,1.937,24.784,24.784,0,0,1-3.475-.013,29.291,29.291,0,0,0,1.985-5.974c1.032-4.933.821-11.111-2.123-15.44a12.6,12.6,0,0,1,7.5,3.985m-8.748-4.1c.221.009.441.024.659.044a24.9,24.9,0,0,1,2.333,8.039,24.548,24.548,0,0,1-.813,8.436,31.966,31.966,0,0,1-1.791,4.91,19.727,19.727,0,0,1-3.648-.8,6.619,6.619,0,0,0-.131-3.182c-.858-3.026-3.272-5.193-4.832-7.832-1.846-3.125-1.468-5.912.592-8.346a24.53,24.53,0,0,1,7.629-1.265m-9.469,1.77.5-.134a7.014,7.014,0,0,0-1.231,2.791c-.5,2.513.613,4.834,2,6.858,1.788,2.609,4.705,5.6,4.059,9.032-.4-.152-.8-.318-1.2-.5a18.777,18.777,0,0,1-9.892-10.92,21.055,21.055,0,0,1,5.769-7.125m-6.834,17.349a14.976,14.976,0,0,1,.709-9.414c1.2,4.745,5.252,8.748,9.53,10.8.542.26,1.1.488,1.669.7a6.918,6.918,0,0,1-3.348,3.476c-1.428.75-3.206.8-4.52,1.678a.206.206,0,0,0-.044.054,16.028,16.028,0,0,1-4-7.3m4.36,7.669c2.191.268,5.094-1.22,6.636-2.642a6.787,6.787,0,0,0,1.788-2.624,23.134,23.134,0,0,0,3.464.841q-.55,1.117-1.173,2.2c-1.175,2.035-3.012,3.929-3.947,6.087a15.319,15.319,0,0,1-6.767-3.86m8.948,4.274a15.168,15.168,0,0,1-1.522-.254c2.052-1.686,3.526-4.648,4.724-6.88.252-.469.492-.947.725-1.427a25.836,25.836,0,0,0,3.837.177,8.818,8.818,0,0,0,1.871,6.217,15,15,0,0,1-9.635,2.168m10.431-2.7c-.884-1.893-1.813-3.431-1.774-5.72v-.013a25.281,25.281,0,0,0,7.168-1.488,13.524,13.524,0,0,1-.583,1.452,14.937,14.937,0,0,1-4.812,5.769" transform="translate(-197.537 -30.644)" fill="#0278a5"/>
    <path id="Path_107569" data-name="Path 107569" d="M65.737,565.423c-2.78-4.079-9.512-12.335-9.611-12.275-2.651-4.176-2.45-8.991-2.274-13.778.185-5.023.291-9.942-1.395-14.752-2.8-8-9.428-14.06-18.123-14.6-7.22-.451-13.642,4.781-15.6,11.594-2.243,7.814,1.281,16.172,7.177,21.391a31.391,31.391,0,0,0,11.216,6.224c5.143,1.653,11.282,2.005,14.535,6.85a.2.2,0,0,0-.031.2A42.155,42.155,0,0,0,55.52,562.5q2.226,3.4,4.453,6.792c1.369,2.091,4.424,8.528,7.913,5.92,3.428-2.563-.562-7.465-2.149-9.792m-21.567-14.9c-3.949-1.236-7.94-2-11.665-3.889-7.438-3.768-13.353-10.8-13.638-19.422-.259-7.837,5.457-15.812,13.67-16.3,9.525-.569,16.946,6.672,19.486,15.313,1.558,5.3.886,10.688.866,16.114-.014,4.018.147,7.945,2.64,11.249-.418.347-.81.745-1.231,1.062-.7.521-1.442.968-2.177,1.432-1.7-2.941-4.791-4.568-7.951-5.557m22.277,24.5c-2.51-.086-3.781-2.961-4.956-4.761q-1.555-2.383-3.114-4.765c-1.927-2.946-3.679-6.423-6.029-9.077a10.745,10.745,0,0,0,2.3-1.258A9.721,9.721,0,0,0,56.1,554c.126.16.254.318.381.476a2.96,2.96,0,0,1-.5.687c-.224.223-.529.4-.672.685a.158.158,0,0,0,.152.225,1.3,1.3,0,0,0,.917-.627,3.348,3.348,0,0,0,.376-.63q.45.559.905,1.114c-.195.355-.322.745-.539,1.093a4.141,4.141,0,0,0-.653,1.028c-.03.115.092.187.189.163.443-.109.723-.588.935-.96a3.44,3.44,0,0,0,.384-.939l.777.943a.249.249,0,0,0-.066.178,1.784,1.784,0,0,1-.14.677,1.239,1.239,0,0,0-.166.578.132.132,0,0,0,.139.12c.47-.027.646-.57.665-1.03l.553.672a8.83,8.83,0,0,1-.716,1.862c-.035.086.046.219.15.168a1.964,1.964,0,0,0,1-1.5q.4.491.795.986a.2.2,0,0,0-.029.132,2.4,2.4,0,0,1-.094,1.019c-.1.292-.284.548-.362.844a.135.135,0,0,0,.142.16c.647-.118.907-.841.876-1.482q.426.544.844,1.1c-.168.261-.3.547-.487.8a2.072,2.072,0,0,0-.525.866.15.15,0,0,0,.156.176,1.22,1.22,0,0,0,.906-.688,3.376,3.376,0,0,0,.329-.64c.13.176.262.349.39.527.168.233.329.471.5.705a2.279,2.279,0,0,1-.395.925c-.2.275-.465.507-.652.79-.068.1.046.22.148.218.725-.016,1.136-.7,1.288-1.38.322.46.645.92.96,1.385a2.715,2.715,0,0,1-.277.692c-.205.351-.588.6-.742.977a.158.158,0,0,0,.152.225c.5,0,.877-.556,1.06-.971a2.421,2.421,0,0,0,.139-.421q.315.47.625.942a.193.193,0,0,0-.029.022,3.724,3.724,0,0,0-1.189,1.832c-.01.1.08.212.189.163a3.4,3.4,0,0,0,1.3-1.6c.039.061.081.12.121.181.168.261.341.522.513.786a5.831,5.831,0,0,1-.689,1.552.154.154,0,0,0,.187.21,1.291,1.291,0,0,0,.877-1.172,11.778,11.778,0,0,1,.734,1.345,7.7,7.7,0,0,1-.759,1.774.136.136,0,0,0,.166.186,1.408,1.408,0,0,0,.937-.962c.34,1.481.286,3.912-1.832,3.84" transform="translate(-11.978 -338.315)" fill="#0278a5"/>
    <path id="Path_107570" data-name="Path 107570" d="M104.178,617.572c-.26-1.144-.172-2.373-.533-3.476a.145.145,0,0,0-.058-.076c.013-.03.031-.061.042-.091a.026.026,0,0,0-.038-.033c-.945.509-1.664,1.345-2.633,1.835-.811.411-1.785.461-2.55.925a.112.112,0,0,0-.03.168.089.089,0,0,0,.015.125,22.612,22.612,0,0,0,3.246,1.775,20.066,20.066,0,0,1,3.55,2.676c.009.014.019.031.028.045a.131.131,0,0,0,.23-.117,34.519,34.519,0,0,1-1.27-3.755m-2.139.939a13.314,13.314,0,0,0-2.7-1.527,6,6,0,0,0,3.891-2.353c-.284,1.954.672,4.577,1.671,6.3a16.109,16.109,0,0,0-2.864-2.418" transform="translate(-65.246 -407.243)" fill="#0278a5"/>
    <path id="Path_107571" data-name="Path 107571" d="M58.936,538.6a20.594,20.594,0,0,0-11.8-13.86c-5-2.1-13.4-1.122-14.868,5.129a9.508,9.508,0,0,0-.223,1.105,21.493,21.493,0,0,0,4.946,17.665c3.9,4.511,10.524,7.123,16.136,4.119,4.987-2.669,6.985-8.84,5.81-14.159m-1.379,7.691a.128.128,0,0,0-.125-.014c-.741.314-1.481.637-2.221.958q-.714-1.2-1.446-2.4,1.661-.834,3.293-1.717a9.278,9.278,0,0,0,1,1.362s.009,0,.013.007a12.71,12.71,0,0,1-.515,1.8M42.042,535.005q.88,1.427,1.746,2.856-1.394.777-2.787,1.561-.864-1.47-1.722-2.948c.911-.508,1.831-1,2.763-1.468m-3.145.815q-.731-1.249-1.472-2.491,1.385-.672,2.767-1.345.741,1.225,1.494,2.444c-.9.443-1.844.9-2.79,1.392m5.465,1.718q-.829-1.421-1.654-2.854c.293-.142.584-.287.879-.423.657-.3,1.3-.623,1.929-.951q.85,1.3,1.682,2.6c-.943.553-1.887,1.1-2.836,1.63m3.2-1.055c.093.146.188.293.279.44.406.647.807,1.3,1.209,1.948-.79.4-1.576.8-2.35,1.21l-.628.335c-.275-.452-.548-.9-.817-1.356-.2-.335-.4-.674-.595-1.012.955-.523,1.925-1.043,2.9-1.566m-3.475,1.88c.149.249.3.5.448.749q.475.805.941,1.623-1.4.744-2.794,1.494c-.258-.419-.515-.839-.766-1.259q-.309-.516-.613-1.035c.932-.526,1.86-1.056,2.784-1.57m1.7,2.914q.659,1.163,1.313,2.336-1.386.619-2.754,1.278-.662-1.055-1.317-2.109,1.38-.75,2.758-1.505m.611-.334.469-.256q1.236-.678,2.471-1.359.787,1.275,1.573,2.551-1.53.717-3.076,1.4-.721-1.172-1.437-2.34m1.991,2.732q1.435-.628,2.824-1.3.7,1.141,1.409,2.279-1.528.745-3.059,1.486-.7-1.18-1.418-2.351c.082-.036.163-.074.245-.11M52,541.982q1.724-.868,3.385-1.849c.476.8.908,1.672,1.385,2.5l-3.35,1.632q-.7-1.144-1.42-2.282m-.3-.475q-.814-1.293-1.634-2.583,1.648-.912,3.285-1.846c.6.861,1.2,1.729,1.764,2.614.015.023.029.048.044.071q-1.709.912-3.458,1.744m-1.9-3.009-1.289-2.03c-.077-.121-.153-.244-.229-.366,1.05-.565,2.1-1.141,3.126-1.74.175.238.351.475.523.713q.617.855,1.223,1.717c-1.11.582-2.233,1.144-3.353,1.706m-1.9-3q-.806-1.29-1.612-2.595c.956-.516,1.894-1.054,2.825-1.608.61.812,1.223,1.622,1.825,2.432-1.017.583-2.028,1.178-3.038,1.772m-1.978-3.184q-.765-1.234-1.549-2.459c.889-.467,1.786-.926,2.692-1.35.557.783,1.128,1.557,1.7,2.328q-1.416.757-2.847,1.48m-.793.4q-1.375.692-2.762,1.378-.717-1.235-1.45-2.461l.274-.134c.782-.38,1.57-.793,2.365-1.212q.78,1.219,1.573,2.428m-4.2-1.95-.41.2q-.682-1.126-1.39-2.23c.229-.121.457-.241.686-.359.642-.329,1.293-.655,1.944-.988.448.751.91,1.5,1.379,2.238-.743.392-1.479.778-2.208,1.137m-1.133.559q-1.379.68-2.756,1.366-.649-1.072-1.317-2.13c.926-.485,1.844-.989,2.76-1.48q.643,1.128,1.312,2.244m-3.327,1.652c-.392.2-.786.391-1.177.589-.275.139-.565.274-.857.411q-.538-1.127-1.1-2.243c.635-.285,1.264-.593,1.889-.914q.609,1.084,1.242,2.157m-1.08,1.338c.486-.231.969-.468,1.454-.7q.745,1.253,1.505,2.5c-.777.414-1.546.851-2.282,1.322-.442-.932-.878-1.866-1.319-2.8.217-.111.431-.22.641-.32m2.189,3.132c.389-.227.781-.451,1.173-.673q.89,1.459,1.775,2.918-1.308.735-2.622,1.461c-.515-.99-1.01-1.99-1.491-3,.388-.241.776-.481,1.165-.709m3.255,2.755c.153.254.307.508.458.762q.452.761.9,1.534c-.7.377-1.4.753-2.1,1.134-.2.112-.412.222-.621.331-.4-.674-.789-1.351-1.157-2.038-.049-.091-.095-.183-.143-.274.9-.466,1.786-.955,2.668-1.45m-.69,4.143q1.186-.636,2.368-1.281.606,1.062,1.211,2.133c-.478.232-.958.461-1.433.7-.417.208-.847.411-1.281.619q-.61-.989-1.208-1.982l.343-.187m2.942,1.793c.305-.151.615-.293.921-.44q.689,1.215,1.395,2.42c-.886.413-1.771.834-2.641,1.277-.463-.781-.936-1.558-1.413-2.334.587-.321,1.167-.642,1.738-.923m1.57-.75q1.358-.645,2.731-1.259.675,1.206,1.362,2.405c-.253.122-.5.246-.758.368-.614.3-1.236.586-1.86.876q-.728-1.2-1.475-2.39m3.767,2.066.667-.324q.653,1.125,1.334,2.228-1.336.608-2.664,1.229-.6-1.084-1.234-2.154c.649-.344,1.283-.68,1.9-.979m1.489-.724q1.533-.744,3.066-1.5.728,1.172,1.467,2.336-1.626.71-3.246,1.442-.625-1.147-1.287-2.278m8.287-2.888a6.956,6.956,0,0,0-.429-1.111c.191-.106.38-.214.569-.322a13.763,13.763,0,0,1-.141,1.433m.164-1.984-.833.406c-.4-.74-.883-1.45-1.306-2.132-.075-.121-.153-.238-.229-.358q1.007-.615,1.993-1.287a14.213,14.213,0,0,1,.375,3.372M57.6,537.1c.125.361.23.729.324,1.1q-1.061.638-2.145,1.23c-.584-.914-1.192-1.812-1.813-2.7q1.4-.807,2.791-1.639A17.637,17.637,0,0,1,57.6,537.1m-.979-2.271c-.925.572-1.878,1.109-2.845,1.628q-.535-.76-1.077-1.513c-.227-.315-.451-.634-.677-.953,1-.6,1.972-1.223,2.905-1.888a19.581,19.581,0,0,1,1.693,2.726m-4.2-5.542a20.717,20.717,0,0,1,2.217,2.43c-1.029.523-2.048,1.076-3.059,1.647-.581-.829-1.161-1.666-1.746-2.5.858-.518,1.717-1.045,2.588-1.576m-.339-.3q-1.272.744-2.558,1.441c-.541-.77-1.088-1.536-1.647-2.291.694-.3,1.393-.573,2.1-.8a20.019,20.019,0,0,1,2.108,1.65m-6.413-3.8c.167.055.334.112.5.174a17.527,17.527,0,0,1,3.026,1.479c-.6.2-1.194.428-1.784.681q-.884-1.17-1.819-2.285l.077-.049m.95,2.686c-.9.415-1.79.871-2.671,1.332-.48-.737-.965-1.468-1.465-2.186.887-.463,1.765-.944,2.608-1.465q.729,1.177,1.528,2.32M44.7,524.91c.049.082.1.163.15.244a21.019,21.019,0,0,1-2.7,1.4q-.684-.966-1.4-1.9a11.234,11.234,0,0,1,3.95.254m-4.446-.183q.575,1.076,1.2,2.134c-.844.366-1.687.722-2.481,1.115-.083.041-.171.081-.255.122-.483-.737-.972-1.469-1.482-2.184a.2.2,0,0,0-.148-.09,9.986,9.986,0,0,1,3.169-1.1m-3.359,1.208a.22.22,0,0,0,0,.216c.387.754.794,1.5,1.209,2.242-.937.437-1.928.878-2.886,1.366-.253-.392-.507-.784-.765-1.172-.143-.214-.437,0-.322.221.21.4.426.789.642,1.183A15.764,15.764,0,0,0,33,531.074c-.107-.208-.216-.416-.326-.623a10.977,10.977,0,0,1,4.216-4.516m-4.36,5.333c.017.044.032.089.048.133l-.062.051c.005-.061.008-.122.013-.183m-.061.833c.111-.045.221-.094.332-.141q.469,1.166,1,2.316a9.853,9.853,0,0,0-1.335.76,26.581,26.581,0,0,1,0-2.934m.037,3.473a7.893,7.893,0,0,0,1.613-.625c.454.951.928,1.895,1.414,2.83a16.1,16.1,0,0,0-2.362,1.917,24.193,24.193,0,0,1-.665-4.122m.713,4.323a18.408,18.408,0,0,0,2.676-1.425c.518.984,1.04,1.96,1.554,2.927-1.035.57-2.073,1.132-3.118,1.679A21.805,21.805,0,0,1,33.22,539.9m1.236,3.472c1.1-.441,2.183-.946,3.249-1.487.408.772.817,1.56,1.231,2.355a18.768,18.768,0,0,0-2.99,1.829,20.126,20.126,0,0,1-1.491-2.7m1.681,2.979a21.737,21.737,0,0,0,3.112-1.515q.528,1.006,1.078,2.011a13.17,13.17,0,0,0-2.557,1.581,19.263,19.263,0,0,1-1.633-2.076m1.957,2.442c-.051-.054-.1-.111-.147-.165a15.76,15.76,0,0,0,2.7-1.19q.664,1.189,1.38,2.335-.853.455-1.671.958a14.861,14.861,0,0,1-2.264-1.937m2.591,2.16a13.491,13.491,0,0,0,1.738-.547c.472.728.972,1.425,1.489,2.1a.124.124,0,0,0,.023.063,14.761,14.761,0,0,1-3.25-1.615m2.488-.855c.89-.385,1.773-.834,2.635-1.288q.631,1.055,1.293,2.083-1.392.655-2.772,1.323-.552-1.069-1.156-2.118m10.677,1.263a10.258,10.258,0,0,1-9.226,1.427c-.055-.111-.115-.221-.171-.332q1.467-.537,2.93-1.125c.381.582.769,1.157,1.171,1.719.14.195.5.034.391-.2-.293-.6-.6-1.192-.922-1.782q1.374-.565,2.735-1.171c.461.733.929,1.46,1.419,2.169.165.238.6.04.468-.239-.362-.762-.751-1.515-1.15-2.264q1.634-.745,3.235-1.545c.316.5.629,1,.95,1.494a.369.369,0,0,0,.037.038,10.61,10.61,0,0,1-1.865,1.811m1.605-3.711q1-.51,1.982-1.037a11.518,11.518,0,0,1-1.244,2.3q-.366-.634-.738-1.265" transform="translate(-21.041 -347.436)" fill="#0278a5"/>
    <path id="Path_107572" data-name="Path 107572" d="M135.655,494.358c-1.472-2.972-4.931-4.993-8.244-4.068a.252.252,0,0,0-.192.309c-2.72,1.212-4.779,3.473-4.8,6.6a7.191,7.191,0,0,0,4.181,6.541,7.574,7.574,0,0,0,8.418-1.774,6.993,6.993,0,0,0,.641-7.607m-.309,1.31a6.492,6.492,0,0,1,.3,3.091c-.76-.831-1.868-1.356-2.505-2.4a4.349,4.349,0,0,1-.522-4.2,6.473,6.473,0,0,1,2.724,3.507m-11.954,3.77a6.234,6.234,0,0,1,.18-4.862c2.128.3,3.6.912,4.244,3.225a9.587,9.587,0,0,1-.113,5.6,6.274,6.274,0,0,1-4.31-3.96m8.32,3.858a7.194,7.194,0,0,1-3.393.239c2.137-2.921-.24-10.656-4.53-9.39a8.315,8.315,0,0,1,3.567-3.331.306.306,0,0,0,.179.065,10.454,10.454,0,0,1,4.528.968c-.735.663-.534,2.527-.319,3.279.442,1.551,1.948,4.052,3.74,4.383a5.549,5.549,0,0,1-3.771,3.788" transform="translate(-81.207 -325.098)" fill="#0278a5"/>
  </g>
    </SvgIcon>
  );
}

export function ExerciseImageIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 260.349,
    height: 164.57,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 260.349 164.57"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 102580" transform="translate(-57 -47)">
        <circle
          data-name="Ellipse 39441"
          cx={18}
          cy={18}
          r={18}
          transform="translate(273 126)"
          fill="rgba(90,197,179,0.1)"
        />
        <g data-name="Verify OTP" transform="translate(57.138 44)">
          <path
            data-name="Path 4696"
            d="M240.637 4.274a2.547 2.547 0 014.411 0l18.014 31.2a2.547 2.547 0 01-2.206 3.821h-36.028a2.547 2.547 0 01-2.206-3.821z"
            transform="translate(-33.562)"
            fill="rgba(90,197,179,0.1)"
          />
          <path
            data-name="Path 4697"
            d="M177.291 157.274a2.547 2.547 0 014.411 0l14.338 24.834a2.547 2.547 0 01-2.207 3.821h-28.674a2.547 2.547 0 01-2.207-3.821z"
            transform="translate(-24.552 -23.101)"
            fill="rgba(90,197,179,0.1)"
          />
          <ellipse
            data-name="Ellipse 39444"
            cx={25.5}
            cy={25}
            rx={25.5}
            ry={25}
            transform="translate(-.138 102.411)"
            fill="rgba(90,197,179,0.1)"
          />
          <circle
            data-name="Ellipse 39445"
            cx={16}
            cy={16}
            r={16}
            transform="translate(35.862 12.411)"
            fill="rgba(90,197,179,0.1)"
          />
          <g
            data-name="Group 5436"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 4735"
              d="M53.008 121.84H0V25.833A25.833 25.833 0 0125.833 0a27.162 27.162 0 0127.163 27.163v94.677z"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4736"
              d="M47.014 121.555V27.376a20.52 20.52 0 00-20.52-20.52h0a20.52 20.52 0 00-20.509 20.52v94.195"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4737"
              d="M26.505 0v121.7"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4738"
              d="M52.722 23.443H.354"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4739"
              d="M52.722 39.973H.354"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4740"
              d="M52.722 56.501H.354"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4741"
              d="M52.722 73.035H.354"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4742"
              d="M52.722 89.565H.354"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4743"
              d="M52.722 106.095H.354"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4744"
              d="M45.721 8.27l-4.747 4.326"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
            <path
              data-name="Path 4745"
              d="M7.484 8.27l4.75 4.326"
              opacity={0.3}
              transform="translate(198.087 7.245)"
            />
          </g>
          <g
            data-name="Group 5437"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 4746"
              d="M53.008 121.84H0V25.833A25.833 25.833 0 0125.833 0 27.163 27.163 0 0153 27.163v94.677z"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4747"
              d="M47.022 121.555V27.376A20.52 20.52 0 0026.502 6.84h0A20.52 20.52 0 005.966 27.376v94.195"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4748"
              d="M26.502 0v121.7"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4749"
              d="M52.723 23.443H.351"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4750"
              d="M52.723 39.973H.351"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4751"
              d="M52.723 56.501H.351"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4752"
              d="M52.723 73.035H.351"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4753"
              d="M52.723 89.564H.351"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4754"
              d="M52.723 106.094H.351"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4755"
              d="M45.721 8.27l-4.75 4.326"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
            <path
              data-name="Path 4756"
              d="M7.485 8.27l4.746 4.326"
              opacity={0.3}
              transform="translate(3.395 7.245)"
            />
          </g>
          <path
            data-name="Path 4757"
            d="M200.816 167.07h55.171"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4758"
            d="M8.489 167.07h186.809"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4759"
            d="M114.483 54.488a2.27 2.27 0 00-.318 2.911c.5.682 1.728 1 1.774 1.228.091.318.273 1 .409 1.364.227.546-1.138 1.682-1.138 1.682a31.347 31.347 0 001.228 3.183c1.092 2.182 3.592 2.911 5.82 3.229a6.68 6.68 0 002.5-.228 6.144 6.144 0 002.183-1.228 7.745 7.745 0 002.047-2.365 10.852 10.852 0 00.863-2.865l-.909-.727a15.236 15.236 0 01.863-2.228c.137-.182.592-.182.773-.364a3.2 3.2 0 001.047-2.047c.227-.909-.592-1.092-.909-1.637-.409-.637-.183-1.819-.409-2.546a9.36 9.36 0 00-5.275-6.275 5.22 5.22 0 00-2.955-.637c-3.229.546-4.957 3.455-6.184 6.184-.454 1.046-.363 2.637-1.409 3.365z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4760"
            d="M98.661 106.46l-.682 5.411s.183 2.456.409 5c.273 3.229.046 7.822.318 11.05.363 4.638 1.273 7.959 2.046 12.505a37.563 37.563 0 01.455 5.685c.046 1.546.046 2.955.046 2.955s1.09.046 1.273.046a11.345 11.345 0 012.774.183c.955.227 1.91.546 2.82.773.137.046.728-.728.728-.728a24.513 24.513 0 00.091-3 45.641 45.641 0 01-.091-6.138c.045-1.364.182-2.365.318-3.683.318-3.729 1.182-6.138 1.728-9.822.137-.864.273-3.138.363-4.229.137-1.092 0-4.321.046-5.185s.091-1.955.091-1.955l1.728-1.182a7.892 7.892 0 00-1.092-3.137 20.131 20.131 0 00-5.774-5.139 7.1 7.1 0 00-4.275-1.092 6.005 6.005 0 00-1.819.5c-.409.363-1.5 1.183-1.5 1.183z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4761"
            d="M147.315 105.916s.273 3.047.409 3.956a24.5 24.5 0 01.137 6.32c-.091 1.638-.137 4.092-.137 6.138s-.182 4.138-.273 5.729a48.626 48.626 0 01-1.136 7.275 56.1 56.1 0 00-.864 6.093c-.182 2.183-.454 8.367-.454 8.367s-5.5.183-6.412.455c-.137.046-1 .318-1 .318s.045-3.41.045-4.319c.046-2.228-.273-6-.591-9.185-.409-3.729-1.364-8.048-1.956-11.732a44.663 44.663 0 01-.318-4.729c0-1.319.045-4.73.045-4.73l-2.136-1.364a8.345 8.345 0 011.273-3.729 16.679 16.679 0 014.911-4.776c1.136-.727 4.229-2 6.729-1.136a14.608 14.608 0 011.728 1.046z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4762"
            d="M134.7 61.365s-.182-.955-.228-1.182a14.582 14.582 0 01-.272-3.729 11.649 11.649 0 01.818-4.5 7.579 7.579 0 013.138-3.5 11.5 11.5 0 011.273-.727 6.858 6.858 0 013.046-.318c1.364.181 2.82.227 4.184.5 3.41.683 5.638 4.547 5.32 7.821-.092.773-.046 1.591-.137 2.365-.046.591-.546 2.456-.638 3.046 0 0 .092-.091-.318 0-.909.228-1.955-1.773-2-2-.137-.409-.818-2.41-.818-2.41s-1.455-.955-2.41-1.5a6.148 6.148 0 00-5.138-.046 3.944 3.944 0 00-1.91 2.637A10.539 10.539 0 01136.742 60c-.363.409-.546.909-1.046 1.137a7.456 7.456 0 01-1 .228z"
            transform="translate(-20.258 -6.697)"
            fill="#263238"
          />
          <path
            data-name="Path 4763"
            d="M12.162 165.568s5.093-.137 13-.409c6.866-.227 15.87-.637 26.6-.954 13.733-.409 29.966-.91 46.335-1.138 9.686-.137 19.6-.183 29.057-.183 7.594 0 15.278.092 22.827.183 3.592.046 7.184.137 10.732.182 5.5.137 10.913.272 16.187.409 7.458.182 14.6.408 21.145.637 10.55.318 19.735.454 26.465.682 7.821.272 12.824.454 12.824.454a2.618 2.618 0 00.773-2.365 1.85 1.85 0 00-.682-1.228s-4.865-.091-12.868-.363c-6.775-.227-16.1-.409-26.646-.682-10.913-.273-23.554-.682-36.514-.863-3.821-.046-7.776-.183-11.641-.228-7.775-.091-15.688-.137-23.554-.137-8.957 0-18.461.046-27.555.183-29.42.409-57.613 1.5-73.528 2.091-8.185.318-13.459.364-13.459.364a2.305 2.305 0 00-.591 1.5c.137 1.819 1.092 1.864 1.092 1.864z"
            transform="translate(-1.672 -23.639)"
            fill="#acb9d3"
          />
          <path
            data-name="Path 4764"
            d="M33.328 134.907a17.754 17.754 0 014.229-.546c2.456-.183 5.457-.183 8.094-.183 3.82 0 6.912.046 6.912.046s1.319.5 2.5 5.366a92.906 92.906 0 011.773 17.142l-2.728.268a11.607 11.607 0 00-.137 1.683 12.68 12.68 0 00.137 1.728h2.774s-.137 3.32-.364 6.957c-.181 3.047-.455 6.321-.773 8.049-1.137 6.183-2.728 7.958-2.728 7.958a50.784 50.784 0 01-6.957.5c-1.864-.045-4.865.092-7.639 0-2.137-.045-4.319-.228-5.366-1.136-1.137-.955-2.637-3.41-3.638-8.23a77.629 77.629 0 01-1.273-8.5c-.272-3.275-.364-5.775-.364-7.184a83.591 83.591 0 01.637-10.731c.773-5.912 2.592-12.187 4.911-13.187z"
            transform="translate(-4.195 -19.806)"
            fill="#838fa5"
          />
          <path
            data-name="Path 4765"
            d="M251.044 134.808l-5-.5-5.412-.137-7.958-.046a1.7 1.7 0 00-.727.318c-.592.455-1.364 1.592-2.092 4.638a100.486 100.486 0 00-1.773 17.825l2.683.046.091 3.592-2.82-.046s.046 3 .273 6.184a90.55 90.55 0 001.046 9.14 27.022 27.022 0 001.638 6c.636 1.455 1.319 1.682 1.319 1.682a55 55 0 006.775.409c2.228-.046 6.958-.046 9.821-.273a9.554 9.554 0 002.32-.409s2.364-1.137 3.729-7a77.057 77.057 0 001.5-8.049 106.234 106.234 0 00.543-10.639 67.028 67.028 0 00-2.046-16.642 16.433 16.433 0 00-2-4.456 4.731 4.731 0 00-1.91-1.637z"
            transform="translate(-34.431 -19.798)"
            fill="#8f9aae"
          />
          <path
            data-name="Path 4766"
            d="M104.253 66.447a19.944 19.944 0 00-3.5 2.546 16.95 16.95 0 00-2.91 4.5 73.027 73.027 0 00-2.82 7.821c-1 2.865-2.137 5.774-2.91 8.685a63.746 63.746 0 00-.863 4.047c-.318 1.955-.455 4.046-.683 5.911-.318 3.092-.728 5.912-1.228 9.095-.182 1.046-.182 2.5-.318 4.229-.091 1.774.273 5.912.273 9.14 0 1.273-.137 2.82-.227 4.092a10.928 10.928 0 01-.909 3.729 15.654 15.654 0 00-1.55 6.049c0 1.092-.273 2.82.318 3.684.227.318.409.273.909.409.363.091 1.364-.409 1.364-.409a4.666 4.666 0 001 .5c.409.091 1.138-.409 1.138-.409s.863.773 1.228.773a2.274 2.274 0 001.273-.681s1.046.954 1.728.545a2.485 2.485 0 00.863-1.318c.092-.818.592-3.364.592-3.364l2.319-.092a19.334 19.334 0 00-.546-1.955c-.592-1.136-2-2.319-2.32-3.592a22.937 22.937 0 01-.318-6.866c.045-1.046 1.183-6.912 1.592-9.095.454-2.41.5-5 .909-7.458a21.682 21.682 0 01.773-3.729c.455-1.319 1.728-4.365 2.32-5.866.637-1.636.545-2.637 1.909-6.412s2.456-3.637 3.138-8a31.178 31.178 0 00.272-6.821 46.64 46.64 0 00-1.273-6.775 296.468 296.468 0 00-1.546-2.911z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4767"
            d="M143.087 66.991s1.319.955 2 1.591a18.662 18.662 0 014.184 7.139c.727 1.91 1.319 3.82 1.909 5.593a79.934 79.934 0 013.592 12.5c.364 2.182.592 4.729.864 6.957.318 2.91.636 5.457 1.136 8.322a31.825 31.825 0 01.228 4.275c0 1.229-.273 5.547-.273 8.776a21.731 21.731 0 00.091 3.865 24.151 24.151 0 001.046 3.956 11.809 11.809 0 011.364 5.274 19.374 19.374 0 01-.137 3.183c-.091.773-.227 1.41-1.046 1.637a3.919 3.919 0 01-1.364-.273 2.75 2.75 0 01-1 .592 3.224 3.224 0 01-1.319-.318 2.122 2.122 0 01-1.273.409 2.024 2.024 0 01-1.182-.773s-.955.636-1.638.228a1.64 1.64 0 01-.636-1.227 92.439 92.439 0 00-.363-2.592l-2.456-.183s.409-2 .5-2.228c.592-1.136 1.864-1.682 2.183-2.955a18.516 18.516 0 00.409-4.866 34.43 34.43 0 00-.455-5.457c-.409-2-.863-4.046-1.227-6-.455-2.546-.546-5.274-.955-7.73a26.1 26.1 0 00-.955-4.273c-.409-1.274-1.592-3.138-2.956-6.958-.818-2.365-1.546-5.184-2.456-7.867a33.137 33.137 0 01-1.727-4.911 30.132 30.132 0 01-.046-6.73 21.514 21.514 0 011.728-5.957 19.177 19.177 0 012.228-3z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 4768"
            d="M161.862 176.512l-.182 2.955a3.66 3.66 0 01.091 1.728c-.227 1.227-1.274 2.91-.909 4.183.409 1.364 2.046 1 2.683 2.091.227.364.045 2.683.545 3.183a6.537 6.537 0 003.775 1.318c2.365.228 5.547.455 7.639-1.137.727-.546.636-1.273.318-2.137-.454-1.136-1.728-2.183-2.5-3.092a13.3 13.3 0 01-2.41-4.092c-.137-.409-.409-.727-.546-1.136a8.255 8.255 0 00-.955-2.092l-.045-2.591a11.992 11.992 0 01-1.364-.137 8.869 8.869 0 00-4.092.227c-.592.273-2.047.728-2.047.728z"
            transform="translate(-24.277 -26.034)"
            fill="#fff"
          />
          <path
            data-name="Path 4769"
            d="M125.728 178.973l-.092-3.455a13.421 13.421 0 00-1.955-.773 16.141 16.141 0 00-3.32-.183c-.455 0-2.32.273-2.32.273l-.041 2.547s.181.137-.228.818c-.909 1.546-1.227 3.365-2.365 4.82-1.092 1.409-3.366 4.592-3.366 4.592s-.681.363-.773.773c-.363 1.728 1 2.137 2.32 2.729a8.689 8.689 0 002.365.454 11.576 11.576 0 003.546-.137 8.018 8.018 0 003.046-1c.637-.546.91-.682 1.047-1.455a9.62 9.62 0 01.182-2c.273-.592 1.455-1.047 2-1.364a1.548 1.548 0 00.773-1.046 2.711 2.711 0 00-.273-1.728s-.318-2.093-.455-2.637a8.919 8.919 0 01-.091-1.228z"
            transform="translate(-16.791 -25.903)"
            fill="#fff"
          />
          <path
            data-name="Path 4770"
            d="M231.727 141.6c.5-1.319 1.092-.683 1.5.591a18.793 18.793 0 01.728 3.046s1.319 12.1.728 20.325c-.228 2.729-.318 5.639-.546 7.959-.318 3.137-.863 5.365-1.409 5.684-.273.183-.818.592-1.182-.773a31.258 31.258 0 01-1-5.5 123.253 123.253 0 01-.636-12.549 115.589 115.589 0 01.636-12.959 26.8 26.8 0 011.182-5.82z"
            transform="translate(-34.714 -20.817)"
            fill="#566072"
          />
          <path
            data-name="Path 4771"
            d="M55.957 141.6c.364-.954.909-.909 1.273-.137a27.794 27.794 0 011.137 4.639s.272 1.864.409 4.092A127.3 127.3 0 0159 166.568c-.227 2.82-.364 5.866-.682 8.094-.409 2.774-.909 4.5-1.455 4.774-.272.183-1.046-.592-1.319-1.956a102.27 102.27 0 01-1.364-17.416c.046-9.458 1.182-16.961 1.773-18.461z"
            transform="translate(-8.181 -20.819)"
            fill="#566072"
          />
          <path
            data-name="Path 4772"
            d="M124.032 177.633a10.334 10.334 0 00-2.91-1.683 2.222 2.222 0 00-1.728.592 5.714 5.714 0 00-.955.863 6.108 6.108 0 00-1.092 1.456 27.919 27.919 0 01-1.909 4.274 16.559 16.559 0 01-2.047 2.365 4.192 4.192 0 00-1.364 2.365c-.091 1.136 1.728 2.183 2.637 2.32a10.033 10.033 0 007.048-.864 5.71 5.71 0 001.047-.773 3.145 3.145 0 00.727-1.455 4.135 4.135 0 01.864-2.047c.363-.454 1.773-1.046 1.864-1.682a17.092 17.092 0 00-.137-3.729c-.092-.546-.955-1.319-2.047-2z"
            transform="translate(-16.915 -26.11)"
            fill="#9aa2be"
          />
          <path
            data-name="Path 4773"
            d="M161.372 180.346a12.181 12.181 0 00-.092 3.638c.137.909 1.5 1.273 2.047 1.955.773.955.546 1.955 1.182 3a4 4 0 001.864 1.41 9.876 9.876 0 003.546.773 9.707 9.707 0 004.321-.637 2.291 2.291 0 001.319-1.547c.228-.818-.5-1.682-.773-2s-1.5-1.682-1.092-1.319-1.774-1.91-2-2.319c-.864-1.637-1.092-3.5-1.955-4.593-.546-.682-1.774-2.182-2.775-1.955a13.621 13.621 0 00-1.455.454 11.4 11.4 0 00-1.864 1.137c-.637.318-2.182 1.364-2.274 2z"
            transform="translate(-24.337 -26.231)"
            fill="#9aa2be"
          />
          <path
            data-name="Path 4774"
            d="M116.312 123l.272-2.183s1.819-2 2.5-2.774a43.169 43.169 0 003.32-4.366 9.038 9.038 0 01.955-1.138l34.376.728a47.439 47.439 0 014.5 4.865 24.519 24.519 0 012.637 4.411 4.964 4.964 0 00-4.456-1.41A12.862 12.862 0 00154.69 124a12.361 12.361 0 00-3.5 4.046 11.608 11.608 0 00-.909 2.911l2.183 1.864-.046 3.41a8.866 8.866 0 01-1.319-1.183 13.026 13.026 0 00-1-1.774 18.156 18.156 0 00-2.729-2.82c-1.864-1-4.729-3.91-6.821-3.592-2.545.364-6.32 2.774-8.094 4.957-2.319 2.91-3.364 4.275-3.364 4.275a18.491 18.491 0 01-.183-2.32 10.854 10.854 0 01.137-1.819l1.728-1.319a12.29 12.29 0 00-6.593-7.957 9.089 9.089 0 00-4.547-1.046 4.422 4.422 0 00-3.32 1.364z"
            transform="translate(-17.562 -16.539)"
            fill="#263238"
          />
          <path
            data-name="Path 4775"
            d="M122.845 76.709s-.364.091 2.41-1.227c1.682-.773 4.592-1.819 6.683-2.592a8.221 8.221 0 002.274-1.273 8.018 8.018 0 002.41 4.865 6.613 6.613 0 004.547 1.773c6.684-.091 7.139-6.684 7.139-6.684s-.727-.091 2.637 1.364c1.5.682 4.456 1.41 6.594 2.319a30.185 30.185 0 014.275 2.182 8.216 8.216 0 00-1.774 2.047 20.2 20.2 0 00-2.228 6.957 22.765 22.765 0 001.136 9.777s-1.591 6.366-1.318 7.412c.318 1.182 1.046 2.683 1.228 3.547.318 1.364-5.729 3.546-5.729 3.546a27.329 27.329 0 01-5.866 2.728 20.965 20.965 0 01-5.411.773 15.179 15.179 0 01-6.321-1.319 43.865 43.865 0 01-4.592-2.456 26.658 26.658 0 00-5.184-2.41c-1.774-.455-1.41-1.409-.682-2.82a7.909 7.909 0 00.773-3.911 54.127 54.127 0 00-1-5.5 33.058 33.058 0 00.727-9.413 34.861 34.861 0 00-1.136-6.229 29.02 29.02 0 00-1.591-3.455z"
            transform="translate(-18.546 -10.353)"
            fill="#38c5ae"
          />
          <path
            data-name="Path 4776"
            d="M103.094 150.977a1.625 1.625 0 01-.5-.092 1.58 1.58 0 01-.818-1.182 16.2 16.2 0 01.137-4.775c0-.182.045-.273.045-.363a12.176 12.176 0 011.042-3.638 14.966 14.966 0 00.954-3.046 45.339 45.339 0 00.183-9c-.046-1.41-.137-2.774-.137-4.047a66.1 66.1 0 01.955-10.095c.137-.818.227-1.682.363-2.591.183-1.364.318-2.5.455-3.638.227-2.091.454-4.092 1.046-7.048a31.447 31.447 0 011.91-6.275c.409-1.092.863-2.274 1.409-3.91 1.319-4.138 2.774-8.367 4.547-10.776 1.955-2.683 4.138-3.82 7.458-5.411a35.286 35.286 0 013.957-1.55c1.955-.683 3.638-1.228 4.774-2.41a.289.289 0 11.409.409c-1.228 1.228-2.955 1.819-5 2.546a39.635 39.635 0 00-3.911 1.5c-3.229 1.546-5.32 2.592-7.23 5.23-1.682 2.319-3.137 6.5-4.456 10.641-.546 1.637-1 2.865-1.409 3.956a30.65 30.65 0 00-1.864 6.184 69.563 69.563 0 00-1.047 7c-.137 1.138-.228 2.274-.454 3.638-.137.864-.227 1.728-.363 2.592a64.789 64.789 0 00-.955 10c0 1.274.045 2.592.137 4a43.039 43.039 0 01-.227 9.095 12.727 12.727 0 01-1 3.137 12.529 12.529 0 00-1.046 3.5c0 .091-.046.228-.046.409a16.384 16.384 0 00-.137 4.547 1.219 1.219 0 00.5.818c.409.183 1.092-.182 1.364-.318a.265.265 0 11.273.454 2.354 2.354 0 01-1.319.5z"
            transform="translate(-15.347 -10.276)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4777"
            d="M105.758 164.4a1.708 1.708 0 01-.727-.183c-1-.546-1.41-2.228-1.41-3.683a.273.273 0 01.545 0c0 1.273.363 2.774 1.092 3.183a1.312 1.312 0 001.319-.183.3.3 0 11.318.5 2.059 2.059 0 01-1.136.363z"
            transform="translate(-15.646 -23.744)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4778"
            d="M108.739 164.771a1.493 1.493 0 01-1.409-.863 9.083 9.083 0 01-.5-3.366c.045-.137.182-.273.318-.228s.273.183.228.318a7.425 7.425 0 00.5 3 1 1 0 00.909.5.839.839 0 00.818-.637.288.288 0 01.546.181 1.406 1.406 0 01-1.319 1.047.143.143 0 01-.092.045z"
            transform="translate(-16.127 -23.751)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4779"
            d="M111.705 164.261a3.1 3.1 0 01-.591-.091 1.732 1.732 0 01-1.092-1.228 15.343 15.343 0 01-.137-2.455v-.318a.273.273 0 01.545 0v.363a13.346 13.346 0 00.091 2.32 1.1 1.1 0 00.727.818.963.963 0 00.955-.137c.363-.318.592-2 .728-3.229a11.816 11.816 0 01.546-2.91.275.275 0 01.5.227 12.874 12.874 0 00-.5 2.729c-.228 1.955-.409 3.228-.955 3.637a1.186 1.186 0 01-.818.273z"
            transform="translate(-16.592 -23.288)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4780"
            d="M116.231 147.42a.293.293 0 01-.273-.273 4.356 4.356 0 00-.454-1.91 6.847 6.847 0 00-.864-1.137 8.4 8.4 0 01-1.364-2.046c-.637-1.364-.591-4.957-.363-7.639a48.487 48.487 0 01.864-5.275c.272-1.319.546-2.865.818-4.5.137-.909.273-2.137.409-3.41a48.157 48.157 0 01.909-6.138 39.611 39.611 0 011.865-5.092c.228-.591.5-1.182.728-1.773a22.355 22.355 0 00.955-3.092 30.337 30.337 0 013.091-7.821 13.089 13.089 0 001.091-5.093c.318-4.593-.363-10.959-2.591-14.142a.3.3 0 11.5-.318c2.32 3.274 3 9.821 2.683 14.505a13.97 13.97 0 01-1.183 5.32 28.709 28.709 0 00-3.046 7.684c-.318 1.091-.592 2.091-1 3.137-.227.638-.5 1.228-.727 1.774a38.62 38.62 0 00-1.864 5.047 45.407 45.407 0 00-.91 6.048c-.137 1.273-.273 2.5-.409 3.41a123.883 123.883 0 01-.818 4.547c-.364 2-.728 3.683-.864 5.228-.227 2.82-.227 6.184.273 7.367a9.31 9.31 0 001.273 1.91 12.235 12.235 0 01.91 1.227 5.05 5.05 0 01.5 2.183c.137.137.046.273-.137.273z"
            transform="translate(-17.026 -11.267)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4781"
            d="M180.7 150.587a2.61 2.61 0 01-1.137-.273.3.3 0 01-.137-.363.285.285 0 01.363-.137 1.841 1.841 0 001.456.091.607.607 0 00.318-.363 26.85 26.85 0 00.183-5.23 11.184 11.184 0 00-1.046-3.5 12.735 12.735 0 01-1-3.138 42.978 42.978 0 01-.227-9.094c.046-1.41.137-2.729.137-4a64.9 64.9 0 00-.955-10c-.137-.864-.228-1.682-.363-2.591-.137-1-.273-1.956-.363-2.911a55.976 55.976 0 00-1.546-8.866 70.93 70.93 0 00-2.865-9l-.183-.5c-.227-.636-.5-1.41-.773-2.228-.818-2.592-1.864-5.82-3.546-7.912-2-2.592-3.821-3.638-7.048-5.047a30.657 30.657 0 00-3.138-1.092c-2.728-.864-5.82-1.864-7.229-3.365a.289.289 0 11.409-.409c1.273 1.364 4.32 2.365 6.957 3.229 1.228.409 2.365.773 3.229 1.136 3.275 1.455 5.184 2.592 7.275 5.23 1.728 2.182 2.775 5.457 3.638 8.094.273.818.5 1.591.728 2.182l.182.5a69.616 69.616 0 012.865 9.049 57.472 57.472 0 011.546 8.912c.092.955.228 1.909.363 2.91.137.863.228 1.728.364 2.591a65.566 65.566 0 01.955 10.1c0 1.273-.046 2.637-.137 4.046a45.353 45.353 0 00.182 9 14.986 14.986 0 00.955 3.046 12.184 12.184 0 011.046 3.638 28.619 28.619 0 01-.182 5.411 1.324 1.324 0 01-.638.773 1.892 1.892 0 01-.636.091z"
            transform="translate(-22.88 -10.204)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4782"
            d="M182.981 164.485a2.182 2.182 0 01-1.137-.363.3.3 0 11.318-.5 1.245 1.245 0 001.273.183c.728-.409 1-1.864 1-3a.293.293 0 01.273-.273.261.261 0 01.272.273c0 1.273-.318 2.955-1.273 3.5a1.906 1.906 0 01-.727.182z"
            transform="translate(-27.436 -23.785)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4783"
            d="M180.285 164.51h-.046a1.381 1.381 0 01-1.318-.955.287.287 0 11.545-.182.845.845 0 00.818.592 1.088 1.088 0 00.955-.455 8.869 8.869 0 00.681-3.091.276.276 0 01.545-.092 8.841 8.841 0 01-.727 3.41 1.747 1.747 0 01-1.455.773z"
            transform="translate(-27.014 -23.718)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4784"
            d="M177.393 163.6a1.391 1.391 0 01-.909-.318c-.591-.408-.682-1.728-.863-3.274a8.286 8.286 0 00-.455-2.547.275.275 0 11.5-.227 9.139 9.139 0 01.5 2.728c.091 1.092.227 2.592.591 2.865a.9.9 0 001 .091 1 1 0 00.683-.727 8.569 8.569 0 00.091-2.137v-.318a.273.273 0 11.545 0v.318a9.856 9.856 0 01-.137 2.274 1.548 1.548 0 01-1.046 1.137.814.814 0 01-.5.137z"
            transform="translate(-26.443 -23.261)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4785"
            d="M171.622 147.589c-.182 0-.272-.138-.272-.318a5.348 5.348 0 011.5-3.683 7.01 7.01 0 001-1.41c.591-1.092.637-4.865.363-7.912a48.064 48.064 0 00-.863-5.23 123.883 123.883 0 01-.818-4.547c-.137-.955-.273-2.137-.409-3.41a45.144 45.144 0 00-.909-6.048 21.732 21.732 0 00-1.728-4.092 38.147 38.147 0 01-1.274-2.729 41.056 41.056 0 01-1.409-4.5 59.155 59.155 0 00-2.41-7.275c-2.046-4.865-.909-14.778 3.046-18.234a.292.292 0 01.409.046.288.288 0 01-.046.409c-3.729 3.274-4.819 13.005-2.91 17.6a57.825 57.825 0 012.41 7.367 40.26 40.26 0 001.409 4.456c.364.955.818 1.819 1.228 2.683a28.9 28.9 0 011.774 4.184 47.879 47.879 0 01.909 6.138c.137 1.273.273 2.5.409 3.41q.409 2.523.818 4.5a48.555 48.555 0 01.863 5.274c.183 2.229.363 6.775-.454 8.23a8.569 8.569 0 01-1.091 1.5 4.84 4.84 0 00-1.364 3.365c.091.091 0 .228-.183.228z"
            transform="translate(-24.671 -11.344)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4786"
            d="M116.639 121.6a.169.169 0 01-.137-.045.3.3 0 01-.091-.409 30.253 30.253 0 012.365-2.865 25.161 25.161 0 003.365-4.319.3.3 0 01.5.318 28.536 28.536 0 01-3.41 4.411 29.148 29.148 0 00-2.32 2.82.643.643 0 01-.273.091z"
            transform="translate(-17.57 -16.733)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4787"
            d="M117.381 155.4a.254.254 0 01-.273-.227l-.227-1.5c-.455-2.865-1-6.093-1.136-8.048-.092-2.047-.137-3.5-.137-5.093 0-1.728-.046-3.546-.183-6.275l-.046-.682c-.046-.727-.091-1.773-.137-2.455a.3.3 0 01.592-.046c.045.682.091 1.682.137 2.456l.045.681c.137 2.775.183 4.547.183 6.321 0 1.545.046 3.046.137 5.047.092 1.955.637 5.184 1.092 8l.227 1.5a.266.266 0 01-.227.318h-.048z"
            transform="translate(-17.401 -19.297)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4788"
            d="M119.1 176.063a.292.292 0 01-.272-.273v-1.318a63.321 63.321 0 00-.592-10.731.276.276 0 01.545-.091 64.909 64.909 0 01.637 10.822v1.318a.391.391 0 01-.318.273z"
            transform="translate(-17.852 -24.22)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4789"
            d="M128.688 155.827a.271.271 0 01-.273-.318 57.233 57.233 0 011-5.639c.273-1.318.5-2.41.592-3.32a44.336 44.336 0 00.454-8.594c-.318-3.274.592-4.775.637-4.82a.3.3 0 01.5.318 8.2 8.2 0 00-.546 4.456 49.786 49.786 0 01-.455 8.731c-.091.909-.318 2.046-.591 3.365-.318 1.683-.728 3.592-.955 5.593-.092.092-.227.228-.363.228z"
            transform="translate(-19.388 -19.628)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4790"
            d="M128.2 177.329a.256.256 0 01-.273-.318c.091-.909.046-2.683 0-4.684-.046-2.591-.137-5.866.046-8.685a.3.3 0 11.59.045c-.183 2.82-.091 6.048-.045 8.64.045 2.047.091 3.775 0 4.73a.333.333 0 01-.318.272z"
            transform="translate(-19.306 -24.214)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4791"
            d="M116.652 190.647a12.024 12.024 0 01-2.137-.182 4 4 0 01-2.683-1.864 1.418 1.418 0 01-.091-1.274 9.777 9.777 0 012.136-2.91 11.256 11.256 0 001.864-2.456c.137-.317.364-.909.638-1.591a7.93 7.93 0 011.092-2.41 6.54 6.54 0 00.5-.545 3.863 3.863 0 012.865-1.728 4.76 4.76 0 012.683 1.364 6.318 6.318 0 00.773.546l.183.092a3.474 3.474 0 011.819 1.864 10.573 10.573 0 01.183 3.774 1.883 1.883 0 01-1.046 1.274 3.505 3.505 0 00-1.228 1.136 2.139 2.139 0 00-.318.955 4 4 0 01-1.5 2.591c-1.364 1-3.821 1.364-5.729 1.364zm-.409-8.413a12.648 12.648 0 01-1.956 2.546 11.169 11.169 0 00-2.045 2.774.8.8 0 00.091.773 3.66 3.66 0 002.32 1.547c1.591.363 5.638.228 7.275-1.092a3.363 3.363 0 001.319-2.228 4.083 4.083 0 01.409-1.182 4.393 4.393 0 011.409-1.274c.455-.273.728-.454.818-.909a10.832 10.832 0 00-.137-3.456c-.318-.863-.818-1.136-1.592-1.591l-.181-.091c-.228-.137-.5-.363-.818-.592a4.755 4.755 0 00-2.365-1.227 3.43 3.43 0 00-2.455 1.546 7.216 7.216 0 01-.546.592 15.139 15.139 0 00-.955 2.228 8.08 8.08 0 01-.591 1.637z"
            transform="translate(-16.855 -26.073)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4792"
            d="M117.131 193.127c-2.182 0-4.774-.5-5.957-2.047-.227-.318-.682-1.182.455-2.5a.291.291 0 11.454.363c-.592.728-.773 1.364-.409 1.774 1.228 1.638 4.73 2.092 7.367 1.682 2.228-.318 3.592-.863 4.046-1.592a3.366 3.366 0 00.228-1.591 2.126 2.126 0 01.272-1.409 2.951 2.951 0 011.228-.773 3.617 3.617 0 001.228-.818c.546-.592.137-1.955-.091-2.456a.275.275 0 11.5-.227c.046.091.863 2.091-.046 3.046a4.306 4.306 0 01-1.409.955 3.394 3.394 0 00-1.046.637 2.95 2.95 0 00-.092 1 3.782 3.782 0 01-.318 1.909c-.592.91-2 1.5-4.456 1.864a12.352 12.352 0 01-1.955.183z"
            transform="translate(-16.744 -27.234)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4793"
            d="M170.841 176.6a.293.293 0 01-.273-.273c0-3.274.137-8.321.546-12.686 0-.138.183-.273.318-.273a.3.3 0 01.273.318c-.363 4.32-.5 9.367-.5 12.641-.092.138-.183.273-.364.273z"
            transform="translate(-25.754 -24.214)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4794"
            d="M161.783 177.949c-.181 0-.272-.137-.272-.318v-.318a91.141 91.141 0 00-.046-13.733.3.3 0 11.59-.046 86.6 86.6 0 01.046 13.824v.318a.391.391 0 01-.318.273z"
            transform="translate(-24.38 -24.197)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4795"
            d="M170.749 191.351c-1.91 0-4.366-.318-5.639-1.409a3.91 3.91 0 01-1.5-2.592 2.984 2.984 0 00-.318-.955 4.585 4.585 0 00-1.228-1.136 1.987 1.987 0 01-1.046-1.273 10.539 10.539 0 01.183-3.775 3.474 3.474 0 011.819-1.864l.181-.092a4.226 4.226 0 00.638-.454 5.421 5.421 0 013.046-1.364 2.8 2.8 0 012.591 1.547 4.46 4.46 0 00.546.681 11.745 11.745 0 011.092 2.41c.273.682.5 1.319.637 1.592a12.519 12.519 0 001.864 2.456 11.386 11.386 0 012.137 2.91 1.416 1.416 0 01-.091 1.274 4.154 4.154 0 01-2.683 1.864 14.693 14.693 0 01-2.228.182zm-3.729-14.369h-.183a5.249 5.249 0 00-2.774 1.273 6.455 6.455 0 01-.682.5l-.183.091a3.03 3.03 0 00-1.591 1.591 9.714 9.714 0 00-.137 3.455c.092.455.364.637.818.909a4.4 4.4 0 011.41 1.274 2.317 2.317 0 01.409 1.182 3.268 3.268 0 001.319 2.228c1.592 1.319 5.684 1.455 7.275 1.091a3.665 3.665 0 002.32-1.547.952.952 0 00.091-.773 11.151 11.151 0 00-2.046-2.774 14.176 14.176 0 01-1.955-2.546 11.181 11.181 0 01-.637-1.638 14.912 14.912 0 00-.955-2.228 4.621 4.621 0 01-.592-.728c-.454-.727-.909-1.364-1.909-1.364z"
            transform="translate(-24.299 -26.185)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4796"
            d="M170.09 193.775a12.075 12.075 0 01-1.91-.137c-2.455-.363-3.864-.955-4.456-1.864a3.686 3.686 0 01-.318-1.909 2.833 2.833 0 00-.091-1 2.715 2.715 0 00-1.046-.637 3.874 3.874 0 01-1.41-.955c-.863-.955-.045-2.955-.045-3.046a.275.275 0 01.5.227c-.183.5-.592 1.864-.091 2.456a3.634 3.634 0 001.227.818 3.95 3.95 0 011.228.773 2.119 2.119 0 01.273 1.409 3.382 3.382 0 00.227 1.592c.5.773 1.819 1.274 4.047 1.591 2.637.409 6.139-.045 7.366-1.682.318-.455.183-1.092-.408-1.774a.291.291 0 11.454-.363c1.136 1.319.682 2.183.455 2.5-1.228 1.547-3.819 2-6 2z"
            transform="translate(-24.228 -27.336)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4797"
            d="M224.372 161.066h-.864c-.182 0-15.415-.546-35.741-.955a.273.273 0 110-.545c20.325.364 35.6.955 35.741.955h.864a.293.293 0 01.273.273.263.263 0 01-.273.272z"
            transform="translate(-28.31 -23.639)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4798"
            d="M166.467 159.918a1749.31 1749.31 0 00-26.1-.182c-9.686 0-17.87.045-26.191.137a.262.262 0 01-.273-.273.294.294 0 01.273-.273c8.322-.137 16.507-.137 26.191-.137 8.139 0 16.962.046 26.1.183a.293.293 0 01.273.272.262.262 0 01-.273.273z"
            transform="translate(-17.198 -23.583)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4799"
            d="M58.687 161.066a.273.273 0 010-.545h.272c.137 0 15.643-.591 36.469-.955a.273.273 0 110 .545c-20.826.363-36.286.955-36.469.955z"
            transform="translate(-8.821 -23.639)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4800"
            d="M11.8 166.19a.167.167 0 01-.137-.046 2.262 2.262 0 01-.909-2.092c0-1.547.773-1.819.864-1.864h.082l13.278-.318.046.546-13.232.318c-.091.045-.455.318-.455 1.319a1.985 1.985 0 00.546 1.546l13.141-.318a.272.272 0 110 .544h-.546l-12.686.364z"
            transform="translate(-1.624 -23.987)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4801"
            d="M58.851 165.121a.273.273 0 010-.545c.136 0 15.915-.637 36.605-1.046a.273.273 0 010 .545c-20.69.409-36.469 1.046-36.605 1.046z"
            transform="translate(-8.845 -24.238)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4802"
            d="M113.642 163.812a.273.273 0 010-.545c7.548-.137 17.416-.273 26.737-.273 8.276 0 17.188.091 26.555.228a.272.272 0 110 .544c-9.32-.137-18.279-.227-26.555-.227-9.321.046-19.189.183-26.737.273z"
            transform="translate(-17.118 -24.157)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4803"
            d="M224.408 165.121h-1.864c-.137 0-14.96-.637-35.422-1.046a.273.273 0 010-.545c20.462.409 35.286 1.046 35.422 1.046h1.819a.292.292 0 01.272.273c0 .136-.045.273-.228.273z"
            transform="translate(-28.212 -24.238)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4804"
            d="M59.2 166.156c-.955 0-1-3.092-1-3.455s.046-3.455 1-3.455q.545 0 .818 1.227a.276.276 0 11-.545.092 1.685 1.685 0 00-.272-.728 6.117 6.117 0 00-.455 2.82 7.458 7.458 0 00.409 2.82 2.767 2.767 0 00.227-1.182.272.272 0 11.545 0c.046.5-.091 1.864-.727 1.864z"
            transform="translate(-8.789 -23.591)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4805"
            d="M56.9 166.147c-.955 0-1-3.091-1-3.455s.046-3.455 1-3.455c.227 0 1.956-.046 1.956-.046v.546s-1.591.046-1.91.046a5.6 5.6 0 00-.455 2.865 6.224 6.224 0 00.455 2.865H58.9v.545a13.348 13.348 0 01-2 .092z"
            transform="translate(-8.441 -23.583)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4806"
            d="M55.923 183.711c-3.046 0-4.684-12.823-4.684-24.873s1.637-24.873 4.684-24.873c2.865 0 4.5 11.459 4.684 22.782a.293.293 0 01-.272.273.262.262 0 01-.273-.273c-.227-13.733-2.274-22.236-4.092-22.236-1.956 0-4.138 10-4.138 24.327s2.182 24.328 4.138 24.328 3.956-9.048 4.092-22.553a.273.273 0 01.546 0c-.182 11.459-1.819 23.1-4.684 23.1z"
            transform="translate(-7.737 -19.774)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4807"
            d="M56.7 179.66c-2 0-2.728-11.686-2.728-19.553s.727-19.553 2.728-19.553 2.592 10.822 2.728 17.233a.273.273 0 01-.546 0c-.181-11.64-1.5-16.642-2.137-16.642-.773 0-2.182 6.5-2.182 19.007s1.41 19.007 2.182 19.007c.727 0 2.046-5.865 2.137-17.552a.273.273 0 01.546 0c-.091 6.684-.727 18.053-2.728 18.053z"
            transform="translate(-8.15 -20.769)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4808"
            d="M42.822 184.089c-3.956 0-7.73-.182-9.049-.591-3.638-1.092-6.366-11.823-6.366-25.009s2.456-22.918 6.138-24.054c2.091-.638 15.643-.773 18.735-.592a.3.3 0 01-.046.591c-3.32-.228-16.642-.046-18.552.545-2.865.864-5.729 9.231-5.729 23.509S31 182.042 33.91 182.952c2.365.727 13.733.682 18.325.137.137 0 .318.091.318.227s-.091.318-.227.318a78.113 78.113 0 01-9.5.454z"
            transform="translate(-4.139 -19.744)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4809"
            d="M48.173 184.066a.169.169 0 01-.137-.045c-2.456-1.138-5.365-12.824-5.365-26.237s2.546-22.236 4.956-23.828a.3.3 0 11.318.5c-1.91 1.228-4.684 9.5-4.684 23.328s3 24.827 5 25.738a.251.251 0 01.137.363.3.3 0 01-.227.182z"
            transform="translate(-6.444 -19.765)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4810"
            d="M230.46 166.1c-.5 0-.682-.727-.818-1.682 0-.137.092-.318.228-.318s.318.091.318.227a2.657 2.657 0 00.273 1.138 6.568 6.568 0 00.409-2.82 6.377 6.377 0 00-.455-2.865 5.351 5.351 0 00-.227.909c-.046.137-.183.273-.318.227s-.273-.183-.228-.318c.137-.773.273-1.409.773-1.409.954 0 1 3.092 1 3.456.046.363 0 3.455-.955 3.455z"
            transform="translate(-34.672 -23.583)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4811"
            d="M232.552 166.164h-2v-.546h1.955a5.609 5.609 0 00.455-2.865 6.225 6.225 0 00-.455-2.865c-.318 0-1.91-.046-1.91-.046v-.542s1.728.046 1.956.046c.955 0 1 3.092 1 3.455 0 .273 0 3.365-1 3.365z"
            transform="translate(-34.811 -23.598)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4812"
            d="M232.4 183.647c-2.865 0-4.547-11.64-4.684-23.145a.273.273 0 01.545 0c.182 13.505 2.274 22.555 4.092 22.555 1.955 0 4.138-10 4.138-24.328s-2.183-24.328-4.138-24.328c-1.819 0-3.911 8.5-4.092 22.282a.273.273 0 01-.545 0c.183-11.368 1.819-22.827 4.684-22.827 3.046 0 4.684 12.824 4.684 24.873s-1.638 24.919-4.684 24.919z"
            transform="translate(-34.382 -19.757)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4813"
            d="M232.319 179.651c-2 0-2.683-11.414-2.728-18.143a.273.273 0 01.546 0c.091 11.686 1.455 17.553 2.137 17.553.773 0 2.182-6.5 2.182-19.007s-1.409-19.007-2.182-19.007c-.638 0-1.956 5.047-2.137 16.687a.273.273 0 01-.546 0c.091-6.411.773-17.233 2.728-17.233s2.729 11.686 2.729 19.553-.728 19.6-2.729 19.6z"
            transform="translate(-34.666 -20.761)"
            fill="#566072"
          />
          <path
            data-name="Path 4814"
            d="M240.571 184.058a.279.279 0 01-.09-.546c.091-.045.137-.045.182-.091 2-.909 5-11.595 5-25.691s-2.729-22.054-4.684-23.327a.3.3 0 01.318-.5c2.41 1.547 4.956 10.413 4.956 23.783s-2.82 25.054-5.32 26.191a.651.651 0 01-.273.091c-.045.091-.091.091-.091.091z"
            transform="translate(-36.281 -19.757)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4815"
            d="M126.9 175.826a.168.168 0 01-.137-.046c-1.636-1.046-4-1.273-7.184-.727a.267.267 0 01-.318-.228c0-.137.091-.318.227-.318 3.32-.592 5.82-.318 7.594.773a.3.3 0 01.091.409.393.393 0 01-.273.137z"
            transform="translate(-18.007 -25.849)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4816"
            d="M148.675 105.635c-.773 0-1.546-.046-2.364-.092s-1.637-.091-2.5-.091h-.046c-1.409 0-2.637.046-3.729.091a34.311 34.311 0 01-4.865-.045 10.188 10.188 0 01-6.821-3.592.291.291 0 11.455-.363 9.294 9.294 0 006.411 3.364 27.55 27.55 0 004.776.046 88.555 88.555 0 013.819-.091c.863 0 1.728.045 2.547.091a16.674 16.674 0 006.729-.592.288.288 0 01.182.546 14.374 14.374 0 01-4.593.728z"
            transform="translate(-19.37 -14.862)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4817"
            d="M131.208 135.281a.248.248 0 01-.228-.137.3.3 0 01.092-.409c.409-.272.955-.727 1.682-1.319a.291.291 0 11.363.455 17.365 17.365 0 01-1.728 1.319c-.045.091-.091.091-.181.091z"
            transform="translate(-19.77 -19.682)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4818"
            d="M132.864 137.454a.17.17 0 01-.137-.046.245.245 0 01-.091-.363 19.993 19.993 0 014.911-5.457c.955-.683 3.183-2.092 4.547-2.229a.276.276 0 01.091.545 12.591 12.591 0 00-4.274 2.137 20.062 20.062 0 00-4.729 5.274.491.491 0 01-.318.137z"
            transform="translate(-20.02 -19.078)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4819"
            d="M158.309 135.962a.167.167 0 01-.137-.046 18.847 18.847 0 01-1.819-1.455.291.291 0 11.363-.454 17.829 17.829 0 001.774 1.409.3.3 0 01.091.409.4.4 0 01-.273.137z"
            transform="translate(-23.592 -19.77)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4820"
            d="M155 136.724a.282.282 0 01-.273-.183c-.864-2-4.82-4.592-7.184-6.138-.773-.5-1.41-.909-1.682-1.136a.291.291 0 01.363-.455c.273.228.863.638 1.636 1.137 2.41 1.591 6.458 4.229 7.367 6.366a.285.285 0 01-.137.363.132.132 0 01-.091.046z"
            transform="translate(-22.007 -18.986)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4821"
            d="M172.2 122.52a.25.25 0 01-.228-.137 33.387 33.387 0 00-5.872-7.683.291.291 0 01.363-.455 34.663 34.663 0 016 7.821.238.238 0 01-.092.363c-.039.091-.085.091-.171.091z"
            transform="translate(-25.063 -16.787)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4822"
            d="M142.433 118.75a20.393 20.393 0 01-5.365-.773 21.45 21.45 0 01-5.23-2.5 21.7 21.7 0 00-2.41-1.319c-.818-.363-1.637-.682-2.365-1a8.254 8.254 0 01-2.456-1.182c-.637-.728-.273-1.5.137-2.365a10.994 10.994 0 00.818-2.365 14.391 14.391 0 00-.455-4.547c-.182-.818-.318-1.682-.454-2.637a.266.266 0 01.227-.318c.136 0 .318.091.318.227.137.955.318 1.819.454 2.637a15.216 15.216 0 01.455 4.73 9.212 9.212 0 01-.864 2.545c-.409.909-.591 1.319-.227 1.728a10.959 10.959 0 002.228 1c.728.273 1.546.637 2.365 1a16.979 16.979 0 012.455 1.364 20.064 20.064 0 005.047 2.456c6.912 1.955 10.913-.092 15.142-2.229.546-.272 1.091-.545 1.683-.818.363-.183.773-.364 1.136-.546 1.592-.728 3.092-1.455 3.455-2.092.137-.272-.137-.863-.409-1.546a9.449 9.449 0 01-.727-2.183 12.342 12.342 0 01.591-4.274 29.16 29.16 0 00.683-3.592.3.3 0 01.591.045 30.583 30.583 0 01-.682 3.684 12.232 12.232 0 00-.546 4.046 13.573 13.573 0 00.682 2.046c.363.863.683 1.546.363 2.046-.455.773-1.955 1.455-3.683 2.274-.364.183-.728.364-1.137.546l-1.636.818c-2.956 1.5-6 3.092-10.186 3.092z"
            transform="translate(-18.763 -14.607)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4823"
            d="M158.129 137.7a.17.17 0 01-.137-.045c-2.591-1.456-2.364-5.593-1.227-8 1.682-3.592 6.32-7 9.912-7.367a4.717 4.717 0 014.456 1.819.337.337 0 01-.045.409.286.286 0 01-.409-.046 4.016 4.016 0 00-3.911-1.59c-3.41.318-7.867 3.637-9.457 7.047-1.047 2.183-1.274 6 1 7.276a.245.245 0 01.091.363.393.393 0 01-.273.137z"
            transform="translate(-23.548 -18.005)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4824"
            d="M128.94 138.043a.248.248 0 01-.227-.137.237.237 0 01.091-.363c2.274-1.274 2.047-5.093 1-7.276-1.591-3.365-5.957-6.593-9.367-6.912a4.135 4.135 0 00-4 1.591.291.291 0 11-.454-.363 4.609 4.609 0 014.5-1.819c3.638.363 8.14 3.683 9.821 7.229 1.138 2.41 1.364 6.548-1.228 8a.166.166 0 01-.137.046z"
            transform="translate(-17.503 -18.076)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4825"
            d="M172.123 155.634h-.046c-.137-.045-.273-.181-.228-.318l.091-.592c.5-3 1.182-6.683 1.274-8.82.091-2.047.137-3.5.137-5.047 0-1.728.045-3.547.182-6.321.046-.454.138-2.092.183-2.547a.3.3 0 01.591.046c-.046.454-.137 2.092-.183 2.547-.137 2.774-.183 4.547-.183 6.275 0 1.546-.045 3.046-.137 5.092-.091 2.183-.773 5.912-1.273 8.912l-.092.592a.381.381 0 01-.318.181z"
            transform="translate(-25.946 -19.434)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4826"
            d="M160.734 155.707a.256.256 0 01-.273-.228c-.273-1.727-.592-3.41-.91-4.911s-.545-2.774-.681-3.774a47.926 47.926 0 01-.455-8.731 8.464 8.464 0 00-.546-4.5.3.3 0 11.5-.318c.046.045.955 1.546.638 4.819a48.155 48.155 0 00.454 8.595c.137 1 .363 2.274.682 3.729.318 1.5.636 3.183.909 4.911a.363.363 0 01-.318.409z"
            transform="translate(-23.83 -19.644)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4827"
            d="M141.861 56.974a.254.254 0 01-.273-.227 4.461 4.461 0 01.318-2.137.288.288 0 01.546.181 4.208 4.208 0 00-.318 1.91.33.33 0 01-.273.272z"
            transform="translate(-21.374 -7.763)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4828"
            d="M146.541 57.108a.339.339 0 01-.181-.046 3.168 3.168 0 01-1.5-3 .3.3 0 11.59.045 2.6 2.6 0 001.274 2.5.347.347 0 01.091.409.333.333 0 01-.274.092z"
            transform="translate(-21.871 -7.668)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4829"
            d="M151.889 58.568a4.919 4.919 0 01-4.092-2.182.3.3 0 11.5-.318 4.332 4.332 0 003.592 1.956.293.293 0 01.273.273.241.241 0 01-.273.272z"
            transform="translate(-22.309 -7.992)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4830"
            d="M143.468 75.086a6.021 6.021 0 01-2.865-.773 8.359 8.359 0 01-4.046-5.275.3.3 0 11.59-.137 7.948 7.948 0 003.775 4.911 5.086 5.086 0 004.275.409 7.762 7.762 0 004.638-5.23.288.288 0 01.546.181 8.231 8.231 0 01-5 5.593 5.981 5.981 0 01-1.909.318z"
            transform="translate(-20.617 -9.914)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4831"
            d="M136.038 67.752c-1.364 0-2.229-1.5-2.319-2.592a1.606 1.606 0 01.5-1.364 1.205 1.205 0 011.046-.318c.137.046.273.182.228.318s-.183.272-.318.227a.682.682 0 00-.591.182.982.982 0 00-.318.909c.091.909.727 2.137 1.819 2.091a.262.262 0 01.273.272.294.294 0 01-.273.272h-.045z"
            transform="translate(-20.189 -9.127)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4832"
            d="M152.674 67.7h-.046a.272.272 0 110-.545h.046c.818 0 1.5-.955 1.637-1.819a1.747 1.747 0 00-.183-1.183.824.824 0 00-.637-.227.272.272 0 110-.545 1.308 1.308 0 011.046.409 2.026 2.026 0 01.363 1.637 2.607 2.607 0 01-2.228 2.274z"
            transform="translate(-23.004 -9.116)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4833"
            d="M153.272 66.111h-.091a.288.288 0 01-.183-.364 1.293 1.293 0 01.591-.773.3.3 0 01.318.5.98.98 0 00-.363.455.308.308 0 01-.273.182z"
            transform="translate(-23.1 -9.35)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4834"
            d="M144.347 66.964a.237.237 0 01-.183-.091c-.5-.5-.592-.727-.592-1.046a1.437 1.437 0 01.273-.773 1.251 1.251 0 00.091-1.319.275.275 0 01.5-.227 1.672 1.672 0 01-.137 1.819.735.735 0 00-.183.455c0 .137 0 .228.409.636a.287.287 0 010 .409c-.046.137-.091.137-.183.137z"
            transform="translate(-21.678 -9.113)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4835"
            d="M141.572 62.332a3.645 3.645 0 01-.954-.228 1.927 1.927 0 00-1.228-.227.276.276 0 11-.09-.545 2.384 2.384 0 011.546.228c.5.182.773.318 1.138.091a.3.3 0 01.318.5 1.558 1.558 0 01-.728.182z"
            transform="translate(-20.997 -8.8)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4836"
            d="M134.6 60.812a.287.287 0 01-.272-.227c-1.5-6.5.5-11.686 5.138-13.187a7.814 7.814 0 014.092-.182.275.275 0 01-.227.5 7.453 7.453 0 00-3.683.182c-4.321 1.364-6.229 6.275-4.776 12.505a.242.242 0 01-.227.318c0 .091-.045.091-.045.091z"
            transform="translate(-20.208 -6.643)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4837"
            d="M153.321 60.8h-.045a.36.36 0 01-.227-.364c1.455-6-.137-9-1.228-10.276a4.573 4.573 0 00-3.911-1.728.3.3 0 01-.045-.591 5.229 5.229 0 014.41 1.91c1.138 1.364 2.865 4.547 1.319 10.776-.045.227-.137.272-.272.272z"
            transform="translate(-22.285 -6.768)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4838"
            d="M136.825 61.7a.284.284 0 01-.273-.182.251.251 0 01.137-.364 5.31 5.31 0 002.41-3.774.3.3 0 11.59.046 5.767 5.767 0 01-2.728 4.229.168.168 0 01-.137.046z"
            transform="translate(-20.613 -8.17)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4839"
            d="M147.538 64a.656.656 0 01.5-.682.608.608 0 01.546.637.656.656 0 01-.5.682.578.578 0 01-.546-.637z"
            transform="translate(-22.277 -9.108)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4840"
            d="M140.145 64.057a.563.563 0 01.454-.683.6.6 0 01.546.591.563.563 0 01-.455.682.6.6 0 01-.545-.591z"
            transform="translate(-21.16 -9.116)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4841"
            d="M135.631 66.314a.287.287 0 01-.273-.227 1.451 1.451 0 00-.318-.5.291.291 0 11.363-.455 1.284 1.284 0 01.546.818.266.266 0 01-.227.318.141.141 0 01-.091.046z"
            transform="translate(-20.373 -9.372)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4842"
            d="M151.937 61.908c-.091 0-.137-.046-.227-.091a3.613 3.613 0 01-.909-1.5.276.276 0 01.545-.091 2.834 2.834 0 00.773 1.273.341.341 0 010 .409h-.182z"
            transform="translate(-22.768 -8.604)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4843"
            d="M143.308 62.481a.271.271 0 01-.182-.046.288.288 0 01-.046-.409l.092-.091a2.154 2.154 0 00.273-.409.275.275 0 11.5.227 2.007 2.007 0 01-.363.5l-.092.091a.243.243 0 01-.182.137z"
            transform="translate(-21.594 -8.813)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4844"
            d="M146.58 62.319a1.227 1.227 0 01-.728-.228.3.3 0 01.318-.5c.363.228.681.137 1.136-.091a3.394 3.394 0 01.818-.272 1.947 1.947 0 01.727 0 .276.276 0 01-.091.545 1.107 1.107 0 00-.546 0 4.085 4.085 0 00-.683.227 1.982 1.982 0 01-.955.318z"
            transform="translate(-22.002 -8.786)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4845"
            d="M144.321 69.158c-1.182.182-1.682-.682-2.183-.046-.5.591-.773 1.591-.182 2 .591.455 1.546.091 2.091.091a6.591 6.591 0 002.137-.046c.683-.272.409-1.682.045-2.092-.5-.5-1.319 0-1.909.091z"
            transform="translate(-21.384 -9.942)"
            fill="#f4f4f4"
          />
          <path
            data-name="Path 4846"
            d="M142.724 71.555a1.593 1.593 0 01-1-.273 1.069 1.069 0 01-.455-.818 2.43 2.43 0 01.592-1.637.993.993 0 011.228-.182 2.247 2.247 0 001.136.137 1.731 1.731 0 00.455-.137c.546-.182 1.182-.364 1.636.137a2.433 2.433 0 01.409 1.819.97.97 0 01-.546.728 3.442 3.442 0 01-1.546.091c-.227 0-.455-.046-.682-.046-.137 0-.318.046-.5.046a1.233 1.233 0 01-.728.137zM142.5 69.1c-.091 0-.137.046-.227.137a1.7 1.7 0 00-.454 1.182.479.479 0 00.227.409 1.963 1.963 0 001.364.091 2.6 2.6 0 01.545-.046 3.44 3.44 0 01.683.046 3.088 3.088 0 001.319-.046.452.452 0 00.227-.318 2.037 2.037 0 00-.273-1.319c-.228-.228-.546-.137-1.047 0a2.389 2.389 0 01-.545.137 2.522 2.522 0 01-1.41-.182 2.306 2.306 0 00-.409-.091z"
            transform="translate(-21.329 -9.883)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4847"
            d="M137.855 65.861a.168.168 0 01-.137-.046.717.717 0 01-.363-.591 9.886 9.886 0 010-1.682.3.3 0 01.591.046A9.574 9.574 0 00137.9 65a2.15 2.15 0 000-.773c0-.137.091-.318.227-.318s.318.091.318.227a1.786 1.786 0 01-.364 1.592.25.25 0 01-.227.137z"
            transform="translate(-20.733 -9.1)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4848"
            d="M143.428 78.488a6.916 6.916 0 01-1.364-.137c-2.592-.546-5.366-2.41-5.775-5.457 0-.137.091-.318.227-.318a.267.267 0 01.318.227c.363 2.728 2.955 4.456 5.32 4.956a6.27 6.27 0 005.093-1.182 6.847 6.847 0 002.728-5c0-.137.182-.272.318-.272a.3.3 0 01.272.318 7.626 7.626 0 01-2.955 5.411 6.514 6.514 0 01-4.184 1.455z"
            transform="translate(-20.579 -10.313)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4849"
            d="M118.895 96.918a.234.234 0 01-.182-.091.339.339 0 010-.409 3.493 3.493 0 00.818-2.456.273.273 0 01.546 0 4.054 4.054 0 01-1 2.865c-.045.091-.091.091-.182.091z"
            transform="translate(-17.915 -13.693)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4850"
            d="M119.1 99.054a.167.167 0 01-.137-.046.3.3 0 01-.137-.364 2.859 2.859 0 013.137-1.591.3.3 0 01-.137.59 2.315 2.315 0 00-2.5 1.273.25.25 0 01-.227.137z"
            transform="translate(-17.939 -14.191)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4851"
            d="M122.44 95.849c-1.728-.182-1.682-2.41-1.682-3.365V92.3a.273.273 0 01.545 0v.182c0 1.41.137 2.728 1.136 2.819a.3.3 0 01.273.318.3.3 0 01-.273.227z"
            transform="translate(-18.234 -13.442)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4852"
            d="M161.947 176.841a.248.248 0 01-.227-.137.3.3 0 01.091-.409q2.66-1.635 7.639-.818c.137.046.272.183.228.318s-.182.273-.318.227c-3.137-.546-5.593-.318-7.229.728-.092.091-.137.091-.183.091z"
            transform="translate(-24.411 -26)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4853"
            d="M141.036 125.861a.272.272 0 01-.181-.045l-.046-.046a14.534 14.534 0 00-5.093-2.728.3.3 0 01.137-.591 14.457 14.457 0 015.275 2.82l.045.046a.288.288 0 01.046.409c0 .091-.091.137-.183.137z"
            transform="translate(-20.458 -18.035)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4854"
            d="M125.9 134.9a.272.272 0 01-.181-.045.288.288 0 01-.046-.409 7.531 7.531 0 001-3.092.276.276 0 01.544.091 8.616 8.616 0 01-1.137 3.365.237.237 0 01-.183.091z"
            transform="translate(-18.967 -19.344)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4855"
            d="M163.54 134.959a.248.248 0 01-.227-.137 11.938 11.938 0 01-1.319-3.228.3.3 0 11.591-.136 11.673 11.673 0 001.273 3.046.3.3 0 01-.091.409.618.618 0 01-.228.045z"
            transform="translate(-24.458 -19.359)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4856"
            d="M275.336 165.875l-13.232-.318a.273.273 0 110-.545h.546l12.6.318a1.986 1.986 0 00.546-1.547c0-1-.363-1.273-.455-1.319l-13.232-.318a.293.293 0 01-.273-.273.262.262 0 01.273-.273l13.324.318h.091c.092.045.864.318.864 1.864a2.345 2.345 0 01-.91 2.092h-.137z"
            transform="translate(-39.534 -23.947)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4857"
            d="M39.74 184.007a.169.169 0 01-.137-.045c-2.456-1.138-5.184-12.462-5.184-25.962s2.546-22.282 4.956-23.828a.3.3 0 11.318.5c-1.91 1.228-4.684 9.5-4.684 23.328s2.865 24.554 4.865 25.464a.252.252 0 01.137.364.282.282 0 01-.272.182z"
            transform="translate(-5.198 -19.798)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4858"
            d="M242.946 184.1c-3.729 0-7.684-.182-9.866-.409a.276.276 0 11.091-.544c4.729.591 15.87.591 18.279-.092 2.911-.863 5.958-10.276 5.958-24.464s-2.865-22.6-5.729-23.508c-1.955-.592-15.234-.773-18.507-.546a.331.331 0 01-.318-.273c-.046-.182.091-.273.272-.318 3.092-.228 16.6-.046 18.735.591 3.639 1.14 6.139 10.78 6.139 24.057s-2.728 23.918-6.366 25.009a53 53 0 01-8.685.5z"
            transform="translate(-35.157 -19.757)"
            fill="#332e3c"
          />
          <path
            data-name="Path 4859"
            d="M248.708 184.044a.282.282 0 01-.273-.183.285.285 0 01.137-.363c1.955-.909 4.821-11.277 4.821-25.509s-2.82-22.145-4.73-23.373a.3.3 0 01.318-.5c2.456 1.592 4.957 10.959 4.957 23.828 0 13.55-2.729 24.919-5.184 26.01.045.091 0 .091-.046.091z"
            transform="translate(-37.509 -19.789)"
            fill="#332e3c"
          />
          <g data-name="Group 5561">
            <path
              data-name="Path 4344"
              d="M29.526 138.1a4.231 4.231 0 00-1.518-2.6c-1.518-1.518-2.491-2.385-2.491-2.385s-.76 2.494.649 4.009a26.667 26.667 0 003.355 2.927z"
              transform="translate(242.718 113.388) translate(-16.525 -133.118)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4345"
              d="M26.934 146.078a4.236 4.236 0 00-1.515-2.6c-1.515-1.518-2.494-2.385-2.494-2.385s-.758 2.494.651 4.012a26.7 26.7 0 003.358 2.919z"
              transform="translate(242.718 113.388) translate(-16.134 -134.322)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4346"
              d="M30.126 140.359a4.228 4.228 0 011.784-2.427c1.669-1.347 2.732-2.108 2.732-2.108s.492 2.558-1.071 3.914a26.6 26.6 0 01-3.651 2.556z"
              transform="translate(242.718 113.388) translate(-17.221 -133.527)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4347"
              d="M26.951 149.852s.229-1.06 2.03-2.236 2.938-1.809 2.938-1.809.218 2.6-1.476 3.786a26.781 26.781 0 01-3.914 2.158z"
              transform="translate(242.718 113.388) translate(-16.709 -135.034)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4348"
              d="M27.618 159.961a4.234 4.234 0 011.518-2.6c1.518-1.518 2.494-2.385 2.494-2.385s.758 2.494-.651 4.012a26.6 26.6 0 01-3.355 2.927z"
              transform="translate(242.718 113.388) translate(-16.874 -136.418)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4349"
              d="M26.926 162.374a4.268 4.268 0 00-1.118-2.8c-1.272-1.723-2.128-2.715-2.128-2.715s-1.118 2.36.073 4.063a26.707 26.707 0 002.91 3.375z"
              transform="translate(242.718 113.388) translate(-16.207 -136.703)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4350"
              d="M25.826 169.893a4.225 4.225 0 011.518-2.6c1.518-1.515 2.494-2.385 2.494-2.385s.758 2.491-.651 4.009a26.6 26.6 0 01-3.355 2.927z"
              transform="translate(242.718 113.388) translate(-16.603 -137.918)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4351"
              d="M27.019 176.475a4.2 4.2 0 01.808-2.9c1.088-1.853 1.809-2.938 1.809-2.938s1.364 2.22.386 4.046a26.5 26.5 0 01-2.516 3.682z"
              transform="translate(242.718 113.388) translate(-16.778 -138.783)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4352"
              d="M13.137 4.708a31.035 31.035 0 01-.414 3.354c-.6 3.1-2.1 5.1-2.7 7.9s1.118 6.4.663 10-1.862 5.592-1.462 8 2.5 8.9 2.5 8.9"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4353"
              d="M12.891 7.551l1.636-1.252"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4354"
              d="M12.968 6.106l-.685-1.217"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4355"
              d="M10.114 15.844s1.367-1.026 2.776-2.055"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4356"
              d="M10.8 13.699a21.886 21.886 0 00-2.432-3.721"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4357"
              d="M10.8 25.083a16.9 16.9 0 012.927-3.914"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4358"
              d="M10.519 26.608a19.267 19.267 0 00-1.482-2.815c-.8-1.18-.914-1.331-.914-1.331"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4359"
              d="M9.223 33.969a18.028 18.028 0 011.233-2.494 15.836 15.836 0 011.6-2.091"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4360"
              d="M10.732 39.581a4.658 4.658 0 01.411-2.4c.559-1.1 1.216-2.547 1.482-3.117"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4361"
              d="M18.571 155.414a2.7 2.7 0 01.668-1.8 37.013 37.013 0 011.306-1.763 2.908 2.908 0 01.028 2.586 16.864 16.864 0 01-1.789 2.2z"
              transform="translate(242.718 113.388) translate(-15.507 -135.947)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4362"
              d="M21.064 160.144a2.7 2.7 0 01.668-1.8c.786-1.116 1.317-1.775 1.317-1.775a2.9 2.9 0 01.025 2.584 16.937 16.937 0 01-1.789 2.2z"
              transform="translate(242.718 113.388) translate(-15.883 -136.659)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4363"
              d="M18.287 156.978s-.19-.663-1.381-1.328-1.943-1.026-1.943-1.026a2.905 2.905 0 001.1 2.343 17.039 17.039 0 002.567 1.2z"
              transform="translate(242.718 113.388) translate(-14.963 -136.365)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4364"
              d="M21.233 162.608s-.257-.64-1.513-1.174-2.038-.816-2.038-.816a2.9 2.9 0 001.336 2.211 16.83 16.83 0 002.681.931z"
              transform="translate(242.718 113.388) translate(-15.374 -137.27)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4365"
              d="M22.064 168.985s-.117-.679-1.233-1.465-1.823-1.225-1.823-1.225a2.919 2.919 0 00.839 2.444 16.971 16.971 0 002.424 1.47z"
              transform="translate(242.718 113.388) translate(-15.571 -138.127)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4366"
              d="M22.9 170.356a2.68 2.68 0 01.405-1.873c.621-1.216 1.04-1.935 1.04-1.935a2.911 2.911 0 01.4 2.556 17.031 17.031 0 01-1.459 2.432z"
              transform="translate(242.718 113.388) translate(-16.155 -138.165)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4367"
              d="M25.118 176.982s.078-.685 1.149-1.535 1.747-1.328 1.747-1.328a2.9 2.9 0 01-.7 2.488 16.854 16.854 0 01-2.337 1.608z"
              transform="translate(242.718 113.388) translate(-16.475 -139.309)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4368"
              d="M24.265 175.02s-.117-.679-1.233-1.468-1.823-1.224-1.823-1.224a2.915 2.915 0 00.839 2.443 16.844 16.844 0 002.418 1.471z"
              transform="translate(242.718 113.388) translate(-15.904 -139.038)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4369"
              d="M24.353 179.248a2.687 2.687 0 00-.822-1.73c-.881-1.043-1.454-1.647-1.454-1.647a2.909 2.909 0 00.2 2.578 16.974 16.974 0 001.974 2.038z"
              transform="translate(242.718 113.388) translate(-16.003 -139.573)"
              fill="#4cc5b1"
            />
            <path
              data-name="Path 4370"
              d="M2.947 19.307a19.847 19.847 0 00.626 2.066c.713 1.876 1.87 2.97 2.55 4.659s0 4.141.671 6.343 1.775 3.308 1.784 4.856-.6 5.849-.6 5.849"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4371"
              d="M3.412 21.064l-1.16-.61"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4372"
              d="M3.207 20.166l.3-.839"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4373"
              d="M6.048 25.962s-.97-.495-1.957-.987"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4374"
              d="M5.392 24.695a13.832 13.832 0 011.118-2.6"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4375"
              d="M6.627 31.831a10.853 10.853 0 00-2.256-2.139"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4376"
              d="M6.959 32.754a12.313 12.313 0 01.623-1.926c.375-.824.428-.933.428-.933"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4377"
              d="M8.528 38.408a10.074 10.074 0 011.247-1.3 6.834 6.834 0 00.814-.707"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4378"
              d="M8.577 37.232a11.6 11.6 0 00-1.043-1.431 10.059 10.059 0 00-1.227-1.133"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4379"
              d="M8.242 40.914a2.944 2.944 0 00-.517-1.462c-.478-.629-1.04-1.465-1.269-1.795"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
            <path
              data-name="Path 4380"
              d="M12.708 53.4H6.372a.5.5 0 01-.5-.5L4.301 42.41h10.471L13.201 52.9a.5.5 0 01-.5.5z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(242.718 113.388)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function FamilyIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 114,
    height: 114,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 114 114"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 4601" transform="translate(-70.233 -537.233)">
        <circle
          data-name="Ellipse 39410"
          cx={57}
          cy={57}
          r={57}
          transform="translate(70.233 537.233)"
          fill="rgba(255,255,255,0.5)"
          opacity={0.5}
        />
        <circle
          data-name="Ellipse 39384"
          cx={50.5}
          cy={50.5}
          r={50.5}
          transform="translate(76.233 543.233)"
          fill="rgba(255,255,255,0.5)"
        />
        <path
          data-name="Path 807"
          d="M46.287 86.494a11.9 11.9 0 01-.573-1.276c-.927-2.522-3.412-9.762-3.23-14.443v-.5H16.042c.173 4.451-2.066 11.218-3.083 14.039a14.089 14.089 0 01-.931 2 6.188 6.188 0 005.425 9.163c.152 0 .3-.007.452-.018v.018h22.861a6.187 6.187 0 005.521-8.981z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-10.819 -62.304)"
          fill="#464c55"
        />
        <path
          data-name="Path 808"
          d="M39.213 94.369H16.355a.449.449 0 01-.1-.011 6.462 6.462 0 01-.355.011 6.636 6.636 0 01-5.818-9.826 13.546 13.546 0 00.9-1.935c.976-2.708 3.228-9.479 3.057-13.87a.448.448 0 01.447-.465h26.446a.448.448 0 01.448.448v.5c-.182 4.681 2.4 12.12 3.2 14.288a11.538 11.538 0 00.552 1.228 6.56 6.56 0 01.715 3 6.642 6.642 0 01-6.634 6.632zm-22.733-.9h22.733a5.746 5.746 0 005.74-5.74 5.672 5.672 0 00-.618-2.591 12.364 12.364 0 01-.594-1.324C42.7 80.99 40.3 73.9 40.485 69.2v-.036H14.947c.015 4.542-2.158 11.079-3.119 13.744a14.38 14.38 0 01-.96 2.063 5.74 5.74 0 005.033 8.5c.125 0 .259-.005.42-.017a.447.447 0 01.159.017z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-9.267 -60.751)"
          fill="#464c55"
        />
        <path
          data-name="Path 809"
          d="M51.387 193.611H36.568a6.143 6.143 0 00-6.148 6.139v5.574h27.114v-5.574a6.143 6.143 0 00-6.147-6.139z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-25.685 -158.032)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 810"
          d="M105.544 193.611H100.2v11.713h11.5v-5.574a6.143 6.143 0 00-6.156-6.139z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-79.843 -158.032)"
          fill="#b7c1cf"
        />
        <path
          data-name="Path 811"
          d="M36.568 193.614a6.144 6.144 0 00-6.148 6.139v5.574h11.5v-11.713z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-25.685 -158.035)"
          fill="#b7c1cf"
        />
        <path
          data-name="Path 812"
          d="M49.278 72h-.075v-1.1a11.781 11.781 0 00-23.561 0V72h-.075a3.557 3.557 0 100 7.113 3.662 3.662 0 00.386-.021 11.808 11.808 0 0022.939 0 3.655 3.655 0 00.386.021 3.557 3.557 0 100-7.113z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-19.23 -53.744)"
          fill="#ffd8be"
        />
        <g data-name="Group 4586" fill="#464c55">
          <path
            data-name="Path 813"
            d="M35.873 86.991a12.149 12.149 0 01-11.813-8.98h-.042a4 4 0 01-.373-7.992v-.667a12.229 12.229 0 0124.456 0v.667a4 4 0 01-.373 7.992h-.042a12.15 12.15 0 01-11.813 8.98zM24.4 77.094a.448.448 0 01.435.345 11.36 11.36 0 0022.067 0 .448.448 0 01.483-.342 3.232 3.232 0 00.338.019 3.109 3.109 0 100-6.218h-.068a.453.453 0 01-.323-.128.448.448 0 01-.135-.32v-1.1a11.333 11.333 0 00-22.665 0v1.1a.448.448 0 01-.457.448h-.055a3.109 3.109 0 10-.008 6.217 3.179 3.179 0 00.338-.019h.047z"
            transform="translate(86.161 558.5) translate(47.823 15.052) translate(2.397 5.054) translate(-19.976 -57.246)"
          />
          <path
            data-name="Path 817"
            d="M35.873 86.991a12.149 12.149 0 01-11.813-8.98h-.042a4 4 0 01-.373-7.992v-.667a12.229 12.229 0 0124.456 0v.667a4 4 0 01-.373 7.992h-.042a12.15 12.15 0 01-11.813 8.98zM24.4 77.094a.448.448 0 01.435.345 11.36 11.36 0 0022.067 0 .448.448 0 01.483-.342 3.232 3.232 0 00.338.019 3.109 3.109 0 100-6.218h-.068a.453.453 0 01-.323-.128.448.448 0 01-.135-.32v-1.1a11.333 11.333 0 00-22.665 0v1.1a.448.448 0 01-.457.448h-.055a3.109 3.109 0 10-.008 6.217 3.179 3.179 0 00.338-.019h.047z"
            transform="translate(86.161 558.5) translate(47.823 15.052) translate(2.397 5.054) translate(-19.976 -57.246)"
          />
        </g>
        <path
          data-name="Path 818"
          d="M108.066 51.875l-.27 2.539a7.2 7.2 0 00.484 3.637 8.935 8.935 0 0010.9 4.924l.083-.025-.042-4.406c-.044-4.6-1.787-8.462-4.464-9.786a7.735 7.735 0 00-3.969-.778c-1.327.082-2.5 1.776-2.727 3.9z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-85.704 -44.987)"
          fill="#464c55"
        />
        <path
          data-name="Path 819"
          d="M114.876 62.288a9.207 9.207 0 01-4.247-1.026 9.5 9.5 0 01-4.31-4.579 7.622 7.622 0 01-.522-3.868l.27-2.539c.25-2.353 1.6-4.2 3.145-4.294a8.2 8.2 0 014.2.824c2.818 1.394 4.667 5.391 4.713 10.183l.042 4.406a.448.448 0 01-.317.432l-.083.025a9.9 9.9 0 01-2.886.436zm-5.11-15.428q-.247 0-.5.015c-1.094.068-2.108 1.6-2.31 3.5l-.27 2.539a6.716 6.716 0 00.447 3.406 8.481 8.481 0 0010.129 4.749L117.225 57c-.042-4.458-1.7-8.143-4.214-9.389a7.246 7.246 0 00-3.245-.751zm-3.253 3.464z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-84.15 -43.435)"
          fill="#464c55"
        />
        <path
          data-name="Path 820"
          d="M110.14 204.22h-11.5a.448.448 0 01-.448-.448v-11.713a.448.448 0 01.448-.448H102a.5.5 0 01.055 0h1.939a6.6 6.6 0 016.6 6.587v5.574a.448.448 0 01-.448.448zm-11.047-.9h10.6v-5.12a5.7 5.7 0 00-5.7-5.691h-4.9v10.818z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-78.291 -156.48)"
          fill="#464c55"
        />
        <path
          data-name="Path 821"
          d="M40.363 204.223h-11.5a.448.448 0 01-.448-.448V198.2a6.6 6.6 0 016.6-6.586h5.347a.448.448 0 01.448.448v11.713a.448.448 0 01-.447.448zm-11.047-.9h10.6V192.51h-4.9a5.7 5.7 0 00-5.7 5.691z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-24.133 -156.483)"
          fill="#464c55"
        />
        <path
          data-name="Path 822"
          d="M72.02 183.5a11.818 11.818 0 01-5.471-1.334v2.334a1.215 1.215 0 00.03.255 1.25 1.25 0 00.079.242c0 .01.009.021.014.03a1.364 1.364 0 00.106.179c.02.028.02.031.032.046l.777.986c.1.13.211.255.323.375l2.381 2.991a2.106 2.106 0 003.3 0l2.431-3.053a5.63 5.63 0 00.308-.361l.792-1.021.04-.05.3-.389a1.21 1.21 0 00.026-.238v-2.323a11.817 11.817 0 01-5.468 1.331z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-53.727 -149.149)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 823"
          d="M55.4 193.614h-2.132a1.119 1.119 0 00-.892 1.795l4.152 5.485a1.119 1.119 0 001.525.247l2.709-1.858z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-42.548 -158.035)"
          fill="#b7c1cf"
        />
        <path
          data-name="Path 824"
          d="M96 193.614h2.129a1.119 1.119 0 01.892 1.795l-4.152 5.485a1.119 1.119 0 01-1.525.247l-2.709-1.858z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-72.421 -158.035)"
          fill="#b7c1cf"
        />
        <path
          data-name="Path 825"
          d="M55.87 200.235a1.563 1.563 0 01-1.25-.622l-4.152-5.485a1.567 1.567 0 011.249-2.513h2.129a.448.448 0 01.325.14l5.366 5.669a.448.448 0 01-.072.677l-2.709 1.858a1.565 1.565 0 01-.886.276zm-4.153-7.724a.672.672 0 00-.535 1.077l4.152 5.485a.671.671 0 00.915.148l2.277-1.562-4.873-5.148z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-40.998 -156.483)"
          fill="#3762cc"
        />
        <path
          data-name="Path 826"
          d="M92.425 200.235a1.562 1.562 0 01-.886-.276L88.83 198.1a.448.448 0 01-.072-.677l5.366-5.669a.448.448 0 01.325-.14h2.129a1.567 1.567 0 011.249 2.513l-4.152 5.485a1.565 1.565 0 01-1.25.623zm-2.656-2.576l2.277 1.562a.67.67 0 00.915-.148l4.152-5.485a.672.672 0 00-.535-1.077h-1.936z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-70.87 -156.483)"
          fill="#464c55"
        />
        <path
          data-name="Path 827"
          d="M44.654 42.427a8.1 8.1 0 00-.115-1.4l-.009-.053a4.821 4.821 0 00-2.751-3.708 4.437 4.437 0 00-.953-.365h-.006a4.447 4.447 0 00-.884-.135l-.078-.006a15 15 0 00-9.915 2.556 13.02 13.02 0 00-5.738 9.982l-.335 4.937.158.023a24.292 24.292 0 0011.672-1.09 16.688 16.688 0 007.231-4.633 5.856 5.856 0 00.438-.6l.018-.031a6.579 6.579 0 00.67-1.415 11.386 11.386 0 00.597-4.062z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-20.603 -36.224)"
          fill="#464c55"
        />
        <path
          data-name="Path 828"
          d="M26.138 53.416a25.553 25.553 0 01-3.726-.274l-.158-.023a.448.448 0 01-.381-.473l.335-4.937a13.531 13.531 0 015.905-10.3l.007-.005a15.308 15.308 0 0110.235-2.644h.066a4.833 4.833 0 01.941.143l.042.011a4.875 4.875 0 011.027.4 5.258 5.258 0 012.977 3.99c0 .012.006.024.008.036l.01.064a8.521 8.521 0 01.12 1.465 11.873 11.873 0 01-.627 4.22 7.015 7.015 0 01-.714 1.5l-.014.025a.373.373 0 01-.025.036 6.193 6.193 0 01-.453.616 17.227 17.227 0 01-7.424 4.767 24.4 24.4 0 01-8.155 1.382zm-3.344-1.124a23.9 23.9 0 0011.2-1.1 16.347 16.347 0 007.042-4.5 5.387 5.387 0 00.4-.548l.008-.012v-.007a6.168 6.168 0 00.63-1.328 10.99 10.99 0 00.577-3.909v-.011a7.67 7.67 0 00-.108-1.324v-.025l-.005-.024a4.374 4.374 0 00-2.5-3.383 4.055 4.055 0 00-.874-.337h-.006a4.014 4.014 0 00-.8-.121l-.083-.006a14.664 14.664 0 00-9.59 2.446.47.47 0 01-.047.036 12.627 12.627 0 00-5.538 9.63z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-19.05 -34.668)"
          fill="#464c55"
        />
        <path
          data-name="Path 845"
          d="M55.87 200.235a1.563 1.563 0 01-1.25-.622l-4.152-5.485a1.567 1.567 0 011.249-2.513h2.129a.448.448 0 01.325.14l5.366 5.669a.448.448 0 01-.072.677l-2.709 1.858a1.565 1.565 0 01-.886.276zm-4.153-7.724a.672.672 0 00-.535 1.077l4.152 5.485a.671.671 0 00.915.148l2.277-1.562-4.873-5.148z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-40.998 -156.483)"
          fill="#464c55"
        />
        <path
          data-name="Path 846"
          d="M90.636 218.94l1.3 4.46a.224.224 0 00.354.113l2.077-1.648a.224.224 0 00-.012-.36z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-72.422 -177.692)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 847"
          d="M77.4 218.94l-1.3 4.46a.224.224 0 01-.354.113l-2.077-1.648a.224.224 0 01.012-.36z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-59.182 -177.692)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 848"
          d="M90.6 222.456a.673.673 0 01-.645-.484l-1.3-4.46a.448.448 0 01.684-.494l3.722 2.565a.671.671 0 01.036 1.079l-2.076 1.648a.671.671 0 01-.421.146zm-.735-3.986l.857 2.932 1.579-1.253zm2.685 1.851z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-70.87 -176.138)"
          fill="#464c55"
        />
        <path
          data-name="Path 849"
          d="M74.325 222.457a.67.67 0 01-.417-.146l-2.077-1.648a.672.672 0 01.036-1.079l3.722-2.565a.448.448 0 01.684.494l-1.3 4.46a.672.672 0 01-.645.483zm-1.7-2.307l1.575 1.25.857-2.932z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-57.629 -176.14)"
          fill="#464c55"
        />
        <path
          data-name="Path 850"
          d="M84.91 219.819l.642 1.424h1.3l.637-1.413-1.3-.89z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-67.978 -177.692)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 851"
          d="M85.3 220.138H84a.448.448 0 01-.408-.264l-.642-1.424a.448.448 0 01.155-.553l1.282-.879a.448.448 0 01.507 0l1.3.89a.448.448 0 01.155.553l-.637 1.413a.448.448 0 01-.412.264zm-1.012-.9h.723l.364-.808-.736-.5-.72.494z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-66.425 -176.139)"
          fill="#464c55"
        />
        <path
          data-name="Path 852"
          d="M55.982 195.337H28.868a.448.448 0 01-.448-.448v-5.574a6.6 6.6 0 016.6-6.587h1.492v-2.115a.448.448 0 01.654-.4 11.437 11.437 0 0010.524 0 .448.448 0 01.654.4v2.112h1.5a6.6 6.6 0 016.6 6.587v5.574a.448.448 0 01-.462.451zm-26.667-.9h26.219v-5.126a5.7 5.7 0 00-5.7-5.691h-1.967a.449.449 0 01-.44-.535.772.772 0 00.017-.149v-1.606a12.338 12.338 0 01-10.041 0v1.62a.725.725 0 00.017.142.448.448 0 01-.439.535h-1.966a5.7 5.7 0 00-5.7 5.691v5.126z"
          transform="translate(86.161 558.5) translate(47.823 15.052) translate(-24.133 -147.597)"
          fill="#464c55"
        />
        <g data-name="Group 4617">
          <g
            data-name="Group 4615"
            transform="translate(86.161 558.5) translate(47.823 15.052) translate(12.806 18.751)"
          >
            <g
              data-name="Group 4618"
              transform="translate(.266 1.966)"
              fill="#464c55"
            >
              <ellipse
                data-name="Ellipse 39387"
                cx={0.964}
                cy={1.204}
                rx={0.964}
                ry={1.204}
              />
              <ellipse
                data-name="Ellipse 39388"
                cx={0.964}
                cy={1.204}
                rx={0.964}
                ry={1.204}
                transform="translate(8.672)"
              />
            </g>
            <path
              data-name="Line 268"
              transform="translate(9.299)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.829 0"
            />
            <path
              data-name="Line 269"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.829 0"
            />
            <path
              data-name="Path 926"
              d="M3.506 8.973a4.052 4.052 0 003.943 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
        <path
          data-name="Path 853"
          d="M155.719 173.179a.734.734 0 01-.079-.008v3.763a3.466 3.466 0 012.793-1.408h.072v-1.063a11.248 11.248 0 01.075-1.288h-2.861z"
          transform="translate(86.161 558.5) translate(-103.656 -141.016)"
          fill="#4671c6"
        />
        <path
          data-name="Path 868"
          d="M29.252 173.052a.741.741 0 01-.079-.008v3.763a3.466 3.466 0 012.793-1.408h.072v-1.059a11.246 11.246 0 01.075-1.288h-2.861z"
          transform="translate(86.161 558.5) translate(-27.704 -140.939)"
          fill="#464c55"
        />
        <path
          data-name="Path 869"
          d="M95.861 173.053H93a11.243 11.243 0 01.075 1.288v1.059h.072a3.466 3.466 0 012.793 1.408v-3.763c-.026.002-.052.008-.079.008z"
          transform="translate(86.161 558.5) translate(-66.037 -140.94)"
          fill="#4671c6"
        />
        <path
          data-name="Path 870"
          d="M52.547 220.217H38.591a5.79 5.79 0 00-5.79 5.79v5.256h25.536v-5.256a5.79 5.79 0 00-5.79-5.79z"
          transform="translate(86.161 558.5) translate(-29.882 -169.27)"
          fill="#b7c1cf"
        />
        <path
          data-name="Path 4204"
          d="M40.434 83.783a9.914 9.914 0 01-.477-1.063c-.772-2.1-2.842-8.13-2.69-12.029v-.418H15.244c.144 3.707-1.72 9.343-2.568 11.693a11.735 11.735 0 01-.775 1.665 5.154 5.154 0 004.519 7.631c.127 0 .252-.006.376-.015v.015h19.04a5.153 5.153 0 004.6-7.48z"
          transform="translate(86.161 558.5) translate(-10.572 -42.193)"
          fill="#464c55"
        />
        <path
          data-name="Path 872"
          d="M53.806 160.432h-.072v-1.063a11.353 11.353 0 00-22.7 0v1.063h-.072a3.432 3.432 0 100 6.865 3.561 3.561 0 00.371-.02 11.375 11.375 0 0022.106 0 3.567 3.567 0 00.371.02 3.432 3.432 0 100-6.865z"
          transform="translate(86.161 558.5) translate(-26.695 -125.973)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 875"
          d="M41.181 175.559a12.078 12.078 0 01-11.664-8.672 4.228 4.228 0 01-.487-8.394v-.322a12.152 12.152 0 0124.3 0v.322a4.228 4.228 0 01-.487 8.394 12.078 12.078 0 01-11.662 8.672zm-11.052-10.283a.8.8 0 01.777.616 10.577 10.577 0 0020.55 0 .807.807 0 01.861-.612 2.738 2.738 0 00.288.016 2.634 2.634 0 10.012-5.267h-.084a.8.8 0 01-.8-.8v-1.063a10.554 10.554 0 00-21.107 0v1.063a.8.8 0 01-.238.57.82.82 0 01-.573.229h-.076a2.634 2.634 0 10.018 5.267 2.738 2.738 0 00.288-.016h.084z"
          transform="translate(86.161 558.5) translate(-25.494 -124.771)"
          fill="#464c55"
        />
        <path
          data-name="Path 877"
          d="M40.007 152.024H28.243a.75.75 0 01-.75-.75v-3a10.241 10.241 0 0110.241-10.241h5.46a2.812 2.812 0 012.812 2.812v5.181a6 6 0 01-6 6z"
          transform="translate(86.161 558.5) translate(-25.238 -119.426)"
          fill="#464c55"
        />
        <path
          data-name="Path 878"
          d="M84.357 152.024h-4.511a6 6 0 01-6-6v-5.181a2.812 2.812 0 012.812-2.812 8.449 8.449 0 018.449 8.449v4.794a.75.75 0 01-.75.75z"
          transform="translate(86.161 558.5) translate(-54.533 -119.912)"
          fill="#184457"
        />
        <path
          data-name="Path 879"
          d="M57.021 215.982a11.38 11.38 0 01-5.151-1.223v1.966a5.15 5.15 0 1010.3 0v-1.964a11.382 11.382 0 01-5.149 1.221z"
          transform="translate(86.161 558.5) translate(-41.335 -165.992)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 880"
          d="M57.136 227.583H31.6a.8.8 0 01-.8-.8v-5.256a6.6 6.6 0 016.589-6.589h1.028v-1.382a.8.8 0 011.16-.713 10.66 10.66 0 009.579 0 .8.8 0 011.159.713v1.38h1.031a6.6 6.6 0 016.589 6.589v5.256a.8.8 0 01-.8.8zm-24.737-1.6h23.938v-4.458a5 5 0 00-4.991-4.991h-1.835a.8.8 0 01-.8-.832v-.921a12.3 12.3 0 01-8.7 0V215.703a.8.8 0 01-.8.832h-1.822a5 5 0 00-4.991 4.991v4.458z"
          transform="translate(86.161 558.5) translate(-28.681 -164.791)"
          fill="#464c55"
        />
        <path
          data-name="Path 881"
          d="M38.807 151.62H27.043a1.551 1.551 0 01-1.549-1.549v-3a11.053 11.053 0 0111.041-11.041h5.46a3.616 3.616 0 013.612 3.611v5.181a6.807 6.807 0 01-6.8 6.8zm-11.715-1.6h11.715a5.207 5.207 0 005.2-5.2v-5.181a2.016 2.016 0 00-2.014-2.014h-5.46a9.453 9.453 0 00-9.443 9.443v2.953z"
          transform="translate(86.161 558.5) translate(-24.038 -118.224)"
          fill="#464c55"
        />
        <path
          data-name="Path 882"
          d="M83.156 151.621h-4.511a6.806 6.806 0 01-6.8-6.8v-5.181a3.615 3.615 0 013.611-3.611 9.258 9.258 0 019.248 9.248v4.794a1.551 1.551 0 01-1.548 1.55zm-7.7-13.993a2.016 2.016 0 00-2.013 2.014v5.181a5.207 5.207 0 005.2 5.2h4.463v-4.745a7.659 7.659 0 00-7.65-7.65z"
          transform="translate(86.161 558.5) translate(-53.332 -118.71)"
          fill="#464c55"
        />
        <path
          data-name="Path 883"
          d="M109.814 209.05H90.131a8.16 8.16 0 00-8.165 8.154v7.4h36.013v-7.4a8.159 8.159 0 00-8.165-8.154z"
          transform="translate(86.161 558.5) translate(-59.41 -162.563)"
          fill="#b7c1cf"
        />
        <path
          data-name="Path 885"
          d="M116.124 202.3a15.7 15.7 0 01-7.267-1.772v3.1a1.6 1.6 0 00.04.338 1.636 1.636 0 00.1.322l.018.041a1.645 1.645 0 00.141.238c.014.02.027.042.042.061l1.032 1.31a7.328 7.328 0 004.066 2.627c.216.051.441.094.673.129a7.358 7.358 0 006.868-2.82l1.5-1.938a1.613 1.613 0 00.034-.316v-3.086a15.7 15.7 0 01-7.247 1.766z"
          transform="translate(86.161 558.5) translate(-75.56 -157.448)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 886"
          d="M111.944 125.979h-.1v-1.459a15.648 15.648 0 00-31.293 0v1.463h-.1a4.724 4.724 0 100 9.448 4.91 4.91 0 00.512-.028 15.683 15.683 0 0030.467 0 4.819 4.819 0 00.512.028 4.724 4.724 0 100-9.448z"
          transform="translate(86.161 558.5) translate(-55.777 -102.498)"
          fill="#ffd8be"
        />
        <g data-name="Group 4587">
          <path
            data-name="Path 887"
            d="M95 146.952a16.342 16.342 0 01-15.846-11.927 5.52 5.52 0 01-.6-11v-.7a16.446 16.446 0 0132.891 0v.7a5.52 5.52 0 01-.6 11A16.343 16.343 0 0195 146.952zM79.765 133.4a.8.8 0 01.777.616 14.884 14.884 0 0028.911 0 .8.8 0 01.86-.611 4.115 4.115 0 00.429.024 3.925 3.925 0 10.01-7.85h-.109a.8.8 0 01-.8-.8v-1.463a14.849 14.849 0 00-29.7 0v1.463a.8.8 0 01-.237.568.818.818 0 01-.571.23h-.092a3.925 3.925 0 100 7.85 4.011 4.011 0 00.429-.024c.038-.003.066-.003.093-.003z"
            transform="translate(86.161 558.5) translate(19.247 5.74) translate(-73.68 -107.037)"
            fill="#3762cc"
          />
          <path
            data-name="Path 891"
            d="M95 146.952a16.342 16.342 0 01-15.846-11.927 5.52 5.52 0 01-.6-11v-.7a16.446 16.446 0 0132.891 0v.7a5.52 5.52 0 01-.6 11A16.343 16.343 0 0195 146.952zM79.765 133.4a.8.8 0 01.777.616 14.884 14.884 0 0028.911 0 .8.8 0 01.86-.611 4.115 4.115 0 00.429.024 3.925 3.925 0 10.01-7.85h-.109a.8.8 0 01-.8-.8v-1.463a14.849 14.849 0 00-29.7 0v1.463a.8.8 0 01-.237.568.818.818 0 01-.571.23h-.092a3.925 3.925 0 100 7.85 4.011 4.011 0 00.429-.024c.038-.003.066-.003.093-.003z"
            transform="translate(86.161 558.5) translate(19.247 5.74) translate(-73.68 -107.037)"
            fill="#464c55"
          />
        </g>
        <path
          data-name="Path 892"
          d="M101.146 97.908a17.857 17.857 0 00-6.6-2.321c-3.2-1.077-7.316-1.372-12.557 0a21.629 21.629 0 01-9.589 1.171.526.526 0 00-.556.661 19.264 19.264 0 002.033 4.679.528.528 0 01-.258.761 26.46 26.46 0 01-3.956 1.23.526.526 0 00-.325.8c1.744 2.679 9.436 12.593 25.852 8.987.292-.064.584-.145.869-.234a10.332 10.332 0 006.227-5.431l1.2-2.518a6.027 6.027 0 00-2.34-7.785z"
          transform="translate(86.161 558.5) translate(-51.775 -93.868)"
          fill="#464c55"
        />
        <path
          data-name="Path 893"
          d="M87.085 114.264a22.934 22.934 0 01-19.615-10.139 1.325 1.325 0 01.818-2.015 25.84 25.84 0 003.543-1.077 20.056 20.056 0 01-1.956-4.6 1.326 1.326 0 011.4-1.669 21.117 21.117 0 009.2-1.106.815.815 0 01.11-.038 22.578 22.578 0 0112.944-.013 18.594 18.594 0 016.826 2.414 6.866 6.866 0 012.655 8.817l-1.2 2.518a11.157 11.157 0 01-6.71 5.85c-.334.1-.64.187-.936.252a32.908 32.908 0 01-7.077.808zm-18.06-10.686c2.2 3.2 9.6 11.655 24.794 8.318.25-.055.513-.126.8-.216a9.558 9.558 0 005.744-5.012l1.2-2.518a5.258 5.258 0 00-2.023-6.75 17.008 17.008 0 00-6.309-2.218.814.814 0 01-.145-.034 20.943 20.943 0 00-12.047.007 22.412 22.412 0 01-9.515 1.235 18.852 18.852 0 001.839 4.1 1.327 1.327 0 01-.647 1.913 27.257 27.257 0 01-3.691 1.177z"
          transform="translate(86.161 558.5) translate(-50.575 -92.667)"
          fill="#464c55"
        />
        <path
          data-name="Path 894"
          d="M156.456 116.985a2.545 2.545 0 00-2.755-.885l-.88.266a6.064 6.064 0 01-.377 1.672c-.059.155-.122.31-.195.462l-1.2 2.518a9.696 9.696 0 01-.282.546l-.016.028q-.144.261-.3.511a9.038 9.038 0 003.684 6.174l2.617 1.881c.033 0 .066-.005.1-.005a4.792 4.792 0 012.282.574l.332-2.431a15.2 15.2 0 00-3.01-11.311z"
          transform="translate(86.161 558.5) translate(-100.539 -106.675)"
          fill="#464c55"
        />
        <path
          data-name="Path 895"
          d="M157.929 130.331a.8.8 0 01-.379-.1 4.022 4.022 0 00-1.9-.478c-.03 0-.065.005-.1.005a.8.8 0 01-.466-.15l-2.617-1.881a9.877 9.877 0 01-4.011-6.72.8.8 0 01.117-.53 10.596 10.596 0 00.556-1.002l1.2-2.518c.063-.132.117-.265.168-.4a5.307 5.307 0 00.327-1.454.8.8 0 01.565-.7l.881-.266a3.36 3.36 0 013.62 1.163 16.1 16.1 0 013.165 11.908l-.332 2.431a.8.8 0 01-.791.691zm-2.128-2.17a5.644 5.644 0 011.476.24l.192-1.407a14.5 14.5 0 00-2.849-10.719 1.755 1.755 0 00-1.89-.607l-.382.116a6.912 6.912 0 01-.359 1.34c-.065.175-.138.35-.22.524l-1.2 2.518c-.095.2-.2.395-.3.588l-.021.036a5.9 5.9 0 01-.167.29 8.269 8.269 0 003.318 5.355z"
          transform="translate(86.161 558.5) translate(-99.337 -105.477)"
          fill="#464c55"
        />
        <path
          data-name="Path 896"
          d="M79.927 140.862a4.782 4.782 0 012.77-.881.67.67 0 01.1.005v-1.463a15.361 15.361 0 01.5-3.912 22.035 22.035 0 01-3.421-2.26 15.187 15.187 0 00-.326 5.774z"
          transform="translate(86.161 558.5) translate(-57.877 -116.5)"
          fill="#464c55"
        />
        <path
          data-name="Path 897"
          d="M78.724 140.46a.8.8 0 01-.792-.691l-.374-2.738a15.927 15.927 0 01.343-6.078.8.8 0 011.275-.427 21.313 21.313 0 003.3 2.178.8.8 0 01.4.908 14.583 14.583 0 00-.479 3.709v1.464a.8.8 0 01-.241.572.77.77 0 01-.577.227h-.083a3.97 3.97 0 00-2.3.734.8.8 0 01-.461.147zm.476-7.911a14.293 14.293 0 00-.058 4.267l.217 1.589a5.534 5.534 0 011.435-.379v-.7a16.2 16.2 0 01.384-3.508 23.161 23.161 0 01-1.978-1.27z"
          transform="translate(86.161 558.5) translate(-56.674 -115.299)"
          fill="#464c55"
        />
        <path
          data-name="Path 898"
          d="M116.777 219.089H80.765a.8.8 0 01-.8-.8v-7.4a8.968 8.968 0 018.964-8.953h1.777v-2.6a.8.8 0 011.168-.709 14.992 14.992 0 006.9 1.682 14.793 14.793 0 006.89-1.678.8.8 0 011.167.709v2.6h1.781a8.968 8.968 0 018.964 8.953v7.4a.8.8 0 01-.799.796zm-35.214-1.6h34.415v-6.6a7.369 7.369 0 00-7.366-7.355H106a.8.8 0 01-.785-.954.852.852 0 00.019-.158v-1.828a16.593 16.593 0 01-12.928 0v1.84a.763.763 0 00.019.147.8.8 0 01-.783.956H88.93a7.369 7.369 0 00-7.366 7.355v6.6z"
          transform="translate(86.161 558.5) translate(-58.209 -156.247)"
          fill="#464c55"
        />
        <path
          data-name="Path 899"
          d="M10.535 50.788S9.598 55.961 15.4 55.8c0-.046 5.55.78 5.55-4.679"
          fill="none"
          stroke="#464c55"
          strokeWidth={3}
          transform="translate(86.161 558.5)"
        />
        <path
          data-name="Path 901"
          d="M33.297 46.486s1.919 4.636 6.735 4.957 7.265-3.875 7.89-4.957"
          fill="none"
          stroke="#464c55"
          strokeWidth={3}
          transform="translate(86.161 558.5)"
        />
        <g data-name="Group 4616">
          <g
            data-name="Group 4615"
            transform="translate(86.161 558.5) translate(31.702 22.572)"
          >
            <ellipse
              data-name="Ellipse 39387"
              cx={2}
              cy={2.5}
              rx={2}
              ry={2.5}
              transform="translate(.37 2.16)"
              fill="#464c55"
            />
            <ellipse
              data-name="Ellipse 39388"
              cx={1.5}
              cy={2.5}
              rx={1.5}
              ry={2.5}
              transform="translate(13.37 2.16)"
              fill="#464c55"
            />
            <path
              data-name="Line 268"
              transform="translate(13.685)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L2.913 0"
            />
            <path
              data-name="Line 269"
              transform="translate(.821)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L2.913 0"
            />
            <path
              data-name="Path 926"
              d="M5.432 13.801a6.451 6.451 0 006.278 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
        <g data-name="Group 4619">
          <g
            data-name="Group 4615"
            transform="translate(86.161 558.5) translate(9.633 34.472)"
          >
            <g
              data-name="Group 4620"
              transform="translate(.076 1.78)"
              fill="#464c55"
            >
              <ellipse
                data-name="Ellipse 39387"
                cx={0.971}
                cy={1.214}
                rx={0.971}
                ry={1.214}
              />
              <ellipse
                data-name="Ellipse 39389"
                cx={0.971}
                cy={1.214}
                rx={0.971}
                ry={1.214}
                transform="translate(9.708)"
              />
            </g>
            <path
              data-name="Line 269"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.91 0"
            />
            <path
              data-name="Line 270"
              transform="translate(9.708)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L1.91 0"
            />
            <path
              data-name="Path 926"
              d="M3.716 9.052a4.231 4.231 0 004.118 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function ForgotPasswordIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 257.436,
    height: 164.392,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 257.436 164.392"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <clipPath id="a">
          <path
            data-name="Path 4910"
            d="M1.131 7.172A10.24 10.24 0 010 4.28c0-.5 1.1-.805 1.1-.805 1.709-.9 9.747.4 13.364 1.005a41.313 41.313 0 006.129.6s.5-.4 1.1-.9S25.108.362 26.214.072a2.832 2.832 0 012.109.4s1.81 1.1 1.506 1.306-4.721 4.018-5.828 4.721-3.415.4-5.425.805c-1.731.345-8.742.772-10.349.9a5.841 5.841 0 01-3.618-.3"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="b">
          <path
            data-name="Path 4914"
            d="M9.528 1.142A2.139 2.139 0 0111.428 0h18.266s1.32 0 .926 2.509-5.811 17.826-7.12 22.457-1.586 14.391-1.586 14.391H0S1.74 16.015 9.528 1.142z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="c">
          <path
            data-name="Path 4933"
            d="M132.608 242.18a.441.441 0 000 .058.441.441 0 010-.058zm1.131 2.892a13.178 13.178 0 01-1.1-2.662 13.012 13.012 0 001.1 2.662zm-1.126-2.818v.06a.148.148 0 000-.06zm.014.077a.511.511 0 00.016.079.513.513 0 01-.016-.079zm1.112 2.739a25.087 25.087 0 003.79 5.346c3.618 3.919 14.068 14.17 15.062 14.873s.7 2.711 0 4.721-3.316 4.929-3.215 8.139 1.1 8.139 1.005 9.144-2.6 4.423-2.6 4.423H173.7s-3.232-4.108-3.232-5.513 4.437-19.406 4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413 1.608-4.823 1.608-4.823l-6.025.3a11.911 11.911 0 01-.7 3.117c-.4.5-1.005-.5-2.413-1.2s-4.108-1.306-5.124-2.111-10.65-9.859-10.65-9.859"
            transform="translate(-132.607 -242.18)"
            fill="#e5e0ff"
          />
        </clipPath>
        <clipPath id="d">
          <path
            data-name="Path 4939"
            d="M8.243 4.823C7.943 3.823 9.851 0 9.851 0L3.826.3a11.911 11.911 0 01-.7 3.117c-.4.5-1.005-.5-2.413-1.205a5.89 5.89 0 00-.345-.159L.004 7.779s.529 5.546 6.866 4.491c2.566-.427 5.3-2.717 7.668-5.291-2.436-.445-6.065-1.387-6.295-2.156z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="e">
          <path
            data-name="Path 4943"
            d="M21.063 11.68c-.4.5-1.005-.5-2.413-1.2-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.861 5.861 0 01-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2S5.989 1.242 5.989 1.242 4.907.42 4.461.012A8.553 8.553 0 010 3.964c4.3 4.489 13.014 13.017 13.929 13.657 1.005.7.7 2.711 0 4.721s-3.316 4.929-3.215 8.139 1.1 8.139 1.005 9.144c-.09.9-2.1 3.7-2.53 4.305l1.021.115h5.318c-.03-2.695-.027-13.693 1.816-18.075 2.111-5.047 3.719-14.29 3.719-14.29z"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="f">
          <path
            data-name="Path 4947"
            d="M4.798.109a2.366 2.366 0 00-2.018.29C2.01 1.073.863 4.529.187 8.278a10.478 10.478 0 00.822 6.449s1.58-4.143 2.059-6.162S4.798.109 4.798.109z"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="g">
          <path
            data-name="Path 4952"
            d="M.535 30.95h11.716s-3.232-4.108-3.232-5.513 4.437-19.406 4.636-20.712-.6-2.21-2.21-2.311S3.708 1.006 3.407.001A134.064 134.064 0 00.293 13.667c-.689 4.739.025 14.576.242 17.283z"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="h">
          <path
            data-name="Path 4956"
            d="M3.114 0S.014 9.859 0 13.666c0 0 4.4-5.332 4.979-9.078S3.114 0 3.114 0z"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="i">
          <path
            data-name="Path 4961"
            d="M1.83 2.73s2.27.093 3.757.307a27.16 27.16 0 002.991.238 5.973 5.973 0 00-1.7-2.128 7.029 7.029 0 00-3.8-1.12C1.747.213-.156 1.555.003 1.982s.874.619 1.827.748z"
            fill="#e5e0ff"
            stroke="#263238"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="j">
          <path
            data-name="Path 4966"
            d="M385 411.37a10.625 10.625 0 012.248-.92c.449.014 3.434 2.032 3.286 2.355a.86.86 0 01-.942.351 178.796 178.796 0 00-2.341-1.011l-1.315.309z"
            transform="translate(-385 -410.449)"
            fill="#e5e0ff"
          />
        </clipPath>
        <clipPath id="k">
          <path
            data-name="Path 4971"
            d="M380.31 408.169a12.788 12.788 0 012.876.164c.477.241 2.629 3.933 2.306 4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342z"
            transform="translate(-380.31 -408.158)"
            fill="#e5e0ff"
          />
        </clipPath>
        <clipPath id="l">
          <path
            data-name="Path 4980"
            d="M1.2 10.47c1.758 2.708 5.288 9.571 6.318 10.344 1.608 1.2 12.354 4.13 13.389 4.929s.964 1.6 1.944 1.9a52.164 52.164 0 006.058 1.265c1.4.131.775-.737.775-.737l-2.391-1.643 2.084-.515a22.748 22.748 0 002.481 2.651c.392.137 1.082 0 1.038-.309-.077-.5-2.306-4.552-3.1-4.724a43.154 43.154 0 00-5.595.493s-10.075-6.794-10.256-7.035a14.01 14.01 0 00-1.1-2.413c-.493-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077a33.181 33.181 0 01-.849-1.884c-.841-1.98-3.818-7.537-4.319-8.339C4.732.614 1.588.184-.006.003"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="m">
          <path
            data-name="Path 4995"
            d="M9.816 0L1.567 3.442a12.163 12.163 0 01-1.06 4.193c-.975 2.062-.405 5.965.531 8.071s5.064 1.282 6.573 1.019a16.265 16.265 0 002.993-.874 2.782 2.782 0 002.673-.372S8.863 3.086 9.816 0z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="n">
          <path
            data-name="Path 5013"
            d="M4.283 12.812a9.428 9.428 0 01-3.358-.8 1.162 1.162 0 11.917-2.132 5.8 5.8 0 002.814.576c.677-.757 1.716-5.33.373-7.537-.3-.49-.586-.581-.773-.6a3.645 3.645 0 00-2.292 1.066 1.167 1.167 0 11-1.6-1.7C.572 1.485 2.496-.25 4.548.027a3.347 3.347 0 012.441 1.684c1.978 3.225.624 9.36-.9 10.575a2.867 2.867 0 01-1.806.526z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
        </clipPath>
        <clipPath id="o">
          <path
            data-name="Rectangle 44653"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
            d="M0 0H12.819V17.014H0z"
          />
        </clipPath>
      </defs>
      <g data-name="Group 102582" transform="translate(-60 -47)">
        <circle
          data-name="Ellipse 39441"
          cx={18}
          cy={18}
          r={18}
          transform="translate(281 111)"
          fill="rgba(90,197,179,0.1)"
        />
        <g data-name="Group 5475" transform="translate(-2275.949 -1938)">
          <g data-name="Forgot password-bro">
            <path
              data-name="Path 4907"
              d="M133.741 233.723a10.24 10.24 0 01-1.131-2.892c0-.5 1.1-.805 1.1-.805 1.709-.9 9.747.4 13.364 1.005a41.313 41.313 0 006.129.6s.5-.4 1.1-.9 3.415-3.818 4.521-4.108a2.832 2.832 0 012.109.4s1.81 1.1 1.506 1.306-4.721 4.018-5.828 4.721-3.415.4-5.425.805c-1.731.345-8.742.772-10.349.9a5.841 5.841 0 01-3.618-.3"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-132.609 -224.354)"
              fill="#fff"
            />
            <g
              data-name="Group 5454"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(.001 2.196)"
              clipPath="url(#a)"
            >
              <path
                data-name="Path 4908"
                d="M160.994 226.974a2.782 2.782 0 00-2.109-.4c-1.1.3-3.919 3.618-4.521 4.108s-1.1.9-1.1.9a41.306 41.306 0 01-6.129-.6c-3.618-.6-11.656-1.917-13.364-1.005 0 0-1.1.3-1.1.805a3.455 3.455 0 00.216.822l.151.055a55.9 55.9 0 016.34-.107c4.332.1 14.353.7 15 .931a15.74 15.74 0 004.368-1.1c1.643-1.339 3.574-3.012 3.768-3.13.286-.176-1.52-1.279-1.52-1.279z"
                transform="translate(-132.661 -226.511)"
                fill="#92e3a9"
              />
              <path
                data-name="Path 4909"
                d="M160.994 226.974a2.782 2.782 0 00-2.109-.4c-1.1.3-3.919 3.618-4.521 4.108s-1.1.9-1.1.9a41.306 41.306 0 01-6.129-.6c-3.618-.6-11.656-1.917-13.364-1.005 0 0-1.1.3-1.1.805a3.455 3.455 0 00.216.822l.151.055a55.9 55.9 0 016.34-.107c4.332.1 14.353.7 15 .931a15.74 15.74 0 004.368-1.1c1.643-1.339 3.574-3.012 3.768-3.13.286-.176-1.52-1.279-1.52-1.279z"
                transform="translate(-132.661 -226.511)"
                fill="#e5e0ff"
              />
            </g>
            <path
              data-name="Path 4911"
              d="M1.132 9.369A10.24 10.24 0 01.001 6.477c0-.5 1.1-.805 1.1-.805 1.709-.9 9.747.4 13.364 1.005a41.313 41.313 0 006.129.6s.5-.4 1.1-.9 3.415-3.818 4.521-4.108a2.832 2.832 0 012.109.4s1.81 1.1 1.506 1.306-4.721 4.018-5.828 4.721-3.415.4-5.425.805c-1.731.345-8.742.772-10.349.9a5.841 5.841 0 01-3.618-.3"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4912"
              d="M256.388 282.332a2.139 2.139 0 011.9-1.142h18.266s1.32 0 .926 2.509-5.811 17.826-7.12 22.457-1.586 14.391-1.586 14.391H246.86s1.74-23.342 9.528-38.215z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-215.571 -264.03)"
              fill="#fff"
            />
            <g
              data-name="Group 5455"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(31.289 17.16)"
              clipPath="url(#b)"
            >
              <path
                data-name="Path 4913"
                d="M264.564 281.19h-6.332a2.139 2.139 0 00-1.9 1.142c-7.791 14.873-9.547 38.206-9.547 38.206h9.826l2.424-9.2 10.105 2.084c.071-.772.153-1.558.249-2.333l-.222-2.465s-2.07-2.177-2.722-2.722-.219-1.528-.329-5.776-3.922-7.3-5.34-9.916.764-4.25 2.725-6.866a5.045 5.045 0 001.063-2.154z"
                transform="translate(-246.809 -281.19)"
                opacity={0.16}
              />
            </g>
            <path
              data-name="Path 4915"
              d="M40.817 18.302a2.139 2.139 0 011.9-1.142h18.266s1.32 0 .926 2.509-5.811 17.826-7.12 22.457-1.586 14.391-1.586 14.391H31.289s1.74-23.342 9.528-38.215z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4916"
              d="M57.81 21.517c-1.846 4.308-5.751 21.361-6.386 34.991h1.764s.274-9.771 1.586-14.391 6.734-19.94 7.12-22.457-.926-2.509-.926-2.509-1.676.913-3.158 4.366z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4917"
              d="M25.722 12.907a10.266 10.266 0 01-4.018-4.721c-1.1-3.012 8.64-7.838 12.871-8.139s5.425.8 7.942 5.124 4.22 10.248 2.914 13.162-3.516 3.618-1.917 6.025 6.129 9.243 5.828 12.458-3.415 6.025-7.942 6.332-10.552-2.413-15.574-6.847-3.719-10.954-1.917-13.063 4.521-2.914 4.721-5.023-2.908-5.308-2.908-5.308z"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4926"
              d="M132.608 242.18a.441.441 0 000 .058.441.441 0 010-.058zm1.131 2.892a13.178 13.178 0 01-1.1-2.662 13.012 13.012 0 001.1 2.662zm-1.126-2.818v.06a.148.148 0 000-.06zm.014.077a.511.511 0 00.016.079.513.513 0 01-.016-.079zm1.112 2.739a25.087 25.087 0 003.79 5.346c3.618 3.919 14.068 14.17 15.062 14.873s.7 2.711 0 4.721-3.316 4.929-3.215 8.139 1.1 8.139 1.005 9.144-2.6 4.423-2.6 4.423H173.7s-3.232-4.108-3.232-5.513 4.437-19.406 4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413 1.608-4.823 1.608-4.823l-6.025.3a11.911 11.911 0 01-.7 3.117c-.4.5-1.005-.5-2.413-1.2s-4.108-1.306-5.124-2.111-10.65-9.859-10.65-9.859"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-132.607 -235.703)"
              fill="#fff"
            />
            <g
              data-name="Group 5457"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(0 6.477)"
              clipPath="url(#c)"
            >
              <path
                data-name="Path 4927"
                d="M209.77 295.64c.5.876 1 1.668 1 1.668a10.2 10.2 0 002.111.95 19.863 19.863 0 012.958 1.369s2.114-.529 1.369-2.325a5.675 5.675 0 00-.882-1.265 6.793 6.793 0 01-.567 2.139c-.4.5-1.005-.5-2.413-1.2-.909-.46-2.385-.876-3.576-1.336z"
                transform="translate(-188.638 -280.999)"
                fill="#92e3a9"
              />
              <path
                data-name="Path 4928"
                d="M165.508 262.535c-3.1-2.873-7.03-6.556-7.03-6.556l-2.284-.329-.274.153s6.447 5.7 7.819 6.34a4.286 4.286 0 001.769.392z"
                transform="translate(-149.535 -251.961)"
                fill="#92e3a9"
              />
              <path
                data-name="Path 4929"
                d="M202.146 291.069l-.246-.219c.126.208.2.34.2.34z"
                transform="translate(-182.923 -277.521)"
                fill="#92e3a9"
              />
              <g data-name="Group 5456" fill="#e5e0ff">
                <path
                  data-name="Path 4930"
                  d="M209.77 295.64c.5.876 1 1.668 1 1.668a10.2 10.2 0 002.111.95 19.863 19.863 0 012.958 1.369s2.114-.529 1.369-2.325a5.675 5.675 0 00-.882-1.265 6.793 6.793 0 01-.567 2.139c-.4.5-1.005-.5-2.413-1.2-.909-.46-2.385-.876-3.576-1.336z"
                  transform="translate(6.385 3.689) translate(-195.023 -284.688)"
                />
                <path
                  data-name="Path 4931"
                  d="M165.508 262.535c-3.1-2.873-7.03-6.556-7.03-6.556l-2.284-.329-.274.153s6.447 5.7 7.819 6.34a4.286 4.286 0 001.769.392z"
                  transform="translate(6.385 3.689) translate(-155.92 -255.65)"
                />
                <path
                  data-name="Path 4932"
                  d="M202.146 291.069l-.246-.219c.126.208.2.34.2.34z"
                  transform="translate(6.385 3.689) translate(-189.308 -281.21)"
                />
              </g>
            </g>
            <path
              data-name="Path 4934"
              d="M.001 6.477a.441.441 0 000 .058.441.441 0 010-.058zm1.131 2.892a13.178 13.178 0 01-1.1-2.662 13.012 13.012 0 001.1 2.662zM.006 6.551v.06a.148.148 0 000-.06zm.014.077a.511.511 0 00.016.079.513.513 0 01-.016-.079zm1.112 2.739a25.087 25.087 0 003.79 5.346c3.618 3.919 14.068 14.17 15.062 14.873s.7 2.711 0 4.721-3.316 4.929-3.215 8.139 1.1 8.139 1.005 9.144-2.6 4.423-2.6 4.423h25.919s-3.232-4.108-3.232-5.513 4.437-19.406 4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413 1.608-4.823 1.608-4.823l-6.025.3a11.911 11.911 0 01-.7 3.117c-.4.5-1.005-.5-2.413-1.2s-4.108-1.306-5.124-2.111-10.65-9.859-10.65-9.859"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4935"
              d="M8.942 10.498s-3.21.06-5-1.416"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4936"
              d="M228.523 297.263c-.3-1 1.608-4.823 1.608-4.823l-6.025.3a11.911 11.911 0 01-.7 3.117c-.4.5-1.005-.5-2.413-1.205a5.89 5.89 0 00-.345-.159l-.364 5.726s.529 5.546 6.866 4.491c2.566-.427 5.3-2.717 7.668-5.291-2.436-.445-6.065-1.387-6.295-2.156z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-196.27 -272.199)"
              fill="#fff"
            />
            <g
              data-name="Group 5458"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(24.01 20.241)"
              clipPath="url(#d)"
            >
              <path
                data-name="Path 4937"
                d="M246.667 294.244s-.364 2.043-.657 4.3-.509 3.941-.509 3.941l1.336-4.179 1.506-4.428s-1.457.002-1.676.366z"
                transform="translate(-238.593 -293.486)"
                fill="#92e3a9"
              />
              <path
                data-name="Path 4938"
                d="M246.667 294.244s-.364 2.043-.657 4.3-.509 3.941-.509 3.941l1.336-4.179 1.506-4.428s-1.457.002-1.676.366z"
                transform="translate(-238.593 -293.486)"
                fill="#e5e0ff"
              />
            </g>
            <path
              data-name="Path 4940"
              d="M32.253 25.064c-.3-1 1.608-4.823 1.608-4.823l-6.025.3a11.911 11.911 0 01-.7 3.117c-.4.5-1.005-.5-2.413-1.205a5.89 5.89 0 00-.345-.159l-.364 5.726s.529 5.546 6.866 4.491c2.566-.427 5.3-2.717 7.668-5.291-2.436-.445-6.065-1.387-6.295-2.156z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4941"
              d="M175.823 273.95c-.4.5-1.005-.5-2.413-1.2-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.861 5.861 0 01-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a8.553 8.553 0 01-4.461 3.952c4.3 4.489 13.014 13.017 13.929 13.657 1.005.7.7 2.711 0 4.721s-3.316 4.929-3.215 8.139 1.1 8.139 1.005 9.144c-.09.9-2.1 3.7-2.53 4.305l1.021.115h5.318c-.03-2.695-.027-13.693 1.816-18.075 2.111-5.047 3.719-14.29 3.719-14.29z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-148.693 -250.291)"
              fill="#38c5ae"
            />
            <g
              data-name="Group 5459"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(6.067 11.979)"
              clipPath="url(#e)"
            >
              <path
                data-name="Path 4942"
                d="M183.14 272.745c-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.86 5.86 0 01-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a7.432 7.432 0 01-.791 1.23 36.9 36.9 0 004.472 3.451c1.369.633 1.69.1 2.739.739a9.461 9.461 0 012.218 2.739s.635-1.692 1.164-.529a36.071 36.071 0 001.8 3.169 10.2 10.2 0 002.111.95 15.258 15.258 0 012.645 1.208c.153-.8.238-1.284.238-1.284-.397.501-.999-.504-2.407-1.205z"
                transform="translate(-164.49 -262.27)"
                opacity={0.16}
              />
            </g>
            <path
              data-name="Path 4944"
              d="M27.13 23.659c-.4.5-1.005-.5-2.413-1.2-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.861 5.861 0 01-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a8.553 8.553 0 01-4.461 3.952c4.3 4.489 13.014 13.017 13.929 13.657 1.005.7.7 2.711 0 4.721s-3.316 4.929-3.215 8.139 1.1 8.139 1.005 9.144c-.09.9-2.1 3.7-2.53 4.305l1.021.115h5.318c-.03-2.695-.027-13.693 1.816-18.075 2.111-5.047 3.719-14.29 3.719-14.29z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4945"
              d="M219.208 303.352a2.366 2.366 0 00-2.018.29c-.77.674-1.917 4.13-2.593 7.879a10.478 10.478 0 00.822 6.449s1.58-4.143 2.059-6.162 1.73-8.456 1.73-8.456z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-192.008 -280.044)"
              fill="#38c5ae"
            />
            <g
              data-name="Group 5460"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(22.403 23.199)"
              clipPath="url(#f)"
            >
              <path
                data-name="Path 4946"
                d="M223.18 303.664a3.444 3.444 0 011.276-.093 3.643 3.643 0 01.871.529l.249-1.046a2.021 2.021 0 00-1.213-.2 2.567 2.567 0 00-1.183.81z"
                transform="translate(-220.778 -302.944)"
                opacity={0.16}
              />
            </g>
            <path
              data-name="Path 4948"
              d="M27.2 23.308a2.366 2.366 0 00-2.018.29c-.77.674-1.917 4.13-2.593 7.879a10.478 10.478 0 00.822 6.449s1.58-4.143 2.059-6.162 1.73-8.456 1.73-8.456z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4949"
              d="M18.79 23.637l1.608 6.532-3.618-8.24"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4950"
              d="M238.473 341h11.716s-3.232-4.108-3.232-5.513 4.437-19.406 4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413a134.064 134.064 0 00-3.114 13.666c-.689 4.739.025 14.576.242 17.283z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-209.092 -284.986)"
              fill="#6552cc"
            />
            <g
              data-name="Group 5461"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(28.846 25.064)"
              clipPath="url(#g)"
            >
              <path
                data-name="Path 4951"
                d="M260.2 313.966a28.581 28.581 0 01-7.364-1.846l.616 1.424a12.354 12.354 0 003.56 1.238c2.04.364 3.938.293 5.179 2.117l.06.09c.077-.351.129-.6.145-.712.221-1.306-.584-2.21-2.196-2.311z"
                transform="translate(-248.759 -311.553)"
                opacity={0.16}
              />
            </g>
            <path
              data-name="Path 4953"
              d="M29.381 56.014h11.716s-3.232-4.108-3.232-5.513 4.437-19.406 4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413a134.064 134.064 0 00-3.114 13.666c-.689 4.739.025 14.576.242 17.283z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4954"
              d="M242.124 310.05s-3.1 9.859-3.114 13.666c0 0 4.4-5.332 4.979-9.078s-1.865-4.588-1.865-4.588z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-209.87 -284.986)"
              fill="#38c5ae"
            />
            <g
              data-name="Group 5462"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(29.14 25.064)"
              clipPath="url(#h)"
            >
              <path
                data-name="Path 4955"
                d="M248.43 311.31a2.87 2.87 0 012.407 1.167 4.759 4.759 0 00-1.873-2.426z"
                transform="translate(-245.85 -310.05)"
                opacity={0.16}
              />
            </g>
            <path
              data-name="Path 4957"
              d="M32.254 25.064s-3.1 9.859-3.114 13.666c0 0 4.4-5.332 4.979-9.078s-1.865-4.588-1.865-4.588z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4958"
              d="M366.376 409.053s2.27.093 3.757.307a27.16 27.16 0 002.991.238 5.973 5.973 0 00-1.7-2.128 7.029 7.029 0 00-3.8-1.12c-1.331.186-3.234 1.528-3.075 1.955s.874.619 1.827.748z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-301.027 -354.894)"
              fill="#fff"
            />
            <g
              data-name="Group 5463"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(63.519 51.429)"
              clipPath="url(#i)"
              fill="#e5e0ff"
            >
              <path
                data-name="Path 4959"
                d="M366.376 409.053s2.27.093 3.757.307a27.16 27.16 0 002.991.238 5.973 5.973 0 00-1.7-2.128 7.029 7.029 0 00-3.8-1.12c-1.331.186-3.234 1.528-3.075 1.955s.874.619 1.827.748z"
                transform="translate(-364.546 -406.323)"
              />
              <path
                data-name="Path 4960"
                d="M366.376 409.053s2.27.093 3.757.307a27.16 27.16 0 002.991.238 5.973 5.973 0 00-1.7-2.128 7.029 7.029 0 00-3.8-1.12c-1.331.186-3.234 1.528-3.075 1.955s.874.619 1.827.748z"
                transform="translate(-364.546 -406.323)"
                opacity={0.5}
              />
            </g>
            <path
              data-name="Path 4962"
              d="M65.349 54.159s2.27.093 3.757.307a27.16 27.16 0 002.991.238 5.973 5.973 0 00-1.7-2.128 7.029 7.029 0 00-3.8-1.12c-1.331.186-3.234 1.528-3.075 1.955s.874.619 1.827.748z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4963"
              d="M385 411.37a10.625 10.625 0 012.248-.92c.449.014 3.434 2.032 3.286 2.355a.86.86 0 01-.942.351 178.796 178.796 0 00-2.341-1.011l-1.315.309z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-315.879 -357.89)"
              fill="#fff"
            />
            <g
              data-name="Group 5464"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(69.121 52.559)"
              clipPath="url(#j)"
              fill="#e5e0ff"
            >
              <path
                data-name="Path 4964"
                d="M385 411.37a10.625 10.625 0 012.248-.92c.449.014 3.434 2.032 3.286 2.355s-.854.586-.942.351a11.946 11.946 0 00-2.341-1.011l-1.315.309z"
                transform="translate(-385 -410.449)"
              />
              <path
                data-name="Path 4965"
                d="M385 411.37a10.625 10.625 0 012.248-.92c.449.014 3.434 2.032 3.286 2.355s-.854.586-.942.351a11.946 11.946 0 00-2.341-1.011l-1.315.309z"
                transform="translate(-385 -410.449)"
                opacity={0.5}
              />
            </g>
            <path
              data-name="Path 4968"
              d="M380.31 408.169a12.788 12.788 0 012.876.164c.477.241 2.629 3.933 2.306 4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-312.474 -356.226)"
              fill="#fff"
            />
            <g
              data-name="Group 5465"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(67.836 51.931)"
              clipPath="url(#k)"
              fill="#e5e0ff"
            >
              <path
                data-name="Path 4969"
                d="M380.31 408.169a12.788 12.788 0 012.876.164c.477.241 2.629 3.933 2.306 4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342z"
                transform="translate(-380.31 -408.158)"
              />
              <path
                data-name="Path 4970"
                d="M380.31 408.169a12.788 12.788 0 012.876.164c.477.241 2.629 3.933 2.306 4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342z"
                transform="translate(-380.31 -408.158)"
                opacity={0.5}
              />
            </g>
            <path
              data-name="Path 4973"
              d="M375.12 406.358a12.8 12.8 0 012.911.167c.482.246 2.662 3.979 2.333 4.253s-1.227.189-1.2-.112-2.007-2.3-2.007-2.3l-1.583-.348z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-308.705 -354.91)"
              fill="#fff"
            />
            <g data-name="Group 5474">
              <path
                data-name="Path 4974"
                d="M378.113 406.553c.482.246 2.662 3.979 2.333 4.253s-1.227.189-1.2-.112-2.007-2.3-2.007-2.3l-1.583-.348s1.975-1.74 2.457-1.493z"
                transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(66.869 51.59) translate(-375.656 -406.529)"
                fill="#e5e0ff"
              />
            </g>
            <path
              data-name="Path 4977"
              d="M66.415 51.448a12.8 12.8 0 012.911.167c.482.246 2.662 3.979 2.333 4.253s-1.227.189-1.2-.112-2.007-2.3-2.007-2.3l-1.583-.348z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4978"
              d="M271.1 327.8c1.758 2.708 5.288 9.571 6.318 10.344 1.608 1.2 12.354 4.13 13.389 4.929s.964 1.6 1.944 1.9a52.164 52.164 0 006.058 1.265c1.4.131.775-.737.775-.737l-2.391-1.643 2.084-.515a22.748 22.748 0 002.481 2.651c.392.137 1.082 0 1.038-.309-.077-.5-2.306-4.552-3.1-4.724a43.154 43.154 0 00-5.595.493s-10.075-6.794-10.256-7.035a14.01 14.01 0 00-1.1-2.413c-.493-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077a33.181 33.181 0 01-.849-1.884c-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.211"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-232.301 -290.273)"
              fill="#6552cc"
            />
            <g
              data-name="Group 5467"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(37.599 27.057)"
              clipPath="url(#l)"
            >
              <path
                data-name="Path 4979"
                d="M278.075 328.019c1.315 1.167.876 1.167.583 2.191s.219-.364 1.46-.29.876 1.676.728 1.969 1.534.657 1.241 1.312-1.969 1.6-2.917 2.555 2.478-1.534 3.645-1.6c.356-.025.649.022.9.016a11.5 11.5 0 00-.991-2.1c-.5-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077a33.181 33.181 0 01-.849-1.884c-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.21l.145 1.268.036.027s1.969.364 2.626.438 1.46.655 1.386 1.1-1.969 2.407-1.386 2.555 1.241-1.46 1.9-1.241 2.172 5.305 3.495 6.472z"
                transform="translate(-269.878 -317.374)"
                opacity={0.16}
              />
            </g>
            <path
              data-name="Path 4981"
              d="M38.799 37.527c1.758 2.708 5.288 9.571 6.318 10.344 1.608 1.2 12.354 4.13 13.389 4.929s.964 1.6 1.944 1.9a52.164 52.164 0 006.058 1.265c1.4.131.775-.737.775-.737l-2.391-1.643 2.084-.515a22.748 22.748 0 002.481 2.651c.392.137 1.082 0 1.038-.309-.077-.5-2.306-4.552-3.1-4.724a43.154 43.154 0 00-5.595.493s-10.075-6.794-10.256-7.035a14.01 14.01 0 00-1.1-2.413c-.493-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077a33.181 33.181 0 01-.849-1.884c-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.211"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4982"
              d="M38.823 33.813a7.65 7.65 0 00-.186.745"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4983"
              d="M41.485 29.281a14.66 14.66 0 00-2.158 3.245"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4984"
              d="M45.508 44.831a7.124 7.124 0 013.22-2.881"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4985"
              d="M44.69 46.178s.131-.257.367-.646"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4986"
              d="M44.69 44.448s1.345-3.363 2.689-4.228.575.865.575.865"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4987"
              d="M310.656 388.535c1.038.8.964 1.6 1.944 1.9a52.177 52.177 0 006.058 1.265c1.4.131.775-.737.775-.737l-2.391-1.643 2.084-.515a22.747 22.747 0 002.481 2.651c.392.137 1.137.186 1.038-.309-.192-.959-2.306-4.552-3.1-4.724a43.147 43.147 0 00-5.595.493s-9.177-6.3-10.182-6.981a8.277 8.277 0 00-6.532 3.64l.027.022c1.612 1.21 12.358 4.135 13.393 4.938z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-252.153 -335.729)"
              fill="#fff"
            />
            <g data-name="Group 5473">
              <path
                data-name="Path 4988"
                d="M332.061 391.182c-.5-1.219-2.306-4.552-3.1-4.724a43.148 43.148 0 00-5.595.493s-9.177-6.3-10.182-6.981a10.2 10.2 0 00-2.977.72c1.449.822 11.105 6.3 12.324 6.543 1.293.274 5.606-.435 6.364.074a25.539 25.539 0 012.887 4.215c.279-.042.381-.094.279-.34z"
                transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(48.639 44.212) translate(-310.21 -379.97)"
                fill="#92e3a9"
              />
              <path
                data-name="Path 4989"
                d="M332.061 391.182c-.778-1.745-2.306-4.552-3.1-4.724a43.148 43.148 0 00-5.595.493s-9.177-6.3-10.182-6.981a10.2 10.2 0 00-2.977.72c1.449.822 11.105 6.3 12.324 6.543 1.293.274 5.606-.435 6.364.074a25.539 25.539 0 012.887 4.215c.279-.042.389-.096.279-.34z"
                transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(48.639 44.212) translate(-310.21 -379.97)"
                fill="#e5e0ff"
              />
            </g>
            <path
              data-name="Path 4992"
              d="M231.823 236.73l-8.249 3.442a12.163 12.163 0 01-1.06 4.193c-.975 2.062-.405 5.965.531 8.071s5.064 1.282 6.573 1.019a16.265 16.265 0 002.993-.874 2.782 2.782 0 002.673-.372s-4.414-12.393-3.461-15.479z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-197.524 -231.746)"
              fill="#fff"
            />
            <g
              data-name="Group 5469"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(24.483 4.984)"
              clipPath="url(#m)"
            >
              <path
                data-name="Path 4993"
                d="M231.823 236.73l-8.249 3.442a12.163 12.163 0 01-1.06 4.193c-.975 2.062-.405 5.965.531 8.071a1.917 1.917 0 00.726.822v-.158s-1.531-3.793-1.241-5.981 1.534-3.286 1.679-4.669.071-2.04 2.845-3.062 3.938-1.969 4.228-.95 1.46 7.734 2.262 9.339.728 3.286-.509 4.012a17.4 17.4 0 01-3.99 1.758l.583-.1a16.265 16.265 0 002.993-.874 2.782 2.782 0 002.673-.372s-4.424-12.385-3.471-15.471z"
                transform="translate(-222.007 -236.73)"
                fill="#92e3a9"
              />
              <path
                data-name="Path 4994"
                d="M231.823 236.73l-8.249 3.442a12.163 12.163 0 01-1.06 4.193c-.975 2.062-.405 5.965.531 8.071a1.917 1.917 0 00.726.822v-.158s-1.531-3.793-1.241-5.981 1.534-3.286 1.679-4.669.071-2.04 2.845-3.062 3.938-1.969 4.228-.95 1.46 7.734 2.262 9.339.728 3.286-.509 4.012a17.4 17.4 0 01-3.99 1.758l.583-.1a16.265 16.265 0 002.993-.874 2.782 2.782 0 002.673-.372s-4.424-12.385-3.471-15.471z"
                transform="translate(-222.007 -236.73)"
                fill="#e5e0ff"
              />
            </g>
            <path
              data-name="Path 4996"
              d="M34.299 4.984L26.05 8.426a12.163 12.163 0 01-1.06 4.193c-.975 2.062-.405 5.965.531 8.071s5.064 1.282 6.573 1.019a16.265 16.265 0 002.993-.874 2.782 2.782 0 002.673-.372S33.346 8.07 34.299 4.984z"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4997"
              d="M30.131 10.382a4.286 4.286 0 01-.178 1.435c-.219.548-2.287 2.7-2.224 2.933s.249.98.616 1.052"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4998"
              d="M32.423 12.307c.288-.575 1.232-.014 1.219 1.282"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 4999"
              d="M27.74 10.614s.805-.353 1.525.95"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 5000"
              d="M31.279 14.205a3.987 3.987 0 012.5 1.049"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.5}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 5001"
              d="M26.768 12.493a5.3 5.3 0 011.4.386"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.5}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 5002"
              d="M235.6 249.84a1.553 1.553 0 00-1.386-.033c-.737.353-1.189.742-1.139.29s.915-.95 1.175-1.016 1.419-.246 1.35.759z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-205.555 -240.674)"
              fill="#263238"
            />
            <path
              data-name="Path 5003"
              d="M249.84 247.836a6.263 6.263 0 011.78 2.317c.548 1.369.98-.126.548-1.021s-1.684-1.85-2.328-1.296z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-217.734 -239.691)"
              fill="#263238"
            />
            <path
              data-name="Path 5004"
              d="M37.882 22.802c0 .638-.362 1.156-.805 1.156s-.8-.518-.8-1.156.359-2.262.8-2.262.805 1.626.805 2.262z"
              fill="#38c5ae"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 5005"
              d="M250.821 262.56a1.676 1.676 0 00-.074.257c-.079.405-.159 1.252 0 1.287s.548-.756.616-1.161a1.544 1.544 0 00.027-.241 4.981 4.981 0 00-.569-.142z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-218.326 -250.502)"
              fill="#263238"
            />
            <path
              data-name="Path 5006"
              d="M233.909 256.969a1.591 1.591 0 00-.058.219c-.082.405-.079 1.3.093 1.328s.455-.8.534-1.2a1.683 1.683 0 00.033-.3 1.553 1.553 0 00-.602-.047z"
              transform="translate(2363.139 2008.096) translate(61.681 75.397) translate(-206.086 -246.434)"
              fill="#263238"
            />
            <path
              data-name="Path 5007"
              d="M32.423 12.32l.274-.509a1.98 1.98 0 011.117.646"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.75}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 5008"
              d="M27.822 10.535l.274-.32s.118-.058.764.236"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.75}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <path
              data-name="Path 5009"
              d="M26.784 17.962s.46-.846 1.076-.846 1.076 1.383 1.076 1.383"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
              transform="translate(2363.139 2008.096) translate(61.681 75.397)"
            />
            <g transform="translate(2363.139 2008.096) translate(38.889 119.369)">
              <path
                data-name="Path 5010"
                d="M154.247 406.156a9.428 9.428 0 01-3.358-.8 1.162 1.162 0 11.917-2.132 5.8 5.8 0 002.814.576c.677-.757 1.716-5.33.373-7.537-.3-.49-.586-.581-.773-.6a3.645 3.645 0 00-2.292 1.066 1.165 1.165 0 11-1.6-1.7c.208-.2 2.132-1.935 4.184-1.658a3.347 3.347 0 012.441 1.684c1.978 3.225.624 9.36-.9 10.575a2.867 2.867 0 01-1.806.526z"
                transform="translate(-139.392 -392.404)"
                fill="#fff"
              />
              <g
                data-name="Group 5470"
                transform="translate(10.572 .94)"
                clipPath="url(#n)"
              >
                <path
                  data-name="Path 5011"
                  d="M156.94 397a2.2 2.2 0 00-1.6-1.3c-1.333-.213-2.585 1.125-2.724 1.274a1 1 0 00-.112 1.114 1.151 1.151 0 00.56-.288 3.817 3.817 0 012.292-1.066c.187 0 .469.112.773.6 1.343 2.185.3 6.78-.373 7.537a5.811 5.811 0 01-2.814-.576 1.166 1.166 0 00-.416-.091.879.879 0 00.448.709 5.33 5.33 0 002.18.618 1.679 1.679 0 001.189-.416c1.002-.915 1.887-5.636.597-8.115z"
                  transform="translate(-151.095 -394.433)"
                  fill="#92e3a9"
                />
                <path
                  data-name="Path 5012"
                  d="M156.94 397a2.2 2.2 0 00-1.6-1.3c-1.333-.213-2.585 1.125-2.724 1.274a1 1 0 00-.112 1.114 1.151 1.151 0 00.56-.288 3.817 3.817 0 012.292-1.066c.187 0 .469.112.773.6 1.343 2.185.3 6.78-.373 7.537a5.811 5.811 0 01-2.814-.576 1.166 1.166 0 00-.416-.091.879.879 0 00.448.709 5.33 5.33 0 002.18.618 1.679 1.679 0 001.189-.416c1.002-.915 1.887-5.636.597-8.115z"
                  transform="translate(-151.095 -394.433)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                data-name="Path 5014"
                d="M14.855 13.752a9.428 9.428 0 01-3.358-.8 1.162 1.162 0 11.917-2.132 5.8 5.8 0 002.814.576c.677-.757 1.716-5.33.373-7.537-.3-.49-.586-.581-.773-.6a3.645 3.645 0 00-2.292 1.066 1.167 1.167 0 11-1.6-1.7c.208-.2 2.132-1.935 4.184-1.658a3.347 3.347 0 012.441 1.684c1.978 3.225.624 9.36-.9 10.575a2.867 2.867 0 01-1.806.526z"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
              />
              <path
                data-name="Rectangle 44650"
                fill="#fff"
                d="M0 0H12.819V17.014H0z"
              />
              <g data-name="Group 5471" clipPath="url(#o)">
                <path
                  data-name="Rectangle 44651"
                  fill="#92e3a9"
                  d="M0 0H5.25V17.014H0z"
                />
                <path
                  data-name="Rectangle 44652"
                  fill="#e0fffa"
                  d="M0 0H5.25V17.014H0z"
                />
              </g>
              <path
                data-name="Rectangle 44654"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M0 0H12.819V17.014H0z"
              />
            </g>
            <g
              transform="translate(2363.139 2008.096) translate(65.575 103.655)"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            >
              <path
                data-name="Path 5015"
                d="M56.577 32.493H1.815L.029 2.393a2.047 2.047 0 012-2.388h54.315a2.047 2.047 0 012.02 2.388z"
                fill="#263238"
                stroke="#263238"
              />
              <path
                data-name="Path 5016"
                d="M4.511.72h51.44a1.994 1.994 0 011.988 2.313"
                fill="none"
                stroke="#fff"
              />
              <path
                data-name="Path 5017"
                d="M.428 2.559A2.009 2.009 0 012.443.72"
                fill="none"
                stroke="#fff"
              />
              <path
                data-name="Rectangle 44655"
                transform="translate(1.585 29.561)"
                fill="#fff"
                stroke="#263238"
                d="M0 0H55.221V2.932H0z"
              />
              <ellipse
                data-name="Ellipse 39450"
                cx={3.912}
                cy={2.345}
                rx={3.912}
                ry={2.345}
                transform="translate(25.086 14.018)"
                fill="#fff"
                stroke="#263238"
              />
            </g>
            <g transform="translate(2363.139 2008.096) translate(0 135.802)">
              <path
                data-name="Rectangle 44656"
                fill="#263238"
                d="M0 0H205.67V4.994H0z"
              />
            </g>
            <g transform="translate(2363.139 2008.096) translate(39.259)">
              <rect
                data-name="Rectangle 44657"
                width={111.022}
                height={68.85}
                rx={11.33}
                fill="#a3e4d9"
              />
              <circle
                data-name="Ellipse 39451"
                cx={16.46}
                cy={16.46}
                r={16.46}
                transform="rotate(-9.13 78.911 -224.662)"
                fill="#263238"
              />
              <path
                data-name="Path 5018"
                d="M242.014 112.168l-5.485 7.041a2.1 2.1 0 01-1.738.97 1.807 1.807 0 01-1.279-.506 1.647 1.647 0 01-.533-1.263 2.473 2.473 0 01.533-1.455l6.252-7.734-5.863-7.739a2.132 2.132 0 01-.426-1.258 1.962 1.962 0 01.624-1.444 1.988 1.988 0 011.439-.613 2.063 2.063 0 011.716.97l5.3 6.977 5.33-6.86a2.265 2.265 0 011.828-1.1 1.823 1.823 0 011.764 1.764 1.865 1.865 0 01-.405 1.135l-6.274 8.027 6.06 8a2.063 2.063 0 01.453 1.258 1.828 1.828 0 01-.634 1.4 2.1 2.1 0 01-1.455.586 2.068 2.068 0 01-1.727-.97z"
                transform="translate(-186.628 -85.811)"
                fill="#fff"
              />
              <path
                data-name="Path 5019"
                d="M249.829 173.394h-62.742a4.8 4.8 0 01-4.8-4.8 4.8 4.8 0 014.8-4.8h62.742a4.8 4.8 0 014.8 4.8 4.8 4.8 0 01-4.8 4.8z"
                transform="translate(-162.957 -116.468)"
                fill="#fff"
              />
              <path
                data-name="Path 5020"
                d="M206.463 172.912a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.416.416 0 01.059-.213l.48-.746h-.978a.32.32 0 01-.245-.1.352.352 0 010-.458.32.32 0 01.245-.1l.965.027-.426-.693a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.283.181l.469.837.448-.8a.373.373 0 01.32-.219.309.309 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.314.314 0 01.245.1.352.352 0 010 .458.314.314 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.346.346 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.341.192z"
                transform="translate(-173.736 -119.237)"
              />
              <path
                data-name="Path 5021"
                d="M215.643 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.416.416 0 01.059-.213l.48-.746h-.981a.32.32 0 01-.245-.1.352.352 0 010-.458.32.32 0 01.245-.1l.965.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.282.181l.469.837.448-.8a.373.373 0 01.32-.219.309.309 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.315.315 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.341.341 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.319.22z"
                transform="translate(-178.023 -119.214)"
              />
              <path
                data-name="Path 5022"
                d="M224.823 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.415.415 0 01.059-.213l.48-.746h-.981a.32.32 0 01-.245-.1.352.352 0 010-.458.32.32 0 01.245-.1l.965.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.282.181l.469.837.448-.8a.373.373 0 01.32-.219.309.309 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.315.315 0 01-.245.1h-.986l.437.682a.564.564 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.341.341 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.319.22z"
                transform="translate(-182.31 -119.214)"
              />
              <path
                data-name="Path 5023"
                d="M234.043 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.415.415 0 01.059-.213l.48-.746h-.981a.32.32 0 01-.245-.1.352.352 0 010-.458.32.32 0 01.245-.1l.965.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.283.181l.469.837.448-.8a.373.373 0 01.32-.219.309.309 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.315.315 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.346.346 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.32.22z"
                transform="translate(-186.615 -119.214)"
              />
              <path
                data-name="Path 5024"
                d="M243.183 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.475.475 0 01.059-.213l.48-.746h-.981a.32.32 0 01-.245-.1.352.352 0 010-.458.32.32 0 01.245-.1l.965.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.283.181l.469.837.448-.8a.373.373 0 01.32-.219.3.3 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.315.315 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.346.346 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.32.22z"
                transform="translate(-190.883 -119.214)"
              />
              <path
                data-name="Path 5025"
                d="M252.363 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.474.474 0 01.059-.213l.48-.746h-.975a.325.325 0 01-.251-.1.352.352 0 010-.458.325.325 0 01.251-.1l.959.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.282.181l.469.837.448-.8a.373.373 0 01.32-.219.3.3 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.315.315 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.347.347 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.319.22z"
                transform="translate(-195.17 -119.214)"
              />
              <path
                data-name="Path 5026"
                d="M261.543 172.912a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.416.416 0 01.059-.213l.48-.746h-.981a.32.32 0 01-.245-.1.352.352 0 010-.458.32.32 0 01.245-.1l.965.027-.469-.693a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.283.181l.469.837.448-.8a.373.373 0 01.32-.219.3.3 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.314.314 0 01.245.1.352.352 0 010 .458.314.314 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.346.346 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.3.192z"
                transform="translate(-199.457 -119.237)"
              />
              <path
                data-name="Path 5027"
                d="M270.723 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.475.475 0 01.059-.213l.48-.746h-.975a.3.3 0 01-.245-.1.336.336 0 010-.458.3.3 0 01.245-.1l.959.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.325-.336.3.3 0 01.283.181l.469.837.448-.8a.373.373 0 01.32-.219.288.288 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.314.314 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.309.33.347.347 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.317.221z"
                transform="translate(-203.744 -119.214)"
              />
              <path
                data-name="Path 5028"
                d="M279.9 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.474.474 0 01.059-.213l.48-.746h-.981a.3.3 0 01-.24-.1.336.336 0 010-.458.3.3 0 01.24-.1l.965.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.325-.336.3.3 0 01.282.181l.469.837.448-.8a.373.373 0 01.32-.219.288.288 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.315.315 0 01.245.1.352.352 0 010 .458.314.314 0 01-.245.1h-.987l.437.682a.565.565 0 01.08.272.32.32 0 01-.309.33.347.347 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.315.221z"
                transform="translate(-208.031 -119.214)"
              />
              <path
                data-name="Path 5029"
                d="M289.043 172.889a.309.309 0 01-.224-.1.325.325 0 01-.1-.24.474.474 0 01.059-.213l.48-.746h-.981a.3.3 0 01-.24-.1.336.336 0 010-.458.3.3 0 01.24-.1l.965.027-.453-.72a.485.485 0 01-.069-.235.325.325 0 01.1-.24.32.32 0 01.229-.1.3.3 0 01.282.181l.469.837.448-.8a.373.373 0 01.32-.219.288.288 0 01.224.1.3.3 0 01.1.229.4.4 0 01-.064.213l-.469.752.975-.027a.314.314 0 01.245.1.352.352 0 010 .458.315.315 0 01-.245.1h-.986l.437.682a.565.565 0 01.08.272.32.32 0 01-.091.235.3.3 0 01-.219.1.347.347 0 01-.309-.208l-.442-.784-.442.784a.357.357 0 01-.319.22z"
                transform="translate(-212.299 -119.214)"
              />
            </g>
          </g>
          <path
            data-name="Rectangle 44658"
            transform="rotate(3.9 -30027.14 37581.939)"
            fill="#f4f2ff"
            d="M0 0H13.569V11.025H0z"
          />
          <g data-name="Verify OTP" transform="translate(2336 1985)">
            <path
              data-name="Path 5032"
              d="M177.275 157.272a2.544 2.544 0 014.407 0L196 182.079a2.545 2.545 0 01-2.2 3.816h-28.643a2.545 2.545 0 01-2.2-3.816z"
              transform="translate(-11.132 -30.482)"
              fill="rgba(90,197,179,0.1)"
            />
            <path
              data-name="Path 4696"
              d="M240.617 4.272a2.544 2.544 0 014.407 0l17.995 31.168a2.545 2.545 0 01-2.2 3.816h-35.99a2.545 2.545 0 01-2.2-3.816z"
              transform="translate(-33.766 -3)"
              fill="rgba(90,197,179,0.1)"
            />
            <circle
              data-name="Ellipse 39444"
              cx={25.5}
              cy={25.5}
              r={25.5}
              transform="translate(-.051 99.322)"
              fill="rgba(90,197,179,0.1)"
            />
            <circle
              data-name="Ellipse 39445"
              cx={16}
              cy={16}
              r={16}
              transform="translate(36.949 9.322)"
              fill="rgba(90,197,179,0.1)"
            />
            <g
              data-name="Group 5436"
              opacity={0.3}
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            >
              <path
                data-name="Path 4735"
                d="M52.951 121.708H0v-95.9A25.805 25.805 0 0125.805 0a27.133 27.133 0 0127.134 27.134v94.574z"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4736"
                d="M46.962 121.423V27.345a20.5 20.5 0 00-20.5-20.5h0a20.5 20.5 0 00-20.487 20.5v94.092"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4737"
                d="M26.476 0v121.566"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4738"
                d="M52.666 23.418H.354"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4739"
                d="M52.666 39.929H.354"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4740"
                d="M52.666 56.44H.354"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4741"
                d="M52.666 72.955H.354"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4742"
                d="M52.666 89.468H.354"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4743"
                d="M52.666 105.979H.354"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4744"
                d="M45.672 8.261l-4.742 4.321"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
              <path
                data-name="Path 4745"
                d="M7.476 8.261l4.745 4.321"
                opacity={0.3}
                transform="translate(197.873 4.24)"
              />
            </g>
            <g
              data-name="Group 5437"
              opacity={0.3}
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            >
              <path
                data-name="Path 4746"
                d="M52.95 121.708H0v-95.9A25.805 25.805 0 0125.8 0a27.134 27.134 0 0127.139 27.134v94.574z"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4747"
                d="M46.97 121.423V27.346a20.5 20.5 0 00-20.5-20.513h0A20.5 20.5 0 005.959 27.346v94.092"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4748"
                d="M26.473 0v121.566"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4749"
                d="M52.666 23.418H.351"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4750"
                d="M52.666 39.929H.351"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4751"
                d="M52.666 56.44H.351"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4752"
                d="M52.666 72.955H.351"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4753"
                d="M52.666 89.467H.351"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4754"
                d="M52.666 105.979H.351"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4755"
                d="M45.67 8.261l-4.745 4.321"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
              <path
                data-name="Path 4756"
                d="M7.475 8.261l4.741 4.321"
                opacity={0.3}
                transform="translate(3.392 4.24)"
              />
            </g>
            <path
              data-name="Path 4757"
              d="M200.598 163.892h55.116"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <path
              data-name="Path 4758"
              d="M8.481 163.892h186.607"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1}
            />
            <g data-name="Group 5561">
              <path
                data-name="Path 4344"
                d="M29.521 138.1A4.226 4.226 0 0028 135.5c-1.517-1.516-2.488-2.382-2.488-2.382s-.76 2.491.648 4a26.637 26.637 0 003.351 2.924z"
                transform="translate(239.911 110.268) translate(-16.535 -133.118)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4345"
                d="M26.93 146.073a4.232 4.232 0 00-1.514-2.6c-1.514-1.516-2.491-2.382-2.491-2.382s-.757 2.491.651 4.007a26.669 26.669 0 003.354 2.916z"
                transform="translate(239.911 110.268) translate(-16.142 -134.329)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4346"
                d="M30.126 140.355a4.224 4.224 0 011.782-2.425c1.667-1.346 2.729-2.106 2.729-2.106s.491 2.555-1.07 3.91a26.569 26.569 0 01-3.647 2.553z"
                transform="translate(239.911 110.268) translate(-17.235 -133.529)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4347"
                d="M26.95 149.847s.229-1.058 2.028-2.234 2.935-1.807 2.935-1.807.218 2.594-1.475 3.782a26.751 26.751 0 01-3.91 2.156z"
                transform="translate(239.911 110.268) translate(-16.72 -135.045)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4348"
                d="M27.618 159.956a4.229 4.229 0 011.516-2.6c1.516-1.516 2.491-2.382 2.491-2.382s.757 2.492-.651 4.008a26.571 26.571 0 01-3.351 2.923z"
                transform="translate(239.911 110.268) translate(-16.885 -136.438)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4349"
                d="M26.922 162.368a4.263 4.263 0 00-1.117-2.793c-1.271-1.721-2.125-2.712-2.125-2.712s-1.117 2.358.073 4.058a26.677 26.677 0 002.907 3.371z"
                transform="translate(239.911 110.268) translate(-16.215 -136.725)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4350"
                d="M25.826 169.888a4.221 4.221 0 011.516-2.6c1.516-1.514 2.491-2.382 2.491-2.382s.757 2.488-.651 4a26.576 26.576 0 01-3.351 2.924z"
                transform="translate(239.911 110.268) translate(-16.613 -137.947)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4351"
                d="M27.019 176.469a4.2 4.2 0 01.807-2.9c1.086-1.851 1.807-2.935 1.807-2.935s1.363 2.218.385 4.041a26.465 26.465 0 01-2.513 3.678z"
                transform="translate(239.911 110.268) translate(-16.789 -138.817)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4352"
                d="M13.123 4.703a31 31 0 01-.413 3.351c-.6 3.095-2.1 5.094-2.7 7.89s1.117 6.4.662 9.99-1.86 5.586-1.461 7.987 2.5 8.887 2.5 8.887"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4353"
                d="M12.877 7.543l1.634-1.251"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4354"
                d="M12.953 6.099l-.684-1.215"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4355"
                d="M10.103 15.827s1.366-1.025 2.773-2.053"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4356"
                d="M10.788 13.685a21.862 21.862 0 00-2.43-3.717"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4357"
                d="M10.788 25.056a16.886 16.886 0 012.924-3.91"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4358"
                d="M10.509 26.578a19.248 19.248 0 00-1.48-2.812c-.8-1.179-.913-1.33-.913-1.33"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4359"
                d="M9.213 33.932a18.007 18.007 0 011.232-2.491 15.819 15.819 0 011.595-2.089"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4360"
                d="M10.721 39.538a4.653 4.653 0 01.411-2.394c.559-1.1 1.215-2.544 1.48-3.113"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4361"
                d="M18.571 155.41a2.7 2.7 0 01.667-1.8 39.185 39.185 0 011.3-1.761 2.905 2.905 0 01.028 2.583 16.847 16.847 0 01-1.787 2.195z"
                transform="translate(239.911 110.268) translate(-15.51 -135.964)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4362"
                d="M21.064 160.14a2.7 2.7 0 01.668-1.8c.785-1.114 1.315-1.773 1.315-1.773a2.9 2.9 0 01.025 2.581 16.92 16.92 0 01-1.787 2.2z"
                transform="translate(239.911 110.268) translate(-15.889 -136.681)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4363"
                d="M18.284 156.976s-.19-.662-1.38-1.326-1.941-1.025-1.941-1.025a2.9 2.9 0 001.1 2.341 17.019 17.019 0 002.564 1.2z"
                transform="translate(239.911 110.268) translate(-14.963 -136.385)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4364"
                d="M21.229 162.606s-.257-.639-1.511-1.173-2.036-.815-2.036-.815a2.893 2.893 0 001.335 2.208 16.81 16.81 0 002.678.93z"
                transform="translate(239.911 110.268) translate(-15.376 -137.295)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4365"
                d="M22.061 168.982s-.117-.678-1.232-1.463-1.821-1.224-1.821-1.224a2.916 2.916 0 00.838 2.442 16.95 16.95 0 002.421 1.469z"
                transform="translate(239.911 110.268) translate(-15.575 -138.158)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4366"
                d="M22.9 170.352a2.677 2.677 0 01.4-1.871c.62-1.214 1.039-1.933 1.039-1.933a2.908 2.908 0 01.4 2.553 17.012 17.012 0 01-1.458 2.43z"
                transform="translate(239.911 110.268) translate(-16.162 -138.196)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4367"
                d="M25.118 176.979s.078-.684 1.148-1.533 1.745-1.326 1.745-1.326a2.9 2.9 0 01-.7 2.485 16.835 16.835 0 01-2.335 1.606z"
                transform="translate(239.911 110.268) translate(-16.484 -139.346)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4368"
                d="M24.262 175.017s-.117-.678-1.232-1.466-1.821-1.223-1.821-1.223a2.912 2.912 0 00.838 2.441 16.826 16.826 0 002.416 1.469z"
                transform="translate(239.911 110.268) translate(-15.909 -139.074)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4369"
                d="M24.35 179.245a2.684 2.684 0 00-.821-1.728c-.88-1.042-1.452-1.645-1.452-1.645a2.906 2.906 0 00.2 2.575 16.954 16.954 0 001.972 2.036z"
                transform="translate(239.911 110.268) translate(-16.01 -139.613)"
                fill="#4cc5b1"
              />
              <path
                data-name="Path 4370"
                d="M2.944 19.286a19.824 19.824 0 00.626 2.063c.712 1.874 1.868 2.967 2.547 4.653s0 4.136.67 6.336 1.773 3.3 1.782 4.851-.6 5.842-.6 5.842"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4371"
                d="M3.407 21.041l-1.159-.609"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4372"
                d="M3.203 20.144l.3-.838"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4373"
                d="M6.041 25.933s-.969-.494-1.955-.985"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4374"
                d="M5.385 24.668a13.816 13.816 0 011.117-2.594"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4375"
                d="M6.619 31.796a10.842 10.842 0 00-2.254-2.137"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4376"
                d="M6.951 32.719a12.3 12.3 0 01.623-1.924c.374-.824.427-.932.427-.932"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4377"
                d="M8.518 38.369a10.061 10.061 0 011.246-1.3 6.827 6.827 0 00.813-.706"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4378"
                d="M8.568 37.191a11.581 11.581 0 00-1.042-1.43A10.047 10.047 0 006.3 34.63"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4379"
                d="M8.233 40.869a2.941 2.941 0 00-.517-1.46c-.478-.628-1.039-1.464-1.268-1.793"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
              <path
                data-name="Path 4380"
                d="M12.693 53.341H6.367a.5.5 0 01-.5-.5l-1.57-10.478H14.76l-1.57 10.478a.5.5 0 01-.5.5z"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                transform="translate(239.911 110.268)"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function GetStartedBgIcon(props) {
  const { rootStyle, ...rest } = props;

  const rootSx = {
    width: 304.5,
    height: 193.749,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 304.5 193.749"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 102584" transform="translate(-36 -54)">
        <circle
          data-name="Ellipse 39441"
          cx={18}
          cy={18}
          r={18}
          transform="translate(290 144)"
          fill="#e4e2f9"
        />
        <g data-name="Customized plan" transform="translate(36 51)">
          <path
            data-name="Path 5075"
            d="M243.9 4.5a3 3 0 015.2 0l21.218 36.75a3 3 0 01-2.6 4.5h-42.436a3 3 0 01-2.6-4.5z"
            fill="rgba(94,90,197,0.1)"
          />
          <path
            data-name="Path 5076"
            d="M179.9 157.5a3 3 0 015.2 0l16.888 29.25a3 3 0 01-2.6 4.5h-33.775a3 3 0 01-2.6-4.5z"
            fill="rgba(94,90,197,0.1)"
          />
          <circle
            data-name="Ellipse 39455"
            cx={30}
            cy={30}
            r={30}
            transform="translate(0 120)"
            fill="rgba(94,90,197,0.1)"
          />
          <circle
            data-name="Ellipse 39456"
            cx={19}
            cy={19}
            r={19}
            transform="translate(43 14)"
            fill="rgba(94,90,197,0.1)"
          />
          <path
            data-name="Path 5077"
            d="M52.9 145.5a3 3 0 015.2 0l16.888 29.25a3 3 0 01-2.6 4.5H38.612a3 3 0 01-2.6-4.5z"
            fill="rgba(255,255,255,0.1)"
          />
          <circle
            data-name="Ellipse 39457"
            cx={19}
            cy={19}
            r={19}
            transform="translate(219 28)"
            fill="rgba(255,255,255,0.1)"
          />
          <path
            data-name="Path 5078"
            d="M23.312 138.989s0-1.275-1.788-3.063-2.934-2.809-2.934-2.809-.9 2.938.764 4.722a31.33 31.33 0 003.952 3.448z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5079"
            d="M20.721 146.964s0-1.278-1.785-3.066S16 141.089 16 141.089s-.892 2.938.767 4.726a31.447 31.447 0 003.955 3.438z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5080"
            d="M23.2 141.165s.135-1.271 2.1-2.858 3.217-2.483 3.217-2.483.58 3.013-1.261 4.61a31.51 31.51 0 01-4.3 3.01z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5081"
            d="M20.063 150.571s.27-1.248 2.391-2.635 3.461-2.13 3.461-2.13.257 3.059-1.739 4.458a31.548 31.548 0 01-4.61 2.543z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5082"
            d="M20.655 160.847s0-1.277 1.788-3.065 2.937-2.809 2.937-2.809.892 2.937-.767 4.725a31.337 31.337 0 01-3.952 3.448z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5083"
            d="M20.625 163.353s.181-1.264-1.317-3.293-2.506-3.2-2.506-3.2-1.317 2.779.086 4.785a31.446 31.446 0 003.428 3.974z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5084"
            d="M18.863 170.779s0-1.278 1.788-3.062 2.937-2.809 2.937-2.809.892 2.934-.767 4.722a31.418 31.418 0 01-3.952 3.448z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5085"
            d="M20.061 177.514s-.329-1.235.952-3.418 2.131-3.461 2.131-3.461 1.607 2.614.454 4.765a31.266 31.266 0 01-2.964 4.337z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5086"
            d="M23.474 138.662a36.6 36.6 0 01-.487 3.952c-.708 3.648-2.473 6.006-3.181 9.3s1.317 7.544.781 11.779-2.193 6.586-1.722 9.418 2.944 10.478 2.944 10.478"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5087"
            d="M23.185 142.011l1.926-1.475"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5088"
            d="M23.274 140.309l-.807-1.432"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5089"
            d="M19.913 151.779s1.61-1.208 3.27-2.42"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5090"
            d="M20.72 149.253a25.818 25.818 0 00-2.865-4.383"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5091"
            d="M20.72 162.662a19.869 19.869 0 013.448-4.61"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5092"
            d="M20.39 164.456a22.8 22.8 0 00-1.745-3.316c-.942-1.389-1.077-1.567-1.077-1.567"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5093"
            d="M18.863 173.128a21.244 21.244 0 011.452-2.937 18.661 18.661 0 011.88-2.463"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5094"
            d="M20.64 179.736a5.481 5.481 0 01.484-2.822c.659-1.3 1.432-3 1.745-3.672"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5095"
            d="M11.609 156.046a3.181 3.181 0 01.787-2.117c.925-1.317 1.538-2.078 1.538-2.078a3.426 3.426 0 01.033 3.046 19.806 19.806 0 01-2.108 2.588z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5096"
            d="M14.1 160.779a3.179 3.179 0 01.787-2.118c.925-1.314 1.551-2.091 1.551-2.091a3.413 3.413 0 01.03 3.043 20.027 20.027 0 01-2.108 2.592z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5097"
            d="M11.915 157.4s-.224-.78-1.627-1.564S8 154.624 8 154.624a3.419 3.419 0 001.294 2.759 20.061 20.061 0 003.023 1.419z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5098"
            d="M14.9 162.962s-.3-.754-1.782-1.383-2.4-.962-2.4-.962a3.414 3.414 0 001.574 2.6 20.02 20.02 0 003.158 1.1z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5099"
            d="M15.648 169.463s-.138-.8-1.452-1.726-2.147-1.442-2.147-1.442a3.436 3.436 0 00.988 2.878 19.9 19.9 0 002.855 1.732z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5100"
            d="M15.939 171.033a3.157 3.157 0 01.477-2.206c.731-1.433 1.225-2.279 1.225-2.279a3.429 3.429 0 01.468 3.01 20.115 20.115 0 01-1.719 2.865z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5101"
            d="M18.181 177.49s.092-.807 1.354-1.808 2.058-1.564 2.058-1.564a3.423 3.423 0 01-.826 2.931 19.844 19.844 0 01-2.753 1.893z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5102"
            d="M17.849 175.5s-.138-.8-1.452-1.729-2.147-1.442-2.147-1.442a3.434 3.434 0 00.988 2.878 19.931 19.931 0 002.848 1.732z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5103"
            d="M17.834 179.849a3.168 3.168 0 00-.968-2.039c-1.037-1.228-1.712-1.939-1.712-1.939a3.427 3.427 0 00.231 3.036 20.06 20.06 0 002.325 2.4z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5104"
            d="M11.471 155.858a23.393 23.393 0 00.738 2.434c.84 2.21 2.2 3.5 3 5.486s0 4.877.79 7.472 2.091 3.9 2.1 5.72-.708 6.889-.708 6.889"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5105"
            d="M12.018 157.927l-1.367-.718"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5106"
            d="M11.777 156.87l.349-.988"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5107"
            d="M15.123 163.7s-1.143-.583-2.305-1.163"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5108"
            d="M14.351 162.2a16.292 16.292 0 011.317-3.059"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5109"
            d="M15.8 170.608a12.778 12.778 0 00-2.657-2.519"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5110"
            d="M16.2 171.7a14.5 14.5 0 01.734-2.269l.5-1.1"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5111"
            d="M18.044 178.353a11.937 11.937 0 011.469-1.528 7.872 7.872 0 00.958-.833"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5112"
            d="M18.1 176.97a13.733 13.733 0 00-1.228-1.686 11.762 11.762 0 00-1.446-1.333"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5113"
            d="M17.708 181.308a3.473 3.473 0 00-.609-1.723c-.563-.741-1.225-1.725-1.495-2.114"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5114"
            d="M22.967 196.014h-7.462a.587.587 0 01-.586-.586l-1.851-12.356H25.4l-1.851 12.356a.587.587 0 01-.586.586z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <g
            data-name="Group 5479"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 5115"
              d="M304 151.508h-62.435V38.427A30.427 30.427 0 01271.992 8a31.993 31.993 0 0131.994 31.994v111.514z"
              opacity={0.3}
            />
            <path
              data-name="Path 5116"
              d="M296.939 151.172V40.244a24.169 24.169 0 00-24.169-24.169h0a24.169 24.169 0 00-24.156 24.169V151.19"
              opacity={0.3}
            />
            <path data-name="Path 5117" d="M272.783 8v143.34" opacity={0.3} />
            <path
              data-name="Path 5118"
              d="M303.664 35.612h-61.682"
              opacity={0.3}
            />
            <path
              data-name="Path 5119"
              d="M303.664 55.081h-61.682"
              opacity={0.3}
            />
            <path
              data-name="Path 5120"
              d="M303.664 74.549h-61.682"
              opacity={0.3}
            />
            <path
              data-name="Path 5121"
              d="M303.664 94.023h-61.682"
              opacity={0.3}
            />
            <path
              data-name="Path 5122"
              d="M303.664 113.493h-61.682"
              opacity={0.3}
            />
            <path
              data-name="Path 5123"
              d="M303.664 132.962h-61.682"
              opacity={0.3}
            />
            <path
              data-name="Path 5124"
              d="M295.417 17.741l-5.591 5.1"
              opacity={0.3}
            />
            <path
              data-name="Path 5125"
              d="M250.38 17.741l5.6 5.1"
              opacity={0.3}
            />
          </g>
          <g
            data-name="Group 5480"
            opacity={0.3}
            fill="none"
            stroke="#000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          >
            <path
              data-name="Path 5126"
              d="M74.685 151.508H12.25V38.427A30.427 30.427 0 0142.677 8a31.994 31.994 0 0131.994 31.994v111.514z"
              opacity={0.3}
            />
            <path
              data-name="Path 5127"
              d="M67.633 151.172V40.244a24.17 24.17 0 00-24.169-24.187h0a24.169 24.169 0 00-24.188 24.187V151.19"
              opacity={0.3}
            />
            <path data-name="Path 5128" d="M43.464 8v143.34" opacity={0.3} />
            <path
              data-name="Path 5129"
              d="M74.349 35.612H12.663"
              opacity={0.3}
            />
            <path
              data-name="Path 5130"
              d="M74.349 55.081H12.663"
              opacity={0.3}
            />
            <path
              data-name="Path 5131"
              d="M74.349 74.549H12.663"
              opacity={0.3}
            />
            <path
              data-name="Path 5132"
              d="M74.349 94.023H12.663"
              opacity={0.3}
            />
            <path
              data-name="Path 5133"
              d="M74.349 113.492H12.663"
              opacity={0.3}
            />
            <path
              data-name="Path 5134"
              d="M74.349 132.961H12.663"
              opacity={0.3}
            />
            <path
              data-name="Path 5135"
              d="M66.1 17.741l-5.595 5.1"
              opacity={0.3}
            />
            <path
              data-name="Path 5136"
              d="M21.065 17.741l5.59 5.1"
              opacity={0.3}
            />
          </g>
          <path
            data-name="Path 5137"
            d="M238.779 196.249h64.988"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5138"
            d="M12.25 196.249h220.031"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5139"
            d="M300.884 108h-2.766v87.577h2.766z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5140"
            d="M284.75 123.211h-3.227v69.6h3.227z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5141"
            d="M283.368 159.164A13.367 13.367 0 10270 145.8a13.367 13.367 0 0013.368 13.364z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5142"
            d="M283.368 152.711a6.914 6.914 0 10-6.914-6.914 6.913 6.913 0 006.914 6.914z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5143"
            d="M283.368 147.64a1.843 1.843 0 10-1.844-1.844 1.844 1.844 0 001.844 1.844z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5144"
            d="M283.368 190.507A13.368 13.368 0 10270 177.14a13.367 13.367 0 0013.368 13.367z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5145"
            d="M283.368 184.054a6.914 6.914 0 10-6.914-6.914 6.913 6.913 0 006.914 6.914z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5146"
            d="M283.368 178.983a1.844 1.844 0 10-1.844-1.844 1.845 1.845 0 001.844 1.844z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5147"
            d="M300.882 191.89H270v3.687h30.882z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5148"
            d="M179.881 129.955l-1.143 2.908s-15.465 6.126-22.213 10.274-7.37 7.887-6.019 11 14.113 28.647 14.113 28.647l.415 1.244-.935 2.489s-6.02 3.01-7.68 3.738-3.01 1.245-1.972 2.6 5.918 1.245 7.471.936a32.005 32.005 0 016.334-.728c1.659.106 4.876.622 4.461-1.867s-1.143-5.19-1.35-6.333-3.632-12.662-4.153-16.709-.885-9.67-2.337-11.846-2.434-3.512-2.434-3.512 5.771-.844 10.795-1.66a94.289 94.289 0 0015.156-3.636s8.2-2.8 12.869-3.116 8.615-1.972 9.965-4.982.622-8.823-2.489-11.938-3.531-3.116-3.531-3.116a29.3 29.3 0 01-12.247 3.738 35.322 35.322 0 01-11.311-.936z"
            fill="#2d3a40"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5149"
            d="M168.257 193.061c1.66.106 4.877.622 4.462-1.867s-1.143-5.19-1.35-6.333c-.069-.369-.47-1.816-1-3.748a17.172 17.172 0 01-6.291.581c.345.7.544 1.088.544 1.088l.414 1.244-.935 2.489s-6.02 3.01-7.679 3.739-3.01 1.244-1.973 2.6 5.918 1.244 7.472.935a32.071 32.071 0 016.333-.728z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5150"
            d="M171.464 185.336l-3.107.148-1.244-1.558c-.829-1.037-2.075.106-2.075.106l-.935 2.489s-6.02 3.01-7.679 3.738-3.01 1.244-1.973 2.6 5.918 1.244 7.472.936a31.988 31.988 0 016.333-.729c1.659.106 4.876.623 4.462-1.866-.365-2.2-.973-4.55-1.254-5.864z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5151"
            d="M185.024 135.444l5.753 4.375"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5152"
            d="M171.512 106.185s-5.111-3.748-7.988-5.873a35.278 35.278 0 01-4.876-4.374l2.249-6.375-7 .373s-2 4.877-.876 6l3.125 3.125s8.624 9.749 10.878 11.749 6.753 2.125 6.753 2.125l-1.752-6.623z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5153"
            d="M172.4 89.061s-3.84.83-4.462 2.909 1.659 9.444 2.6 11.624a18.7 18.7 0 011.143 3.218s-.313 4.876 1.037 7.577 6.541 3.531 6.541 3.531l1.973 3.425-1.351 8.615s8.094 2.8 15.257 1.244a17.311 17.311 0 0010.482-6.849l-5.707-4.983s-.207-11.625-.521-17.124-.622-10.587-2.9-12.767-9.135-1.351-9.758-1.452-2.18-1.765-2.9-3.425-2.181-5.6-2.181-5.6-2.281.622-2.7 2.18a12.291 12.291 0 01-3.425 4.983c-1.35 1.143-3.116 2.908-3.116 2.908z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5154"
            d="M180.637 82.728s.374 1.5-1.12 4.236a24 24 0 01-2.244 3.614l-2.121-3.24s4.863-3.987 5.485-4.614z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5155"
            d="M199.544 105.586a6.335 6.335 0 01-7-.954c-3.323-3.116-3.738-11.731-3.738-13.7 0-1.452.055-2.507.088-2.964-.526.014-.987.032-1.351.051-.111 2.162-.645 12.482-1.019 15.266-.415 3.116-4.254 4.669-7.264 3.839a6.028 6.028 0 01-4.775-6.333c0-3.425 1.244-12.975 1.244-12.975l-1.143.207s-1.659 11.832-2.387 14.321a22.261 22.261 0 00-.687 3.84c.129.42.17.622.17.622s-.313 4.877 1.037 7.578 6.541 3.531 6.541 3.531l.392.677c.484.507 2.185 1.517 7.914.881 6.3-.7 10.666-3.089 12.261-4.448a639.43 639.43 0 00-.277-9.44z"
            fill="#6552cc"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5156"
            d="M186.338 119.248s1.208.807 5.236 1.41z"
            fill="#6552cc"
          />
          <path
            data-name="Path 5157"
            d="M186.338 119.248s1.208.807 5.236 1.41"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5158"
            d="M185.131 116.63a9.909 9.909 0 008.859-1.208"
            fill="none"
            stroke="#6552cc"
            strokeWidth={1}
          />
          <path
            data-name="Path 5159"
            d="M180.089 65.291s2.281-3.217 5.706-1.765 7.679 11.519 7.163 15.879-5.6 5.084-8.822 3.946-2.489-6.227-3.01-9.343-1.037-8.721-1.037-8.721z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5160"
            d="M191.171 89.241s4.586-2.051 7.8 1.166a22.135 22.135 0 014.568 6.541l8.408 10.887s1.765-7.19 1.35-9.477-2.7-4.462-3.116-5.5.729-5.19.729-5.19 6.642.106 6.955.106 1.245 2.7 1.037 4.568a5.449 5.449 0 01-1.973 3.217 130.223 130.223 0 01.936 15.777c-.207 6.334-3.346 6.476-6.421 4.647-5.715-3.4-8.421-7.408-10.7-9.38a26.032 26.032 0 01-3.323-3.324"
            fill="#fff"
          />
          <path
            data-name="Path 5161"
            d="M191.171 89.241s4.586-2.051 7.8 1.166a22.135 22.135 0 014.568 6.541l8.408 10.887s1.765-7.19 1.35-9.477-2.7-4.462-3.116-5.5.729-5.19.729-5.19 6.642.106 6.955.106 1.245 2.7 1.037 4.568a5.449 5.449 0 01-1.973 3.217 130.223 130.223 0 01.936 15.777c-.207 6.334-3.346 6.476-6.421 4.647-5.715-3.4-8.421-7.408-10.7-9.38a26.032 26.032 0 01-3.323-3.324"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5162"
            d="M198.357 102.659l-1.973 1.973"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5163"
            d="M182.165 93.731l4.877-2.7"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5164"
            d="M175.521 88.231a7.189 7.189 0 011.867 5.291"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5165"
            d="M206.269 131.587a10.811 10.811 0 00-6.67.548c-4.047 1.973-10.38 9.86-11.519 12.353s.314 6.333.936 7.578 10.067 20.76 12.04 24.185a29.346 29.346 0 012.668 7.486 2.1 2.1 0 00-.594.507l-.208 4.254a8.819 8.819 0 01-3.116 3.116c-1.871.936-3.009 2.908-1.244 3.531s7.785.52 9.237.106 3.217-.415 3.217-1.66a44.534 44.534 0 00-.415-7.264c-.414-1.558-.935-1.558-.935-1.558h-.457c-.189-1.834-.972-9.366-1.511-14.533a42.536 42.536 0 00-4.776-15.363 41.194 41.194 0 00-4.153-5.918s-.935-.729 1.037-1.452 9.86-3.425 11.418-7.371c1.364-3.452.5-5.632.262-6.121"
            fill="#2d3a40"
          />
          <path
            data-name="Path 5166"
            d="M206.269 131.587a10.811 10.811 0 00-6.67.548c-4.047 1.973-10.38 9.86-11.519 12.353s.314 6.333.936 7.578 10.067 20.76 12.04 24.185a29.346 29.346 0 012.668 7.486 2.1 2.1 0 00-.594.507l-.208 4.254a8.819 8.819 0 01-3.116 3.116c-1.871.936-3.009 2.908-1.244 3.531s7.785.52 9.237.106 3.217-.415 3.217-1.66a44.534 44.534 0 00-.415-7.264c-.414-1.558-.935-1.558-.935-1.558h-.457c-.189-1.834-.972-9.366-1.511-14.533a42.536 42.536 0 00-4.776-15.363 41.194 41.194 0 00-4.153-5.918s-.935-.729 1.037-1.452 9.86-3.425 11.418-7.371c1.364-3.452.5-5.632.262-6.121"
            fill="none"
            stroke="#2d3a40"
            strokeWidth={1}
          />
          <path
            data-name="Path 5167"
            d="M207.8 195.241c1.452-.415 3.217-.415 3.217-1.659a44.54 44.54 0 00-.415-7.265c-.414-1.558-.935-1.558-.935-1.558h-.457c-.059-.59-.184-1.779-.341-3.291a17.451 17.451 0 01-5.692.134c.235.825.415 1.567.544 2.129a2.118 2.118 0 00-.6.507l-.207 4.255a8.829 8.829 0 01-3.116 3.116c-1.872.935-3.01 2.908-1.245 3.531s7.785.52 9.237.106z"
            fill="#fff"
            stroke="#2d3a40"
            strokeWidth={1}
          />
          <path
            data-name="Path 5168"
            d="M207.8 195.242c1.452-.415 3.217-.415 3.217-1.66a44.534 44.534 0 00-.415-7.264c-.414-1.558-.935-1.558-.935-1.558h-1.351s-1.558-1.659-2.18-1.659a12.808 12.808 0 00-2.415.631 2.119 2.119 0 00-.6.507l-.207 4.254a8.82 8.82 0 01-3.116 3.116c-1.872.936-3.01 2.909-1.245 3.531s7.785.521 9.237.106z"
            fill="#fff"
            stroke="#2d3a40"
            strokeWidth={1}
          />
          <path
            data-name="Path 5169"
            d="M134.609 98.211c3.127 0 5.661-3.612 5.661-8.066s-2.534-8.066-5.661-8.066-5.66 3.611-5.66 8.066 2.534 8.066 5.66 8.066z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5170"
            d="M135.568 98.211c3.127 0 5.661-3.612 5.661-8.066s-2.534-8.066-5.661-8.066-5.66 3.611-5.66 8.066 2.534 8.066 5.66 8.066z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5171"
            d="M136.7 90.145c0 .89-.507 1.613-1.134 1.613s-1.133-.724-1.133-1.613.507-1.613 1.133-1.613 1.134.723 1.134 1.613z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5172"
            d="M138.854 101.746c4.5 0 8.144-5.194 8.144-11.6s-3.646-11.6-8.144-11.6-8.145 5.194-8.145 11.6 3.646 11.6 8.145 11.6z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5173"
            d="M140.236 101.746c4.5 0 8.144-5.194 8.144-11.6s-3.646-11.6-8.144-11.6-8.145 5.194-8.145 11.6 3.646 11.6 8.145 11.6z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5174"
            d="M236.877 90.909h-37.4c-1.037-1.387-2.8-1.844-2.291-1.844h39.691a.922.922 0 110 1.844z"
            fill="#263238"
          />
          <path
            data-name="Path 5175"
            d="M171.626 89.176a3.433 3.433 0 01.913-.023.876.876 0 00-.383-.083h-32.537a.922.922 0 100 1.844h28.951a5.4 5.4 0 013.052-1.733z"
            fill="#263238"
          />
          <path
            data-name="Path 5176"
            d="M240.258 101.746c4.5 0 8.145-5.194 8.145-11.6s-3.647-11.6-8.145-11.6-8.145 5.194-8.145 11.6 3.647 11.6 8.145 11.6z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5177"
            d="M241.64 101.746c4.5 0 8.144-5.194 8.144-11.6s-3.646-11.6-8.144-11.6-8.145 5.194-8.145 11.6 3.647 11.6 8.145 11.6z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5178"
            d="M243.851 98.211c3.126 0 5.66-3.612 5.66-8.066s-2.534-8.066-5.66-8.066-5.661 3.611-5.661 8.066 2.535 8.066 5.661 8.066z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5179"
            d="M244.81 98.211c3.126 0 5.66-3.612 5.66-8.066s-2.534-8.066-5.66-8.066-5.661 3.611-5.661 8.066 2.535 8.066 5.661 8.066z"
            fill="#7a7a7a"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5180"
            d="M245.945 90.145c0 .89-.507 1.613-1.134 1.613s-1.134-.724-1.134-1.613.507-1.613 1.134-1.613 1.134.723 1.134 1.613z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5181"
            d="M157.623 87.1s-4.6 1.023-4.715 1.364a2.154 2.154 0 00.512 1.816c.511.456 5.734-.17 6.19-.341s.226-1.475.171-2.213-2.158-.626-2.158-.626z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5182"
            d="M158.647 95.938s3.009-5.43 3.009-6.057-3.235-2.383-3.466-3.01-1.078 0-.737 1.134a5.492 5.492 0 00.853 1.761l.511.567s-3.01 2.047-3.8 3.466 2.1 2.157 2.1 2.157"
            fill="#fff"
          />
          <path
            data-name="Path 5183"
            d="M158.647 95.938s3.009-5.43 3.009-6.057-3.235-2.383-3.466-3.01-1.078 0-.737 1.134a5.492 5.492 0 00.853 1.761l.511.567s-3.01 2.047-3.8 3.466 2.1 2.157 2.1 2.157"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5184"
            d="M212.368 86.526s5.383 0 5.752.622l.374.622s0 1.867-.466 1.973a34.61 34.61 0 01-5.845.106c-1.207-.207-.465-2.489-.465-3.116s.65-.207.65-.207z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5185"
            d="M213.881 92.273a23.958 23.958 0 00-1.614-2.424c-.414-.415-1.659-1.351-1.659-1.351s2.489-.622 2.489-1.35-1.244-.622-1.765-.207-2.388.313-2.388 1.143-.415 2.908.207 3.738a32.339 32.339 0 003.116 2.909"
            fill="#fff"
          />
          <path
            data-name="Path 5186"
            d="M213.881 92.273a23.958 23.958 0 00-1.614-2.424c-.414-.415-1.659-1.351-1.659-1.351s2.489-.622 2.489-1.35-1.244-.622-1.765-.207-2.388.313-2.388 1.143-.415 2.908.207 3.738a32.339 32.339 0 003.116 2.909"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5187"
            d="M166.1 66.12a9.74 9.74 0 00-1.166 5.914c.622 4.047 1.037 7.37 1.037 7.37a9.407 9.407 0 00.729 4.254c.935 2.074 4.047 5.5 5.291 5.5a12.572 12.572 0 005.19-1.973c1.973-1.143 3.738-4.254 3.738-4.983v-1.973s1.867-1.351 2.075-2.7a19.179 19.179 0 00.106-3.217 14.305 14.305 0 00-1.867-8.3c-2.388-3.84-7.656-3.95-11.417-3.01a6.109 6.109 0 00-3.716 3.118z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5188"
            d="M169.825 62.054a4.968 4.968 0 00-3.724 4.07 14.922 14.922 0 01-.719 1.65l.074.009s.106-.521.935-.207 1.143 1.143 3.84.728 5.291-2.18 6.227-1.452.622 3.531.521 5.291 2.388 1.452 2.388 1.452.414 2.388 1.244 1.867 1.037-2.7 2.489-1.143c0 0 1.2-5.808-1.189-9.652s-8.325-3.558-12.086-2.618z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5189"
            d="M174.691 77.795c0 .484-.254.88-.572.88s-.571-.392-.571-.88.253-.88.571-.88.572.391.572.88z"
            fill="#263238"
          />
          <path
            data-name="Path 5190"
            d="M168.671 77.795c0 .484-.253.88-.571.88s-.572-.392-.572-.88.254-.88.572-.88.571.391.571.88z"
            fill="#263238"
          />
          <path
            data-name="Path 5191"
            d="M169.916 77.643a14.594 14.594 0 01-.208 2.388c-.207 1.037-1.244 1.558-.414 1.765a8.431 8.431 0 001.765.207"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5192"
            d="M172.083 84.631a.8.8 0 01-.507.991c-.369.069-.733-.267-.821-.747a.8.8 0 01.507-.991c.369-.069.733.267.821.747z"
            fill="#263238"
          />
          <path
            data-name="Path 5193"
            d="M171.782 76.191s2.18-1.143 3.84-.521"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5194"
            d="M169.293 76.814a4.38 4.38 0 00-2.388-.936"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5195"
            d="M161.163 68.3c2.618-1.811 4.217-.525 4.217-.525s-4.618 1.53-4.618 4.554"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5196"
            d="M163.828 75.836s-2.623-2.005-2.733-.664c-.083.996 2.733.664 2.733.664z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5197"
            d="M163.826 77.413s-2.484.083-2.816 1.327 2.816-1.327 2.816-1.327z"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5198"
            d="M68.129 105.717s-1.074 8.144-1.383 13.058 0 24.121-.152 25.042a52.765 52.765 0 00.306 5.683s-4.3 8.449-4.918 14.137-2.457 23.046-2.457 23.046l5.07-.152s5.531-16.285 8.3-20.894 6.914-15.363 7.836-18.437 6.605-18.9 6.605-18.9 10.14 14.289 12.293 16.594a57.811 57.811 0 015.071 7.066 39.2 39.2 0 001.535 11.371c1.691 5.071 5.531 10.45 7.222 16.9.53 2.023 1.231 6.605 1.231 6.605l5.531-.922s-.415-3.144-.769-9.371a176.988 176.988 0 00-4.762-32.113c-.461-1.231-4.918-17.824-8.145-22.738s-5.07-7.836-5.07-7.836l-3.379-6.453a140.295 140.295 0 01-16.746 1.231 29.292 29.292 0 01-13.215-2.918z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5199"
            d="M106.543 121.7c-3.227-4.918-5.071-7.836-5.071-7.836l-3.378-6.453a140.3 140.3 0 01-16.746 1.231 29.292 29.292 0 01-13.215-2.918s-1.074 8.145-1.383 13.058c-.235 3.771-.111 15.953-.106 21.839a95.543 95.543 0 0015.644 1.946c2-5.753 5.052-14.257 5.052-14.257s6.218 8.758 9.947 13.667a73.032 73.032 0 0015.561-3.679c-1.701-5.621-4.248-13.471-6.305-16.598z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5200"
            d="M121.293 181.771s-2.918-.77-2.918.309v.032a2.359 2.359 0 01-2.742 2.309c-.913-.147-1.72-.207-1.72.06 0 .613-1.064 6.352.47 7.274s4 0 5.38.922a13.382 13.382 0 007.066 1.535c2.613-.153 5.683-.152 4.3-2.614s-5.222-3.226-6.762-4.918a25.444 25.444 0 01-3.074-4.918z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5201"
            d="M65.521 182.845s-1.535-2-3.535-1.231a2.955 2.955 0 00-2 2.614s-1.231 4.761-2.153 5.379-2.3 4.609-.922 5.379 5.992.77 7.836 0 1.844-4 1.844-5.683.461-2.918.309-4.149a1.285 1.285 0 00-1.231-1.231l-.152-1.074z"
            fill="#263238"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5202"
            d="M85.057 57.779s-10.33 4.061-14.506 6.034-6.613 6.387-6.613 9.287 4.3 22.982 4.526 23.793-.7 10.33-.7 10.33 4.992 4.3 15.667 3.83 14.625-1.742 15.552-2.323.35-6.73.465-8.822 6.034-15.437 6.034-15.437 3.019 4.642 4.3 5.688a9.2 9.2 0 011.857 1.973s1.858 6.614 4.176 9.053 5.919 9.979 6.034 10.56-.581 1.857-.581 2.2-1.742 2.784-1.277 3.48 0 2.088.7 2.553a10.588 10.588 0 001.507.812 3.744 3.744 0 002.088 1.161 1.424 1.424 0 001.507-.926s3.019-1.858 3.134-3.6a16.223 16.223 0 00-1.742-8.007c-1.627-3.364-3.946-15.086-5.222-17.99a50.25 50.25 0 00-3.946-6.73l-6.852-12.768s-2.784-6.384-6.154-8.587-9.052-3.83-11.491-4.526a59.059 59.059 0 00-8.472-1.046z"
            fill="#6552cc"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5203"
            d="M83.086 56.733a36.359 36.359 0 00.23 5.453c.346 2.434 2.669 4.526 6.153 5.338s5.573-1.742 6.384-3.25a10.524 10.524 0 00.7-4.3 6.733 6.733 0 01-7.2.581 51.858 51.858 0 01-6.269-3.83z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5204"
            d="M94.239 61.111a6.448 6.448 0 01-4.89-.549 54.459 54.459 0 01-5.96-3.609l-.313.083a35.112 35.112 0 00.24 5.153 4.853 4.853 0 00.336 1.18 9.288 9.288 0 003.8 1.268c5.692.567 8.688-2.558 8.688-2.558l-1.9-.973z"
            fill="#263238"
            stroke="#263238"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5205"
            d="M80.762 63.117s1.627 4.526 3.946 6.269"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5206"
            d="M97.59 65.555a26.4 26.4 0 01-1.742 5.573"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5207"
            d="M109.813 79.747a13.006 13.006 0 001.24-2.12"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5208"
            d="M108.726 77.147c-1.364 3.383-3.245 7.324-3.245 7.324a31.284 31.284 0 003.365-3.466"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5209"
            d="M109.893 73.912a26.182 26.182 0 01-.641 1.894"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5210"
            d="M108.036 84.587a31.944 31.944 0 004.877-4.061"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5211"
            d="M125.407 103.955a57.837 57.837 0 01-6 2.743 44.474 44.474 0 012.438 5.047c.116.581-.58 1.858-.58 2.2s-1.743 2.784-1.277 3.48 0 2.088.7 2.554a10.643 10.643 0 001.507.811 3.753 3.753 0 002.088 1.162 1.423 1.423 0 001.507-.927s3.02-1.857 3.135-3.6a16.223 16.223 0 00-1.743-8.006 37.263 37.263 0 01-1.779-5.471z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5212"
            d="M72.4 84.126s2.669-3.019 4.176-5.222"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5213"
            d="M72.756 84.937a10.638 10.638 0 004.644-2.669"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5214"
            d="M69.385 102a14.109 14.109 0 006.73 2.323"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5215"
            d="M94.29 103.443a28.146 28.146 0 01-8.186 3.43"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5216"
            d="M97.705 100.839a16.475 16.475 0 01-1.936 1.609"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5217"
            d="M77.626 105.942a41.392 41.392 0 0011.025-1.507"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5218"
            d="M98.627 48.768s.807-.23.807 1.328a7.92 7.92 0 01-.922 3.231z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5219"
            d="M81.071 49.938s-2.06-1.733-2.388.977a3.507 3.507 0 002.388 3.9h.429a7.479 7.479 0 001.95 4.337c1.733 1.627 5.637 4.01 7.591 4.337a5.8 5.8 0 005.1-1.41 12.377 12.377 0 002.388-6.07c0-1.627.217-9.868.217-11.058s.65-4.665-3.794-7.048-12.146.433-13.768 2.71-.111 9.325-.111 9.325z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5220"
            d="M89.507 54.327a1.1 1.1 0 00.867 1.194c.977.217 3.254.544 3.9-.217a1.921 1.921 0 00.327-1.733"
            fill="#fff"
          />
          <path
            data-name="Path 5221"
            d="M89.507 54.327a1.1 1.1 0 00.867 1.194c.977.217 3.254.544 3.9-.217a1.921 1.921 0 00.327-1.733"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5222"
            d="M93.834 57.419s-3.577-.111-4.01.76 3.577 1.59 4.987.111c.871-.917-.977-.867-.977-.867z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5223"
            d="M89.119 51.353c0 .6-.244 1.1-.549 1.1s-.549-.493-.549-1.1.244-1.1.549-1.1.549.496.549 1.1z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5224"
            d="M95.627 51.077c0 .6-.244 1.1-.549 1.1s-.549-.493-.549-1.1.244-1.1.549-1.1.549.497.549 1.1z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5225"
            d="M85.984 48.6a2.983 2.983 0 013.176.346z"
            fill="#fff"
          />
          <path
            data-name="Path 5226"
            d="M85.984 48.6a2.983 2.983 0 013.176.346"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5227"
            d="M94.181 48.652a2.962 2.962 0 012.54-.576z"
            fill="#fff"
          />
          <path
            data-name="Path 5228"
            d="M94.181 48.652a2.962 2.962 0 012.54-.576"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5229"
            d="M92.949 90.855s2.438.35 2.669 1.858-1.392 2.9-2.9 3.83-6.153-2.2-6.849-4.176 7.08-1.507 7.08-1.507z"
            fill="#afbf6e"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5230"
            d="M68.459 65.555a16.093 16.093 0 00-6.269 5.573c-2.088 3.6-4.641 15.552-5.453 19.732s-1.046 10.1-.231 10.33 14.275-1.507 18.221-1.743 8.7-.926 8.7-.926 6.269 1.742 7.2 1.392 2.438-2.669 2.438-2.669a13.48 13.48 0 003.019-2.438c.581-.931.465-1.507-.7-1.046a8.058 8.058 0 01-3.715.811c-1.858 0-3.715-2.088-3.715-2.088l1.277-.7a12.687 12.687 0 003.019 0c.811-.23.926-1.742.23-1.857a35.166 35.166 0 00-3.6-.115c-.931 0-2.669-.926-3.83-.115a45.207 45.207 0 00-3.48 3.019s-6.153.811-7.661.581-3.6-.7-3.6-.7 2.2-4.176 2.323-5.688-.115-2.784.115-6.154"
            fill="#6552cc"
          />
          <path
            data-name="Path 5231"
            d="M68.459 65.555a16.093 16.093 0 00-6.269 5.573c-2.088 3.6-4.641 15.552-5.453 19.732s-1.046 10.1-.231 10.33 14.275-1.507 18.221-1.743 8.7-.926 8.7-.926 6.269 1.742 7.2 1.392 2.438-2.669 2.438-2.669a13.48 13.48 0 003.019-2.438c.581-.931.465-1.507-.7-1.046a8.058 8.058 0 01-3.715.811c-1.858 0-3.715-2.088-3.715-2.088l1.277-.7a12.687 12.687 0 003.019 0c.811-.23.926-1.742.23-1.857a35.166 35.166 0 00-3.6-.115c-.931 0-2.669-.926-3.83-.115a45.207 45.207 0 00-3.48 3.019s-6.153.811-7.661.581-3.6-.7-3.6-.7 2.2-4.176 2.323-5.688-.115-2.784.115-6.154"
            fill="none"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5232"
            d="M70.094 92.7s-3.729-.733-6.213-1.1"
            fill="none"
            stroke="#6552cc"
            strokeWidth={1}
          />
          <path
            data-name="Path 5233"
            d="M95.387 93.759a8 8 0 01-3.715.811c-1.858 0-3.715-2.088-3.715-2.088l1.277-.7a12.692 12.692 0 003.019 0c.811-.23.926-1.742.23-1.858a35.2 35.2 0 00-3.6-.115c-.931 0-2.669-.927-3.83-.115a45.2 45.2 0 00-3.48 3.019s-6.153.811-7.661.581l-.258-.041a23.456 23.456 0 00-.489 6.315c.608-.055 1.138-.1 1.558-.12 3.946-.231 8.7-.927 8.7-.927s6.269 1.743 7.2 1.392 2.438-2.669 2.438-2.669a13.478 13.478 0 003.019-2.438c.581-.926.465-1.507-.7-1.046z"
            fill="#fff"
            stroke="#263238"
            strokeWidth={1}
          />
          <path
            data-name="Path 5234"
            d="M263.5 62A26.5 26.5 0 10237 35.5 26.5 26.5 0 00263.5 62z"
            fill="#3e479b"
          />
          <path
            data-name="Path 5235"
            d="M263.5 59.584A24.084 24.084 0 10239.416 35.5 24.085 24.085 0 00263.5 59.584z"
            fill="#fff"
            opacity={0.55}
          />
          <path
            data-name="Path 5236"
            d="M263.5 57.126A21.626 21.626 0 10241.874 35.5 21.627 21.627 0 00263.5 57.126z"
            fill="#fff"
          />
          <path
            data-name="Path 5237"
            d="M263.485 14.82h-.043a.562.562 0 00-.562.562V18.2a.562.562 0 00.562.562h.043a.562.562 0 00.562-.562v-2.818a.562.562 0 00-.562-.562z"
            fill="#373449"
          />
          <path
            data-name="Path 5238"
            d="M263.558 52.241h-.043a.562.562 0 00-.562.562v2.815a.562.562 0 00.562.562h.043a.562.562 0 00.562-.562V52.8a.562.562 0 00-.562-.559z"
            fill="#373449"
          />
          <path
            data-name="Path 5239"
            d="M284.18 35.485v-.042a.563.563 0 00-.563-.562H280.8a.563.563 0 00-.563.562v.042a.563.563 0 00.563.562h2.814a.563.563 0 00.566-.562z"
            fill="#373449"
          />
          <path
            data-name="Path 5240"
            d="M246.759 35.558v-.042a.562.562 0 00-.562-.562h-2.815a.563.563 0 00-.563.562v.042a.563.563 0 00.563.562h2.818a.562.562 0 00.559-.562z"
            fill="#373449"
          />
          <path
            data-name="Path 5241"
            d="M277.645 21.273l.031.03a.562.562 0 010 .8l-1.028 1.028a.563.563 0 01-.8 0l-.03-.03a.562.562 0 010-.8l1.028-1.028a.562.562 0 01.799 0z"
            fill="#373449"
          />
          <path
            data-name="Path 5242"
            d="M251.361 47.655l.03.03a.562.562 0 010 .8l-1.265 1.264a.562.562 0 01-.8 0l-.03-.03a.562.562 0 010-.8l1.265-1.264a.562.562 0 01.8 0z"
            fill="#373449"
          />
          <path
            data-name="Path 5243"
            d="M277.728 49.662l-.03.03a.562.562 0 01-.795 0l-1.028-1.028a.562.562 0 010-.8l.031-.03a.562.562 0 01.795 0l1.028 1.028a.562.562 0 01-.001.8z"
            fill="#373449"
          />
          <path
            data-name="Path 5244"
            d="M251.343 23.381l-.03.03a.562.562 0 01-.795 0l-1.264-1.265a.562.562 0 010-.8l.03-.03a.562.562 0 01.795 0l1.265 1.265a.562.562 0 01-.001.8z"
            fill="#373449"
          />
          <path
            data-name="Path 5245"
            d="M263.517 21.013h-.049a.62.62 0 00-.62.62v13.582a.62.62 0 00.62.62h.049a.62.62 0 00.62-.62V21.633a.62.62 0 00-.62-.62z"
            fill="#3e479b"
          />
          <path
            data-name="Path 5246"
            d="M273.479 36.343v-.049a.62.62 0 00-.62-.62h-9.392a.62.62 0 00-.62.62v.049a.62.62 0 00.62.62h9.392a.62.62 0 00.62-.62z"
            fill="#3e479b"
          />
          <path
            data-name="Path 5247"
            d="M255 43l9-8"
            fill="none"
            stroke="#373449"
            strokeLinecap="round"
            strokeWidth={1}
          />
          <path
            data-name="Path 5248"
            d="M263.5 37.835a2.336 2.336 0 10-2.336-2.336 2.336 2.336 0 002.336 2.336z"
            fill="#4c65ba"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function HealthIssuesIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 114,
    height: 114,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 114 114"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 105556" transform="translate(-71.805 -202.805)">
        <circle
          data-name="Ellipse 39409"
          cx={57}
          cy={57}
          r={57}
          transform="translate(71.805 202.805)"
          fill="rgba(255,255,255,0.5)"
          opacity={0.5}
        />
        <circle
          data-name="Ellipse 39383"
          cx={50.782}
          cy={50.782}
          r={50.782}
          transform="translate(78.023 209.023)"
          fill="rgba(255,255,255,0.5)"
        />
        <path
          data-name="Path 4206"
          d="M77.653 185.106H53.908a9.851 9.851 0 00-9.851 9.851v8.943H87.5v-8.943a9.851 9.851 0 00-9.847-9.851z"
          transform="translate(102.808 218.602) translate(-39.787 -127.762)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 4207"
          d="M77.95 58.343c-.041 0-.081.005-.122.006v-1.808a19.316 19.316 0 00-38.631 0v1.808c-.041 0-.081-.006-.122-.006a5.84 5.84 0 100 11.68 6.033 6.033 0 00.632-.035 19.354 19.354 0 0037.61 0 6.033 6.033 0 00.632.035 5.84 5.84 0 100-11.68z"
          transform="translate(102.808 218.602) translate(-32.69 -29.051)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 4208"
          d="M57.177 84.093a19.853 19.853 0 01-19.315-14.745 6.5 6.5 0 01-.662-12.983V55.2a19.98 19.98 0 0139.957 0v1.161a6.5 6.5 0 01-.541 12.984h-.123a19.854 19.854 0 01-19.316 14.748zm-18.8-16.105a.663.663 0 01.645.511 18.69 18.69 0 0036.319 0 .663.663 0 01.716-.508 5.278 5.278 0 00.562.031 5.176 5.176 0 100-10.352c-.052 0-.084.006-.115.006a.681.681 0 01-.476-.19.664.664 0 01-.2-.473V55.2a18.653 18.653 0 00-37.3 0v1.808a.664.664 0 01-.2.473.689.689 0 01-.476.19h-.095a5.176 5.176 0 10.548 10.32.641.641 0 01.071 0z"
          transform="translate(102.808 218.602) translate(-31.183 -27.714)"
          fill="#464c55"
        />
        <path
          data-name="Path 4209"
          d="M91.889 176.006a19.365 19.365 0 01-8.765-2.081v3.345a8.762 8.762 0 1017.524 0v-3.343a19.364 19.364 0 01-8.76 2.079z"
          transform="translate(102.808 218.602) translate(-65.895 -120.291)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 4210"
          d="M86.167 195.756H42.72a.664.664 0 01-.663-.663v-8.943a10.526 10.526 0 0110.514-10.514h2.445v-3.047a.663.663 0 01.963-.592A18.831 18.831 0 0072.9 172a.664.664 0 01.963.592v3.044h2.449a10.526 10.526 0 0110.514 10.514v8.943a.663.663 0 01-.659.663zm-42.784-1.327H85.5v-8.28a9.2 9.2 0 00-9.187-9.187h-3.118a.663.663 0 01-.663-.692c0-.111.009-.224.009-.337v-2.295a20.187 20.187 0 01-16.2 0v2.3c0 .113 0 .226.009.338a.663.663 0 01-.663.691h-3.116a9.2 9.2 0 00-9.187 9.187v8.28z"
          transform="translate(102.808 218.602) translate(-38.45 -118.954)"
          fill="#464c55"
        />
        <path
          data-name="Path 4211"
          d="M54.42 39.755H35.134v-6.7a18.828 18.828 0 0118.828-18.824h5.416a4.957 4.957 0 014.957 4.957v10.654a9.914 9.914 0 01-9.915 9.913z"
          transform="translate(102.808 218.602) translate(-33.823 -13.568)"
          fill="#464c55"
        />
        <path
          data-name="Path 4212"
          d="M143.025 39.093H131.8a8.635 8.635 0 01-8.635-8.635v-11.7a4.53 4.53 0 014.53-4.53 15.329 15.329 0 0115.329 15.329z"
          transform="translate(102.808 218.602) translate(-92.655 -13.568)"
          fill="#464c55"
        />
        <path
          data-name="Path 4213"
          d="M41.255 91.18v4.054a5.9 5.9 0 013.215-.95c.041 0 .081.005.122.006v-1.808c0-.438.018-.872.047-1.3h-3.384z"
          transform="translate(102.808 218.602) translate(-37.914 -64.992)"
          fill="#464c55"
        />
        <path
          data-name="Path 4214"
          d="M167.466 89.182a19.139 19.139 0 01.1 1.965v1.808c.041 0 .081-.006.122-.006a5.9 5.9 0 013.211.947v-4.714z"
          transform="translate(102.808 218.602) translate(-122.261 -63.657)"
          fill="#464c55"
        />
        <path
          data-name="Path 4217"
          d="M102.466 142.772h-9.945a1.01 1.01 0 01-1.01-1.01 4.6 4.6 0 014.6-4.6h2.769a4.6 4.6 0 014.6 4.6 1.01 1.01 0 01-1.014 1.01z"
          transform="translate(102.808 218.602) translate(-71.5 -95.723)"
          fill="#ffc7a2"
        />
        <g data-name="Group 5030" fill="#464c55">
          <path
            data-name="Path 4218"
            d="M53.084 39.082H33.8a.664.664 0 01-.663-.663v-6.7a19.513 19.513 0 0119.488-19.488h5.416a5.626 5.626 0 015.62 5.62V28.5a10.589 10.589 0 01-10.577 10.582zm-18.623-1.327h18.623a9.261 9.261 0 009.25-9.25V17.851a4.3 4.3 0 00-4.293-4.293h-5.416a18.185 18.185 0 00-18.164 18.164z"
            transform="translate(102.808 218.602) translate(.647) translate(-33.134 -12.231)"
          />
          <path
            data-name="Path 4219"
            d="M141.688 38.42h-11.224a9.309 9.309 0 01-9.3-9.3v-11.7a5.2 5.2 0 015.194-5.193 16.01 16.01 0 0115.992 15.992v9.532a.663.663 0 01-.662.669zm-15.329-24.862a3.871 3.871 0 00-3.867 3.867v11.7a7.981 7.981 0 007.972 7.972h10.56v-8.873a14.682 14.682 0 00-14.665-14.666z"
            transform="translate(102.808 218.602) translate(.647) translate(-91.965 -12.232)"
          />
          <path
            data-name="Path 4220"
            d="M39.918 94.562a.663.663 0 01-.663-.663v-4.055a.664.664 0 01.663-.663H43.3a.664.664 0 01.662.709c-.031.447-.045.859-.045 1.257v1.808a.664.664 0 01-.2.473.689.689 0 01-.476.19H43.139a5.247 5.247 0 00-2.865.842.658.658 0 01-.356.102zm.663-4.054V92.8a6.553 6.553 0 012.011-.492v-1.161c0-.209 0-.421.011-.639z"
            transform="translate(102.808 218.602) translate(.647) translate(-37.225 -63.657)"
          />
          <path
            data-name="Path 4221"
            d="M169.565 93.224a.665.665 0 01-.36-.106 5.245 5.245 0 00-2.851-.841c-.048 0-.08.006-.112.006a.681.681 0 01-.476-.19.664.664 0 01-.2-.473v-1.808a18.568 18.568 0 00-.1-1.9.663.663 0 01.66-.731h3.436a.664.664 0 01.663.663v4.714a.662.662 0 01-.663.663zm-2.665-2.252a6.573 6.573 0 012.006.491v-2.954h-2.056c.03.441.045.877.045 1.3z"
            transform="translate(102.808 218.602) translate(.647) translate(-121.57 -62.321)"
          />
          <path
            data-name="Path 4222"
            d="M101.131 142.1h-9.946a1.675 1.675 0 01-1.673-1.673 5.268 5.268 0 015.262-5.261h2.769a5.268 5.268 0 015.262 5.261 1.675 1.675 0 01-1.674 1.673zm-6.357-5.608a3.939 3.939 0 00-3.935 3.935.347.347 0 00.346.347h9.945a.347.347 0 00.346-.347 3.939 3.939 0 00-3.935-3.935z"
            transform="translate(102.808 218.602) translate(.647) translate(-70.811 -94.388)"
          />
        </g>
        <path
          data-name="Path 4223"
          d="M133.673 200.611a4.007 4.007 0 00-3.689.788 4.007 4.007 0 00-3.689-.788 4.107 4.107 0 00-2.542 5.4 4.332 4.332 0 001.449 1.976l4.256 3.283a.931.931 0 00.214.162.427.427 0 00.073.036.6.6 0 00.633-.079l.015-.012.015-.012.537-.432 3.819-2.945a4.334 4.334 0 001.449-1.976 4.107 4.107 0 00-2.54-5.401z"
          transform="translate(102.808 218.602) translate(-90.938 -137.146)"
          fill="#ffc7a2"
        />
        <path
          data-name="Path 4224"
          d="M147.467 219.161a.572.572 0 01-.4-.16l-2.056-1.977a.577.577 0 01-.161-.283l-.684-2.937a.573.573 0 011.117-.26l.645 2.772 1.933 1.86a.573.573 0 01-.4.986z"
          transform="translate(102.808 218.602) translate(-105.681 -146.171)"
          fill="#464c55"
        />
        <path
          data-name="Path 4225"
          d="M140.779 219.334a.6.6 0 01-.109-.01l-2.16-.416a.573.573 0 01.217-1.126l2.16.416a.573.573 0 01-.108 1.136z"
          transform="translate(102.808 218.602) translate(-101.323 -149.503)"
          fill="#464c55"
        />
        <path
          data-name="Path 4226"
          d="M128.578 210.672a1.217 1.217 0 01-.483-.1.853.853 0 01-.135-.067 1.544 1.544 0 01-.3-.225l-4.227-3.26a4.934 4.934 0 01-1.436-6.078 4.458 4.458 0 012.712-2.3 4.54 4.54 0 013.855.622 4.537 4.537 0 013.855-.622 4.458 4.458 0 012.712 2.3 4.933 4.933 0 01-1.439 6.079l-3.817 2.944-.527.425-.023.018-.021.015a1.188 1.188 0 01-.726.249zm-.038-1.159a.167.167 0 00.04.013.281.281 0 00.029-.018l.017-.013.537-.433 3.829-2.953a3.789 3.789 0 001.111-4.657 3.323 3.323 0 00-2.02-1.718 3.429 3.429 0 00-3.16.683.572.572 0 01-.726 0 3.431 3.431 0 00-3.16-.683 3.323 3.323 0 00-2.019 1.718 3.787 3.787 0 001.1 4.648l.011.009 4.257 3.283a.571.571 0 01.071.066.469.469 0 00.07.049l.012.007zm-.017-.007h.008z"
          transform="translate(102.808 218.602) translate(-89.515 -135.72)"
          fill="#464c55"
        />
        <path
          data-name="Path 4227"
          d="M.341 8.644a.82.82 0 01.09-1.387L4.5 5.062l-1.044-.75a.82.82 0 01.089-1.387L8.775.1a.82.82 0 01.78 1.443l-4.078 2.2 1.045.757a.82.82 0 01-.09 1.387L1.209 8.7a.82.82 0 01-.868-.056z"
          transform="translate(102.808 218.602) rotate(7 -398.695 425.462)"
          fill="#464c55"
        />
        <path
          data-name="Path 4228"
          d="M12.279.456a.82.82 0 01-.729 1.183l-4.624.034.574 1.152a.82.82 0 01-.73 1.184l-5.944.048a.82.82 0 01-.013-1.64l4.635-.037-.572-1.153A.82.82 0 015.605.044L11.539 0a.82.82 0 01.74.456z"
          transform="translate(102.808 218.602) rotate(7 -474.774 433.947)"
          fill="#464c55"
        />
        <path
          data-name="Path 4229"
          d="M1.812 12.591A.82.82 0 01.9 11.547l1.325-4.43-1.273.208a.82.82 0 01-.918-1.044l1.7-5.7a.82.82 0 011.571.469L1.98 5.5l1.27-.208a.82.82 0 01.918 1.044l-1.7 5.685a.82.82 0 01-.656.57z"
          transform="translate(102.808 218.602) rotate(7 -348.814 391.378)"
          fill="#464c55"
        />
        <path
          data-name="Path 4230"
          d="M17.085 57.373s.383 8.5 8.7 8.5 9.222-8.5 9.222-8.5"
          fill="none"
          stroke="#464c55"
          strokeWidth={2}
          transform="translate(102.808 218.602)"
        />
        <g data-name="Group 5032">
          <g data-name="Group 4617">
            <g
              data-name="Group 4615"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={2}
              transform="translate(102.808 218.602) translate(16.371 31.79)"
            >
              <path
                data-name="Line 268"
                transform="rotate(-25 11.465 -34.018)"
                d="M0 0L3.924 0"
              />
              <path
                data-name="Line 269"
                transform="rotate(25)"
                d="M0 0L3.924 0"
              />
            </g>
          </g>
          <g data-name="Group 5031">
            <g
              data-name="Group 4615"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={2}
              transform="translate(102.808 218.602) translate(16.371 31.79) translate(0 2.071)"
            >
              <path
                data-name="Line 268"
                transform="rotate(25 7.726 34.847)"
                d="M0 0L3.924 0"
              />
              <path
                data-name="Line 269"
                transform="rotate(-25 3.74 .829)"
                d="M0 0L3.924 0"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function HealthQueriesIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 114,
    height: 114,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 114 114"
      sx={rootSx}
      {...rest}
    >
      <g data-name="Group 105557" transform="translate(-71.77 -537.77)">
        <circle
          data-name="Ellipse 39409"
          cx={57}
          cy={57}
          r={57}
          transform="translate(71.77 537.77)"
          fill="rgba(255,255,255,0.5)"
          opacity={0.5}
        />
        <circle
          data-name="Ellipse 39384"
          cx={50.782}
          cy={50.782}
          r={50.782}
          transform="translate(77.988 543.988)"
          fill="rgba(255,255,255,0.5)"
        />
        <g data-name="Group 4596">
          <g data-name="Group 4595">
            <path
              data-name="Path 771"
              d="M89 296.434v4.826a1.7 1.7 0 00.366 1.053l6.36 8.037a1.131 1.131 0 001.765.009l6.5-8.043a1.7 1.7 0 00.377-1.065v-4.709A16.675 16.675 0 0189 296.434zm0 0"
              transform="translate(99.347 559.953) translate(-74.259 -247.161)"
              fill="#ffd8be"
            />
            <path
              data-name="Path 773"
              d="M199.1 119.5h-1.175a4.638 4.638 0 01-4.639-4.638v-12.856a4.638 4.638 0 014.639-4.639h1.175a4.639 4.639 0 014.639 4.639v12.853a4.638 4.638 0 01-4.639 4.641zm0 0"
              transform="translate(99.347 559.953) translate(-161.207 -81.183)"
              fill="#464c55"
            />
            <path
              data-name="Path 774"
              d="M19.6 118.689h-1.172a4.638 4.638 0 01-4.639-4.639V101.2a4.639 4.639 0 014.639-4.639H19.6a4.639 4.639 0 014.639 4.639v12.85a4.639 4.639 0 01-4.639 4.639zm0 0"
              transform="translate(99.347 559.953) translate(-11.546 -80.509)"
              fill="#464c55"
            />
            <path
              data-name="Path 775"
              d="M196.372 116.827H195.2a5.309 5.309 0 01-5.3-5.3V98.671a5.309 5.309 0 015.3-5.3h1.175a5.309 5.309 0 015.3 5.3v12.853a5.309 5.309 0 01-5.303 5.303zM195.2 94.7a3.978 3.978 0 00-3.974 3.974v12.853a3.978 3.978 0 003.974 3.973h1.175a3.978 3.978 0 003.974-3.973V98.671a3.978 3.978 0 00-3.974-3.974zm0 0"
              transform="translate(99.347 559.953) translate(-158.38 -77.848)"
              fill="#464c55"
            />
            <path
              data-name="Path 776"
              d="M16.876 116.018H15.7a5.309 5.309 0 01-5.3-5.3V97.862a5.31 5.31 0 015.3-5.3h1.175a5.31 5.31 0 015.3 5.3v12.853a5.31 5.31 0 01-5.299 5.303zM15.7 93.888a3.978 3.978 0 00-3.974 3.974v12.853a3.978 3.978 0 003.974 3.974h1.175a3.978 3.978 0 003.974-3.974V97.862a3.978 3.978 0 00-3.974-3.974zm0 0"
              transform="translate(99.347 559.953) translate(-8.719 -77.174)"
              fill="#464c55"
            />
            <path
              data-name="Path 777"
              d="M42.327 78.085c-.036 0-.07.005-.105.006v-1.576a16.672 16.672 0 00-33.344 0v1.575c-.035 0-.069-.006-.105-.006a5.087 5.087 0 10.546 10.143 16.669 16.669 0 0032.462 0 5.086 5.086 0 10.546-10.143zm0 0"
              transform="translate(99.347 559.953) translate(-3.123 -49.897)"
              fill="#ffd8be"
            />
            <g data-name="Group 4617">
              <g
                data-name="Group 4615"
                transform="translate(99.347 559.953) translate(13.731 26.726)"
              >
                <g
                  data-name="Group 4618"
                  transform="translate(.147 2.391)"
                  fill="#464c55"
                >
                  <ellipse
                    data-name="Ellipse 39387"
                    cx={1.295}
                    cy={2.073}
                    rx={1.295}
                    ry={2.073}
                  />
                  <ellipse
                    data-name="Ellipse 39388"
                    cx={1.555}
                    cy={2.073}
                    rx={1.555}
                    ry={2.073}
                    transform="translate(14.509)"
                  />
                </g>
                <path
                  data-name="Line 268"
                  transform="translate(14.957)"
                  fill="none"
                  stroke="#464c55"
                  strokeLinecap="round"
                  strokeWidth={3}
                  d="M0 0L2.942 0"
                />
                <path
                  data-name="Line 269"
                  fill="none"
                  stroke="#464c55"
                  strokeLinecap="round"
                  strokeWidth={3}
                  d="M0 0L2.942 0"
                />
                <path
                  data-name="Path 926"
                  d="M5.639 14.433a6.517 6.517 0 006.342 0"
                  fill="none"
                  stroke="#464c55"
                  strokeLinecap="round"
                  strokeWidth={2}
                />
              </g>
            </g>
            <g data-name="Group 4584">
              <path
                data-name="Path 781"
                d="M22.826 98.428A17.253 17.253 0 016.082 85.587h-.033a5.751 5.751 0 01-.56-11.476v-.931a17.336 17.336 0 1134.673 0v.932a5.751 5.751 0 01-.593 11.475 17.252 17.252 0 01-16.743 12.841zM6.595 84.227a.665.665 0 01.647.514 16 16 0 0031.167 0 .666.666 0 01.718-.51 4.514 4.514 0 00.475.027 4.422 4.422 0 00.006-8.843c-.044 0-.071.005-.1.006H39.5a.666.666 0 01-.665-.665V73.18a16.007 16.007 0 10-32.014 0v1.575a.663.663 0 01-.2.474.67.67 0 01-.479.19h-.084a4.421 4.421 0 10-.007 8.842 4.344 4.344 0 00.475-.027h.071zm0 0"
                transform="translate(99.347 559.953) translate(0 9.282) translate(-.297 -55.844)"
                fill="#464c55"
              />
            </g>
            <path
              data-name="Path 785"
              d="M41.178 8.048h-2.865A5.839 5.839 0 0033.1 11.39a.405.405 0 01-.731.013 5.555 5.555 0 00-4.589-2.95C15.7 8.105 8.5 5.158 6.214 4.056a.565.565 0 00-.8.529v11.86a7.785 7.785 0 007.664 7.9h11.115a8.825 8.825 0 007.658-4.527.41.41 0 01.759.132 5.19 5.19 0 004.96 4.019h8.591a2.267 2.267 0 002.2-2.325v-6.012a7.394 7.394 0 00-7.187-7.584zm0 0"
              transform="translate(99.347 559.953) translate(-4.563 -3.336)"
              fill="#464c55"
            />
            <path
              data-name="Path 786"
              d="M21.467 21.675H10.351a8.459 8.459 0 01-8.328-8.565V1.249A1.244 1.244 0 012.606.188 1.205 1.205 0 013.777.121c2.472 1.189 9.5 3.991 21.3 4.331A6.171 6.171 0 0130 7.353a6.455 6.455 0 015.589-3.306h2.864a8.067 8.067 0 017.847 8.248v6.014a2.935 2.935 0 01-2.869 2.99h-8.59a5.823 5.823 0 01-5.441-3.99 9.518 9.518 0 01-7.933 4.366zM3.353 1.392V13.11a7.128 7.128 0 007 7.236h11.115a8.206 8.206 0 007.08-4.191 1.062 1.062 0 011.067-.534 1.1 1.1 0 01.915.832 4.527 4.527 0 004.315 3.517h8.591a1.6 1.6 0 001.539-1.66V12.3a6.737 6.737 0 00-6.522-6.919h-2.865a5.167 5.167 0 00-4.614 2.971 1.07 1.07 0 01-1.912.035 4.867 4.867 0 00-4.038-2.6C13.212 5.441 6.03 2.656 3.353 1.392zm0 0"
              transform="translate(99.347 559.953) translate(-1.736)"
              fill="#464c55"
            />
            <path
              data-name="Path 787"
              d="M177.074 79.946a7.629 7.629 0 11-7.629-7.629 7.629 7.629 0 017.629 7.629zm0 0"
              transform="translate(99.347 559.953) translate(-134.969 -60.296)"
              fill="#ccaacb"
            />
            <path
              data-name="Path 788"
              d="M186.152 91.283a5.369 5.369 0 11-5.369-5.369 5.369 5.369 0 015.369 5.369zm0 0"
              transform="translate(99.347 559.953) translate(-146.307 -71.634)"
              fill="#ecd6e3"
            />
            <path
              data-name="Path 789"
              d="M251.4 102.066h-1.275a7.652 7.652 0 01-.111 5.651h1.386a.908.908 0 00.908-.908v-3.836a.909.909 0 00-.908-.907zm0 0"
              transform="translate(99.347 559.953) translate(-208.508 -85.101)"
              fill="#ccaacb"
            />
            <path
              data-name="Path 790"
              d="M31.9 102.066H6.322a.908.908 0 00-.908.908v3.836a.908.908 0 00.908.908h25.687a7.643 7.643 0 01-.111-5.651zm0 0"
              transform="translate(99.347 559.953) translate(-4.564 -85.101)"
              fill="#ccaacb"
            />
            <path
              data-name="Path 791"
              d="M166.716 84.9a8.294 8.294 0 118.294-8.295 8.3 8.3 0 01-8.294 8.295zm0-15.259a6.965 6.965 0 106.964 6.964 6.973 6.973 0 00-6.964-6.959zm0 0"
              transform="translate(99.347 559.953) translate(-132.139 -56.961)"
              fill="#464c55"
            />
            <path
              data-name="Path 792"
              d="M178.057 93.982a6.034 6.034 0 116.033-6.034 6.041 6.041 0 01-6.033 6.034zm0-10.737a4.7 4.7 0 104.7 4.7 4.709 4.709 0 00-4.7-4.7zm0 0"
              transform="translate(99.347 559.953) translate(-143.479 -68.299)"
              fill="#464c55"
            />
            <path
              data-name="Path 793"
              d="M248.673 105.044h-1.386a.665.665 0 01-.612-.924 6.986 6.986 0 00.1-5.159.665.665 0 01.622-.9h1.275a1.575 1.575 0 011.573 1.573v3.835a1.576 1.576 0 01-1.572 1.575zm-.446-1.33h.446a.243.243 0 00.243-.243v-3.836a.243.243 0 00-.243-.243h-.373a8.352 8.352 0 01-.075 4.322zm0 0"
              transform="translate(99.347 559.953) translate(-205.679 -81.762)"
              fill="#464c55"
            />
            <path
              data-name="Path 794"
              d="M29.283 105.047H3.6a1.574 1.574 0 01-1.573-1.573v-3.835A1.574 1.574 0 013.6 98.066h25.571a.664.664 0 01.623.9 6.99 6.99 0 00.1 5.159.664.664 0 01-.612.924zM3.6 99.4a.243.243 0 00-.243.243v3.836a.243.243 0 00.243.243h24.743a8.342 8.342 0 01-.075-4.322zm0 0"
              transform="translate(99.347 559.953) translate(-1.736 -81.766)"
              fill="#464c55"
            />
            <path
              data-name="Path 795"
              d="M43.9 336.169a1.13 1.13 0 01-1.765-.009l-6.36-8.037a1.7 1.7 0 01-.323-.7 11.772 11.772 0 00-10.727 11.724v2.356h37.3v-2.356a11.772 11.772 0 00-11.285-11.761zm0 0"
              transform="translate(99.347 559.953) translate(-20.663 -272.973)"
              fill="#ccaacb"
            />
            <path
              data-name="Path 796"
              d="M58.687 313.024h-37.3a.665.665 0 01-.665-.665V310a12.358 12.358 0 0110.685-12.312V293.1a.664.664 0 01.976-.588 16.024 16.024 0 007.473 1.853 15.832 15.832 0 007.279-1.749.665.665 0 01.968.591v4.418A12.4 12.4 0 0159.352 310v2.356a.665.665 0 01-.666.664zm-36.634-1.33h35.969V310a11.074 11.074 0 00-10.647-11.1.666.666 0 01-.6-.9.574.574 0 01-.007-.1v-3.657a17.143 17.143 0 01-6.917 1.436 17.384 17.384 0 01-7.119-1.53v3.761a1.045 1.045 0 00.027.217.665.665 0 01-.591.8A11.039 11.039 0 0022.052 310v1.691zm0 0"
              transform="translate(99.347 559.953) translate(-17.328 -243.825)"
              fill="#464c55"
            />
            <path
              data-name="Path 806"
              d="M14.745 54.418l6.7 8.682a1.147 1.147 0 001.854 0c.177-.177 6.887-8.682 6.887-8.682"
              fill="none"
              stroke="#464c55"
              strokeWidth={2}
              transform="translate(99.347 559.953)"
            />
            <path
              data-name="Path 925"
              d="M106.074 111.971h-1.611a.1.1 0 01-.1-.1v-1.611a.488.488 0 00-.488-.488h-.975a.488.488 0 00-.488.488v1.611a.1.1 0 01-.1.1H100.7a.488.488 0 00-.488.488v.976a.488.488 0 00.488.488h1.611a.1.1 0 01.1.1v1.611a.488.488 0 00.488.488h.976a.488.488 0 00.488-.488v-1.611a.1.1 0 01.1-.1h1.611a.488.488 0 00.488-.488v-.976a.488.488 0 00-.488-.488z"
              transform="translate(99.347 559.953) translate(-68.714 -93.474)"
              fill="#464c55"
            />
          </g>
          <g data-name="Group 4593">
            <g data-name="Group 4591" fill="#464c55">
              <path
                data-name="Path 802"
                d="M260.9 318.824h-7.211a6.009 6.009 0 01-6.009-6.009V305.6a6.009 6.009 0 016.009-6.009h7.211a6.009 6.009 0 016.009 6.009v7.211a6.009 6.009 0 01-6.009 6.013zm0 0"
                transform="translate(99.347 559.953) translate(45.056 40.617) translate(-247.35 -299.098)"
              />
              <path
                data-name="Path 804"
                d="M257.319 315.66h-7.211a6.435 6.435 0 01-6.427-6.427v-7.211a6.435 6.435 0 016.427-6.427h7.211a6.435 6.435 0 016.427 6.427v7.211a6.435 6.435 0 01-6.427 6.427zm-7.211-19.23a5.6 5.6 0 00-5.591 5.591v7.211a5.6 5.6 0 005.591 5.591h7.211a5.6 5.6 0 005.591-5.591v-7.211a5.6 5.6 0 00-5.591-5.591zm0 0"
                transform="translate(99.347 559.953) translate(45.056 40.617) translate(-243.68 -295.594)"
              />
            </g>
            <path
              data-name="Path 805"
              d="M314.988 330.75c2.6 0 4.369 1.534 4.369 4.058 0 2.54-1.671 3.759-3.989 3.923a.622.622 0 00-.583.586l-.019.378a.62.62 0 01-.619.589h-.732a.62.62 0 01-.62-.6l-.058-1.808a.62.62 0 01.62-.64c2.194 0 3.883-.388 3.883-2.427a2.041 2.041 0 00-2.233-2.194 2.015 2.015 0 00-2.206 1.622.623.623 0 01-.609.514h-.851a.618.618 0 01-.616-.7c.288-1.971 1.892-3.301 4.263-3.301zm-1.243 13.825a1.456 1.456 0 01-1.162-2.311.586.586 0 01.17-.185 1.441 1.441 0 012.39 1.08 1.4 1.4 0 01-1.398 1.416zm0 0"
              transform="translate(99.347 559.953) translate(45.056 40.617) translate(-304.978 -327.66)"
              fill="#ffd8be"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function MySelfIcon(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 114,
    height: 114,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 114 114"
      {...rest}
      sx={rootSx}
    >
      <g data-name="Group 4590" transform="translate(-72.697 -203.757)">
        <circle
          data-name="Ellipse 39409"
          cx={57}
          cy={57}
          r={57}
          transform="translate(72.697 203.757)"
          fill="rgba(255,255,255,0.5)"
          opacity={0.5}
        />
        <circle
          data-name="Ellipse 39383"
          cx={51.5}
          cy={51.5}
          r={51.5}
          transform="translate(78.697 208.757)"
          fill="rgba(255,255,255,0.5)"
        />
        <path
          data-name="Path 807"
          d="M68.205 96.646a19.353 19.353 0 01-.931-2.075c-1.507-4.1-5.548-15.872-5.251-23.482v-.815H19.031c.282 7.237-3.359 18.239-5.012 22.827a22.907 22.907 0 01-1.513 3.25 10.061 10.061 0 008.821 14.9c.247 0 .492-.012.735-.029v.029h37.167a10.06 10.06 0 008.976-14.6z"
          transform="translate(100.007 219.062) translate(-10.539 -57.315)"
          fill="#464c55"
        />
        <path
          data-name="Path 808"
          d="M57.957 110.7H20.792a.73.73 0 01-.161-.018c-.209.012-.4.018-.576.018A10.789 10.789 0 0110.6 94.727a22.025 22.025 0 001.466-3.146c1.587-4.4 5.248-15.412 4.97-22.551a.728.728 0 01.727-.756h42.988a.728.728 0 01.728.728v.815c-.3 7.611 3.91 19.705 5.206 23.231a18.76 18.76 0 00.9 2 10.666 10.666 0 011.162 4.871 10.8 10.8 0 01-10.79 10.781zM21 109.247h36.96a9.343 9.343 0 009.333-9.332 9.223 9.223 0 00-1-4.212 20.1 20.1 0 01-.966-2.153c-1.691-4.6-5.593-16.126-5.3-23.762v-.059H18.5c.025 7.384-3.509 18.014-5.071 22.346a23.381 23.381 0 01-1.56 3.354 9.333 9.333 0 008.183 13.819c.2 0 .421-.009.682-.028a.727.727 0 01.259.027z"
          transform="translate(100.007 219.062) translate(-9.267 -56.042)"
          fill="#464c55"
        />
        <path
          data-name="Path 809"
          d="M64.51 193.611H40.416a9.989 9.989 0 00-10 9.982v9.062h44.089v-9.062a9.989 9.989 0 00-9.995-9.982z"
          transform="translate(100.007 219.062) translate(-22.721 -135.763)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 810"
          d="M108.891 193.611H100.2v19.044h18.69v-9.062a9.989 9.989 0 00-9.999-9.982z"
          transform="translate(100.007 219.062) translate(-67.103 -135.763)"
          fill="#ffc7a2"
        />
        <path
          data-name="Path 811"
          d="M40.415 193.614a9.989 9.989 0 00-10 9.981v9.063H49.11v-19.044z"
          transform="translate(100.007 219.062) translate(-22.721 -135.766)"
          fill="#ffc7a2"
        />
        <path
          data-name="Path 812"
          d="M66.368 79.986c-.041 0-.08.005-.121.006V78.2a19.155 19.155 0 00-38.308 0v1.791c-.041 0-.08-.006-.121-.006a5.783 5.783 0 100 11.566 5.953 5.953 0 00.627-.034 19.2 19.2 0 0037.3 0 5.942 5.942 0 00.627.034 5.783 5.783 0 100-11.566z"
          transform="translate(100.007 219.062) translate(-17.512 -50.301)"
          fill="#ffd8be"
        />
        <g data-name="Group 4586" fill="#464c55">
          <path
            data-name="Path 813"
            d="M45.822 105.608a19.753 19.753 0 01-19.206-14.6h-.068a6.509 6.509 0 01-.607-12.994v-1.085a19.883 19.883 0 0139.763 0v1.085a6.509 6.509 0 01-.604 12.994h-.068a19.754 19.754 0 01-19.207 14.6zm-18.647-16.09a.728.728 0 01.708.561 18.471 18.471 0 0035.879 0 .729.729 0 01.785-.557 5.255 5.255 0 00.55.03 5.055 5.055 0 100-10.11l-.11.006a.737.737 0 01-.525-.207.729.729 0 01-.219-.52v-1.792a18.427 18.427 0 00-36.852 0v1.791a.728.728 0 01-.744.728h-.09a5.055 5.055 0 10-.013 10.109 5.17 5.17 0 00.55-.03.747.747 0 01.076 0z"
            transform="translate(100.007 219.062) translate(3.898 8.217) translate(-19.976 -57.246)"
          />
          <path
            data-name="Path 817"
            d="M45.822 105.608a19.753 19.753 0 01-19.206-14.6h-.068a6.509 6.509 0 01-.607-12.994v-1.085a19.883 19.883 0 0139.763 0v1.085a6.509 6.509 0 01-.604 12.994h-.068a19.754 19.754 0 01-19.207 14.6zm-18.647-16.09a.728.728 0 01.708.561 18.471 18.471 0 0035.879 0 .729.729 0 01.785-.557 5.255 5.255 0 00.55.03 5.055 5.055 0 100-10.11l-.11.006a.737.737 0 01-.525-.207.729.729 0 01-.219-.52v-1.792a18.427 18.427 0 00-36.852 0v1.791a.728.728 0 01-.744.728h-.09a5.055 5.055 0 10-.013 10.109 5.17 5.17 0 00.55-.03.747.747 0 01.076 0z"
            transform="translate(100.007 219.062) translate(3.898 8.217) translate(-19.976 -57.246)"
          />
        </g>
        <path
          data-name="Path 818"
          d="M108.266 54.324l-.44 4.128a11.714 11.714 0 00.788 5.913 14.528 14.528 0 0017.73 8.006l.135-.041-.068-7.163c-.071-7.474-2.905-13.758-7.258-15.911a12.576 12.576 0 00-6.453-1.266c-2.158.134-4.067 2.888-4.434 6.333z"
          transform="translate(100.007 219.062) translate(-71.906 -43.124)"
          fill="#464c55"
        />
        <path
          data-name="Path 819"
          d="M120.59 72.5a14.97 14.97 0 01-6.9-1.668 15.438 15.438 0 01-7.008-7.444 12.393 12.393 0 01-.848-6.29l.44-4.128c.407-3.826 2.606-6.828 5.113-6.982a13.333 13.333 0 016.821 1.34c4.581 2.266 7.589 8.765 7.663 16.556l.068 7.163a.728.728 0 01-.515.7l-.135.041a16.091 16.091 0 01-4.693.709zm-8.309-25.08q-.4 0-.809.025c-1.778.11-3.428 2.607-3.755 5.684l-.44 4.128a10.92 10.92 0 00.723 5.538 13.789 13.789 0 0016.468 7.721l-.058-6.616c-.068-7.248-2.758-13.24-6.852-15.265a11.781 11.781 0 00-5.277-1.217zm-5.289 5.631z"
          transform="translate(100.007 219.062) translate(-70.633 -41.853)"
          fill="#464c55"
        />
        <path
          data-name="Path 820"
          d="M117.615 212.112h-18.69a.728.728 0 01-.728-.728V192.34a.728.728 0 01.728-.728h5.452a.83.83 0 01.09 0h3.152a10.728 10.728 0 0110.723 10.71v9.062a.728.728 0 01-.728.728zm-17.962-1.456h17.234v-8.334a9.271 9.271 0 00-9.268-9.254h-7.967v17.588z"
          transform="translate(100.007 219.062) translate(-65.831 -134.491)"
          fill="#464c55"
        />
        <path
          data-name="Path 821"
          d="M47.838 212.114h-18.69a.728.728 0 01-.728-.728v-9.063a10.729 10.729 0 0110.723-10.708h8.694a.728.728 0 01.728.728v19.044a.728.728 0 01-.727.727zm-17.962-1.456H47.11V193.07h-7.967a9.271 9.271 0 00-9.268 9.253z"
          transform="translate(100.007 219.062) translate(-21.449 -134.494)"
          fill="#464c55"
        />
        <path
          data-name="Path 822"
          d="M75.445 184.335a19.215 19.215 0 01-8.9-2.169v3.794a1.973 1.973 0 00.049.414 2.033 2.033 0 00.128.394l.022.05c.024.052.051.1.08.151s.06.094.092.14c.017.025.033.051.052.075l1.263 1.6c.167.211.343.414.526.61l3.872 4.862a3.425 3.425 0 005.358 0l3.952-4.964c.173-.189.342-.383.5-.587l1.288-1.659.064-.081.491-.633a1.968 1.968 0 00.042-.387v-3.777a19.214 19.214 0 01-8.879 2.167z"
          transform="translate(100.007 219.062) translate(-45.701 -128.484)"
          fill="#ffd8be"
        />
        <path
          data-name="Path 823"
          d="M57.431 193.614H53.97a1.82 1.82 0 00-1.451 2.918l6.751 8.918a1.82 1.82 0 002.48.4l4.4-3.021z"
          transform="translate(100.007 219.062) translate(-36.541 -135.766)"
          fill="#ffc7a2"
        />
        <path
          data-name="Path 824"
          d="M99.359 193.614h3.461a1.82 1.82 0 011.451 2.918l-6.751 8.918a1.82 1.82 0 01-2.48.4l-4.4-3.021z"
          transform="translate(100.007 219.062) translate(-61.021 -135.766)"
          fill="#ffc7a2"
        />
        <path
          data-name="Path 825"
          d="M59.451 205.63a2.542 2.542 0 01-2.032-1.011l-6.751-8.919a2.547 2.547 0 012.031-4.085h3.461a.729.729 0 01.529.227l8.724 9.217a.728.728 0 01-.117 1.1l-4.4 3.021a2.544 2.544 0 01-1.445.45zM52.7 193.07a1.092 1.092 0 00-.871 1.751l6.751 8.918a1.09 1.09 0 001.488.241l3.7-2.539-7.923-8.371z"
          transform="translate(100.007 219.062) translate(-35.27 -134.494)"
          fill="#3762cc"
        />
        <path
          data-name="Path 826"
          d="M94.8 205.63a2.54 2.54 0 01-1.441-.448l-4.4-3.021a.728.728 0 01-.117-1.1l8.724-9.217a.728.728 0 01.529-.227h3.461a2.547 2.547 0 012.031 4.085l-6.751 8.918a2.545 2.545 0 01-2.036 1.01zm-4.319-4.188l3.7 2.539a1.09 1.09 0 001.488-.241l6.751-8.918a1.092 1.092 0 00-.871-1.751H98.4z"
          transform="translate(100.007 219.062) translate(-59.75 -134.494)"
          fill="#464c55"
        />
        <path
          data-name="Path 827"
          d="M57.662 46.029a13.162 13.162 0 00-.186-2.28l-.014-.087a7.838 7.838 0 00-4.472-6.029 7.214 7.214 0 00-1.549-.594h-.01a7.231 7.231 0 00-1.438-.219l-.127-.009a24.381 24.381 0 00-16.121 4.155 21.169 21.169 0 00-9.33 16.23l-.544 8.027.257.038A39.5 39.5 0 0043.1 63.492a27.133 27.133 0 0011.756-7.533 9.519 9.519 0 00.713-.974l.029-.05a10.7 10.7 0 001.09-2.3 18.513 18.513 0 00.974-6.606z"
          transform="translate(100.007 219.062) translate(-18.557 -35.943)"
          fill="#464c55"
        />
        <path
          data-name="Path 828"
          d="M28.808 65.15a41.546 41.546 0 01-6.058-.45l-.257-.038a.728.728 0 01-.62-.769l.544-8.027a22 22 0 019.6-16.752l.011-.009a24.89 24.89 0 0116.642-4.3l.108.008a7.857 7.857 0 011.529.233h.007q.034.007.068.017a7.926 7.926 0 011.669.645 8.549 8.549 0 014.842 6.492.986.986 0 01.013.058l.017.1a13.854 13.854 0 01.195 2.381 19.3 19.3 0 01-1.018 6.868 11.4 11.4 0 01-1.16 2.444l-.023.04a.608.608 0 01-.04.059 10.068 10.068 0 01-.737 1 28.009 28.009 0 01-12.073 7.75 39.677 39.677 0 01-13.259 2.25zm-5.436-1.827a38.86 38.86 0 0018.209-1.792 26.579 26.579 0 0011.449-7.324 8.76 8.76 0 00.651-.891l.013-.019.007-.012a10.029 10.029 0 001.024-2.159 17.869 17.869 0 00.938-6.355v-.018a12.47 12.47 0 00-.175-2.153l-.007-.041c0-.013-.006-.026-.008-.039a7.112 7.112 0 00-4.065-5.5 6.594 6.594 0 00-1.421-.548h-.011a6.527 6.527 0 00-1.293-.2l-.135-.01a23.842 23.842 0 00-15.593 3.977.763.763 0 01-.077.059 20.53 20.53 0 00-9.008 15.671z"
          transform="translate(100.007 219.062) translate(-17.284 -34.668)"
          fill="#464c55"
        />
        <path
          data-name="Path 845"
          d="M59.451 205.63a2.542 2.542 0 01-2.032-1.011l-6.751-8.919a2.547 2.547 0 012.031-4.085h3.461a.729.729 0 01.529.227l8.724 9.217a.728.728 0 01-.117 1.1l-4.4 3.021a2.544 2.544 0 01-1.445.45zM52.7 193.07a1.092 1.092 0 00-.871 1.751l6.751 8.918a1.09 1.09 0 001.488.241l3.7-2.539-7.923-8.371z"
          transform="translate(100.007 219.062) translate(-35.27 -134.494)"
          fill="#464c55"
        />
        <path
          data-name="Path 846"
          d="M90.636 218.94l2.119 7.252a.364.364 0 00.575.183l3.376-2.679a.364.364 0 00-.02-.585z"
          transform="translate(100.007 219.062) translate(-61.022 -151.874)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 847"
          d="M79.786 218.94l-2.119 7.252a.364.364 0 01-.575.183l-3.377-2.675a.364.364 0 01.02-.585z"
          transform="translate(100.007 219.062) translate(-50.172 -151.874)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 848"
          d="M91.832 225.909a1.094 1.094 0 01-1.049-.786l-2.119-7.252a.728.728 0 011.112-.8l6.051 4.171a1.092 1.092 0 01.059 1.754l-3.376 2.679a1.091 1.091 0 01-.678.234zm-1.2-6.48l1.398 4.771 2.567-2.037zM95 222.437z"
          transform="translate(100.007 219.062) translate(-59.75 -150.601)"
          fill="#464c55"
        />
        <path
          data-name="Path 849"
          d="M76.045 225.91a1.09 1.09 0 01-.678-.237l-3.376-2.679a1.092 1.092 0 01.059-1.754l6.051-4.171a.728.728 0 011.112.8l-2.119 7.252a1.093 1.093 0 01-1.049.786zm-2.765-3.75l2.567 2.037 1.393-4.767z"
          transform="translate(100.007 219.062) translate(-48.9 -150.602)"
          fill="#464c55"
        />
        <path
          data-name="Path 850"
          d="M84.91 220.369l1.043 2.315h2.116l1.035-2.3-2.11-1.447z"
          transform="translate(100.007 219.062) translate(-57.38 -151.874)"
          fill="#55cbcd"
        />
        <path
          data-name="Path 851"
          d="M86.8 222.14h-2.119a.728.728 0 01-.664-.429l-1.043-2.311a.728.728 0 01.252-.9l2.084-1.429a.729.729 0 01.824 0l2.11 1.447a.728.728 0 01.252.9l-1.035 2.3a.728.728 0 01-.661.422zm-1.645-1.456h1.175l.592-1.314-1.2-.82-1.17.8z"
          transform="translate(100.007 219.062) translate(-56.107 -150.602)"
          fill="#464c55"
        />
        <path
          data-name="Path 852"
          d="M73.233 204.833H29.148a.728.728 0 01-.728-.728v-9.062a10.728 10.728 0 0110.723-10.71h2.426v-3.439a.728.728 0 011.064-.646 18.6 18.6 0 0017.11 0 .728.728 0 011.063.646v3.433h2.431a10.728 10.728 0 0110.723 10.71v9.063a.728.728 0 01-.727.733zm-43.357-1.456h42.629v-8.334a9.271 9.271 0 00-9.268-9.254h-3.2a.729.729 0 01-.716-.87 1.257 1.257 0 00.028-.242v-2.619a20.06 20.06 0 01-16.326 0v2.634a1.179 1.179 0 00.028.23.728.728 0 01-.714.871h-3.2a9.271 9.271 0 00-9.268 9.254v8.334z"
          transform="translate(100.007 219.062) translate(-21.449 -127.212)"
          fill="#464c55"
        />
        <g data-name="Group 4617">
          <g
            data-name="Group 4615"
            transform="translate(100.007 219.062) translate(20.821 30.488)"
          >
            <g
              data-name="Group 4618"
              transform="translate(.861 3.2)"
              fill="#464c55"
            >
              <ellipse
                data-name="Ellipse 39387"
                cx={1.5}
                cy={2}
                rx={1.5}
                ry={2}
                transform="translate(.008 .008)"
              />
              <ellipse
                data-name="Ellipse 39388"
                cx={1.5}
                cy={2}
                rx={1.5}
                ry={2}
                transform="translate(14.008 .008)"
              />
            </g>
            <path
              data-name="Line 268"
              transform="translate(15.12)"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L2.974 0"
            />
            <path
              data-name="Line 269"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
              d="M0 0L2.974 0"
            />
            <path
              data-name="Path 926"
              d="M5.701 14.59a6.588 6.588 0 006.412 0"
              fill="none"
              stroke="#464c55"
              strokeLinecap="round"
              strokeWidth={3}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function ExpertSplash(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 245,
    height: 61,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 245 61"
      {...rest}
      sx={rootSx}
    >
      <g id="Group_4989" data-name="Group 4989" transform="translate(-24 -54)">
        <g id="hospital-cross-in-3d-circle" transform="translate(24 60.618)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M46.7,33.636A18.455,18.455,0,0,1,22.95,41.712a16.661,16.661,0,0,0,2.48.195,16.929,16.929,0,1,0-4-33.327A18.525,18.525,0,0,1,46.7,33.636ZM8.01,31.387A23.38,23.38,0,0,1,30.427,1.4a22.993,22.993,0,0,1,4.262.413A24.712,24.712,0,0,0,25.452,0a24.983,24.983,0,1,0,7.053,48.941,25.541,25.541,0,0,0,4.18-1.666A23.3,23.3,0,0,1,8.01,31.387ZM22.692,15.411v6.145H16.549V28h6.143v6.143h6.446V28h6.143V21.555H29.138V15.411Z"
            transform="translate(-0.452 0)"
            fill="#fff"
          />
        </g>
        <text
          id="Health_Circles"
          data-name="Health Circles"
          transform="translate(85 81)"
          fill="#fff"
          fontSize="26"
          fontFamily="Poppins-SemiBold, Poppins"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Health Circles
          </tspan>
        </text>
        <text
          id="Expert"
          transform="translate(85 109)"
          fill="#fff"
          fontSize="16"
          fontFamily="Poppins-Regular, Poppins"
        >
          <tspan x="0" y="0">
            Expert
          </tspan>
        </text>
      </g>
    </SvgIcon>
  );
}

export function ExpertForgotPasswordTopImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 257.436,
    height: 164.392,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 257.436 164.392"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="Path_4910"
            data-name="Path 4910"
            d="M133.741,233.723a10.24,10.24,0,0,1-1.131-2.892c0-.5,1.1-.805,1.1-.805,1.709-.9,9.747.4,13.364,1.005a41.313,41.313,0,0,0,6.129.6s.5-.4,1.1-.9,3.415-3.818,4.521-4.108a2.832,2.832,0,0,1,2.109.4s1.81,1.1,1.506,1.306-4.721,4.018-5.828,4.721-3.415.4-5.425.805c-1.731.345-8.742.772-10.349.9a5.841,5.841,0,0,1-3.618-.3"
            transform="translate(-132.61 -226.551)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <path
            id="Path_4914"
            data-name="Path 4914"
            d="M256.388,282.332a2.139,2.139,0,0,1,1.9-1.142h18.266s1.32,0,.926,2.509-5.811,17.826-7.12,22.457-1.586,14.391-1.586,14.391H246.86S248.6,297.205,256.388,282.332Z"
            transform="translate(-246.86 -281.19)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-3">
          <path
            id="Path_4933"
            data-name="Path 4933"
            d="M132.608,242.18a.441.441,0,0,0,0,.058A.441.441,0,0,1,132.608,242.18Zm1.131,2.892a13.178,13.178,0,0,1-1.1-2.662A13.012,13.012,0,0,0,133.739,245.072Zm-1.126-2.818v.06A.148.148,0,0,0,132.613,242.254Zm.014.077a.511.511,0,0,0,.016.079.513.513,0,0,1-.016-.079Zm1.112,2.739a25.087,25.087,0,0,0,3.79,5.346c3.618,3.919,14.068,14.17,15.062,14.873s.7,2.711,0,4.721-3.316,4.929-3.215,8.139,1.1,8.139,1.005,9.144-2.6,4.423-2.6,4.423H173.7s-3.232-4.108-3.232-5.513,4.437-19.406,4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413,1.608-4.823,1.608-4.823l-6.025.3a11.911,11.911,0,0,1-.7,3.117c-.4.5-1.005-.5-2.413-1.2s-4.108-1.306-5.124-2.111-10.65-9.859-10.65-9.859"
            transform="translate(-132.607 -242.18)"
            fill="#e5e0ff"
          />
        </clipPath>
        <clipPath id="clip-path-4">
          <path
            id="Path_4939"
            data-name="Path 4939"
            d="M228.523,297.263c-.3-1,1.608-4.823,1.608-4.823l-6.025.3a11.911,11.911,0,0,1-.7,3.117c-.4.5-1.005-.5-2.413-1.205-.107-.055-.225-.107-.345-.159l-.364,5.726s.529,5.546,6.866,4.491c2.566-.427,5.3-2.717,7.668-5.291C232.382,298.974,228.753,298.032,228.523,297.263Z"
            transform="translate(-220.28 -292.44)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-5">
          <path
            id="Path_4943"
            data-name="Path 4943"
            d="M175.823,273.95c-.4.5-1.005-.5-2.413-1.2-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.861,5.861,0,0,1-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a8.553,8.553,0,0,1-4.461,3.952c4.3,4.489,13.014,13.017,13.929,13.657,1.005.7.7,2.711,0,4.721s-3.316,4.929-3.215,8.139,1.1,8.139,1.005,9.144c-.09.9-2.1,3.7-2.53,4.305l1.021.115h5.318c-.03-2.695-.027-13.693,1.816-18.075C174.215,283.193,175.823,273.95,175.823,273.95Z"
            transform="translate(-154.76 -262.27)"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-6">
          <path
            id="Path_4947"
            data-name="Path 4947"
            d="M219.208,303.352a2.366,2.366,0,0,0-2.018.29c-.77.674-1.917,4.13-2.593,7.879a10.478,10.478,0,0,0,.822,6.449s1.58-4.143,2.059-6.162S219.208,303.352,219.208,303.352Z"
            transform="translate(-214.41 -303.243)"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-7">
          <path
            id="Path_4952"
            data-name="Path 4952"
            d="M238.473,341h11.716s-3.232-4.108-3.232-5.513,4.437-19.406,4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413a134.064,134.064,0,0,0-3.114,13.666C237.542,328.456,238.256,338.293,238.473,341Z"
            transform="translate(-237.938 -310.05)"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-8">
          <path
            id="Path_4956"
            data-name="Path 4956"
            d="M242.124,310.05s-3.1,9.859-3.114,13.666c0,0,4.4-5.332,4.979-9.078S242.124,310.05,242.124,310.05Z"
            transform="translate(-239.01 -310.05)"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-9">
          <path
            id="Path_4961"
            data-name="Path 4961"
            d="M366.376,409.053s2.27.093,3.757.307a27.16,27.16,0,0,0,2.991.238,5.973,5.973,0,0,0-1.7-2.128,7.029,7.029,0,0,0-3.8-1.12c-1.331.186-3.234,1.528-3.075,1.955S365.423,408.924,366.376,409.053Z"
            transform="translate(-364.546 -406.323)"
            fill="#e5e0ff"
            stroke="#263238"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-10">
          <path
            id="Path_4966"
            data-name="Path 4966"
            d="M385,411.37a10.625,10.625,0,0,1,2.248-.92c.449.014,3.434,2.032,3.286,2.355a.86.86,0,0,1-.942.351c-.331-.156-2.341-1.011-2.341-1.011l-1.315.309Z"
            transform="translate(-385 -410.449)"
            fill="#e5e0ff"
          />
        </clipPath>
        <clipPath id="clip-path-11">
          <path
            id="Path_4971"
            data-name="Path 4971"
            d="M380.31,408.169a12.788,12.788,0,0,1,2.876.164c.477.241,2.629,3.933,2.306,4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342Z"
            transform="translate(-380.31 -408.158)"
            fill="#e5e0ff"
          />
        </clipPath>
        <clipPath id="clip-path-12">
          <path
            id="Path_4980"
            data-name="Path 4980"
            d="M271.1,327.8c1.758,2.708,5.288,9.571,6.318,10.344,1.608,1.2,12.354,4.13,13.389,4.929s.964,1.6,1.944,1.9a52.164,52.164,0,0,0,6.058,1.265c1.4.131.775-.737.775-.737l-2.391-1.643,2.084-.515a22.748,22.748,0,0,0,2.481,2.651c.392.137,1.082,0,1.038-.309-.077-.5-2.306-4.552-3.1-4.724a43.154,43.154,0,0,0-5.595.493s-10.075-6.794-10.256-7.035a14.01,14.01,0,0,0-1.1-2.413c-.493-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077c-.274-.548-.548-1.172-.849-1.884-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.211"
            transform="translate(-269.9 -317.33)"
            fill="#92e3a9"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-13">
          <path
            id="Path_4995"
            data-name="Path 4995"
            d="M231.823,236.73l-8.249,3.442a12.163,12.163,0,0,1-1.06,4.193c-.975,2.062-.405,5.965.531,8.071s5.064,1.282,6.573,1.019a16.265,16.265,0,0,0,2.993-.874,2.782,2.782,0,0,0,2.673-.372S230.87,239.816,231.823,236.73Z"
            transform="translate(-222.007 -236.73)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-14">
          <path
            id="Path_5013"
            data-name="Path 5013"
            d="M154.247,406.156a9.428,9.428,0,0,1-3.358-.8,1.162,1.162,0,1,1,.917-2.132,5.8,5.8,0,0,0,2.814.576c.677-.757,1.716-5.33.373-7.537-.3-.49-.586-.581-.773-.6a3.645,3.645,0,0,0-2.292,1.066,1.165,1.165,0,1,1-1.6-1.7c.208-.2,2.132-1.935,4.184-1.658a3.347,3.347,0,0,1,2.441,1.684c1.978,3.225.624,9.36-.9,10.575A2.867,2.867,0,0,1,154.247,406.156Z"
            transform="translate(-149.964 -393.344)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
        <clipPath id="clip-path-15">
          <rect
            id="Rectangle_44653"
            data-name="Rectangle 44653"
            width="12.819"
            height="17.014"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="Group_102582"
        data-name="Group 102582"
        transform="translate(-60 -47)"
      >
        <circle
          id="Ellipse_39441"
          data-name="Ellipse 39441"
          cx="18"
          cy="18"
          r="18"
          transform="translate(281 111)"
          fill="rgba(101,82,204,0.1)"
        />
        <g
          id="Group_5475"
          data-name="Group 5475"
          transform="translate(-2275.949 -1938)"
        >
          <g
            id="Forgot_password-bro"
            data-name="Forgot password-bro"
            transform="translate(2363.139 2008.096)"
          >
            <g
              id="freepik--Character--inject-65"
              transform="translate(61.681 75.397)"
            >
              <path
                id="Path_4907"
                data-name="Path 4907"
                d="M133.741,233.723a10.24,10.24,0,0,1-1.131-2.892c0-.5,1.1-.805,1.1-.805,1.709-.9,9.747.4,13.364,1.005a41.313,41.313,0,0,0,6.129.6s.5-.4,1.1-.9,3.415-3.818,4.521-4.108a2.832,2.832,0,0,1,2.109.4s1.81,1.1,1.506,1.306-4.721,4.018-5.828,4.721-3.415.4-5.425.805c-1.731.345-8.742.772-10.349.9a5.841,5.841,0,0,1-3.618-.3"
                transform="translate(-132.609 -224.354)"
                fill="#fff"
              />
              <g
                id="Group_5454"
                data-name="Group 5454"
                transform="translate(0.001 2.196)"
                clipPath="url(#clip-path)"
              >
                <path
                  id="Path_4908"
                  data-name="Path 4908"
                  d="M160.994,226.974a2.782,2.782,0,0,0-2.109-.4c-1.1.3-3.919,3.618-4.521,4.108s-1.1.9-1.1.9a41.306,41.306,0,0,1-6.129-.6c-3.618-.6-11.656-1.917-13.364-1.005,0,0-1.1.3-1.1.805a3.455,3.455,0,0,0,.216.822l.151.055a55.9,55.9,0,0,1,6.34-.107c4.332.1,14.353.7,15,.931a15.74,15.74,0,0,0,4.368-1.1c1.643-1.339,3.574-3.012,3.768-3.13C162.8,228.077,160.994,226.974,160.994,226.974Z"
                  transform="translate(-132.661 -226.511)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_4909"
                  data-name="Path 4909"
                  d="M160.994,226.974a2.782,2.782,0,0,0-2.109-.4c-1.1.3-3.919,3.618-4.521,4.108s-1.1.9-1.1.9a41.306,41.306,0,0,1-6.129-.6c-3.618-.6-11.656-1.917-13.364-1.005,0,0-1.1.3-1.1.805a3.455,3.455,0,0,0,.216.822l.151.055a55.9,55.9,0,0,1,6.34-.107c4.332.1,14.353.7,15,.931a15.74,15.74,0,0,0,4.368-1.1c1.643-1.339,3.574-3.012,3.768-3.13C162.8,228.077,160.994,226.974,160.994,226.974Z"
                  transform="translate(-132.661 -226.511)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                id="Path_4911"
                data-name="Path 4911"
                d="M133.741,233.723a10.24,10.24,0,0,1-1.131-2.892c0-.5,1.1-.805,1.1-.805,1.709-.9,9.747.4,13.364,1.005a41.313,41.313,0,0,0,6.129.6s.5-.4,1.1-.9,3.415-3.818,4.521-4.108a2.832,2.832,0,0,1,2.109.4s1.81,1.1,1.506,1.306-4.721,4.018-5.828,4.721-3.415.4-5.425.805c-1.731.345-8.742.772-10.349.9a5.841,5.841,0,0,1-3.618-.3"
                transform="translate(-132.609 -224.354)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4912"
                data-name="Path 4912"
                d="M256.388,282.332a2.139,2.139,0,0,1,1.9-1.142h18.266s1.32,0,.926,2.509-5.811,17.826-7.12,22.457-1.586,14.391-1.586,14.391H246.86S248.6,297.205,256.388,282.332Z"
                transform="translate(-215.571 -264.03)"
                fill="#fff"
              />
              <g
                id="Group_5455"
                data-name="Group 5455"
                transform="translate(31.289 17.16)"
                clipPath="url(#clip-path-2)"
              >
                <path
                  id="Path_4913"
                  data-name="Path 4913"
                  d="M264.564,281.19h-6.332a2.139,2.139,0,0,0-1.9,1.142c-7.791,14.873-9.547,38.206-9.547,38.206h9.826l2.424-9.2,10.105,2.084c.071-.772.153-1.558.249-2.333l-.222-2.465s-2.07-2.177-2.722-2.722-.219-1.528-.329-5.776-3.922-7.3-5.34-9.916.764-4.25,2.725-6.866A5.045,5.045,0,0,0,264.564,281.19Z"
                  transform="translate(-246.809 -281.19)"
                  opacity="0.16"
                />
              </g>
              <path
                id="Path_4915"
                data-name="Path 4915"
                d="M256.388,282.332a2.139,2.139,0,0,1,1.9-1.142h18.266s1.32,0,.926,2.509-5.811,17.826-7.12,22.457-1.586,14.391-1.586,14.391H246.86S248.6,297.205,256.388,282.332Z"
                transform="translate(-215.571 -264.03)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4916"
                data-name="Path 4916"
                d="M326.766,285.525c-1.846,4.308-5.751,21.361-6.386,34.991h1.764s.274-9.771,1.586-14.391,6.734-19.94,7.12-22.457-.926-2.509-.926-2.509S328.248,282.072,326.766,285.525Z"
                transform="translate(-268.956 -264.008)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4917"
                data-name="Path 4917"
                d="M215.648,231.437a10.266,10.266,0,0,1-4.018-4.721c-1.1-3.012,8.64-7.838,12.871-8.139s5.425.8,7.942,5.124,4.22,10.248,2.914,13.162-3.516,3.618-1.917,6.025,6.129,9.243,5.828,12.458-3.415,6.025-7.942,6.332-10.552-2.413-15.574-6.847-3.719-10.954-1.917-13.063,4.521-2.914,4.721-5.023S215.648,231.437,215.648,231.437Z"
                transform="translate(-189.926 -218.53)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4926"
                data-name="Path 4926"
                d="M132.608,242.18a.441.441,0,0,0,0,.058A.441.441,0,0,1,132.608,242.18Zm1.131,2.892a13.178,13.178,0,0,1-1.1-2.662A13.012,13.012,0,0,0,133.739,245.072Zm-1.126-2.818v.06A.148.148,0,0,0,132.613,242.254Zm.014.077a.511.511,0,0,0,.016.079.513.513,0,0,1-.016-.079Zm1.112,2.739a25.087,25.087,0,0,0,3.79,5.346c3.618,3.919,14.068,14.17,15.062,14.873s.7,2.711,0,4.721-3.316,4.929-3.215,8.139,1.1,8.139,1.005,9.144-2.6,4.423-2.6,4.423H173.7s-3.232-4.108-3.232-5.513,4.437-19.406,4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413,1.608-4.823,1.608-4.823l-6.025.3a11.911,11.911,0,0,1-.7,3.117c-.4.5-1.005-.5-2.413-1.2s-4.108-1.306-5.124-2.111-10.65-9.859-10.65-9.859"
                transform="translate(-132.607 -235.703)"
                fill="#fff"
              />
              <g
                id="Group_5457"
                data-name="Group 5457"
                transform="translate(0 6.477)"
                clipPath="url(#clip-path-3)"
              >
                <path
                  id="Path_4927"
                  data-name="Path 4927"
                  d="M209.77,295.64c.5.876,1,1.668,1,1.668a10.2,10.2,0,0,0,2.111.95,19.863,19.863,0,0,1,2.958,1.369s2.114-.529,1.369-2.325a5.675,5.675,0,0,0-.882-1.265,6.793,6.793,0,0,1-.567,2.139c-.4.5-1.005-.5-2.413-1.2C212.437,296.516,210.961,296.1,209.77,295.64Z"
                  transform="translate(-188.638 -280.999)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_4928"
                  data-name="Path 4928"
                  d="M165.508,262.535c-3.1-2.873-7.03-6.556-7.03-6.556l-2.284-.329-.274.153s6.447,5.7,7.819,6.34A4.286,4.286,0,0,0,165.508,262.535Z"
                  transform="translate(-149.535 -251.961)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_4929"
                  data-name="Path 4929"
                  d="M202.146,291.069l-.246-.219c.126.208.2.34.2.34Z"
                  transform="translate(-182.923 -277.521)"
                  fill="#92e3a9"
                />
                <g
                  id="Group_5456"
                  data-name="Group 5456"
                  transform="translate(6.385 3.689)"
                >
                  <path
                    id="Path_4930"
                    data-name="Path 4930"
                    d="M209.77,295.64c.5.876,1,1.668,1,1.668a10.2,10.2,0,0,0,2.111.95,19.863,19.863,0,0,1,2.958,1.369s2.114-.529,1.369-2.325a5.675,5.675,0,0,0-.882-1.265,6.793,6.793,0,0,1-.567,2.139c-.4.5-1.005-.5-2.413-1.2C212.437,296.516,210.961,296.1,209.77,295.64Z"
                    transform="translate(-195.023 -284.688)"
                    fill="#e5e0ff"
                  />
                  <path
                    id="Path_4931"
                    data-name="Path 4931"
                    d="M165.508,262.535c-3.1-2.873-7.03-6.556-7.03-6.556l-2.284-.329-.274.153s6.447,5.7,7.819,6.34A4.286,4.286,0,0,0,165.508,262.535Z"
                    transform="translate(-155.92 -255.65)"
                    fill="#e5e0ff"
                  />
                  <path
                    id="Path_4932"
                    data-name="Path 4932"
                    d="M202.146,291.069l-.246-.219c.126.208.2.34.2.34Z"
                    transform="translate(-189.308 -281.21)"
                    fill="#e5e0ff"
                  />
                </g>
              </g>
              <path
                id="Path_4934"
                data-name="Path 4934"
                d="M132.608,242.18a.441.441,0,0,0,0,.058A.441.441,0,0,1,132.608,242.18Zm1.131,2.892a13.178,13.178,0,0,1-1.1-2.662A13.012,13.012,0,0,0,133.739,245.072Zm-1.126-2.818v.06A.148.148,0,0,0,132.613,242.254Zm.014.077a.511.511,0,0,0,.016.079.513.513,0,0,1-.016-.079Zm1.112,2.739a25.087,25.087,0,0,0,3.79,5.346c3.618,3.919,14.068,14.17,15.062,14.873s.7,2.711,0,4.721-3.316,4.929-3.215,8.139,1.1,8.139,1.005,9.144-2.6,4.423-2.6,4.423H173.7s-3.232-4.108-3.232-5.513,4.437-19.406,4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413,1.608-4.823,1.608-4.823l-6.025.3a11.911,11.911,0,0,1-.7,3.117c-.4.5-1.005-.5-2.413-1.2s-4.108-1.306-5.124-2.111-10.65-9.859-10.65-9.859"
                transform="translate(-132.607 -235.703)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4935"
                data-name="Path 4935"
                d="M152,253.1s-3.21.06-5-1.416"
                transform="translate(-143.058 -242.602)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4936"
                data-name="Path 4936"
                d="M228.523,297.263c-.3-1,1.608-4.823,1.608-4.823l-6.025.3a11.911,11.911,0,0,1-.7,3.117c-.4.5-1.005-.5-2.413-1.205-.107-.055-.225-.107-.345-.159l-.364,5.726s.529,5.546,6.866,4.491c2.566-.427,5.3-2.717,7.668-5.291C232.382,298.974,228.753,298.032,228.523,297.263Z"
                transform="translate(-196.27 -272.199)"
                fill="#fff"
              />
              <g
                id="Group_5458"
                data-name="Group 5458"
                transform="translate(24.01 20.241)"
                clipPath="url(#clip-path-4)"
              >
                <path
                  id="Path_4937"
                  data-name="Path 4937"
                  d="M246.667,294.244s-.364,2.043-.657,4.3-.509,3.941-.509,3.941l1.336-4.179,1.506-4.428S246.886,293.88,246.667,294.244Z"
                  transform="translate(-238.593 -293.486)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_4938"
                  data-name="Path 4938"
                  d="M246.667,294.244s-.364,2.043-.657,4.3-.509,3.941-.509,3.941l1.336-4.179,1.506-4.428S246.886,293.88,246.667,294.244Z"
                  transform="translate(-238.593 -293.486)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                id="Path_4940"
                data-name="Path 4940"
                d="M228.523,297.263c-.3-1,1.608-4.823,1.608-4.823l-6.025.3a11.911,11.911,0,0,1-.7,3.117c-.4.5-1.005-.5-2.413-1.205-.107-.055-.225-.107-.345-.159l-.364,5.726s.529,5.546,6.866,4.491c2.566-.427,5.3-2.717,7.668-5.291C232.382,298.974,228.753,298.032,228.523,297.263Z"
                transform="translate(-196.27 -272.199)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4941"
                data-name="Path 4941"
                d="M175.823,273.95c-.4.5-1.005-.5-2.413-1.2-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.861,5.861,0,0,1-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a8.553,8.553,0,0,1-4.461,3.952c4.3,4.489,13.014,13.017,13.929,13.657,1.005.7.7,2.711,0,4.721s-3.316,4.929-3.215,8.139,1.1,8.139,1.005,9.144c-.09.9-2.1,3.7-2.53,4.305l1.021.115h5.318c-.03-2.695-.027-13.693,1.816-18.075C174.215,283.193,175.823,273.95,175.823,273.95Z"
                transform="translate(-148.693 -250.291)"
                fill="#7a67d9"
              />
              <g
                id="Group_5459"
                data-name="Group 5459"
                transform="translate(6.067 11.979)"
                clipPath="url(#clip-path-5)"
              >
                <path
                  id="Path_4942"
                  data-name="Path 4942"
                  d="M183.14,272.745c-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.86,5.86,0,0,1-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a7.432,7.432,0,0,1-.791,1.23,36.9,36.9,0,0,0,4.472,3.451c1.369.633,1.69.1,2.739.739a9.461,9.461,0,0,1,2.218,2.739s.635-1.692,1.164-.529a36.071,36.071,0,0,0,1.8,3.169,10.2,10.2,0,0,0,2.111.95,15.258,15.258,0,0,1,2.645,1.208c.153-.8.238-1.284.238-1.284C185.15,274.451,184.548,273.446,183.14,272.745Z"
                  transform="translate(-164.49 -262.27)"
                  opacity="0.16"
                />
              </g>
              <path
                id="Path_4944"
                data-name="Path 4944"
                d="M175.823,273.95c-.4.5-1.005-.5-2.413-1.2-.887-.446-2.3-.852-3.47-1.29-.331-.786-.77-1.81-1.052-2.429-.5-1.1-1.306-.4-1.306-.4a5.861,5.861,0,0,1-1.005-1.608c-.5-1.1-1.306-1.005-2.41-1.2s-3.418-2.311-3.418-2.311-1.082-.822-1.528-1.23a8.553,8.553,0,0,1-4.461,3.952c4.3,4.489,13.014,13.017,13.929,13.657,1.005.7.7,2.711,0,4.721s-3.316,4.929-3.215,8.139,1.1,8.139,1.005,9.144c-.09.9-2.1,3.7-2.53,4.305l1.021.115h5.318c-.03-2.695-.027-13.693,1.816-18.075C174.215,283.193,175.823,273.95,175.823,273.95Z"
                transform="translate(-148.693 -250.291)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4945"
                data-name="Path 4945"
                d="M219.208,303.352a2.366,2.366,0,0,0-2.018.29c-.77.674-1.917,4.13-2.593,7.879a10.478,10.478,0,0,0,.822,6.449s1.58-4.143,2.059-6.162S219.208,303.352,219.208,303.352Z"
                transform="translate(-192.008 -280.044)"
                fill="#6552cc"
              />
              <g
                id="Group_5460"
                data-name="Group 5460"
                transform="translate(22.403 23.199)"
                clipPath="url(#clip-path-6)"
              >
                <path
                  id="Path_4946"
                  data-name="Path 4946"
                  d="M223.18,303.664a3.444,3.444,0,0,1,1.276-.093,3.643,3.643,0,0,1,.871.529l.249-1.046a2.021,2.021,0,0,0-1.213-.2A2.567,2.567,0,0,0,223.18,303.664Z"
                  transform="translate(-220.778 -302.944)"
                  opacity="0.16"
                />
              </g>
              <path
                id="Path_4948"
                data-name="Path 4948"
                d="M219.208,303.352a2.366,2.366,0,0,0-2.018.29c-.77.674-1.917,4.13-2.593,7.879a10.478,10.478,0,0,0,.822,6.449s1.58-4.143,2.059-6.162S219.208,303.352,219.208,303.352Z"
                transform="translate(-192.008 -280.044)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4949"
                data-name="Path 4949"
                d="M195.89,300.309l1.608,6.532-3.618-8.24"
                transform="translate(-177.1 -276.672)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4950"
                data-name="Path 4950"
                d="M238.473,341h11.716s-3.232-4.108-3.232-5.513,4.437-19.406,4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413a134.064,134.064,0,0,0-3.114,13.666C237.542,328.456,238.256,338.293,238.473,341Z"
                transform="translate(-209.092 -284.986)"
                fill="#6552cc"
              />
              <g
                id="Group_5461"
                data-name="Group 5461"
                transform="translate(28.846 25.064)"
                clipPath="url(#clip-path-7)"
              >
                <path
                  id="Path_4951"
                  data-name="Path 4951"
                  d="M260.2,313.966a28.581,28.581,0,0,1-7.364-1.846l.616,1.424a12.354,12.354,0,0,0,3.56,1.238c2.04.364,3.938.293,5.179,2.117l.06.09c.077-.351.129-.6.145-.712C262.617,314.971,261.812,314.067,260.2,313.966Z"
                  transform="translate(-248.759 -311.553)"
                  opacity="0.16"
                />
              </g>
              <path
                id="Path_4953"
                data-name="Path 4953"
                d="M238.473,341h11.716s-3.232-4.108-3.232-5.513,4.437-19.406,4.636-20.712-.6-2.21-2.21-2.311-7.737-1.408-8.038-2.413a134.064,134.064,0,0,0-3.114,13.666C237.542,328.456,238.256,338.293,238.473,341Z"
                transform="translate(-209.092 -284.986)"
                fill="#7a67d9"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4954"
                data-name="Path 4954"
                d="M242.124,310.05s-3.1,9.859-3.114,13.666c0,0,4.4-5.332,4.979-9.078S242.124,310.05,242.124,310.05Z"
                transform="translate(-209.87 -284.986)"
                fill="#6552cc"
              />
              <g
                id="Group_5462"
                data-name="Group 5462"
                transform="translate(29.14 25.064)"
                clipPath="url(#clip-path-8)"
              >
                <path
                  id="Path_4955"
                  data-name="Path 4955"
                  d="M248.43,311.31a2.87,2.87,0,0,1,2.407,1.167,4.759,4.759,0,0,0-1.873-2.426Z"
                  transform="translate(-245.85 -310.05)"
                  opacity="0.16"
                />
              </g>
              <path
                id="Path_4957"
                data-name="Path 4957"
                d="M242.124,310.05s-3.1,9.859-3.114,13.666c0,0,4.4-5.332,4.979-9.078S242.124,310.05,242.124,310.05Z"
                transform="translate(-209.87 -284.986)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4958"
                data-name="Path 4958"
                d="M366.376,409.053s2.27.093,3.757.307a27.16,27.16,0,0,0,2.991.238,5.973,5.973,0,0,0-1.7-2.128,7.029,7.029,0,0,0-3.8-1.12c-1.331.186-3.234,1.528-3.075,1.955S365.423,408.924,366.376,409.053Z"
                transform="translate(-301.027 -354.894)"
                fill="#fff"
              />
              <g
                id="Group_5463"
                data-name="Group 5463"
                transform="translate(63.519 51.429)"
                clipPath="url(#clip-path-9)"
              >
                <path
                  id="Path_4959"
                  data-name="Path 4959"
                  d="M366.376,409.053s2.27.093,3.757.307a27.16,27.16,0,0,0,2.991.238,5.973,5.973,0,0,0-1.7-2.128,7.029,7.029,0,0,0-3.8-1.12c-1.331.186-3.234,1.528-3.075,1.955S365.423,408.924,366.376,409.053Z"
                  transform="translate(-364.546 -406.323)"
                  fill="#e5e0ff"
                />
                <path
                  id="Path_4960"
                  data-name="Path 4960"
                  d="M366.376,409.053s2.27.093,3.757.307a27.16,27.16,0,0,0,2.991.238,5.973,5.973,0,0,0-1.7-2.128,7.029,7.029,0,0,0-3.8-1.12c-1.331.186-3.234,1.528-3.075,1.955S365.423,408.924,366.376,409.053Z"
                  transform="translate(-364.546 -406.323)"
                  fill="#e5e0ff"
                  opacity="0.5"
                />
              </g>
              <path
                id="Path_4962"
                data-name="Path 4962"
                d="M366.376,409.053s2.27.093,3.757.307a27.16,27.16,0,0,0,2.991.238,5.973,5.973,0,0,0-1.7-2.128,7.029,7.029,0,0,0-3.8-1.12c-1.331.186-3.234,1.528-3.075,1.955S365.423,408.924,366.376,409.053Z"
                transform="translate(-301.027 -354.894)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4963"
                data-name="Path 4963"
                d="M385,411.37a10.625,10.625,0,0,1,2.248-.92c.449.014,3.434,2.032,3.286,2.355a.86.86,0,0,1-.942.351c-.331-.156-2.341-1.011-2.341-1.011l-1.315.309Z"
                transform="translate(-315.879 -357.89)"
                fill="#fff"
              />
              <g
                id="Group_5464"
                data-name="Group 5464"
                transform="translate(69.121 52.559)"
                clipPath="url(#clip-path-10)"
              >
                <path
                  id="Path_4964"
                  data-name="Path 4964"
                  d="M385,411.37a10.625,10.625,0,0,1,2.248-.92c.449.014,3.434,2.032,3.286,2.355s-.854.586-.942.351a11.946,11.946,0,0,0-2.341-1.011l-1.315.309Z"
                  transform="translate(-385 -410.449)"
                  fill="#e5e0ff"
                />
                <path
                  id="Path_4965"
                  data-name="Path 4965"
                  d="M385,411.37a10.625,10.625,0,0,1,2.248-.92c.449.014,3.434,2.032,3.286,2.355s-.854.586-.942.351a11.946,11.946,0,0,0-2.341-1.011l-1.315.309Z"
                  transform="translate(-385 -410.449)"
                  fill="#e5e0ff"
                  opacity="0.5"
                />
              </g>
              <path
                id="Path_4968"
                data-name="Path 4968"
                d="M380.31,408.169a12.788,12.788,0,0,1,2.876.164c.477.241,2.629,3.933,2.306,4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342Z"
                transform="translate(-312.474 -356.226)"
                fill="#fff"
              />
              <g
                id="Group_5465"
                data-name="Group 5465"
                transform="translate(67.836 51.931)"
                clipPath="url(#clip-path-11)"
              >
                <path
                  id="Path_4969"
                  data-name="Path 4969"
                  d="M380.31,408.169a12.788,12.788,0,0,1,2.876.164c.477.241,2.629,3.933,2.306,4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342Z"
                  transform="translate(-380.31 -408.158)"
                  fill="#e5e0ff"
                />
                <path
                  id="Path_4970"
                  data-name="Path 4970"
                  d="M380.31,408.169a12.788,12.788,0,0,1,2.876.164c.477.241,2.629,3.933,2.306,4.2s-1.216.189-1.189-.11-1.983-2.276-1.983-2.276l-1.564-.342Z"
                  transform="translate(-380.31 -408.158)"
                  fill="#e5e0ff"
                  opacity="0.5"
                />
              </g>
              <path
                id="Path_4973"
                data-name="Path 4973"
                d="M375.12,406.358a12.8,12.8,0,0,1,2.911.167c.482.246,2.662,3.979,2.333,4.253s-1.227.189-1.2-.112-2.007-2.3-2.007-2.3l-1.583-.348Z"
                transform="translate(-308.705 -354.91)"
                fill="#fff"
              />
              <g
                id="Group_5474"
                data-name="Group 5474"
                transform="translate(66.869 51.59)"
              >
                <path
                  id="Path_4974"
                  data-name="Path 4974"
                  d="M378.113,406.553c.482.246,2.662,3.979,2.333,4.253s-1.227.189-1.2-.112-2.007-2.3-2.007-2.3l-1.583-.348S377.631,406.306,378.113,406.553Z"
                  transform="translate(-375.656 -406.529)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                id="Path_4977"
                data-name="Path 4977"
                d="M375.12,406.358a12.8,12.8,0,0,1,2.911.167c.482.246,2.662,3.979,2.333,4.253s-1.227.189-1.2-.112-2.007-2.3-2.007-2.3l-1.583-.348Z"
                transform="translate(-308.705 -354.91)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4978"
                data-name="Path 4978"
                d="M271.1,327.8c1.758,2.708,5.288,9.571,6.318,10.344,1.608,1.2,12.354,4.13,13.389,4.929s.964,1.6,1.944,1.9a52.164,52.164,0,0,0,6.058,1.265c1.4.131.775-.737.775-.737l-2.391-1.643,2.084-.515a22.748,22.748,0,0,0,2.481,2.651c.392.137,1.082,0,1.038-.309-.077-.5-2.306-4.552-3.1-4.724a43.154,43.154,0,0,0-5.595.493s-10.075-6.794-10.256-7.035a14.01,14.01,0,0,0-1.1-2.413c-.493-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077c-.274-.548-.548-1.172-.849-1.884-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.211"
                transform="translate(-232.301 -290.273)"
                fill="#6552cc"
              />
              <g
                id="Group_5467"
                data-name="Group 5467"
                transform="translate(37.599 27.057)"
                clipPath="url(#clip-path-12)"
              >
                <path
                  id="Path_4979"
                  data-name="Path 4979"
                  d="M278.075,328.019c1.315,1.167.876,1.167.583,2.191s.219-.364,1.46-.29.876,1.676.728,1.969,1.534.657,1.241,1.312-1.969,1.6-2.917,2.555,2.478-1.534,3.645-1.6c.356-.025.649.022.9.016a11.5,11.5,0,0,0-.991-2.1c-.5-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077c-.274-.548-.548-1.172-.849-1.884-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.21l.145,1.268.036.027s1.969.364,2.626.438,1.46.655,1.386,1.1-1.969,2.407-1.386,2.555,1.241-1.46,1.9-1.241S276.752,326.852,278.075,328.019Z"
                  transform="translate(-269.878 -317.374)"
                  opacity="0.16"
                />
              </g>
              <path
                id="Path_4981"
                data-name="Path 4981"
                d="M271.1,327.8c1.758,2.708,5.288,9.571,6.318,10.344,1.608,1.2,12.354,4.13,13.389,4.929s.964,1.6,1.944,1.9a52.164,52.164,0,0,0,6.058,1.265c1.4.131.775-.737.775-.737l-2.391-1.643,2.084-.515a22.748,22.748,0,0,0,2.481,2.651c.392.137,1.082,0,1.038-.309-.077-.5-2.306-4.552-3.1-4.724a43.154,43.154,0,0,0-5.595.493s-10.075-6.794-10.256-7.035a14.01,14.01,0,0,0-1.1-2.413c-.493-.7-.805-.5-.805-.5s.2-.907-.1-1.208l-1.608-1.608-.057.077c-.274-.548-.548-1.172-.849-1.884-.841-1.98-3.818-7.537-4.319-8.339-.375-.6-3.519-1.03-5.113-1.211"
                transform="translate(-232.301 -290.273)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4982"
                data-name="Path 4982"
                d="M273.876,342c-.074.246-.137.493-.186.745"
                transform="translate(-235.053 -308.187)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4983"
                data-name="Path 4983"
                d="M278.368,325.45a14.66,14.66,0,0,0-2.158,3.245"
                transform="translate(-236.883 -296.169)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4984"
                data-name="Path 4984"
                d="M298.78,374.591A7.124,7.124,0,0,1,302,371.71"
                transform="translate(-253.272 -329.76)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4985"
                data-name="Path 4985"
                d="M295.79,385.436s.131-.257.367-.646"
                transform="translate(-251.1 -339.258)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4986"
                data-name="Path 4986"
                d="M295.79,368.976s1.345-3.363,2.689-4.228.575.865.575.865"
                transform="translate(-251.1 -324.528)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4987"
                data-name="Path 4987"
                d="M310.656,388.535c1.038.8.964,1.6,1.944,1.9a52.177,52.177,0,0,0,6.058,1.265c1.4.131.775-.737.775-.737l-2.391-1.643,2.084-.515a22.747,22.747,0,0,0,2.481,2.651c.392.137,1.137.186,1.038-.309-.192-.959-2.306-4.552-3.1-4.724a43.147,43.147,0,0,0-5.595.493s-9.177-6.3-10.182-6.981a8.277,8.277,0,0,0-6.532,3.64l.027.022C298.875,384.807,309.621,387.732,310.656,388.535Z"
                transform="translate(-252.153 -335.729)"
                fill="#fff"
              />
              <g
                id="Group_5473"
                data-name="Group 5473"
                transform="translate(48.639 44.212)"
              >
                <path
                  id="Path_4988"
                  data-name="Path 4988"
                  d="M332.061,391.182c-.5-1.219-2.306-4.552-3.1-4.724a43.148,43.148,0,0,0-5.595.493s-9.177-6.3-10.182-6.981a10.2,10.2,0,0,0-2.977.72c1.449.822,11.105,6.3,12.324,6.543,1.293.274,5.606-.435,6.364.074a25.539,25.539,0,0,1,2.887,4.215C332.061,391.48,332.163,391.428,332.061,391.182Z"
                  transform="translate(-310.21 -379.97)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_4989"
                  data-name="Path 4989"
                  d="M332.061,391.182c-.778-1.745-2.306-4.552-3.1-4.724a43.148,43.148,0,0,0-5.595.493s-9.177-6.3-10.182-6.981a10.2,10.2,0,0,0-2.977.72c1.449.822,11.105,6.3,12.324,6.543,1.293.274,5.606-.435,6.364.074a25.539,25.539,0,0,1,2.887,4.215C332.061,391.48,332.171,391.426,332.061,391.182Z"
                  transform="translate(-310.21 -379.97)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                id="Path_4992"
                data-name="Path 4992"
                d="M231.823,236.73l-8.249,3.442a12.163,12.163,0,0,1-1.06,4.193c-.975,2.062-.405,5.965.531,8.071s5.064,1.282,6.573,1.019a16.265,16.265,0,0,0,2.993-.874,2.782,2.782,0,0,0,2.673-.372S230.87,239.816,231.823,236.73Z"
                transform="translate(-197.524 -231.746)"
                fill="#fff"
              />
              <g
                id="Group_5469"
                data-name="Group 5469"
                transform="translate(24.483 4.984)"
                clipPath="url(#clip-path-13)"
              >
                <path
                  id="Path_4993"
                  data-name="Path 4993"
                  d="M231.823,236.73l-8.249,3.442a12.163,12.163,0,0,1-1.06,4.193c-.975,2.062-.405,5.965.531,8.071a1.917,1.917,0,0,0,.726.822V253.1s-1.531-3.793-1.241-5.981,1.534-3.286,1.679-4.669.071-2.04,2.845-3.062,3.938-1.969,4.228-.95,1.46,7.734,2.262,9.339.728,3.286-.509,4.012a17.4,17.4,0,0,1-3.99,1.758l.583-.1a16.265,16.265,0,0,0,2.993-.874,2.782,2.782,0,0,0,2.673-.372S230.87,239.816,231.823,236.73Z"
                  transform="translate(-222.007 -236.73)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_4994"
                  data-name="Path 4994"
                  d="M231.823,236.73l-8.249,3.442a12.163,12.163,0,0,1-1.06,4.193c-.975,2.062-.405,5.965.531,8.071a1.917,1.917,0,0,0,.726.822V253.1s-1.531-3.793-1.241-5.981,1.534-3.286,1.679-4.669.071-2.04,2.845-3.062,3.938-1.969,4.228-.95,1.46,7.734,2.262,9.339.728,3.286-.509,4.012a17.4,17.4,0,0,1-3.99,1.758l.583-.1a16.265,16.265,0,0,0,2.993-.874,2.782,2.782,0,0,0,2.673-.372S230.87,239.816,231.823,236.73Z"
                  transform="translate(-222.007 -236.73)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                id="Path_4996"
                data-name="Path 4996"
                d="M231.823,236.73l-8.249,3.442a12.163,12.163,0,0,1-1.06,4.193c-.975,2.062-.405,5.965.531,8.071s5.064,1.282,6.573,1.019a16.265,16.265,0,0,0,2.993-.874,2.782,2.782,0,0,0,2.673-.372S230.87,239.816,231.823,236.73Z"
                transform="translate(-197.524 -231.746)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4997"
                data-name="Path 4997"
                d="M236.258,256.44a4.286,4.286,0,0,1-.178,1.435c-.219.548-2.287,2.7-2.224,2.933s.249.98.616,1.052"
                transform="translate(-206.127 -246.058)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4998"
                data-name="Path 4998"
                d="M251,262.873c.288-.575,1.232-.014,1.219,1.282"
                transform="translate(-218.577 -250.566)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4999"
                data-name="Path 4999"
                d="M233.9,257.174s.805-.353,1.525.95"
                transform="translate(-206.16 -246.56)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_5000"
                data-name="Path 5000"
                d="M246.82,270.4a3.987,3.987,0,0,1,2.5,1.049"
                transform="translate(-215.541 -256.195)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
              />
              <path
                id="Path_5001"
                data-name="Path 5001"
                d="M230.35,264.15a5.3,5.3,0,0,1,1.4.386"
                transform="translate(-203.582 -251.657)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.5"
              />
              <path
                id="Path_5002"
                data-name="Path 5002"
                d="M235.6,249.84a1.553,1.553,0,0,0-1.386-.033c-.737.353-1.189.742-1.139.29s.915-.95,1.175-1.016S235.669,248.835,235.6,249.84Z"
                transform="translate(-205.555 -240.674)"
                fill="#263238"
              />
              <path
                id="Path_5003"
                data-name="Path 5003"
                d="M249.84,247.836a6.263,6.263,0,0,1,1.78,2.317c.548,1.369.98-.126.548-1.021S250.484,247.282,249.84,247.836Z"
                transform="translate(-217.734 -239.691)"
                fill="#263238"
              />
              <path
                id="Path_5004"
                data-name="Path 5004"
                d="M266.668,295.8c0,.638-.362,1.156-.805,1.156s-.8-.518-.8-1.156.359-2.262.8-2.262S266.668,295.164,266.668,295.8Z"
                transform="translate(-228.786 -272.998)"
                fill="#7a67d9"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_5005"
                data-name="Path 5005"
                d="M250.821,262.56a1.676,1.676,0,0,0-.074.257c-.079.405-.159,1.252,0,1.287s.548-.756.616-1.161a1.544,1.544,0,0,0,.027-.241A4.981,4.981,0,0,0,250.821,262.56Z"
                transform="translate(-218.326 -250.502)"
                fill="#263238"
              />
              <path
                id="Path_5006"
                data-name="Path 5006"
                d="M233.909,256.969a1.591,1.591,0,0,0-.058.219c-.082.405-.079,1.3.093,1.328s.455-.8.534-1.2a1.683,1.683,0,0,0,.033-.3A1.553,1.553,0,0,0,233.909,256.969Z"
                transform="translate(-206.086 -246.434)"
                fill="#263238"
              />
              <path
                id="Path_5007"
                data-name="Path 5007"
                d="M251,262.169l.274-.509a1.98,1.98,0,0,1,1.117.646"
                transform="translate(-218.577 -249.849)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.75"
              />
              <path
                id="Path_5008"
                data-name="Path 5008"
                d="M234.2,256.138l.274-.32s.118-.058.764.236"
                transform="translate(-206.378 -245.603)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="0.75"
              />
              <path
                id="Path_5009"
                data-name="Path 5009"
                d="M230.41,281.876s.46-.846,1.076-.846,1.076,1.383,1.076,1.383"
                transform="translate(-203.626 -263.914)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g
              id="freepik--Mug--inject-65"
              transform="translate(38.889 119.369)"
            >
              <path
                id="Path_5010"
                data-name="Path 5010"
                d="M154.247,406.156a9.428,9.428,0,0,1-3.358-.8,1.162,1.162,0,1,1,.917-2.132,5.8,5.8,0,0,0,2.814.576c.677-.757,1.716-5.33.373-7.537-.3-.49-.586-.581-.773-.6a3.645,3.645,0,0,0-2.292,1.066,1.165,1.165,0,1,1-1.6-1.7c.208-.2,2.132-1.935,4.184-1.658a3.347,3.347,0,0,1,2.441,1.684c1.978,3.225.624,9.36-.9,10.575A2.867,2.867,0,0,1,154.247,406.156Z"
                transform="translate(-139.392 -392.404)"
                fill="#fff"
              />
              <g
                id="Group_5470"
                data-name="Group 5470"
                transform="translate(10.572 0.94)"
                clipPath="url(#clip-path-14)"
              >
                <path
                  id="Path_5011"
                  data-name="Path 5011"
                  d="M156.94,397a2.2,2.2,0,0,0-1.6-1.3c-1.333-.213-2.585,1.125-2.724,1.274a1,1,0,0,0-.112,1.114,1.151,1.151,0,0,0,.56-.288,3.817,3.817,0,0,1,2.292-1.066c.187,0,.469.112.773.6,1.343,2.185.3,6.78-.373,7.537a5.811,5.811,0,0,1-2.814-.576,1.166,1.166,0,0,0-.416-.091.879.879,0,0,0,.448.709,5.33,5.33,0,0,0,2.18.618,1.679,1.679,0,0,0,1.189-.416C157.345,404.2,158.23,399.479,156.94,397Z"
                  transform="translate(-151.095 -394.433)"
                  fill="#92e3a9"
                />
                <path
                  id="Path_5012"
                  data-name="Path 5012"
                  d="M156.94,397a2.2,2.2,0,0,0-1.6-1.3c-1.333-.213-2.585,1.125-2.724,1.274a1,1,0,0,0-.112,1.114,1.151,1.151,0,0,0,.56-.288,3.817,3.817,0,0,1,2.292-1.066c.187,0,.469.112.773.6,1.343,2.185.3,6.78-.373,7.537a5.811,5.811,0,0,1-2.814-.576,1.166,1.166,0,0,0-.416-.091.879.879,0,0,0,.448.709,5.33,5.33,0,0,0,2.18.618,1.679,1.679,0,0,0,1.189-.416C157.345,404.2,158.23,399.479,156.94,397Z"
                  transform="translate(-151.095 -394.433)"
                  fill="#e5e0ff"
                />
              </g>
              <path
                id="Path_5014"
                data-name="Path 5014"
                d="M154.247,406.156a9.428,9.428,0,0,1-3.358-.8,1.162,1.162,0,1,1,.917-2.132,5.8,5.8,0,0,0,2.814.576c.677-.757,1.716-5.33.373-7.537-.3-.49-.586-.581-.773-.6a3.645,3.645,0,0,0-2.292,1.066,1.165,1.165,0,1,1-1.6-1.7c.208-.2,2.132-1.935,4.184-1.658a3.347,3.347,0,0,1,2.441,1.684c1.978,3.225.624,9.36-.9,10.575A2.867,2.867,0,0,1,154.247,406.156Z"
                transform="translate(-139.392 -392.404)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_44650"
                data-name="Rectangle 44650"
                width="12.819"
                height="17.014"
                fill="#fff"
              />
              <g
                id="Group_5471"
                data-name="Group 5471"
                clipPath="url(#clip-path-15)"
              >
                <rect
                  id="Rectangle_44651"
                  data-name="Rectangle 44651"
                  width="5.25"
                  height="17.014"
                  fill="#92e3a9"
                />
                <rect
                  id="Rectangle_44652"
                  data-name="Rectangle 44652"
                  width="5.25"
                  height="17.014"
                  fill="#eeebff"
                />
              </g>
              <rect
                id="Rectangle_44654"
                data-name="Rectangle 44654"
                width="12.819"
                height="17.014"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g
              id="freepik--Device--inject-65"
              transform="translate(65.575 103.655)"
            >
              <path
                id="Path_5015"
                data-name="Path 5015"
                d="M236.773,394.593H182.011l-1.786-30.1a2.047,2.047,0,0,1,2-2.388h54.315a2.047,2.047,0,0,1,2.02,2.388Z"
                transform="translate(-180.196 -362.1)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_5016"
                data-name="Path 5016"
                d="M188.66,363.45H240.1a1.994,1.994,0,0,1,1.988,2.313"
                transform="translate(-184.149 -362.73)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_5017"
                data-name="Path 5017"
                d="M181,365.289a2.009,2.009,0,0,1,2.015-1.839"
                transform="translate(-180.572 -362.73)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <rect
                id="Rectangle_44655"
                data-name="Rectangle 44655"
                width="55.221"
                height="2.932"
                transform="translate(1.585 29.561)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <ellipse
                id="Ellipse_39450"
                data-name="Ellipse 39450"
                cx="3.912"
                cy="2.345"
                rx="3.912"
                ry="2.345"
                transform="translate(25.086 14.018)"
                fill="#fff"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
            <g id="freepik--Table--inject-65" transform="translate(0 135.802)">
              <rect
                id="Rectangle_44656"
                data-name="Rectangle 44656"
                width="205.67"
                height="4.994"
                transform="translate(0 0)"
                fill="#263238"
              />
            </g>
            <g
              id="freepik--pop-up-window--inject-65"
              transform="translate(39.259 0)"
            >
              <rect
                id="Rectangle_44657"
                data-name="Rectangle 44657"
                width="111.022"
                height="68.85"
                rx="11.33"
                transform="translate(0 0)"
                fill="#cabeff"
              />
              <circle
                id="Ellipse_39451"
                data-name="Ellipse 39451"
                cx="16.46"
                cy="16.46"
                r="16.46"
                transform="translate(36.648 9.675) rotate(-9.13)"
                fill="#263238"
              />
              <path
                id="Path_5018"
                data-name="Path 5018"
                d="M242.014,112.168l-5.485,7.041a2.1,2.1,0,0,1-1.738.97,1.807,1.807,0,0,1-1.279-.506,1.647,1.647,0,0,1-.533-1.263,2.473,2.473,0,0,1,.533-1.455l6.252-7.734-5.863-7.739a2.132,2.132,0,0,1-.426-1.258,1.962,1.962,0,0,1,.624-1.444,1.988,1.988,0,0,1,1.439-.613,2.063,2.063,0,0,1,1.716.97l5.3,6.977,5.33-6.86a2.265,2.265,0,0,1,1.828-1.1,1.823,1.823,0,0,1,1.764,1.764,1.865,1.865,0,0,1-.405,1.135l-6.274,8.027,6.06,8a2.063,2.063,0,0,1,.453,1.258,1.828,1.828,0,0,1-.634,1.4,2.1,2.1,0,0,1-1.455.586,2.068,2.068,0,0,1-1.727-.97Z"
                transform="translate(-186.628 -85.811)"
                fill="#fff"
              />
              <path
                id="Path_5019"
                data-name="Path 5019"
                d="M249.829,173.394H187.087a4.8,4.8,0,0,1-4.8-4.8h0a4.8,4.8,0,0,1,4.8-4.8h62.742a4.8,4.8,0,0,1,4.8,4.8h0A4.8,4.8,0,0,1,249.829,173.394Z"
                transform="translate(-162.957 -116.468)"
                fill="#fff"
              />
              <path
                id="Path_5020"
                data-name="Path 5020"
                d="M206.463,172.912a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.416.416,0,0,1,.059-.213l.48-.746H205.7a.32.32,0,0,1-.245-.1.352.352,0,0,1,0-.458.32.32,0,0,1,.245-.1l.965.027-.426-.693a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.283.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.309.309,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.314.314,0,0,1,.245.1.352.352,0,0,1,0,.458.314.314,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.346.346,0,0,1-.309-.208l-.442-.784-.442.784a.357.357,0,0,1-.341.192Z"
                transform="translate(-173.736 -119.237)"
              />
              <path
                id="Path_5021"
                data-name="Path 5021"
                d="M215.643,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.416.416,0,0,1,.059-.213l.48-.746h-.981a.32.32,0,0,1-.245-.1.352.352,0,0,1,0-.458.32.32,0,0,1,.245-.1l.965.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.282.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.309.309,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.315.315,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.341.341,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,215.643,172.889Z"
                transform="translate(-178.023 -119.214)"
              />
              <path
                id="Path_5022"
                data-name="Path 5022"
                d="M224.823,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.415.415,0,0,1,.059-.213l.48-.746h-.981a.32.32,0,0,1-.245-.1.352.352,0,0,1,0-.458.32.32,0,0,1,.245-.1l.965.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.282.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.309.309,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.315.315,0,0,1-.245.1h-.986l.437.682a.564.564,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.341.341,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,224.823,172.889Z"
                transform="translate(-182.31 -119.214)"
              />
              <path
                id="Path_5023"
                data-name="Path 5023"
                d="M234.043,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.415.415,0,0,1,.059-.213l.48-.746h-.981a.32.32,0,0,1-.245-.1.352.352,0,0,1,0-.458.32.32,0,0,1,.245-.1l.965.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.283.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.309.309,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.315.315,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.346.346,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,234.043,172.889Z"
                transform="translate(-186.615 -119.214)"
              />
              <path
                id="Path_5024"
                data-name="Path 5024"
                d="M243.183,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.475.475,0,0,1,.059-.213l.48-.746h-.981a.32.32,0,0,1-.245-.1.352.352,0,0,1,0-.458.32.32,0,0,1,.245-.1l.965.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.283.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.3.3,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.315.315,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.346.346,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,243.183,172.889Z"
                transform="translate(-190.883 -119.214)"
              />
              <path
                id="Path_5025"
                data-name="Path 5025"
                d="M252.363,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.474.474,0,0,1,.059-.213l.48-.746h-.975a.325.325,0,0,1-.251-.1.352.352,0,0,1,0-.458.325.325,0,0,1,.251-.1l.959.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.282.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.3.3,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.315.315,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.347.347,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,252.363,172.889Z"
                transform="translate(-195.17 -119.214)"
              />
              <path
                id="Path_5026"
                data-name="Path 5026"
                d="M261.543,172.912a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.416.416,0,0,1,.059-.213l.48-.746h-.981a.32.32,0,0,1-.245-.1.352.352,0,0,1,0-.458.32.32,0,0,1,.245-.1l.965.027-.469-.693a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.283.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.3.3,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.314.314,0,0,1,.245.1.352.352,0,0,1,0,.458.314.314,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.346.346,0,0,1-.309-.208l-.442-.784-.442.784a.357.357,0,0,1-.3.192Z"
                transform="translate(-199.457 -119.237)"
              />
              <path
                id="Path_5027"
                data-name="Path 5027"
                d="M270.723,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.475.475,0,0,1,.059-.213l.48-.746h-.975a.3.3,0,0,1-.245-.1.336.336,0,0,1,0-.458.3.3,0,0,1,.245-.1l.959.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.325-.336.3.3,0,0,1,.283.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.288.288,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.314.314,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.309.33.347.347,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,270.723,172.889Z"
                transform="translate(-203.744 -119.214)"
              />
              <path
                id="Path_5028"
                data-name="Path 5028"
                d="M279.9,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.474.474,0,0,1,.059-.213l.48-.746h-.981a.3.3,0,0,1-.24-.1.336.336,0,0,1,0-.458.3.3,0,0,1,.24-.1l.965.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.325-.336.3.3,0,0,1,.282.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.288.288,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.315.315,0,0,1,.245.1.352.352,0,0,1,0,.458.314.314,0,0,1-.245.1H281.2l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.309.33.347.347,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,279.9,172.889Z"
                transform="translate(-208.031 -119.214)"
              />
              <path
                id="Path_5029"
                data-name="Path 5029"
                d="M289.043,172.889a.309.309,0,0,1-.224-.1.325.325,0,0,1-.1-.24.474.474,0,0,1,.059-.213l.48-.746h-.981a.3.3,0,0,1-.24-.1.336.336,0,0,1,0-.458.3.3,0,0,1,.24-.1l.965.027-.453-.72a.485.485,0,0,1-.069-.235.325.325,0,0,1,.1-.24.32.32,0,0,1,.229-.1.3.3,0,0,1,.282.181l.469.837.448-.8a.373.373,0,0,1,.32-.219.288.288,0,0,1,.224.1.3.3,0,0,1,.1.229.4.4,0,0,1-.064.213l-.469.752.975-.027a.314.314,0,0,1,.245.1.352.352,0,0,1,0,.458.315.315,0,0,1-.245.1h-.986l.437.682a.565.565,0,0,1,.08.272.32.32,0,0,1-.091.235.3.3,0,0,1-.219.1.347.347,0,0,1-.309-.208l-.442-.784-.442.784A.357.357,0,0,1,289.043,172.889Z"
                transform="translate(-212.299 -119.214)"
              />
            </g>
          </g>
          <rect
            id="Rectangle_44658"
            data-name="Rectangle 44658"
            width="13.569"
            height="11.025"
            transform="translate(2486.612 2129.334) rotate(3.9)"
            fill="#f4f2ff"
          />
          <g
            id="Verify_OTP"
            data-name="Verify OTP"
            transform="translate(2336 1985)"
          >
            <path
              id="Path_5032"
              data-name="Path 5032"
              d="M177.275,157.272a2.544,2.544,0,0,1,4.407,0L196,182.079a2.545,2.545,0,0,1-2.2,3.816H165.157a2.545,2.545,0,0,1-2.2-3.816Z"
              transform="translate(-11.132 -30.482)"
              fill="rgba(101,82,204,0.1)"
            />
            <path
              id="Path_4696"
              data-name="Path 4696"
              d="M240.617,4.272a2.544,2.544,0,0,1,4.407,0L263.019,35.44a2.545,2.545,0,0,1-2.2,3.816h-35.99a2.545,2.545,0,0,1-2.2-3.816Z"
              transform="translate(-33.766 -3)"
              fill="rgba(101,82,204,0.1)"
            />
            <circle
              id="Ellipse_39444"
              data-name="Ellipse 39444"
              cx="25.5"
              cy="25.5"
              r="25.5"
              transform="translate(-0.051 99.322)"
              fill="rgba(101,82,204,0.1)"
            />
            <circle
              id="Ellipse_39445"
              data-name="Ellipse 39445"
              cx="16"
              cy="16"
              r="16"
              transform="translate(36.949 9.322)"
              fill="rgba(101,82,204,0.1)"
            />
            <g
              id="Group_5436"
              data-name="Group 5436"
              transform="translate(197.873 4.24)"
              opacity="0.3"
            >
              <path
                id="Path_4735"
                data-name="Path 4735"
                d="M286.266,129.708H233.315v-95.9A25.805,25.805,0,0,1,259.12,8a27.133,27.133,0,0,1,27.134,27.134v94.574Z"
                transform="translate(-233.315 -8)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4736"
                data-name="Path 4736"
                d="M281.348,130.65V36.572a20.5,20.5,0,0,0-20.5-20.5h0a20.5,20.5,0,0,0-20.487,20.5v94.092"
                transform="translate(-234.386 -9.227)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4737"
                data-name="Path 4737"
                d="M264.533,8V129.566"
                transform="translate(-238.057 -8)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4738"
                data-name="Path 4738"
                d="M286.044,35.612H233.732"
                transform="translate(-233.378 -12.194)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4739"
                data-name="Path 4739"
                d="M286.044,55.081H233.732"
                transform="translate(-233.378 -15.152)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4740"
                data-name="Path 4740"
                d="M286.044,74.549H233.732"
                transform="translate(-233.378 -18.109)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4741"
                data-name="Path 4741"
                d="M286.044,94.023H233.732"
                transform="translate(-233.378 -21.068)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4742"
                data-name="Path 4742"
                d="M286.044,113.493H233.732"
                transform="translate(-233.378 -24.025)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4743"
                data-name="Path 4743"
                d="M286.044,132.962H233.732"
                transform="translate(-233.378 -26.983)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4744"
                data-name="Path 4744"
                d="M286.318,17.741l-4.742,4.321"
                transform="translate(-240.646 -9.48)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4745"
                data-name="Path 4745"
                d="M242.13,17.741l4.745,4.321"
                transform="translate(-234.654 -9.48)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
            </g>
            <g
              id="Group_5437"
              data-name="Group 5437"
              transform="translate(3.392 4.24)"
              opacity="0.3"
            >
              <path
                id="Path_4746"
                data-name="Path 4746"
                d="M56.95,129.708H4v-95.9A25.805,25.805,0,0,1,29.8,8,27.134,27.134,0,0,1,56.939,35.134v94.574Z"
                transform="translate(-4 -8)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4747"
                data-name="Path 4747"
                d="M52.037,130.647V36.57a20.5,20.5,0,0,0-20.5-20.513h0A20.5,20.5,0,0,0,11.026,36.57v94.092"
                transform="translate(-5.067 -9.224)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4748"
                data-name="Path 4748"
                d="M35.214,8V129.566"
                transform="translate(-8.741 -8)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4749"
                data-name="Path 4749"
                d="M56.728,35.612H4.413"
                transform="translate(-4.062 -12.194)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4750"
                data-name="Path 4750"
                d="M56.728,55.081H4.413"
                transform="translate(-4.062 -15.152)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4751"
                data-name="Path 4751"
                d="M56.728,74.549H4.413"
                transform="translate(-4.062 -18.109)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4752"
                data-name="Path 4752"
                d="M56.728,94.023H4.413"
                transform="translate(-4.062 -21.068)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4753"
                data-name="Path 4753"
                d="M56.728,113.492H4.413"
                transform="translate(-4.062 -24.025)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4754"
                data-name="Path 4754"
                d="M56.728,132.961H4.413"
                transform="translate(-4.062 -26.982)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4755"
                data-name="Path 4755"
                d="M57,17.741l-4.745,4.321"
                transform="translate(-11.33 -9.48)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
              <path
                id="Path_4756"
                data-name="Path 4756"
                d="M12.814,17.741l4.741,4.321"
                transform="translate(-5.339 -9.48)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
                opacity="0.3"
              />
            </g>
            <path
              id="Path_4757"
              data-name="Path 4757"
              d="M236.529,196.248h55.116"
              transform="translate(-35.931 -32.356)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4758"
              data-name="Path 4758"
              d="M10,196.248H196.607"
              transform="translate(-1.519 -32.356)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <g
              id="Group_5561"
              data-name="Group 5561"
              transform="translate(239.911 110.268)"
            >
              <path
                id="Path_4344"
                data-name="Path 4344"
                d="M29.521,138.1A4.226,4.226,0,0,0,28,135.5c-1.517-1.516-2.488-2.382-2.488-2.382s-.76,2.491.648,4a26.637,26.637,0,0,0,3.351,2.924Z"
                transform="translate(-16.535 -133.118)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4345"
                data-name="Path 4345"
                d="M26.93,146.073a4.232,4.232,0,0,0-1.514-2.6c-1.514-1.516-2.491-2.382-2.491-2.382s-.757,2.491.651,4.007a26.669,26.669,0,0,0,3.354,2.916Z"
                transform="translate(-16.142 -134.329)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4346"
                data-name="Path 4346"
                d="M30.126,140.355a4.224,4.224,0,0,1,1.782-2.425c1.667-1.346,2.729-2.106,2.729-2.106s.491,2.555-1.07,3.91a26.569,26.569,0,0,1-3.647,2.553Z"
                transform="translate(-17.235 -133.529)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4347"
                data-name="Path 4347"
                d="M26.95,149.847s.229-1.058,2.028-2.234,2.935-1.807,2.935-1.807.218,2.594-1.475,3.782a26.751,26.751,0,0,1-3.91,2.156Z"
                transform="translate(-16.72 -135.045)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4348"
                data-name="Path 4348"
                d="M27.618,159.956a4.229,4.229,0,0,1,1.516-2.6c1.516-1.516,2.491-2.382,2.491-2.382s.757,2.492-.651,4.008a26.571,26.571,0,0,1-3.351,2.923Z"
                transform="translate(-16.885 -136.438)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4349"
                data-name="Path 4349"
                d="M26.922,162.368a4.263,4.263,0,0,0-1.117-2.793c-1.271-1.721-2.125-2.712-2.125-2.712s-1.117,2.358.073,4.058a26.677,26.677,0,0,0,2.907,3.371Z"
                transform="translate(-16.215 -136.725)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4350"
                data-name="Path 4350"
                d="M25.826,169.888a4.221,4.221,0,0,1,1.516-2.6c1.516-1.514,2.491-2.382,2.491-2.382s.757,2.488-.651,4a26.576,26.576,0,0,1-3.351,2.924Z"
                transform="translate(-16.613 -137.947)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4351"
                data-name="Path 4351"
                d="M27.019,176.469a4.2,4.2,0,0,1,.807-2.9c1.086-1.851,1.807-2.935,1.807-2.935s1.363,2.218.385,4.041a26.465,26.465,0,0,1-2.513,3.678Z"
                transform="translate(-16.789 -138.817)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4352"
                data-name="Path 4352"
                d="M29.724,138.663a31,31,0,0,1-.413,3.351c-.6,3.095-2.1,5.094-2.7,7.89s1.117,6.4.662,9.99-1.86,5.586-1.461,7.987,2.5,8.887,2.5,8.887"
                transform="translate(-16.601 -133.96)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4353"
                data-name="Path 4353"
                d="M30.147,141.788l1.634-1.251"
                transform="translate(-17.27 -134.245)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4354"
                data-name="Path 4354"
                d="M30.114,140.092l-.684-1.215"
                transform="translate(-17.161 -133.993)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4355"
                data-name="Path 4355"
                d="M26.876,151.412s1.366-1.025,2.773-2.053"
                transform="translate(-16.773 -135.585)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4356"
                data-name="Path 4356"
                d="M27.248,148.588a21.862,21.862,0,0,0-2.43-3.717"
                transform="translate(-16.46 -134.903)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4357"
                data-name="Path 4357"
                d="M27.683,161.962a16.886,16.886,0,0,1,2.924-3.91"
                transform="translate(-16.895 -136.906)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4358"
                data-name="Path 4358"
                d="M26.925,163.715a19.248,19.248,0,0,0-1.48-2.812c-.8-1.179-.913-1.33-.913-1.33"
                transform="translate(-16.416 -137.137)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4359"
                data-name="Path 4359"
                d="M25.826,172.308a18.007,18.007,0,0,1,1.232-2.491,15.819,15.819,0,0,1,1.595-2.089"
                transform="translate(-16.613 -138.376)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4360"
                data-name="Path 4360"
                d="M27.6,178.751a4.653,4.653,0,0,1,.411-2.394c.559-1.1,1.215-2.544,1.48-3.113"
                transform="translate(-16.879 -139.213)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4361"
                data-name="Path 4361"
                d="M18.571,155.41a2.7,2.7,0,0,1,.667-1.8c.785-1.117,1.3-1.761,1.3-1.761a2.905,2.905,0,0,1,.028,2.583,16.847,16.847,0,0,1-1.787,2.195Z"
                transform="translate(-15.51 -135.964)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4362"
                data-name="Path 4362"
                d="M21.064,160.14a2.7,2.7,0,0,1,.668-1.8c.785-1.114,1.315-1.773,1.315-1.773a2.9,2.9,0,0,1,.025,2.581,16.92,16.92,0,0,1-1.787,2.2Z"
                transform="translate(-15.889 -136.681)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4363"
                data-name="Path 4363"
                d="M18.284,156.976s-.19-.662-1.38-1.326-1.941-1.025-1.941-1.025a2.9,2.9,0,0,0,1.1,2.341,17.019,17.019,0,0,0,2.564,1.2Z"
                transform="translate(-14.963 -136.385)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4364"
                data-name="Path 4364"
                d="M21.229,162.606s-.257-.639-1.511-1.173-2.036-.815-2.036-.815a2.893,2.893,0,0,0,1.335,2.208,16.81,16.81,0,0,0,2.678.93Z"
                transform="translate(-15.376 -137.295)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4365"
                data-name="Path 4365"
                d="M22.061,168.982s-.117-.678-1.232-1.463-1.821-1.224-1.821-1.224a2.916,2.916,0,0,0,.838,2.442,16.95,16.95,0,0,0,2.421,1.469Z"
                transform="translate(-15.575 -138.158)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4366"
                data-name="Path 4366"
                d="M22.9,170.352a2.677,2.677,0,0,1,.4-1.871c.62-1.214,1.039-1.933,1.039-1.933a2.908,2.908,0,0,1,.4,2.553,17.012,17.012,0,0,1-1.458,2.43Z"
                transform="translate(-16.162 -138.196)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4367"
                data-name="Path 4367"
                d="M25.118,176.979s.078-.684,1.148-1.533,1.745-1.326,1.745-1.326a2.9,2.9,0,0,1-.7,2.485,16.835,16.835,0,0,1-2.335,1.606Z"
                transform="translate(-16.484 -139.346)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4368"
                data-name="Path 4368"
                d="M24.262,175.017s-.117-.678-1.232-1.466-1.821-1.223-1.821-1.223a2.912,2.912,0,0,0,.838,2.441,16.826,16.826,0,0,0,2.416,1.469Z"
                transform="translate(-15.909 -139.074)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4369"
                data-name="Path 4369"
                d="M24.35,179.245a2.684,2.684,0,0,0-.821-1.728c-.88-1.042-1.452-1.645-1.452-1.645a2.906,2.906,0,0,0,.2,2.575,16.954,16.954,0,0,0,1.972,2.036Z"
                transform="translate(-16.01 -139.613)"
                fill="#4cc5b1"
              />
              <path
                id="Path_4370"
                data-name="Path 4370"
                d="M18.434,155.859a19.824,19.824,0,0,0,.626,2.063c.712,1.874,1.868,2.967,2.547,4.653s0,4.136.67,6.336,1.773,3.3,1.782,4.851-.6,5.842-.6,5.842"
                transform="translate(-15.49 -136.573)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4371"
                data-name="Path 4371"
                d="M18.773,157.819l-1.159-.609"
                transform="translate(-15.366 -136.778)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4372"
                data-name="Path 4372"
                d="M18.74,156.72l.3-.838"
                transform="translate(-15.537 -136.576)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4373"
                data-name="Path 4373"
                d="M21.736,163.52s-.969-.494-1.955-.985"
                transform="translate(-15.695 -137.587)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4374"
                data-name="Path 4374"
                d="M21.313,161.74a13.816,13.816,0,0,1,1.117-2.594"
                transform="translate(-15.928 -137.072)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4375"
                data-name="Path 4375"
                d="M22.364,170.226a10.842,10.842,0,0,0-2.254-2.137"
                transform="translate(-15.745 -138.43)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4376"
                data-name="Path 4376"
                d="M23.159,171.186a12.3,12.3,0,0,1,.623-1.924c.374-.824.427-.932.427-.932"
                transform="translate(-16.208 -138.467)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4377"
                data-name="Path 4377"
                d="M25.007,178a10.061,10.061,0,0,1,1.246-1.3,6.827,6.827,0,0,0,.813-.706"
                transform="translate(-16.489 -139.631)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4378"
                data-name="Path 4378"
                d="M24.659,176.512a11.581,11.581,0,0,0-1.042-1.43,10.047,10.047,0,0,0-1.226-1.131"
                transform="translate(-16.091 -139.321)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4379"
                data-name="Path 4379"
                d="M24.351,180.725a2.941,2.941,0,0,0-.517-1.46c-.478-.628-1.039-1.464-1.268-1.793"
                transform="translate(-16.118 -139.856)"
                fill="none"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
              <path
                id="Path_4380"
                data-name="Path 4380"
                d="M28.426,194.048H22.1a.5.5,0,0,1-.5-.5l-1.57-10.478H30.493l-1.57,10.478a.5.5,0,0,1-.5.5Z"
                transform="translate(-15.733 -140.707)"
                fill="#263238"
                stroke="#263238"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

// export function ExpertProfileBannerImage(props) {
//   const { rootStyle, ...rest } = props;
//   const rootSx = {
//     width: 126,
//     height: 120,
//     ...rootStyle,
//   };
//   return (
//     <SvgIcon
//       xmlns="http://www.w3.org/2000/svg"
//       xmlns:xlink="http://www.w3.org/1999/xlink"
//       viewBox="0 0 126 120"
//       {...rest}
//       sx={rootSx}
//     >
//       <defs>
//         <clipPath id="clip-path">
//           <path
//             id="Rectangle_56261"
//             data-name="Rectangle 56261"
//             d="M60,0h58.615A7.385,7.385,0,0,1,126,7.385V112.615A7.385,7.385,0,0,1,118.615,120H60A60,60,0,0,1,0,60v0A60,60,0,0,1,60,0Z"
//             transform="translate(2196 14115)"
//             fill="#fff"
//             stroke="#707070"
//             stroke-width="1"
//           />
//         </clipPath>
//       </defs>
//       <g
//         id="Mask_Group_43"
//         data-name="Mask Group 43"
//         transform="translate(-2196 -14115)"
//         opacity="0.5"
//         clip-path="url(#clip-path)"
//       >
//         <g
//           id="Group_106509"
//           data-name="Group 106509"
//           transform="translate(2161 14108)"
//         >
//           <path
//             id="Path_101059"
//             data-name="Path 101059"
//             d="M321.407,1075.865c.407,2.851,4.431,2.437,12.407,2.215s12.185,0,12.628-2.658-3.323-5.982-12.407-5.982-13.071,3.323-12.628,6.425Z"
//             transform="translate(-267.617 -992.841)"
//             fill="#7a67d9"
//           />
//           <path
//             id="Path_101060"
//             data-name="Path 101060"
//             d="M388.432,1121.781l.361,2.66c.044.323.535.186.492-.135l-.361-2.66c-.044-.323-.535-.186-.492.135Z"
//             transform="translate(-330.283 -1041.456)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101061"
//             data-name="Path 101061"
//             d="M387.83,1120.324a12.859,12.859,0,0,1,2.146-.578c.322-.058.186-.549-.135-.492a12.882,12.882,0,0,0-2.146.578c-.306.111-.173.6.136.492Z"
//             transform="translate(-329.435 -1039.39)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101062"
//             data-name="Path 101062"
//             d="M390,1137.7l1.694-.461a.255.255,0,0,0-.136-.492l-1.693.461a.255.255,0,0,0,.135.492Z"
//             transform="translate(-331.457 -1055.73)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101063"
//             data-name="Path 101063"
//             d="M446.139,1116.986a4.169,4.169,0,0,0-.433,2.5.665.665,0,0,0,1.119.444c1.059-.746,1.019-3.171-.594-3.108-.327.013-.329.522,0,.509.6-.023.823.542.81,1.053-.009.323-.136.918-.454,1.089-.547.293-.42-.679-.388-.967a3.931,3.931,0,0,1,.38-1.265c.142-.294-.3-.552-.44-.257h0Z"
//             transform="translate(-383.765 -1037.12)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101064"
//             data-name="Path 101064"
//             d="M446.93,1116.413a.921.921,0,0,0,.229,1.479c.746.4,1.517-.12,2.09-.572.257-.2-.105-.561-.36-.36a1.9,1.9,0,0,1-1.182.56c-.366-.018-.785-.424-.416-.747.247-.216-.115-.575-.36-.36h0Z"
//             transform="translate(-384.691 -1036.676)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101065"
//             data-name="Path 101065"
//             d="M508.719,1112.3a10.294,10.294,0,0,0-.609,1.288,3.287,3.287,0,0,0-.351,1.291.716.716,0,0,0,1.1.507c1.156-.593,1.546-2.661.208-3.251-.3-.131-.557.308-.257.44a1,1,0,0,1,.61.962,1.711,1.711,0,0,1-.574,1.208c-.837.447-.376-.671-.281-.922a9.357,9.357,0,0,1,.6-1.264c.16-.287-.28-.544-.44-.257h0Z"
//             transform="translate(-441.799 -1032.719)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101066"
//             data-name="Path 101066"
//             d="M515.55,1112.424a.837.837,0,0,0-.661,1.205c.421.736,1.377.259,2.007.335.325.039.322-.471,0-.509-.4-.048-.78.119-1.179.093-.155-.01-.351-.055-.4-.221a.326.326,0,0,1,.234-.392c.321-.041.325-.551,0-.509h0Z"
//             transform="translate(-448.37 -1033.01)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101067"
//             data-name="Path 101067"
//             d="M563.04,1115.988q-.485,1.322-1.082,2.595c-.139.3.3.554.44.257q.625-1.333,1.133-2.717c.113-.308-.379-.441-.492-.135h0Z"
//             transform="translate(-492.427 -1036.179)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101068"
//             data-name="Path 101068"
//             d="M560.521,1114.344c.651.244,1.143.951.549,1.543a2.87,2.87,0,0,1-1.747.708c-.324.03-.327.539,0,.509a2.872,2.872,0,0,0,2.474-1.388c.323-.84-.412-1.591-1.142-1.864-.308-.115-.441.377-.135.492h0Z"
//             transform="translate(-489.762 -1034.329)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101069"
//             data-name="Path 101069"
//             d="M634.738,1134.25a1.462,1.462,0,0,1-1.253,1.28c-.323.05-.186.541.135.492a1.968,1.968,0,0,0,1.627-1.772c.031-.326-.479-.324-.509,0h0Z"
//             transform="translate(-559.125 -1053.18)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101070"
//             data-name="Path 101070"
//             d="M613.509,1162.459v-.074a.255.255,0,0,0-.509,0v.074a.255.255,0,0,0,.509,0Z"
//             transform="translate(-540.153 -1079.471)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101071"
//             data-name="Path 101071"
//             d="M659.118,1646.253a2.507,2.507,0,0,0-2.677,1.989c-.22,2.021,2.075,3.6,3.873,3.689a4.314,4.314,0,0,0,4.266-3.848c.221-1.586-.378-3.712-2.19-4.021a3.206,3.206,0,0,0-3.517,2.379.255.255,0,0,0,.492.135,2.661,2.661,0,0,1,3.189-1.959c1.963.623,1.816,3.575.973,4.988a3.626,3.626,0,0,1-6.074.244c-1.124-1.533-.079-3.062,1.667-3.084a.255.255,0,0,0,0-.509Z"
//             transform="translate(-580.736 -1529.808)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101072"
//             data-name="Path 101072"
//             d="M669.685,1650.715a3.536,3.536,0,0,1,1.4,1.462c.151.291.591.034.44-.257a4.023,4.023,0,0,0-1.586-1.645.255.255,0,0,0-.257.44Z"
//             transform="translate(-593.011 -1535.62)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101073"
//             data-name="Path 101073"
//             d="M690.656,1619.627a3.045,3.045,0,0,1,.845-3.35l-.426-.113a2.9,2.9,0,0,1-.869,3.243c-.25.213.112.572.36.36a3.394,3.394,0,0,0,1-3.739.259.259,0,0,0-.426-.113,3.546,3.546,0,0,0-.977,3.846c.11.306.6.174.492-.136h0Z"
//             transform="translate(-612.069 -1503.476)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101074"
//             data-name="Path 101074"
//             d="M682.774,1706.063a1.309,1.309,0,0,0,.414,1.29c.248.211.61-.147.36-.36a.8.8,0,0,1-.283-.795c.071-.319-.42-.456-.492-.135h0Z"
//             transform="translate(-605.328 -1587.619)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101075"
//             data-name="Path 101075"
//             d="M704.741,1732.229a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
//             transform="translate(-625.659 -1611.766)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101076"
//             data-name="Path 101076"
//             d="M768.7,1715.349c-2.643.082-4.978,2.785-6.472,4.683a18.421,18.421,0,0,0-2.389,3.809,4.28,4.28,0,0,0-.541,2.717c.424,1.482,2.023,1.928,3.368,2.071,3.843.411,7.828.073,11.685.081,3.6.007,7.356.273,10.925-.306a5.323,5.323,0,0,0,2.406-.858,5.743,5.743,0,0,0,1.506-2.369,20.339,20.339,0,0,0,1.4-4.472,5.537,5.537,0,0,0-.143-3.487c-1.354-2.483-3.991.859-4.842,1.973-.753.987-1.8,2.913-3.28,2.465a21.066,21.066,0,0,1-4.125-2.135c-1.7-.976-3.391-1.97-5.158-2.817a10.989,10.989,0,0,0-4.337-1.356.255.255,0,0,0,0,.509c2.749.064,5.554,2,7.861,3.312,1.279.73,2.544,1.49,3.849,2.173a6.473,6.473,0,0,0,2.336.931c.865.057,1.533-.655,2.057-1.252.881-1,1.583-2.158,2.515-3.119.818-.844,2.336-1.666,2.825-.056a7.872,7.872,0,0,1-.348,4.044,19.364,19.364,0,0,1-1.481,3.951,3.156,3.156,0,0,1-1.536,1.639c-2.2.974-5.123.709-7.463.722-4.209.024-8.417.012-12.626.029-1.766.007-4.509.382-6.062-.715-2-1.413.01-4.318.978-5.767a20.582,20.582,0,0,1,3.355-3.914,6.423,6.423,0,0,1,3.741-1.978c.327-.01.329-.52,0-.509Z"
//             transform="translate(-676.807 -1596.467)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101077"
//             data-name="Path 101077"
//             d="M827.3,1633.722a6.347,6.347,0,0,0-3.1,1.682c-.433.394-1.411,1.255-1.223,1.958.269,1.009,3.172.619,3.869.6a24.254,24.254,0,0,0,6.618-.764c1.14-.357,1.959-1.235.637-2.051a10.315,10.315,0,0,0-3.317-1.1,11.623,11.623,0,0,0-3.411-.338c-.323.032-.327.542,0,.509a12.4,12.4,0,0,1,6.174,1.208c.268.135.858.383.758.757-.067.253-.64.409-.827.475a13.318,13.318,0,0,1-2.861.549,34.669,34.669,0,0,1-6.106.215c-.206-.013-.707.034-.879-.1-.316-.247.116-.7.34-.966a6.18,6.18,0,0,1,3.468-2.146c.323-.054.186-.545-.135-.492Z"
//             transform="translate(-736.36 -1520.147)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101078"
//             data-name="Path 101078"
//             d="M879.768,1692.5a7.935,7.935,0,0,1,.115,1.489.255.255,0,0,0,.509,0,8.652,8.652,0,0,0-.133-1.624c-.056-.323-.547-.186-.492.135h0Z"
//             transform="translate(-789.453 -1574.819)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101079"
//             data-name="Path 101079"
//             d="M914.2,1691.485v1.551a.255.255,0,0,0,.509,0v-1.551a.255.255,0,0,0-.509,0Z"
//             transform="translate(-821.636 -1573.935)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101080"
//             data-name="Path 101080"
//             d="M854.164,1772.307a4.566,4.566,0,0,0-3.623,4.8c.295,2.254,2.557,3.247,4.6,2.866,2.079-.387,3.743-1.894,3.549-4.107a3.806,3.806,0,0,0-4.463-3.573c-.32.042-.325.553,0,.509a3.328,3.328,0,0,1,3.962,3.209,3.367,3.367,0,0,1-2.944,3.42c-1.751.395-3.762-.255-4.175-2.2-.435-2.046,1.311-4.041,3.225-4.436C854.62,1772.732,854.485,1772.24,854.164,1772.307Z"
//             transform="translate(-762.115 -1649.649)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101081"
//             data-name="Path 101081"
//             d="M903.5,1820.7l2.437,4.209a.255.255,0,0,0,.44-.257l-2.437-4.209a.255.255,0,0,0-.44.257Z"
//             transform="translate(-811.603 -1694.563)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101082"
//             data-name="Path 101082"
//             d="M940.7,1876.482c.071.717,1.087.777,1.635.766.475-.009,1.559-.1,1.531-.791-.028-.667-1.1-.792-1.582-.812-.6-.025-1.527.084-1.584.837-.025.327.485.325.509,0,.042-.554,2.152-.375,2.145-.007-.006.35-2.106.406-2.145.007C941.176,1876.158,940.667,1876.155,940.7,1876.482Z"
//             transform="translate(-846.399 -1746.267)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101083"
//             data-name="Path 101083"
//             d="M1104.79,1627.425a4.262,4.262,0,0,0-1.521.97,29.825,29.825,0,0,0-2.3,1.919c-.381.355-1.093.89-1.222,1.443a1.163,1.163,0,0,0,1.177,1.316c.553-.056,1.146-.666,1.561-.974.8-.6,1.593-1.206,2.359-1.845.364-.3,1.209-.827,1.344-1.336.183-.688-.679-1.381-1.264-1.493-.321-.061-.458.43-.135.492.428.081,1,.534.821.952-.069.164-.334.336-.46.45-.437.4-.9.772-1.364,1.14q-.848.675-1.721,1.319c-.209.154-.756.721-1.032.727a2.656,2.656,0,0,1-.777-.655c0-.067.109-.15.133-.2a2.4,2.4,0,0,1,.5-.557c.458-.462.952-.89,1.449-1.308.635-.533,1.712-1.722,2.58-1.864.323-.053.186-.544-.135-.492Z"
//             transform="translate(-995.016 -1514.294)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101084"
//             data-name="Path 101084"
//             d="M1186.665,1650.785l2.059,5.37c.117.3.609.172.492-.135q-1.03-2.685-2.059-5.37c-.116-.3-.609-.171-.492.135Z"
//             transform="translate(-1076.248 -1535.842)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101085"
//             data-name="Path 101085"
//             d="M1173.241,1662.88l1.929,4.524c.128.3.568.041.44-.257l-1.929-4.524c-.128-.3-.568-.041-.44.257Z"
//             transform="translate(-1063.698 -1547.068)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101086"
//             data-name="Path 101086"
//             d="M789.445,1951.31c-.933.242-.714,2.332.19,2.5a17.272,17.272,0,0,0,2.617.083,7.078,7.078,0,0,0,2.266-.044c.783-.277.963-2.354.035-2.545a12.829,12.829,0,0,0-2.409,0h-2.631a.255.255,0,0,0,0,.509h3.409a4.8,4.8,0,0,1,1.5,0,1.59,1.59,0,0,1,.031,1.529c-.212.181-1.11.054-1.365.053-.636,0-1.272-.022-1.907-.042a4.889,4.889,0,0,1-1.5-.052c-.225-.105-.507-1.392-.1-1.5a.255.255,0,0,0-.136-.492Z"
//             transform="translate(-704.485 -1816.91)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101087"
//             data-name="Path 101087"
//             d="M1134.655,1951.31c-.933.242-.714,2.332.19,2.5a17.273,17.273,0,0,0,2.617.083,7.078,7.078,0,0,0,2.266-.044c.783-.277.963-2.354.035-2.545a12.828,12.828,0,0,0-2.409,0h-2.631a.255.255,0,0,0,0,.509h3.409a4.8,4.8,0,0,1,1.5,0,1.59,1.59,0,0,1,.031,1.529c-.212.181-1.11.054-1.365.053-.636,0-1.272-.022-1.907-.042a4.889,4.889,0,0,1-1.5-.052c-.225-.105-.507-1.392-.1-1.5a.255.255,0,0,0-.135-.492Z"
//             transform="translate(-1027.097 -1816.91)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101088"
//             data-name="Path 101088"
//             d="M824.219,1911.7q-.458,1.247-1.034,2.442c-.141.294.3.553.44.257q.6-1.256,1.085-2.564c.113-.308-.379-.441-.492-.135Z"
//             transform="translate(-736.553 -1779.801)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101089"
//             data-name="Path 101089"
//             d="M846.626,1913.4l-1.112,2.435c-.135.3.3.555.44.257l1.112-2.435c.135-.3-.3-.555-.44-.257Z"
//             transform="translate(-757.422 -1781.427)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101090"
//             data-name="Path 101090"
//             d="M1140.979,1910.4a15.886,15.886,0,0,1,1.287,2.531c.12.3.613.169.492-.135a16.7,16.7,0,0,0-1.339-2.653c-.173-.278-.614-.022-.44.257Z"
//             transform="translate(-1033.532 -1778.396)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101091"
//             data-name="Path 101091"
//             d="M1162,1906.608l1.323,2.844c.138.3.577.039.44-.257l-1.323-2.844c-.138-.3-.577-.039-.44.257Z"
//             transform="translate(-1053.194 -1774.843)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101092"
//             data-name="Path 101092"
//             d="M1207.442,1767.088a5.247,5.247,0,0,1-.53,2.027c-.144.293.3.552.44.257a5.9,5.9,0,0,0,.6-2.283c.019-.327-.491-.327-.509,0h0Z"
//             transform="translate(-1095.16 -1644.591)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101093"
//             data-name="Path 101093"
//             d="M1196.611,1819.1a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
//             transform="translate(-1085.33 -1692.95)"
//             fill="#414042"
//           />
//           <g
//             id="Group_106489"
//             data-name="Group 106489"
//             transform="translate(117.907 113.788)"
//           >
//             <path
//               id="Path_101094"
//               data-name="Path 101094"
//               d="M1309.516,1691.515a6.989,6.989,0,0,0-7.1,3.082,5.819,5.819,0,0,0,.8,7.631,7.068,7.068,0,0,0,7.75,1.694,6.453,6.453,0,0,0,3.984-5.869,6.893,6.893,0,0,0-5.431-6.538.255.255,0,0,0-.135.492c3.165.823,5.587,3.692,4.966,7.078a6.133,6.133,0,0,1-6.457,4.845c-3.344-.232-6.741-3.444-5.972-6.963a6.581,6.581,0,0,1,7.461-4.961c.32.068.456-.423.135-.492Z"
//               transform="translate(-1301.34 -1687.855)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101095"
//               data-name="Path 101095"
//               d="M1357.039,1642.089a20.189,20.189,0,0,1,.373-3.015c.153-.684.306-.863,1-.935a11.188,11.188,0,0,1,1.881.008c.829.054,2.783-.036,3.011.955a9.228,9.228,0,0,1-.122,3.148c-.045.321.446.459.492.135.156-1.113.48-2.66.045-3.735-.407-1-2.3-.928-3.185-1s-2.846-.408-3.386.551c-.583,1.033-.533,2.723-.612,3.883-.022.327.487.326.509,0Z"
//               transform="translate(-1352.916 -1637.542)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101096"
//               data-name="Path 101096"
//               d="M1376.138,1657.754a4.944,4.944,0,0,1,.366-1.749c.328-.681,1.366-.483,1.992-.382.551.088,1.222.111,1.261.769a6.07,6.07,0,0,1-.147,1.494c-.062.32.429.458.492.136a4.555,4.555,0,0,0,.1-2.1c-.213-.661-1.165-.729-1.746-.812-.638-.091-1.673-.245-2.179.281a4.049,4.049,0,0,0-.65,2.368c-.024.327.486.326.509,0h0Z"
//               transform="translate(-1370.765 -1653.867)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101097"
//               data-name="Path 101097"
//               d="M1328.2,1749.719a3.837,3.837,0,0,0-1.07,2.454c-.02.327.49.326.509,0a3.281,3.281,0,0,1,.92-2.093c.226-.237-.133-.6-.36-.36h0Z"
//               transform="translate(-1325.443 -1742.303)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101098"
//               data-name="Path 101098"
//               d="M1330.589,1806.213l.071.049a.257.257,0,0,0,.349-.092.26.26,0,0,0-.092-.349l-.071-.049a.257.257,0,0,0-.349.092.26.26,0,0,0,.092.349Z"
//               transform="translate(-1328.557 -1794.726)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101099"
//               data-name="Path 101099"
//               d="M1384.319,1758.536a21.208,21.208,0,0,0-1,2.992.255.255,0,0,0,.492.136,21.178,21.178,0,0,1,1-2.992c.126-.3-.367-.434-.492-.135Z"
//               transform="translate(-1377.948 -1750.458)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101100"
//               data-name="Path 101100"
//               d="M1393.216,1771.761a3.121,3.121,0,0,1-1.323.791.258.258,0,0,0-.153.374,3.536,3.536,0,0,0,1.2,1.224c.28.173.536-.268.257-.44a3,3,0,0,1-1.021-1.041l-.152.375a3.663,3.663,0,0,0,1.548-.922.255.255,0,0,0-.36-.36h0Z"
//               transform="translate(-1385.791 -1762.906)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101101"
//               data-name="Path 101101"
//               d="M1418.9,1787.286a.571.571,0,0,0-.4-.424c-.23-.046-.494.206-.667.331-.345.251-.865.592-.976,1.031-.12.473.325.65.708.606a2.666,2.666,0,0,0,1.362-.6c.256-.2-.107-.564-.36-.36a2.121,2.121,0,0,1-.629.351,2.181,2.181,0,0,1-.34.09c-.1.017-.223.079-.2-.048.024-.151.373-.375.483-.465a5.375,5.375,0,0,1,.684-.471h-.257l.1.094c.1.313.588.179.492-.135h0Z"
//               transform="translate(-1409.285 -1777.081)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101102"
//               data-name="Path 101102"
//               d="M1378.852,1788.538a2.615,2.615,0,0,1-.988,2.573,3.3,3.3,0,0,1-3.153-.007c-.3-.132-.556.307-.257.44a3.845,3.845,0,0,0,3.667.007,3.08,3.08,0,0,0,1.24-3.013c-.01-.327-.52-.328-.509,0h0Z"
//               transform="translate(-1369.544 -1778.424)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101103"
//             data-name="Path 101103"
//             d="M1500.429,1033.75c-4.375,1.989-5.5,8.495,0,8.994s22.986-1.5,25.484-3,1.749-7.995-2-8.495S1503.177,1032.5,1500.429,1033.75Z"
//             transform="translate(-1366.018 -957.07)"
//             fill="#7a67d9"
//           />
//           <path
//             id="Path_101104"
//             data-name="Path 101104"
//             d="M1558.939,1100.721l.781,2.443a.257.257,0,0,0,.492,0,20.343,20.343,0,0,1,.88-2.125h-.44a8.164,8.164,0,0,0,1.317,1.75.258.258,0,0,0,.435-.18l.324-3.045c.035-.326-.475-.323-.509,0q-.162,1.523-.324,3.045l.435-.18a7.658,7.658,0,0,1-1.237-1.648.257.257,0,0,0-.44,0,21.594,21.594,0,0,0-.932,2.247h.492l-.782-2.442c-.1-.311-.592-.178-.492.135h0Z"
//             transform="translate(-1424.157 -1020.765)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101105"
//             data-name="Path 101105"
//             d="M1636.27,1094.258c-.8-.454-1.233.45-1.4,1.09-.154.592-.475,2,.313,2.3.723.275,1.291-.611,1.441-1.187a2.43,2.43,0,0,0-.562-2.243c-.219-.245-.579.117-.36.36a1.844,1.844,0,0,1,.1,2.4c-.607.6-.6-.427-.562-.788.024-.258.23-1.81.778-1.5a.255.255,0,0,0,.257-.44Z"
//             transform="translate(-1494.946 -1015.919)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101106"
//             data-name="Path 101106"
//             d="M1640.188,1096.366a.9.9,0,0,0-.287,1.587c.732.537,2.046-.182,2.679-.59.275-.177.02-.618-.257-.44a4.664,4.664,0,0,1-1.126.542,3.435,3.435,0,0,1-.55.133c-.378.052-1.045-.453-.325-.74.3-.12.17-.613-.135-.492h0Z"
//             transform="translate(-1499.489 -1017.986)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101107"
//             data-name="Path 101107"
//             d="M1688.791,1086.926l-.212,2.912c-.023.327.486.325.509,0l.212-2.912c.024-.327-.486-.325-.509,0Z"
//             transform="translate(-1545.322 -1008.953)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101108"
//             data-name="Path 101108"
//             d="M1691.959,1087.638a.474.474,0,0,1,.649.642c-.181.312-.634.377-.956.436s-.186.551.135.492c.644-.119,1.424-.416,1.39-1.205a.989.989,0,0,0-1.477-.8c-.291.151-.034.591.257.44h0Z"
//             transform="translate(-1548.024 -1009.322)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101109"
//             data-name="Path 101109"
//             d="M1692.911,1111.7a.958.958,0,0,1,1.033,1.037c-.031.327.479.324.509,0a1.468,1.468,0,0,0-1.678-1.528c-.323.048-.186.539.135.492h0Z"
//             transform="translate(-1549.071 -1031.862)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101110"
//             data-name="Path 101110"
//             d="M1735.9,1084.38a15.311,15.311,0,0,1,.075,2.581c-.018.328.492.327.509,0a15.311,15.311,0,0,0-.075-2.581c-.037-.322-.547-.326-.509,0Z"
//             transform="translate(-1589.546 -1006.576)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101111"
//             data-name="Path 101111"
//             d="M1739.245,1079.216a1.571,1.571,0,0,1-1.122,1.4c-.188.058-.275.373-.061.465a2.984,2.984,0,0,1,1.239.958c.194.259.638.005.44-.257a3.467,3.467,0,0,0-1.422-1.14l-.061.465a2.1,2.1,0,0,0,1.5-1.893c.024-.327-.486-.325-.509,0h0Z"
//             transform="translate(-1591.449 -1001.748)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101112"
//             data-name="Path 101112"
//             d="M1784.31,1072.459c-.829-.042-1.045,1.606-1.167,2.167-.139.64-.29,1.734.7,1.705.733-.022,1.172-.846,1.268-1.479a2.31,2.31,0,0,0-.814-2.132c-.251-.206-.614.152-.36.36a1.81,1.81,0,0,1,.477,2.273c-.161.277-.677.861-.883.018a2.454,2.454,0,0,1,.166-.853c.058-.238.348-1.563.619-1.549.328.016.327-.493,0-.509h0Z"
//             transform="translate(-1633.601 -995.661)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101113"
//             data-name="Path 101113"
//             d="M1788.587,1077.586c-.831-.393-1.154,1.243-.651,1.71.7.65,1.753-.5,2.09-1.051.172-.28-.269-.537-.44-.257a2.414,2.414,0,0,1-.833.837c-.187.111-.466.238-.56-.06-.052-.165.041-.717.255-.749l-.2-.026.077.037c.295.139.554-.3.257-.44h0Z"
//             transform="translate(-1637.952 -1000.397)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101114"
//             data-name="Path 101114"
//             d="M1833.512,1070.32c-.079.672-.3,2.95.885,2.863a1.027,1.027,0,0,0,.868-.818,15.366,15.366,0,0,0,.335-2.226c.045-.321-.446-.459-.492-.135q-.083.6-.168,1.2a3.525,3.525,0,0,1-.188,1.079q-.068.411-.636.16l-.031-.131a2.278,2.278,0,0,1-.1-.75,6.5,6.5,0,0,1,.039-1.237c.038-.325-.472-.322-.509,0h0Z"
//             transform="translate(-1680.703 -993.195)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101115"
//             data-name="Path 101115"
//             d="M1882.685,1067.974a10.085,10.085,0,0,1,1.677-.187c.327-.009.329-.519,0-.509a10.966,10.966,0,0,0-1.813.2c-.321.063-.185.555.135.492h0Z"
//             transform="translate(-1726.424 -990.82)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101116"
//             data-name="Path 101116"
//             d="M1892.591,1071.3a9.124,9.124,0,0,0-.288,2.829c.018.326.528.328.509,0a8.648,8.648,0,0,1,.27-2.694.255.255,0,0,0-.492-.135h0Z"
//             transform="translate(-1735.698 -994.407)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101117"
//             data-name="Path 101117"
//             d="M1896,1117.3a1.961,1.961,0,0,1-1.921,1.48.255.255,0,0,0,0,.509,2.474,2.474,0,0,0,2.412-1.854.255.255,0,0,0-.492-.135h0Z"
//             transform="translate(-1737.14 -1037.399)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101118"
//             data-name="Path 101118"
//             d="M1872.07,1147.945v.083a.255.255,0,0,0,.51,0v-.083a.255.255,0,0,0-.51,0Z"
//             transform="translate(-1716.802 -1065.976)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101119"
//             data-name="Path 101119"
//             d="M1528.677,1280.005a2.939,2.939,0,0,0,1.079-2.04l-.5.068c.334.837,1.17,1.777,2.067.988l-.36-.36a5.761,5.761,0,0,0-1.506,2.929l.5.067a3.038,3.038,0,0,0-.9-2.255c-.2-.258-.561.105-.36.36a2.516,2.516,0,0,1,.754,1.895c-.037.283.447.349.5.067a5.281,5.281,0,0,1,1.374-2.7.255.255,0,0,0-.36-.36c-.638.561-1.076-.415-1.216-.763a.256.256,0,0,0-.5.068,2.42,2.42,0,0,1-.93,1.679c-.254.208.109.567.36.36h0Z"
//             transform="translate(-1395.471 -1187.484)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101120"
//             data-name="Path 101120"
//             d="M1408.852,1312.087a3.334,3.334,0,0,0,1.164-1.952c.031-.249-.372-.351-.475-.128-.379.819.68,2.385,1.438,1.386.177-.234-.2-.509-.4-.309a5.392,5.392,0,0,0-1.333,2.212l.492.135a1.849,1.849,0,0,0-.661-1.792c-.252-.206-.615.153-.36.36a1.352,1.352,0,0,1,.53,1.3.255.255,0,0,0,.492.135,4.829,4.829,0,0,1,1.2-1.987l-.4-.309c-.236.311-.66-.65-.558-.872l-.475-.128a2.858,2.858,0,0,1-1.015,1.592.255.255,0,0,0,.36.36h0Z"
//             transform="translate(-1283.501 -1217.544)"
//             fill="#414042"
//           />
//           <g
//             id="Group_106491"
//             data-name="Group 106491"
//             transform="translate(103.46 88.048)"
//           >
//             <g
//               id="Group_106490"
//               data-name="Group 106490"
//               transform="translate(5.45 5.933)"
//             >
//               <path
//                 id="Path_101121"
//                 data-name="Path 101121"
//                 d="M1229.347,1452.75c-.48.39-1.228.8-1.341,1.473a3.053,3.053,0,0,0,.573,1.8,12.718,12.718,0,0,0,1.329,1.777c.4.486.723,1.313,1.293,1.643a1.752,1.752,0,0,0,1.554-.032,17.306,17.306,0,0,0,3.689-2.4,7.458,7.458,0,0,0,2.413-2.294c.395-.839-.291-1.4-.742-2.074-.611-.912-1.523-3.1-2.823-3.295-.643-.1-1.376.736-1.775,1.139-.231.233.129.594.36.36.465-.469,1-1.136,1.709-.745,1.034.574,1.768,2.351,2.435,3.307.518.743.564.995-.078,1.678a17.634,17.634,0,0,1-2.586,2.094c-.811.585-2.484,2.159-3.633,1.918-.618-.13-1.267-1.419-1.692-1.93a8.987,8.987,0,0,1-1.185-1.713,1.684,1.684,0,0,1-.026-1.612,4.662,4.662,0,0,1,.884-.734c.255-.207-.108-.566-.36-.36h0Z"
//                 transform="translate(-1223.795 -1441.853)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101122"
//                 data-name="Path 101122"
//                 d="M1190.236,1427.238c-.506.325-1.7-1.555-1.864-1.828a1.632,1.632,0,0,1,.136-2.306,9.644,9.644,0,0,1,2.475-1.794c.289-.156.032-.6-.257-.44-1.143.616-3.123,1.719-3.332,3.145-.145.988,1.847,4.466,3.1,3.661.275-.177.02-.618-.257-.44h0Z"
//                 transform="translate(-1185.849 -1415.217)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101123"
//                 data-name="Path 101123"
//                 d="M1259.6,1395.9a1.794,1.794,0,0,1,.969-.67c.64-.135,1.109.344,1.5.772.565.617,1.624,1.925,1.267,2.834-.12.3.372.438.492.135.47-1.2-.855-2.833-1.65-3.589a1.859,1.859,0,0,0-2.939.157c-.2.255.158.619.36.36h0Z"
//                 transform="translate(-1252.947 -1390.825)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101124"
//                 data-name="Path 101124"
//                 d="M1175.5,1366.95a3.383,3.383,0,0,1,1.115-5.457,2.876,2.876,0,0,1,4.091,1.629c.126.3.619.167.492-.135-.84-1.995-2.842-3.021-4.84-1.934a3.891,3.891,0,0,0-1.218,6.258c.22.244.579-.117.36-.36h0Z"
//                 transform="translate(-1173.38 -1358.934)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101125"
//                 data-name="Path 101125"
//                 d="M1165.306,1338.91a4.325,4.325,0,0,1-.7-.974c-.426-.839.2-1.335.858-1.8.547-.384,1.335-.948,1.928-.4a3.5,3.5,0,0,1,.725,1.183c.125.3.618.167.492-.135a3.623,3.623,0,0,0-1.118-1.635c-.722-.482-1.68.129-2.283.55s-1.415,1.005-1.284,1.833a3.625,3.625,0,0,0,1.027,1.741c.224.24.584-.12.36-.36h0Z"
//                 transform="translate(-1163.906 -1334.97)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101126"
//                 data-name="Path 101126"
//                 d="M1251.128,1443.375c-.057.777-.065,2.24.816,2.584a1.429,1.429,0,0,0,1.587-.686c.28-.566-.221-1.073-.643-1.384a6.262,6.262,0,0,0-1.438-.761c-.306-.118-.438.374-.135.492a6.016,6.016,0,0,1,1.165.6c.208.14.524.346.6.6.094.312-.287.524-.533.622-.993.4-.954-1.5-.911-2.072C1251.661,1443.048,1251.151,1443.05,1251.128,1443.375Z"
//                 transform="translate(-1245.398 -1436.032)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101127"
//                 data-name="Path 101127"
//                 d="M1251.038,1510.224q1.453-1.125,2.98-2.148c.271-.182.016-.623-.257-.44q-1.58,1.06-3.083,2.227c-.259.2.1.558.36.36h0Z"
//                 transform="translate(-1244.913 -1496.292)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101128"
//                 data-name="Path 101128"
//                 d="M1325.636,1477.818a9.028,9.028,0,0,1,1.357-.912c.287-.158.031-.6-.257-.44a9.767,9.767,0,0,0-1.46.992c-.254.208.108.566.36.36h0Z"
//                 transform="translate(-1314.631 -1467.172)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101129"
//                 data-name="Path 101129"
//                 d="M1267.269,1514.535l5.429-3.776c.267-.186.013-.628-.257-.44l-5.429,3.776c-.267.186-.013.628.257.44Z"
//                 transform="translate(-1260.157 -1498.798)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101130"
//                 data-name="Path 101130"
//                 d="M1173.773,1348.606a8.255,8.255,0,0,1,2.911-1.9c.3-.117.172-.609-.135-.492a8.868,8.868,0,0,0-3.136,2.033.255.255,0,0,0,.36.36h0Z"
//                 transform="translate(-1172.721 -1345.459)"
//                 fill="#414042"
//               />
//               <path
//                 id="Path_101131"
//                 data-name="Path 101131"
//                 d="M1195.132,1399.33a1.342,1.342,0,0,0-.076,1.485.255.255,0,0,0,.44-.257.847.847,0,0,1,.077-.971c.2-.26-.244-.514-.44-.257h0Z"
//                 transform="translate(-1192.841 -1395.017)"
//                 fill="#414042"
//               />
//             </g>
//             <path
//               id="Path_101132"
//               data-name="Path 101132"
//               d="M1171.976,1247.994c.6-.664,2.649-3.295.733-3.642-1.558-.283-1.281,2.595-1.168,3.462.042.321.552.325.509,0-.078-.6-.379-2.778.427-2.968.982-.231.212,1.318.047,1.584a8.444,8.444,0,0,1-.909,1.2C1171.4,1247.877,1171.756,1248.239,1171.976,1247.994Z"
//               transform="translate(-1165.504 -1244.333)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101133"
//               data-name="Path 101133"
//               d="M1084.185,1256.663c-.592-.755-2.4-2.753-3.36-1.454a1.051,1.051,0,0,0,.3,1.429,3.756,3.756,0,0,0,2.946.451c.323-.05.186-.541-.135-.492a3.4,3.4,0,0,1-2.4-.286c-.294-.206-.575-.649-.183-.912.765-.516,2.061,1.1,2.471,1.625.2.258.56-.1.36-.36Z"
//               transform="translate(-1080.652 -1254.097)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101134"
//             data-name="Path 101134"
//             d="M955.15,1519.335c-2.658,1.773-1.773,4.652,4.874,5.1s7.976-2.658,6.2-4.652S957.808,1517.563,955.15,1519.335Z"
//             transform="translate(-858.601 -1412.162)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101135"
//             data-name="Path 101135"
//             d="M1006.77,1543.082c-1.09-.44-1.576.969-1.552,1.788a.619.619,0,0,0,.7.635c.484-.038.7-.5.844-.9.112-.309-.38-.442-.492-.136-.057.158-.168.528-.387.521-.234-.007-.139-.414-.12-.567.055-.437.322-1.076.876-.853.3.122.436-.37.135-.492Z"
//             transform="translate(-906.695 -1435.4)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101136"
//             data-name="Path 101136"
//             d="M1017.035,1557.261a2.366,2.366,0,0,0,.722.255.262.262,0,0,0,.314-.178.257.257,0,0,0-.178-.314,1.934,1.934,0,0,1-.6-.2c-.289-.156-.546.284-.257.44h0Z"
//             transform="translate(-917.621 -1448.286)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101137"
//             data-name="Path 101137"
//             d="M1047.176,1546.106a2.584,2.584,0,0,0,.8,1.156c.252.205.615-.152.36-.36a2.1,2.1,0,0,1-.668-.931c-.109-.307-.6-.175-.492.135h0Z"
//             transform="translate(-945.892 -1438.015)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101138"
//             data-name="Path 101138"
//             d="M1048.782,1547.892a23.8,23.8,0,0,1-1.437,2.013c-.2.254.156.617.36.36a25,25,0,0,0,1.517-2.116c.177-.277-.264-.533-.44-.257h0Z"
//             transform="translate(-946.009 -1439.861)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101139"
//             data-name="Path 101139"
//             d="M1077,1555.916l.822-1.587-.466-.061a11.472,11.472,0,0,1,.286,1.377c.046.323.538.186.492-.135a11.623,11.623,0,0,0-.285-1.377.258.258,0,0,0-.465-.061l-.822,1.587c-.151.291.289.548.44.257h0Z"
//             transform="translate(-973.337 -1445.633)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101140"
//             data-name="Path 101140"
//             d="M1094.218,1557.273a9.549,9.549,0,0,1,1.171-1.125l-.435-.18q-.055.79-.111,1.582c-.023.327.487.326.509,0q.055-.79.111-1.582c.017-.243-.28-.306-.435-.18a9.664,9.664,0,0,0-1.171,1.125c-.216.245.143.608.36.36Z"
//             transform="translate(-989.471 -1447.292)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101141"
//             data-name="Path 101141"
//             d="M976.889,1544.42a1.148,1.148,0,0,0-.448,1.249.255.255,0,0,0,.492-.136.623.623,0,0,1,.214-.674c.262-.192.008-.634-.257-.44h0Z"
//             transform="translate(-879.762 -1436.683)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101142"
//             data-name="Path 101142"
//             d="M980.149,1574.229v-.074a.255.255,0,0,0-.509,0v.074a.255.255,0,0,0,.509,0Z"
//             transform="translate(-882.792 -1464.286)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101143"
//             data-name="Path 101143"
//             d="M1870.885,299.116a3.832,3.832,0,0,0,1.8-2.638l-.5-.067a1.749,1.749,0,0,0,1.756,1.836c-.022-.167-.045-.334-.067-.5-.51.124-.721.507-.98.935a21.392,21.392,0,0,0-1.237,2.419l.475.128c.07-1.059.017-2.22-1.059-2.736-.294-.141-.553.3-.257.44.89.427.863,1.443.807,2.3-.016.243.372.36.474.128.23-.518.471-1.03.737-1.531.243-.456.623-1.455,1.176-1.589a.256.256,0,0,0-.067-.5,1.231,1.231,0,0,1-1.246-1.326c.008-.281-.448-.355-.5-.067a3.346,3.346,0,0,1-1.567,2.334c-.277.174-.021.615.257.44h0Z"
//             transform="translate(-1715.342 -270.181)"
//             fill="#414042"
//           />
//           <g
//             id="Group_106492"
//             data-name="Group 106492"
//             transform="translate(128.433 7.054)"
//           >
//             <path
//               id="Path_101144"
//               data-name="Path 101144"
//               d="M1577.225,11.686c-.027.312-.068.625-.125.933a5.113,5.113,0,0,1-.159.692c-.108.323-.115.7-.414.329-.381-.477-.168-1.807-.122-2.4.026-.328-.48-.323-.509,0-.047.512-.464,2.9-1.333,1.93-.468-.521-.255-1.887-.161-2.527l-.5-.067a7.938,7.938,0,0,1-.187,1.157,2.435,2.435,0,0,1-.316.918c-.368.418-.434.209-.63-.167a5.788,5.788,0,0,1-.13-2.572h-.509a7.883,7.883,0,0,1,.005,1.034,3.506,3.506,0,0,1-.135.937c-.263.742-.843.781-1.155,0-.8-2,.9-3.912,2.774-4.232a7.084,7.084,0,0,1,5.061.926c1.632,1.234.924,4.254.995,6.021a20.093,20.093,0,0,1-.819,6.741c-.475,1.593-1.195,3.145-1.555,4.769a4.066,4.066,0,0,1-.3,1.37c-.349.5-1.26.45-1.79.5-1.706.149-3.417.321-5.129.381-2.015.07-4.19.041-5.95-1.058-1.208-.753-2.4-1.534-3.588-2.323a.256.256,0,0,0-.384.22,13.778,13.778,0,0,1-.581,4.72,7.933,7.933,0,0,0-.3,3.1c.058.322.549.186.492-.136a10.51,10.51,0,0,1,.59-4,11.219,11.219,0,0,0,.306-3.684l-.384.22a28.782,28.782,0,0,0,4.505,2.814c2.071.868,4.539.712,6.728.558,1.072-.075,2.142-.178,3.214-.264a5.785,5.785,0,0,0,2.264-.367,1.3,1.3,0,0,0,.611-.887c.213-.8.321-1.589.588-2.379.879-2.594,1.9-5.219,2.027-7.988.061-1.372-.106-2.742-.058-4.115a8.124,8.124,0,0,0-.334-3.528c-.691-1.593-2.761-2.052-4.33-2.181-1.659-.137-3.685.123-4.646,1.656-.549.875-1.349,4.359.637,4.308,1.293-.033,1.2-2.289,1.141-3.135a.255.255,0,0,0-.509,0c-.051.808-.309,3.183.716,3.54,1.234.429,1.5-2.177,1.566-2.874.026-.283-.458-.352-.5-.067-.132.9-.417,3.136.843,3.415s1.576-1.851,1.652-2.683h-.509c-.052.668-.321,2.99.7,3.135.988.141,1.087-2.08,1.141-2.692.029-.327-.481-.325-.509,0h0Z"
//               transform="translate(-1552.87 -7.054)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101145"
//               data-name="Path 101145"
//               d="M1462.446,97.428a4.325,4.325,0,0,1,4.626,1.042.26.26,0,0,0,.309.04,4.353,4.353,0,0,1,2.1-.655c2.145-.09,3.319,1.807,3.951,3.6a.26.26,0,0,0,.375.153c2.9-1.4,6.052.215,7.627,2.789.171.28.612.024.44-.257-1.735-2.836-5.154-4.5-8.324-2.971l.375.153c-.924-2.629-2.94-4.747-5.879-3.688-.226.081-.592.363-.821.374-.146.007-.046-.092-.285-.371a3.053,3.053,0,0,0-1.095-.652,5.036,5.036,0,0,0-3.534-.051c-.305.113-.173.606.135.492h0Z"
//               transform="translate(-1462.139 -90.778)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101146"
//               data-name="Path 101146"
//               d="M1746.954,92.829c.18,2.269-.844,4.222-1.911,6.148-.159.287.281.545.44.257,1.106-2,2.167-4.055,1.98-6.405-.026-.325-.535-.327-.509,0Z"
//               transform="translate(-1726.491 -86.986)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101147"
//               data-name="Path 101147"
//               d="M1495.882,99.008c-1.055,5.287-1.455,12.283,4.625,14.531.308.114.441-.378.135-.492-5.774-2.134-5.26-8.941-4.269-13.9.064-.32-.427-.458-.492-.135Z"
//               transform="translate(-1493.093 -92.817)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101148"
//               data-name="Path 101148"
//               d="M1465.688,99.191a24.169,24.169,0,0,0-.065,6.86c.058.322.549.186.492-.135a23.823,23.823,0,0,1,.083-6.725c.036-.325-.474-.323-.509,0Z"
//               transform="translate(-1465.187 -92.932)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101149"
//               data-name="Path 101149"
//               d="M1497.875,296.66a8.779,8.779,0,0,0,4.524,3.165c.32.064.457-.427.135-.492a8.335,8.335,0,0,1-4.3-3.033c-.213-.249-.572.112-.36.36Z"
//               transform="translate(-1495.476 -277.287)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101150"
//             data-name="Path 101150"
//             d="M1381.162,358.859a3.454,3.454,0,0,0,1.543-1.64l-.465-.2c-.191.94.445,2.052,1.53,1.627l-.2-.465a4.644,4.644,0,0,0-1.664,2.39l.5.067c0-.839-.13-2.294-1.2-2.391-.327-.029-.325.48,0,.509.664.06.691,1.452.689,1.882a.256.256,0,0,0,.5.067,4.05,4.05,0,0,1,1.43-2.085c.2-.157.1-.582-.2-.465-.695.272-1.019-.427-.9-1,.054-.264-.338-.475-.466-.2a3.028,3.028,0,0,1-1.36,1.457c-.289.156-.031.6.257.44h0Z"
//             transform="translate(-1257.672 -326.88)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101151"
//             data-name="Path 101151"
//             d="M1548.107,707.622l-.255,1.411c-.058.321.433.458.492.135l.255-1.411c.058-.321-.433-.458-.492-.136Z"
//             transform="translate(-1413.803 -654.536)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101152"
//             data-name="Path 101152"
//             d="M1398.623,676.43a2.975,2.975,0,0,0,1.479-2.05h-.492c.16,1.013,1.115,2.111,2.177,1.35l-.309-.4a5.056,5.056,0,0,0-1.825,2.867l.492.135a2,2,0,0,0-1.293-2.3c-.307-.117-.44.376-.136.492a1.474,1.474,0,0,1,.938,1.673c-.06.318.415.458.492.136a4.624,4.624,0,0,1,1.694-2.641c.225-.177-.073-.569-.309-.4-.765.549-1.322-.369-1.429-1.045a.257.257,0,0,0-.492,0,2.487,2.487,0,0,1-1.246,1.745.255.255,0,0,0,.257.44h0Z"
//             transform="translate(-1273.991 -623.346)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101153"
//             data-name="Path 101153"
//             d="M1409.483,917.683c-.35,1.051-.664,7.976,0,8.2s3.323.221,3.766-.664.443-7.533-.221-7.976S1409.7,917.018,1409.483,917.683Z"
//             transform="translate(-1284.133 -850.388)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101154"
//             data-name="Path 101154"
//             d="M1293.33,819.7c-.793.4-5.539,5.76-5.318,6.425s1.551,2.215,2.658,1.773,5.539-5.539,5.317-6.2-1.773-2.437-2.658-1.994Z"
//             transform="translate(-1170.971 -759.381)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101155"
//             data-name="Path 101155"
//             d="M1069.167,930.289c-2.082,3.492-1.764,7.816-3.743,11.331a10.653,10.653,0,0,1-5.647,4.421,4.415,4.415,0,0,1-6.076-3.964,3.135,3.135,0,0,1,1.844-3.34c1.648-.56,2.927.537,3.811,1.821a18.636,18.636,0,0,1,1.385,2.784,11.478,11.478,0,0,0,1.8,2.73c2.813,3.21,7.1,5.435,11.376,3.78,4.713-1.824,5.545-7.338,5.227-11.764-.023-.325-.533-.328-.509,0,.2,2.845.083,5.844-1.456,8.34a7.312,7.312,0,0,1-7,3.421,10.965,10.965,0,0,1-7.28-4.137c-1.739-1.981-2.185-4.745-4.074-6.592a3.264,3.264,0,0,0-4.439-.3c-1.447,1.2-1.449,3.515-.771,5.123a4.8,4.8,0,0,0,4.76,2.958,11.047,11.047,0,0,0,5.705-2.816c3.932-3.443,3.007-9.312,5.526-13.537a.255.255,0,0,0-.44-.257h0Z"
//             transform="translate(-951.517 -862.685)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101156"
//             data-name="Path 101156"
//             d="M1127.658,457.672c-1.838,3.472,1.459,5.837,8.512,7.539s13.376-.244,8.268-5.35S1129.846,453.538,1127.658,457.672Z"
//             transform="translate(-1020.652 -418.796)"
//             fill="#7a67d9"
//           />
//           <path
//             id="Path_101157"
//             data-name="Path 101157"
//             d="M1189.115,486.115l-.924,1.456a5.108,5.108,0,0,0-.757,1.226c-.184.755,1.044.444,1.381.361a2.305,2.305,0,0,0,1.726-1.373,1.393,1.393,0,0,0-.752-1.742c-.3-.137-.554.3-.257.44a.951.951,0,0,1,.3,1.544,2.456,2.456,0,0,1-1.571.719c-.012,0-.418.1-.327.108,0,.1.018.09.065-.025l.115-.182.461-.728.981-1.547c.176-.278-.265-.534-.44-.257h0Z"
//             transform="translate(-1076.966 -447.59)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101158"
//             data-name="Path 101158"
//             d="M1243.091,510.42l2.467-2.307-.435-.18q-.031,1.408-.061,2.816a.255.255,0,0,0,.509,0q.031-1.408.061-2.816a.257.257,0,0,0-.435-.18l-2.467,2.307c-.24.225.121.585.36.36Z"
//             transform="translate(-1128.586 -467.857)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101159"
//             data-name="Path 101159"
//             d="M1255.694,531.074l1.854.449c.319.077.454-.414.135-.492l-1.854-.449c-.319-.077-.454.414-.135.492Z"
//             transform="translate(-1140.605 -489.25)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101160"
//             data-name="Path 101160"
//             d="M1317.065,525.206a4.764,4.764,0,0,0,1.58,2.015c.264.2.518-.247.257-.44a4.132,4.132,0,0,1-1.347-1.711c-.126-.3-.619-.167-.492.135h0Z"
//             transform="translate(-1198.108 -483.949)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101161"
//             data-name="Path 101161"
//             d="M1317.247,534.424a3.831,3.831,0,0,1-.566,1.342c-.134.2-.878,1.206-1.187.837-.211-.252-.57.11-.36.36.438.525,1.126.039,1.485-.325a4.258,4.258,0,0,0,1.119-2.079c.071-.319-.42-.456-.492-.135h0Z"
//             transform="translate(-1196.265 -492.676)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101162"
//             data-name="Path 101162"
//             d="M781.855,105.669q1.367,3.757,2.867,7.466c.7,1.727,1.411,3.452,2.211,5.134.388.814.863,2.233,1.665,2.76.979.643,3.177-.335,4.129-.649a20.1,20.1,0,0,0,2.767-1.106c.4-.2,1.043-.477,1.214-.939.267-.716-.211-1.974-.363-2.669-.384-1.754-.834-3.494-1.29-5.231q-1.2-4.552-2.5-9.075a.26.26,0,0,0-.314-.178,38.367,38.367,0,0,0-10.267,4.2.255.255,0,0,0,.257.44,37.907,37.907,0,0,1,10.145-4.148l-.314-.178q.945,3.284,1.836,6.582a82.927,82.927,0,0,1,2.266,9.306,1.786,1.786,0,0,1,.059.8c-.247.549-1.638.958-2.12,1.152a25.39,25.39,0,0,1-2.808.943c-.551.15-1.766.635-2.328.384-.7-.314-1.213-1.862-1.515-2.49-.782-1.626-1.476-3.3-2.154-4.967q-1.545-3.81-2.951-7.675c-.111-.306-.6-.173-.492.136Z"
//             transform="translate(-697.939 -87.959)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101163"
//             data-name="Path 101163"
//             d="M771.617,66.587a6.729,6.729,0,0,1-.691-2.753c.165-1.039,2.578-1.675,3.367-2a25.159,25.159,0,0,1,4.808-1.748c.89-.169,1.46-.071,1.825.837a6.394,6.394,0,0,1,.383,1.525c.042.32.553.325.509,0-.13-.968-.379-2.55-1.46-2.9a3.9,3.9,0,0,0-2.09.217,35.392,35.392,0,0,0-3.747,1.422c-.926.384-1.87.746-2.763,1.206a2.61,2.61,0,0,0-1.25.979c-.424.923.3,2.467.617,3.348.11.306.6.174.492-.135Z"
//             transform="translate(-687.23 -48.986)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101164"
//             data-name="Path 101164"
//             d="M849.7,25.745a5.96,5.96,0,0,0,1.336-3.42l-.187.245a3.869,3.869,0,0,1,.953-.285l.238-.071a3.924,3.924,0,0,0,.136.462c.182.6.349,1.211.486,1.828.071.32.563.185.492-.136-.118-.528-.251-1.052-.407-1.57-.082-.274-.144-.779-.372-.984-.393-.353-1.249.14-1.662.263a.264.264,0,0,0-.187.245,5.367,5.367,0,0,1-1.187,3.06c-.2.253.154.616.36.36h0Z"
//             transform="translate(-760.961 -13.677)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101165"
//             data-name="Path 101165"
//             d="M868.685,34.866a3,3,0,0,1,1.257-.513c.323-.054.186-.545-.135-.492a3.365,3.365,0,0,0-1.379.564c-.266.187-.012.628.257.44Z"
//             transform="translate(-778.755 -25.049)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101166"
//             data-name="Path 101166"
//             d="M796.585,18.631c-.74-1.066-3.037.218-3.786.765A6.058,6.058,0,0,0,790.382,24c-.02.327.49.327.509,0a5.58,5.58,0,0,1,1.591-3.67,5.459,5.459,0,0,1,1.483-1.048c.367-.176,1.874-.839,2.179-.4.186.268.628.013.44-.257Z"
//             transform="translate(-705.923 -10.436)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101167"
//             data-name="Path 101167"
//             d="M779.131,120.083a20.15,20.15,0,0,1,3.95-2.151c.3-.122.169-.615-.135-.492a20.715,20.715,0,0,0-4.072,2.2c-.267.186-.012.628.257.44h0Z"
//             transform="translate(-695.063 -103.143)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101168"
//             data-name="Path 101168"
//             d="M862.4,88.343a18.754,18.754,0,0,1,4.465-1.458c.321-.063.185-.554-.135-.492a19.314,19.314,0,0,0-4.587,1.51c-.3.14-.038.579.257.44Z"
//             transform="translate(-772.868 -74.14)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101169"
//             data-name="Path 101169"
//             d="M556.925,235.918a14.772,14.772,0,0,0-4.224.278c-1.333.337-1.531,1.094-1.7,2.352a41.908,41.908,0,0,0-.32,5.636c0,.616-.258,2.476.418,2.869a2.682,2.682,0,0,0,1.051.086c.742.021,1.485.017,2.226.012q2.837-.018,5.672-.126c.67-.026,2.332.194,2.886-.311.278-.253.31-.853.364-1.19.127-.8.185-1.614.232-2.422a26.4,26.4,0,0,0-.038-5.611c-.232-1.443-2.031-1.565-3.242-1.572a.255.255,0,0,0,0,.509,6.739,6.739,0,0,1,1.652.193,1.237,1.237,0,0,1,1.133,1.336,32.971,32.971,0,0,1,.026,4.346c-.03.727-.073,1.454-.144,2.178a4.38,4.38,0,0,1-.283,1.722c-.291.429-1.814.281-2.387.305-2.808.115-5.661.25-8.47.108a1.392,1.392,0,0,1-.443-.031c-.153-.079.08.149-.02-.077a4.839,4.839,0,0,1-.115-1.619c-.033-1.57.025-3.147.147-4.713.1-1.284-.067-3.049,1.4-3.466a13.444,13.444,0,0,1,4.186-.283c.328.015.327-.495,0-.509h0Z"
//             transform="translate(-481.867 -213.853)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101170"
//             data-name="Path 101170"
//             d="M587.447,185.359c-.042-.846-.2-2.619.623-3.083.9-.5,2.583-.292,3.572-.278.664.009,2.571-.21,2.978.408.439.666.179,2.176.119,2.953-.026.327.484.325.509,0,.069-.892.351-2.685-.3-3.423-.6-.682-2.51-.436-3.305-.448-1.069-.015-3.049-.26-3.989.424-.893.649-.763,2.484-.716,3.447.016.327.526.329.509,0h0Z"
//             transform="translate(-515.762 -162.964)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101171"
//             data-name="Path 101171"
//             d="M589.71,208.011a31.439,31.439,0,0,1,5.539-.075c.327.024.325-.485,0-.509a31.44,31.44,0,0,0-5.539.075c-.323.033-.327.543,0,.509Z"
//             transform="translate(-518.16 -187.174)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101172"
//             data-name="Path 101172"
//             d="M691.219,210.789a2.41,2.41,0,0,1,.828.162c.307.116.44-.376.136-.492a2.835,2.835,0,0,0-.964-.18.255.255,0,0,0,0,.509Z"
//             transform="translate(-613.021 -189.922)"
//             fill="#414042"
//           />
//           <g
//             id="Group_106493"
//             data-name="Group 106493"
//             transform="translate(72.366 23.949)"
//           >
//             <path
//               id="Path_101173"
//               data-name="Path 101173"
//               d="M615.089,270.775h-1.772V269.04h-1.994v1.735H609.55v1.735l1.773-.079v1.815h1.994v-1.9l1.772-.08Z"
//               transform="translate(-609.295 -268.785)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101174"
//               data-name="Path 101174"
//               d="M611.444,266.885h-1.773l.255.255V265.4a.258.258,0,0,0-.255-.255h-1.994a.258.258,0,0,0-.255.255v1.735l.255-.255H605.9a.258.258,0,0,0-.255.255v1.735a.257.257,0,0,0,.255.255l1.773-.079-.255-.255v1.815a.258.258,0,0,0,.255.255h1.994a.258.258,0,0,0,.255-.255v-1.9l-.255.255,1.773-.079a.259.259,0,0,0,.255-.255V267.14a.255.255,0,0,0-.509,0v1.487l.255-.255-1.773.079a.259.259,0,0,0-.255.255v1.9l.255-.255h-1.994l.255.255V268.8a.257.257,0,0,0-.255-.255l-1.773.079.255.255V267.14l-.255.255h1.773a.258.258,0,0,0,.255-.255V265.4l-.255.255h1.994l-.255-.255v1.735a.258.258,0,0,0,.255.255h1.773A.255.255,0,0,0,611.444,266.885Z"
//               transform="translate(-605.65 -265.15)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101175"
//             data-name="Path 101175"
//             d="M672.182,44.9c-1.64.877-.705,3.354-.222,4.656.466,1.256,1.712,2.631,3.149,1.71,1.405-.9.653-2.642.217-3.882-.506-1.44-1.27-3.181-3.083-2.51-.305.113-.173.606.135.492,1.5-.555,2.052,1.008,2.455,2.155.305.865,1.03,2.325.238,3.115-1.287,1.284-2.408-.569-2.776-1.652-.342-1.007-1.093-2.982.142-3.643C672.729,45.188,672.472,44.747,672.182,44.9Z"
//             transform="translate(-594.594 -35.208)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101176"
//             data-name="Path 101176"
//             d="M674.541,52.5a5.838,5.838,0,0,1,3.139-1.274s-.554-3.212-2.769-2.769c-1.994.443-.369,4.044-.369,4.044Z"
//             transform="translate(-597.083 -38.657)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101177"
//             data-name="Path 101177"
//             d="M696.636,114.921a1.2,1.2,0,0,0,.757.81.255.255,0,1,0,.135-.492.667.667,0,0,1-.4-.454.255.255,0,0,0-.492.136h0Z"
//             transform="translate(-618.304 -100.511)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101178"
//             data-name="Path 101178"
//             d="M545.73,29.606c-1.508-.948-3.338.583-4.332,1.632-1.031,1.089-1.947,2.722-.4,3.845,1.433,1.037,3.21-.842,4.153-1.768s1.845-2.607.626-3.668c-.246-.215-.608.144-.36.36.992.865.094,2.23-.627,2.948-.75.746-2.294,2.408-3.409,1.735-1.608-.971-.136-2.625.755-3.473.781-.743,2.211-1.874,3.332-1.168.278.175.534-.266.257-.44Z"
//             transform="translate(-472.094 -20.799)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101179"
//             data-name="Path 101179"
//             d="M545.16,53.26s-1.94,1.733-1.725,2.834a1.663,1.663,0,0,0,2.56,1.07,4.657,4.657,0,0,0,1.642-1.3A6.018,6.018,0,0,1,545.16,53.26Z"
//             transform="translate(-475.126 -43.182)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101180"
//             data-name="Path 101180"
//             d="M588.021,41.357a1.324,1.324,0,0,1,.738-.344.262.262,0,0,0,.255-.255.256.256,0,0,0-.255-.255,1.909,1.909,0,0,0-1.1.494c-.243.222.118.581.36.36Z"
//             transform="translate(-516.397 -31.259)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101181"
//             data-name="Path 101181"
//             d="M858.15,247.122l1.806,4.059c.133.3.572.04.44-.257l-1.806-4.059c-.133-.3-.572-.04-.44.257Z"
//             transform="translate(-769.232 -223.989)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101182"
//             data-name="Path 101182"
//             d="M896.965,229.972q.664,2.189,1.493,4.32c.118.3.611.171.492-.135q-.829-2.132-1.493-4.32c-.095-.313-.587-.179-.492.135Z"
//             transform="translate(-805.518 -208.033)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101183"
//             data-name="Path 101183"
//             d="M935.267,221.437q.461,1.936,1.048,3.838c.1.312.588.179.492-.136q-.587-1.9-1.048-3.838c-.076-.319-.568-.184-.492.136Z"
//             transform="translate(-841.316 -200.053)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101184"
//             data-name="Path 101184"
//             d="M61.941,27.512a3.593,3.593,0,0,0,.492,6.883c3.2.738,16.962-.738,19.174-1.475s3.687-6.883,1.229-7.375S64.154,26.529,61.941,27.512Z"
//             transform="translate(-22.97 -17.191)"
//             fill="#7a67d9"
//           />
//           <path
//             id="Path_101185"
//             data-name="Path 101185"
//             d="M94.387,83.508a12.187,12.187,0,0,0,.149,2.093c.05.323.541.186.492-.136a11.4,11.4,0,0,1-.131-1.958.255.255,0,0,0-.509,0h0Z"
//             transform="translate(-55.488 -71.22)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101186"
//             data-name="Path 101186"
//             d="M93,79.653a11.949,11.949,0,0,1,1.217-.215c.321-.039.325-.549,0-.509a13.323,13.323,0,0,0-1.352.232c-.319.073-.185.564.135.492Z"
//             transform="translate(-53.896 -67.168)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101187"
//             data-name="Path 101187"
//             d="M93.888,93.335a3.966,3.966,0,0,0,1.486-.244c.305-.113.173-.6-.136-.492a3.586,3.586,0,0,1-1.35.225.255.255,0,0,0,0,.509h0Z"
//             transform="translate(-54.794 -79.931)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101188"
//             data-name="Path 101188"
//             d="M135.739,78.832l-.082,2.027c-.013.328.5.327.509,0l.082-2.027c.013-.328-.5-.327-.509,0Z"
//             transform="translate(-94.057 -66.85)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101189"
//             data-name="Path 101189"
//             d="M159.508,75q.515-.064,1.032-.117.239-.025.477-.046l.239-.021q.331.049.058-.283l.22-.126H161.5c-.327.01-.329.52,0,.509a.307.307,0,0,0,.09-.6,2.3,2.3,0,0,0-.888.042q-.6.059-1.191.133c-.321.04-.325.55,0,.509Z"
//             transform="translate(-116.12 -62.824)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101190"
//             data-name="Path 101190"
//             d="M173.55,77.875q0,.984-.01,1.967a.255.255,0,0,0,.509,0q0-.984.01-1.967a.255.255,0,0,0-.509,0Z"
//             transform="translate(-129.461 -65.955)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101191"
//             data-name="Path 101191"
//             d="M213.311,75q.188-1.215.376-2.43l-.465.061a16.816,16.816,0,0,0,1.6,2.256c.151.181.426.022.435-.18a9.052,9.052,0,0,1,.446-2.422c.1-.312-.389-.446-.492-.136a9.556,9.556,0,0,0-.465,2.558l.435-.18a16.053,16.053,0,0,1-1.516-2.153c-.1-.173-.431-.165-.465.061q-.188,1.215-.376,2.43c-.05.321.441.459.492.136h0Z"
//             transform="translate(-166.166 -60.669)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101192"
//             data-name="Path 101192"
//             d="M274.929,67.048c-.389-.047-1.053-.1-1.319.267a2.858,2.858,0,0,0-.175,1.5c.006.3-.045.868.34.982a.8.8,0,0,0,.53-.131l.971-.438c.3-.135.04-.574-.257-.44a6.776,6.776,0,0,1-.809.365c-.242.072-.221.081-.26-.173a2.565,2.565,0,0,1-.006-.414,2.436,2.436,0,0,1,.06-.841c.13-.281.642-.2.925-.169.325.039.322-.471,0-.509h0Z"
//             transform="translate(-222.801 -56.035)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101193"
//             data-name="Path 101193"
//             d="M275.035,82.277l1.356-.22c.323-.052.186-.543-.136-.492l-1.356.22c-.323.052-.186.543.135.492Z"
//             transform="translate(-224.013 -69.631)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101194"
//             data-name="Path 101194"
//             d="M319.311,60.069a1.088,1.088,0,0,0-1.081,1.061,1.112,1.112,0,0,0,.267.707c.107.124.259.181.371.293q.339.133.043.462a2.094,2.094,0,0,1-.383.321c-.266.188-.012.63.257.44.353-.249.955-.682.784-1.192a.97.97,0,0,0-.388-.433c-.176-.139-.341-.225-.4-.458a.539.539,0,0,1,.534-.692c.325-.023.328-.532,0-.509Z"
//             transform="translate(-264.679 -49.544)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101195"
//             data-name="Path 101195"
//             d="M351.73,54.622a1.094,1.094,0,0,0-1.3.759c-.219.8,1.053,1.831-.253,2.175a.255.255,0,0,0,.135.492,1.315,1.315,0,0,0,1.02-.951,1.026,1.026,0,0,0-.064-.594c-.064-.161-.168-.3-.245-.452-.219-.432-.071-1.027.571-.937.321.045.46-.446.136-.492h0Z"
//             transform="translate(-294.368 -44.44)"
//             fill="#fff"
//           />
//           <g
//             id="Group_106494"
//             data-name="Group 106494"
//             transform="translate(56.184 29.364)"
//           >
//             <path
//               id="Path_101196"
//               data-name="Path 101196"
//               d="M438.329,371.679a9.668,9.668,0,0,0-.379-2.769c-.269-.871-1.042-2.163-2.153-1.666-1.017.455-.831,1.692-.261,2.4a15.207,15.207,0,0,0,2.358,2.215c.253.2.616-.155.36-.36-.71-.57-3.655-2.668-2.409-3.684,1.5-1.22,1.971,3.113,1.974,3.864a.255.255,0,0,0,.509,0Z"
//               transform="translate(-430.056 -365.873)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101197"
//               data-name="Path 101197"
//               d="M510.262,443.69c.218-1.254.975-5.2-1.3-5.02-1.419.115-.9,1.452-.529,2.26.437.949.9,1.885,1.366,2.819.147.293.587.035.44-.257q-.406-.814-.8-1.634c-.19-.394-.38-.788-.563-1.185-.208-.45-.474-.746-.19-1.184.7-1.084,1.251.4,1.3.969a8.839,8.839,0,0,1,0,1.29,16.225,16.225,0,0,1-.207,1.805c-.056.321.435.458.492.135Z"
//               transform="translate(-498.232 -432.721)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101198"
//               data-name="Path 101198"
//               d="M441.31,475.615a3.961,3.961,0,0,0-1.386-2.054c-.925-.687-2.736-.92-3.534.1a1.345,1.345,0,0,0,.839,2.046,9.488,9.488,0,0,0,3.834.23c.324-.028.327-.538,0-.509a14.648,14.648,0,0,1-2.366.021c-.594-.045-2.81-.432-1.872-1.518.772-.894,2.436-.374,3.128.331a3.577,3.577,0,0,1,.864,1.488.255.255,0,0,0,.492-.136Z"
//               transform="translate(-431.052 -464.781)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101199"
//               data-name="Path 101199"
//               d="M362.737,418.975c-.446-1.485-2.677-1.675-3.85-1.088-.717.359-.437.992.158,1.3a4.709,4.709,0,0,0,3.513.1c.309-.1.176-.6-.135-.492a4.53,4.53,0,0,1-2.736.092c-.143-.043-.734-.208-.745-.42-.01-.2.766-.293.886-.311.824-.122,2.131,0,2.416.952a.255.255,0,0,0,.492-.135Z"
//               transform="translate(-358.461 -413.015)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101200"
//               data-name="Path 101200"
//               d="M364.039,350.643a3.1,3.1,0,0,0,.01-1.686,1.648,1.648,0,0,0-2.008-1.032c-1.653.412,1.057,2.571,1.623,2.87.29.153.547-.287.257-.44a5.8,5.8,0,0,1-1.221-.951,2.988,2.988,0,0,1-.589-.682c-.126-.23-.109-.284.157-.321,1.308-.182,1.541,1.127,1.279,2.107a.255.255,0,0,0,.492.135Z"
//               transform="translate(-361.314 -347.87)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101201"
//             data-name="Path 101201"
//             d="M92.739,912.115a4.39,4.39,0,0,0-6.4-.433c-2.644,2.419-.794,5.918,1.161,8.1a8.832,8.832,0,0,0,4.23,2.931,3.483,3.483,0,0,0,2.372-.863c2.7-1.712,6.421-5.26,5.663-8.833-.728-3.428-5.721-3.519-7.431-.854-.177.277.263.533.44.257a4.143,4.143,0,0,1,4.943-1.3c2.008.981,1.835,3.4,1,5.114a13.208,13.208,0,0,1-4.212,4.732c-.75.537-1.843,1.449-2.817,1.212-1.63-.4-3.138-1.9-4.165-3.144-1.043-1.261-2.109-2.9-2.023-4.607a3.859,3.859,0,0,1,4.593-3.371,4.632,4.632,0,0,1,2.28,1.418c.217.247.575-.115.36-.36Z"
//             transform="translate(-46.745 -844.114)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101202"
//             data-name="Path 101202"
//             d="M89.8,960.516a7.364,7.364,0,0,0,2.112,0c.524-.194.933-.979,1.288-1.4L92.77,959q.332,1.883.664,3.766c.047.268.416.215.492,0l1.773-5.1-.5-.067q.111,3.213.221,6.425a.256.256,0,0,0,.5.067l.756-3.215c.04-.171.072-.346.121-.515-.006.022-.328.119-.13.15a2.449,2.449,0,0,0,.374,0h1.734a.255.255,0,0,0,0-.509H96.56a.259.259,0,0,0-.245.187l-.886,3.766.5.067q-.111-3.213-.221-6.425a.256.256,0,0,0-.5-.067q-.886,2.548-1.773,5.1h.492q-.332-1.883-.664-3.766a.257.257,0,0,0-.426-.113l-.623.747a3.2,3.2,0,0,1-.4.484c-.2.153.223-.031,0,.024a9.454,9.454,0,0,1-2.009,0,.255.255,0,0,0,0,.509h0Z"
//             transform="translate(-50.968 -888.092)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101203"
//             data-name="Path 101203"
//             d="M256.645,934.358a1.424,1.424,0,0,1,1.03,1.172c.04.321.55.325.509,0a1.949,1.949,0,0,0-1.4-1.664.255.255,0,0,0-.135.492Z"
//             transform="translate(-206.958 -866.132)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101204"
//             data-name="Path 101204"
//             d="M279.5,971.64h-.056a.255.255,0,0,0,0,.509h.056a.255.255,0,0,0,0-.509Z"
//             transform="translate(-228.203 -901.443)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101205"
//             data-name="Path 101205"
//             d="M656.822,850.024l-.038.086a.271.271,0,0,0,.04.309c.26.3.573.088.8-.143a2.248,2.248,0,0,0,.616-1.607l-.5.067c.155.822.619,1.6,1.555,1.534a.259.259,0,0,0,.22-.384c-.5-1.163-1.778,2.156-1.87,2.5a.255.255,0,0,0,.492.135,2.164,2.164,0,0,0-.934-2.444c-.276-.179-.531.261-.257.44a1.635,1.635,0,0,1,.7,1.868l.492.135a7.706,7.706,0,0,1,.473-1.313c.113-.237.578-.8.466-1.062l.22-.384c-.7.047-.956-.59-1.064-1.159-.054-.288-.5-.213-.5.067a1.786,1.786,0,0,1-.156.77c-.028.06-.41.6-.395.621.013.1.027.206.04.309l.038-.086c.131-.3-.308-.557-.44-.257h0Z"
//             transform="translate(-581.042 -786.288)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101206"
//             data-name="Path 101206"
//             d="M700.689,635.466c.691.452,1.205-1.214,1.268-1.634h-.492c.227.7.582,1.377,1.415,1.318-.022-.167-.045-.334-.067-.5-.927.345-1.178,1.895-1.358,2.736l.5.067a3.023,3.023,0,0,0-.738-2.389c-.212-.251-.572.111-.36.36a2.549,2.549,0,0,1,.589,2.029c-.034.285.441.346.5.067.126-.588.356-2.14,1-2.38.25-.093.24-.522-.067-.5-.628.044-.788-.524-.924-.944-.07-.216-.451-.267-.492,0a6.012,6.012,0,0,1-.52,1.329c-.275-.18-.531.261-.257.44h0Z"
//             transform="translate(-621.992 -585.452)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101207"
//             data-name="Path 101207"
//             d="M1009.929,583.5c-.824.272-1.96-1.4-1.673-2.131.234-.594.97-.247,1.2.153a2.935,2.935,0,0,1,.285.9.255.255,0,0,0,.509,0c-.013.1.033-.166.043-.206a2.767,2.767,0,0,1,.147-.465c.117-.274.661-1.012,1-.536.225.314-.208.975-.373,1.222a2.948,2.948,0,0,1-1.2,1.095c-.3.133-.04.572.257.44a3.566,3.566,0,0,0,1.615-1.671c.227-.456.46-1.183-.047-1.547-1.086-.779-1.841.843-1.951,1.668h.509a2.623,2.623,0,0,0-.611-1.5,1.166,1.166,0,0,0-1.79.118c-.642,1.1.939,3.382,2.214,2.961.31-.1.177-.594-.135-.492Z"
//             transform="translate(-909.017 -535.947)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101208"
//             data-name="Path 101208"
//             d="M1019.572,652.3a2.458,2.458,0,0,1-2.323,2.931c-.326.017-.328.527,0,.509a2.971,2.971,0,0,0,2.814-3.576c-.059-.322-.551-.186-.492.135h0Z"
//             transform="translate(-917.71 -602.707)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101209"
//             data-name="Path 101209"
//             d="M522.268,568.162a33.947,33.947,0,0,1,2.207,3.937c.368.772,1.514.1,1.148-.671a33.975,33.975,0,0,0-2.207-3.937c-.465-.714-1.616-.048-1.148.671Z"
//             transform="translate(-455.258 -523.464)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101210"
//             data-name="Path 101210"
//             d="M542.581,569.516l-.024.021a.677.677,0,0,0-.1.805l.018.035a.647.647,0,0,0,.574.329c.49-.041.85-.469,1.214-.766l1.271-1.038a.67.67,0,0,0,0-.94.68.68,0,0,0-.94,0c-.6.492-1.191,1.074-1.839,1.5l.335-.091-.041,0,.574.329-.018-.035-.1.805.024-.021c.645-.564-.3-1.5-.94-.94h0Z"
//             transform="translate(-474.145 -524.014)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101211"
//             data-name="Path 101211"
//             d="M563.919,536.594c.416.8.855,1.581,1.324,2.349a5.637,5.637,0,0,0,1.292,1.824.673.673,0,0,0,.976-.4l.01-.026a.665.665,0,0,0-.306-.751l-.019-.009c-.767-.37-1.441.775-.671,1.148l.019.009-.306-.751-.01.026.976-.4a6.544,6.544,0,0,1-.441-.745q-.3-.479-.6-.967c-.388-.651-.753-1.313-1.1-1.984-.4-.759-1.544-.087-1.148.671h0Z"
//             transform="translate(-494.207 -493.936)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101212"
//             data-name="Path 101212"
//             d="M604.407,520.945a11.452,11.452,0,0,0,1.712,3.138c.742.825,1.876-.227,2.585-.634a.665.665,0,0,0-.671-1.148,9.829,9.829,0,0,1-1.434.816l.512.067c-.176-.079-.372-.57-.468-.733q-.186-.315-.359-.637c-.268-.5-.509-1.017-.73-1.542-.333-.785-1.477-.109-1.148.671Z"
//             transform="translate(-532.067 -479.298)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101213"
//             data-name="Path 101213"
//             d="M606.133,506.6a1.709,1.709,0,0,1,1.221-.7.681.681,0,0,0,.664-.664.67.67,0,0,0-.664-.664,2.99,2.99,0,0,0-2.161,1.094.686.686,0,0,0,0,.94.67.67,0,0,0,.94,0h0Z"
//             transform="translate(-532.682 -464.946)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101214"
//             data-name="Path 101214"
//             d="M623.357,532.809a8.274,8.274,0,0,1,1.328-.774.67.67,0,0,0,.238-.909.68.68,0,0,0-.909-.238,8.322,8.322,0,0,0-1.328.774.683.683,0,0,0-.238.909.67.67,0,0,0,.909.238Z"
//             transform="translate(-548.899 -489.468)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101215"
//             data-name="Path 101215"
//             d="M688.724,483.307a18.337,18.337,0,0,1,.725-4.193l-1.111.293c.482.443.958.893,1.419,1.357q.346.349.683.706a5.864,5.864,0,0,1,.516.5l.641-.841-.03,0,.664.664c0-.007,0-.015,0-.022-.111-.836-1.441-.846-1.329,0,0,.007,0,.015,0,.022a.677.677,0,0,0,.664.664l.03,0a.672.672,0,0,0,.641-.841,4.534,4.534,0,0,0-1.2-1.439c-.569-.588-1.159-1.155-1.763-1.708a.672.672,0,0,0-1.111.293,19.911,19.911,0,0,0-.772,4.546c-.046.855,1.283.852,1.33,0h0Z"
//             transform="translate(-609.675 -440.381)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101216"
//             data-name="Path 101216"
//             d="M695.856,520.483c.48-.242.966-.473,1.462-.679a.686.686,0,0,0,.464-.818.669.669,0,0,0-.818-.464c-.6.251-1.2.518-1.78.813a.665.665,0,1,0,.671,1.148h0Z"
//             transform="translate(-616.654 -477.953)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101217"
//             data-name="Path 101217"
//             d="M778.33,455.326q.011,2.136.1,4.269a.671.671,0,0,0,.841.641,19.113,19.113,0,0,1,2.531-.731c.836-.181.482-1.462-.354-1.282a19.321,19.321,0,0,0-2.531.731l.841.641q-.088-2.134-.1-4.269a.665.665,0,0,0-1.329,0h0Z"
//             transform="translate(-694.66 -418.327)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101218"
//             data-name="Path 101218"
//             d="M844.921,451.271q1.61-.115,3.212-.326c.836-.111.847-1.441,0-1.33q-1.6.211-3.212.326c-.848.06-.855,1.39,0,1.33Z"
//             transform="translate(-756.295 -413.585)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101219"
//             data-name="Path 101219"
//             d="M869.662,460.386c.041,1.155.008,2.311-.014,3.467a.665.665,0,0,0,1.33,0c.022-1.155.054-2.311.014-3.467-.03-.853-1.36-.857-1.33,0Z"
//             transform="translate(-780 -423.057)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101220"
//             data-name="Path 101220"
//             d="M930.739,451.936a32.68,32.68,0,0,1-.167,3.6c-.086.85,1.243.844,1.329,0a32.658,32.658,0,0,0,.167-3.6.665.665,0,0,0-1.33,0Z"
//             transform="translate(-836.933 -415.159)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101221"
//             data-name="Path 101221"
//             d="M934.6,480.086l2.88.073a.665.665,0,0,0,0-1.33l-2.88-.073a.665.665,0,0,0,0,1.33Z"
//             transform="translate(-840.104 -440.824)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101222"
//             data-name="Path 101222"
//             d="M975.154,448.578a17.961,17.961,0,0,1-.752,3.53.665.665,0,0,0,1.282.353,19.649,19.649,0,0,0,.8-3.884c.066-.853-1.263-.849-1.33,0h0Z"
//             transform="translate(-877.87 -412.025)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101223"
//             data-name="Path 101223"
//             d="M1027.026,463.5a11.535,11.535,0,0,0,1.937,2.242c.638.567,1.581-.371.94-.94a10.2,10.2,0,0,1-1.729-1.973c-.472-.709-1.624-.044-1.148.671Z"
//             transform="translate(-926.971 -425.654)"
//             fill="#6552cc"
//           />
//           <path
//             id="Path_101224"
//             data-name="Path 101224"
//             d="M1040.71,460.293a6.156,6.156,0,0,1-2.175,3.421c-.723.454-.056,1.605.671,1.148,1.531-.963,2.2-2.579,2.786-4.216.289-.807-.994-1.154-1.282-.353h0Z"
//             transform="translate(-937.542 -423.145)"
//             fill="#6552cc"
//           />
//           <g
//             id="Group_106496"
//             data-name="Group 106496"
//             transform="translate(127.861 88.192)"
//           >
//             <g
//               id="Group_106495"
//               data-name="Group 106495"
//               transform="translate(9.137 26.914)"
//             >
//               <path
//                 id="Path_101225"
//                 data-name="Path 101225"
//                 d="M1600.4,1661.611q-1.89,3.922-3.475,7.982a14.992,14.992,0,0,0,5.839,1.871l2.973-5.031a51.357,51.357,0,0,0,.686,5.488c.228.229,5.031,0,6.4-.914.228-1.143-.686-8.918-.686-8.918-2.771.969-7.209.291-11.739-.478Z"
//                 transform="translate(-1596.671 -1661.352)"
//                 fill="#656565"
//               />
//               <path
//                 id="Path_101226"
//                 data-name="Path 101226"
//                 d="M1596.494,1657.793q-1.9,3.957-3.5,8.043a.257.257,0,0,0,.117.288,14.822,14.822,0,0,0,5.9,1.9.268.268,0,0,0,.288-.117l2.973-5.031-.475-.128c.128,1.464.262,2.931.462,4.387.048.35.031,1.04.325,1.3s1.079.14,1.44.128a21.075,21.075,0,0,0,2.924-.3c.579-.1,1.972-.232,2.372-.767.25-.333.111-1.058.1-1.439-.037-.935-.118-1.868-.2-2.8q-.218-2.433-.506-4.86a.259.259,0,0,0-.323-.246c-3.636,1.184-7.958.14-11.6-.478-.321-.054-.459.437-.135.492,3.75.634,8.141,1.693,11.875.478l-.323-.245q.271,2.309.484,4.623c.092,1.01.183,2.023.223,3.036a2.941,2.941,0,0,1,.007,1c-.148.315-.713.4-1.055.489a16.9,16.9,0,0,1-3.522.487,5.3,5.3,0,0,1-1.227.009c-.258-.052-.2.013-.257-.369-.229-1.64-.4-3.284-.547-4.934a.257.257,0,0,0-.475-.128l-1.6,2.7-1.028,1.741c-.054.09-.183.418-.281.475-.113.066-.653-.135-.941-.191a16.323,16.323,0,0,1-3.015-.876c-.292-.117-1.372-.429-1.542-.748.057.107.592-1.089.674-1.289q.457-1.121.938-2.233.907-2.093,1.9-4.148C1597.075,1657.756,1596.636,1657.5,1596.494,1657.793Z"
//                 transform="translate(-1592.981 -1657.662)"
//                 fill="#656565"
//               />
//             </g>
//             <path
//               id="Path_101227"
//               data-name="Path 101227"
//               d="M1559.358,1787.674l-2.973,8c-.115.308.378.441.492.135l2.973-8c.115-.308-.378-.441-.492-.136Z"
//               transform="translate(-1549.627 -1752.088)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101228"
//               data-name="Path 101228"
//               d="M1746.856,1816.863q.125,3.053.25,6.106a21.3,21.3,0,0,1,.093,2.264c-.029.433-.564,1.854.047,2.259.5.331,1.828.1,2.387.113,1.31.03,2.621.062,3.931.047.509-.006,1.46.164,1.762-.374.539-.962-.927-1.273-1.358-1.634-.735-.616-1.208-2.386-2.291-2.519a2.089,2.089,0,0,0-1.536.816c-.319.447-.122.866.041,1.368l.178-.314a4.616,4.616,0,0,1-2.776.026c-.291-.149-.549.29-.257.44a5.093,5.093,0,0,0,3.169.026.256.256,0,0,0,.178-.314c-.226-.694-.024-1.388.81-1.415.6-.02,1.019.759,1.369,1.22a9.269,9.269,0,0,0,.706.965c.279.279.6.281.942.514,1.252.861-.8.687-1.223.689-1.034,0-2.067-.015-3.1-.037a11.869,11.869,0,0,1-2.374-.058c-.378-.092-.308.06-.291-.477.013-.422.147-.823.183-1.24a28.923,28.923,0,0,0-.13-3.624q-.1-2.423-.2-4.848c-.013-.327-.523-.329-.509,0h0Z"
//               transform="translate(-1727.646 -1779.297)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101229"
//               data-name="Path 101229"
//               d="M1812.232,1807.26q-.39,3.476-.779,6.951c-.037.325.473.323.509,0q.39-3.476.779-6.951c.037-.325-.473-.323-.509,0Z"
//               transform="translate(-1788.013 -1770.327)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101230"
//               data-name="Path 101230"
//               d="M1494.71,1806.925q-2.194,4.386-4.387,8.773a1.084,1.084,0,0,0-.181.888c.087.531.24.725-.232.915a4.884,4.884,0,0,1-1.206.159c-1.085.115-2.176.189-3.266.208-.5.009-2.329.213-2.66-.28s.741-1.349,1.065-1.577c.423-.3.879-.545,1.3-.843.4-.284.78-.62,1.2-.88.105-.066.316-.238.44-.239.983-.011.444.922.531,1.295.3,1.271,2.041,1.473,3.062,1.194a.255.255,0,0,0-.135-.491,1.959,1.959,0,0,1-2.02-.352c-.432-.447-.265-.706-.376-1.24a1.084,1.084,0,0,0-.674-.879,1.373,1.373,0,0,0-1.2.347c-.9.609-1.855,1.212-2.707,1.878-.569.445-1.6,1.65-.675,2.276a5.415,5.415,0,0,0,2.734.3,35.8,35.8,0,0,0,3.826-.26c.572-.07,1.4-.016,1.593-.686a1.6,1.6,0,0,0-.039-.712c-.028-.132-.119-.648-.173-.306a2.4,2.4,0,0,1,.278-.556l1.441-2.881,2.9-5.8c.146-.293-.293-.551-.44-.257h0Z"
//               transform="translate(-1480.335 -1770.12)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101231"
//               data-name="Path 101231"
//               d="M1563.94,1899.117a5.271,5.271,0,0,0,3.616,1.362.255.255,0,0,0,0-.509,4.728,4.728,0,0,1-3.256-1.213c-.244-.218-.606.141-.36.36Z"
//               transform="translate(-1556.628 -1855.998)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101232"
//               data-name="Path 101232"
//               d="M1505.4,1934.516c-.106,1.976,3.28.645,4.006-.048.238-.227-.123-.587-.36-.36-.483.461-3.2,1.623-3.136.409.018-.328-.492-.327-.509,0h0Z"
//               transform="translate(-1501.989 -1889.029)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101233"
//               data-name="Path 101233"
//               d="M1797.67,1941.321c.93,1.03,2.452,1.789,3.739.954.274-.178.019-.619-.257-.44-1.093.708-2.347-.017-3.121-.875-.22-.244-.58.117-.36.36Z"
//               transform="translate(-1775.07 -1895.426)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101234"
//               data-name="Path 101234"
//               d="M1756.288,1908.052a6.225,6.225,0,0,0,3.756-.584c.294-.145.036-.585-.257-.44a5.625,5.625,0,0,1-3.363.532c-.321-.048-.459.443-.135.492Z"
//               transform="translate(-1736.288 -1863.764)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101235"
//               data-name="Path 101235"
//               d="M1653.471,1455.824c.808.325,1.591.7,2.4,1.029l-.178-.314a8.284,8.284,0,0,0-.3,3.359c.107.695.646,1.37.579,2.018-.252,2.471-.813,4.889-.975,7.382l.255-.255a36.972,36.972,0,0,1-11.872-.856l.178.314c.52-1.96.9-3.96,1.352-5.936a15.407,15.407,0,0,1,.671-2.12,6.347,6.347,0,0,0,.084-4.248l-.178.314a18.112,18.112,0,0,1,2.329-.686l-.323-.245c.371,2.994,6.08,3.256,6.3,0,.022-.327-.488-.326-.509,0-.179,2.662-5,2.224-5.281,0a.259.259,0,0,0-.323-.245,18.114,18.114,0,0,0-2.329.686.26.26,0,0,0-.178.314c.746,2.3-.349,4.3-.85,6.515-.416,1.838-.773,3.7-1.257,5.517a.258.258,0,0,0,.178.314,37.459,37.459,0,0,0,12.007.875.263.263,0,0,0,.255-.255,56.292,56.292,0,0,1,.924-7.081,2.059,2.059,0,0,0,.119-.82c-.069-.271-.383-.571-.486-.862a6.687,6.687,0,0,1,.119-3.861.263.263,0,0,0-.178-.314c-.808-.325-1.591-.7-2.4-1.029-.3-.122-.437.37-.135.492Z"
//               transform="translate(-1630.642 -1441.646)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101236"
//               data-name="Path 101236"
//               d="M1596.837,1469.5a59.223,59.223,0,0,0-4.115,4.573l.4.052-1.143-2.286c-.147-.293-.587-.035-.44.257l1.143,2.286a.256.256,0,0,0,.4.052,59.173,59.173,0,0,1,4.116-4.573.255.255,0,0,0-.36-.36h0Z"
//               transform="translate(-1582.469 -1454.837)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101237"
//               data-name="Path 101237"
//               d="M1556.513,1522.228c.378,1.491,1.091,4.028,2.683,4.65,1.849.723,4.066-1.914,5.05-3.157.2-.255-.156-.617-.36-.36-.859,1.085-3.071,3.791-4.642,2.976-1.31-.679-1.9-2.918-2.239-4.246a.255.255,0,0,0-.492.136h0Z"
//               transform="translate(-1549.755 -1503.884)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101238"
//               data-name="Path 101238"
//               d="M1836.048,1469.923a17.832,17.832,0,0,1,3.1,2.167c1.121.97,3.629,3.153,2.747,4.84a12.123,12.123,0,0,1-2.667,2.849q-1.146,1.062-2.321,2.092c-.247.217.115.575.36.36q1.467-1.284,2.888-2.622c.85-.805,2.244-1.871,2.431-3.119.24-1.6-1.548-3.343-2.585-4.316a18.113,18.113,0,0,0-3.7-2.69c-.288-.157-.546.283-.257.44h0Z"
//               transform="translate(-1810.88 -1454.857)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101239"
//               data-name="Path 101239"
//               d="M1828.833,1546.629l2.744,1.829v-.44a11.405,11.405,0,0,0-3.843,4.369c-.127.3.312.558.44.257a10.914,10.914,0,0,1,3.66-4.186.259.259,0,0,0,0-.44l-2.744-1.829c-.274-.183-.529.259-.257.44h0Z"
//               transform="translate(-1803.208 -1526.533)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101240"
//               data-name="Path 101240"
//               d="M1827.57,1660.141c.828.811,3.1.563,3.464-.681.346-1.186-1.5-1.407-2.276-1.411a.255.255,0,0,0,0,.509c.434,0,1.784.045,1.8.66.014.462-.78.725-1.119.807a1.616,1.616,0,0,1-1.512-.245c-.234-.23-.595.13-.36.36h0Z"
//               transform="translate(-1803.004 -1631.111)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101241"
//               data-name="Path 101241"
//               d="M1690.267,1298.419a10.484,10.484,0,0,0-1.674,5.1c.043,1.144.64,1.482,1.53,2.054.6.388,1.284.846,1.25,1.651a1.551,1.551,0,0,1-1.183,1.371c-.307.109-.175.6.135.492a1.99,1.99,0,0,0,1.559-1.784c0-1.2-.877-1.783-1.821-2.363-1.412-.865-.963-2.4-.486-3.761a15.876,15.876,0,0,1,1.13-2.5c.16-.286-.279-.543-.44-.257h0Z"
//               transform="translate(-1673.194 -1294.906)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101242"
//               data-name="Path 101242"
//               d="M1712.757,1260.39a2.8,2.8,0,0,1,.073-2.481c.1-.18.328-.631.534-.689a2.692,2.692,0,0,0,.661.135,1.543,1.543,0,0,0,.347-.089,1.444,1.444,0,0,0,.746-.681c.63-1.169-.158-2.762-1.414-1.568l.426.248a3.254,3.254,0,0,0-.157-2.334,3.69,3.69,0,0,0-2.056-1.172c-1.7-.552-6.307-.945-4.965-3.846a1.592,1.592,0,0,1,2.092-.723,30.976,30.976,0,0,1,4.313,2.05c1.062.52,2.659,1.184,2.789,2.528a5,5,0,0,1-1.3,3.25c-.209.25.15.612.36.36,1.356-1.621,2.194-4.057.257-5.514a31.725,31.725,0,0,0-4.653-2.432c-.938-.485-2.2-1.224-3.285-.759-1.413.606-1.585,2.647-.688,3.748,1.629,2,7.954.808,6.8,4.709a.257.257,0,0,0,.426.248c.862-.819.975.938.242,1.362-.57.329-.968-.139-1.442.261a3.205,3.205,0,0,0-.6,3.524c.116.3.609.172.492-.135h0Z"
//               transform="translate(-1689.731 -1246.527)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101243"
//               data-name="Path 101243"
//               d="M1504.756,1402.473c-3.373-1.478-6.456,2.419-5.6,5.639a3.521,3.521,0,0,0,3.833,2.48,4.6,4.6,0,0,0,3.649-3.136,3.908,3.908,0,0,0-1.878-4.983c-.291-.149-.55.291-.257.44,4.2,2.142.469,9.057-3.553,6.763-3.471-1.979-.164-8.391,3.553-6.763.3.13.557-.308.257-.44Z"
//               transform="translate(-1496.023 -1391.963)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101244"
//               data-name="Path 101244"
//               d="M1541.073,1444.957a1.332,1.332,0,0,0-1.76.708,1.378,1.378,0,0,0,.375,1.845c1.559.894,2.991-1.716,1.386-2.553-.291-.151-.548.288-.257.44,1.03.538.1,2.247-.871,1.673-.806-.474-.007-2.048.871-1.673C1541.115,1445.524,1541.375,1445.085,1541.073,1444.957Z"
//               transform="translate(-1533.511 -1431.86)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101245"
//               data-name="Path 101245"
//               d="M1459.027,1402.33c-1.927-1.567-4.7.356-5.346,2.309a4.231,4.231,0,0,0,.616,4.206,3.72,3.72,0,0,0,3.727.781.255.255,0,0,0-.135-.492,3.23,3.23,0,0,1-3.151-.572,3.687,3.687,0,0,1-.566-3.788c.51-1.546,2.876-3.4,4.494-2.085.252.2.615-.153.36-.36h0Z"
//               transform="translate(-1453.401 -1391.593)"
//               fill="#414042"
//             />
//             <circle
//               id="Ellipse_129861"
//               data-name="Ellipse 129861"
//               cx="0.571"
//               cy="0.571"
//               r="0.571"
//               transform="translate(16.942 6.386) rotate(-45)"
//               fill="#414042"
//             />
//             <circle
//               id="Ellipse_129862"
//               data-name="Ellipse 129862"
//               cx="0.571"
//               cy="0.571"
//               r="0.571"
//               transform="translate(20.946 7.949) rotate(-76.72)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101246"
//               data-name="Path 101246"
//               d="M1730.328,1365.563a1.109,1.109,0,1,0,1.921,1.1c.152-.29-.287-.548-.44-.257a.6.6,0,1,1-1.041-.587c.173-.28-.268-.536-.44-.257Z"
//               transform="translate(-1712.044 -1357.658)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101247"
//               data-name="Path 101247"
//               d="M1719.15,1323.028l.91.144a.264.264,0,0,0,.314-.178.257.257,0,0,0-.178-.313l-.91-.144a.264.264,0,0,0-.313.178.257.257,0,0,0,.178.314Z"
//               transform="translate(-1701.579 -1317.557)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101248"
//               data-name="Path 101248"
//               d="M1779.859,1339.127a1.541,1.541,0,0,0,.7.388c.318.078.454-.413.135-.492a1.024,1.024,0,0,1-.475-.257c-.237-.227-.6.133-.36.36Z"
//               transform="translate(-1758.416 -1332.661)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101249"
//               data-name="Path 101249"
//               d="M1676.75,1524.547c.7-.37,2.122-.079,2.878-.058l2.865.077a.255.255,0,0,0,0-.509l-3.526-.094a5.081,5.081,0,0,0-2.473.145c-.29.153-.033.593.257.44h0Z"
//               transform="translate(-1661.77 -1505.725)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101250"
//               data-name="Path 101250"
//               d="M1785.664,1531.14a22.269,22.269,0,0,1,3.26.254c.321.049.459-.442.135-.492a23.217,23.217,0,0,0-3.395-.272.255.255,0,0,0,0,.509h0Z"
//               transform="translate(-1763.684 -1512.032)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101251"
//               data-name="Path 101251"
//               d="M1673.68,1548.5a9.239,9.239,0,0,1,2.481.1l2.584.207,5.168.414c.327.026.325-.484,0-.509l-5.6-.448c-1.491-.119-3.3-.56-4.77-.257-.321.066-.185.557.135.492h0Z"
//               transform="translate(-1658.962 -1528.171)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101252"
//               data-name="Path 101252"
//               d="M1661.706,1574a94.919,94.919,0,0,0,10.975.617c.327-.014.329-.524,0-.509a94.855,94.855,0,0,1-10.975-.617c-.327-.024-.325.486,0,.509Z"
//               transform="translate(-1647.841 -1552.084)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101253"
//               data-name="Path 101253"
//               d="M1907.251,1559.374a.374.374,0,0,1,.1.482.255.255,0,0,0,.44.257.882.882,0,0,0-.181-1.1c-.249-.21-.612.149-.36.36h0Z"
//               transform="translate(-1877.463 -1538.499)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106498"
//             data-name="Group 106498"
//             transform="translate(35.263 87.105)"
//           >
//             <path
//               id="Path_101254"
//               data-name="Path 101254"
//               d="M86.323,1335.274a7.178,7.178,0,0,0-4.133-.676c-1.948.067-3.9.145-5.844.223a42.032,42.032,0,0,0-4.422.18,1.923,1.923,0,0,0-.784.325,6.218,6.218,0,0,1-1.673.775c-.369.083-.905.266-.69-.42a1.618,1.618,0,0,1,.37-.466.257.257,0,0,0-.113-.426,9.56,9.56,0,0,1-1.371-.371c-.117-.044-.57-.175-.626-.3-.113-.259-.177.018.016-.13.288-.22,1.2-.141,1.549-.165,1.582-.109,3.164-.193,4.737-.4,1.445-.194,2.846-.579,4.279-.831,1.595-.279,3.2-.477,4.812-.655,1.239-.138,2.478-.255,3.717-.391a4.351,4.351,0,0,0,2.479-.752c.565-.471,1.405-1.614.9-2.365-.683-1.009-2.563-.676-2.338-2.3A10.573,10.573,0,0,1,88.347,1323a2.468,2.468,0,0,1,.357-.687,4.42,4.42,0,0,1,1.871-.452,2.935,2.935,0,0,1,2.19.577c.651.576.863,1.545,1.391,2.231a3.315,3.315,0,0,0,.757.758c.072.048.39.151.43.217.4.642-1.257,1.61-1.59,1.993a1.723,1.723,0,0,0-.465,1.427,2.779,2.779,0,0,0,1.636,2.134c1.83.869,4.275.594,6.233.644,3.051.077,6.055.252,9.1.512a23.632,23.632,0,0,0,5.5-.109c.39-.056,1.934-.242,1.1.6a3.669,3.669,0,0,1-1.414.589,11.724,11.724,0,0,1-1.908.426c-.214.028-.391.359-.128.475a2.549,2.549,0,0,1,.746.4c.545.551-.239.316-.639.226a20.736,20.736,0,0,0-3.194-.653c-1.5-.1-3.054.041-4.558.017a40.627,40.627,0,0,0-5.678.177c-1.064.134-2.442.3-3.141,1.224-.2.261.244.515.44.257.951-1.253,3.739-1.1,5.108-1.141,1.963-.06,3.924.042,5.886.028a14.844,14.844,0,0,1,2.827.066,16.592,16.592,0,0,0,3.07.672c.409-.008.807-.167.731-.657-.081-.517-.933-.877-1.34-1.056-.043.158-.086.317-.128.475a8.691,8.691,0,0,0,3.579-1.085c.613-.408.882-1.138.065-1.49a3.082,3.082,0,0,0-1.688-.028,15.015,15.015,0,0,1-3.079.21c-1.839-.056-3.66-.316-5.494-.447-2.877-.2-5.769-.172-8.65-.286a6.529,6.529,0,0,1-3.538-.744,1.732,1.732,0,0,1-.405-2.709c.507-.521,1.472-.951,1.68-1.7.179-.644-.3-.767-.729-1.037-1.251-.791-1.3-2.545-2.58-3.293a4.477,4.477,0,0,0-3.584-.111c-.86.288-.974.62-1.355,1.416a9.833,9.833,0,0,0-1.084,3.122c-.127,1.266.742,1.625,1.782,2.125,1.506.725-.141,2.323-1.174,2.573a10.239,10.239,0,0,1-1.316.166c-1.47.158-2.942.3-4.41.471-3.875.455-7.642,1.437-11.54,1.7-.832.056-1.671.083-2.5.183-.278.034-.75.029-.962.246-.926.941,2,1.555,2.352,1.632q-.056-.213-.113-.426c-.347.359-.9,1.021-.545,1.534.494.714,1.789.08,2.349-.189a13.694,13.694,0,0,1,1.241-.7c-.213.075.078.02.164.01.7-.083,1.436-.059,2.142-.088q3.312-.135,6.624-.261c1.774-.066,3.7-.377,5.305.555a.255.255,0,0,0,.257-.44h0Z"
//               transform="translate(-64.567 -1315.345)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101255"
//               data-name="Path 101255"
//               d="M405.868,1285.328c3.536-.7,5.927-4.046,4.582-7.594-1.193-3.146-5.613-4.648-8.294-2.37a5.132,5.132,0,0,0-1.654,2.76c-.067.32.424.457.492.135.719-3.454,5.079-4.5,7.654-2.27a5.107,5.107,0,0,1,1.539,4.933,5.315,5.315,0,0,1-4.453,3.914c-.321.063-.185.554.136.492h0Z"
//               transform="translate(-376.822 -1271.365)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101256"
//               data-name="Path 101256"
//               d="M498.2,1233.385a3.034,3.034,0,0,1-.062-1.528c.382-1.579,2.355-1.711,3.562-1.02,1.363.78,1.681,2.306.364,3.3a4.931,4.931,0,0,1-1.829.835c-.319.075-.184.566.135.492a4.579,4.579,0,0,0,2.715-1.637c.875-1.282.093-2.728-1.129-3.429-1.2-.689-3.039-.721-3.93.492a3.085,3.085,0,0,0-.319,2.632.255.255,0,0,0,.492-.135h0Z"
//               transform="translate(-467.525 -1229.92)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101257"
//               data-name="Path 101257"
//               d="M353.091,1468.383a34.7,34.7,0,0,0-.75,4.925c-.163,2.577.994,5.262-.834,7.531-.108.134-.095.387.113.426,1.551.292,3.121.507,4.69.669,2.2.227,4.8.555,6.929-.21a.259.259,0,0,0,.153-.375,6.364,6.364,0,0,1-.838-3.008c-.009-1.377.814-2.7,1.043-4.069a26.456,26.456,0,0,0,.289-5.427c-.014-.327-.523-.329-.509,0a21.774,21.774,0,0,1-.484,6.316c-.355,1.354-.981,2.371-.8,3.831a7.141,7.141,0,0,0,.859,2.615l.152-.374c-2.089.748-4.638.414-6.794.192-1.525-.157-3.049-.368-4.555-.651q.056.213.113.426c1.714-2.128,1.06-4.56.961-7.04a23.537,23.537,0,0,1,.754-5.641c.067-.32-.424-.457-.492-.135h0Z"
//               transform="translate(-330.978 -1452.601)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101258"
//               data-name="Path 101258"
//               d="M388.287,1467.42c-1.3,5.425,8.013,4.991,8.99.365.067-.32-.424-.457-.492-.135-.447,2.116-2.642,3.213-4.639,3.255-2.027.043-3.9-1.125-3.368-3.349.077-.319-.415-.455-.492-.136h0Z"
//               transform="translate(-365.297 -1451.703)"
//               fill="#414042"
//             />
//             <g
//               id="Group_106497"
//               data-name="Group 106497"
//               transform="translate(7.131 28.168)"
//             >
//               <path
//                 id="Path_101259"
//                 data-name="Path 101259"
//                 d="M165.032,1664.031s-9.417,8.728-13.322,14.011a4.214,4.214,0,0,0,2.986,1.838s11.485-9.877,14.7-10.336,9.877,5.053,10.107,5.742-.689,5.053-.689,5.053a4.23,4.23,0,0,0,3.9,0s1.838-5.053,1.838-7.58-8.039-8.269-8.039-8.269c-3.107.879-7.177.379-11.485-.46Z"
//                 transform="translate(-151.454 -1663.78)"
//                 fill="#616161"
//               />
//               <path
//                 id="Path_101260"
//                 data-name="Path 101260"
//                 d="M161.2,1660.28c-4.7,4.363-9.519,8.908-13.362,14.063a.25.25,0,0,0,0,.257,3.609,3.609,0,0,0,1.794,1.517c.441.193,1.126.556,1.595.369a6.017,6.017,0,0,0,1.206-1.019c2.192-1.832,4.421-3.625,6.72-5.323,1.183-.874,2.383-1.728,3.634-2.5a9.4,9.4,0,0,1,2.828-1.385c1.448-.3,3.074.558,4.3,1.229a27.025,27.025,0,0,1,4.112,2.8,9.529,9.529,0,0,1,1.347,1.215c.332.4.269.714.217,1.242a37.138,37.138,0,0,1-.674,3.953.26.26,0,0,0,.117.288,5.512,5.512,0,0,0,2.029.508,3.411,3.411,0,0,0,2.158-.528,4.576,4.576,0,0,0,.613-1.675,36.671,36.671,0,0,0,1.043-3.854,5.97,5.97,0,0,0,.168-2.869c-.59-1.858-2.575-3.418-3.98-4.644-.841-.733-1.708-1.436-2.59-2.118a7.138,7.138,0,0,0-1.4-1.05c-.278-.112-.426-.041-.753.035a14.375,14.375,0,0,1-3.229.332,40.125,40.125,0,0,1-7.646-.912c-.32-.062-.458.429-.136.492a39.026,39.026,0,0,0,8.151.926,16.334,16.334,0,0,0,1.771-.128,8.532,8.532,0,0,1,1.446-.308,1.7,1.7,0,0,1,.635.369c2.36,1.758,5,3.693,6.688,6.137.968,1.4.576,2.843.2,4.416-.217.913-.477,1.815-.757,2.709a6.788,6.788,0,0,1-.566,1.705c-.206.289-.62.323-.99.386a4.761,4.761,0,0,1-1.635-.036s-.985-.277-.841-.08c-.118-.162.253-1.279.286-1.462.183-.991.757-2.7.4-3.693-.277-.765-1.363-1.441-1.959-1.918a27.138,27.138,0,0,0-4.192-2.805,7.828,7.828,0,0,0-4.035-1.224,6.653,6.653,0,0,0-2.633,1.054,63.379,63.379,0,0,0-7.666,5.472q-1.641,1.3-3.25,2.64c-.3.253-1.077,1.187-1.485,1.252.257-.041-.815-.435-.434-.241-.353-.179-.756-.262-1.1-.47-.84-.5-1.1-.776-.531-1.5.655-.836,1.345-1.644,2.049-2.439,1.516-1.715,3.1-3.37,4.709-5,1.957-1.981,3.95-3.93,5.992-5.824.241-.223-.12-.583-.36-.36Z"
//                 transform="translate(-147.804 -1660.209)"
//                 fill="#414042"
//               />
//             </g>
//             <path
//               id="Path_101261"
//               data-name="Path 101261"
//               d="M46.072,1874.12a13.01,13.01,0,0,1-4.985,4.116c-.459.178-2.133.525-2.217,1.187-.066.522.552.579.93.626a16.776,16.776,0,0,0,3.358-.037,5.5,5.5,0,0,0,2.143-.424,19.939,19.939,0,0,0,4.118-3.271c.24-.224-.12-.584-.36-.36a27.923,27.923,0,0,1-3.43,2.831c-1.39.929-3.307.834-4.926.8a3.055,3.055,0,0,1-1.2-.1c-.17-.1-.03.01.1-.107a2.96,2.96,0,0,1,.882-.378,10.745,10.745,0,0,0,2.672-1.251,20.913,20.913,0,0,0,3.28-3.274c.211-.249-.147-.611-.36-.36h0Z"
//               transform="translate(-38.865 -1831.871)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101262"
//               data-name="Path 101262"
//               d="M557.176,1909.5a21.63,21.63,0,0,0-.293,2.384c-.035.565-.193,1.687.41,2.038a4.9,4.9,0,0,0,1.858.214c1.174.068,2.353.1,3.528.083.363-.005,3.354-.033,1.985-.963a13.637,13.637,0,0,0-2.935-.995c-.784-.291-.684-.649-.5-1.418.1-.407.213-.81.344-1.207.1-.312-.389-.446-.492-.135-.331,1.007-1.071,2.586.183,3.127.837.361,1.749.534,2.6.844.229.083.44.215.662.3-.123-.047.158-.146-.138-.17a9.25,9.25,0,0,0-1.023.089,34.383,34.383,0,0,1-5.332-.148c-.384-.044-.481,0-.624-.366a3.825,3.825,0,0,1-.012-1.4,20.935,20.935,0,0,1,.266-2.137c.056-.321-.435-.458-.492-.135h0Z"
//               transform="translate(-522.931 -1864.843)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101263"
//               data-name="Path 101263"
//               d="M176.279,1606.931a2.3,2.3,0,0,0,2.025-2.542.255.255,0,0,0-.509,0c-.037,1.111.176,2.157,1.335,2.542v-.492c-1.182.316-1.442,1.458-1.565,2.543h.509c-.022-1.263-.306-2.7-1.862-2.552-.324.03-.327.54,0,.509,1.249-.116,1.336,1.081,1.353,2.042a.255.255,0,0,0,.509,0c.095-.835.256-1.8,1.191-2.051a.257.257,0,0,0,0-.492c-.924-.307-.99-1.206-.962-2.051h-.509a1.814,1.814,0,0,1-1.65,2.051c-.319.073-.185.564.135.492Z"
//               transform="translate(-166.987 -1579.645)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101264"
//               data-name="Path 101264"
//               d="M90.477,1716.306a1.691,1.691,0,0,1,1.176,1.473.255.255,0,0,0,.509,0,2.768,2.768,0,0,1,.946-1.818.256.256,0,0,0-.052-.4,1.668,1.668,0,0,1-.92-1.493.255.255,0,0,0-.509,0,2.171,2.171,0,0,1-1.019,1.709c-.274.179-.018.62.257.44a2.715,2.715,0,0,0,1.271-2.149h-.509A2.165,2.165,0,0,0,92.8,1716c-.017-.134-.035-.267-.052-.4a3.312,3.312,0,0,0-1.1,2.178h.509a2.223,2.223,0,0,0-1.549-1.964c-.311-.106-.444.386-.136.491h0Z"
//               transform="translate(-86.934 -1682.145)"
//               fill="#414042"
//             />
//             <circle
//               id="Ellipse_129863"
//               data-name="Ellipse 129863"
//               cx="0.574"
//               cy="0.574"
//               r="0.574"
//               transform="translate(23.81 8.32)"
//               fill="#414042"
//             />
//             <circle
//               id="Ellipse_129864"
//               data-name="Ellipse 129864"
//               cx="0.574"
//               cy="0.574"
//               r="0.574"
//               transform="translate(27.485 9.239)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101265"
//               data-name="Path 101265"
//               d="M406.716,1342.476a.716.716,0,0,1,.727.1c.251.208.613-.151.36-.36a1.252,1.252,0,0,0-1.344-.185c-.3.132-.041.571.257.44Z"
//               transform="translate(-382.271 -1334.588)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101266"
//               data-name="Path 101266"
//               d="M465.6,1354.658a1.465,1.465,0,0,1,.714.424c.225.24.585-.121.36-.36a1.962,1.962,0,0,0-.938-.555.255.255,0,0,0-.136.492h0Z"
//               transform="translate(-437.494 -1346.025)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101267"
//               data-name="Path 101267"
//               d="M412.72,1387.718a1.049,1.049,0,0,0,1.928.563c.188-.27-.253-.524-.44-.257a.536.536,0,0,1-.978-.306.255.255,0,0,0-.509,0h0Z"
//               transform="translate(-388.247 -1377.159)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101268"
//               data-name="Path 101268"
//               d="M430.77,1278.766a5.8,5.8,0,0,1,3.973-2.789c.322-.062.185-.553-.135-.492a6.294,6.294,0,0,0-4.277,3.024.255.255,0,0,0,.44.257Z"
//               transform="translate(-404.669 -1272.498)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101269"
//               data-name="Path 101269"
//               d="M455.071,1289.279l3.359-2.372c.266-.188.012-.63-.257-.44l-3.359,2.372c-.266.188-.012.63.257.44Z"
//               transform="translate(-427.48 -1282.723)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101270"
//               data-name="Path 101270"
//               d="M478.687,1305.824a9.842,9.842,0,0,0,3.051-2.9c.185-.272-.257-.527-.44-.257a9.242,9.242,0,0,1-2.869,2.722.255.255,0,0,0,.257.44Z"
//               transform="translate(-449.541 -1297.793)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101271"
//               data-name="Path 101271"
//               d="M499.452,1313.849a6.513,6.513,0,0,0,2.465-4.176c.05-.321-.441-.459-.492-.135a6.112,6.112,0,0,1-2.334,3.951c-.259.2.1.559.36.36h0Z"
//               transform="translate(-468.881 -1304.153)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101272"
//               data-name="Path 101272"
//               d="M506.235,1322.862a4.641,4.641,0,0,0,2.443-5.808c-.1-.309-.6-.176-.492.135a4.143,4.143,0,0,1-2.209,5.232c-.3.14-.038.579.257.44h0Z"
//               transform="translate(-475.276 -1311.186)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101273"
//               data-name="Path 101273"
//               d="M509.938,1238.077a4.067,4.067,0,0,1,2.37-2.9c.3-.132.041-.572-.257-.44a4.536,4.536,0,0,0-2.6,3.208c-.069.32.422.456.492.135Z"
//               transform="translate(-478.635 -1234.395)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101274"
//               data-name="Path 101274"
//               d="M520.566,1242.73a7.3,7.3,0,0,0,2.7-3.3c.126-.3-.367-.434-.492-.135a6.681,6.681,0,0,1-2.465,2.994c-.271.182-.016.623.257.44h0Z"
//               transform="translate(-488.684 -1238.525)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101275"
//               data-name="Path 101275"
//               d="M529.025,1255.156a4.067,4.067,0,0,0,3.143-3.077c.073-.319-.418-.456-.492-.135a3.568,3.568,0,0,1-2.787,2.721c-.321.065-.185.556.135.492Z"
//               transform="translate(-496.64 -1250.331)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101276"
//               data-name="Path 101276"
//               d="M386.52,1588.587a1.535,1.535,0,0,1,.19,1.069c-.061.321.43.458.492.135a2.084,2.084,0,0,0-.242-1.462.255.255,0,0,0-.44.257h0Z"
//               transform="translate(-363.729 -1564.752)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101277"
//               data-name="Path 101277"
//               d="M385.169,1634.329v-.115a.255.255,0,0,0-.509,0v.115a.255.255,0,0,0,.509,0Z"
//               transform="translate(-362.024 -1607.519)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106499"
//             data-name="Group 106499"
//             transform="translate(37.586 84.684)"
//           >
//             <path
//               id="Path_101278"
//               data-name="Path 101278"
//               d="M82.363,1203.482c-1.445-1.053-2.946-2-4.792-1.193-1.525.67-2.351,2.529-2.8,4.028-.392,1.323-.786,3.306.15,4.5.975,1.248,2.982,1.314,4.334.74l-.374-.152a2.917,2.917,0,0,0,2.871,2.1c1.678-.056,3.073-1.739,3.908-3.027.922-1.421,1.757-3.411.758-5a3.475,3.475,0,0,0-1.767-1.346,16.275,16.275,0,0,1-2.293-.644.255.255,0,0,0-.257.44c.941.533,2.112.414,3.054,1.011,1.709,1.082,1.279,3.081.475,4.592a6.929,6.929,0,0,1-3.252,3.341,2.379,2.379,0,0,1-3-1.6.26.26,0,0,0-.374-.153c-1.238.526-3.3.379-3.9-1.011-.534-1.244-.111-2.929.317-4.14.458-1.3,1.25-2.914,2.68-3.331,1.628-.476,2.772.39,4,1.285.265.193.52-.249.257-.44Z"
//               transform="translate(-74.348 -1201.392)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101279"
//               data-name="Path 101279"
//               d="M191.235,1195.373a4.012,4.012,0,0,1,4.485-1.792l-.153-.375a3.669,3.669,0,0,1-4.485,1.792.255.255,0,0,0-.136.492,4.181,4.181,0,0,0,5.061-2.026.257.257,0,0,0-.153-.374,4.539,4.539,0,0,0-5.061,2.026c-.189.269.253.524.44.257Z"
//               transform="translate(-183.129 -1192.935)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101280"
//               data-name="Path 101280"
//               d="M181.766,1227.4l-.6,1.211c-.145.293.294.551.44.257l.6-1.211c.145-.293-.294-.551-.44-.257Z"
//               transform="translate(-174.145 -1225.024)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101281"
//               data-name="Path 101281"
//               d="M141.646,1304.021l-1.05,2.379c-.131.3.308.557.44.257l1.05-2.38c.131-.3-.308-.557-.44-.257Z"
//               transform="translate(-136.236 -1296.625)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101282"
//               data-name="Path 101282"
//               d="M158.681,1270.941a1.755,1.755,0,0,0-.575,1.06c-.039.347.138.744.54.739s.7-.459.827-.8a.826.826,0,0,0-.308-1.037.255.255,0,0,0-.257.44c.2.117.12.363.039.531-.036.075-.231.437-.332.323-.075-.084.046-.354.082-.433a1.406,1.406,0,0,1,.344-.461c.242-.223-.12-.583-.36-.36Z"
//               transform="translate(-152.618 -1265.763)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101283"
//               data-name="Path 101283"
//               d="M103.45,1244.686a2.919,2.919,0,0,0-1.1,2.328.255.255,0,0,0,.509,0,2.438,2.438,0,0,1,.952-1.968c.257-.2-.106-.562-.36-.36Z"
//               transform="translate(-100.516 -1241.242)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101284"
//               data-name="Path 101284"
//               d="M102.039,1297.8l.119-.119a.255.255,0,0,0-.36-.36l-.119.119a.255.255,0,0,0,.36.36Z"
//               transform="translate(-99.82 -1290.415)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106500"
//             data-name="Group 106500"
//             transform="translate(74.347 47.645)"
//           >
//             <path
//               id="Path_101285"
//               data-name="Path 101285"
//               d="M838.232,712.54a2.341,2.341,0,0,0-2.709,1.736,2.029,2.029,0,0,0,1.436,2.6c2.8.6,4.4-3.716,1.273-4.336-.32-.063-.458.427-.135.492,2.465.489,1.185,3.738-.96,3.358A1.5,1.5,0,0,1,836,714.474a1.823,1.823,0,0,1,2.1-1.443c.321.043.46-.448.135-.492Z"
//               transform="translate(-822.383 -706.924)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101286"
//               data-name="Path 101286"
//               d="M870.528,659.523a5.964,5.964,0,0,1,4.027-3.359c1.325-.236,2.258.035,2.783,1.424.115.3.608.172.492-.136a2.5,2.5,0,0,0-2.881-1.86,6.347,6.347,0,0,0-4.861,3.672c-.147.292.293.551.44.257h0Z"
//               transform="translate(-854.731 -653.712)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101287"
//               data-name="Path 101287"
//               d="M891.579,674.42c1.369-2.51,2.51-1.369,5.361-3.764-.342-1.026-1.026-1.026-1.026-1.026a7.807,7.807,0,0,0-5.144,3.357,2.36,2.36,0,0,1,.809,1.434Z"
//               transform="translate(-874.086 -666.848)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101288"
//               data-name="Path 101288"
//               d="M851.1,772.462a3.288,3.288,0,0,1-1.229,2.758c-.254.208.109.567.36.36a3.765,3.765,0,0,0,1.378-3.118c-.016-.327-.526-.329-.509,0Z"
//               transform="translate(-835.78 -762.719)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101289"
//               data-name="Path 101289"
//               d="M916.966,683.359c.138,1.42,1.109,2.813.419,4.229-.733,1.5-2.259,1.31-3.452,2.145a3.283,3.283,0,0,0-.668,4.657c.208.254.566-.108.36-.36a2.742,2.742,0,0,1,1.11-4.139,6.391,6.391,0,0,0,2.524-1.224c1.608-1.7.4-3.373.217-5.308-.031-.323-.541-.327-.509,0h0Z"
//               transform="translate(-894.469 -679.451)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101290"
//               data-name="Path 101290"
//               d="M841.677,639.052s-2.966-2.738-5.931-.228a5.031,5.031,0,0,0-1.6,5.7,2.723,2.723,0,0,1,2.281-1.825A7.635,7.635,0,0,1,841.677,639.052Z"
//               transform="translate(-820.877 -637.068)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101291"
//               data-name="Path 101291"
//               d="M749.854,628.773s-.685-2.738-3.422-1.141-2.51,4.106-2.738,5.932-2.281.912-1.825,2.51,1.6,2.51,3.879.228,1.141-5.7,3.422-6.616l.685-.912Z"
//               transform="translate(-734.871 -627.132)"
//               fill="#414042"
//             />
//             <circle
//               id="Ellipse_129865"
//               data-name="Ellipse 129865"
//               cx="0.57"
//               cy="0.57"
//               r="0.57"
//               transform="translate(19.774 6.204)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101292"
//               data-name="Path 101292"
//               d="M961.645,749.4a1.37,1.37,0,0,0,1.438.411c.312-.1.179-.589-.135-.492a.869.869,0,0,1-.943-.28c-.213-.25-.572.112-.36.36h0Z"
//               transform="translate(-940.262 -740.977)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101293"
//               data-name="Path 101293"
//               d="M848.205,818.383a4.141,4.141,0,0,0,2.178,1.885,5.312,5.312,0,0,0,1.694.276c.374.009,1.055.12,1.384-.117.264-.19.01-.632-.257-.44-.447.321-2.095-.01-2.55-.16a3.641,3.641,0,0,1-2.01-1.7.255.255,0,0,0-.44.257h0Z"
//               transform="translate(-834.274 -805.507)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101294"
//               data-name="Path 101294"
//               d="M797.808,815.579a11.83,11.83,0,0,0-3.412,2.414.258.258,0,0,0,0,.36,3.618,3.618,0,0,1,.9,3.9,5.286,5.286,0,0,0-.413,1.184c-.075.642.2,1.256.141,1.9-.029.327.481.325.509,0a6,6,0,0,0-.093-1.185,3.432,3.432,0,0,1,.317-1.667,4.336,4.336,0,0,0,.291-1.462,4.171,4.171,0,0,0-1.3-3.028v.36a11.471,11.471,0,0,1,3.309-2.334c.3-.139.038-.579-.257-.44h0Z"
//               transform="translate(-783.953 -803.217)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101295"
//               data-name="Path 101295"
//               d="M922.532,849.918a8.169,8.169,0,0,1,1.385,4.921c-.083,1.589-.753,3.068-.832,4.66-.016.328.494.327.509,0,.091-1.84.911-3.53.836-5.4a8.712,8.712,0,0,0-1.458-4.442c-.179-.273-.621-.018-.44.257Z"
//               transform="translate(-903.73 -834.985)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101296"
//               data-name="Path 101296"
//               d="M732.451,852.084a20.207,20.207,0,0,0-3.354,3.946c-.736,1.143-1.5,2.476-.719,3.794.8,1.362,2.552,1.716,3.943,2.13,1.938.577,3.871,1.178,5.817,1.73.872.247,1.432.977,2.4.391a3.263,3.263,0,0,0,1.381-2.13,2.825,2.825,0,0,0-1.113-1.676c-.927-.7-1.714.341-2.736.158a36.529,36.529,0,0,1-3.775-.888,3.941,3.941,0,0,1-1.57-.594c-.445-.495.335-1.217.74-1.577.246-.218-.116-.577-.36-.36-.916.812-1.6,1.974-.221,2.584a22.393,22.393,0,0,0,5.185,1.355,2.19,2.19,0,0,0,1.07-.018c.685-.221,1.078-.613,1.676.08a4.9,4.9,0,0,1,.5.731c.081.137.1.309.1.085a2.775,2.775,0,0,1-.553,1.194,1.3,1.3,0,0,1-1.265.71c-.393-.05-.337-.165-.608-.278a17.5,17.5,0,0,0-1.728-.555l-5.015-1.491a7.632,7.632,0,0,1-2.852-1.193c-1.188-1.005-.869-2.272-.157-3.456a19.494,19.494,0,0,1,3.564-4.309c.242-.222-.119-.582-.36-.36h0Z"
//               transform="translate(-722.02 -837.295)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101297"
//               data-name="Path 101297"
//               d="M938.5,978.787a13.608,13.608,0,0,0,3.976,1.784c.313.1.447-.392.135-.492a13.168,13.168,0,0,1-3.854-1.732c-.266-.193-.52.249-.257.44Z"
//               transform="translate(-918.588 -955.312)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101298"
//               data-name="Path 101298"
//               d="M948.074,924.955c.713,1.03,2.037,2.473,3.389,2.59.791.068,2.357-.844,2.877.086.209.373-.114,1.3-.247,1.7a4.757,4.757,0,0,1-.415.919q-1.522.942-1.515-1.128c.219-.243-.14-.6-.36-.36a1.291,1.291,0,0,0,.424,2.126c1.32.623,1.953-.18,2.358-1.421.251-.768.709-2.426-.406-2.7-1.074-.266-2.156.462-3.23.067a5.625,5.625,0,0,1-2.435-2.133c-.185-.268-.627-.013-.44.257h0Z"
//               transform="translate(-927.596 -905.113)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101299"
//               data-name="Path 101299"
//               d="M1004.823,985.027a1.579,1.579,0,0,0,1.486,1.086.255.255,0,0,0,0-.509,1.056,1.056,0,0,1-.994-.712c-.1-.309-.6-.177-.492.135h0Z"
//               transform="translate(-980.659 -961.308)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101300"
//               data-name="Path 101300"
//               d="M1006.049,978.513c-.012-.236.509.209.556.246a.963.963,0,0,0,.619.238.255.255,0,0,0,0-.509c-.228,0-.382-.2-.55-.332a.906.906,0,0,0-.517-.221.578.578,0,0,0-.617.578c.018.326.527.328.509,0h0Z"
//               transform="translate(-981.342 -954.971)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101301"
//               data-name="Path 101301"
//               d="M1011.226,971.477c.008-.082.909.177.992.2a.255.255,0,0,0,.136-.492c-.5-.133-1.549-.554-1.637.293-.034.326.476.323.509,0Z"
//               transform="translate(-986.18 -948.454)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101302"
//               data-name="Path 101302"
//               d="M795.772,999.775a20.091,20.091,0,0,1-.519,3.6.259.259,0,0,0,.245.323c1.678.154,3.357.31,5.044.331a12.276,12.276,0,0,0,4.44-.467.26.26,0,0,0,.178-.314,17.655,17.655,0,0,1-.57-2.628c-.045-.323-.536-.186-.492.135a17.646,17.646,0,0,0,.57,2.628l.178-.314a12.806,12.806,0,0,1-4.744.44c-1.539-.04-3.073-.181-4.6-.323l.245.323a20.761,20.761,0,0,0,.537-3.733c.018-.328-.492-.327-.509,0Z"
//               transform="translate(-784.815 -975.152)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101303"
//               data-name="Path 101303"
//               d="M782.2,1056.184c-.323,1.432-.591,2.873-.784,4.328-.085.641-.594,2.146-.043,2.666.247.232.886.145,1.184.169q1.281.1,2.565.17c1.57.083,3.14.123,4.712.132a.256.256,0,0,0,.246-.187l.534-3.947c.043-.321-.448-.459-.492-.135l-.3,2.193a5.468,5.468,0,0,1-.178,1.316c-.212.3-.348.212-.671.245a28.786,28.786,0,0,1-4.5-.162c-.706-.042-1.438-.046-2.137-.151a1.008,1.008,0,0,1-.433-.086q-.437-.019-.181-.5a4.76,4.76,0,0,1,.116-1.077,47.859,47.859,0,0,1,.846-4.838c.072-.319-.419-.456-.492-.135h0Z"
//               transform="translate(-771.615 -1027.926)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101304"
//               data-name="Path 101304"
//               d="M914.381,1068.022l3.017-.306a.259.259,0,0,0,.255-.255,20.426,20.426,0,0,0-1.483-6.2c-.124-.3-.617-.168-.492.136a19.949,19.949,0,0,1,1.465,6.066l.255-.255-3.017.306c-.323.033-.327.543,0,.509h0Z"
//               transform="translate(-895.923 -1032.683)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101305"
//               data-name="Path 101305"
//               d="M831.41,1063.408q-.376,3.079-.751,6.159c-.04.325.47.322.509,0q.376-3.079.752-6.159c.04-.325-.47-.322-.509,0Z"
//               transform="translate(-817.908 -1034.621)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101306"
//               data-name="Path 101306"
//               d="M849.609,1065.967c-.16.97-.3,1.942-.429,2.916a19.3,19.3,0,0,0-.175,3.035l.314.178-.007-.026a.255.255,0,0,0-.492.136l.007.026a.258.258,0,0,0,.314.178l.026-.007a.263.263,0,0,0,.187-.245q.246-3.043.746-6.054c.053-.321-.438-.459-.492-.135h0Z"
//               transform="translate(-834.875 -1037.068)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101307"
//               data-name="Path 101307"
//               d="M833.372,824.125a3.96,3.96,0,0,0,1.69,2.014.255.255,0,0,0,.257-.44,3.4,3.4,0,0,1-1.455-1.709c-.116-.3-.609-.172-.492.135Z"
//               transform="translate(-820.429 -810.942)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101308"
//               data-name="Path 101308"
//               d="M878.755,864.657a6.283,6.283,0,0,0,2.068.268,2.841,2.841,0,0,0,1.5-.3c.246-.218-.115-.577-.36-.36a4.022,4.022,0,0,1-.78.128,5.779,5.779,0,0,1-.714.033,5.894,5.894,0,0,1-1.575-.256.255.255,0,0,0-.135.492h0Z"
//               transform="translate(-862.691 -848.639)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101309"
//               data-name="Path 101309"
//               d="M646.939,1161.2c.046,1.814.106,3.629.2,5.441.026.518.054,1.037.092,1.555a2.768,2.768,0,0,0,.058.7c.1.24-.079.32.194.153a7.261,7.261,0,0,1-2.2.373c-1.272.2-2.549.386-3.833.492a10.481,10.481,0,0,1-1.4.06c-.391-.021-.367-.069-.769-.323-.692-.438-1.86-.916-2.6-.308a2.573,2.573,0,0,0-.623,1.681,14.7,14.7,0,0,0,.4,6.01c.135.434.31.977.768,1.158.983.389,1.979-.642,2.261-1.461a8.105,8.105,0,0,1,.76-2.38c.062-.087.516-.585.32-.5-.16.068-.05.033.056.041.763.052,1.518.139,2.284.158,2.472.062,5.26-.1,7.448-1.371,2.113-1.227,2.844-3.875,3.231-6.13a25.691,25.691,0,0,0,.376-5.069c-.01-.327-.519-.329-.509,0a20.78,20.78,0,0,1-1.077,7.732,5.713,5.713,0,0,1-4.083,3.77,18.441,18.441,0,0,1-5.932.538c-.8-.037-1.7-.395-2.23.154a3.972,3.972,0,0,0-.981,1.92,3.748,3.748,0,0,1-.321,1.36c-.245.4-1.025,1.1-1.514.714a1.594,1.594,0,0,1-.367-.769,14.4,14.4,0,0,1-.472-4.8,6.1,6.1,0,0,1,.263-1.9c.441-1.151,1.758-.384,2.5.041,1.158.661,3.149.106,4.42-.066q2.006-.272,4-.639a.254.254,0,0,0,.187-.246,76.379,76.379,0,0,1-.391-8.084.255.255,0,0,0-.509,0h0Z"
//               transform="translate(-635.911 -1126.007)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101310"
//               data-name="Path 101310"
//               d="M683.61,1300.226a7.721,7.721,0,0,0,.143,4.088c.1.312.589.179.492-.135a7.2,7.2,0,0,1-.143-3.817c.074-.319-.417-.456-.492-.135Z"
//               transform="translate(-680.292 -1255.993)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101311"
//               data-name="Path 101311"
//               d="M707.7,1298.474a11.543,11.543,0,0,0,.028,3.394c.05.323.541.186.492-.135a10.694,10.694,0,0,1-.027-3.123c.044-.321-.446-.459-.492-.135Z"
//               transform="translate(-702.896 -1254.354)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101312"
//               data-name="Path 101312"
//               d="M898.771,1165.02q1.655,3.215,3.483,6.336c.964,1.639,2.122,3.21,3,4.891.522,1,1.642,4.236,3.252,3.541a9.2,9.2,0,0,0,2.654-2.33c.622-.676,1.727-1.7,1.9-2.655.151-.843-.691-.859-1.3-.733a12,12,0,0,0-1.739.573c-.855.319-1.434-.212-1.794-.973-2.311-4.879-3.655-10.192-5-15.4a.255.255,0,0,0-.492.135,108.736,108.736,0,0,0,3.634,12.074c.362.933.759,1.853,1.144,2.777a4.087,4.087,0,0,0,.706,1.347,1.679,1.679,0,0,0,2.235.416,5.244,5.244,0,0,1,1.61-.488c.818,0,.306.614.005,1.04a17.442,17.442,0,0,1-2.6,2.859c-.313.282-.778.814-1.208.914-.559.131-1-.568-1.269-.964a21.765,21.765,0,0,1-1.3-2.433c-.863-1.668-2.025-3.228-2.979-4.852q-1.832-3.117-3.483-6.336c-.15-.292-.59-.034-.44.257h0Z"
//               transform="translate(-881.536 -1123.336)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101313"
//               data-name="Path 101313"
//               d="M1003,1402.8q1.265-.889,2.483-1.838c.259-.2-.1-.56-.36-.36q-1.168.909-2.38,1.759c-.266.187-.012.629.257.44h0Z"
//               transform="translate(-978.621 -1349.916)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101314"
//               data-name="Path 101314"
//               d="M1011.331,1417.044a7.755,7.755,0,0,0,2.7-2.235c.2-.259-.242-.513-.44-.257a7.214,7.214,0,0,1-2.516,2.052c-.293.147-.036.586.257.44h0Z"
//               transform="translate(-986.393 -1362.906)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101315"
//               data-name="Path 101315"
//               d="M651.515,1290.05a27.411,27.411,0,0,0,.3,8.167c.06.322.551.186.492-.136a26.957,26.957,0,0,1-.278-8.031c.037-.325-.473-.323-.509,0h0Z"
//               transform="translate(-650.329 -1246.427)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101316"
//               data-name="Path 101316"
//               d="M1027.279,1447.289a18.972,18.972,0,0,1,2.364-2.2c.258-.2-.1-.561-.36-.36a18.993,18.993,0,0,0-2.364,2.2c-.22.242.14.6.36.36Z"
//               transform="translate(-1001.259 -1391.152)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101317"
//               data-name="Path 101317"
//               d="M1077.213,1408.986a10.9,10.9,0,0,0,1.46-1.84c.175-.278-.265-.534-.44-.257a10.293,10.293,0,0,1-1.38,1.737c-.23.234.13.594.36.36h0Z"
//               transform="translate(-1047.919 -1355.733)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106501"
//             data-name="Group 106501"
//             transform="translate(100.022 8.242)"
//           >
//             <path
//               id="Path_101318"
//               data-name="Path 101318"
//               d="M1117.978,181.6a49.172,49.172,0,0,0,12.251-4.66,12.892,12.892,0,0,0,4.347-3.367c.185-.272-.256-.527-.44-.257-1.007,1.478-2.955,2.518-4.465,3.353a49.459,49.459,0,0,1-11.829,4.44.255.255,0,0,0,.135.492Z"
//               transform="translate(-1111.8 -163.51)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101319"
//               data-name="Path 101319"
//               d="M1100.067,161.255c1-.173,2.419-.27,2.844.836a10.477,10.477,0,0,1,.319,5.244,6.277,6.277,0,0,1-1.9,3.83,15.472,15.472,0,0,1-3.631,2.328,19.457,19.457,0,0,1-8.2,2.3c-2.953-.009-4.453-2.733-5.093-5.276a.255.255,0,0,0-.492.135c.51,2.031,1.549,4.306,3.547,5.241,2.1.983,4.914.133,6.981-.539a20.239,20.239,0,0,0,7.166-3.755c2.187-1.938,2.546-5.175,2.164-7.935-.135-.974-.251-2.331-1.274-2.776a4.678,4.678,0,0,0-2.569-.124c-.323.056-.186.547.135.492h0Z"
//               transform="translate(-1080.255 -151.781)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101320"
//               data-name="Path 101320"
//               d="M1206.851,336.6a2.617,2.617,0,0,1,.342.9.259.259,0,0,0,.313.178,32.39,32.39,0,0,0,8.712-3.6.258.258,0,0,0,.117-.288l-.406-1.1c-.113-.305-.6-.173-.492.135.122.33.362.67.187,1.017-.111.22-.78.445-1.024.576q-1.193.641-2.439,1.174a31.813,31.813,0,0,1-4.791,1.6l.313.178a4.306,4.306,0,0,0-.393-1.017c-.154-.29-.594-.033-.44.257h0Z"
//               transform="translate(-1195.122 -312.39)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101321"
//               data-name="Path 101321"
//               d="M1035.7,204.449c-.77,1.195-2.22,3.193-3.889,2.711s1.182-2.1.331-3.017c-.374-.4-1.275-.281-1.736-.292-.355-.008-1.236.069-1.516-.156-.494-.4.339-.977.674-1.288,1.139-1.059,2.271-1.88,3.86-1.445.8.22,1.607.439,2.429.581.321.055.458-.436.136-.492a24.01,24.01,0,0,0-3.453-.8c-1.288-.018-2.446.978-3.333,1.8-.388.36-1.4,1.143-.972,1.8s1.895.486,2.535.513c.208.009.95-.078,1.029.234.038.149-.327.566-.4.682a3.193,3.193,0,0,0-.623,1.195c-.119.787.512,1.157,1.223,1.22,1.886.168,3.231-1.561,4.15-2.988.178-.276-.263-.532-.44-.257h0Z"
//               transform="translate(-1028.13 -188.788)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101322"
//               data-name="Path 101322"
//               d="M1130.694,208.829a2.157,2.157,0,0,0-2.15,2.011,1.832,1.832,0,0,0,1.564,2.08c1.194.127,2.787-.667,2.967-1.951.2-1.395-1.19-2.109-2.381-2.139a.255.255,0,0,0,0,.509c.886.023,2.061.507,1.872,1.6a2.279,2.279,0,0,1-2.508,1.467,1.348,1.348,0,0,1-1-1.561,1.643,1.643,0,0,1,1.641-1.5c.327-.01.329-.519,0-.509Z"
//               transform="translate(-1121.963 -196.809)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101323"
//               data-name="Path 101323"
//               d="M1064.518,105.623a23.734,23.734,0,0,0-.367-4.141c-.231-1.285-.669-3.572-2.262-3.83a3.409,3.409,0,0,0-2.639.868,3.85,3.85,0,0,1-1.339.9,15.473,15.473,0,0,0-1.847.33c-1.773.74-2.442,2.91-.19,3.375,1.4.288,2.812.458,4.2.775,1.315.3,3.143.662,3.967,1.847.186.268.628.013.44-.257-1.332-1.915-4.591-2.188-6.68-2.545-.933-.16-3.674-.245-2.7-1.8.879-1.4,2.531-.8,3.722-1.613.943-.642,2.061-1.961,3.358-1.252.813.444,1.106,1.7,1.3,2.516a20.877,20.877,0,0,1,.518,4.823A.255.255,0,0,0,1064.518,105.623Z"
//               transform="translate(-1052.721 -92.88)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101324"
//               data-name="Path 101324"
//               d="M1218.864,87.833a8.374,8.374,0,0,0,1.715-6.038c-.129-1.261-.332-2.763,1.149-3.232,1.133-.358,2.359-.164,3.417-.786.385-.226.686-.607,1.144-.215.656.562-.322,1.479-.577,2.034-.5,1.09-.134,2.265-.433,3.392-.434,1.637-2.633,2.346-4,3.056q-1.356.7-2.723,1.389c-.293.147-.035.587.257.44q1.156-.578,2.3-1.173a17.1,17.1,0,0,0,3.8-2.15,3.518,3.518,0,0,0,.992-2.682,5.466,5.466,0,0,1,.209-1.913c.216-.562.675-1.008.872-1.574a1.087,1.087,0,0,0-.84-1.453c-.64-.185-.971.291-1.51.545-1.557.734-4.107-.011-4.591,2.217a5.936,5.936,0,0,0,0,1.934,7.834,7.834,0,0,1-1.544,5.848c-.2.253.155.616.36.36Z"
//               transform="translate(-1205.969 -73.503)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101325"
//               data-name="Path 101325"
//               d="M1162.043,198.327l.789-.456a.255.255,0,0,0-.257-.44l-.789.456a.255.255,0,0,0,.257.44Z"
//               transform="translate(-1152.921 -186.123)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101326"
//               data-name="Path 101326"
//               d="M1200.3,172.471a13.332,13.332,0,0,1,2.746-.93c.32-.071.185-.563-.135-.492a13.962,13.962,0,0,0-2.868.982c-.3.139-.039.578.257.44Z"
//               transform="translate(-1188.664 -161.496)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101327"
//               data-name="Path 101327"
//               d="M1232.42,137.489a19.757,19.757,0,0,1-3.76,5.946c-.221.242.138.6.36.36a20.44,20.44,0,0,0,3.892-6.171c.123-.3-.37-.436-.492-.135h0Z"
//               transform="translate(-1215.468 -129.98)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101328"
//               data-name="Path 101328"
//               d="M1140.087,146.683c1.627,1.052,3.262,2.233,3.882,4.158.1.311.593.178.492-.135-.663-2.059-2.37-3.333-4.116-4.463-.276-.179-.532.262-.257.44Z"
//               transform="translate(-1132.648 -138.281)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101329"
//               data-name="Path 101329"
//               d="M1100.191,245a9.048,9.048,0,0,1,1.652-.77c.308-.107.175-.6-.135-.492a9.729,9.729,0,0,0-1.774.821.255.255,0,0,0,.257.44h0Z"
//               transform="translate(-1095.119 -229.421)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101330"
//               data-name="Path 101330"
//               d="M1144.787,230.846a.713.713,0,0,0-.182.873.722.722,0,0,0,.825.338.255.255,0,0,0-.135-.492c-.253.071-.33-.216-.148-.358a.256.256,0,0,0,0-.36.261.261,0,0,0-.36,0h0Z"
//               transform="translate(-1136.908 -217.317)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101331"
//               data-name="Path 101331"
//               d="M1199.1,25.291a2.28,2.28,0,0,0-1.748,2.654,1.988,1.988,0,0,0,2.586,1.352,2.279,2.279,0,0,0,1.77-2.542,1.987,1.987,0,0,0-2.609-1.464c-.319.077-.184.569.135.492a1.477,1.477,0,0,1,1.97,1.053,1.769,1.769,0,0,1-1.4,1.971,1.477,1.477,0,0,1-1.959-1,1.769,1.769,0,0,1,1.392-2.027c.313-.095.179-.587-.135-.492Z"
//               transform="translate(-1186.215 -25.212)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101332"
//               data-name="Path 101332"
//               d="M1216.549,56.019a.511.511,0,0,0,.575.742.261.261,0,0,0,.178-.314.257.257,0,0,0-.314-.178c-.071.025.067.007,0,0a.038.038,0,0,1,.03.017.3.3,0,0,1-.035-.035c.016.018.016.015,0-.01.01.024.011.021,0-.007a.06.06,0,0,1,0,.043q-.019.036.006,0c.18-.275-.261-.531-.44-.257h0Z"
//               transform="translate(-1204.148 -53.893)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101333"
//               data-name="Path 101333"
//               d="M1361.334,76.882a31.925,31.925,0,0,0,3.4-2.342l-.426-.113c.116.858.079,1.665-.787,2.1-.538.268-1.813.765-2.257.169-.194-.261-.636-.007-.44.257.659.886,1.922.467,2.775.1,1.215-.529,1.363-1.552,1.2-2.756-.029-.213-.3-.213-.426-.113a31.076,31.076,0,0,1-3.3,2.262.255.255,0,0,0,.257.44h0Z"
//               transform="translate(-1339.003 -70.913)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101334"
//               data-name="Path 101334"
//               d="M1086.018,54.428a7.764,7.764,0,0,1,3.815-1.608.259.259,0,0,0,.18-.435,2.565,2.565,0,0,0-4.48,1.9c.019.326.528.328.509,0a2.057,2.057,0,0,1,3.61-1.535l.18-.435a8.4,8.4,0,0,0-4.175,1.758c-.257.2.105.561.36.36Z"
//               transform="translate(-1081.771 -49.766)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101335"
//               data-name="Path 101335"
//               d="M1140.548,336.411a1.667,1.667,0,0,0,2.251,1.255c.3-.116.172-.609-.135-.492a1.165,1.165,0,0,1-1.624-.9c-.061-.322-.552-.185-.492.135h0Z"
//               transform="translate(-1133.183 -315.741)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101336"
//               data-name="Path 101336"
//               d="M1189.6,353.119h.078a.255.255,0,0,0,0-.509h-.078a.255.255,0,0,0,0,.509Z"
//               transform="translate(-1178.804 -331.178)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101337"
//               data-name="Path 101337"
//               d="M1361.224,192.348l.931.6c.192.123.37-.183.179-.306l-.931-.6c-.193-.123-.371.183-.179.306Z"
//               transform="translate(-1339.342 -181.094)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101338"
//               data-name="Path 101338"
//               d="M1347.026,201.02l1.134.65a.177.177,0,0,0,.179-.306l-1.134-.65a.177.177,0,0,0-.179.306Z"
//               transform="translate(-1326.07 -189.202)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101339"
//               data-name="Path 101339"
//               d="M1371.834,213.976l.469.234c.2.1.383-.2.179-.306l-.469-.234c-.2-.1-.383.2-.179.306Z"
//               transform="translate(-1349.25 -201.314)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101340"
//               data-name="Path 101340"
//               d="M1333.018,216.423a27.614,27.614,0,0,1,2.731,1.135c.2.1.385-.208.179-.306a28.4,28.4,0,0,0-2.815-1.17c-.215-.077-.308.266-.094.342Z"
//               transform="translate(-1312.946 -203.577)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101341"
//               data-name="Path 101341"
//               d="M1247,166.987l.988,1.225c.143.177.393-.075.251-.251q-.494-.613-.988-1.225c-.143-.177-.393.075-.251.251Z"
//               transform="translate(-1232.629 -157.415)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101342"
//               data-name="Path 101342"
//               d="M1248.856,154.352l1.326,1.477c.152.17.4-.081.251-.251l-1.326-1.477c-.152-.17-.4.081-.251.251Z"
//               transform="translate(-1234.363 -145.611)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101343"
//               data-name="Path 101343"
//               d="M1259.325,147.447l.918,1.07c.149.173.4-.079.251-.251l-.918-1.07c-.149-.173-.4.079-.251.251Z"
//               transform="translate(-1244.148 -139.157)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101344"
//               data-name="Path 101344"
//               d="M1170.38,172.619q.068.591.136,1.183c.026.224.38.227.355,0q-.068-.591-.136-1.183c-.026-.224-.38-.227-.354,0h0Z"
//               transform="translate(-1161.067 -162.812)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101345"
//               data-name="Path 101345"
//               d="M1158.609,161.691a5.374,5.374,0,0,0,0,1.989c.042.224.384.129.342-.094a4.867,4.867,0,0,1,0-1.8c.041-.223-.3-.319-.342-.094Z"
//               transform="translate(-1149.982 -152.637)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101346"
//               data-name="Path 101346"
//               d="M1142.411,163.772q-.074.7-.147,1.4c-.023.226.331.225.354,0q.073-.7.146-1.4c.024-.227-.331-.225-.355,0h0Z"
//               transform="translate(-1134.792 -154.543)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101347"
//               data-name="Path 101347"
//               d="M1097.685,283.6a.613.613,0,0,0,.143.643c.16.163.41-.088.251-.251a.265.265,0,0,1-.052-.3.178.178,0,0,0-.124-.218.181.181,0,0,0-.218.124Z"
//               transform="translate(-1093.096 -266.563)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101348"
//               data-name="Path 101348"
//               d="M1108.734,276.616l.234.117c.2.1.383-.2.179-.306l-.234-.117c-.2-.1-.383.2-.179.306Z"
//               transform="translate(-1103.374 -259.853)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106503"
//             data-name="Group 106503"
//             transform="translate(132.668 31.354)"
//           >
//             <path
//               id="Path_101349"
//               data-name="Path 101349"
//               d="M1528.462,383.2c-2.953,1.776-1.141,5.7-.4,8.282.5,1.766,1.025,3.528,1.623,5.264a18.291,18.291,0,0,0,1.7,3.981,1.481,1.481,0,0,0,1.471.89,14.038,14.038,0,0,0,2.681-.613c2.959-.841,5.87-1.863,8.763-2.906,2.326-.839,4.7-1.644,6.948-2.686,2.139-.993.956-3.61.473-5.384a73.6,73.6,0,0,0-3.027-9.226,5.385,5.385,0,0,0-1.374-2.378c-.453-.295-1.068-.106-1.565-.02-3.271.566-6.5,1.5-9.7,2.385-1.657.46-3.312.933-4.953,1.45a14.662,14.662,0,0,0-2.642.96c-.288.158-.031.6.257.44a28.11,28.11,0,0,1,5.674-1.851c2.825-.811,5.666-1.575,8.525-2.254,1.024-.243,2.053-.489,3.092-.66.729-.12.992-.187,1.411.474,1.428,2.256,2.127,5.151,2.9,7.679.373,1.22.73,2.446,1.055,3.68.278,1.057,1.152,3.065.248,3.9a5.475,5.475,0,0,1-1.635.789c-1.037.425-2.086.825-3.136,1.22-2.7,1.015-5.425,1.984-8.169,2.88-1.2.392-2.4.772-3.617,1.108a8.059,8.059,0,0,1-2.369.515c-.881-.053-1.316-1.422-1.618-2.117a48.541,48.541,0,0,1-1.8-5.182c-.479-1.574-.92-3.16-1.365-4.744-.536-1.9-1.218-4.218.808-5.437a.255.255,0,0,0-.257-.44Z"
//               transform="translate(-1526.831 -378.27)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101350"
//               data-name="Path 101350"
//               d="M1540.7,459.858q.794,3.281,1.688,6.536a48.653,48.653,0,0,0,2.793,8.657c.269.549.5.992,1.148,1a9.858,9.858,0,0,0,2.819-.642c3.177-.949,6.292-2.118,9.394-3.285q3.359-1.264,6.7-2.589c.3-.12.17-.613-.135-.492-4.728,1.887-9.491,3.728-14.328,5.318-1.142.376-2.294.752-3.468,1.017-.7.158-1.152.365-1.538-.3a17.111,17.111,0,0,1-1.274-3.308c-.522-1.609-.988-3.236-1.438-4.867q-.988-3.579-1.866-7.188c-.077-.319-.569-.184-.491.135h0Z"
//               transform="translate(-1539.787 -454.219)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101351"
//               data-name="Path 101351"
//               d="M1655.744,434.328a57.421,57.421,0,0,1-8.421,2.725l.314.178c-.35-2.01.021-4.787,2.167-5.623,2.474-.964,4.827.9,5.788,3.094.131.3.571.041.44-.257-1.091-2.488-3.859-4.445-6.585-3.236-2.279,1.011-2.685,3.956-2.3,6.157a.259.259,0,0,0,.313.178,57.417,57.417,0,0,0,8.421-2.725c.3-.113.173-.606-.135-.492Z"
//               transform="translate(-1639.15 -427.4)"
//               fill="#414042"
//             />
//             <g
//               id="Group_106502"
//               data-name="Group 106502"
//               transform="translate(4.357 3.983)"
//             >
//               <path
//                 id="Path_101352"
//                 data-name="Path 101352"
//                 d="M1608.45,444.091s3.324-1.33,3.766-1.108,3.323,9.3,2.658,9.748-13.958,5.1-14.4,4.874-3.1-9.527-2.88-9.97,3.323-1.33,3.323-1.33l.221,2.215,8.419-2.658-1.108-1.773Z"
//                 transform="translate(-1597.306 -442.706)"
//                 fill="#cececf"
//               />
//               <path
//                 id="Path_101353"
//                 data-name="Path 101353"
//                 d="M1604.6,440.74q.8-.318,1.611-.6c.45-.156,1.654-.728,2.01-.424.3.252.444,1.061.572,1.418.3.848.58,1.707.842,2.57a23.949,23.949,0,0,1,1.144,4.677c.041.453.086.467-.217.664a7.919,7.919,0,0,1-1.5.587q-4.724,1.768-9.536,3.306c-.618.2-1.237.394-1.86.571-.224.064-.827.342-1.062.252.192.074-.04-.255-.09-.372-.09-.21-.164-.429-.24-.644-.282-.795-.531-1.6-.775-2.408-.533-1.765-1.058-3.548-1.439-5.353-.038-.181-.2-.589-.135-.77.091-.27.636-.412.919-.524.726-.285,1.477-.518,2.226-.734l-.323-.245q.111,1.108.221,2.215a.258.258,0,0,0,.323.245l8.419-2.658a.258.258,0,0,0,.153-.374l-1.108-1.773c-.174-.278-.615-.022-.44.257l1.108,1.773.152-.374-8.419,2.658.323.245q-.111-1.108-.221-2.215a.258.258,0,0,0-.323-.245,24.444,24.444,0,0,0-2.329.774c-.438.175-1.085.349-1.195.865a4.265,4.265,0,0,0,.276,1.55c.224.961.483,1.915.75,2.865a36.548,36.548,0,0,0,1.651,5.17c.38.842.93.535,1.712.313,3.773-1.073,7.491-2.426,11.165-3.792.586-.218,2.063-.479,2.316-1.153a3.513,3.513,0,0,0-.141-1.627c-.19-.973-.451-1.933-.723-2.886-.315-1.1-.658-2.2-1.037-3.286a5.953,5.953,0,0,0-.782-1.915c-.388-.418-.976-.173-1.471-.033a27.392,27.392,0,0,0-2.66.938c-.3.12-.169.613.135.492Z"
//                 transform="translate(-1593.387 -439.11)"
//                 fill="#414042"
//               />
//             </g>
//             <path
//               id="Path_101354"
//               data-name="Path 101354"
//               d="M1663.655,491.289h.3a.255.255,0,0,0,0-.509h-.3a.255.255,0,0,0,0,.509Z"
//               transform="translate(-1654.468 -483.415)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101355"
//               data-name="Path 101355"
//               d="M1692.2,448.365l.156.44a.262.262,0,0,0,.314.178.257.257,0,0,0,.178-.314l-.156-.44a.262.262,0,0,0-.313-.178.257.257,0,0,0-.178.314Z"
//               transform="translate(-1681.366 -443.475)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101356"
//               data-name="Path 101356"
//               d="M1672.378,468.639l.3.3a.255.255,0,0,0,.36-.36l-.3-.3a.255.255,0,0,0-.36.36Z"
//               transform="translate(-1662.78 -462.317)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101357"
//               data-name="Path 101357"
//               d="M1724.2,450.535v.148a.255.255,0,0,0,.509,0v-.148a.255.255,0,0,0-.509,0Z"
//               transform="translate(-1711.28 -445.574)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101358"
//               data-name="Path 101358"
//               d="M1744.717,468.278l-.148.148a.255.255,0,0,0,.36.36l.148-.148a.255.255,0,0,0-.36-.36Z"
//               transform="translate(-1730.245 -462.316)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101359"
//               data-name="Path 101359"
//               d="M1532.637,483.32l-.748,2.747a.177.177,0,0,0,.342.094l.748-2.747a.177.177,0,0,0-.342-.094Z"
//               transform="translate(-1531.551 -476.326)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101360"
//               data-name="Path 101360"
//               d="M1541.332,505.453l-.664,2.743c-.054.222.288.316.342.094l.664-2.743c.054-.222-.288-.316-.342-.094Z"
//               transform="translate(-1539.757 -497.009)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101361"
//               data-name="Path 101361"
//               d="M1546.044,532.453l-.882,2.959a.177.177,0,0,0,.342.094l.882-2.959a.177.177,0,0,0-.342-.094Z"
//               transform="translate(-1543.954 -522.244)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106504"
//             data-name="Group 106504"
//             transform="translate(134.423 54.873)"
//           >
//             <path
//               id="Path_101362"
//               data-name="Path 101362"
//               d="M1586.851,762.287a40.068,40.068,0,0,0-4.2.357c-.969.135-3.575.286-3.845,1.569-.44,2.084,3.81,2.4,4.985,2.355a14.361,14.361,0,0,0,3.68-.79c.8-.248.966.107,1.411.7,1.848,2.46,5.087,3.138,7.956,3.139a.255.255,0,0,0,0-.509,9.867,9.867,0,0,1-5.027-1.03,8.4,8.4,0,0,1-2.3-1.633c-.243-.27-.389-.619-.634-.882a1.254,1.254,0,0,0-1.214-.378,24.682,24.682,0,0,1-4.034.881c-.689.016-4.931-.327-4.3-1.85.268-.643,1.831-.8,2.389-.909a33.749,33.749,0,0,1,5.128-.509c.327-.011.329-.52,0-.509Z"
//               transform="translate(-1577.129 -760.668)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101363"
//               data-name="Path 101363"
//               d="M1698.981,742.169a4.583,4.583,0,0,1-.679-1.038c-.534-1.127-.141-1.854.866-2.514a2.664,2.664,0,0,1,1.414-.567c.837.046.973.959,1.2,1.61.211.6.431,1.193.666,1.783.12.3.613.169.492-.136-.165-.414-.322-.832-.475-1.251a7.937,7.937,0,0,0-.763-1.957c-.708-.975-1.978-.454-2.8.078-.9.583-1.576,1.265-1.339,2.4a4.486,4.486,0,0,0,1.049,1.952c.216.247.575-.114.36-.36h0Z"
//               transform="translate(-1688.104 -737.552)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101364"
//               data-name="Path 101364"
//               d="M1561.947,784.8c-1.46.653-1.67,2.768-1.587,4.118.02.326.53.328.509,0-.071-1.172.043-3.1,1.335-3.678.3-.134.04-.573-.257-.44Z"
//               transform="translate(-1559.906 -781.681)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101365"
//               data-name="Path 101365"
//               d="M1554.835,850.239a20.421,20.421,0,0,1-.524-2.8,8.615,8.615,0,0,1-.045-2.121,6.932,6.932,0,0,1,.158-.842,3.229,3.229,0,0,0,.338-.018c3.3.058,5.861,2.874,6.646,5.913a.255.255,0,0,0,.492-.135c-.835-3.233-3.663-6.345-7.21-6.288-1.96.031-.64,5.289-.346,6.424a.255.255,0,0,0,.492-.135h0Z"
//               transform="translate(-1553.637 -836.984)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101366"
//               data-name="Path 101366"
//               d="M1691.356,813.589a12.734,12.734,0,0,0,4.694,4.089,12.19,12.19,0,0,0,5.466.762c.326-.02.328-.53,0-.509a12.273,12.273,0,0,1-5-.611,11.7,11.7,0,0,1-4.719-3.987c-.2-.258-.638,0-.44.257h0Z"
//               transform="translate(-1682.294 -808.271)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101367"
//               data-name="Path 101367"
//               d="M1561.158,850.436c-.465,1.11,0,2.494,1.3,2.471.934-.016,1.871-.09,2.8-.132,3.481-.156,6.962-.308,10.442-.475,2.518-.12,5.085-.129,7.59-.431,1.161-.14,3.278-.956,3.488-2.361a4.36,4.36,0,0,0-.558-1.913,9.257,9.257,0,0,0-.8-1.885,2.956,2.956,0,0,0-4.034-1.306c-2.062,1.132-2.5,3.862-2.408,5.984.014.327.524.329.509,0-.086-1.919.251-4.523,2.156-5.544,1.7-.908,3.068.377,3.729,1.875.181.409.272.835.423,1.251.119.328.255.616.353.96.189.668-.047.969-.547,1.41a5.109,5.109,0,0,1-3.227,1.1c-5.128.357-10.273.525-15.408.755q-1.747.078-3.494.158a7.243,7.243,0,0,1-.951.047c-.951-.087-1.228-.984-.877-1.823.126-.3-.367-.434-.492-.135h0Z"
//               transform="translate(-1560.502 -837.065)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101368"
//               data-name="Path 101368"
//               d="M1739.483,797.867c.7-1.254,1.87-2.674,3.279-1.3.235.228.6-.132.36-.36a2.035,2.035,0,0,0-2.2-.611,3.973,3.973,0,0,0-1.877,2.019c-.159.287.281.544.44.257h0Z"
//               transform="translate(-1726.874 -791.678)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101369"
//               data-name="Path 101369"
//               d="M1764.926,811.075c.562-.948,1.851-2.761,3.115-1.588.24.223.6-.137.36-.36a1.877,1.877,0,0,0-2.025-.325,4.307,4.307,0,0,0-1.891,2.016.255.255,0,0,0,.44.257h0Z"
//               transform="translate(-1750.648 -803.991)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101370"
//               data-name="Path 101370"
//               d="M1787.571,821.34a5.072,5.072,0,0,1,2.173-2.192c.291-.153.033-.592-.257-.44a5.536,5.536,0,0,0-2.355,2.374c-.15.291.289.549.44.257Z"
//               transform="translate(-1771.817 -813.366)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101371"
//               data-name="Path 101371"
//               d="M1820.094,819.173c.355.7,1.212.818,1.906,1,.981.259,1.972.483,2.945.774a.255.255,0,0,0,.135-.492c-.716-.214-1.443-.39-2.168-.575-.667-.169-2.036-.3-2.377-.966-.149-.292-.589-.035-.44.257h0Z"
//               transform="translate(-1802.624 -813.469)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101372"
//               data-name="Path 101372"
//               d="M1567.368,910.219c5.1-.12,10.2.17,15.293.006a33.277,33.277,0,0,0,6.133-.613,4.994,4.994,0,0,0,3.221-1.686c.182-.274-.259-.53-.44-.257-.734,1.107-2.452,1.386-3.655,1.6a41.931,41.931,0,0,1-6.443.479c-4.7.087-9.406-.146-14.108-.035a.255.255,0,0,0,0,.509h0Z"
//               transform="translate(-1566.24 -896.424)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101373"
//               data-name="Path 101373"
//               d="M1723.286,870.921a16.4,16.4,0,0,0-1.86,4.264l.313-.178-.02-.006.153.374.012-.027-.466-.061.032.082c.118.3.611.17.491-.135l-.032-.082c-.069-.176-.369-.285-.465-.061l-.012.028a.26.26,0,0,0,.153.374l.02.006a.259.259,0,0,0,.314-.178,15.938,15.938,0,0,1,1.809-4.142c.173-.28-.268-.536-.44-.257h0Z"
//               transform="translate(-1710.423 -862.078)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101374"
//               data-name="Path 101374"
//               d="M1767.4,884.515a11.158,11.158,0,0,0-1.3,3.481c-.062.32.429.458.492.135a10.756,10.756,0,0,1,1.249-3.359.255.255,0,0,0-.44-.257Z"
//               transform="translate(-1752.189 -874.779)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101375"
//               data-name="Path 101375"
//               d="M1562.09,836.833a2.733,2.733,0,0,0,1.736.408c.941,0,1.882,0,2.823,0a.255.255,0,0,0,0-.509l-2.159,0a3.5,3.5,0,0,1-2.143-.34c-.265-.194-.519.248-.257.44h0Z"
//               transform="translate(-1561.433 -829.878)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101376"
//               data-name="Path 101376"
//               d="M1654.672,841.146a19.674,19.674,0,0,0,3.967-.226c.323-.051.186-.542-.135-.492a19,19,0,0,1-3.832.208c-.328-.015-.327.495,0,.509h0Z"
//               transform="translate(-1647.828 -833.69)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101377"
//               data-name="Path 101377"
//               d="M1593.9,790.738a14.749,14.749,0,0,1,7.094-1.018c.326.033.323-.477,0-.509a15.056,15.056,0,0,0-7.23,1.036c-.3.122-.169.615.135.492h0Z"
//               transform="translate(-1590.975 -785.756)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101378"
//               data-name="Path 101378"
//               d="M1729.674,921.505l1.028,1.042c.16.163.411-.088.251-.251l-1.028-1.042c-.16-.163-.411.088-.251.251Z"
//               transform="translate(-1718.102 -909.18)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101379"
//               data-name="Path 101379"
//               d="M1735.517,906.4q.953,1,1.99,1.911c.171.15.422-.1.251-.251q-1.038-.911-1.99-1.911c-.158-.166-.408.085-.251.251Z"
//               transform="translate(-1723.565 -895.058)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101380"
//               data-name="Path 101380"
//               d="M1742.589,890.072a11.562,11.562,0,0,0,1.692,1.776c.173.147.426-.1.251-.251a11.168,11.168,0,0,1-1.637-1.7c-.137-.178-.445,0-.306.179h0Z"
//               transform="translate(-1730.186 -879.85)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101381"
//               data-name="Path 101381"
//               d="M1752.287,880.155a22.345,22.345,0,0,1,1.744,1.673c.156.167.406-.084.251-.251a22.366,22.366,0,0,0-1.744-1.673c-.172-.148-.424.1-.251.251Z"
//               transform="translate(-1739.228 -870.543)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101382"
//             data-name="Path 101382"
//             d="M1306.628,886.7l1.108-1.44c.2-.26-.243-.514-.44-.257l-1.108,1.44c-.2.26.243.514.44.257Z"
//             transform="translate(-1187.916 -820.38)"
//             fill="#fff"
//           />
//           <path
//             id="Path_101383"
//             data-name="Path 101383"
//             d="M1342.2,866.419l.111-.111a.255.255,0,0,0-.36-.36l-.111.111a.255.255,0,0,0,.36.36Z"
//             transform="translate(-1221.211 -802.599)"
//             fill="#fff"
//           />
//           <g
//             id="Group_106505"
//             data-name="Group 106505"
//             transform="translate(103.462 50.093)"
//           >
//             <path
//               id="Path_101384"
//               data-name="Path 101384"
//               d="M1106.305,716.57a6.185,6.185,0,0,0,5.835-1.975,4.456,4.456,0,0,0,1.225-2.811c-.012-.63-.51-.873-1.043-1.185a4.089,4.089,0,0,0-5.686,1.3,6.218,6.218,0,0,0-.508,4.492c.077.319.568.184.492-.135a6.349,6.349,0,0,1,.018-3.028,3.589,3.589,0,0,1,5.238-2.3c.327.174.934.48,1.017.8.213.816-.78,2.171-1.293,2.7a5.66,5.66,0,0,1-5.157,1.65c-.319-.076-.455.415-.135.492Z"
//               transform="translate(-1104.277 -706.998)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101385"
//               data-name="Path 101385"
//               d="M1082.42,672.919c-.832,1-2.039,2.64-1.68,4.023.633,2.438,4.957,1.049,6.359.325,3.363-1.735,4.961-4.845,6.436-8.165.6-1.351,1.746-4.645-.921-4.577-1.934.049-3.947,1.787-5.331,3.005-.247.217.115.576.36.36,1.273-1.119,2.965-2.543,4.683-2.822,1.87-.3,1.585,1.68,1.163,2.823a28.435,28.435,0,0,1-2.325,4.906c-1.691,2.76-5.368,5.635-8.831,4.859-2.327-.522-.45-3.306.446-4.379.209-.25-.15-.612-.36-.36h0Z"
//               transform="translate(-1080.675 -664.524)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101386"
//               data-name="Path 101386"
//               d="M1082.988,679.386c.255,3.538,4.538,4.432,7.366,3.735,4.675-1.152,5.16-6.1,6.739-9.832a7.057,7.057,0,0,0,.816-3.492,3.887,3.887,0,0,0-2.247-2.834.255.255,0,0,0-.257.44,3.243,3.243,0,0,1,1.843,3.991c-.315,1.2-.941,2.292-1.339,3.466-.678,2-1.058,4.071-2.459,5.745a6.791,6.791,0,0,1-7.787,1.716,3.753,3.753,0,0,1-2.165-2.933c-.024-.325-.533-.328-.509,0h0Z"
//               transform="translate(-1082.837 -666.77)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101387"
//               data-name="Path 101387"
//               d="M1129.677,737.867a1.911,1.911,0,0,0-.452,1.69c.066.321.557.185.492-.135a1.365,1.365,0,0,1,.321-1.195c.217-.244-.142-.606-.36-.36h0Z"
//               transform="translate(-1126.007 -732.989)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101388"
//               data-name="Path 101388"
//               d="M1133.1,778.789a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
//               transform="translate(-1129.439 -770.833)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101389"
//               data-name="Path 101389"
//               d="M1156.171,889.448a2.408,2.408,0,0,0,1.182.1c.225-.035.13-.376-.094-.342a2.042,2.042,0,0,1-.993-.1c-.216-.075-.309.267-.094.342Z"
//               transform="translate(-1151.115 -874.395)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101390"
//               data-name="Path 101390"
//               d="M1194.973,884.195l.6-.126c.223-.047.129-.389-.094-.342l-.6.126c-.223.047-.129.389.094.342Z"
//               transform="translate(-1187.284 -869.373)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101391"
//               data-name="Path 101391"
//               d="M1185.714,871.114l.6-.121c.223-.045.129-.387-.094-.342l-.6.121c-.223.045-.129.387.094.342Z"
//               transform="translate(-1178.63 -857.154)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106506"
//             data-name="Group 106506"
//             transform="translate(54.874 52.614)"
//           >
//             <path
//               id="Path_101392"
//               data-name="Path 101392"
//               d="M340.09,714.814c-.709,1.217-.713,2.807.657,3.533a2.741,2.741,0,0,0,4-2.476l-.384.22c.943.57,2.315.954,3.277.232a2.156,2.156,0,0,0,.556-2.672l-.4.309c1.154,1.24,2.645.468,2.758-1.11l-.5.067a2.264,2.264,0,0,0,2.585,1.659,2.059,2.059,0,0,0,1.623-2.724l-.426.248c1.6,1.4,3.479.238,3.786-1.731.29-1.855-1.25-2.826-2.91-2.886l.22.384c.889-2.072-1.559-3.246-2.763-1.419l.475.128c.118-4-5.653-4.875-7-1.229h.492a1.264,1.264,0,0,0-1.682-.729,2.031,2.031,0,0,0-1.374,2.19l.384-.22c-1.442-1.019-3.4-1.248-4.422.468a4.1,4.1,0,0,0,1.093,5.043l.248-.426c-2.509-.407-2.664,3.9,0,3.511.323-.048.186-.539-.135-.492-1.843.271-1.686-2.8,0-2.529.229.037.454-.238.248-.426a3.635,3.635,0,0,1-1.111-4.247c.817-1.633,2.542-1.368,3.822-.464a.256.256,0,0,0,.384-.22,1.581,1.581,0,0,1,.732-1.585c.418-.229,1.149-.318,1.323.259a.257.257,0,0,0,.492,0c1.159-3.128,6.1-2.308,6,1.094a.257.257,0,0,0,.475.128c.807-1.225,2.534-.613,1.883.9a.259.259,0,0,0,.22.384c1.126.04,2.281.479,2.419,1.741.175,1.606-1.455,3.3-2.935,2.006-.171-.149-.529-.009-.426.248a1.567,1.567,0,0,1-1.267,2.1,1.756,1.756,0,0,1-1.958-1.3.256.256,0,0,0-.5.067c-.083,1.144-1.093,1.6-1.888.749-.209-.225-.516.06-.4.309a1.574,1.574,0,0,1-1.274,2.3,3.467,3.467,0,0,1-1.862-.556.258.258,0,0,0-.384.22c-.094,1.822-2.493,3.372-3.837,1.542a2.2,2.2,0,0,1,.131-2.342.255.255,0,0,0-.44-.257Z"
//               transform="translate(-338.437 -703.044)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101393"
//               data-name="Path 101393"
//               d="M406.736,796.231c-.044-.242-.107-.488-.134-.733a1.3,1.3,0,0,1,.587-1.22,1.194,1.194,0,0,1,1.881.666c.116.3.609.172.492-.135a1.76,1.76,0,0,0-2.3-1.191,2.383,2.383,0,0,0-1.079,1.087,2.743,2.743,0,0,0,.059,1.661c.059.322.55.186.492-.135h0Z"
//               transform="translate(-401.642 -787.562)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101394"
//               data-name="Path 101394"
//               d="M451.389,795.986a1.284,1.284,0,0,1,.694-.789c.4-.176.965-.055.9.48-.04.325.47.322.509,0a1.01,1.01,0,0,0-1.142-1.072,1.754,1.754,0,0,0-1.452,1.246c-.106.311.386.444.492.135h0Z"
//               transform="translate(-443.522 -788.608)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101395"
//               data-name="Path 101395"
//               d="M599.514,790.561a.6.6,0,0,1,.019.763c-.192.267.25.522.44.257a1.107,1.107,0,0,0-.1-1.38c-.22-.244-.579.117-.36.36Z"
//               transform="translate(-582.36 -784.419)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101396"
//               data-name="Path 101396"
//               d="M593.3,821.989h.058a.255.255,0,0,0,0-.509H593.3a.255.255,0,0,0,0,.509Z"
//               transform="translate(-576.391 -813.727)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101397"
//               data-name="Path 101397"
//               d="M426.219,872.761a65.027,65.027,0,0,1,4.179,4.994.261.261,0,0,0,.288.117l4.7-1.95a.268.268,0,0,0,.187-.245q.077-2.943.172-5.885c.01-.328-.5-.327-.509,0q-.069,2.1-.128,4.2c-.022.812.116,1.358-.642,1.761-.676.359-1.449.6-2.156.894-.6.247-1.305.774-1.849.357a8.142,8.142,0,0,1-1.057-1.345c-.905-1.12-1.852-2.2-2.829-3.261-.223-.242-.583.12-.36.36h0Z"
//               transform="translate(-420.408 -858.647)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101398"
//               data-name="Path 101398"
//               d="M469.158,876.2a19.616,19.616,0,0,0,1.773,2.115.257.257,0,0,0,.435-.18l-.249-3.939c-.02-.326-.53-.328-.509,0l.249,3.939.435-.18a18.6,18.6,0,0,1-1.694-2.012c-.191-.263-.633-.008-.44.257h0Z"
//               transform="translate(-460.556 -862.766)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101399"
//               data-name="Path 101399"
//               d="M505.012,869.844l1.682,3.228a.257.257,0,0,0,.475-.128,22.814,22.814,0,0,1,.2-2.988c.043-.321-.448-.46-.492-.136a23.977,23.977,0,0,0-.218,3.124l.475-.128-1.682-3.228c-.152-.291-.592-.033-.44.257h0Z"
//               transform="translate(-494.078 -858.566)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101400"
//               data-name="Path 101400"
//               d="M439.95,901.77a4.942,4.942,0,0,0-.458,1.417c-.036.223.306.319.342.094a4.637,4.637,0,0,1,.423-1.333c.1-.2-.2-.384-.306-.179h0Z"
//               transform="translate(-432.874 -888.677)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101401"
//               data-name="Path 101401"
//               d="M454.091,905.365a5.2,5.2,0,0,0-.475,1.934c-.011.228.343.227.354,0a4.734,4.734,0,0,1,.426-1.755c.094-.206-.211-.386-.306-.179h0Z"
//               transform="translate(-446.076 -892.036)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101402"
//               data-name="Path 101402"
//               d="M464.775,908.78q-.318,1.169-.636,2.34a.177.177,0,0,0,.342.094q.318-1.169.636-2.34a.177.177,0,0,0-.342-.094Z"
//               transform="translate(-455.904 -895.195)"
//               fill="#414042"
//             />
//           </g>
//           <path
//             id="Path_101403"
//             data-name="Path 101403"
//             d="M558,387.342a25.73,25.73,0,0,0,3.549.188.177.177,0,0,0,0-.354,25.725,25.725,0,0,1-3.549-.188c-.226-.027-.224.327,0,.355h0Z"
//             transform="translate(-488.598 -355.062)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101404"
//             data-name="Path 101404"
//             d="M634.187,389.287l6.536-.012a.177.177,0,0,0,0-.354l-6.536.012a.178.178,0,0,0,0,.355h0Z"
//             transform="translate(-559.794 -356.869)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101405"
//             data-name="Path 101405"
//             d="M576.286,270.335a2.882,2.882,0,0,0-.528,1.3c-.045.321.445.46.492.136a2.552,2.552,0,0,1,.477-1.177c.194-.265-.248-.52-.44-.257h0Z"
//             transform="translate(-505.346 -245.944)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101406"
//             data-name="Path 101406"
//             d="M575.571,319.809a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
//             transform="translate(-504.944 -291.806)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101407"
//             data-name="Path 101407"
//             d="M791.124,159.986l-.5,1.867a.177.177,0,0,0,.342.094l.5-1.867a.177.177,0,0,0-.342-.094Z"
//             transform="translate(-706.14 -142.804)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101408"
//             data-name="Path 101408"
//             d="M798.563,154.61q-.485,1.594-.969,3.187c-.058.189.235.319.324.137l.14-.289c.1-.2-.206-.384-.306-.179l-.14.289.324.137q.485-1.594.969-3.187c.067-.219-.276-.312-.342-.094h0Z"
//             transform="translate(-712.656 -137.781)"
//             fill="#414042"
//           />
//           <path
//             id="Path_101409"
//             data-name="Path 101409"
//             d="M805.711,146.2l-.831,2.237-.356.958c-.081.219-.288,1.171-.492,1.271l.242.063-.025-.051-.063.242.037-.019c.2-.105.024-.411-.179-.306l-.037.019a.18.18,0,0,0-.063.242l.025.052a.18.18,0,0,0,.242.063c.414-.2.57-1.254.715-1.643l1.128-3.035c.08-.214-.263-.306-.342-.094h0Z"
//             transform="translate(-718.576 -129.921)"
//             fill="#414042"
//           />
//           <g
//             id="Group_106507"
//             data-name="Group 106507"
//             transform="translate(37.616 17.296)"
//           >
//             <path
//               id="Path_101410"
//               data-name="Path 101410"
//               d="M117.3,221.815c-.85-1.235-2.792-.095-2.994,1.106a4.889,4.889,0,0,0,.471,2.173c.363,1.094.764,2.176,1.213,3.238.466,1.1,1.1,3.266,2.58,3.31a2.008,2.008,0,0,0,1.828-1,2.859,2.859,0,0,0-.309-2.448c-.866-2.141-1.727-4.326-2.789-6.379-.151-.291-.59-.034-.44.257.81,1.566,1.472,3.224,2.155,4.849a20.836,20.836,0,0,1,.939,2.313,1.306,1.306,0,0,1-.756,1.787,1.19,1.19,0,0,1-1.284-.162,6.31,6.31,0,0,1-1.15-2.018c-.426-.933-.8-1.893-1.142-2.857a19.265,19.265,0,0,1-.7-2.139,1.506,1.506,0,0,1,.238-1.513c.361-.387,1.3-.839,1.7-.258.185.268.626.014.44-.257Z"
//               transform="translate(-111.703 -217.501)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101411"
//               data-name="Path 101411"
//               d="M91.824,255.637a2.414,2.414,0,0,0-1.694,1.28c-.315.856.287,1.928.638,2.68a9.328,9.328,0,0,0,1.65,2.793,1.864,1.864,0,0,0,2.2-.044c.288-.157.031-.6-.257-.44a1.307,1.307,0,0,1-1.939-.353,15.724,15.724,0,0,1-1.1-1.97,5.8,5.8,0,0,1-.75-2.037c-.037-.8.7-1.231,1.386-1.417a.255.255,0,0,0-.136-.492h0Z"
//               transform="translate(-89.045 -249.597)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101412"
//               data-name="Path 101412"
//               d="M76.168,291.024a2.106,2.106,0,0,0-1.235.939,2.542,2.542,0,0,0,.283,2.022c.208.476.568,1.383,1.148,1.522.532.128,1.24-.4,1.636-.688.264-.19.01-.632-.257-.44a3.036,3.036,0,0,1-.969.562c-.575.117-.823-.574-1.032-1.022-.247-.53-.661-1.379-.232-1.906a1.778,1.778,0,0,1,.793-.5c.31-.1.177-.6-.136-.492h0Z"
//               transform="translate(-74.807 -282.665)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101413"
//               data-name="Path 101413"
//               d="M327.951,165.124c.581,1.887,1.027,3.815,1.607,5.7a15.375,15.375,0,0,0,.957,2.665c.3.568.553.631,1.2.548.824-.105,2.08-.456,2.45-1.3a3.42,3.42,0,0,0-.18-2,25.224,25.224,0,0,0-2.126-6.407,1.719,1.719,0,0,0-2.023-.772c-.788.126-2.048.555-1.884,1.56.053.323.544.186.492-.136-.111-.681,1.362-.939,1.807-.959a1.074,1.074,0,0,1,1.169.564,14.786,14.786,0,0,1,1.082,2.794c.342,1.055.653,2.122.92,3.2.241.965.673,1.966-.425,2.546-.321.17-1.425.638-1.8.436-.215-.117-.322-.495-.413-.713a27.51,27.51,0,0,1-.9-2.719c-.508-1.707-.914-3.445-1.439-5.147-.1-.312-.589-.179-.492.135Z"
//               transform="translate(-311.367 -163.514)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101414"
//               data-name="Path 101414"
//               d="M381.769,164.711c.917-.543,2.074-.674,2.677.372a10.8,10.8,0,0,1,.981,2.827,7.411,7.411,0,0,1,.394,2.446c-.109.816-1.157,1.218-1.854,1.445-.31.1-.177.594.135.492.751-.245,1.855-.676,2.156-1.481.345-.926-.173-2.4-.4-3.294-.272-1.058-.59-2.561-1.447-3.326a2.5,2.5,0,0,0-2.9.079.255.255,0,0,0,.257.44Z"
//               transform="translate(-361.32 -163.742)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101415"
//               data-name="Path 101415"
//               d="M432.391,183.637a1.307,1.307,0,0,1,2.092,1,1.542,1.542,0,0,1-1.338,1.9c-.323.05-.186.541.135.492a2.068,2.068,0,0,0,1.65-2.714,1.779,1.779,0,0,0-2.8-1.113.255.255,0,0,0,.257.44Z"
//               transform="translate(-408.628 -181.602)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101416"
//               data-name="Path 101416"
//               d="M173.972,225.392l10.806-3.285c.313-.095.179-.587-.136-.492L173.836,224.9c-.313.095-.179.587.135.492Z"
//               transform="translate(-167.187 -217.8)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101417"
//               data-name="Path 101417"
//               d="M186.355,253.684l10.518-3.121a.255.255,0,0,0-.136-.492l-10.518,3.121a.255.255,0,0,0,.136.492Z"
//               transform="translate(-178.76 -244.395)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101418"
//               data-name="Path 101418"
//               d="M346.689,175.17l1.217,3.154c.081.211.424.119.342-.094l-1.217-3.154c-.081-.211-.424-.119-.342.094Z"
//               transform="translate(-328.879 -174.208)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101419"
//               data-name="Path 101419"
//               d="M375.375,250.2l1.042,4.193a.177.177,0,0,0,.342-.094l-1.042-4.193a.177.177,0,0,0-.342.094Z"
//               transform="translate(-355.693 -244.32)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101420"
//               data-name="Path 101420"
//               d="M134.731,232.847l1.355,3.674c.079.212.421.12.342-.094l-1.355-3.674c-.079-.212-.421-.12-.342.094Z"
//               transform="translate(-130.798 -228.108)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101421"
//               data-name="Path 101421"
//               d="M170.707,314.925a21.727,21.727,0,0,0,1.458,2.79c.12.194.427.016.306-.179a21.727,21.727,0,0,1-1.458-2.79c-.09-.209-.4-.028-.306.179Z"
//               transform="translate(-164.414 -304.759)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101422"
//               data-name="Path 101422"
//               d="M189.734,267.321a10.112,10.112,0,0,0-.164,1.715.177.177,0,0,0,.354,0,9.481,9.481,0,0,1,.151-1.621c.041-.223-.3-.319-.342-.094Z"
//               transform="translate(-182.057 -260.406)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101423"
//               data-name="Path 101423"
//               d="M199.628,264.089a12.938,12.938,0,0,0-.293,2.139c-.012.228.342.227.354,0a12.374,12.374,0,0,1,.28-2.044c.05-.222-.292-.317-.342-.094Z"
//               transform="translate(-191.184 -257.386)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101424"
//               data-name="Path 101424"
//               d="M213.326,261.489q-.225.973-.45,1.946c-.051.222.29.317.342.094q.225-.973.45-1.945c.051-.222-.29-.317-.342-.094Z"
//               transform="translate(-203.833 -254.956)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101425"
//               data-name="Path 101425"
//               d="M229.589,258.68a6.736,6.736,0,0,0-.507,1.928c-.025.227.33.225.354,0a6.162,6.162,0,0,1,.458-1.749c.088-.208-.217-.388-.306-.179h0Z"
//               transform="translate(-218.982 -252.363)"
//               fill="#414042"
//             />
//           </g>
//           <g
//             id="Group_106508"
//             data-name="Group 106508"
//             transform="translate(35.011 35.217)"
//           >
//             <path
//               id="Path_101426"
//               data-name="Path 101426"
//               d="M198.228,446.472a2.144,2.144,0,0,0-1.211-1.115c-.624-.3-1.422-.305-1.955-.763-.758-.653-.482-1.782.637-1.574.221.041.467-.251.248-.426-1.283-1.027-2.285-3.908-.227-4.688,2.162-.82,3.1,1.765,3.345,3.385a.256.256,0,0,0,.314.178c.666-.237,1.824-.276,1.927.658.073.662-.8,1.548-1.18,1.982a21.035,21.035,0,0,1-2.325,2.251c-.252.211.111.57.36.36a12.411,12.411,0,0,0,3.439-3.82c.759-1.639-.975-2.415-2.358-1.923l.314.178a5.3,5.3,0,0,0-1.359-3.219,2.788,2.788,0,0,0-2.8-.454c-2.249,1.015-1.337,4.249.191,5.471l.248-.426c-1.1-.2-2.076.569-1.629,1.741.581,1.523,3.1.909,3.531,2.339a.255.255,0,0,0,.492-.136Z"
//               transform="translate(-183.634 -437.281)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101427"
//               data-name="Path 101427"
//               d="M277.87,514.242a3.669,3.669,0,0,1,.187-1.1c.346-1.052,1.089-1.267,2.069-1.572a5.344,5.344,0,0,0,1.613-.8c.385-.28.7-.667,1.191-.709.734-.063,1.171.641,1.352,1.291a3.045,3.045,0,0,1-.044,1.708.861.861,0,0,1-1.081.725,1.67,1.67,0,0,0-1.15.081c-.454.219-.934.689-1.449.748a3.934,3.934,0,0,1-1.772-.5,2.161,2.161,0,0,0-1.237-.119.255.255,0,0,0,.135.492c1.045-.287,1.892.891,3.009.624a7.245,7.245,0,0,0,1.438-.727c.656-.321.778-.007,1.366.039,1.861.144,1.506-3.3.77-4.233a1.523,1.523,0,0,0-1.673-.634,7.58,7.58,0,0,0-1.438,1.009,5.447,5.447,0,0,1-1.427.593,2.965,2.965,0,0,0-2.368,3.083.255.255,0,0,0,.509,0Z"
//               transform="translate(-261.495 -504.762)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101428"
//               data-name="Path 101428"
//               d="M243.608,493.865a35.023,35.023,0,0,1,.425,6.474.255.255,0,0,0,.509,0,35.739,35.739,0,0,0-.443-6.609c-.052-.323-.543-.186-.492.135h0Z"
//               transform="translate(-229.948 -489.862)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101429"
//               data-name="Path 101429"
//               d="M249.692,541.352a24.339,24.339,0,0,1,6.961-3.78c.308-.107.175-.6-.136-.492a25.1,25.1,0,0,0-7.186,3.912c-.259.2.1.559.36.36h0Z"
//               transform="translate(-235.218 -530.533)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101430"
//               data-name="Path 101430"
//               d="M131.028,576.515a5.34,5.34,0,0,0-8.268,1.4c-2.093,4.207,2.485,8.341,1.86,12.671-.033.228.235.456.426.248a15.957,15.957,0,0,1,5.544-3.81c1.963-.849,4.209-1.966,5.063-4.071,1.383-3.406-1.6-6.034-4.737-6.5-.321-.048-.459.443-.135.492a7.212,7.212,0,0,1,3,1.17,3.932,3.932,0,0,1,.532,5.988c-1.527,1.663-3.72,2.2-5.638,3.238a15.577,15.577,0,0,0-3.991,3.135l.426.248a9.606,9.606,0,0,0-.431-3.831c-.6-2.215-2.02-4.434-1.942-6.774a4.75,4.75,0,0,1,7.928-3.24c.235.229.6-.131.36-.36Z"
//               transform="translate(-116.5 -566.107)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101431"
//               data-name="Path 101431"
//               d="M74.515,453.934a2.752,2.752,0,0,0,1.581-1.965l-.492-.135a1.718,1.718,0,0,0,1.4,2.124l-.061-.465a3.056,3.056,0,0,0-1.546,2.582h.509c-.113-.953-.055-2.12-1.082-2.543-.3-.125-.435.368-.136.492.443.183.567.911.618,1.3.033.251.06.5.09.757a.255.255,0,0,0,.509,0,2.529,2.529,0,0,1,1.294-2.142c.172-.1.166-.432-.061-.465a1.207,1.207,0,0,1-1.045-1.5c.046-.316-.418-.463-.492-.135a2.279,2.279,0,0,1-1.347,1.661c-.3.137-.039.576.257.44h0Z"
//               transform="translate(-71.564 -450.71)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101432"
//               data-name="Path 101432"
//               d="M35.193,591.886c.845.19,1.411-.674,1.71-1.344.111-.249-.183-.531-.4-.309-.615.628.733,2.531,1.415,1.807a.255.255,0,0,0-.36-.36c-.583.5-1.584,1.477-1.43,2.325.052.282.514.217.5-.067a3.7,3.7,0,0,0-1.069-2.472c-.229-.236-.589.125-.36.36a3.173,3.173,0,0,1,.92,2.112l.5-.067c-.054-.3.388-.841.545-1.048a4.975,4.975,0,0,1,.753-.781l-.36-.36c-.081.086-.9-.875-.7-1.086l-.4-.309c-.181.408-.578,1.235-1.134,1.11-.319-.072-.456.419-.136.492h0Z"
//               transform="translate(-35.011 -580.145)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101433"
//               data-name="Path 101433"
//               d="M140.746,603.626a5.63,5.63,0,0,0,2.354,1.318.255.255,0,0,0,.136-.492,5.071,5.071,0,0,1-2.129-1.187c-.24-.223-.6.136-.36.36h0Z"
//               transform="translate(-133.75 -592.334)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101434"
//               data-name="Path 101434"
//               d="M220.057,640.224a19.871,19.871,0,0,0,6.934,1.765c.327.023.326-.487,0-.509a19.147,19.147,0,0,1-6.677-1.7c-.3-.135-.555.3-.257.44Z"
//               transform="translate(-207.82 -626.504)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101435"
//               data-name="Path 101435"
//               d="M124.109,657.148c1.557,1.529,3.67,1.987,5.617,2.821.3.128.558-.311.257-.44-1.9-.812-4-1.253-5.514-2.741-.234-.23-.6.13-.36.36h0Z"
//               transform="translate(-118.205 -642.349)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101436"
//               data-name="Path 101436"
//               d="M238.03,710.446a13.938,13.938,0,0,0,3.608.751c.327.025.325-.485,0-.509a13.444,13.444,0,0,1-3.473-.733c-.31-.109-.443.383-.136.492h0Z"
//               transform="translate(-224.577 -692.091)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101437"
//               data-name="Path 101437"
//               d="M144.076,724.679a5.021,5.021,0,0,0,1.851,1.063c.313.1.447-.391.136-.492a4.416,4.416,0,0,1-1.625-.932c-.243-.219-.6.14-.36.36h0Z"
//               transform="translate(-136.861 -705.464)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101438"
//               data-name="Path 101438"
//               d="M211.131,466.08a1.279,1.279,0,0,0,.106,1.575c.216.247.575-.114.36-.36a.768.768,0,0,1-.026-.958c.189-.269-.253-.524-.44-.257Z"
//               transform="translate(-199.393 -464.089)"
//               fill="#414042"
//             />
//             <path
//               id="Path_101439"
//               data-name="Path 101439"
//               d="M222.049,497.466v-.111a.255.255,0,0,0-.509,0v.111a.255.255,0,0,0,.509,0Z"
//               transform="translate(-209.329 -493.192)"
//               fill="#414042"
//             />
//           </g>
//         </g>
//       </g>
//     </SvgIcon>
//   );
// }

export function ExpertProfileBannerImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 126,
    height: 120,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 126 120"
      {...rest}
      sx={rootSx}
    >
      <defs>
        <clipPath id="clip-path">
          <path
            id="Rectangle_56261"
            data-name="Rectangle 56261"
            d="M60,0h58.615A7.385,7.385,0,0,1,126,7.385V112.615A7.385,7.385,0,0,1,118.615,120H60A60,60,0,0,1,0,60v0A60,60,0,0,1,60,0Z"
            transform="translate(2196 14115)"
            fill="#fff"
            stroke="#707070"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g
        id="Mask_Group_43"
        data-name="Mask Group 43"
        transform="translate(-2196 -14115)"
        opacity="0.5"
        clipPath="url(#clip-path)"
      >
        <g
          id="Group_106509"
          data-name="Group 106509"
          transform="translate(2161 14108)"
        >
          <path
            id="Path_101059"
            data-name="Path 101059"
            d="M321.407,1075.865c.407,2.851,4.431,2.437,12.407,2.215s12.185,0,12.628-2.658-3.323-5.982-12.407-5.982-13.071,3.323-12.628,6.425Z"
            transform="translate(-267.617 -992.841)"
            fill="#7a67d9"
          />
          <path
            id="Path_101060"
            data-name="Path 101060"
            d="M388.432,1121.781l.361,2.66c.044.323.535.186.492-.135l-.361-2.66c-.044-.323-.535-.186-.492.135Z"
            transform="translate(-330.283 -1041.456)"
            fill="#fff"
          />
          <path
            id="Path_101061"
            data-name="Path 101061"
            d="M387.83,1120.324a12.859,12.859,0,0,1,2.146-.578c.322-.058.186-.549-.135-.492a12.882,12.882,0,0,0-2.146.578c-.306.111-.173.6.136.492Z"
            transform="translate(-329.435 -1039.39)"
            fill="#fff"
          />
          <path
            id="Path_101062"
            data-name="Path 101062"
            d="M390,1137.7l1.694-.461a.255.255,0,0,0-.136-.492l-1.693.461a.255.255,0,0,0,.135.492Z"
            transform="translate(-331.457 -1055.73)"
            fill="#fff"
          />
          <path
            id="Path_101063"
            data-name="Path 101063"
            d="M446.139,1116.986a4.169,4.169,0,0,0-.433,2.5.665.665,0,0,0,1.119.444c1.059-.746,1.019-3.171-.594-3.108-.327.013-.329.522,0,.509.6-.023.823.542.81,1.053-.009.323-.136.918-.454,1.089-.547.293-.42-.679-.388-.967a3.931,3.931,0,0,1,.38-1.265c.142-.294-.3-.552-.44-.257h0Z"
            transform="translate(-383.765 -1037.12)"
            fill="#fff"
          />
          <path
            id="Path_101064"
            data-name="Path 101064"
            d="M446.93,1116.413a.921.921,0,0,0,.229,1.479c.746.4,1.517-.12,2.09-.572.257-.2-.105-.561-.36-.36a1.9,1.9,0,0,1-1.182.56c-.366-.018-.785-.424-.416-.747.247-.216-.115-.575-.36-.36h0Z"
            transform="translate(-384.691 -1036.676)"
            fill="#fff"
          />
          <path
            id="Path_101065"
            data-name="Path 101065"
            d="M508.719,1112.3a10.294,10.294,0,0,0-.609,1.288,3.287,3.287,0,0,0-.351,1.291.716.716,0,0,0,1.1.507c1.156-.593,1.546-2.661.208-3.251-.3-.131-.557.308-.257.44a1,1,0,0,1,.61.962,1.711,1.711,0,0,1-.574,1.208c-.837.447-.376-.671-.281-.922a9.357,9.357,0,0,1,.6-1.264c.16-.287-.28-.544-.44-.257h0Z"
            transform="translate(-441.799 -1032.719)"
            fill="#fff"
          />
          <path
            id="Path_101066"
            data-name="Path 101066"
            d="M515.55,1112.424a.837.837,0,0,0-.661,1.205c.421.736,1.377.259,2.007.335.325.039.322-.471,0-.509-.4-.048-.78.119-1.179.093-.155-.01-.351-.055-.4-.221a.326.326,0,0,1,.234-.392c.321-.041.325-.551,0-.509h0Z"
            transform="translate(-448.37 -1033.01)"
            fill="#fff"
          />
          <path
            id="Path_101067"
            data-name="Path 101067"
            d="M563.04,1115.988q-.485,1.322-1.082,2.595c-.139.3.3.554.44.257q.625-1.333,1.133-2.717c.113-.308-.379-.441-.492-.135h0Z"
            transform="translate(-492.427 -1036.179)"
            fill="#fff"
          />
          <path
            id="Path_101068"
            data-name="Path 101068"
            d="M560.521,1114.344c.651.244,1.143.951.549,1.543a2.87,2.87,0,0,1-1.747.708c-.324.03-.327.539,0,.509a2.872,2.872,0,0,0,2.474-1.388c.323-.84-.412-1.591-1.142-1.864-.308-.115-.441.377-.135.492h0Z"
            transform="translate(-489.762 -1034.329)"
            fill="#fff"
          />
          <path
            id="Path_101069"
            data-name="Path 101069"
            d="M634.738,1134.25a1.462,1.462,0,0,1-1.253,1.28c-.323.05-.186.541.135.492a1.968,1.968,0,0,0,1.627-1.772c.031-.326-.479-.324-.509,0h0Z"
            transform="translate(-559.125 -1053.18)"
            fill="#fff"
          />
          <path
            id="Path_101070"
            data-name="Path 101070"
            d="M613.509,1162.459v-.074a.255.255,0,0,0-.509,0v.074a.255.255,0,0,0,.509,0Z"
            transform="translate(-540.153 -1079.471)"
            fill="#fff"
          />
          <path
            id="Path_101071"
            data-name="Path 101071"
            d="M659.118,1646.253a2.507,2.507,0,0,0-2.677,1.989c-.22,2.021,2.075,3.6,3.873,3.689a4.314,4.314,0,0,0,4.266-3.848c.221-1.586-.378-3.712-2.19-4.021a3.206,3.206,0,0,0-3.517,2.379.255.255,0,0,0,.492.135,2.661,2.661,0,0,1,3.189-1.959c1.963.623,1.816,3.575.973,4.988a3.626,3.626,0,0,1-6.074.244c-1.124-1.533-.079-3.062,1.667-3.084a.255.255,0,0,0,0-.509Z"
            transform="translate(-580.736 -1529.808)"
            fill="#414042"
          />
          <path
            id="Path_101072"
            data-name="Path 101072"
            d="M669.685,1650.715a3.536,3.536,0,0,1,1.4,1.462c.151.291.591.034.44-.257a4.023,4.023,0,0,0-1.586-1.645.255.255,0,0,0-.257.44Z"
            transform="translate(-593.011 -1535.62)"
            fill="#414042"
          />
          <path
            id="Path_101073"
            data-name="Path 101073"
            d="M690.656,1619.627a3.045,3.045,0,0,1,.845-3.35l-.426-.113a2.9,2.9,0,0,1-.869,3.243c-.25.213.112.572.36.36a3.394,3.394,0,0,0,1-3.739.259.259,0,0,0-.426-.113,3.546,3.546,0,0,0-.977,3.846c.11.306.6.174.492-.136h0Z"
            transform="translate(-612.069 -1503.476)"
            fill="#414042"
          />
          <path
            id="Path_101074"
            data-name="Path 101074"
            d="M682.774,1706.063a1.309,1.309,0,0,0,.414,1.29c.248.211.61-.147.36-.36a.8.8,0,0,1-.283-.795c.071-.319-.42-.456-.492-.135h0Z"
            transform="translate(-605.328 -1587.619)"
            fill="#414042"
          />
          <path
            id="Path_101075"
            data-name="Path 101075"
            d="M704.741,1732.229a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
            transform="translate(-625.659 -1611.766)"
            fill="#414042"
          />
          <path
            id="Path_101076"
            data-name="Path 101076"
            d="M768.7,1715.349c-2.643.082-4.978,2.785-6.472,4.683a18.421,18.421,0,0,0-2.389,3.809,4.28,4.28,0,0,0-.541,2.717c.424,1.482,2.023,1.928,3.368,2.071,3.843.411,7.828.073,11.685.081,3.6.007,7.356.273,10.925-.306a5.323,5.323,0,0,0,2.406-.858,5.743,5.743,0,0,0,1.506-2.369,20.339,20.339,0,0,0,1.4-4.472,5.537,5.537,0,0,0-.143-3.487c-1.354-2.483-3.991.859-4.842,1.973-.753.987-1.8,2.913-3.28,2.465a21.066,21.066,0,0,1-4.125-2.135c-1.7-.976-3.391-1.97-5.158-2.817a10.989,10.989,0,0,0-4.337-1.356.255.255,0,0,0,0,.509c2.749.064,5.554,2,7.861,3.312,1.279.73,2.544,1.49,3.849,2.173a6.473,6.473,0,0,0,2.336.931c.865.057,1.533-.655,2.057-1.252.881-1,1.583-2.158,2.515-3.119.818-.844,2.336-1.666,2.825-.056a7.872,7.872,0,0,1-.348,4.044,19.364,19.364,0,0,1-1.481,3.951,3.156,3.156,0,0,1-1.536,1.639c-2.2.974-5.123.709-7.463.722-4.209.024-8.417.012-12.626.029-1.766.007-4.509.382-6.062-.715-2-1.413.01-4.318.978-5.767a20.582,20.582,0,0,1,3.355-3.914,6.423,6.423,0,0,1,3.741-1.978c.327-.01.329-.52,0-.509Z"
            transform="translate(-676.807 -1596.467)"
            fill="#414042"
          />
          <path
            id="Path_101077"
            data-name="Path 101077"
            d="M827.3,1633.722a6.347,6.347,0,0,0-3.1,1.682c-.433.394-1.411,1.255-1.223,1.958.269,1.009,3.172.619,3.869.6a24.254,24.254,0,0,0,6.618-.764c1.14-.357,1.959-1.235.637-2.051a10.315,10.315,0,0,0-3.317-1.1,11.623,11.623,0,0,0-3.411-.338c-.323.032-.327.542,0,.509a12.4,12.4,0,0,1,6.174,1.208c.268.135.858.383.758.757-.067.253-.64.409-.827.475a13.318,13.318,0,0,1-2.861.549,34.669,34.669,0,0,1-6.106.215c-.206-.013-.707.034-.879-.1-.316-.247.116-.7.34-.966a6.18,6.18,0,0,1,3.468-2.146c.323-.054.186-.545-.135-.492Z"
            transform="translate(-736.36 -1520.147)"
            fill="#414042"
          />
          <path
            id="Path_101078"
            data-name="Path 101078"
            d="M879.768,1692.5a7.935,7.935,0,0,1,.115,1.489.255.255,0,0,0,.509,0,8.652,8.652,0,0,0-.133-1.624c-.056-.323-.547-.186-.492.135h0Z"
            transform="translate(-789.453 -1574.819)"
            fill="#414042"
          />
          <path
            id="Path_101079"
            data-name="Path 101079"
            d="M914.2,1691.485v1.551a.255.255,0,0,0,.509,0v-1.551a.255.255,0,0,0-.509,0Z"
            transform="translate(-821.636 -1573.935)"
            fill="#414042"
          />
          <path
            id="Path_101080"
            data-name="Path 101080"
            d="M854.164,1772.307a4.566,4.566,0,0,0-3.623,4.8c.295,2.254,2.557,3.247,4.6,2.866,2.079-.387,3.743-1.894,3.549-4.107a3.806,3.806,0,0,0-4.463-3.573c-.32.042-.325.553,0,.509a3.328,3.328,0,0,1,3.962,3.209,3.367,3.367,0,0,1-2.944,3.42c-1.751.395-3.762-.255-4.175-2.2-.435-2.046,1.311-4.041,3.225-4.436C854.62,1772.732,854.485,1772.24,854.164,1772.307Z"
            transform="translate(-762.115 -1649.649)"
            fill="#414042"
          />
          <path
            id="Path_101081"
            data-name="Path 101081"
            d="M903.5,1820.7l2.437,4.209a.255.255,0,0,0,.44-.257l-2.437-4.209a.255.255,0,0,0-.44.257Z"
            transform="translate(-811.603 -1694.563)"
            fill="#414042"
          />
          <path
            id="Path_101082"
            data-name="Path 101082"
            d="M940.7,1876.482c.071.717,1.087.777,1.635.766.475-.009,1.559-.1,1.531-.791-.028-.667-1.1-.792-1.582-.812-.6-.025-1.527.084-1.584.837-.025.327.485.325.509,0,.042-.554,2.152-.375,2.145-.007-.006.35-2.106.406-2.145.007C941.176,1876.158,940.667,1876.155,940.7,1876.482Z"
            transform="translate(-846.399 -1746.267)"
            fill="#414042"
          />
          <path
            id="Path_101083"
            data-name="Path 101083"
            d="M1104.79,1627.425a4.262,4.262,0,0,0-1.521.97,29.825,29.825,0,0,0-2.3,1.919c-.381.355-1.093.89-1.222,1.443a1.163,1.163,0,0,0,1.177,1.316c.553-.056,1.146-.666,1.561-.974.8-.6,1.593-1.206,2.359-1.845.364-.3,1.209-.827,1.344-1.336.183-.688-.679-1.381-1.264-1.493-.321-.061-.458.43-.135.492.428.081,1,.534.821.952-.069.164-.334.336-.46.45-.437.4-.9.772-1.364,1.14q-.848.675-1.721,1.319c-.209.154-.756.721-1.032.727a2.656,2.656,0,0,1-.777-.655c0-.067.109-.15.133-.2a2.4,2.4,0,0,1,.5-.557c.458-.462.952-.89,1.449-1.308.635-.533,1.712-1.722,2.58-1.864.323-.053.186-.544-.135-.492Z"
            transform="translate(-995.016 -1514.294)"
            fill="#414042"
          />
          <path
            id="Path_101084"
            data-name="Path 101084"
            d="M1186.665,1650.785l2.059,5.37c.117.3.609.172.492-.135q-1.03-2.685-2.059-5.37c-.116-.3-.609-.171-.492.135Z"
            transform="translate(-1076.248 -1535.842)"
            fill="#414042"
          />
          <path
            id="Path_101085"
            data-name="Path 101085"
            d="M1173.241,1662.88l1.929,4.524c.128.3.568.041.44-.257l-1.929-4.524c-.128-.3-.568-.041-.44.257Z"
            transform="translate(-1063.698 -1547.068)"
            fill="#414042"
          />
          <path
            id="Path_101086"
            data-name="Path 101086"
            d="M789.445,1951.31c-.933.242-.714,2.332.19,2.5a17.272,17.272,0,0,0,2.617.083,7.078,7.078,0,0,0,2.266-.044c.783-.277.963-2.354.035-2.545a12.829,12.829,0,0,0-2.409,0h-2.631a.255.255,0,0,0,0,.509h3.409a4.8,4.8,0,0,1,1.5,0,1.59,1.59,0,0,1,.031,1.529c-.212.181-1.11.054-1.365.053-.636,0-1.272-.022-1.907-.042a4.889,4.889,0,0,1-1.5-.052c-.225-.105-.507-1.392-.1-1.5a.255.255,0,0,0-.136-.492Z"
            transform="translate(-704.485 -1816.91)"
            fill="#414042"
          />
          <path
            id="Path_101087"
            data-name="Path 101087"
            d="M1134.655,1951.31c-.933.242-.714,2.332.19,2.5a17.273,17.273,0,0,0,2.617.083,7.078,7.078,0,0,0,2.266-.044c.783-.277.963-2.354.035-2.545a12.828,12.828,0,0,0-2.409,0h-2.631a.255.255,0,0,0,0,.509h3.409a4.8,4.8,0,0,1,1.5,0,1.59,1.59,0,0,1,.031,1.529c-.212.181-1.11.054-1.365.053-.636,0-1.272-.022-1.907-.042a4.889,4.889,0,0,1-1.5-.052c-.225-.105-.507-1.392-.1-1.5a.255.255,0,0,0-.135-.492Z"
            transform="translate(-1027.097 -1816.91)"
            fill="#414042"
          />
          <path
            id="Path_101088"
            data-name="Path 101088"
            d="M824.219,1911.7q-.458,1.247-1.034,2.442c-.141.294.3.553.44.257q.6-1.256,1.085-2.564c.113-.308-.379-.441-.492-.135Z"
            transform="translate(-736.553 -1779.801)"
            fill="#414042"
          />
          <path
            id="Path_101089"
            data-name="Path 101089"
            d="M846.626,1913.4l-1.112,2.435c-.135.3.3.555.44.257l1.112-2.435c.135-.3-.3-.555-.44-.257Z"
            transform="translate(-757.422 -1781.427)"
            fill="#414042"
          />
          <path
            id="Path_101090"
            data-name="Path 101090"
            d="M1140.979,1910.4a15.886,15.886,0,0,1,1.287,2.531c.12.3.613.169.492-.135a16.7,16.7,0,0,0-1.339-2.653c-.173-.278-.614-.022-.44.257Z"
            transform="translate(-1033.532 -1778.396)"
            fill="#414042"
          />
          <path
            id="Path_101091"
            data-name="Path 101091"
            d="M1162,1906.608l1.323,2.844c.138.3.577.039.44-.257l-1.323-2.844c-.138-.3-.577-.039-.44.257Z"
            transform="translate(-1053.194 -1774.843)"
            fill="#414042"
          />
          <path
            id="Path_101092"
            data-name="Path 101092"
            d="M1207.442,1767.088a5.247,5.247,0,0,1-.53,2.027c-.144.293.3.552.44.257a5.9,5.9,0,0,0,.6-2.283c.019-.327-.491-.327-.509,0h0Z"
            transform="translate(-1095.16 -1644.591)"
            fill="#414042"
          />
          <path
            id="Path_101093"
            data-name="Path 101093"
            d="M1196.611,1819.1a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
            transform="translate(-1085.33 -1692.95)"
            fill="#414042"
          />
          <g
            id="Group_106489"
            data-name="Group 106489"
            transform="translate(117.907 113.788)"
          >
            <path
              id="Path_101094"
              data-name="Path 101094"
              d="M1309.516,1691.515a6.989,6.989,0,0,0-7.1,3.082,5.819,5.819,0,0,0,.8,7.631,7.068,7.068,0,0,0,7.75,1.694,6.453,6.453,0,0,0,3.984-5.869,6.893,6.893,0,0,0-5.431-6.538.255.255,0,0,0-.135.492c3.165.823,5.587,3.692,4.966,7.078a6.133,6.133,0,0,1-6.457,4.845c-3.344-.232-6.741-3.444-5.972-6.963a6.581,6.581,0,0,1,7.461-4.961c.32.068.456-.423.135-.492Z"
              transform="translate(-1301.34 -1687.855)"
              fill="#414042"
            />
            <path
              id="Path_101095"
              data-name="Path 101095"
              d="M1357.039,1642.089a20.189,20.189,0,0,1,.373-3.015c.153-.684.306-.863,1-.935a11.188,11.188,0,0,1,1.881.008c.829.054,2.783-.036,3.011.955a9.228,9.228,0,0,1-.122,3.148c-.045.321.446.459.492.135.156-1.113.48-2.66.045-3.735-.407-1-2.3-.928-3.185-1s-2.846-.408-3.386.551c-.583,1.033-.533,2.723-.612,3.883-.022.327.487.326.509,0Z"
              transform="translate(-1352.916 -1637.542)"
              fill="#414042"
            />
            <path
              id="Path_101096"
              data-name="Path 101096"
              d="M1376.138,1657.754a4.944,4.944,0,0,1,.366-1.749c.328-.681,1.366-.483,1.992-.382.551.088,1.222.111,1.261.769a6.07,6.07,0,0,1-.147,1.494c-.062.32.429.458.492.136a4.555,4.555,0,0,0,.1-2.1c-.213-.661-1.165-.729-1.746-.812-.638-.091-1.673-.245-2.179.281a4.049,4.049,0,0,0-.65,2.368c-.024.327.486.326.509,0h0Z"
              transform="translate(-1370.765 -1653.867)"
              fill="#414042"
            />
            <path
              id="Path_101097"
              data-name="Path 101097"
              d="M1328.2,1749.719a3.837,3.837,0,0,0-1.07,2.454c-.02.327.49.326.509,0a3.281,3.281,0,0,1,.92-2.093c.226-.237-.133-.6-.36-.36h0Z"
              transform="translate(-1325.443 -1742.303)"
              fill="#414042"
            />
            <path
              id="Path_101098"
              data-name="Path 101098"
              d="M1330.589,1806.213l.071.049a.257.257,0,0,0,.349-.092.26.26,0,0,0-.092-.349l-.071-.049a.257.257,0,0,0-.349.092.26.26,0,0,0,.092.349Z"
              transform="translate(-1328.557 -1794.726)"
              fill="#414042"
            />
            <path
              id="Path_101099"
              data-name="Path 101099"
              d="M1384.319,1758.536a21.208,21.208,0,0,0-1,2.992.255.255,0,0,0,.492.136,21.178,21.178,0,0,1,1-2.992c.126-.3-.367-.434-.492-.135Z"
              transform="translate(-1377.948 -1750.458)"
              fill="#414042"
            />
            <path
              id="Path_101100"
              data-name="Path 101100"
              d="M1393.216,1771.761a3.121,3.121,0,0,1-1.323.791.258.258,0,0,0-.153.374,3.536,3.536,0,0,0,1.2,1.224c.28.173.536-.268.257-.44a3,3,0,0,1-1.021-1.041l-.152.375a3.663,3.663,0,0,0,1.548-.922.255.255,0,0,0-.36-.36h0Z"
              transform="translate(-1385.791 -1762.906)"
              fill="#414042"
            />
            <path
              id="Path_101101"
              data-name="Path 101101"
              d="M1418.9,1787.286a.571.571,0,0,0-.4-.424c-.23-.046-.494.206-.667.331-.345.251-.865.592-.976,1.031-.12.473.325.65.708.606a2.666,2.666,0,0,0,1.362-.6c.256-.2-.107-.564-.36-.36a2.121,2.121,0,0,1-.629.351,2.181,2.181,0,0,1-.34.09c-.1.017-.223.079-.2-.048.024-.151.373-.375.483-.465a5.375,5.375,0,0,1,.684-.471h-.257l.1.094c.1.313.588.179.492-.135h0Z"
              transform="translate(-1409.285 -1777.081)"
              fill="#414042"
            />
            <path
              id="Path_101102"
              data-name="Path 101102"
              d="M1378.852,1788.538a2.615,2.615,0,0,1-.988,2.573,3.3,3.3,0,0,1-3.153-.007c-.3-.132-.556.307-.257.44a3.845,3.845,0,0,0,3.667.007,3.08,3.08,0,0,0,1.24-3.013c-.01-.327-.52-.328-.509,0h0Z"
              transform="translate(-1369.544 -1778.424)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101103"
            data-name="Path 101103"
            d="M1500.429,1033.75c-4.375,1.989-5.5,8.495,0,8.994s22.986-1.5,25.484-3,1.749-7.995-2-8.495S1503.177,1032.5,1500.429,1033.75Z"
            transform="translate(-1366.018 -957.07)"
            fill="#7a67d9"
          />
          <path
            id="Path_101104"
            data-name="Path 101104"
            d="M1558.939,1100.721l.781,2.443a.257.257,0,0,0,.492,0,20.343,20.343,0,0,1,.88-2.125h-.44a8.164,8.164,0,0,0,1.317,1.75.258.258,0,0,0,.435-.18l.324-3.045c.035-.326-.475-.323-.509,0q-.162,1.523-.324,3.045l.435-.18a7.658,7.658,0,0,1-1.237-1.648.257.257,0,0,0-.44,0,21.594,21.594,0,0,0-.932,2.247h.492l-.782-2.442c-.1-.311-.592-.178-.492.135h0Z"
            transform="translate(-1424.157 -1020.765)"
            fill="#fff"
          />
          <path
            id="Path_101105"
            data-name="Path 101105"
            d="M1636.27,1094.258c-.8-.454-1.233.45-1.4,1.09-.154.592-.475,2,.313,2.3.723.275,1.291-.611,1.441-1.187a2.43,2.43,0,0,0-.562-2.243c-.219-.245-.579.117-.36.36a1.844,1.844,0,0,1,.1,2.4c-.607.6-.6-.427-.562-.788.024-.258.23-1.81.778-1.5a.255.255,0,0,0,.257-.44Z"
            transform="translate(-1494.946 -1015.919)"
            fill="#fff"
          />
          <path
            id="Path_101106"
            data-name="Path 101106"
            d="M1640.188,1096.366a.9.9,0,0,0-.287,1.587c.732.537,2.046-.182,2.679-.59.275-.177.02-.618-.257-.44a4.664,4.664,0,0,1-1.126.542,3.435,3.435,0,0,1-.55.133c-.378.052-1.045-.453-.325-.74.3-.12.17-.613-.135-.492h0Z"
            transform="translate(-1499.489 -1017.986)"
            fill="#fff"
          />
          <path
            id="Path_101107"
            data-name="Path 101107"
            d="M1688.791,1086.926l-.212,2.912c-.023.327.486.325.509,0l.212-2.912c.024-.327-.486-.325-.509,0Z"
            transform="translate(-1545.322 -1008.953)"
            fill="#fff"
          />
          <path
            id="Path_101108"
            data-name="Path 101108"
            d="M1691.959,1087.638a.474.474,0,0,1,.649.642c-.181.312-.634.377-.956.436s-.186.551.135.492c.644-.119,1.424-.416,1.39-1.205a.989.989,0,0,0-1.477-.8c-.291.151-.034.591.257.44h0Z"
            transform="translate(-1548.024 -1009.322)"
            fill="#fff"
          />
          <path
            id="Path_101109"
            data-name="Path 101109"
            d="M1692.911,1111.7a.958.958,0,0,1,1.033,1.037c-.031.327.479.324.509,0a1.468,1.468,0,0,0-1.678-1.528c-.323.048-.186.539.135.492h0Z"
            transform="translate(-1549.071 -1031.862)"
            fill="#fff"
          />
          <path
            id="Path_101110"
            data-name="Path 101110"
            d="M1735.9,1084.38a15.311,15.311,0,0,1,.075,2.581c-.018.328.492.327.509,0a15.311,15.311,0,0,0-.075-2.581c-.037-.322-.547-.326-.509,0Z"
            transform="translate(-1589.546 -1006.576)"
            fill="#fff"
          />
          <path
            id="Path_101111"
            data-name="Path 101111"
            d="M1739.245,1079.216a1.571,1.571,0,0,1-1.122,1.4c-.188.058-.275.373-.061.465a2.984,2.984,0,0,1,1.239.958c.194.259.638.005.44-.257a3.467,3.467,0,0,0-1.422-1.14l-.061.465a2.1,2.1,0,0,0,1.5-1.893c.024-.327-.486-.325-.509,0h0Z"
            transform="translate(-1591.449 -1001.748)"
            fill="#fff"
          />
          <path
            id="Path_101112"
            data-name="Path 101112"
            d="M1784.31,1072.459c-.829-.042-1.045,1.606-1.167,2.167-.139.64-.29,1.734.7,1.705.733-.022,1.172-.846,1.268-1.479a2.31,2.31,0,0,0-.814-2.132c-.251-.206-.614.152-.36.36a1.81,1.81,0,0,1,.477,2.273c-.161.277-.677.861-.883.018a2.454,2.454,0,0,1,.166-.853c.058-.238.348-1.563.619-1.549.328.016.327-.493,0-.509h0Z"
            transform="translate(-1633.601 -995.661)"
            fill="#fff"
          />
          <path
            id="Path_101113"
            data-name="Path 101113"
            d="M1788.587,1077.586c-.831-.393-1.154,1.243-.651,1.71.7.65,1.753-.5,2.09-1.051.172-.28-.269-.537-.44-.257a2.414,2.414,0,0,1-.833.837c-.187.111-.466.238-.56-.06-.052-.165.041-.717.255-.749l-.2-.026.077.037c.295.139.554-.3.257-.44h0Z"
            transform="translate(-1637.952 -1000.397)"
            fill="#fff"
          />
          <path
            id="Path_101114"
            data-name="Path 101114"
            d="M1833.512,1070.32c-.079.672-.3,2.95.885,2.863a1.027,1.027,0,0,0,.868-.818,15.366,15.366,0,0,0,.335-2.226c.045-.321-.446-.459-.492-.135q-.083.6-.168,1.2a3.525,3.525,0,0,1-.188,1.079q-.068.411-.636.16l-.031-.131a2.278,2.278,0,0,1-.1-.75,6.5,6.5,0,0,1,.039-1.237c.038-.325-.472-.322-.509,0h0Z"
            transform="translate(-1680.703 -993.195)"
            fill="#fff"
          />
          <path
            id="Path_101115"
            data-name="Path 101115"
            d="M1882.685,1067.974a10.085,10.085,0,0,1,1.677-.187c.327-.009.329-.519,0-.509a10.966,10.966,0,0,0-1.813.2c-.321.063-.185.555.135.492h0Z"
            transform="translate(-1726.424 -990.82)"
            fill="#fff"
          />
          <path
            id="Path_101116"
            data-name="Path 101116"
            d="M1892.591,1071.3a9.124,9.124,0,0,0-.288,2.829c.018.326.528.328.509,0a8.648,8.648,0,0,1,.27-2.694.255.255,0,0,0-.492-.135h0Z"
            transform="translate(-1735.698 -994.407)"
            fill="#fff"
          />
          <path
            id="Path_101117"
            data-name="Path 101117"
            d="M1896,1117.3a1.961,1.961,0,0,1-1.921,1.48.255.255,0,0,0,0,.509,2.474,2.474,0,0,0,2.412-1.854.255.255,0,0,0-.492-.135h0Z"
            transform="translate(-1737.14 -1037.399)"
            fill="#fff"
          />
          <path
            id="Path_101118"
            data-name="Path 101118"
            d="M1872.07,1147.945v.083a.255.255,0,0,0,.51,0v-.083a.255.255,0,0,0-.51,0Z"
            transform="translate(-1716.802 -1065.976)"
            fill="#fff"
          />
          <path
            id="Path_101119"
            data-name="Path 101119"
            d="M1528.677,1280.005a2.939,2.939,0,0,0,1.079-2.04l-.5.068c.334.837,1.17,1.777,2.067.988l-.36-.36a5.761,5.761,0,0,0-1.506,2.929l.5.067a3.038,3.038,0,0,0-.9-2.255c-.2-.258-.561.105-.36.36a2.516,2.516,0,0,1,.754,1.895c-.037.283.447.349.5.067a5.281,5.281,0,0,1,1.374-2.7.255.255,0,0,0-.36-.36c-.638.561-1.076-.415-1.216-.763a.256.256,0,0,0-.5.068,2.42,2.42,0,0,1-.93,1.679c-.254.208.109.567.36.36h0Z"
            transform="translate(-1395.471 -1187.484)"
            fill="#414042"
          />
          <path
            id="Path_101120"
            data-name="Path 101120"
            d="M1408.852,1312.087a3.334,3.334,0,0,0,1.164-1.952c.031-.249-.372-.351-.475-.128-.379.819.68,2.385,1.438,1.386.177-.234-.2-.509-.4-.309a5.392,5.392,0,0,0-1.333,2.212l.492.135a1.849,1.849,0,0,0-.661-1.792c-.252-.206-.615.153-.36.36a1.352,1.352,0,0,1,.53,1.3.255.255,0,0,0,.492.135,4.829,4.829,0,0,1,1.2-1.987l-.4-.309c-.236.311-.66-.65-.558-.872l-.475-.128a2.858,2.858,0,0,1-1.015,1.592.255.255,0,0,0,.36.36h0Z"
            transform="translate(-1283.501 -1217.544)"
            fill="#414042"
          />
          <g
            id="Group_106491"
            data-name="Group 106491"
            transform="translate(103.46 88.048)"
          >
            <g
              id="Group_106490"
              data-name="Group 106490"
              transform="translate(5.45 5.933)"
            >
              <path
                id="Path_101121"
                data-name="Path 101121"
                d="M1229.347,1452.75c-.48.39-1.228.8-1.341,1.473a3.053,3.053,0,0,0,.573,1.8,12.718,12.718,0,0,0,1.329,1.777c.4.486.723,1.313,1.293,1.643a1.752,1.752,0,0,0,1.554-.032,17.306,17.306,0,0,0,3.689-2.4,7.458,7.458,0,0,0,2.413-2.294c.395-.839-.291-1.4-.742-2.074-.611-.912-1.523-3.1-2.823-3.295-.643-.1-1.376.736-1.775,1.139-.231.233.129.594.36.36.465-.469,1-1.136,1.709-.745,1.034.574,1.768,2.351,2.435,3.307.518.743.564.995-.078,1.678a17.634,17.634,0,0,1-2.586,2.094c-.811.585-2.484,2.159-3.633,1.918-.618-.13-1.267-1.419-1.692-1.93a8.987,8.987,0,0,1-1.185-1.713,1.684,1.684,0,0,1-.026-1.612,4.662,4.662,0,0,1,.884-.734c.255-.207-.108-.566-.36-.36h0Z"
                transform="translate(-1223.795 -1441.853)"
                fill="#414042"
              />
              <path
                id="Path_101122"
                data-name="Path 101122"
                d="M1190.236,1427.238c-.506.325-1.7-1.555-1.864-1.828a1.632,1.632,0,0,1,.136-2.306,9.644,9.644,0,0,1,2.475-1.794c.289-.156.032-.6-.257-.44-1.143.616-3.123,1.719-3.332,3.145-.145.988,1.847,4.466,3.1,3.661.275-.177.02-.618-.257-.44h0Z"
                transform="translate(-1185.849 -1415.217)"
                fill="#414042"
              />
              <path
                id="Path_101123"
                data-name="Path 101123"
                d="M1259.6,1395.9a1.794,1.794,0,0,1,.969-.67c.64-.135,1.109.344,1.5.772.565.617,1.624,1.925,1.267,2.834-.12.3.372.438.492.135.47-1.2-.855-2.833-1.65-3.589a1.859,1.859,0,0,0-2.939.157c-.2.255.158.619.36.36h0Z"
                transform="translate(-1252.947 -1390.825)"
                fill="#414042"
              />
              <path
                id="Path_101124"
                data-name="Path 101124"
                d="M1175.5,1366.95a3.383,3.383,0,0,1,1.115-5.457,2.876,2.876,0,0,1,4.091,1.629c.126.3.619.167.492-.135-.84-1.995-2.842-3.021-4.84-1.934a3.891,3.891,0,0,0-1.218,6.258c.22.244.579-.117.36-.36h0Z"
                transform="translate(-1173.38 -1358.934)"
                fill="#414042"
              />
              <path
                id="Path_101125"
                data-name="Path 101125"
                d="M1165.306,1338.91a4.325,4.325,0,0,1-.7-.974c-.426-.839.2-1.335.858-1.8.547-.384,1.335-.948,1.928-.4a3.5,3.5,0,0,1,.725,1.183c.125.3.618.167.492-.135a3.623,3.623,0,0,0-1.118-1.635c-.722-.482-1.68.129-2.283.55s-1.415,1.005-1.284,1.833a3.625,3.625,0,0,0,1.027,1.741c.224.24.584-.12.36-.36h0Z"
                transform="translate(-1163.906 -1334.97)"
                fill="#414042"
              />
              <path
                id="Path_101126"
                data-name="Path 101126"
                d="M1251.128,1443.375c-.057.777-.065,2.24.816,2.584a1.429,1.429,0,0,0,1.587-.686c.28-.566-.221-1.073-.643-1.384a6.262,6.262,0,0,0-1.438-.761c-.306-.118-.438.374-.135.492a6.016,6.016,0,0,1,1.165.6c.208.14.524.346.6.6.094.312-.287.524-.533.622-.993.4-.954-1.5-.911-2.072C1251.661,1443.048,1251.151,1443.05,1251.128,1443.375Z"
                transform="translate(-1245.398 -1436.032)"
                fill="#414042"
              />
              <path
                id="Path_101127"
                data-name="Path 101127"
                d="M1251.038,1510.224q1.453-1.125,2.98-2.148c.271-.182.016-.623-.257-.44q-1.58,1.06-3.083,2.227c-.259.2.1.558.36.36h0Z"
                transform="translate(-1244.913 -1496.292)"
                fill="#414042"
              />
              <path
                id="Path_101128"
                data-name="Path 101128"
                d="M1325.636,1477.818a9.028,9.028,0,0,1,1.357-.912c.287-.158.031-.6-.257-.44a9.767,9.767,0,0,0-1.46.992c-.254.208.108.566.36.36h0Z"
                transform="translate(-1314.631 -1467.172)"
                fill="#414042"
              />
              <path
                id="Path_101129"
                data-name="Path 101129"
                d="M1267.269,1514.535l5.429-3.776c.267-.186.013-.628-.257-.44l-5.429,3.776c-.267.186-.013.628.257.44Z"
                transform="translate(-1260.157 -1498.798)"
                fill="#414042"
              />
              <path
                id="Path_101130"
                data-name="Path 101130"
                d="M1173.773,1348.606a8.255,8.255,0,0,1,2.911-1.9c.3-.117.172-.609-.135-.492a8.868,8.868,0,0,0-3.136,2.033.255.255,0,0,0,.36.36h0Z"
                transform="translate(-1172.721 -1345.459)"
                fill="#414042"
              />
              <path
                id="Path_101131"
                data-name="Path 101131"
                d="M1195.132,1399.33a1.342,1.342,0,0,0-.076,1.485.255.255,0,0,0,.44-.257.847.847,0,0,1,.077-.971c.2-.26-.244-.514-.44-.257h0Z"
                transform="translate(-1192.841 -1395.017)"
                fill="#414042"
              />
            </g>
            <path
              id="Path_101132"
              data-name="Path 101132"
              d="M1171.976,1247.994c.6-.664,2.649-3.295.733-3.642-1.558-.283-1.281,2.595-1.168,3.462.042.321.552.325.509,0-.078-.6-.379-2.778.427-2.968.982-.231.212,1.318.047,1.584a8.444,8.444,0,0,1-.909,1.2C1171.4,1247.877,1171.756,1248.239,1171.976,1247.994Z"
              transform="translate(-1165.504 -1244.333)"
              fill="#414042"
            />
            <path
              id="Path_101133"
              data-name="Path 101133"
              d="M1084.185,1256.663c-.592-.755-2.4-2.753-3.36-1.454a1.051,1.051,0,0,0,.3,1.429,3.756,3.756,0,0,0,2.946.451c.323-.05.186-.541-.135-.492a3.4,3.4,0,0,1-2.4-.286c-.294-.206-.575-.649-.183-.912.765-.516,2.061,1.1,2.471,1.625.2.258.56-.1.36-.36Z"
              transform="translate(-1080.652 -1254.097)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101134"
            data-name="Path 101134"
            d="M955.15,1519.335c-2.658,1.773-1.773,4.652,4.874,5.1s7.976-2.658,6.2-4.652S957.808,1517.563,955.15,1519.335Z"
            transform="translate(-858.601 -1412.162)"
            fill="#6552cc"
          />
          <path
            id="Path_101135"
            data-name="Path 101135"
            d="M1006.77,1543.082c-1.09-.44-1.576.969-1.552,1.788a.619.619,0,0,0,.7.635c.484-.038.7-.5.844-.9.112-.309-.38-.442-.492-.136-.057.158-.168.528-.387.521-.234-.007-.139-.414-.12-.567.055-.437.322-1.076.876-.853.3.122.436-.37.135-.492Z"
            transform="translate(-906.695 -1435.4)"
            fill="#fff"
          />
          <path
            id="Path_101136"
            data-name="Path 101136"
            d="M1017.035,1557.261a2.366,2.366,0,0,0,.722.255.262.262,0,0,0,.314-.178.257.257,0,0,0-.178-.314,1.934,1.934,0,0,1-.6-.2c-.289-.156-.546.284-.257.44h0Z"
            transform="translate(-917.621 -1448.286)"
            fill="#fff"
          />
          <path
            id="Path_101137"
            data-name="Path 101137"
            d="M1047.176,1546.106a2.584,2.584,0,0,0,.8,1.156c.252.205.615-.152.36-.36a2.1,2.1,0,0,1-.668-.931c-.109-.307-.6-.175-.492.135h0Z"
            transform="translate(-945.892 -1438.015)"
            fill="#fff"
          />
          <path
            id="Path_101138"
            data-name="Path 101138"
            d="M1048.782,1547.892a23.8,23.8,0,0,1-1.437,2.013c-.2.254.156.617.36.36a25,25,0,0,0,1.517-2.116c.177-.277-.264-.533-.44-.257h0Z"
            transform="translate(-946.009 -1439.861)"
            fill="#fff"
          />
          <path
            id="Path_101139"
            data-name="Path 101139"
            d="M1077,1555.916l.822-1.587-.466-.061a11.472,11.472,0,0,1,.286,1.377c.046.323.538.186.492-.135a11.623,11.623,0,0,0-.285-1.377.258.258,0,0,0-.465-.061l-.822,1.587c-.151.291.289.548.44.257h0Z"
            transform="translate(-973.337 -1445.633)"
            fill="#fff"
          />
          <path
            id="Path_101140"
            data-name="Path 101140"
            d="M1094.218,1557.273a9.549,9.549,0,0,1,1.171-1.125l-.435-.18q-.055.79-.111,1.582c-.023.327.487.326.509,0q.055-.79.111-1.582c.017-.243-.28-.306-.435-.18a9.664,9.664,0,0,0-1.171,1.125c-.216.245.143.608.36.36Z"
            transform="translate(-989.471 -1447.292)"
            fill="#fff"
          />
          <path
            id="Path_101141"
            data-name="Path 101141"
            d="M976.889,1544.42a1.148,1.148,0,0,0-.448,1.249.255.255,0,0,0,.492-.136.623.623,0,0,1,.214-.674c.262-.192.008-.634-.257-.44h0Z"
            transform="translate(-879.762 -1436.683)"
            fill="#fff"
          />
          <path
            id="Path_101142"
            data-name="Path 101142"
            d="M980.149,1574.229v-.074a.255.255,0,0,0-.509,0v.074a.255.255,0,0,0,.509,0Z"
            transform="translate(-882.792 -1464.286)"
            fill="#fff"
          />
          <path
            id="Path_101143"
            data-name="Path 101143"
            d="M1870.885,299.116a3.832,3.832,0,0,0,1.8-2.638l-.5-.067a1.749,1.749,0,0,0,1.756,1.836c-.022-.167-.045-.334-.067-.5-.51.124-.721.507-.98.935a21.392,21.392,0,0,0-1.237,2.419l.475.128c.07-1.059.017-2.22-1.059-2.736-.294-.141-.553.3-.257.44.89.427.863,1.443.807,2.3-.016.243.372.36.474.128.23-.518.471-1.03.737-1.531.243-.456.623-1.455,1.176-1.589a.256.256,0,0,0-.067-.5,1.231,1.231,0,0,1-1.246-1.326c.008-.281-.448-.355-.5-.067a3.346,3.346,0,0,1-1.567,2.334c-.277.174-.021.615.257.44h0Z"
            transform="translate(-1715.342 -270.181)"
            fill="#414042"
          />
          <g
            id="Group_106492"
            data-name="Group 106492"
            transform="translate(128.433 7.054)"
          >
            <path
              id="Path_101144"
              data-name="Path 101144"
              d="M1577.225,11.686c-.027.312-.068.625-.125.933a5.113,5.113,0,0,1-.159.692c-.108.323-.115.7-.414.329-.381-.477-.168-1.807-.122-2.4.026-.328-.48-.323-.509,0-.047.512-.464,2.9-1.333,1.93-.468-.521-.255-1.887-.161-2.527l-.5-.067a7.938,7.938,0,0,1-.187,1.157,2.435,2.435,0,0,1-.316.918c-.368.418-.434.209-.63-.167a5.788,5.788,0,0,1-.13-2.572h-.509a7.883,7.883,0,0,1,.005,1.034,3.506,3.506,0,0,1-.135.937c-.263.742-.843.781-1.155,0-.8-2,.9-3.912,2.774-4.232a7.084,7.084,0,0,1,5.061.926c1.632,1.234.924,4.254.995,6.021a20.093,20.093,0,0,1-.819,6.741c-.475,1.593-1.195,3.145-1.555,4.769a4.066,4.066,0,0,1-.3,1.37c-.349.5-1.26.45-1.79.5-1.706.149-3.417.321-5.129.381-2.015.07-4.19.041-5.95-1.058-1.208-.753-2.4-1.534-3.588-2.323a.256.256,0,0,0-.384.22,13.778,13.778,0,0,1-.581,4.72,7.933,7.933,0,0,0-.3,3.1c.058.322.549.186.492-.136a10.51,10.51,0,0,1,.59-4,11.219,11.219,0,0,0,.306-3.684l-.384.22a28.782,28.782,0,0,0,4.505,2.814c2.071.868,4.539.712,6.728.558,1.072-.075,2.142-.178,3.214-.264a5.785,5.785,0,0,0,2.264-.367,1.3,1.3,0,0,0,.611-.887c.213-.8.321-1.589.588-2.379.879-2.594,1.9-5.219,2.027-7.988.061-1.372-.106-2.742-.058-4.115a8.124,8.124,0,0,0-.334-3.528c-.691-1.593-2.761-2.052-4.33-2.181-1.659-.137-3.685.123-4.646,1.656-.549.875-1.349,4.359.637,4.308,1.293-.033,1.2-2.289,1.141-3.135a.255.255,0,0,0-.509,0c-.051.808-.309,3.183.716,3.54,1.234.429,1.5-2.177,1.566-2.874.026-.283-.458-.352-.5-.067-.132.9-.417,3.136.843,3.415s1.576-1.851,1.652-2.683h-.509c-.052.668-.321,2.99.7,3.135.988.141,1.087-2.08,1.141-2.692.029-.327-.481-.325-.509,0h0Z"
              transform="translate(-1552.87 -7.054)"
              fill="#414042"
            />
            <path
              id="Path_101145"
              data-name="Path 101145"
              d="M1462.446,97.428a4.325,4.325,0,0,1,4.626,1.042.26.26,0,0,0,.309.04,4.353,4.353,0,0,1,2.1-.655c2.145-.09,3.319,1.807,3.951,3.6a.26.26,0,0,0,.375.153c2.9-1.4,6.052.215,7.627,2.789.171.28.612.024.44-.257-1.735-2.836-5.154-4.5-8.324-2.971l.375.153c-.924-2.629-2.94-4.747-5.879-3.688-.226.081-.592.363-.821.374-.146.007-.046-.092-.285-.371a3.053,3.053,0,0,0-1.095-.652,5.036,5.036,0,0,0-3.534-.051c-.305.113-.173.606.135.492h0Z"
              transform="translate(-1462.139 -90.778)"
              fill="#414042"
            />
            <path
              id="Path_101146"
              data-name="Path 101146"
              d="M1746.954,92.829c.18,2.269-.844,4.222-1.911,6.148-.159.287.281.545.44.257,1.106-2,2.167-4.055,1.98-6.405-.026-.325-.535-.327-.509,0Z"
              transform="translate(-1726.491 -86.986)"
              fill="#414042"
            />
            <path
              id="Path_101147"
              data-name="Path 101147"
              d="M1495.882,99.008c-1.055,5.287-1.455,12.283,4.625,14.531.308.114.441-.378.135-.492-5.774-2.134-5.26-8.941-4.269-13.9.064-.32-.427-.458-.492-.135Z"
              transform="translate(-1493.093 -92.817)"
              fill="#414042"
            />
            <path
              id="Path_101148"
              data-name="Path 101148"
              d="M1465.688,99.191a24.169,24.169,0,0,0-.065,6.86c.058.322.549.186.492-.135a23.823,23.823,0,0,1,.083-6.725c.036-.325-.474-.323-.509,0Z"
              transform="translate(-1465.187 -92.932)"
              fill="#414042"
            />
            <path
              id="Path_101149"
              data-name="Path 101149"
              d="M1497.875,296.66a8.779,8.779,0,0,0,4.524,3.165c.32.064.457-.427.135-.492a8.335,8.335,0,0,1-4.3-3.033c-.213-.249-.572.112-.36.36Z"
              transform="translate(-1495.476 -277.287)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101150"
            data-name="Path 101150"
            d="M1381.162,358.859a3.454,3.454,0,0,0,1.543-1.64l-.465-.2c-.191.94.445,2.052,1.53,1.627l-.2-.465a4.644,4.644,0,0,0-1.664,2.39l.5.067c0-.839-.13-2.294-1.2-2.391-.327-.029-.325.48,0,.509.664.06.691,1.452.689,1.882a.256.256,0,0,0,.5.067,4.05,4.05,0,0,1,1.43-2.085c.2-.157.1-.582-.2-.465-.695.272-1.019-.427-.9-1,.054-.264-.338-.475-.466-.2a3.028,3.028,0,0,1-1.36,1.457c-.289.156-.031.6.257.44h0Z"
            transform="translate(-1257.672 -326.88)"
            fill="#414042"
          />
          <path
            id="Path_101151"
            data-name="Path 101151"
            d="M1548.107,707.622l-.255,1.411c-.058.321.433.458.492.135l.255-1.411c.058-.321-.433-.458-.492-.136Z"
            transform="translate(-1413.803 -654.536)"
            fill="#414042"
          />
          <path
            id="Path_101152"
            data-name="Path 101152"
            d="M1398.623,676.43a2.975,2.975,0,0,0,1.479-2.05h-.492c.16,1.013,1.115,2.111,2.177,1.35l-.309-.4a5.056,5.056,0,0,0-1.825,2.867l.492.135a2,2,0,0,0-1.293-2.3c-.307-.117-.44.376-.136.492a1.474,1.474,0,0,1,.938,1.673c-.06.318.415.458.492.136a4.624,4.624,0,0,1,1.694-2.641c.225-.177-.073-.569-.309-.4-.765.549-1.322-.369-1.429-1.045a.257.257,0,0,0-.492,0,2.487,2.487,0,0,1-1.246,1.745.255.255,0,0,0,.257.44h0Z"
            transform="translate(-1273.991 -623.346)"
            fill="#414042"
          />
          <path
            id="Path_101153"
            data-name="Path 101153"
            d="M1409.483,917.683c-.35,1.051-.664,7.976,0,8.2s3.323.221,3.766-.664.443-7.533-.221-7.976S1409.7,917.018,1409.483,917.683Z"
            transform="translate(-1284.133 -850.388)"
            fill="#414042"
          />
          <path
            id="Path_101154"
            data-name="Path 101154"
            d="M1293.33,819.7c-.793.4-5.539,5.76-5.318,6.425s1.551,2.215,2.658,1.773,5.539-5.539,5.317-6.2-1.773-2.437-2.658-1.994Z"
            transform="translate(-1170.971 -759.381)"
            fill="#414042"
          />
          <path
            id="Path_101155"
            data-name="Path 101155"
            d="M1069.167,930.289c-2.082,3.492-1.764,7.816-3.743,11.331a10.653,10.653,0,0,1-5.647,4.421,4.415,4.415,0,0,1-6.076-3.964,3.135,3.135,0,0,1,1.844-3.34c1.648-.56,2.927.537,3.811,1.821a18.636,18.636,0,0,1,1.385,2.784,11.478,11.478,0,0,0,1.8,2.73c2.813,3.21,7.1,5.435,11.376,3.78,4.713-1.824,5.545-7.338,5.227-11.764-.023-.325-.533-.328-.509,0,.2,2.845.083,5.844-1.456,8.34a7.312,7.312,0,0,1-7,3.421,10.965,10.965,0,0,1-7.28-4.137c-1.739-1.981-2.185-4.745-4.074-6.592a3.264,3.264,0,0,0-4.439-.3c-1.447,1.2-1.449,3.515-.771,5.123a4.8,4.8,0,0,0,4.76,2.958,11.047,11.047,0,0,0,5.705-2.816c3.932-3.443,3.007-9.312,5.526-13.537a.255.255,0,0,0-.44-.257h0Z"
            transform="translate(-951.517 -862.685)"
            fill="#414042"
          />
          <path
            id="Path_101156"
            data-name="Path 101156"
            d="M1127.658,457.672c-1.838,3.472,1.459,5.837,8.512,7.539s13.376-.244,8.268-5.35S1129.846,453.538,1127.658,457.672Z"
            transform="translate(-1020.652 -418.796)"
            fill="#7a67d9"
          />
          <path
            id="Path_101157"
            data-name="Path 101157"
            d="M1189.115,486.115l-.924,1.456a5.108,5.108,0,0,0-.757,1.226c-.184.755,1.044.444,1.381.361a2.305,2.305,0,0,0,1.726-1.373,1.393,1.393,0,0,0-.752-1.742c-.3-.137-.554.3-.257.44a.951.951,0,0,1,.3,1.544,2.456,2.456,0,0,1-1.571.719c-.012,0-.418.1-.327.108,0,.1.018.09.065-.025l.115-.182.461-.728.981-1.547c.176-.278-.265-.534-.44-.257h0Z"
            transform="translate(-1076.966 -447.59)"
            fill="#fff"
          />
          <path
            id="Path_101158"
            data-name="Path 101158"
            d="M1243.091,510.42l2.467-2.307-.435-.18q-.031,1.408-.061,2.816a.255.255,0,0,0,.509,0q.031-1.408.061-2.816a.257.257,0,0,0-.435-.18l-2.467,2.307c-.24.225.121.585.36.36Z"
            transform="translate(-1128.586 -467.857)"
            fill="#fff"
          />
          <path
            id="Path_101159"
            data-name="Path 101159"
            d="M1255.694,531.074l1.854.449c.319.077.454-.414.135-.492l-1.854-.449c-.319-.077-.454.414-.135.492Z"
            transform="translate(-1140.605 -489.25)"
            fill="#fff"
          />
          <path
            id="Path_101160"
            data-name="Path 101160"
            d="M1317.065,525.206a4.764,4.764,0,0,0,1.58,2.015c.264.2.518-.247.257-.44a4.132,4.132,0,0,1-1.347-1.711c-.126-.3-.619-.167-.492.135h0Z"
            transform="translate(-1198.108 -483.949)"
            fill="#fff"
          />
          <path
            id="Path_101161"
            data-name="Path 101161"
            d="M1317.247,534.424a3.831,3.831,0,0,1-.566,1.342c-.134.2-.878,1.206-1.187.837-.211-.252-.57.11-.36.36.438.525,1.126.039,1.485-.325a4.258,4.258,0,0,0,1.119-2.079c.071-.319-.42-.456-.492-.135h0Z"
            transform="translate(-1196.265 -492.676)"
            fill="#fff"
          />
          <path
            id="Path_101162"
            data-name="Path 101162"
            d="M781.855,105.669q1.367,3.757,2.867,7.466c.7,1.727,1.411,3.452,2.211,5.134.388.814.863,2.233,1.665,2.76.979.643,3.177-.335,4.129-.649a20.1,20.1,0,0,0,2.767-1.106c.4-.2,1.043-.477,1.214-.939.267-.716-.211-1.974-.363-2.669-.384-1.754-.834-3.494-1.29-5.231q-1.2-4.552-2.5-9.075a.26.26,0,0,0-.314-.178,38.367,38.367,0,0,0-10.267,4.2.255.255,0,0,0,.257.44,37.907,37.907,0,0,1,10.145-4.148l-.314-.178q.945,3.284,1.836,6.582a82.927,82.927,0,0,1,2.266,9.306,1.786,1.786,0,0,1,.059.8c-.247.549-1.638.958-2.12,1.152a25.39,25.39,0,0,1-2.808.943c-.551.15-1.766.635-2.328.384-.7-.314-1.213-1.862-1.515-2.49-.782-1.626-1.476-3.3-2.154-4.967q-1.545-3.81-2.951-7.675c-.111-.306-.6-.173-.492.136Z"
            transform="translate(-697.939 -87.959)"
            fill="#414042"
          />
          <path
            id="Path_101163"
            data-name="Path 101163"
            d="M771.617,66.587a6.729,6.729,0,0,1-.691-2.753c.165-1.039,2.578-1.675,3.367-2a25.159,25.159,0,0,1,4.808-1.748c.89-.169,1.46-.071,1.825.837a6.394,6.394,0,0,1,.383,1.525c.042.32.553.325.509,0-.13-.968-.379-2.55-1.46-2.9a3.9,3.9,0,0,0-2.09.217,35.392,35.392,0,0,0-3.747,1.422c-.926.384-1.87.746-2.763,1.206a2.61,2.61,0,0,0-1.25.979c-.424.923.3,2.467.617,3.348.11.306.6.174.492-.135Z"
            transform="translate(-687.23 -48.986)"
            fill="#414042"
          />
          <path
            id="Path_101164"
            data-name="Path 101164"
            d="M849.7,25.745a5.96,5.96,0,0,0,1.336-3.42l-.187.245a3.869,3.869,0,0,1,.953-.285l.238-.071a3.924,3.924,0,0,0,.136.462c.182.6.349,1.211.486,1.828.071.32.563.185.492-.136-.118-.528-.251-1.052-.407-1.57-.082-.274-.144-.779-.372-.984-.393-.353-1.249.14-1.662.263a.264.264,0,0,0-.187.245,5.367,5.367,0,0,1-1.187,3.06c-.2.253.154.616.36.36h0Z"
            transform="translate(-760.961 -13.677)"
            fill="#414042"
          />
          <path
            id="Path_101165"
            data-name="Path 101165"
            d="M868.685,34.866a3,3,0,0,1,1.257-.513c.323-.054.186-.545-.135-.492a3.365,3.365,0,0,0-1.379.564c-.266.187-.012.628.257.44Z"
            transform="translate(-778.755 -25.049)"
            fill="#414042"
          />
          <path
            id="Path_101166"
            data-name="Path 101166"
            d="M796.585,18.631c-.74-1.066-3.037.218-3.786.765A6.058,6.058,0,0,0,790.382,24c-.02.327.49.327.509,0a5.58,5.58,0,0,1,1.591-3.67,5.459,5.459,0,0,1,1.483-1.048c.367-.176,1.874-.839,2.179-.4.186.268.628.013.44-.257Z"
            transform="translate(-705.923 -10.436)"
            fill="#414042"
          />
          <path
            id="Path_101167"
            data-name="Path 101167"
            d="M779.131,120.083a20.15,20.15,0,0,1,3.95-2.151c.3-.122.169-.615-.135-.492a20.715,20.715,0,0,0-4.072,2.2c-.267.186-.012.628.257.44h0Z"
            transform="translate(-695.063 -103.143)"
            fill="#414042"
          />
          <path
            id="Path_101168"
            data-name="Path 101168"
            d="M862.4,88.343a18.754,18.754,0,0,1,4.465-1.458c.321-.063.185-.554-.135-.492a19.314,19.314,0,0,0-4.587,1.51c-.3.14-.038.579.257.44Z"
            transform="translate(-772.868 -74.14)"
            fill="#414042"
          />
          <path
            id="Path_101169"
            data-name="Path 101169"
            d="M556.925,235.918a14.772,14.772,0,0,0-4.224.278c-1.333.337-1.531,1.094-1.7,2.352a41.908,41.908,0,0,0-.32,5.636c0,.616-.258,2.476.418,2.869a2.682,2.682,0,0,0,1.051.086c.742.021,1.485.017,2.226.012q2.837-.018,5.672-.126c.67-.026,2.332.194,2.886-.311.278-.253.31-.853.364-1.19.127-.8.185-1.614.232-2.422a26.4,26.4,0,0,0-.038-5.611c-.232-1.443-2.031-1.565-3.242-1.572a.255.255,0,0,0,0,.509,6.739,6.739,0,0,1,1.652.193,1.237,1.237,0,0,1,1.133,1.336,32.971,32.971,0,0,1,.026,4.346c-.03.727-.073,1.454-.144,2.178a4.38,4.38,0,0,1-.283,1.722c-.291.429-1.814.281-2.387.305-2.808.115-5.661.25-8.47.108a1.392,1.392,0,0,1-.443-.031c-.153-.079.08.149-.02-.077a4.839,4.839,0,0,1-.115-1.619c-.033-1.57.025-3.147.147-4.713.1-1.284-.067-3.049,1.4-3.466a13.444,13.444,0,0,1,4.186-.283c.328.015.327-.495,0-.509h0Z"
            transform="translate(-481.867 -213.853)"
            fill="#414042"
          />
          <path
            id="Path_101170"
            data-name="Path 101170"
            d="M587.447,185.359c-.042-.846-.2-2.619.623-3.083.9-.5,2.583-.292,3.572-.278.664.009,2.571-.21,2.978.408.439.666.179,2.176.119,2.953-.026.327.484.325.509,0,.069-.892.351-2.685-.3-3.423-.6-.682-2.51-.436-3.305-.448-1.069-.015-3.049-.26-3.989.424-.893.649-.763,2.484-.716,3.447.016.327.526.329.509,0h0Z"
            transform="translate(-515.762 -162.964)"
            fill="#414042"
          />
          <path
            id="Path_101171"
            data-name="Path 101171"
            d="M589.71,208.011a31.439,31.439,0,0,1,5.539-.075c.327.024.325-.485,0-.509a31.44,31.44,0,0,0-5.539.075c-.323.033-.327.543,0,.509Z"
            transform="translate(-518.16 -187.174)"
            fill="#414042"
          />
          <path
            id="Path_101172"
            data-name="Path 101172"
            d="M691.219,210.789a2.41,2.41,0,0,1,.828.162c.307.116.44-.376.136-.492a2.835,2.835,0,0,0-.964-.18.255.255,0,0,0,0,.509Z"
            transform="translate(-613.021 -189.922)"
            fill="#414042"
          />
          <g
            id="Group_106493"
            data-name="Group 106493"
            transform="translate(72.366 23.949)"
          >
            <path
              id="Path_101173"
              data-name="Path 101173"
              d="M615.089,270.775h-1.772V269.04h-1.994v1.735H609.55v1.735l1.773-.079v1.815h1.994v-1.9l1.772-.08Z"
              transform="translate(-609.295 -268.785)"
              fill="#414042"
            />
            <path
              id="Path_101174"
              data-name="Path 101174"
              d="M611.444,266.885h-1.773l.255.255V265.4a.258.258,0,0,0-.255-.255h-1.994a.258.258,0,0,0-.255.255v1.735l.255-.255H605.9a.258.258,0,0,0-.255.255v1.735a.257.257,0,0,0,.255.255l1.773-.079-.255-.255v1.815a.258.258,0,0,0,.255.255h1.994a.258.258,0,0,0,.255-.255v-1.9l-.255.255,1.773-.079a.259.259,0,0,0,.255-.255V267.14a.255.255,0,0,0-.509,0v1.487l.255-.255-1.773.079a.259.259,0,0,0-.255.255v1.9l.255-.255h-1.994l.255.255V268.8a.257.257,0,0,0-.255-.255l-1.773.079.255.255V267.14l-.255.255h1.773a.258.258,0,0,0,.255-.255V265.4l-.255.255h1.994l-.255-.255v1.735a.258.258,0,0,0,.255.255h1.773A.255.255,0,0,0,611.444,266.885Z"
              transform="translate(-605.65 -265.15)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101175"
            data-name="Path 101175"
            d="M672.182,44.9c-1.64.877-.705,3.354-.222,4.656.466,1.256,1.712,2.631,3.149,1.71,1.405-.9.653-2.642.217-3.882-.506-1.44-1.27-3.181-3.083-2.51-.305.113-.173.606.135.492,1.5-.555,2.052,1.008,2.455,2.155.305.865,1.03,2.325.238,3.115-1.287,1.284-2.408-.569-2.776-1.652-.342-1.007-1.093-2.982.142-3.643C672.729,45.188,672.472,44.747,672.182,44.9Z"
            transform="translate(-594.594 -35.208)"
            fill="#414042"
          />
          <path
            id="Path_101176"
            data-name="Path 101176"
            d="M674.541,52.5a5.838,5.838,0,0,1,3.139-1.274s-.554-3.212-2.769-2.769c-1.994.443-.369,4.044-.369,4.044Z"
            transform="translate(-597.083 -38.657)"
            fill="#414042"
          />
          <path
            id="Path_101177"
            data-name="Path 101177"
            d="M696.636,114.921a1.2,1.2,0,0,0,.757.81.255.255,0,1,0,.135-.492.667.667,0,0,1-.4-.454.255.255,0,0,0-.492.136h0Z"
            transform="translate(-618.304 -100.511)"
            fill="#414042"
          />
          <path
            id="Path_101178"
            data-name="Path 101178"
            d="M545.73,29.606c-1.508-.948-3.338.583-4.332,1.632-1.031,1.089-1.947,2.722-.4,3.845,1.433,1.037,3.21-.842,4.153-1.768s1.845-2.607.626-3.668c-.246-.215-.608.144-.36.36.992.865.094,2.23-.627,2.948-.75.746-2.294,2.408-3.409,1.735-1.608-.971-.136-2.625.755-3.473.781-.743,2.211-1.874,3.332-1.168.278.175.534-.266.257-.44Z"
            transform="translate(-472.094 -20.799)"
            fill="#414042"
          />
          <path
            id="Path_101179"
            data-name="Path 101179"
            d="M545.16,53.26s-1.94,1.733-1.725,2.834a1.663,1.663,0,0,0,2.56,1.07,4.657,4.657,0,0,0,1.642-1.3A6.018,6.018,0,0,1,545.16,53.26Z"
            transform="translate(-475.126 -43.182)"
            fill="#414042"
          />
          <path
            id="Path_101180"
            data-name="Path 101180"
            d="M588.021,41.357a1.324,1.324,0,0,1,.738-.344.262.262,0,0,0,.255-.255.256.256,0,0,0-.255-.255,1.909,1.909,0,0,0-1.1.494c-.243.222.118.581.36.36Z"
            transform="translate(-516.397 -31.259)"
            fill="#414042"
          />
          <path
            id="Path_101181"
            data-name="Path 101181"
            d="M858.15,247.122l1.806,4.059c.133.3.572.04.44-.257l-1.806-4.059c-.133-.3-.572-.04-.44.257Z"
            transform="translate(-769.232 -223.989)"
            fill="#414042"
          />
          <path
            id="Path_101182"
            data-name="Path 101182"
            d="M896.965,229.972q.664,2.189,1.493,4.32c.118.3.611.171.492-.135q-.829-2.132-1.493-4.32c-.095-.313-.587-.179-.492.135Z"
            transform="translate(-805.518 -208.033)"
            fill="#414042"
          />
          <path
            id="Path_101183"
            data-name="Path 101183"
            d="M935.267,221.437q.461,1.936,1.048,3.838c.1.312.588.179.492-.136q-.587-1.9-1.048-3.838c-.076-.319-.568-.184-.492.136Z"
            transform="translate(-841.316 -200.053)"
            fill="#414042"
          />
          <path
            id="Path_101184"
            data-name="Path 101184"
            d="M61.941,27.512a3.593,3.593,0,0,0,.492,6.883c3.2.738,16.962-.738,19.174-1.475s3.687-6.883,1.229-7.375S64.154,26.529,61.941,27.512Z"
            transform="translate(-22.97 -17.191)"
            fill="#7a67d9"
          />
          <path
            id="Path_101185"
            data-name="Path 101185"
            d="M94.387,83.508a12.187,12.187,0,0,0,.149,2.093c.05.323.541.186.492-.136a11.4,11.4,0,0,1-.131-1.958.255.255,0,0,0-.509,0h0Z"
            transform="translate(-55.488 -71.22)"
            fill="#fff"
          />
          <path
            id="Path_101186"
            data-name="Path 101186"
            d="M93,79.653a11.949,11.949,0,0,1,1.217-.215c.321-.039.325-.549,0-.509a13.323,13.323,0,0,0-1.352.232c-.319.073-.185.564.135.492Z"
            transform="translate(-53.896 -67.168)"
            fill="#fff"
          />
          <path
            id="Path_101187"
            data-name="Path 101187"
            d="M93.888,93.335a3.966,3.966,0,0,0,1.486-.244c.305-.113.173-.6-.136-.492a3.586,3.586,0,0,1-1.35.225.255.255,0,0,0,0,.509h0Z"
            transform="translate(-54.794 -79.931)"
            fill="#fff"
          />
          <path
            id="Path_101188"
            data-name="Path 101188"
            d="M135.739,78.832l-.082,2.027c-.013.328.5.327.509,0l.082-2.027c.013-.328-.5-.327-.509,0Z"
            transform="translate(-94.057 -66.85)"
            fill="#fff"
          />
          <path
            id="Path_101189"
            data-name="Path 101189"
            d="M159.508,75q.515-.064,1.032-.117.239-.025.477-.046l.239-.021q.331.049.058-.283l.22-.126H161.5c-.327.01-.329.52,0,.509a.307.307,0,0,0,.09-.6,2.3,2.3,0,0,0-.888.042q-.6.059-1.191.133c-.321.04-.325.55,0,.509Z"
            transform="translate(-116.12 -62.824)"
            fill="#fff"
          />
          <path
            id="Path_101190"
            data-name="Path 101190"
            d="M173.55,77.875q0,.984-.01,1.967a.255.255,0,0,0,.509,0q0-.984.01-1.967a.255.255,0,0,0-.509,0Z"
            transform="translate(-129.461 -65.955)"
            fill="#fff"
          />
          <path
            id="Path_101191"
            data-name="Path 101191"
            d="M213.311,75q.188-1.215.376-2.43l-.465.061a16.816,16.816,0,0,0,1.6,2.256c.151.181.426.022.435-.18a9.052,9.052,0,0,1,.446-2.422c.1-.312-.389-.446-.492-.136a9.556,9.556,0,0,0-.465,2.558l.435-.18a16.053,16.053,0,0,1-1.516-2.153c-.1-.173-.431-.165-.465.061q-.188,1.215-.376,2.43c-.05.321.441.459.492.136h0Z"
            transform="translate(-166.166 -60.669)"
            fill="#fff"
          />
          <path
            id="Path_101192"
            data-name="Path 101192"
            d="M274.929,67.048c-.389-.047-1.053-.1-1.319.267a2.858,2.858,0,0,0-.175,1.5c.006.3-.045.868.34.982a.8.8,0,0,0,.53-.131l.971-.438c.3-.135.04-.574-.257-.44a6.776,6.776,0,0,1-.809.365c-.242.072-.221.081-.26-.173a2.565,2.565,0,0,1-.006-.414,2.436,2.436,0,0,1,.06-.841c.13-.281.642-.2.925-.169.325.039.322-.471,0-.509h0Z"
            transform="translate(-222.801 -56.035)"
            fill="#fff"
          />
          <path
            id="Path_101193"
            data-name="Path 101193"
            d="M275.035,82.277l1.356-.22c.323-.052.186-.543-.136-.492l-1.356.22c-.323.052-.186.543.135.492Z"
            transform="translate(-224.013 -69.631)"
            fill="#fff"
          />
          <path
            id="Path_101194"
            data-name="Path 101194"
            d="M319.311,60.069a1.088,1.088,0,0,0-1.081,1.061,1.112,1.112,0,0,0,.267.707c.107.124.259.181.371.293q.339.133.043.462a2.094,2.094,0,0,1-.383.321c-.266.188-.012.63.257.44.353-.249.955-.682.784-1.192a.97.97,0,0,0-.388-.433c-.176-.139-.341-.225-.4-.458a.539.539,0,0,1,.534-.692c.325-.023.328-.532,0-.509Z"
            transform="translate(-264.679 -49.544)"
            fill="#fff"
          />
          <path
            id="Path_101195"
            data-name="Path 101195"
            d="M351.73,54.622a1.094,1.094,0,0,0-1.3.759c-.219.8,1.053,1.831-.253,2.175a.255.255,0,0,0,.135.492,1.315,1.315,0,0,0,1.02-.951,1.026,1.026,0,0,0-.064-.594c-.064-.161-.168-.3-.245-.452-.219-.432-.071-1.027.571-.937.321.045.46-.446.136-.492h0Z"
            transform="translate(-294.368 -44.44)"
            fill="#fff"
          />
          <g
            id="Group_106494"
            data-name="Group 106494"
            transform="translate(56.184 29.364)"
          >
            <path
              id="Path_101196"
              data-name="Path 101196"
              d="M438.329,371.679a9.668,9.668,0,0,0-.379-2.769c-.269-.871-1.042-2.163-2.153-1.666-1.017.455-.831,1.692-.261,2.4a15.207,15.207,0,0,0,2.358,2.215c.253.2.616-.155.36-.36-.71-.57-3.655-2.668-2.409-3.684,1.5-1.22,1.971,3.113,1.974,3.864a.255.255,0,0,0,.509,0Z"
              transform="translate(-430.056 -365.873)"
              fill="#414042"
            />
            <path
              id="Path_101197"
              data-name="Path 101197"
              d="M510.262,443.69c.218-1.254.975-5.2-1.3-5.02-1.419.115-.9,1.452-.529,2.26.437.949.9,1.885,1.366,2.819.147.293.587.035.44-.257q-.406-.814-.8-1.634c-.19-.394-.38-.788-.563-1.185-.208-.45-.474-.746-.19-1.184.7-1.084,1.251.4,1.3.969a8.839,8.839,0,0,1,0,1.29,16.225,16.225,0,0,1-.207,1.805c-.056.321.435.458.492.135Z"
              transform="translate(-498.232 -432.721)"
              fill="#414042"
            />
            <path
              id="Path_101198"
              data-name="Path 101198"
              d="M441.31,475.615a3.961,3.961,0,0,0-1.386-2.054c-.925-.687-2.736-.92-3.534.1a1.345,1.345,0,0,0,.839,2.046,9.488,9.488,0,0,0,3.834.23c.324-.028.327-.538,0-.509a14.648,14.648,0,0,1-2.366.021c-.594-.045-2.81-.432-1.872-1.518.772-.894,2.436-.374,3.128.331a3.577,3.577,0,0,1,.864,1.488.255.255,0,0,0,.492-.136Z"
              transform="translate(-431.052 -464.781)"
              fill="#414042"
            />
            <path
              id="Path_101199"
              data-name="Path 101199"
              d="M362.737,418.975c-.446-1.485-2.677-1.675-3.85-1.088-.717.359-.437.992.158,1.3a4.709,4.709,0,0,0,3.513.1c.309-.1.176-.6-.135-.492a4.53,4.53,0,0,1-2.736.092c-.143-.043-.734-.208-.745-.42-.01-.2.766-.293.886-.311.824-.122,2.131,0,2.416.952a.255.255,0,0,0,.492-.135Z"
              transform="translate(-358.461 -413.015)"
              fill="#414042"
            />
            <path
              id="Path_101200"
              data-name="Path 101200"
              d="M364.039,350.643a3.1,3.1,0,0,0,.01-1.686,1.648,1.648,0,0,0-2.008-1.032c-1.653.412,1.057,2.571,1.623,2.87.29.153.547-.287.257-.44a5.8,5.8,0,0,1-1.221-.951,2.988,2.988,0,0,1-.589-.682c-.126-.23-.109-.284.157-.321,1.308-.182,1.541,1.127,1.279,2.107a.255.255,0,0,0,.492.135Z"
              transform="translate(-361.314 -347.87)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101201"
            data-name="Path 101201"
            d="M92.739,912.115a4.39,4.39,0,0,0-6.4-.433c-2.644,2.419-.794,5.918,1.161,8.1a8.832,8.832,0,0,0,4.23,2.931,3.483,3.483,0,0,0,2.372-.863c2.7-1.712,6.421-5.26,5.663-8.833-.728-3.428-5.721-3.519-7.431-.854-.177.277.263.533.44.257a4.143,4.143,0,0,1,4.943-1.3c2.008.981,1.835,3.4,1,5.114a13.208,13.208,0,0,1-4.212,4.732c-.75.537-1.843,1.449-2.817,1.212-1.63-.4-3.138-1.9-4.165-3.144-1.043-1.261-2.109-2.9-2.023-4.607a3.859,3.859,0,0,1,4.593-3.371,4.632,4.632,0,0,1,2.28,1.418c.217.247.575-.115.36-.36Z"
            transform="translate(-46.745 -844.114)"
            fill="#414042"
          />
          <path
            id="Path_101202"
            data-name="Path 101202"
            d="M89.8,960.516a7.364,7.364,0,0,0,2.112,0c.524-.194.933-.979,1.288-1.4L92.77,959q.332,1.883.664,3.766c.047.268.416.215.492,0l1.773-5.1-.5-.067q.111,3.213.221,6.425a.256.256,0,0,0,.5.067l.756-3.215c.04-.171.072-.346.121-.515-.006.022-.328.119-.13.15a2.449,2.449,0,0,0,.374,0h1.734a.255.255,0,0,0,0-.509H96.56a.259.259,0,0,0-.245.187l-.886,3.766.5.067q-.111-3.213-.221-6.425a.256.256,0,0,0-.5-.067q-.886,2.548-1.773,5.1h.492q-.332-1.883-.664-3.766a.257.257,0,0,0-.426-.113l-.623.747a3.2,3.2,0,0,1-.4.484c-.2.153.223-.031,0,.024a9.454,9.454,0,0,1-2.009,0,.255.255,0,0,0,0,.509h0Z"
            transform="translate(-50.968 -888.092)"
            fill="#414042"
          />
          <path
            id="Path_101203"
            data-name="Path 101203"
            d="M256.645,934.358a1.424,1.424,0,0,1,1.03,1.172c.04.321.55.325.509,0a1.949,1.949,0,0,0-1.4-1.664.255.255,0,0,0-.135.492Z"
            transform="translate(-206.958 -866.132)"
            fill="#414042"
          />
          <path
            id="Path_101204"
            data-name="Path 101204"
            d="M279.5,971.64h-.056a.255.255,0,0,0,0,.509h.056a.255.255,0,0,0,0-.509Z"
            transform="translate(-228.203 -901.443)"
            fill="#414042"
          />
          <path
            id="Path_101205"
            data-name="Path 101205"
            d="M656.822,850.024l-.038.086a.271.271,0,0,0,.04.309c.26.3.573.088.8-.143a2.248,2.248,0,0,0,.616-1.607l-.5.067c.155.822.619,1.6,1.555,1.534a.259.259,0,0,0,.22-.384c-.5-1.163-1.778,2.156-1.87,2.5a.255.255,0,0,0,.492.135,2.164,2.164,0,0,0-.934-2.444c-.276-.179-.531.261-.257.44a1.635,1.635,0,0,1,.7,1.868l.492.135a7.706,7.706,0,0,1,.473-1.313c.113-.237.578-.8.466-1.062l.22-.384c-.7.047-.956-.59-1.064-1.159-.054-.288-.5-.213-.5.067a1.786,1.786,0,0,1-.156.77c-.028.06-.41.6-.395.621.013.1.027.206.04.309l.038-.086c.131-.3-.308-.557-.44-.257h0Z"
            transform="translate(-581.042 -786.288)"
            fill="#414042"
          />
          <path
            id="Path_101206"
            data-name="Path 101206"
            d="M700.689,635.466c.691.452,1.205-1.214,1.268-1.634h-.492c.227.7.582,1.377,1.415,1.318-.022-.167-.045-.334-.067-.5-.927.345-1.178,1.895-1.358,2.736l.5.067a3.023,3.023,0,0,0-.738-2.389c-.212-.251-.572.111-.36.36a2.549,2.549,0,0,1,.589,2.029c-.034.285.441.346.5.067.126-.588.356-2.14,1-2.38.25-.093.24-.522-.067-.5-.628.044-.788-.524-.924-.944-.07-.216-.451-.267-.492,0a6.012,6.012,0,0,1-.52,1.329c-.275-.18-.531.261-.257.44h0Z"
            transform="translate(-621.992 -585.452)"
            fill="#414042"
          />
          <path
            id="Path_101207"
            data-name="Path 101207"
            d="M1009.929,583.5c-.824.272-1.96-1.4-1.673-2.131.234-.594.97-.247,1.2.153a2.935,2.935,0,0,1,.285.9.255.255,0,0,0,.509,0c-.013.1.033-.166.043-.206a2.767,2.767,0,0,1,.147-.465c.117-.274.661-1.012,1-.536.225.314-.208.975-.373,1.222a2.948,2.948,0,0,1-1.2,1.095c-.3.133-.04.572.257.44a3.566,3.566,0,0,0,1.615-1.671c.227-.456.46-1.183-.047-1.547-1.086-.779-1.841.843-1.951,1.668h.509a2.623,2.623,0,0,0-.611-1.5,1.166,1.166,0,0,0-1.79.118c-.642,1.1.939,3.382,2.214,2.961.31-.1.177-.594-.135-.492Z"
            transform="translate(-909.017 -535.947)"
            fill="#414042"
          />
          <path
            id="Path_101208"
            data-name="Path 101208"
            d="M1019.572,652.3a2.458,2.458,0,0,1-2.323,2.931c-.326.017-.328.527,0,.509a2.971,2.971,0,0,0,2.814-3.576c-.059-.322-.551-.186-.492.135h0Z"
            transform="translate(-917.71 -602.707)"
            fill="#414042"
          />
          <path
            id="Path_101209"
            data-name="Path 101209"
            d="M522.268,568.162a33.947,33.947,0,0,1,2.207,3.937c.368.772,1.514.1,1.148-.671a33.975,33.975,0,0,0-2.207-3.937c-.465-.714-1.616-.048-1.148.671Z"
            transform="translate(-455.258 -523.464)"
            fill="#6552cc"
          />
          <path
            id="Path_101210"
            data-name="Path 101210"
            d="M542.581,569.516l-.024.021a.677.677,0,0,0-.1.805l.018.035a.647.647,0,0,0,.574.329c.49-.041.85-.469,1.214-.766l1.271-1.038a.67.67,0,0,0,0-.94.68.68,0,0,0-.94,0c-.6.492-1.191,1.074-1.839,1.5l.335-.091-.041,0,.574.329-.018-.035-.1.805.024-.021c.645-.564-.3-1.5-.94-.94h0Z"
            transform="translate(-474.145 -524.014)"
            fill="#6552cc"
          />
          <path
            id="Path_101211"
            data-name="Path 101211"
            d="M563.919,536.594c.416.8.855,1.581,1.324,2.349a5.637,5.637,0,0,0,1.292,1.824.673.673,0,0,0,.976-.4l.01-.026a.665.665,0,0,0-.306-.751l-.019-.009c-.767-.37-1.441.775-.671,1.148l.019.009-.306-.751-.01.026.976-.4a6.544,6.544,0,0,1-.441-.745q-.3-.479-.6-.967c-.388-.651-.753-1.313-1.1-1.984-.4-.759-1.544-.087-1.148.671h0Z"
            transform="translate(-494.207 -493.936)"
            fill="#6552cc"
          />
          <path
            id="Path_101212"
            data-name="Path 101212"
            d="M604.407,520.945a11.452,11.452,0,0,0,1.712,3.138c.742.825,1.876-.227,2.585-.634a.665.665,0,0,0-.671-1.148,9.829,9.829,0,0,1-1.434.816l.512.067c-.176-.079-.372-.57-.468-.733q-.186-.315-.359-.637c-.268-.5-.509-1.017-.73-1.542-.333-.785-1.477-.109-1.148.671Z"
            transform="translate(-532.067 -479.298)"
            fill="#6552cc"
          />
          <path
            id="Path_101213"
            data-name="Path 101213"
            d="M606.133,506.6a1.709,1.709,0,0,1,1.221-.7.681.681,0,0,0,.664-.664.67.67,0,0,0-.664-.664,2.99,2.99,0,0,0-2.161,1.094.686.686,0,0,0,0,.94.67.67,0,0,0,.94,0h0Z"
            transform="translate(-532.682 -464.946)"
            fill="#6552cc"
          />
          <path
            id="Path_101214"
            data-name="Path 101214"
            d="M623.357,532.809a8.274,8.274,0,0,1,1.328-.774.67.67,0,0,0,.238-.909.68.68,0,0,0-.909-.238,8.322,8.322,0,0,0-1.328.774.683.683,0,0,0-.238.909.67.67,0,0,0,.909.238Z"
            transform="translate(-548.899 -489.468)"
            fill="#6552cc"
          />
          <path
            id="Path_101215"
            data-name="Path 101215"
            d="M688.724,483.307a18.337,18.337,0,0,1,.725-4.193l-1.111.293c.482.443.958.893,1.419,1.357q.346.349.683.706a5.864,5.864,0,0,1,.516.5l.641-.841-.03,0,.664.664c0-.007,0-.015,0-.022-.111-.836-1.441-.846-1.329,0,0,.007,0,.015,0,.022a.677.677,0,0,0,.664.664l.03,0a.672.672,0,0,0,.641-.841,4.534,4.534,0,0,0-1.2-1.439c-.569-.588-1.159-1.155-1.763-1.708a.672.672,0,0,0-1.111.293,19.911,19.911,0,0,0-.772,4.546c-.046.855,1.283.852,1.33,0h0Z"
            transform="translate(-609.675 -440.381)"
            fill="#6552cc"
          />
          <path
            id="Path_101216"
            data-name="Path 101216"
            d="M695.856,520.483c.48-.242.966-.473,1.462-.679a.686.686,0,0,0,.464-.818.669.669,0,0,0-.818-.464c-.6.251-1.2.518-1.78.813a.665.665,0,1,0,.671,1.148h0Z"
            transform="translate(-616.654 -477.953)"
            fill="#6552cc"
          />
          <path
            id="Path_101217"
            data-name="Path 101217"
            d="M778.33,455.326q.011,2.136.1,4.269a.671.671,0,0,0,.841.641,19.113,19.113,0,0,1,2.531-.731c.836-.181.482-1.462-.354-1.282a19.321,19.321,0,0,0-2.531.731l.841.641q-.088-2.134-.1-4.269a.665.665,0,0,0-1.329,0h0Z"
            transform="translate(-694.66 -418.327)"
            fill="#6552cc"
          />
          <path
            id="Path_101218"
            data-name="Path 101218"
            d="M844.921,451.271q1.61-.115,3.212-.326c.836-.111.847-1.441,0-1.33q-1.6.211-3.212.326c-.848.06-.855,1.39,0,1.33Z"
            transform="translate(-756.295 -413.585)"
            fill="#6552cc"
          />
          <path
            id="Path_101219"
            data-name="Path 101219"
            d="M869.662,460.386c.041,1.155.008,2.311-.014,3.467a.665.665,0,0,0,1.33,0c.022-1.155.054-2.311.014-3.467-.03-.853-1.36-.857-1.33,0Z"
            transform="translate(-780 -423.057)"
            fill="#6552cc"
          />
          <path
            id="Path_101220"
            data-name="Path 101220"
            d="M930.739,451.936a32.68,32.68,0,0,1-.167,3.6c-.086.85,1.243.844,1.329,0a32.658,32.658,0,0,0,.167-3.6.665.665,0,0,0-1.33,0Z"
            transform="translate(-836.933 -415.159)"
            fill="#6552cc"
          />
          <path
            id="Path_101221"
            data-name="Path 101221"
            d="M934.6,480.086l2.88.073a.665.665,0,0,0,0-1.33l-2.88-.073a.665.665,0,0,0,0,1.33Z"
            transform="translate(-840.104 -440.824)"
            fill="#6552cc"
          />
          <path
            id="Path_101222"
            data-name="Path 101222"
            d="M975.154,448.578a17.961,17.961,0,0,1-.752,3.53.665.665,0,0,0,1.282.353,19.649,19.649,0,0,0,.8-3.884c.066-.853-1.263-.849-1.33,0h0Z"
            transform="translate(-877.87 -412.025)"
            fill="#6552cc"
          />
          <path
            id="Path_101223"
            data-name="Path 101223"
            d="M1027.026,463.5a11.535,11.535,0,0,0,1.937,2.242c.638.567,1.581-.371.94-.94a10.2,10.2,0,0,1-1.729-1.973c-.472-.709-1.624-.044-1.148.671Z"
            transform="translate(-926.971 -425.654)"
            fill="#6552cc"
          />
          <path
            id="Path_101224"
            data-name="Path 101224"
            d="M1040.71,460.293a6.156,6.156,0,0,1-2.175,3.421c-.723.454-.056,1.605.671,1.148,1.531-.963,2.2-2.579,2.786-4.216.289-.807-.994-1.154-1.282-.353h0Z"
            transform="translate(-937.542 -423.145)"
            fill="#6552cc"
          />
          <g
            id="Group_106496"
            data-name="Group 106496"
            transform="translate(127.861 88.192)"
          >
            <g
              id="Group_106495"
              data-name="Group 106495"
              transform="translate(9.137 26.914)"
            >
              <path
                id="Path_101225"
                data-name="Path 101225"
                d="M1600.4,1661.611q-1.89,3.922-3.475,7.982a14.992,14.992,0,0,0,5.839,1.871l2.973-5.031a51.357,51.357,0,0,0,.686,5.488c.228.229,5.031,0,6.4-.914.228-1.143-.686-8.918-.686-8.918-2.771.969-7.209.291-11.739-.478Z"
                transform="translate(-1596.671 -1661.352)"
                fill="#656565"
              />
              <path
                id="Path_101226"
                data-name="Path 101226"
                d="M1596.494,1657.793q-1.9,3.957-3.5,8.043a.257.257,0,0,0,.117.288,14.822,14.822,0,0,0,5.9,1.9.268.268,0,0,0,.288-.117l2.973-5.031-.475-.128c.128,1.464.262,2.931.462,4.387.048.35.031,1.04.325,1.3s1.079.14,1.44.128a21.075,21.075,0,0,0,2.924-.3c.579-.1,1.972-.232,2.372-.767.25-.333.111-1.058.1-1.439-.037-.935-.118-1.868-.2-2.8q-.218-2.433-.506-4.86a.259.259,0,0,0-.323-.246c-3.636,1.184-7.958.14-11.6-.478-.321-.054-.459.437-.135.492,3.75.634,8.141,1.693,11.875.478l-.323-.245q.271,2.309.484,4.623c.092,1.01.183,2.023.223,3.036a2.941,2.941,0,0,1,.007,1c-.148.315-.713.4-1.055.489a16.9,16.9,0,0,1-3.522.487,5.3,5.3,0,0,1-1.227.009c-.258-.052-.2.013-.257-.369-.229-1.64-.4-3.284-.547-4.934a.257.257,0,0,0-.475-.128l-1.6,2.7-1.028,1.741c-.054.09-.183.418-.281.475-.113.066-.653-.135-.941-.191a16.323,16.323,0,0,1-3.015-.876c-.292-.117-1.372-.429-1.542-.748.057.107.592-1.089.674-1.289q.457-1.121.938-2.233.907-2.093,1.9-4.148C1597.075,1657.756,1596.636,1657.5,1596.494,1657.793Z"
                transform="translate(-1592.981 -1657.662)"
                fill="#656565"
              />
            </g>
            <path
              id="Path_101227"
              data-name="Path 101227"
              d="M1559.358,1787.674l-2.973,8c-.115.308.378.441.492.135l2.973-8c.115-.308-.378-.441-.492-.136Z"
              transform="translate(-1549.627 -1752.088)"
              fill="#414042"
            />
            <path
              id="Path_101228"
              data-name="Path 101228"
              d="M1746.856,1816.863q.125,3.053.25,6.106a21.3,21.3,0,0,1,.093,2.264c-.029.433-.564,1.854.047,2.259.5.331,1.828.1,2.387.113,1.31.03,2.621.062,3.931.047.509-.006,1.46.164,1.762-.374.539-.962-.927-1.273-1.358-1.634-.735-.616-1.208-2.386-2.291-2.519a2.089,2.089,0,0,0-1.536.816c-.319.447-.122.866.041,1.368l.178-.314a4.616,4.616,0,0,1-2.776.026c-.291-.149-.549.29-.257.44a5.093,5.093,0,0,0,3.169.026.256.256,0,0,0,.178-.314c-.226-.694-.024-1.388.81-1.415.6-.02,1.019.759,1.369,1.22a9.269,9.269,0,0,0,.706.965c.279.279.6.281.942.514,1.252.861-.8.687-1.223.689-1.034,0-2.067-.015-3.1-.037a11.869,11.869,0,0,1-2.374-.058c-.378-.092-.308.06-.291-.477.013-.422.147-.823.183-1.24a28.923,28.923,0,0,0-.13-3.624q-.1-2.423-.2-4.848c-.013-.327-.523-.329-.509,0h0Z"
              transform="translate(-1727.646 -1779.297)"
              fill="#414042"
            />
            <path
              id="Path_101229"
              data-name="Path 101229"
              d="M1812.232,1807.26q-.39,3.476-.779,6.951c-.037.325.473.323.509,0q.39-3.476.779-6.951c.037-.325-.473-.323-.509,0Z"
              transform="translate(-1788.013 -1770.327)"
              fill="#414042"
            />
            <path
              id="Path_101230"
              data-name="Path 101230"
              d="M1494.71,1806.925q-2.194,4.386-4.387,8.773a1.084,1.084,0,0,0-.181.888c.087.531.24.725-.232.915a4.884,4.884,0,0,1-1.206.159c-1.085.115-2.176.189-3.266.208-.5.009-2.329.213-2.66-.28s.741-1.349,1.065-1.577c.423-.3.879-.545,1.3-.843.4-.284.78-.62,1.2-.88.105-.066.316-.238.44-.239.983-.011.444.922.531,1.295.3,1.271,2.041,1.473,3.062,1.194a.255.255,0,0,0-.135-.491,1.959,1.959,0,0,1-2.02-.352c-.432-.447-.265-.706-.376-1.24a1.084,1.084,0,0,0-.674-.879,1.373,1.373,0,0,0-1.2.347c-.9.609-1.855,1.212-2.707,1.878-.569.445-1.6,1.65-.675,2.276a5.415,5.415,0,0,0,2.734.3,35.8,35.8,0,0,0,3.826-.26c.572-.07,1.4-.016,1.593-.686a1.6,1.6,0,0,0-.039-.712c-.028-.132-.119-.648-.173-.306a2.4,2.4,0,0,1,.278-.556l1.441-2.881,2.9-5.8c.146-.293-.293-.551-.44-.257h0Z"
              transform="translate(-1480.335 -1770.12)"
              fill="#414042"
            />
            <path
              id="Path_101231"
              data-name="Path 101231"
              d="M1563.94,1899.117a5.271,5.271,0,0,0,3.616,1.362.255.255,0,0,0,0-.509,4.728,4.728,0,0,1-3.256-1.213c-.244-.218-.606.141-.36.36Z"
              transform="translate(-1556.628 -1855.998)"
              fill="#414042"
            />
            <path
              id="Path_101232"
              data-name="Path 101232"
              d="M1505.4,1934.516c-.106,1.976,3.28.645,4.006-.048.238-.227-.123-.587-.36-.36-.483.461-3.2,1.623-3.136.409.018-.328-.492-.327-.509,0h0Z"
              transform="translate(-1501.989 -1889.029)"
              fill="#414042"
            />
            <path
              id="Path_101233"
              data-name="Path 101233"
              d="M1797.67,1941.321c.93,1.03,2.452,1.789,3.739.954.274-.178.019-.619-.257-.44-1.093.708-2.347-.017-3.121-.875-.22-.244-.58.117-.36.36Z"
              transform="translate(-1775.07 -1895.426)"
              fill="#414042"
            />
            <path
              id="Path_101234"
              data-name="Path 101234"
              d="M1756.288,1908.052a6.225,6.225,0,0,0,3.756-.584c.294-.145.036-.585-.257-.44a5.625,5.625,0,0,1-3.363.532c-.321-.048-.459.443-.135.492Z"
              transform="translate(-1736.288 -1863.764)"
              fill="#414042"
            />
            <path
              id="Path_101235"
              data-name="Path 101235"
              d="M1653.471,1455.824c.808.325,1.591.7,2.4,1.029l-.178-.314a8.284,8.284,0,0,0-.3,3.359c.107.695.646,1.37.579,2.018-.252,2.471-.813,4.889-.975,7.382l.255-.255a36.972,36.972,0,0,1-11.872-.856l.178.314c.52-1.96.9-3.96,1.352-5.936a15.407,15.407,0,0,1,.671-2.12,6.347,6.347,0,0,0,.084-4.248l-.178.314a18.112,18.112,0,0,1,2.329-.686l-.323-.245c.371,2.994,6.08,3.256,6.3,0,.022-.327-.488-.326-.509,0-.179,2.662-5,2.224-5.281,0a.259.259,0,0,0-.323-.245,18.114,18.114,0,0,0-2.329.686.26.26,0,0,0-.178.314c.746,2.3-.349,4.3-.85,6.515-.416,1.838-.773,3.7-1.257,5.517a.258.258,0,0,0,.178.314,37.459,37.459,0,0,0,12.007.875.263.263,0,0,0,.255-.255,56.292,56.292,0,0,1,.924-7.081,2.059,2.059,0,0,0,.119-.82c-.069-.271-.383-.571-.486-.862a6.687,6.687,0,0,1,.119-3.861.263.263,0,0,0-.178-.314c-.808-.325-1.591-.7-2.4-1.029-.3-.122-.437.37-.135.492Z"
              transform="translate(-1630.642 -1441.646)"
              fill="#414042"
            />
            <path
              id="Path_101236"
              data-name="Path 101236"
              d="M1596.837,1469.5a59.223,59.223,0,0,0-4.115,4.573l.4.052-1.143-2.286c-.147-.293-.587-.035-.44.257l1.143,2.286a.256.256,0,0,0,.4.052,59.173,59.173,0,0,1,4.116-4.573.255.255,0,0,0-.36-.36h0Z"
              transform="translate(-1582.469 -1454.837)"
              fill="#414042"
            />
            <path
              id="Path_101237"
              data-name="Path 101237"
              d="M1556.513,1522.228c.378,1.491,1.091,4.028,2.683,4.65,1.849.723,4.066-1.914,5.05-3.157.2-.255-.156-.617-.36-.36-.859,1.085-3.071,3.791-4.642,2.976-1.31-.679-1.9-2.918-2.239-4.246a.255.255,0,0,0-.492.136h0Z"
              transform="translate(-1549.755 -1503.884)"
              fill="#414042"
            />
            <path
              id="Path_101238"
              data-name="Path 101238"
              d="M1836.048,1469.923a17.832,17.832,0,0,1,3.1,2.167c1.121.97,3.629,3.153,2.747,4.84a12.123,12.123,0,0,1-2.667,2.849q-1.146,1.062-2.321,2.092c-.247.217.115.575.36.36q1.467-1.284,2.888-2.622c.85-.805,2.244-1.871,2.431-3.119.24-1.6-1.548-3.343-2.585-4.316a18.113,18.113,0,0,0-3.7-2.69c-.288-.157-.546.283-.257.44h0Z"
              transform="translate(-1810.88 -1454.857)"
              fill="#414042"
            />
            <path
              id="Path_101239"
              data-name="Path 101239"
              d="M1828.833,1546.629l2.744,1.829v-.44a11.405,11.405,0,0,0-3.843,4.369c-.127.3.312.558.44.257a10.914,10.914,0,0,1,3.66-4.186.259.259,0,0,0,0-.44l-2.744-1.829c-.274-.183-.529.259-.257.44h0Z"
              transform="translate(-1803.208 -1526.533)"
              fill="#414042"
            />
            <path
              id="Path_101240"
              data-name="Path 101240"
              d="M1827.57,1660.141c.828.811,3.1.563,3.464-.681.346-1.186-1.5-1.407-2.276-1.411a.255.255,0,0,0,0,.509c.434,0,1.784.045,1.8.66.014.462-.78.725-1.119.807a1.616,1.616,0,0,1-1.512-.245c-.234-.23-.595.13-.36.36h0Z"
              transform="translate(-1803.004 -1631.111)"
              fill="#414042"
            />
            <path
              id="Path_101241"
              data-name="Path 101241"
              d="M1690.267,1298.419a10.484,10.484,0,0,0-1.674,5.1c.043,1.144.64,1.482,1.53,2.054.6.388,1.284.846,1.25,1.651a1.551,1.551,0,0,1-1.183,1.371c-.307.109-.175.6.135.492a1.99,1.99,0,0,0,1.559-1.784c0-1.2-.877-1.783-1.821-2.363-1.412-.865-.963-2.4-.486-3.761a15.876,15.876,0,0,1,1.13-2.5c.16-.286-.279-.543-.44-.257h0Z"
              transform="translate(-1673.194 -1294.906)"
              fill="#414042"
            />
            <path
              id="Path_101242"
              data-name="Path 101242"
              d="M1712.757,1260.39a2.8,2.8,0,0,1,.073-2.481c.1-.18.328-.631.534-.689a2.692,2.692,0,0,0,.661.135,1.543,1.543,0,0,0,.347-.089,1.444,1.444,0,0,0,.746-.681c.63-1.169-.158-2.762-1.414-1.568l.426.248a3.254,3.254,0,0,0-.157-2.334,3.69,3.69,0,0,0-2.056-1.172c-1.7-.552-6.307-.945-4.965-3.846a1.592,1.592,0,0,1,2.092-.723,30.976,30.976,0,0,1,4.313,2.05c1.062.52,2.659,1.184,2.789,2.528a5,5,0,0,1-1.3,3.25c-.209.25.15.612.36.36,1.356-1.621,2.194-4.057.257-5.514a31.725,31.725,0,0,0-4.653-2.432c-.938-.485-2.2-1.224-3.285-.759-1.413.606-1.585,2.647-.688,3.748,1.629,2,7.954.808,6.8,4.709a.257.257,0,0,0,.426.248c.862-.819.975.938.242,1.362-.57.329-.968-.139-1.442.261a3.205,3.205,0,0,0-.6,3.524c.116.3.609.172.492-.135h0Z"
              transform="translate(-1689.731 -1246.527)"
              fill="#414042"
            />
            <path
              id="Path_101243"
              data-name="Path 101243"
              d="M1504.756,1402.473c-3.373-1.478-6.456,2.419-5.6,5.639a3.521,3.521,0,0,0,3.833,2.48,4.6,4.6,0,0,0,3.649-3.136,3.908,3.908,0,0,0-1.878-4.983c-.291-.149-.55.291-.257.44,4.2,2.142.469,9.057-3.553,6.763-3.471-1.979-.164-8.391,3.553-6.763.3.13.557-.308.257-.44Z"
              transform="translate(-1496.023 -1391.963)"
              fill="#414042"
            />
            <path
              id="Path_101244"
              data-name="Path 101244"
              d="M1541.073,1444.957a1.332,1.332,0,0,0-1.76.708,1.378,1.378,0,0,0,.375,1.845c1.559.894,2.991-1.716,1.386-2.553-.291-.151-.548.288-.257.44,1.03.538.1,2.247-.871,1.673-.806-.474-.007-2.048.871-1.673C1541.115,1445.524,1541.375,1445.085,1541.073,1444.957Z"
              transform="translate(-1533.511 -1431.86)"
              fill="#414042"
            />
            <path
              id="Path_101245"
              data-name="Path 101245"
              d="M1459.027,1402.33c-1.927-1.567-4.7.356-5.346,2.309a4.231,4.231,0,0,0,.616,4.206,3.72,3.72,0,0,0,3.727.781.255.255,0,0,0-.135-.492,3.23,3.23,0,0,1-3.151-.572,3.687,3.687,0,0,1-.566-3.788c.51-1.546,2.876-3.4,4.494-2.085.252.2.615-.153.36-.36h0Z"
              transform="translate(-1453.401 -1391.593)"
              fill="#414042"
            />
            <circle
              id="Ellipse_129861"
              data-name="Ellipse 129861"
              cx="0.571"
              cy="0.571"
              r="0.571"
              transform="translate(16.942 6.386) rotate(-45)"
              fill="#414042"
            />
            <circle
              id="Ellipse_129862"
              data-name="Ellipse 129862"
              cx="0.571"
              cy="0.571"
              r="0.571"
              transform="translate(20.946 7.949) rotate(-76.72)"
              fill="#414042"
            />
            <path
              id="Path_101246"
              data-name="Path 101246"
              d="M1730.328,1365.563a1.109,1.109,0,1,0,1.921,1.1c.152-.29-.287-.548-.44-.257a.6.6,0,1,1-1.041-.587c.173-.28-.268-.536-.44-.257Z"
              transform="translate(-1712.044 -1357.658)"
              fill="#414042"
            />
            <path
              id="Path_101247"
              data-name="Path 101247"
              d="M1719.15,1323.028l.91.144a.264.264,0,0,0,.314-.178.257.257,0,0,0-.178-.313l-.91-.144a.264.264,0,0,0-.313.178.257.257,0,0,0,.178.314Z"
              transform="translate(-1701.579 -1317.557)"
              fill="#414042"
            />
            <path
              id="Path_101248"
              data-name="Path 101248"
              d="M1779.859,1339.127a1.541,1.541,0,0,0,.7.388c.318.078.454-.413.135-.492a1.024,1.024,0,0,1-.475-.257c-.237-.227-.6.133-.36.36Z"
              transform="translate(-1758.416 -1332.661)"
              fill="#414042"
            />
            <path
              id="Path_101249"
              data-name="Path 101249"
              d="M1676.75,1524.547c.7-.37,2.122-.079,2.878-.058l2.865.077a.255.255,0,0,0,0-.509l-3.526-.094a5.081,5.081,0,0,0-2.473.145c-.29.153-.033.593.257.44h0Z"
              transform="translate(-1661.77 -1505.725)"
              fill="#414042"
            />
            <path
              id="Path_101250"
              data-name="Path 101250"
              d="M1785.664,1531.14a22.269,22.269,0,0,1,3.26.254c.321.049.459-.442.135-.492a23.217,23.217,0,0,0-3.395-.272.255.255,0,0,0,0,.509h0Z"
              transform="translate(-1763.684 -1512.032)"
              fill="#414042"
            />
            <path
              id="Path_101251"
              data-name="Path 101251"
              d="M1673.68,1548.5a9.239,9.239,0,0,1,2.481.1l2.584.207,5.168.414c.327.026.325-.484,0-.509l-5.6-.448c-1.491-.119-3.3-.56-4.77-.257-.321.066-.185.557.135.492h0Z"
              transform="translate(-1658.962 -1528.171)"
              fill="#414042"
            />
            <path
              id="Path_101252"
              data-name="Path 101252"
              d="M1661.706,1574a94.919,94.919,0,0,0,10.975.617c.327-.014.329-.524,0-.509a94.855,94.855,0,0,1-10.975-.617c-.327-.024-.325.486,0,.509Z"
              transform="translate(-1647.841 -1552.084)"
              fill="#414042"
            />
            <path
              id="Path_101253"
              data-name="Path 101253"
              d="M1907.251,1559.374a.374.374,0,0,1,.1.482.255.255,0,0,0,.44.257.882.882,0,0,0-.181-1.1c-.249-.21-.612.149-.36.36h0Z"
              transform="translate(-1877.463 -1538.499)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106498"
            data-name="Group 106498"
            transform="translate(35.263 87.105)"
          >
            <path
              id="Path_101254"
              data-name="Path 101254"
              d="M86.323,1335.274a7.178,7.178,0,0,0-4.133-.676c-1.948.067-3.9.145-5.844.223a42.032,42.032,0,0,0-4.422.18,1.923,1.923,0,0,0-.784.325,6.218,6.218,0,0,1-1.673.775c-.369.083-.905.266-.69-.42a1.618,1.618,0,0,1,.37-.466.257.257,0,0,0-.113-.426,9.56,9.56,0,0,1-1.371-.371c-.117-.044-.57-.175-.626-.3-.113-.259-.177.018.016-.13.288-.22,1.2-.141,1.549-.165,1.582-.109,3.164-.193,4.737-.4,1.445-.194,2.846-.579,4.279-.831,1.595-.279,3.2-.477,4.812-.655,1.239-.138,2.478-.255,3.717-.391a4.351,4.351,0,0,0,2.479-.752c.565-.471,1.405-1.614.9-2.365-.683-1.009-2.563-.676-2.338-2.3A10.573,10.573,0,0,1,88.347,1323a2.468,2.468,0,0,1,.357-.687,4.42,4.42,0,0,1,1.871-.452,2.935,2.935,0,0,1,2.19.577c.651.576.863,1.545,1.391,2.231a3.315,3.315,0,0,0,.757.758c.072.048.39.151.43.217.4.642-1.257,1.61-1.59,1.993a1.723,1.723,0,0,0-.465,1.427,2.779,2.779,0,0,0,1.636,2.134c1.83.869,4.275.594,6.233.644,3.051.077,6.055.252,9.1.512a23.632,23.632,0,0,0,5.5-.109c.39-.056,1.934-.242,1.1.6a3.669,3.669,0,0,1-1.414.589,11.724,11.724,0,0,1-1.908.426c-.214.028-.391.359-.128.475a2.549,2.549,0,0,1,.746.4c.545.551-.239.316-.639.226a20.736,20.736,0,0,0-3.194-.653c-1.5-.1-3.054.041-4.558.017a40.627,40.627,0,0,0-5.678.177c-1.064.134-2.442.3-3.141,1.224-.2.261.244.515.44.257.951-1.253,3.739-1.1,5.108-1.141,1.963-.06,3.924.042,5.886.028a14.844,14.844,0,0,1,2.827.066,16.592,16.592,0,0,0,3.07.672c.409-.008.807-.167.731-.657-.081-.517-.933-.877-1.34-1.056-.043.158-.086.317-.128.475a8.691,8.691,0,0,0,3.579-1.085c.613-.408.882-1.138.065-1.49a3.082,3.082,0,0,0-1.688-.028,15.015,15.015,0,0,1-3.079.21c-1.839-.056-3.66-.316-5.494-.447-2.877-.2-5.769-.172-8.65-.286a6.529,6.529,0,0,1-3.538-.744,1.732,1.732,0,0,1-.405-2.709c.507-.521,1.472-.951,1.68-1.7.179-.644-.3-.767-.729-1.037-1.251-.791-1.3-2.545-2.58-3.293a4.477,4.477,0,0,0-3.584-.111c-.86.288-.974.62-1.355,1.416a9.833,9.833,0,0,0-1.084,3.122c-.127,1.266.742,1.625,1.782,2.125,1.506.725-.141,2.323-1.174,2.573a10.239,10.239,0,0,1-1.316.166c-1.47.158-2.942.3-4.41.471-3.875.455-7.642,1.437-11.54,1.7-.832.056-1.671.083-2.5.183-.278.034-.75.029-.962.246-.926.941,2,1.555,2.352,1.632q-.056-.213-.113-.426c-.347.359-.9,1.021-.545,1.534.494.714,1.789.08,2.349-.189a13.694,13.694,0,0,1,1.241-.7c-.213.075.078.02.164.01.7-.083,1.436-.059,2.142-.088q3.312-.135,6.624-.261c1.774-.066,3.7-.377,5.305.555a.255.255,0,0,0,.257-.44h0Z"
              transform="translate(-64.567 -1315.345)"
              fill="#414042"
            />
            <path
              id="Path_101255"
              data-name="Path 101255"
              d="M405.868,1285.328c3.536-.7,5.927-4.046,4.582-7.594-1.193-3.146-5.613-4.648-8.294-2.37a5.132,5.132,0,0,0-1.654,2.76c-.067.32.424.457.492.135.719-3.454,5.079-4.5,7.654-2.27a5.107,5.107,0,0,1,1.539,4.933,5.315,5.315,0,0,1-4.453,3.914c-.321.063-.185.554.136.492h0Z"
              transform="translate(-376.822 -1271.365)"
              fill="#414042"
            />
            <path
              id="Path_101256"
              data-name="Path 101256"
              d="M498.2,1233.385a3.034,3.034,0,0,1-.062-1.528c.382-1.579,2.355-1.711,3.562-1.02,1.363.78,1.681,2.306.364,3.3a4.931,4.931,0,0,1-1.829.835c-.319.075-.184.566.135.492a4.579,4.579,0,0,0,2.715-1.637c.875-1.282.093-2.728-1.129-3.429-1.2-.689-3.039-.721-3.93.492a3.085,3.085,0,0,0-.319,2.632.255.255,0,0,0,.492-.135h0Z"
              transform="translate(-467.525 -1229.92)"
              fill="#414042"
            />
            <path
              id="Path_101257"
              data-name="Path 101257"
              d="M353.091,1468.383a34.7,34.7,0,0,0-.75,4.925c-.163,2.577.994,5.262-.834,7.531-.108.134-.095.387.113.426,1.551.292,3.121.507,4.69.669,2.2.227,4.8.555,6.929-.21a.259.259,0,0,0,.153-.375,6.364,6.364,0,0,1-.838-3.008c-.009-1.377.814-2.7,1.043-4.069a26.456,26.456,0,0,0,.289-5.427c-.014-.327-.523-.329-.509,0a21.774,21.774,0,0,1-.484,6.316c-.355,1.354-.981,2.371-.8,3.831a7.141,7.141,0,0,0,.859,2.615l.152-.374c-2.089.748-4.638.414-6.794.192-1.525-.157-3.049-.368-4.555-.651q.056.213.113.426c1.714-2.128,1.06-4.56.961-7.04a23.537,23.537,0,0,1,.754-5.641c.067-.32-.424-.457-.492-.135h0Z"
              transform="translate(-330.978 -1452.601)"
              fill="#414042"
            />
            <path
              id="Path_101258"
              data-name="Path 101258"
              d="M388.287,1467.42c-1.3,5.425,8.013,4.991,8.99.365.067-.32-.424-.457-.492-.135-.447,2.116-2.642,3.213-4.639,3.255-2.027.043-3.9-1.125-3.368-3.349.077-.319-.415-.455-.492-.136h0Z"
              transform="translate(-365.297 -1451.703)"
              fill="#414042"
            />
            <g
              id="Group_106497"
              data-name="Group 106497"
              transform="translate(7.131 28.168)"
            >
              <path
                id="Path_101259"
                data-name="Path 101259"
                d="M165.032,1664.031s-9.417,8.728-13.322,14.011a4.214,4.214,0,0,0,2.986,1.838s11.485-9.877,14.7-10.336,9.877,5.053,10.107,5.742-.689,5.053-.689,5.053a4.23,4.23,0,0,0,3.9,0s1.838-5.053,1.838-7.58-8.039-8.269-8.039-8.269c-3.107.879-7.177.379-11.485-.46Z"
                transform="translate(-151.454 -1663.78)"
                fill="#616161"
              />
              <path
                id="Path_101260"
                data-name="Path 101260"
                d="M161.2,1660.28c-4.7,4.363-9.519,8.908-13.362,14.063a.25.25,0,0,0,0,.257,3.609,3.609,0,0,0,1.794,1.517c.441.193,1.126.556,1.595.369a6.017,6.017,0,0,0,1.206-1.019c2.192-1.832,4.421-3.625,6.72-5.323,1.183-.874,2.383-1.728,3.634-2.5a9.4,9.4,0,0,1,2.828-1.385c1.448-.3,3.074.558,4.3,1.229a27.025,27.025,0,0,1,4.112,2.8,9.529,9.529,0,0,1,1.347,1.215c.332.4.269.714.217,1.242a37.138,37.138,0,0,1-.674,3.953.26.26,0,0,0,.117.288,5.512,5.512,0,0,0,2.029.508,3.411,3.411,0,0,0,2.158-.528,4.576,4.576,0,0,0,.613-1.675,36.671,36.671,0,0,0,1.043-3.854,5.97,5.97,0,0,0,.168-2.869c-.59-1.858-2.575-3.418-3.98-4.644-.841-.733-1.708-1.436-2.59-2.118a7.138,7.138,0,0,0-1.4-1.05c-.278-.112-.426-.041-.753.035a14.375,14.375,0,0,1-3.229.332,40.125,40.125,0,0,1-7.646-.912c-.32-.062-.458.429-.136.492a39.026,39.026,0,0,0,8.151.926,16.334,16.334,0,0,0,1.771-.128,8.532,8.532,0,0,1,1.446-.308,1.7,1.7,0,0,1,.635.369c2.36,1.758,5,3.693,6.688,6.137.968,1.4.576,2.843.2,4.416-.217.913-.477,1.815-.757,2.709a6.788,6.788,0,0,1-.566,1.705c-.206.289-.62.323-.99.386a4.761,4.761,0,0,1-1.635-.036s-.985-.277-.841-.08c-.118-.162.253-1.279.286-1.462.183-.991.757-2.7.4-3.693-.277-.765-1.363-1.441-1.959-1.918a27.138,27.138,0,0,0-4.192-2.805,7.828,7.828,0,0,0-4.035-1.224,6.653,6.653,0,0,0-2.633,1.054,63.379,63.379,0,0,0-7.666,5.472q-1.641,1.3-3.25,2.64c-.3.253-1.077,1.187-1.485,1.252.257-.041-.815-.435-.434-.241-.353-.179-.756-.262-1.1-.47-.84-.5-1.1-.776-.531-1.5.655-.836,1.345-1.644,2.049-2.439,1.516-1.715,3.1-3.37,4.709-5,1.957-1.981,3.95-3.93,5.992-5.824.241-.223-.12-.583-.36-.36Z"
                transform="translate(-147.804 -1660.209)"
                fill="#414042"
              />
            </g>
            <path
              id="Path_101261"
              data-name="Path 101261"
              d="M46.072,1874.12a13.01,13.01,0,0,1-4.985,4.116c-.459.178-2.133.525-2.217,1.187-.066.522.552.579.93.626a16.776,16.776,0,0,0,3.358-.037,5.5,5.5,0,0,0,2.143-.424,19.939,19.939,0,0,0,4.118-3.271c.24-.224-.12-.584-.36-.36a27.923,27.923,0,0,1-3.43,2.831c-1.39.929-3.307.834-4.926.8a3.055,3.055,0,0,1-1.2-.1c-.17-.1-.03.01.1-.107a2.96,2.96,0,0,1,.882-.378,10.745,10.745,0,0,0,2.672-1.251,20.913,20.913,0,0,0,3.28-3.274c.211-.249-.147-.611-.36-.36h0Z"
              transform="translate(-38.865 -1831.871)"
              fill="#414042"
            />
            <path
              id="Path_101262"
              data-name="Path 101262"
              d="M557.176,1909.5a21.63,21.63,0,0,0-.293,2.384c-.035.565-.193,1.687.41,2.038a4.9,4.9,0,0,0,1.858.214c1.174.068,2.353.1,3.528.083.363-.005,3.354-.033,1.985-.963a13.637,13.637,0,0,0-2.935-.995c-.784-.291-.684-.649-.5-1.418.1-.407.213-.81.344-1.207.1-.312-.389-.446-.492-.135-.331,1.007-1.071,2.586.183,3.127.837.361,1.749.534,2.6.844.229.083.44.215.662.3-.123-.047.158-.146-.138-.17a9.25,9.25,0,0,0-1.023.089,34.383,34.383,0,0,1-5.332-.148c-.384-.044-.481,0-.624-.366a3.825,3.825,0,0,1-.012-1.4,20.935,20.935,0,0,1,.266-2.137c.056-.321-.435-.458-.492-.135h0Z"
              transform="translate(-522.931 -1864.843)"
              fill="#414042"
            />
            <path
              id="Path_101263"
              data-name="Path 101263"
              d="M176.279,1606.931a2.3,2.3,0,0,0,2.025-2.542.255.255,0,0,0-.509,0c-.037,1.111.176,2.157,1.335,2.542v-.492c-1.182.316-1.442,1.458-1.565,2.543h.509c-.022-1.263-.306-2.7-1.862-2.552-.324.03-.327.54,0,.509,1.249-.116,1.336,1.081,1.353,2.042a.255.255,0,0,0,.509,0c.095-.835.256-1.8,1.191-2.051a.257.257,0,0,0,0-.492c-.924-.307-.99-1.206-.962-2.051h-.509a1.814,1.814,0,0,1-1.65,2.051c-.319.073-.185.564.135.492Z"
              transform="translate(-166.987 -1579.645)"
              fill="#414042"
            />
            <path
              id="Path_101264"
              data-name="Path 101264"
              d="M90.477,1716.306a1.691,1.691,0,0,1,1.176,1.473.255.255,0,0,0,.509,0,2.768,2.768,0,0,1,.946-1.818.256.256,0,0,0-.052-.4,1.668,1.668,0,0,1-.92-1.493.255.255,0,0,0-.509,0,2.171,2.171,0,0,1-1.019,1.709c-.274.179-.018.62.257.44a2.715,2.715,0,0,0,1.271-2.149h-.509A2.165,2.165,0,0,0,92.8,1716c-.017-.134-.035-.267-.052-.4a3.312,3.312,0,0,0-1.1,2.178h.509a2.223,2.223,0,0,0-1.549-1.964c-.311-.106-.444.386-.136.491h0Z"
              transform="translate(-86.934 -1682.145)"
              fill="#414042"
            />
            <circle
              id="Ellipse_129863"
              data-name="Ellipse 129863"
              cx="0.574"
              cy="0.574"
              r="0.574"
              transform="translate(23.81 8.32)"
              fill="#414042"
            />
            <circle
              id="Ellipse_129864"
              data-name="Ellipse 129864"
              cx="0.574"
              cy="0.574"
              r="0.574"
              transform="translate(27.485 9.239)"
              fill="#414042"
            />
            <path
              id="Path_101265"
              data-name="Path 101265"
              d="M406.716,1342.476a.716.716,0,0,1,.727.1c.251.208.613-.151.36-.36a1.252,1.252,0,0,0-1.344-.185c-.3.132-.041.571.257.44Z"
              transform="translate(-382.271 -1334.588)"
              fill="#414042"
            />
            <path
              id="Path_101266"
              data-name="Path 101266"
              d="M465.6,1354.658a1.465,1.465,0,0,1,.714.424c.225.24.585-.121.36-.36a1.962,1.962,0,0,0-.938-.555.255.255,0,0,0-.136.492h0Z"
              transform="translate(-437.494 -1346.025)"
              fill="#414042"
            />
            <path
              id="Path_101267"
              data-name="Path 101267"
              d="M412.72,1387.718a1.049,1.049,0,0,0,1.928.563c.188-.27-.253-.524-.44-.257a.536.536,0,0,1-.978-.306.255.255,0,0,0-.509,0h0Z"
              transform="translate(-388.247 -1377.159)"
              fill="#414042"
            />
            <path
              id="Path_101268"
              data-name="Path 101268"
              d="M430.77,1278.766a5.8,5.8,0,0,1,3.973-2.789c.322-.062.185-.553-.135-.492a6.294,6.294,0,0,0-4.277,3.024.255.255,0,0,0,.44.257Z"
              transform="translate(-404.669 -1272.498)"
              fill="#414042"
            />
            <path
              id="Path_101269"
              data-name="Path 101269"
              d="M455.071,1289.279l3.359-2.372c.266-.188.012-.63-.257-.44l-3.359,2.372c-.266.188-.012.63.257.44Z"
              transform="translate(-427.48 -1282.723)"
              fill="#414042"
            />
            <path
              id="Path_101270"
              data-name="Path 101270"
              d="M478.687,1305.824a9.842,9.842,0,0,0,3.051-2.9c.185-.272-.257-.527-.44-.257a9.242,9.242,0,0,1-2.869,2.722.255.255,0,0,0,.257.44Z"
              transform="translate(-449.541 -1297.793)"
              fill="#414042"
            />
            <path
              id="Path_101271"
              data-name="Path 101271"
              d="M499.452,1313.849a6.513,6.513,0,0,0,2.465-4.176c.05-.321-.441-.459-.492-.135a6.112,6.112,0,0,1-2.334,3.951c-.259.2.1.559.36.36h0Z"
              transform="translate(-468.881 -1304.153)"
              fill="#414042"
            />
            <path
              id="Path_101272"
              data-name="Path 101272"
              d="M506.235,1322.862a4.641,4.641,0,0,0,2.443-5.808c-.1-.309-.6-.176-.492.135a4.143,4.143,0,0,1-2.209,5.232c-.3.14-.038.579.257.44h0Z"
              transform="translate(-475.276 -1311.186)"
              fill="#414042"
            />
            <path
              id="Path_101273"
              data-name="Path 101273"
              d="M509.938,1238.077a4.067,4.067,0,0,1,2.37-2.9c.3-.132.041-.572-.257-.44a4.536,4.536,0,0,0-2.6,3.208c-.069.32.422.456.492.135Z"
              transform="translate(-478.635 -1234.395)"
              fill="#414042"
            />
            <path
              id="Path_101274"
              data-name="Path 101274"
              d="M520.566,1242.73a7.3,7.3,0,0,0,2.7-3.3c.126-.3-.367-.434-.492-.135a6.681,6.681,0,0,1-2.465,2.994c-.271.182-.016.623.257.44h0Z"
              transform="translate(-488.684 -1238.525)"
              fill="#414042"
            />
            <path
              id="Path_101275"
              data-name="Path 101275"
              d="M529.025,1255.156a4.067,4.067,0,0,0,3.143-3.077c.073-.319-.418-.456-.492-.135a3.568,3.568,0,0,1-2.787,2.721c-.321.065-.185.556.135.492Z"
              transform="translate(-496.64 -1250.331)"
              fill="#414042"
            />
            <path
              id="Path_101276"
              data-name="Path 101276"
              d="M386.52,1588.587a1.535,1.535,0,0,1,.19,1.069c-.061.321.43.458.492.135a2.084,2.084,0,0,0-.242-1.462.255.255,0,0,0-.44.257h0Z"
              transform="translate(-363.729 -1564.752)"
              fill="#414042"
            />
            <path
              id="Path_101277"
              data-name="Path 101277"
              d="M385.169,1634.329v-.115a.255.255,0,0,0-.509,0v.115a.255.255,0,0,0,.509,0Z"
              transform="translate(-362.024 -1607.519)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106499"
            data-name="Group 106499"
            transform="translate(37.586 84.684)"
          >
            <path
              id="Path_101278"
              data-name="Path 101278"
              d="M82.363,1203.482c-1.445-1.053-2.946-2-4.792-1.193-1.525.67-2.351,2.529-2.8,4.028-.392,1.323-.786,3.306.15,4.5.975,1.248,2.982,1.314,4.334.74l-.374-.152a2.917,2.917,0,0,0,2.871,2.1c1.678-.056,3.073-1.739,3.908-3.027.922-1.421,1.757-3.411.758-5a3.475,3.475,0,0,0-1.767-1.346,16.275,16.275,0,0,1-2.293-.644.255.255,0,0,0-.257.44c.941.533,2.112.414,3.054,1.011,1.709,1.082,1.279,3.081.475,4.592a6.929,6.929,0,0,1-3.252,3.341,2.379,2.379,0,0,1-3-1.6.26.26,0,0,0-.374-.153c-1.238.526-3.3.379-3.9-1.011-.534-1.244-.111-2.929.317-4.14.458-1.3,1.25-2.914,2.68-3.331,1.628-.476,2.772.39,4,1.285.265.193.52-.249.257-.44Z"
              transform="translate(-74.348 -1201.392)"
              fill="#414042"
            />
            <path
              id="Path_101279"
              data-name="Path 101279"
              d="M191.235,1195.373a4.012,4.012,0,0,1,4.485-1.792l-.153-.375a3.669,3.669,0,0,1-4.485,1.792.255.255,0,0,0-.136.492,4.181,4.181,0,0,0,5.061-2.026.257.257,0,0,0-.153-.374,4.539,4.539,0,0,0-5.061,2.026c-.189.269.253.524.44.257Z"
              transform="translate(-183.129 -1192.935)"
              fill="#414042"
            />
            <path
              id="Path_101280"
              data-name="Path 101280"
              d="M181.766,1227.4l-.6,1.211c-.145.293.294.551.44.257l.6-1.211c.145-.293-.294-.551-.44-.257Z"
              transform="translate(-174.145 -1225.024)"
              fill="#414042"
            />
            <path
              id="Path_101281"
              data-name="Path 101281"
              d="M141.646,1304.021l-1.05,2.379c-.131.3.308.557.44.257l1.05-2.38c.131-.3-.308-.557-.44-.257Z"
              transform="translate(-136.236 -1296.625)"
              fill="#414042"
            />
            <path
              id="Path_101282"
              data-name="Path 101282"
              d="M158.681,1270.941a1.755,1.755,0,0,0-.575,1.06c-.039.347.138.744.54.739s.7-.459.827-.8a.826.826,0,0,0-.308-1.037.255.255,0,0,0-.257.44c.2.117.12.363.039.531-.036.075-.231.437-.332.323-.075-.084.046-.354.082-.433a1.406,1.406,0,0,1,.344-.461c.242-.223-.12-.583-.36-.36Z"
              transform="translate(-152.618 -1265.763)"
              fill="#414042"
            />
            <path
              id="Path_101283"
              data-name="Path 101283"
              d="M103.45,1244.686a2.919,2.919,0,0,0-1.1,2.328.255.255,0,0,0,.509,0,2.438,2.438,0,0,1,.952-1.968c.257-.2-.106-.562-.36-.36Z"
              transform="translate(-100.516 -1241.242)"
              fill="#414042"
            />
            <path
              id="Path_101284"
              data-name="Path 101284"
              d="M102.039,1297.8l.119-.119a.255.255,0,0,0-.36-.36l-.119.119a.255.255,0,0,0,.36.36Z"
              transform="translate(-99.82 -1290.415)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106500"
            data-name="Group 106500"
            transform="translate(74.347 47.645)"
          >
            <path
              id="Path_101285"
              data-name="Path 101285"
              d="M838.232,712.54a2.341,2.341,0,0,0-2.709,1.736,2.029,2.029,0,0,0,1.436,2.6c2.8.6,4.4-3.716,1.273-4.336-.32-.063-.458.427-.135.492,2.465.489,1.185,3.738-.96,3.358A1.5,1.5,0,0,1,836,714.474a1.823,1.823,0,0,1,2.1-1.443c.321.043.46-.448.135-.492Z"
              transform="translate(-822.383 -706.924)"
              fill="#414042"
            />
            <path
              id="Path_101286"
              data-name="Path 101286"
              d="M870.528,659.523a5.964,5.964,0,0,1,4.027-3.359c1.325-.236,2.258.035,2.783,1.424.115.3.608.172.492-.136a2.5,2.5,0,0,0-2.881-1.86,6.347,6.347,0,0,0-4.861,3.672c-.147.292.293.551.44.257h0Z"
              transform="translate(-854.731 -653.712)"
              fill="#414042"
            />
            <path
              id="Path_101287"
              data-name="Path 101287"
              d="M891.579,674.42c1.369-2.51,2.51-1.369,5.361-3.764-.342-1.026-1.026-1.026-1.026-1.026a7.807,7.807,0,0,0-5.144,3.357,2.36,2.36,0,0,1,.809,1.434Z"
              transform="translate(-874.086 -666.848)"
              fill="#414042"
            />
            <path
              id="Path_101288"
              data-name="Path 101288"
              d="M851.1,772.462a3.288,3.288,0,0,1-1.229,2.758c-.254.208.109.567.36.36a3.765,3.765,0,0,0,1.378-3.118c-.016-.327-.526-.329-.509,0Z"
              transform="translate(-835.78 -762.719)"
              fill="#414042"
            />
            <path
              id="Path_101289"
              data-name="Path 101289"
              d="M916.966,683.359c.138,1.42,1.109,2.813.419,4.229-.733,1.5-2.259,1.31-3.452,2.145a3.283,3.283,0,0,0-.668,4.657c.208.254.566-.108.36-.36a2.742,2.742,0,0,1,1.11-4.139,6.391,6.391,0,0,0,2.524-1.224c1.608-1.7.4-3.373.217-5.308-.031-.323-.541-.327-.509,0h0Z"
              transform="translate(-894.469 -679.451)"
              fill="#414042"
            />
            <path
              id="Path_101290"
              data-name="Path 101290"
              d="M841.677,639.052s-2.966-2.738-5.931-.228a5.031,5.031,0,0,0-1.6,5.7,2.723,2.723,0,0,1,2.281-1.825A7.635,7.635,0,0,1,841.677,639.052Z"
              transform="translate(-820.877 -637.068)"
              fill="#414042"
            />
            <path
              id="Path_101291"
              data-name="Path 101291"
              d="M749.854,628.773s-.685-2.738-3.422-1.141-2.51,4.106-2.738,5.932-2.281.912-1.825,2.51,1.6,2.51,3.879.228,1.141-5.7,3.422-6.616l.685-.912Z"
              transform="translate(-734.871 -627.132)"
              fill="#414042"
            />
            <circle
              id="Ellipse_129865"
              data-name="Ellipse 129865"
              cx="0.57"
              cy="0.57"
              r="0.57"
              transform="translate(19.774 6.204)"
              fill="#414042"
            />
            <path
              id="Path_101292"
              data-name="Path 101292"
              d="M961.645,749.4a1.37,1.37,0,0,0,1.438.411c.312-.1.179-.589-.135-.492a.869.869,0,0,1-.943-.28c-.213-.25-.572.112-.36.36h0Z"
              transform="translate(-940.262 -740.977)"
              fill="#414042"
            />
            <path
              id="Path_101293"
              data-name="Path 101293"
              d="M848.205,818.383a4.141,4.141,0,0,0,2.178,1.885,5.312,5.312,0,0,0,1.694.276c.374.009,1.055.12,1.384-.117.264-.19.01-.632-.257-.44-.447.321-2.095-.01-2.55-.16a3.641,3.641,0,0,1-2.01-1.7.255.255,0,0,0-.44.257h0Z"
              transform="translate(-834.274 -805.507)"
              fill="#414042"
            />
            <path
              id="Path_101294"
              data-name="Path 101294"
              d="M797.808,815.579a11.83,11.83,0,0,0-3.412,2.414.258.258,0,0,0,0,.36,3.618,3.618,0,0,1,.9,3.9,5.286,5.286,0,0,0-.413,1.184c-.075.642.2,1.256.141,1.9-.029.327.481.325.509,0a6,6,0,0,0-.093-1.185,3.432,3.432,0,0,1,.317-1.667,4.336,4.336,0,0,0,.291-1.462,4.171,4.171,0,0,0-1.3-3.028v.36a11.471,11.471,0,0,1,3.309-2.334c.3-.139.038-.579-.257-.44h0Z"
              transform="translate(-783.953 -803.217)"
              fill="#414042"
            />
            <path
              id="Path_101295"
              data-name="Path 101295"
              d="M922.532,849.918a8.169,8.169,0,0,1,1.385,4.921c-.083,1.589-.753,3.068-.832,4.66-.016.328.494.327.509,0,.091-1.84.911-3.53.836-5.4a8.712,8.712,0,0,0-1.458-4.442c-.179-.273-.621-.018-.44.257Z"
              transform="translate(-903.73 -834.985)"
              fill="#414042"
            />
            <path
              id="Path_101296"
              data-name="Path 101296"
              d="M732.451,852.084a20.207,20.207,0,0,0-3.354,3.946c-.736,1.143-1.5,2.476-.719,3.794.8,1.362,2.552,1.716,3.943,2.13,1.938.577,3.871,1.178,5.817,1.73.872.247,1.432.977,2.4.391a3.263,3.263,0,0,0,1.381-2.13,2.825,2.825,0,0,0-1.113-1.676c-.927-.7-1.714.341-2.736.158a36.529,36.529,0,0,1-3.775-.888,3.941,3.941,0,0,1-1.57-.594c-.445-.495.335-1.217.74-1.577.246-.218-.116-.577-.36-.36-.916.812-1.6,1.974-.221,2.584a22.393,22.393,0,0,0,5.185,1.355,2.19,2.19,0,0,0,1.07-.018c.685-.221,1.078-.613,1.676.08a4.9,4.9,0,0,1,.5.731c.081.137.1.309.1.085a2.775,2.775,0,0,1-.553,1.194,1.3,1.3,0,0,1-1.265.71c-.393-.05-.337-.165-.608-.278a17.5,17.5,0,0,0-1.728-.555l-5.015-1.491a7.632,7.632,0,0,1-2.852-1.193c-1.188-1.005-.869-2.272-.157-3.456a19.494,19.494,0,0,1,3.564-4.309c.242-.222-.119-.582-.36-.36h0Z"
              transform="translate(-722.02 -837.295)"
              fill="#414042"
            />
            <path
              id="Path_101297"
              data-name="Path 101297"
              d="M938.5,978.787a13.608,13.608,0,0,0,3.976,1.784c.313.1.447-.392.135-.492a13.168,13.168,0,0,1-3.854-1.732c-.266-.193-.52.249-.257.44Z"
              transform="translate(-918.588 -955.312)"
              fill="#414042"
            />
            <path
              id="Path_101298"
              data-name="Path 101298"
              d="M948.074,924.955c.713,1.03,2.037,2.473,3.389,2.59.791.068,2.357-.844,2.877.086.209.373-.114,1.3-.247,1.7a4.757,4.757,0,0,1-.415.919q-1.522.942-1.515-1.128c.219-.243-.14-.6-.36-.36a1.291,1.291,0,0,0,.424,2.126c1.32.623,1.953-.18,2.358-1.421.251-.768.709-2.426-.406-2.7-1.074-.266-2.156.462-3.23.067a5.625,5.625,0,0,1-2.435-2.133c-.185-.268-.627-.013-.44.257h0Z"
              transform="translate(-927.596 -905.113)"
              fill="#414042"
            />
            <path
              id="Path_101299"
              data-name="Path 101299"
              d="M1004.823,985.027a1.579,1.579,0,0,0,1.486,1.086.255.255,0,0,0,0-.509,1.056,1.056,0,0,1-.994-.712c-.1-.309-.6-.177-.492.135h0Z"
              transform="translate(-980.659 -961.308)"
              fill="#414042"
            />
            <path
              id="Path_101300"
              data-name="Path 101300"
              d="M1006.049,978.513c-.012-.236.509.209.556.246a.963.963,0,0,0,.619.238.255.255,0,0,0,0-.509c-.228,0-.382-.2-.55-.332a.906.906,0,0,0-.517-.221.578.578,0,0,0-.617.578c.018.326.527.328.509,0h0Z"
              transform="translate(-981.342 -954.971)"
              fill="#414042"
            />
            <path
              id="Path_101301"
              data-name="Path 101301"
              d="M1011.226,971.477c.008-.082.909.177.992.2a.255.255,0,0,0,.136-.492c-.5-.133-1.549-.554-1.637.293-.034.326.476.323.509,0Z"
              transform="translate(-986.18 -948.454)"
              fill="#414042"
            />
            <path
              id="Path_101302"
              data-name="Path 101302"
              d="M795.772,999.775a20.091,20.091,0,0,1-.519,3.6.259.259,0,0,0,.245.323c1.678.154,3.357.31,5.044.331a12.276,12.276,0,0,0,4.44-.467.26.26,0,0,0,.178-.314,17.655,17.655,0,0,1-.57-2.628c-.045-.323-.536-.186-.492.135a17.646,17.646,0,0,0,.57,2.628l.178-.314a12.806,12.806,0,0,1-4.744.44c-1.539-.04-3.073-.181-4.6-.323l.245.323a20.761,20.761,0,0,0,.537-3.733c.018-.328-.492-.327-.509,0Z"
              transform="translate(-784.815 -975.152)"
              fill="#414042"
            />
            <path
              id="Path_101303"
              data-name="Path 101303"
              d="M782.2,1056.184c-.323,1.432-.591,2.873-.784,4.328-.085.641-.594,2.146-.043,2.666.247.232.886.145,1.184.169q1.281.1,2.565.17c1.57.083,3.14.123,4.712.132a.256.256,0,0,0,.246-.187l.534-3.947c.043-.321-.448-.459-.492-.135l-.3,2.193a5.468,5.468,0,0,1-.178,1.316c-.212.3-.348.212-.671.245a28.786,28.786,0,0,1-4.5-.162c-.706-.042-1.438-.046-2.137-.151a1.008,1.008,0,0,1-.433-.086q-.437-.019-.181-.5a4.76,4.76,0,0,1,.116-1.077,47.859,47.859,0,0,1,.846-4.838c.072-.319-.419-.456-.492-.135h0Z"
              transform="translate(-771.615 -1027.926)"
              fill="#414042"
            />
            <path
              id="Path_101304"
              data-name="Path 101304"
              d="M914.381,1068.022l3.017-.306a.259.259,0,0,0,.255-.255,20.426,20.426,0,0,0-1.483-6.2c-.124-.3-.617-.168-.492.136a19.949,19.949,0,0,1,1.465,6.066l.255-.255-3.017.306c-.323.033-.327.543,0,.509h0Z"
              transform="translate(-895.923 -1032.683)"
              fill="#414042"
            />
            <path
              id="Path_101305"
              data-name="Path 101305"
              d="M831.41,1063.408q-.376,3.079-.751,6.159c-.04.325.47.322.509,0q.376-3.079.752-6.159c.04-.325-.47-.322-.509,0Z"
              transform="translate(-817.908 -1034.621)"
              fill="#414042"
            />
            <path
              id="Path_101306"
              data-name="Path 101306"
              d="M849.609,1065.967c-.16.97-.3,1.942-.429,2.916a19.3,19.3,0,0,0-.175,3.035l.314.178-.007-.026a.255.255,0,0,0-.492.136l.007.026a.258.258,0,0,0,.314.178l.026-.007a.263.263,0,0,0,.187-.245q.246-3.043.746-6.054c.053-.321-.438-.459-.492-.135h0Z"
              transform="translate(-834.875 -1037.068)"
              fill="#414042"
            />
            <path
              id="Path_101307"
              data-name="Path 101307"
              d="M833.372,824.125a3.96,3.96,0,0,0,1.69,2.014.255.255,0,0,0,.257-.44,3.4,3.4,0,0,1-1.455-1.709c-.116-.3-.609-.172-.492.135Z"
              transform="translate(-820.429 -810.942)"
              fill="#414042"
            />
            <path
              id="Path_101308"
              data-name="Path 101308"
              d="M878.755,864.657a6.283,6.283,0,0,0,2.068.268,2.841,2.841,0,0,0,1.5-.3c.246-.218-.115-.577-.36-.36a4.022,4.022,0,0,1-.78.128,5.779,5.779,0,0,1-.714.033,5.894,5.894,0,0,1-1.575-.256.255.255,0,0,0-.135.492h0Z"
              transform="translate(-862.691 -848.639)"
              fill="#414042"
            />
            <path
              id="Path_101309"
              data-name="Path 101309"
              d="M646.939,1161.2c.046,1.814.106,3.629.2,5.441.026.518.054,1.037.092,1.555a2.768,2.768,0,0,0,.058.7c.1.24-.079.32.194.153a7.261,7.261,0,0,1-2.2.373c-1.272.2-2.549.386-3.833.492a10.481,10.481,0,0,1-1.4.06c-.391-.021-.367-.069-.769-.323-.692-.438-1.86-.916-2.6-.308a2.573,2.573,0,0,0-.623,1.681,14.7,14.7,0,0,0,.4,6.01c.135.434.31.977.768,1.158.983.389,1.979-.642,2.261-1.461a8.105,8.105,0,0,1,.76-2.38c.062-.087.516-.585.32-.5-.16.068-.05.033.056.041.763.052,1.518.139,2.284.158,2.472.062,5.26-.1,7.448-1.371,2.113-1.227,2.844-3.875,3.231-6.13a25.691,25.691,0,0,0,.376-5.069c-.01-.327-.519-.329-.509,0a20.78,20.78,0,0,1-1.077,7.732,5.713,5.713,0,0,1-4.083,3.77,18.441,18.441,0,0,1-5.932.538c-.8-.037-1.7-.395-2.23.154a3.972,3.972,0,0,0-.981,1.92,3.748,3.748,0,0,1-.321,1.36c-.245.4-1.025,1.1-1.514.714a1.594,1.594,0,0,1-.367-.769,14.4,14.4,0,0,1-.472-4.8,6.1,6.1,0,0,1,.263-1.9c.441-1.151,1.758-.384,2.5.041,1.158.661,3.149.106,4.42-.066q2.006-.272,4-.639a.254.254,0,0,0,.187-.246,76.379,76.379,0,0,1-.391-8.084.255.255,0,0,0-.509,0h0Z"
              transform="translate(-635.911 -1126.007)"
              fill="#414042"
            />
            <path
              id="Path_101310"
              data-name="Path 101310"
              d="M683.61,1300.226a7.721,7.721,0,0,0,.143,4.088c.1.312.589.179.492-.135a7.2,7.2,0,0,1-.143-3.817c.074-.319-.417-.456-.492-.135Z"
              transform="translate(-680.292 -1255.993)"
              fill="#414042"
            />
            <path
              id="Path_101311"
              data-name="Path 101311"
              d="M707.7,1298.474a11.543,11.543,0,0,0,.028,3.394c.05.323.541.186.492-.135a10.694,10.694,0,0,1-.027-3.123c.044-.321-.446-.459-.492-.135Z"
              transform="translate(-702.896 -1254.354)"
              fill="#414042"
            />
            <path
              id="Path_101312"
              data-name="Path 101312"
              d="M898.771,1165.02q1.655,3.215,3.483,6.336c.964,1.639,2.122,3.21,3,4.891.522,1,1.642,4.236,3.252,3.541a9.2,9.2,0,0,0,2.654-2.33c.622-.676,1.727-1.7,1.9-2.655.151-.843-.691-.859-1.3-.733a12,12,0,0,0-1.739.573c-.855.319-1.434-.212-1.794-.973-2.311-4.879-3.655-10.192-5-15.4a.255.255,0,0,0-.492.135,108.736,108.736,0,0,0,3.634,12.074c.362.933.759,1.853,1.144,2.777a4.087,4.087,0,0,0,.706,1.347,1.679,1.679,0,0,0,2.235.416,5.244,5.244,0,0,1,1.61-.488c.818,0,.306.614.005,1.04a17.442,17.442,0,0,1-2.6,2.859c-.313.282-.778.814-1.208.914-.559.131-1-.568-1.269-.964a21.765,21.765,0,0,1-1.3-2.433c-.863-1.668-2.025-3.228-2.979-4.852q-1.832-3.117-3.483-6.336c-.15-.292-.59-.034-.44.257h0Z"
              transform="translate(-881.536 -1123.336)"
              fill="#414042"
            />
            <path
              id="Path_101313"
              data-name="Path 101313"
              d="M1003,1402.8q1.265-.889,2.483-1.838c.259-.2-.1-.56-.36-.36q-1.168.909-2.38,1.759c-.266.187-.012.629.257.44h0Z"
              transform="translate(-978.621 -1349.916)"
              fill="#414042"
            />
            <path
              id="Path_101314"
              data-name="Path 101314"
              d="M1011.331,1417.044a7.755,7.755,0,0,0,2.7-2.235c.2-.259-.242-.513-.44-.257a7.214,7.214,0,0,1-2.516,2.052c-.293.147-.036.586.257.44h0Z"
              transform="translate(-986.393 -1362.906)"
              fill="#414042"
            />
            <path
              id="Path_101315"
              data-name="Path 101315"
              d="M651.515,1290.05a27.411,27.411,0,0,0,.3,8.167c.06.322.551.186.492-.136a26.957,26.957,0,0,1-.278-8.031c.037-.325-.473-.323-.509,0h0Z"
              transform="translate(-650.329 -1246.427)"
              fill="#414042"
            />
            <path
              id="Path_101316"
              data-name="Path 101316"
              d="M1027.279,1447.289a18.972,18.972,0,0,1,2.364-2.2c.258-.2-.1-.561-.36-.36a18.993,18.993,0,0,0-2.364,2.2c-.22.242.14.6.36.36Z"
              transform="translate(-1001.259 -1391.152)"
              fill="#414042"
            />
            <path
              id="Path_101317"
              data-name="Path 101317"
              d="M1077.213,1408.986a10.9,10.9,0,0,0,1.46-1.84c.175-.278-.265-.534-.44-.257a10.293,10.293,0,0,1-1.38,1.737c-.23.234.13.594.36.36h0Z"
              transform="translate(-1047.919 -1355.733)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106501"
            data-name="Group 106501"
            transform="translate(100.022 8.242)"
          >
            <path
              id="Path_101318"
              data-name="Path 101318"
              d="M1117.978,181.6a49.172,49.172,0,0,0,12.251-4.66,12.892,12.892,0,0,0,4.347-3.367c.185-.272-.256-.527-.44-.257-1.007,1.478-2.955,2.518-4.465,3.353a49.459,49.459,0,0,1-11.829,4.44.255.255,0,0,0,.135.492Z"
              transform="translate(-1111.8 -163.51)"
              fill="#414042"
            />
            <path
              id="Path_101319"
              data-name="Path 101319"
              d="M1100.067,161.255c1-.173,2.419-.27,2.844.836a10.477,10.477,0,0,1,.319,5.244,6.277,6.277,0,0,1-1.9,3.83,15.472,15.472,0,0,1-3.631,2.328,19.457,19.457,0,0,1-8.2,2.3c-2.953-.009-4.453-2.733-5.093-5.276a.255.255,0,0,0-.492.135c.51,2.031,1.549,4.306,3.547,5.241,2.1.983,4.914.133,6.981-.539a20.239,20.239,0,0,0,7.166-3.755c2.187-1.938,2.546-5.175,2.164-7.935-.135-.974-.251-2.331-1.274-2.776a4.678,4.678,0,0,0-2.569-.124c-.323.056-.186.547.135.492h0Z"
              transform="translate(-1080.255 -151.781)"
              fill="#414042"
            />
            <path
              id="Path_101320"
              data-name="Path 101320"
              d="M1206.851,336.6a2.617,2.617,0,0,1,.342.9.259.259,0,0,0,.313.178,32.39,32.39,0,0,0,8.712-3.6.258.258,0,0,0,.117-.288l-.406-1.1c-.113-.305-.6-.173-.492.135.122.33.362.67.187,1.017-.111.22-.78.445-1.024.576q-1.193.641-2.439,1.174a31.813,31.813,0,0,1-4.791,1.6l.313.178a4.306,4.306,0,0,0-.393-1.017c-.154-.29-.594-.033-.44.257h0Z"
              transform="translate(-1195.122 -312.39)"
              fill="#414042"
            />
            <path
              id="Path_101321"
              data-name="Path 101321"
              d="M1035.7,204.449c-.77,1.195-2.22,3.193-3.889,2.711s1.182-2.1.331-3.017c-.374-.4-1.275-.281-1.736-.292-.355-.008-1.236.069-1.516-.156-.494-.4.339-.977.674-1.288,1.139-1.059,2.271-1.88,3.86-1.445.8.22,1.607.439,2.429.581.321.055.458-.436.136-.492a24.01,24.01,0,0,0-3.453-.8c-1.288-.018-2.446.978-3.333,1.8-.388.36-1.4,1.143-.972,1.8s1.895.486,2.535.513c.208.009.95-.078,1.029.234.038.149-.327.566-.4.682a3.193,3.193,0,0,0-.623,1.195c-.119.787.512,1.157,1.223,1.22,1.886.168,3.231-1.561,4.15-2.988.178-.276-.263-.532-.44-.257h0Z"
              transform="translate(-1028.13 -188.788)"
              fill="#414042"
            />
            <path
              id="Path_101322"
              data-name="Path 101322"
              d="M1130.694,208.829a2.157,2.157,0,0,0-2.15,2.011,1.832,1.832,0,0,0,1.564,2.08c1.194.127,2.787-.667,2.967-1.951.2-1.395-1.19-2.109-2.381-2.139a.255.255,0,0,0,0,.509c.886.023,2.061.507,1.872,1.6a2.279,2.279,0,0,1-2.508,1.467,1.348,1.348,0,0,1-1-1.561,1.643,1.643,0,0,1,1.641-1.5c.327-.01.329-.519,0-.509Z"
              transform="translate(-1121.963 -196.809)"
              fill="#414042"
            />
            <path
              id="Path_101323"
              data-name="Path 101323"
              d="M1064.518,105.623a23.734,23.734,0,0,0-.367-4.141c-.231-1.285-.669-3.572-2.262-3.83a3.409,3.409,0,0,0-2.639.868,3.85,3.85,0,0,1-1.339.9,15.473,15.473,0,0,0-1.847.33c-1.773.74-2.442,2.91-.19,3.375,1.4.288,2.812.458,4.2.775,1.315.3,3.143.662,3.967,1.847.186.268.628.013.44-.257-1.332-1.915-4.591-2.188-6.68-2.545-.933-.16-3.674-.245-2.7-1.8.879-1.4,2.531-.8,3.722-1.613.943-.642,2.061-1.961,3.358-1.252.813.444,1.106,1.7,1.3,2.516a20.877,20.877,0,0,1,.518,4.823A.255.255,0,0,0,1064.518,105.623Z"
              transform="translate(-1052.721 -92.88)"
              fill="#414042"
            />
            <path
              id="Path_101324"
              data-name="Path 101324"
              d="M1218.864,87.833a8.374,8.374,0,0,0,1.715-6.038c-.129-1.261-.332-2.763,1.149-3.232,1.133-.358,2.359-.164,3.417-.786.385-.226.686-.607,1.144-.215.656.562-.322,1.479-.577,2.034-.5,1.09-.134,2.265-.433,3.392-.434,1.637-2.633,2.346-4,3.056q-1.356.7-2.723,1.389c-.293.147-.035.587.257.44q1.156-.578,2.3-1.173a17.1,17.1,0,0,0,3.8-2.15,3.518,3.518,0,0,0,.992-2.682,5.466,5.466,0,0,1,.209-1.913c.216-.562.675-1.008.872-1.574a1.087,1.087,0,0,0-.84-1.453c-.64-.185-.971.291-1.51.545-1.557.734-4.107-.011-4.591,2.217a5.936,5.936,0,0,0,0,1.934,7.834,7.834,0,0,1-1.544,5.848c-.2.253.155.616.36.36Z"
              transform="translate(-1205.969 -73.503)"
              fill="#414042"
            />
            <path
              id="Path_101325"
              data-name="Path 101325"
              d="M1162.043,198.327l.789-.456a.255.255,0,0,0-.257-.44l-.789.456a.255.255,0,0,0,.257.44Z"
              transform="translate(-1152.921 -186.123)"
              fill="#414042"
            />
            <path
              id="Path_101326"
              data-name="Path 101326"
              d="M1200.3,172.471a13.332,13.332,0,0,1,2.746-.93c.32-.071.185-.563-.135-.492a13.962,13.962,0,0,0-2.868.982c-.3.139-.039.578.257.44Z"
              transform="translate(-1188.664 -161.496)"
              fill="#414042"
            />
            <path
              id="Path_101327"
              data-name="Path 101327"
              d="M1232.42,137.489a19.757,19.757,0,0,1-3.76,5.946c-.221.242.138.6.36.36a20.44,20.44,0,0,0,3.892-6.171c.123-.3-.37-.436-.492-.135h0Z"
              transform="translate(-1215.468 -129.98)"
              fill="#414042"
            />
            <path
              id="Path_101328"
              data-name="Path 101328"
              d="M1140.087,146.683c1.627,1.052,3.262,2.233,3.882,4.158.1.311.593.178.492-.135-.663-2.059-2.37-3.333-4.116-4.463-.276-.179-.532.262-.257.44Z"
              transform="translate(-1132.648 -138.281)"
              fill="#414042"
            />
            <path
              id="Path_101329"
              data-name="Path 101329"
              d="M1100.191,245a9.048,9.048,0,0,1,1.652-.77c.308-.107.175-.6-.135-.492a9.729,9.729,0,0,0-1.774.821.255.255,0,0,0,.257.44h0Z"
              transform="translate(-1095.119 -229.421)"
              fill="#414042"
            />
            <path
              id="Path_101330"
              data-name="Path 101330"
              d="M1144.787,230.846a.713.713,0,0,0-.182.873.722.722,0,0,0,.825.338.255.255,0,0,0-.135-.492c-.253.071-.33-.216-.148-.358a.256.256,0,0,0,0-.36.261.261,0,0,0-.36,0h0Z"
              transform="translate(-1136.908 -217.317)"
              fill="#414042"
            />
            <path
              id="Path_101331"
              data-name="Path 101331"
              d="M1199.1,25.291a2.28,2.28,0,0,0-1.748,2.654,1.988,1.988,0,0,0,2.586,1.352,2.279,2.279,0,0,0,1.77-2.542,1.987,1.987,0,0,0-2.609-1.464c-.319.077-.184.569.135.492a1.477,1.477,0,0,1,1.97,1.053,1.769,1.769,0,0,1-1.4,1.971,1.477,1.477,0,0,1-1.959-1,1.769,1.769,0,0,1,1.392-2.027c.313-.095.179-.587-.135-.492Z"
              transform="translate(-1186.215 -25.212)"
              fill="#414042"
            />
            <path
              id="Path_101332"
              data-name="Path 101332"
              d="M1216.549,56.019a.511.511,0,0,0,.575.742.261.261,0,0,0,.178-.314.257.257,0,0,0-.314-.178c-.071.025.067.007,0,0a.038.038,0,0,1,.03.017.3.3,0,0,1-.035-.035c.016.018.016.015,0-.01.01.024.011.021,0-.007a.06.06,0,0,1,0,.043q-.019.036.006,0c.18-.275-.261-.531-.44-.257h0Z"
              transform="translate(-1204.148 -53.893)"
              fill="#414042"
            />
            <path
              id="Path_101333"
              data-name="Path 101333"
              d="M1361.334,76.882a31.925,31.925,0,0,0,3.4-2.342l-.426-.113c.116.858.079,1.665-.787,2.1-.538.268-1.813.765-2.257.169-.194-.261-.636-.007-.44.257.659.886,1.922.467,2.775.1,1.215-.529,1.363-1.552,1.2-2.756-.029-.213-.3-.213-.426-.113a31.076,31.076,0,0,1-3.3,2.262.255.255,0,0,0,.257.44h0Z"
              transform="translate(-1339.003 -70.913)"
              fill="#414042"
            />
            <path
              id="Path_101334"
              data-name="Path 101334"
              d="M1086.018,54.428a7.764,7.764,0,0,1,3.815-1.608.259.259,0,0,0,.18-.435,2.565,2.565,0,0,0-4.48,1.9c.019.326.528.328.509,0a2.057,2.057,0,0,1,3.61-1.535l.18-.435a8.4,8.4,0,0,0-4.175,1.758c-.257.2.105.561.36.36Z"
              transform="translate(-1081.771 -49.766)"
              fill="#414042"
            />
            <path
              id="Path_101335"
              data-name="Path 101335"
              d="M1140.548,336.411a1.667,1.667,0,0,0,2.251,1.255c.3-.116.172-.609-.135-.492a1.165,1.165,0,0,1-1.624-.9c-.061-.322-.552-.185-.492.135h0Z"
              transform="translate(-1133.183 -315.741)"
              fill="#414042"
            />
            <path
              id="Path_101336"
              data-name="Path 101336"
              d="M1189.6,353.119h.078a.255.255,0,0,0,0-.509h-.078a.255.255,0,0,0,0,.509Z"
              transform="translate(-1178.804 -331.178)"
              fill="#414042"
            />
            <path
              id="Path_101337"
              data-name="Path 101337"
              d="M1361.224,192.348l.931.6c.192.123.37-.183.179-.306l-.931-.6c-.193-.123-.371.183-.179.306Z"
              transform="translate(-1339.342 -181.094)"
              fill="#414042"
            />
            <path
              id="Path_101338"
              data-name="Path 101338"
              d="M1347.026,201.02l1.134.65a.177.177,0,0,0,.179-.306l-1.134-.65a.177.177,0,0,0-.179.306Z"
              transform="translate(-1326.07 -189.202)"
              fill="#414042"
            />
            <path
              id="Path_101339"
              data-name="Path 101339"
              d="M1371.834,213.976l.469.234c.2.1.383-.2.179-.306l-.469-.234c-.2-.1-.383.2-.179.306Z"
              transform="translate(-1349.25 -201.314)"
              fill="#414042"
            />
            <path
              id="Path_101340"
              data-name="Path 101340"
              d="M1333.018,216.423a27.614,27.614,0,0,1,2.731,1.135c.2.1.385-.208.179-.306a28.4,28.4,0,0,0-2.815-1.17c-.215-.077-.308.266-.094.342Z"
              transform="translate(-1312.946 -203.577)"
              fill="#414042"
            />
            <path
              id="Path_101341"
              data-name="Path 101341"
              d="M1247,166.987l.988,1.225c.143.177.393-.075.251-.251q-.494-.613-.988-1.225c-.143-.177-.393.075-.251.251Z"
              transform="translate(-1232.629 -157.415)"
              fill="#414042"
            />
            <path
              id="Path_101342"
              data-name="Path 101342"
              d="M1248.856,154.352l1.326,1.477c.152.17.4-.081.251-.251l-1.326-1.477c-.152-.17-.4.081-.251.251Z"
              transform="translate(-1234.363 -145.611)"
              fill="#414042"
            />
            <path
              id="Path_101343"
              data-name="Path 101343"
              d="M1259.325,147.447l.918,1.07c.149.173.4-.079.251-.251l-.918-1.07c-.149-.173-.4.079-.251.251Z"
              transform="translate(-1244.148 -139.157)"
              fill="#414042"
            />
            <path
              id="Path_101344"
              data-name="Path 101344"
              d="M1170.38,172.619q.068.591.136,1.183c.026.224.38.227.355,0q-.068-.591-.136-1.183c-.026-.224-.38-.227-.354,0h0Z"
              transform="translate(-1161.067 -162.812)"
              fill="#414042"
            />
            <path
              id="Path_101345"
              data-name="Path 101345"
              d="M1158.609,161.691a5.374,5.374,0,0,0,0,1.989c.042.224.384.129.342-.094a4.867,4.867,0,0,1,0-1.8c.041-.223-.3-.319-.342-.094Z"
              transform="translate(-1149.982 -152.637)"
              fill="#414042"
            />
            <path
              id="Path_101346"
              data-name="Path 101346"
              d="M1142.411,163.772q-.074.7-.147,1.4c-.023.226.331.225.354,0q.073-.7.146-1.4c.024-.227-.331-.225-.355,0h0Z"
              transform="translate(-1134.792 -154.543)"
              fill="#414042"
            />
            <path
              id="Path_101347"
              data-name="Path 101347"
              d="M1097.685,283.6a.613.613,0,0,0,.143.643c.16.163.41-.088.251-.251a.265.265,0,0,1-.052-.3.178.178,0,0,0-.124-.218.181.181,0,0,0-.218.124Z"
              transform="translate(-1093.096 -266.563)"
              fill="#414042"
            />
            <path
              id="Path_101348"
              data-name="Path 101348"
              d="M1108.734,276.616l.234.117c.2.1.383-.2.179-.306l-.234-.117c-.2-.1-.383.2-.179.306Z"
              transform="translate(-1103.374 -259.853)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106503"
            data-name="Group 106503"
            transform="translate(132.668 31.354)"
          >
            <path
              id="Path_101349"
              data-name="Path 101349"
              d="M1528.462,383.2c-2.953,1.776-1.141,5.7-.4,8.282.5,1.766,1.025,3.528,1.623,5.264a18.291,18.291,0,0,0,1.7,3.981,1.481,1.481,0,0,0,1.471.89,14.038,14.038,0,0,0,2.681-.613c2.959-.841,5.87-1.863,8.763-2.906,2.326-.839,4.7-1.644,6.948-2.686,2.139-.993.956-3.61.473-5.384a73.6,73.6,0,0,0-3.027-9.226,5.385,5.385,0,0,0-1.374-2.378c-.453-.295-1.068-.106-1.565-.02-3.271.566-6.5,1.5-9.7,2.385-1.657.46-3.312.933-4.953,1.45a14.662,14.662,0,0,0-2.642.96c-.288.158-.031.6.257.44a28.11,28.11,0,0,1,5.674-1.851c2.825-.811,5.666-1.575,8.525-2.254,1.024-.243,2.053-.489,3.092-.66.729-.12.992-.187,1.411.474,1.428,2.256,2.127,5.151,2.9,7.679.373,1.22.73,2.446,1.055,3.68.278,1.057,1.152,3.065.248,3.9a5.475,5.475,0,0,1-1.635.789c-1.037.425-2.086.825-3.136,1.22-2.7,1.015-5.425,1.984-8.169,2.88-1.2.392-2.4.772-3.617,1.108a8.059,8.059,0,0,1-2.369.515c-.881-.053-1.316-1.422-1.618-2.117a48.541,48.541,0,0,1-1.8-5.182c-.479-1.574-.92-3.16-1.365-4.744-.536-1.9-1.218-4.218.808-5.437a.255.255,0,0,0-.257-.44Z"
              transform="translate(-1526.831 -378.27)"
              fill="#414042"
            />
            <path
              id="Path_101350"
              data-name="Path 101350"
              d="M1540.7,459.858q.794,3.281,1.688,6.536a48.653,48.653,0,0,0,2.793,8.657c.269.549.5.992,1.148,1a9.858,9.858,0,0,0,2.819-.642c3.177-.949,6.292-2.118,9.394-3.285q3.359-1.264,6.7-2.589c.3-.12.17-.613-.135-.492-4.728,1.887-9.491,3.728-14.328,5.318-1.142.376-2.294.752-3.468,1.017-.7.158-1.152.365-1.538-.3a17.111,17.111,0,0,1-1.274-3.308c-.522-1.609-.988-3.236-1.438-4.867q-.988-3.579-1.866-7.188c-.077-.319-.569-.184-.491.135h0Z"
              transform="translate(-1539.787 -454.219)"
              fill="#414042"
            />
            <path
              id="Path_101351"
              data-name="Path 101351"
              d="M1655.744,434.328a57.421,57.421,0,0,1-8.421,2.725l.314.178c-.35-2.01.021-4.787,2.167-5.623,2.474-.964,4.827.9,5.788,3.094.131.3.571.041.44-.257-1.091-2.488-3.859-4.445-6.585-3.236-2.279,1.011-2.685,3.956-2.3,6.157a.259.259,0,0,0,.313.178,57.417,57.417,0,0,0,8.421-2.725c.3-.113.173-.606-.135-.492Z"
              transform="translate(-1639.15 -427.4)"
              fill="#414042"
            />
            <g
              id="Group_106502"
              data-name="Group 106502"
              transform="translate(4.357 3.983)"
            >
              <path
                id="Path_101352"
                data-name="Path 101352"
                d="M1608.45,444.091s3.324-1.33,3.766-1.108,3.323,9.3,2.658,9.748-13.958,5.1-14.4,4.874-3.1-9.527-2.88-9.97,3.323-1.33,3.323-1.33l.221,2.215,8.419-2.658-1.108-1.773Z"
                transform="translate(-1597.306 -442.706)"
                fill="#cececf"
              />
              <path
                id="Path_101353"
                data-name="Path 101353"
                d="M1604.6,440.74q.8-.318,1.611-.6c.45-.156,1.654-.728,2.01-.424.3.252.444,1.061.572,1.418.3.848.58,1.707.842,2.57a23.949,23.949,0,0,1,1.144,4.677c.041.453.086.467-.217.664a7.919,7.919,0,0,1-1.5.587q-4.724,1.768-9.536,3.306c-.618.2-1.237.394-1.86.571-.224.064-.827.342-1.062.252.192.074-.04-.255-.09-.372-.09-.21-.164-.429-.24-.644-.282-.795-.531-1.6-.775-2.408-.533-1.765-1.058-3.548-1.439-5.353-.038-.181-.2-.589-.135-.77.091-.27.636-.412.919-.524.726-.285,1.477-.518,2.226-.734l-.323-.245q.111,1.108.221,2.215a.258.258,0,0,0,.323.245l8.419-2.658a.258.258,0,0,0,.153-.374l-1.108-1.773c-.174-.278-.615-.022-.44.257l1.108,1.773.152-.374-8.419,2.658.323.245q-.111-1.108-.221-2.215a.258.258,0,0,0-.323-.245,24.444,24.444,0,0,0-2.329.774c-.438.175-1.085.349-1.195.865a4.265,4.265,0,0,0,.276,1.55c.224.961.483,1.915.75,2.865a36.548,36.548,0,0,0,1.651,5.17c.38.842.93.535,1.712.313,3.773-1.073,7.491-2.426,11.165-3.792.586-.218,2.063-.479,2.316-1.153a3.513,3.513,0,0,0-.141-1.627c-.19-.973-.451-1.933-.723-2.886-.315-1.1-.658-2.2-1.037-3.286a5.953,5.953,0,0,0-.782-1.915c-.388-.418-.976-.173-1.471-.033a27.392,27.392,0,0,0-2.66.938c-.3.12-.169.613.135.492Z"
                transform="translate(-1593.387 -439.11)"
                fill="#414042"
              />
            </g>
            <path
              id="Path_101354"
              data-name="Path 101354"
              d="M1663.655,491.289h.3a.255.255,0,0,0,0-.509h-.3a.255.255,0,0,0,0,.509Z"
              transform="translate(-1654.468 -483.415)"
              fill="#414042"
            />
            <path
              id="Path_101355"
              data-name="Path 101355"
              d="M1692.2,448.365l.156.44a.262.262,0,0,0,.314.178.257.257,0,0,0,.178-.314l-.156-.44a.262.262,0,0,0-.313-.178.257.257,0,0,0-.178.314Z"
              transform="translate(-1681.366 -443.475)"
              fill="#414042"
            />
            <path
              id="Path_101356"
              data-name="Path 101356"
              d="M1672.378,468.639l.3.3a.255.255,0,0,0,.36-.36l-.3-.3a.255.255,0,0,0-.36.36Z"
              transform="translate(-1662.78 -462.317)"
              fill="#414042"
            />
            <path
              id="Path_101357"
              data-name="Path 101357"
              d="M1724.2,450.535v.148a.255.255,0,0,0,.509,0v-.148a.255.255,0,0,0-.509,0Z"
              transform="translate(-1711.28 -445.574)"
              fill="#414042"
            />
            <path
              id="Path_101358"
              data-name="Path 101358"
              d="M1744.717,468.278l-.148.148a.255.255,0,0,0,.36.36l.148-.148a.255.255,0,0,0-.36-.36Z"
              transform="translate(-1730.245 -462.316)"
              fill="#414042"
            />
            <path
              id="Path_101359"
              data-name="Path 101359"
              d="M1532.637,483.32l-.748,2.747a.177.177,0,0,0,.342.094l.748-2.747a.177.177,0,0,0-.342-.094Z"
              transform="translate(-1531.551 -476.326)"
              fill="#414042"
            />
            <path
              id="Path_101360"
              data-name="Path 101360"
              d="M1541.332,505.453l-.664,2.743c-.054.222.288.316.342.094l.664-2.743c.054-.222-.288-.316-.342-.094Z"
              transform="translate(-1539.757 -497.009)"
              fill="#414042"
            />
            <path
              id="Path_101361"
              data-name="Path 101361"
              d="M1546.044,532.453l-.882,2.959a.177.177,0,0,0,.342.094l.882-2.959a.177.177,0,0,0-.342-.094Z"
              transform="translate(-1543.954 -522.244)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106504"
            data-name="Group 106504"
            transform="translate(134.423 54.873)"
          >
            <path
              id="Path_101362"
              data-name="Path 101362"
              d="M1586.851,762.287a40.068,40.068,0,0,0-4.2.357c-.969.135-3.575.286-3.845,1.569-.44,2.084,3.81,2.4,4.985,2.355a14.361,14.361,0,0,0,3.68-.79c.8-.248.966.107,1.411.7,1.848,2.46,5.087,3.138,7.956,3.139a.255.255,0,0,0,0-.509,9.867,9.867,0,0,1-5.027-1.03,8.4,8.4,0,0,1-2.3-1.633c-.243-.27-.389-.619-.634-.882a1.254,1.254,0,0,0-1.214-.378,24.682,24.682,0,0,1-4.034.881c-.689.016-4.931-.327-4.3-1.85.268-.643,1.831-.8,2.389-.909a33.749,33.749,0,0,1,5.128-.509c.327-.011.329-.52,0-.509Z"
              transform="translate(-1577.129 -760.668)"
              fill="#414042"
            />
            <path
              id="Path_101363"
              data-name="Path 101363"
              d="M1698.981,742.169a4.583,4.583,0,0,1-.679-1.038c-.534-1.127-.141-1.854.866-2.514a2.664,2.664,0,0,1,1.414-.567c.837.046.973.959,1.2,1.61.211.6.431,1.193.666,1.783.12.3.613.169.492-.136-.165-.414-.322-.832-.475-1.251a7.937,7.937,0,0,0-.763-1.957c-.708-.975-1.978-.454-2.8.078-.9.583-1.576,1.265-1.339,2.4a4.486,4.486,0,0,0,1.049,1.952c.216.247.575-.114.36-.36h0Z"
              transform="translate(-1688.104 -737.552)"
              fill="#414042"
            />
            <path
              id="Path_101364"
              data-name="Path 101364"
              d="M1561.947,784.8c-1.46.653-1.67,2.768-1.587,4.118.02.326.53.328.509,0-.071-1.172.043-3.1,1.335-3.678.3-.134.04-.573-.257-.44Z"
              transform="translate(-1559.906 -781.681)"
              fill="#414042"
            />
            <path
              id="Path_101365"
              data-name="Path 101365"
              d="M1554.835,850.239a20.421,20.421,0,0,1-.524-2.8,8.615,8.615,0,0,1-.045-2.121,6.932,6.932,0,0,1,.158-.842,3.229,3.229,0,0,0,.338-.018c3.3.058,5.861,2.874,6.646,5.913a.255.255,0,0,0,.492-.135c-.835-3.233-3.663-6.345-7.21-6.288-1.96.031-.64,5.289-.346,6.424a.255.255,0,0,0,.492-.135h0Z"
              transform="translate(-1553.637 -836.984)"
              fill="#414042"
            />
            <path
              id="Path_101366"
              data-name="Path 101366"
              d="M1691.356,813.589a12.734,12.734,0,0,0,4.694,4.089,12.19,12.19,0,0,0,5.466.762c.326-.02.328-.53,0-.509a12.273,12.273,0,0,1-5-.611,11.7,11.7,0,0,1-4.719-3.987c-.2-.258-.638,0-.44.257h0Z"
              transform="translate(-1682.294 -808.271)"
              fill="#414042"
            />
            <path
              id="Path_101367"
              data-name="Path 101367"
              d="M1561.158,850.436c-.465,1.11,0,2.494,1.3,2.471.934-.016,1.871-.09,2.8-.132,3.481-.156,6.962-.308,10.442-.475,2.518-.12,5.085-.129,7.59-.431,1.161-.14,3.278-.956,3.488-2.361a4.36,4.36,0,0,0-.558-1.913,9.257,9.257,0,0,0-.8-1.885,2.956,2.956,0,0,0-4.034-1.306c-2.062,1.132-2.5,3.862-2.408,5.984.014.327.524.329.509,0-.086-1.919.251-4.523,2.156-5.544,1.7-.908,3.068.377,3.729,1.875.181.409.272.835.423,1.251.119.328.255.616.353.96.189.668-.047.969-.547,1.41a5.109,5.109,0,0,1-3.227,1.1c-5.128.357-10.273.525-15.408.755q-1.747.078-3.494.158a7.243,7.243,0,0,1-.951.047c-.951-.087-1.228-.984-.877-1.823.126-.3-.367-.434-.492-.135h0Z"
              transform="translate(-1560.502 -837.065)"
              fill="#414042"
            />
            <path
              id="Path_101368"
              data-name="Path 101368"
              d="M1739.483,797.867c.7-1.254,1.87-2.674,3.279-1.3.235.228.6-.132.36-.36a2.035,2.035,0,0,0-2.2-.611,3.973,3.973,0,0,0-1.877,2.019c-.159.287.281.544.44.257h0Z"
              transform="translate(-1726.874 -791.678)"
              fill="#414042"
            />
            <path
              id="Path_101369"
              data-name="Path 101369"
              d="M1764.926,811.075c.562-.948,1.851-2.761,3.115-1.588.24.223.6-.137.36-.36a1.877,1.877,0,0,0-2.025-.325,4.307,4.307,0,0,0-1.891,2.016.255.255,0,0,0,.44.257h0Z"
              transform="translate(-1750.648 -803.991)"
              fill="#414042"
            />
            <path
              id="Path_101370"
              data-name="Path 101370"
              d="M1787.571,821.34a5.072,5.072,0,0,1,2.173-2.192c.291-.153.033-.592-.257-.44a5.536,5.536,0,0,0-2.355,2.374c-.15.291.289.549.44.257Z"
              transform="translate(-1771.817 -813.366)"
              fill="#414042"
            />
            <path
              id="Path_101371"
              data-name="Path 101371"
              d="M1820.094,819.173c.355.7,1.212.818,1.906,1,.981.259,1.972.483,2.945.774a.255.255,0,0,0,.135-.492c-.716-.214-1.443-.39-2.168-.575-.667-.169-2.036-.3-2.377-.966-.149-.292-.589-.035-.44.257h0Z"
              transform="translate(-1802.624 -813.469)"
              fill="#414042"
            />
            <path
              id="Path_101372"
              data-name="Path 101372"
              d="M1567.368,910.219c5.1-.12,10.2.17,15.293.006a33.277,33.277,0,0,0,6.133-.613,4.994,4.994,0,0,0,3.221-1.686c.182-.274-.259-.53-.44-.257-.734,1.107-2.452,1.386-3.655,1.6a41.931,41.931,0,0,1-6.443.479c-4.7.087-9.406-.146-14.108-.035a.255.255,0,0,0,0,.509h0Z"
              transform="translate(-1566.24 -896.424)"
              fill="#414042"
            />
            <path
              id="Path_101373"
              data-name="Path 101373"
              d="M1723.286,870.921a16.4,16.4,0,0,0-1.86,4.264l.313-.178-.02-.006.153.374.012-.027-.466-.061.032.082c.118.3.611.17.491-.135l-.032-.082c-.069-.176-.369-.285-.465-.061l-.012.028a.26.26,0,0,0,.153.374l.02.006a.259.259,0,0,0,.314-.178,15.938,15.938,0,0,1,1.809-4.142c.173-.28-.268-.536-.44-.257h0Z"
              transform="translate(-1710.423 -862.078)"
              fill="#414042"
            />
            <path
              id="Path_101374"
              data-name="Path 101374"
              d="M1767.4,884.515a11.158,11.158,0,0,0-1.3,3.481c-.062.32.429.458.492.135a10.756,10.756,0,0,1,1.249-3.359.255.255,0,0,0-.44-.257Z"
              transform="translate(-1752.189 -874.779)"
              fill="#414042"
            />
            <path
              id="Path_101375"
              data-name="Path 101375"
              d="M1562.09,836.833a2.733,2.733,0,0,0,1.736.408c.941,0,1.882,0,2.823,0a.255.255,0,0,0,0-.509l-2.159,0a3.5,3.5,0,0,1-2.143-.34c-.265-.194-.519.248-.257.44h0Z"
              transform="translate(-1561.433 -829.878)"
              fill="#414042"
            />
            <path
              id="Path_101376"
              data-name="Path 101376"
              d="M1654.672,841.146a19.674,19.674,0,0,0,3.967-.226c.323-.051.186-.542-.135-.492a19,19,0,0,1-3.832.208c-.328-.015-.327.495,0,.509h0Z"
              transform="translate(-1647.828 -833.69)"
              fill="#414042"
            />
            <path
              id="Path_101377"
              data-name="Path 101377"
              d="M1593.9,790.738a14.749,14.749,0,0,1,7.094-1.018c.326.033.323-.477,0-.509a15.056,15.056,0,0,0-7.23,1.036c-.3.122-.169.615.135.492h0Z"
              transform="translate(-1590.975 -785.756)"
              fill="#414042"
            />
            <path
              id="Path_101378"
              data-name="Path 101378"
              d="M1729.674,921.505l1.028,1.042c.16.163.411-.088.251-.251l-1.028-1.042c-.16-.163-.411.088-.251.251Z"
              transform="translate(-1718.102 -909.18)"
              fill="#414042"
            />
            <path
              id="Path_101379"
              data-name="Path 101379"
              d="M1735.517,906.4q.953,1,1.99,1.911c.171.15.422-.1.251-.251q-1.038-.911-1.99-1.911c-.158-.166-.408.085-.251.251Z"
              transform="translate(-1723.565 -895.058)"
              fill="#414042"
            />
            <path
              id="Path_101380"
              data-name="Path 101380"
              d="M1742.589,890.072a11.562,11.562,0,0,0,1.692,1.776c.173.147.426-.1.251-.251a11.168,11.168,0,0,1-1.637-1.7c-.137-.178-.445,0-.306.179h0Z"
              transform="translate(-1730.186 -879.85)"
              fill="#414042"
            />
            <path
              id="Path_101381"
              data-name="Path 101381"
              d="M1752.287,880.155a22.345,22.345,0,0,1,1.744,1.673c.156.167.406-.084.251-.251a22.366,22.366,0,0,0-1.744-1.673c-.172-.148-.424.1-.251.251Z"
              transform="translate(-1739.228 -870.543)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101382"
            data-name="Path 101382"
            d="M1306.628,886.7l1.108-1.44c.2-.26-.243-.514-.44-.257l-1.108,1.44c-.2.26.243.514.44.257Z"
            transform="translate(-1187.916 -820.38)"
            fill="#fff"
          />
          <path
            id="Path_101383"
            data-name="Path 101383"
            d="M1342.2,866.419l.111-.111a.255.255,0,0,0-.36-.36l-.111.111a.255.255,0,0,0,.36.36Z"
            transform="translate(-1221.211 -802.599)"
            fill="#fff"
          />
          <g
            id="Group_106505"
            data-name="Group 106505"
            transform="translate(103.462 50.093)"
          >
            <path
              id="Path_101384"
              data-name="Path 101384"
              d="M1106.305,716.57a6.185,6.185,0,0,0,5.835-1.975,4.456,4.456,0,0,0,1.225-2.811c-.012-.63-.51-.873-1.043-1.185a4.089,4.089,0,0,0-5.686,1.3,6.218,6.218,0,0,0-.508,4.492c.077.319.568.184.492-.135a6.349,6.349,0,0,1,.018-3.028,3.589,3.589,0,0,1,5.238-2.3c.327.174.934.48,1.017.8.213.816-.78,2.171-1.293,2.7a5.66,5.66,0,0,1-5.157,1.65c-.319-.076-.455.415-.135.492Z"
              transform="translate(-1104.277 -706.998)"
              fill="#414042"
            />
            <path
              id="Path_101385"
              data-name="Path 101385"
              d="M1082.42,672.919c-.832,1-2.039,2.64-1.68,4.023.633,2.438,4.957,1.049,6.359.325,3.363-1.735,4.961-4.845,6.436-8.165.6-1.351,1.746-4.645-.921-4.577-1.934.049-3.947,1.787-5.331,3.005-.247.217.115.576.36.36,1.273-1.119,2.965-2.543,4.683-2.822,1.87-.3,1.585,1.68,1.163,2.823a28.435,28.435,0,0,1-2.325,4.906c-1.691,2.76-5.368,5.635-8.831,4.859-2.327-.522-.45-3.306.446-4.379.209-.25-.15-.612-.36-.36h0Z"
              transform="translate(-1080.675 -664.524)"
              fill="#414042"
            />
            <path
              id="Path_101386"
              data-name="Path 101386"
              d="M1082.988,679.386c.255,3.538,4.538,4.432,7.366,3.735,4.675-1.152,5.16-6.1,6.739-9.832a7.057,7.057,0,0,0,.816-3.492,3.887,3.887,0,0,0-2.247-2.834.255.255,0,0,0-.257.44,3.243,3.243,0,0,1,1.843,3.991c-.315,1.2-.941,2.292-1.339,3.466-.678,2-1.058,4.071-2.459,5.745a6.791,6.791,0,0,1-7.787,1.716,3.753,3.753,0,0,1-2.165-2.933c-.024-.325-.533-.328-.509,0h0Z"
              transform="translate(-1082.837 -666.77)"
              fill="#414042"
            />
            <path
              id="Path_101387"
              data-name="Path 101387"
              d="M1129.677,737.867a1.911,1.911,0,0,0-.452,1.69c.066.321.557.185.492-.135a1.365,1.365,0,0,1,.321-1.195c.217-.244-.142-.606-.36-.36h0Z"
              transform="translate(-1126.007 -732.989)"
              fill="#414042"
            />
            <path
              id="Path_101388"
              data-name="Path 101388"
              d="M1133.1,778.789a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
              transform="translate(-1129.439 -770.833)"
              fill="#414042"
            />
            <path
              id="Path_101389"
              data-name="Path 101389"
              d="M1156.171,889.448a2.408,2.408,0,0,0,1.182.1c.225-.035.13-.376-.094-.342a2.042,2.042,0,0,1-.993-.1c-.216-.075-.309.267-.094.342Z"
              transform="translate(-1151.115 -874.395)"
              fill="#414042"
            />
            <path
              id="Path_101390"
              data-name="Path 101390"
              d="M1194.973,884.195l.6-.126c.223-.047.129-.389-.094-.342l-.6.126c-.223.047-.129.389.094.342Z"
              transform="translate(-1187.284 -869.373)"
              fill="#414042"
            />
            <path
              id="Path_101391"
              data-name="Path 101391"
              d="M1185.714,871.114l.6-.121c.223-.045.129-.387-.094-.342l-.6.121c-.223.045-.129.387.094.342Z"
              transform="translate(-1178.63 -857.154)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106506"
            data-name="Group 106506"
            transform="translate(54.874 52.614)"
          >
            <path
              id="Path_101392"
              data-name="Path 101392"
              d="M340.09,714.814c-.709,1.217-.713,2.807.657,3.533a2.741,2.741,0,0,0,4-2.476l-.384.22c.943.57,2.315.954,3.277.232a2.156,2.156,0,0,0,.556-2.672l-.4.309c1.154,1.24,2.645.468,2.758-1.11l-.5.067a2.264,2.264,0,0,0,2.585,1.659,2.059,2.059,0,0,0,1.623-2.724l-.426.248c1.6,1.4,3.479.238,3.786-1.731.29-1.855-1.25-2.826-2.91-2.886l.22.384c.889-2.072-1.559-3.246-2.763-1.419l.475.128c.118-4-5.653-4.875-7-1.229h.492a1.264,1.264,0,0,0-1.682-.729,2.031,2.031,0,0,0-1.374,2.19l.384-.22c-1.442-1.019-3.4-1.248-4.422.468a4.1,4.1,0,0,0,1.093,5.043l.248-.426c-2.509-.407-2.664,3.9,0,3.511.323-.048.186-.539-.135-.492-1.843.271-1.686-2.8,0-2.529.229.037.454-.238.248-.426a3.635,3.635,0,0,1-1.111-4.247c.817-1.633,2.542-1.368,3.822-.464a.256.256,0,0,0,.384-.22,1.581,1.581,0,0,1,.732-1.585c.418-.229,1.149-.318,1.323.259a.257.257,0,0,0,.492,0c1.159-3.128,6.1-2.308,6,1.094a.257.257,0,0,0,.475.128c.807-1.225,2.534-.613,1.883.9a.259.259,0,0,0,.22.384c1.126.04,2.281.479,2.419,1.741.175,1.606-1.455,3.3-2.935,2.006-.171-.149-.529-.009-.426.248a1.567,1.567,0,0,1-1.267,2.1,1.756,1.756,0,0,1-1.958-1.3.256.256,0,0,0-.5.067c-.083,1.144-1.093,1.6-1.888.749-.209-.225-.516.06-.4.309a1.574,1.574,0,0,1-1.274,2.3,3.467,3.467,0,0,1-1.862-.556.258.258,0,0,0-.384.22c-.094,1.822-2.493,3.372-3.837,1.542a2.2,2.2,0,0,1,.131-2.342.255.255,0,0,0-.44-.257Z"
              transform="translate(-338.437 -703.044)"
              fill="#414042"
            />
            <path
              id="Path_101393"
              data-name="Path 101393"
              d="M406.736,796.231c-.044-.242-.107-.488-.134-.733a1.3,1.3,0,0,1,.587-1.22,1.194,1.194,0,0,1,1.881.666c.116.3.609.172.492-.135a1.76,1.76,0,0,0-2.3-1.191,2.383,2.383,0,0,0-1.079,1.087,2.743,2.743,0,0,0,.059,1.661c.059.322.55.186.492-.135h0Z"
              transform="translate(-401.642 -787.562)"
              fill="#414042"
            />
            <path
              id="Path_101394"
              data-name="Path 101394"
              d="M451.389,795.986a1.284,1.284,0,0,1,.694-.789c.4-.176.965-.055.9.48-.04.325.47.322.509,0a1.01,1.01,0,0,0-1.142-1.072,1.754,1.754,0,0,0-1.452,1.246c-.106.311.386.444.492.135h0Z"
              transform="translate(-443.522 -788.608)"
              fill="#414042"
            />
            <path
              id="Path_101395"
              data-name="Path 101395"
              d="M599.514,790.561a.6.6,0,0,1,.019.763c-.192.267.25.522.44.257a1.107,1.107,0,0,0-.1-1.38c-.22-.244-.579.117-.36.36Z"
              transform="translate(-582.36 -784.419)"
              fill="#414042"
            />
            <path
              id="Path_101396"
              data-name="Path 101396"
              d="M593.3,821.989h.058a.255.255,0,0,0,0-.509H593.3a.255.255,0,0,0,0,.509Z"
              transform="translate(-576.391 -813.727)"
              fill="#414042"
            />
            <path
              id="Path_101397"
              data-name="Path 101397"
              d="M426.219,872.761a65.027,65.027,0,0,1,4.179,4.994.261.261,0,0,0,.288.117l4.7-1.95a.268.268,0,0,0,.187-.245q.077-2.943.172-5.885c.01-.328-.5-.327-.509,0q-.069,2.1-.128,4.2c-.022.812.116,1.358-.642,1.761-.676.359-1.449.6-2.156.894-.6.247-1.305.774-1.849.357a8.142,8.142,0,0,1-1.057-1.345c-.905-1.12-1.852-2.2-2.829-3.261-.223-.242-.583.12-.36.36h0Z"
              transform="translate(-420.408 -858.647)"
              fill="#414042"
            />
            <path
              id="Path_101398"
              data-name="Path 101398"
              d="M469.158,876.2a19.616,19.616,0,0,0,1.773,2.115.257.257,0,0,0,.435-.18l-.249-3.939c-.02-.326-.53-.328-.509,0l.249,3.939.435-.18a18.6,18.6,0,0,1-1.694-2.012c-.191-.263-.633-.008-.44.257h0Z"
              transform="translate(-460.556 -862.766)"
              fill="#414042"
            />
            <path
              id="Path_101399"
              data-name="Path 101399"
              d="M505.012,869.844l1.682,3.228a.257.257,0,0,0,.475-.128,22.814,22.814,0,0,1,.2-2.988c.043-.321-.448-.46-.492-.136a23.977,23.977,0,0,0-.218,3.124l.475-.128-1.682-3.228c-.152-.291-.592-.033-.44.257h0Z"
              transform="translate(-494.078 -858.566)"
              fill="#414042"
            />
            <path
              id="Path_101400"
              data-name="Path 101400"
              d="M439.95,901.77a4.942,4.942,0,0,0-.458,1.417c-.036.223.306.319.342.094a4.637,4.637,0,0,1,.423-1.333c.1-.2-.2-.384-.306-.179h0Z"
              transform="translate(-432.874 -888.677)"
              fill="#414042"
            />
            <path
              id="Path_101401"
              data-name="Path 101401"
              d="M454.091,905.365a5.2,5.2,0,0,0-.475,1.934c-.011.228.343.227.354,0a4.734,4.734,0,0,1,.426-1.755c.094-.206-.211-.386-.306-.179h0Z"
              transform="translate(-446.076 -892.036)"
              fill="#414042"
            />
            <path
              id="Path_101402"
              data-name="Path 101402"
              d="M464.775,908.78q-.318,1.169-.636,2.34a.177.177,0,0,0,.342.094q.318-1.169.636-2.34a.177.177,0,0,0-.342-.094Z"
              transform="translate(-455.904 -895.195)"
              fill="#414042"
            />
          </g>
          <path
            id="Path_101403"
            data-name="Path 101403"
            d="M558,387.342a25.73,25.73,0,0,0,3.549.188.177.177,0,0,0,0-.354,25.725,25.725,0,0,1-3.549-.188c-.226-.027-.224.327,0,.355h0Z"
            transform="translate(-488.598 -355.062)"
            fill="#414042"
          />
          <path
            id="Path_101404"
            data-name="Path 101404"
            d="M634.187,389.287l6.536-.012a.177.177,0,0,0,0-.354l-6.536.012a.178.178,0,0,0,0,.355h0Z"
            transform="translate(-559.794 -356.869)"
            fill="#414042"
          />
          <path
            id="Path_101405"
            data-name="Path 101405"
            d="M576.286,270.335a2.882,2.882,0,0,0-.528,1.3c-.045.321.445.46.492.136a2.552,2.552,0,0,1,.477-1.177c.194-.265-.248-.52-.44-.257h0Z"
            transform="translate(-505.346 -245.944)"
            fill="#414042"
          />
          <path
            id="Path_101406"
            data-name="Path 101406"
            d="M575.571,319.809a.255.255,0,0,0,0-.509.255.255,0,0,0,0,.509Z"
            transform="translate(-504.944 -291.806)"
            fill="#414042"
          />
          <path
            id="Path_101407"
            data-name="Path 101407"
            d="M791.124,159.986l-.5,1.867a.177.177,0,0,0,.342.094l.5-1.867a.177.177,0,0,0-.342-.094Z"
            transform="translate(-706.14 -142.804)"
            fill="#414042"
          />
          <path
            id="Path_101408"
            data-name="Path 101408"
            d="M798.563,154.61q-.485,1.594-.969,3.187c-.058.189.235.319.324.137l.14-.289c.1-.2-.206-.384-.306-.179l-.14.289.324.137q.485-1.594.969-3.187c.067-.219-.276-.312-.342-.094h0Z"
            transform="translate(-712.656 -137.781)"
            fill="#414042"
          />
          <path
            id="Path_101409"
            data-name="Path 101409"
            d="M805.711,146.2l-.831,2.237-.356.958c-.081.219-.288,1.171-.492,1.271l.242.063-.025-.051-.063.242.037-.019c.2-.105.024-.411-.179-.306l-.037.019a.18.18,0,0,0-.063.242l.025.052a.18.18,0,0,0,.242.063c.414-.2.57-1.254.715-1.643l1.128-3.035c.08-.214-.263-.306-.342-.094h0Z"
            transform="translate(-718.576 -129.921)"
            fill="#414042"
          />
          <g
            id="Group_106507"
            data-name="Group 106507"
            transform="translate(37.616 17.296)"
          >
            <path
              id="Path_101410"
              data-name="Path 101410"
              d="M117.3,221.815c-.85-1.235-2.792-.095-2.994,1.106a4.889,4.889,0,0,0,.471,2.173c.363,1.094.764,2.176,1.213,3.238.466,1.1,1.1,3.266,2.58,3.31a2.008,2.008,0,0,0,1.828-1,2.859,2.859,0,0,0-.309-2.448c-.866-2.141-1.727-4.326-2.789-6.379-.151-.291-.59-.034-.44.257.81,1.566,1.472,3.224,2.155,4.849a20.836,20.836,0,0,1,.939,2.313,1.306,1.306,0,0,1-.756,1.787,1.19,1.19,0,0,1-1.284-.162,6.31,6.31,0,0,1-1.15-2.018c-.426-.933-.8-1.893-1.142-2.857a19.265,19.265,0,0,1-.7-2.139,1.506,1.506,0,0,1,.238-1.513c.361-.387,1.3-.839,1.7-.258.185.268.626.014.44-.257Z"
              transform="translate(-111.703 -217.501)"
              fill="#414042"
            />
            <path
              id="Path_101411"
              data-name="Path 101411"
              d="M91.824,255.637a2.414,2.414,0,0,0-1.694,1.28c-.315.856.287,1.928.638,2.68a9.328,9.328,0,0,0,1.65,2.793,1.864,1.864,0,0,0,2.2-.044c.288-.157.031-.6-.257-.44a1.307,1.307,0,0,1-1.939-.353,15.724,15.724,0,0,1-1.1-1.97,5.8,5.8,0,0,1-.75-2.037c-.037-.8.7-1.231,1.386-1.417a.255.255,0,0,0-.136-.492h0Z"
              transform="translate(-89.045 -249.597)"
              fill="#414042"
            />
            <path
              id="Path_101412"
              data-name="Path 101412"
              d="M76.168,291.024a2.106,2.106,0,0,0-1.235.939,2.542,2.542,0,0,0,.283,2.022c.208.476.568,1.383,1.148,1.522.532.128,1.24-.4,1.636-.688.264-.19.01-.632-.257-.44a3.036,3.036,0,0,1-.969.562c-.575.117-.823-.574-1.032-1.022-.247-.53-.661-1.379-.232-1.906a1.778,1.778,0,0,1,.793-.5c.31-.1.177-.6-.136-.492h0Z"
              transform="translate(-74.807 -282.665)"
              fill="#414042"
            />
            <path
              id="Path_101413"
              data-name="Path 101413"
              d="M327.951,165.124c.581,1.887,1.027,3.815,1.607,5.7a15.375,15.375,0,0,0,.957,2.665c.3.568.553.631,1.2.548.824-.105,2.08-.456,2.45-1.3a3.42,3.42,0,0,0-.18-2,25.224,25.224,0,0,0-2.126-6.407,1.719,1.719,0,0,0-2.023-.772c-.788.126-2.048.555-1.884,1.56.053.323.544.186.492-.136-.111-.681,1.362-.939,1.807-.959a1.074,1.074,0,0,1,1.169.564,14.786,14.786,0,0,1,1.082,2.794c.342,1.055.653,2.122.92,3.2.241.965.673,1.966-.425,2.546-.321.17-1.425.638-1.8.436-.215-.117-.322-.495-.413-.713a27.51,27.51,0,0,1-.9-2.719c-.508-1.707-.914-3.445-1.439-5.147-.1-.312-.589-.179-.492.135Z"
              transform="translate(-311.367 -163.514)"
              fill="#414042"
            />
            <path
              id="Path_101414"
              data-name="Path 101414"
              d="M381.769,164.711c.917-.543,2.074-.674,2.677.372a10.8,10.8,0,0,1,.981,2.827,7.411,7.411,0,0,1,.394,2.446c-.109.816-1.157,1.218-1.854,1.445-.31.1-.177.594.135.492.751-.245,1.855-.676,2.156-1.481.345-.926-.173-2.4-.4-3.294-.272-1.058-.59-2.561-1.447-3.326a2.5,2.5,0,0,0-2.9.079.255.255,0,0,0,.257.44Z"
              transform="translate(-361.32 -163.742)"
              fill="#414042"
            />
            <path
              id="Path_101415"
              data-name="Path 101415"
              d="M432.391,183.637a1.307,1.307,0,0,1,2.092,1,1.542,1.542,0,0,1-1.338,1.9c-.323.05-.186.541.135.492a2.068,2.068,0,0,0,1.65-2.714,1.779,1.779,0,0,0-2.8-1.113.255.255,0,0,0,.257.44Z"
              transform="translate(-408.628 -181.602)"
              fill="#414042"
            />
            <path
              id="Path_101416"
              data-name="Path 101416"
              d="M173.972,225.392l10.806-3.285c.313-.095.179-.587-.136-.492L173.836,224.9c-.313.095-.179.587.135.492Z"
              transform="translate(-167.187 -217.8)"
              fill="#414042"
            />
            <path
              id="Path_101417"
              data-name="Path 101417"
              d="M186.355,253.684l10.518-3.121a.255.255,0,0,0-.136-.492l-10.518,3.121a.255.255,0,0,0,.136.492Z"
              transform="translate(-178.76 -244.395)"
              fill="#414042"
            />
            <path
              id="Path_101418"
              data-name="Path 101418"
              d="M346.689,175.17l1.217,3.154c.081.211.424.119.342-.094l-1.217-3.154c-.081-.211-.424-.119-.342.094Z"
              transform="translate(-328.879 -174.208)"
              fill="#414042"
            />
            <path
              id="Path_101419"
              data-name="Path 101419"
              d="M375.375,250.2l1.042,4.193a.177.177,0,0,0,.342-.094l-1.042-4.193a.177.177,0,0,0-.342.094Z"
              transform="translate(-355.693 -244.32)"
              fill="#414042"
            />
            <path
              id="Path_101420"
              data-name="Path 101420"
              d="M134.731,232.847l1.355,3.674c.079.212.421.12.342-.094l-1.355-3.674c-.079-.212-.421-.12-.342.094Z"
              transform="translate(-130.798 -228.108)"
              fill="#414042"
            />
            <path
              id="Path_101421"
              data-name="Path 101421"
              d="M170.707,314.925a21.727,21.727,0,0,0,1.458,2.79c.12.194.427.016.306-.179a21.727,21.727,0,0,1-1.458-2.79c-.09-.209-.4-.028-.306.179Z"
              transform="translate(-164.414 -304.759)"
              fill="#414042"
            />
            <path
              id="Path_101422"
              data-name="Path 101422"
              d="M189.734,267.321a10.112,10.112,0,0,0-.164,1.715.177.177,0,0,0,.354,0,9.481,9.481,0,0,1,.151-1.621c.041-.223-.3-.319-.342-.094Z"
              transform="translate(-182.057 -260.406)"
              fill="#414042"
            />
            <path
              id="Path_101423"
              data-name="Path 101423"
              d="M199.628,264.089a12.938,12.938,0,0,0-.293,2.139c-.012.228.342.227.354,0a12.374,12.374,0,0,1,.28-2.044c.05-.222-.292-.317-.342-.094Z"
              transform="translate(-191.184 -257.386)"
              fill="#414042"
            />
            <path
              id="Path_101424"
              data-name="Path 101424"
              d="M213.326,261.489q-.225.973-.45,1.946c-.051.222.29.317.342.094q.225-.973.45-1.945c.051-.222-.29-.317-.342-.094Z"
              transform="translate(-203.833 -254.956)"
              fill="#414042"
            />
            <path
              id="Path_101425"
              data-name="Path 101425"
              d="M229.589,258.68a6.736,6.736,0,0,0-.507,1.928c-.025.227.33.225.354,0a6.162,6.162,0,0,1,.458-1.749c.088-.208-.217-.388-.306-.179h0Z"
              transform="translate(-218.982 -252.363)"
              fill="#414042"
            />
          </g>
          <g
            id="Group_106508"
            data-name="Group 106508"
            transform="translate(35.011 35.217)"
          >
            <path
              id="Path_101426"
              data-name="Path 101426"
              d="M198.228,446.472a2.144,2.144,0,0,0-1.211-1.115c-.624-.3-1.422-.305-1.955-.763-.758-.653-.482-1.782.637-1.574.221.041.467-.251.248-.426-1.283-1.027-2.285-3.908-.227-4.688,2.162-.82,3.1,1.765,3.345,3.385a.256.256,0,0,0,.314.178c.666-.237,1.824-.276,1.927.658.073.662-.8,1.548-1.18,1.982a21.035,21.035,0,0,1-2.325,2.251c-.252.211.111.57.36.36a12.411,12.411,0,0,0,3.439-3.82c.759-1.639-.975-2.415-2.358-1.923l.314.178a5.3,5.3,0,0,0-1.359-3.219,2.788,2.788,0,0,0-2.8-.454c-2.249,1.015-1.337,4.249.191,5.471l.248-.426c-1.1-.2-2.076.569-1.629,1.741.581,1.523,3.1.909,3.531,2.339a.255.255,0,0,0,.492-.136Z"
              transform="translate(-183.634 -437.281)"
              fill="#414042"
            />
            <path
              id="Path_101427"
              data-name="Path 101427"
              d="M277.87,514.242a3.669,3.669,0,0,1,.187-1.1c.346-1.052,1.089-1.267,2.069-1.572a5.344,5.344,0,0,0,1.613-.8c.385-.28.7-.667,1.191-.709.734-.063,1.171.641,1.352,1.291a3.045,3.045,0,0,1-.044,1.708.861.861,0,0,1-1.081.725,1.67,1.67,0,0,0-1.15.081c-.454.219-.934.689-1.449.748a3.934,3.934,0,0,1-1.772-.5,2.161,2.161,0,0,0-1.237-.119.255.255,0,0,0,.135.492c1.045-.287,1.892.891,3.009.624a7.245,7.245,0,0,0,1.438-.727c.656-.321.778-.007,1.366.039,1.861.144,1.506-3.3.77-4.233a1.523,1.523,0,0,0-1.673-.634,7.58,7.58,0,0,0-1.438,1.009,5.447,5.447,0,0,1-1.427.593,2.965,2.965,0,0,0-2.368,3.083.255.255,0,0,0,.509,0Z"
              transform="translate(-261.495 -504.762)"
              fill="#414042"
            />
            <path
              id="Path_101428"
              data-name="Path 101428"
              d="M243.608,493.865a35.023,35.023,0,0,1,.425,6.474.255.255,0,0,0,.509,0,35.739,35.739,0,0,0-.443-6.609c-.052-.323-.543-.186-.492.135h0Z"
              transform="translate(-229.948 -489.862)"
              fill="#414042"
            />
            <path
              id="Path_101429"
              data-name="Path 101429"
              d="M249.692,541.352a24.339,24.339,0,0,1,6.961-3.78c.308-.107.175-.6-.136-.492a25.1,25.1,0,0,0-7.186,3.912c-.259.2.1.559.36.36h0Z"
              transform="translate(-235.218 -530.533)"
              fill="#414042"
            />
            <path
              id="Path_101430"
              data-name="Path 101430"
              d="M131.028,576.515a5.34,5.34,0,0,0-8.268,1.4c-2.093,4.207,2.485,8.341,1.86,12.671-.033.228.235.456.426.248a15.957,15.957,0,0,1,5.544-3.81c1.963-.849,4.209-1.966,5.063-4.071,1.383-3.406-1.6-6.034-4.737-6.5-.321-.048-.459.443-.135.492a7.212,7.212,0,0,1,3,1.17,3.932,3.932,0,0,1,.532,5.988c-1.527,1.663-3.72,2.2-5.638,3.238a15.577,15.577,0,0,0-3.991,3.135l.426.248a9.606,9.606,0,0,0-.431-3.831c-.6-2.215-2.02-4.434-1.942-6.774a4.75,4.75,0,0,1,7.928-3.24c.235.229.6-.131.36-.36Z"
              transform="translate(-116.5 -566.107)"
              fill="#414042"
            />
            <path
              id="Path_101431"
              data-name="Path 101431"
              d="M74.515,453.934a2.752,2.752,0,0,0,1.581-1.965l-.492-.135a1.718,1.718,0,0,0,1.4,2.124l-.061-.465a3.056,3.056,0,0,0-1.546,2.582h.509c-.113-.953-.055-2.12-1.082-2.543-.3-.125-.435.368-.136.492.443.183.567.911.618,1.3.033.251.06.5.09.757a.255.255,0,0,0,.509,0,2.529,2.529,0,0,1,1.294-2.142c.172-.1.166-.432-.061-.465a1.207,1.207,0,0,1-1.045-1.5c.046-.316-.418-.463-.492-.135a2.279,2.279,0,0,1-1.347,1.661c-.3.137-.039.576.257.44h0Z"
              transform="translate(-71.564 -450.71)"
              fill="#414042"
            />
            <path
              id="Path_101432"
              data-name="Path 101432"
              d="M35.193,591.886c.845.19,1.411-.674,1.71-1.344.111-.249-.183-.531-.4-.309-.615.628.733,2.531,1.415,1.807a.255.255,0,0,0-.36-.36c-.583.5-1.584,1.477-1.43,2.325.052.282.514.217.5-.067a3.7,3.7,0,0,0-1.069-2.472c-.229-.236-.589.125-.36.36a3.173,3.173,0,0,1,.92,2.112l.5-.067c-.054-.3.388-.841.545-1.048a4.975,4.975,0,0,1,.753-.781l-.36-.36c-.081.086-.9-.875-.7-1.086l-.4-.309c-.181.408-.578,1.235-1.134,1.11-.319-.072-.456.419-.136.492h0Z"
              transform="translate(-35.011 -580.145)"
              fill="#414042"
            />
            <path
              id="Path_101433"
              data-name="Path 101433"
              d="M140.746,603.626a5.63,5.63,0,0,0,2.354,1.318.255.255,0,0,0,.136-.492,5.071,5.071,0,0,1-2.129-1.187c-.24-.223-.6.136-.36.36h0Z"
              transform="translate(-133.75 -592.334)"
              fill="#414042"
            />
            <path
              id="Path_101434"
              data-name="Path 101434"
              d="M220.057,640.224a19.871,19.871,0,0,0,6.934,1.765c.327.023.326-.487,0-.509a19.147,19.147,0,0,1-6.677-1.7c-.3-.135-.555.3-.257.44Z"
              transform="translate(-207.82 -626.504)"
              fill="#414042"
            />
            <path
              id="Path_101435"
              data-name="Path 101435"
              d="M124.109,657.148c1.557,1.529,3.67,1.987,5.617,2.821.3.128.558-.311.257-.44-1.9-.812-4-1.253-5.514-2.741-.234-.23-.6.13-.36.36h0Z"
              transform="translate(-118.205 -642.349)"
              fill="#414042"
            />
            <path
              id="Path_101436"
              data-name="Path 101436"
              d="M238.03,710.446a13.938,13.938,0,0,0,3.608.751c.327.025.325-.485,0-.509a13.444,13.444,0,0,1-3.473-.733c-.31-.109-.443.383-.136.492h0Z"
              transform="translate(-224.577 -692.091)"
              fill="#414042"
            />
            <path
              id="Path_101437"
              data-name="Path 101437"
              d="M144.076,724.679a5.021,5.021,0,0,0,1.851,1.063c.313.1.447-.391.136-.492a4.416,4.416,0,0,1-1.625-.932c-.243-.219-.6.14-.36.36h0Z"
              transform="translate(-136.861 -705.464)"
              fill="#414042"
            />
            <path
              id="Path_101438"
              data-name="Path 101438"
              d="M211.131,466.08a1.279,1.279,0,0,0,.106,1.575c.216.247.575-.114.36-.36a.768.768,0,0,1-.026-.958c.189-.269-.253-.524-.44-.257Z"
              transform="translate(-199.393 -464.089)"
              fill="#414042"
            />
            <path
              id="Path_101439"
              data-name="Path 101439"
              d="M222.049,497.466v-.111a.255.255,0,0,0-.509,0v.111a.255.255,0,0,0,.509,0Z"
              transform="translate(-209.329 -493.192)"
              fill="#414042"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function ExpertLoginSplashLogo(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 151,
    height: 38,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 151 38"
      {...rest}
      sx={rootSx}
    >
      <g id="Group_4989" data-name="Group 4989" transform="translate(-24 -54)">
        <g id="hospital-cross-in-3d-circle" transform="translate(23.548 58)">
          <path
            id="Path_1"
            data-name="Path 1"
            d="M28.4,20.33A11.154,11.154,0,0,1,14.05,25.211a10.07,10.07,0,0,0,1.5.118A10.232,10.232,0,1,0,13.13,5.186,11.2,11.2,0,0,1,28.4,20.33ZM5.02,18.971A14.131,14.131,0,0,1,18.569.847a13.9,13.9,0,0,1,2.576.249A14.936,14.936,0,0,0,15.563,0a15.1,15.1,0,1,0,4.263,29.581,15.437,15.437,0,0,0,2.527-1.007,14.082,14.082,0,0,1-17.332-9.6Zm8.874-9.656v3.714H10.181v3.9h3.713v3.713h3.9V16.924H21.5v-3.9H17.79V9.314Z"
            transform="translate(0 0)"
            fill="#6552cc"
          />
        </g>
        <text
          id="Health_Circles"
          data-name="Health Circles"
          transform="translate(61 71)"
          fill="#6552cc"
          fontSize="16"
          fontFamily="Poppins-SemiBold, Poppins"
          fontWeight="600"
        >
          <tspan x="0" y="0">
            Health Circles
          </tspan>
        </text>
        <text
          id="Expert"
          transform="translate(61 88)"
          fill="#6552cc"
          fontSize="10"
          fontFamily="Poppins-Regular, Poppins"
        >
          <tspan x="0" y="0">
            Expert
          </tspan>
        </text>
      </g>
    </SvgIcon>
  );
}

export function ExpertLoginTopImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 256.025,
    height: 164.145,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256.025 164.145"
      {...rest}
      sx={rootSx}
    >
      <g
        id="Group_102579"
        data-name="Group 102579"
        transform="translate(-59.737 -47)"
      >
        <circle
          id="Ellipse_39441"
          data-name="Ellipse 39441"
          cx="18"
          cy="18"
          r="18"
          transform="translate(279 137)"
          fill="rgba(101,82,204,0.1)"
        />
        <g
          id="Signup_illustration"
          data-name="Signup illustration"
          transform="translate(59.737 44)"
        >
          <path
            id="Path_4343"
            data-name="Path 4343"
            d="M240.589,4.27a2.54,2.54,0,0,1,4.4,0l17.968,31.12a2.541,2.541,0,0,1-2.2,3.811H224.822a2.541,2.541,0,0,1-2.2-3.811Z"
            transform="translate(-34.051)"
            fill="rgba(101,82,204,0.1)"
          />
          <circle
            id="Ellipse_39439"
            data-name="Ellipse 39439"
            cx="25.404"
            cy="25.404"
            r="25.404"
            transform="translate(0 102.077)"
            fill="rgba(101,82,204,0.1)"
          />
          <circle
            id="Ellipse_39440"
            data-name="Ellipse 39440"
            cx="16.089"
            cy="16.089"
            r="16.089"
            transform="translate(36.413 12.315)"
            fill="rgba(101,82,204,0.1)"
          />
          <g
            id="Group_5561"
            data-name="Group 5561"
            transform="translate(12.671 113.185)"
          >
            <path
              id="Path_4344"
              data-name="Path 4344"
              d="M29.515,138.09A4.22,4.22,0,0,0,28,135.5c-1.514-1.514-2.485-2.379-2.485-2.379s-.758,2.487.647,4a26.6,26.6,0,0,0,3.346,2.92Z"
              transform="translate(-16.548 -133.118)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4345"
              data-name="Path 4345"
              d="M26.923,146.065a4.225,4.225,0,0,0-1.511-2.6c-1.511-1.514-2.487-2.379-2.487-2.379s-.756,2.487.65,4A26.629,26.629,0,0,0,26.923,148Z"
              transform="translate(-16.151 -134.339)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4346"
              data-name="Path 4346"
              d="M30.125,140.348a4.217,4.217,0,0,1,1.779-2.421c1.665-1.344,2.724-2.1,2.724-2.1s.491,2.551-1.068,3.9a26.528,26.528,0,0,1-3.642,2.549Z"
              transform="translate(-17.254 -133.533)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4347"
              data-name="Path 4347"
              d="M26.949,149.841s.229-1.057,2.024-2.231,2.931-1.8,2.931-1.8.217,2.59-1.472,3.776a26.712,26.712,0,0,1-3.9,2.153Z"
              transform="translate(-16.735 -135.062)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4348"
              data-name="Path 4348"
              d="M27.618,159.948a4.223,4.223,0,0,1,1.514-2.6c1.514-1.514,2.487-2.379,2.487-2.379s.756,2.488-.65,4a26.531,26.531,0,0,1-3.346,2.919Z"
              transform="translate(-16.902 -136.466)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4349"
              data-name="Path 4349"
              d="M26.917,162.36a4.257,4.257,0,0,0-1.115-2.789c-1.269-1.718-2.122-2.708-2.122-2.708s-1.115,2.354.072,4.052a26.637,26.637,0,0,0,2.9,3.366Z"
              transform="translate(-16.225 -136.755)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4350"
              data-name="Path 4350"
              d="M25.826,169.88a4.214,4.214,0,0,1,1.514-2.594c1.514-1.512,2.487-2.379,2.487-2.379s.756,2.485-.65,4a26.537,26.537,0,0,1-3.346,2.92Z"
              transform="translate(-16.627 -137.988)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4351"
              data-name="Path 4351"
              d="M27.018,176.46a4.19,4.19,0,0,1,.806-2.894c1.085-1.849,1.8-2.931,1.8-2.931s1.361,2.214.385,4.035a26.426,26.426,0,0,1-2.51,3.673Z"
              transform="translate(-16.805 -138.865)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4352"
              data-name="Path 4352"
              d="M29.718,138.663a30.954,30.954,0,0,1-.413,3.346c-.6,3.09-2.094,5.087-2.694,7.878s1.115,6.388.661,9.975-1.857,5.577-1.458,7.975,2.493,8.874,2.493,8.874"
              transform="translate(-16.614 -133.967)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4353"
              data-name="Path 4353"
              d="M30.147,141.786l1.631-1.249"
              transform="translate(-17.289 -134.255)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4354"
              data-name="Path 4354"
              d="M30.113,140.09l-.683-1.213"
              transform="translate(-17.179 -134)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4355"
              data-name="Path 4355"
              d="M26.876,151.409s1.364-1.024,2.769-2.05"
              transform="translate(-16.788 -135.606)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4356"
              data-name="Path 4356"
              d="M27.244,148.583a21.829,21.829,0,0,0-2.426-3.712"
              transform="translate(-16.473 -134.918)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4357"
              data-name="Path 4357"
              d="M27.683,161.956a16.861,16.861,0,0,1,2.92-3.9"
              transform="translate(-16.911 -136.938)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4358"
              data-name="Path 4358"
              d="M26.921,163.709a19.218,19.218,0,0,0-1.478-2.808c-.8-1.177-.912-1.328-.912-1.328"
              transform="translate(-16.429 -137.171)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4359"
              data-name="Path 4359"
              d="M25.826,172.3a17.979,17.979,0,0,1,1.23-2.487,15.8,15.8,0,0,1,1.592-2.086"
              transform="translate(-16.627 -138.42)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4360"
              data-name="Path 4360"
              d="M27.6,178.742a4.646,4.646,0,0,1,.41-2.391c.558-1.1,1.213-2.54,1.478-3.109"
              transform="translate(-16.895 -139.265)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4361"
              data-name="Path 4361"
              d="M18.571,155.4a2.7,2.7,0,0,1,.666-1.794c.784-1.115,1.3-1.759,1.3-1.759a2.9,2.9,0,0,1,.028,2.579,16.822,16.822,0,0,1-1.785,2.192Z"
              transform="translate(-15.515 -135.988)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4362"
              data-name="Path 4362"
              d="M21.064,160.134a2.691,2.691,0,0,1,.667-1.793c.784-1.113,1.313-1.771,1.313-1.771a2.89,2.89,0,0,1,.025,2.577,16.894,16.894,0,0,1-1.785,2.194Z"
              transform="translate(-15.897 -136.711)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4363"
              data-name="Path 4363"
              d="M18.279,156.972s-.19-.661-1.378-1.324-1.938-1.024-1.938-1.024a2.9,2.9,0,0,0,1.1,2.337,16.993,16.993,0,0,0,2.56,1.2Z"
              transform="translate(-14.963 -136.412)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4364"
              data-name="Path 4364"
              d="M21.224,162.6s-.257-.639-1.509-1.171-2.033-.814-2.033-.814a2.888,2.888,0,0,0,1.333,2.205,16.785,16.785,0,0,0,2.674.929Z"
              transform="translate(-15.38 -137.331)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4365"
              data-name="Path 4365"
              d="M22.056,168.978s-.117-.677-1.23-1.461-1.818-1.222-1.818-1.222a2.911,2.911,0,0,0,.837,2.438,16.927,16.927,0,0,0,2.418,1.467Z"
              transform="translate(-15.58 -138.2)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4366"
              data-name="Path 4366"
              d="M22.9,170.346a2.673,2.673,0,0,1,.4-1.868c.619-1.213,1.037-1.93,1.037-1.93a2.9,2.9,0,0,1,.4,2.549,16.986,16.986,0,0,1-1.456,2.426Z"
              transform="translate(-16.173 -138.239)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4367"
              data-name="Path 4367"
              d="M25.118,176.974s.078-.683,1.146-1.531,1.743-1.324,1.743-1.324a2.9,2.9,0,0,1-.7,2.481,16.808,16.808,0,0,1-2.331,1.6Z"
              transform="translate(-16.497 -139.399)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4368"
              data-name="Path 4368"
              d="M24.257,175.013s-.117-.677-1.23-1.464-1.818-1.221-1.818-1.221a2.907,2.907,0,0,0,.837,2.437,16.8,16.8,0,0,0,2.412,1.467Z"
              transform="translate(-15.917 -139.125)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4369"
              data-name="Path 4369"
              d="M24.346,179.24a2.68,2.68,0,0,0-.82-1.726c-.878-1.041-1.45-1.643-1.45-1.643a2.9,2.9,0,0,0,.2,2.571,16.929,16.929,0,0,0,1.969,2.033Z"
              transform="translate(-16.018 -139.667)"
              fill="#4cc5b1"
            />
            <path
              id="Path_4370"
              data-name="Path 4370"
              d="M18.434,155.859a19.794,19.794,0,0,0,.625,2.06c.711,1.871,1.866,2.962,2.543,4.646s0,4.13.669,6.327,1.771,3.3,1.779,4.844-.6,5.834-.6,5.834"
              transform="translate(-15.495 -136.602)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4371"
              data-name="Path 4371"
              d="M18.772,157.818l-1.157-.608"
              transform="translate(-15.369 -136.809)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4372"
              data-name="Path 4372"
              d="M18.74,156.719l.3-.837"
              transform="translate(-15.542 -136.605)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4373"
              data-name="Path 4373"
              d="M21.733,163.519s-.968-.494-1.952-.984"
              transform="translate(-15.701 -137.624)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4374"
              data-name="Path 4374"
              d="M21.313,161.736a13.8,13.8,0,0,1,1.115-2.59"
              transform="translate(-15.936 -137.105)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4375"
              data-name="Path 4375"
              d="M22.361,170.223a10.825,10.825,0,0,0-2.25-2.134"
              transform="translate(-15.751 -138.475)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4376"
              data-name="Path 4376"
              d="M23.159,171.182a12.28,12.28,0,0,1,.622-1.921c.374-.822.427-.931.427-.931"
              transform="translate(-16.218 -138.512)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4377"
              data-name="Path 4377"
              d="M25.007,177.992a10.045,10.045,0,0,1,1.244-1.294,6.819,6.819,0,0,0,.811-.705"
              transform="translate(-16.502 -139.686)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4378"
              data-name="Path 4378"
              d="M24.656,176.508a11.568,11.568,0,0,0-1.04-1.428,10.033,10.033,0,0,0-1.224-1.13"
              transform="translate(-16.101 -139.373)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4379"
              data-name="Path 4379"
              d="M24.348,180.72a2.937,2.937,0,0,0-.516-1.458c-.477-.627-1.037-1.462-1.266-1.79"
              transform="translate(-16.128 -139.913)"
              fill="none"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
            <path
              id="Path_4380"
              data-name="Path 4380"
              d="M28.414,194.032H22.095a.5.5,0,0,1-.5-.5l-1.567-10.462H30.477L28.91,193.535a.5.5,0,0,1-.5.5Z"
              transform="translate(-15.739 -140.771)"
              fill="#263238"
              stroke="#263238"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
            />
          </g>
          <g
            id="Group_5427"
            data-name="Group 5427"
            transform="translate(202.655 7.234)"
            opacity="0.3"
          >
            <path
              id="Path_4381"
              data-name="Path 4381"
              d="M292.186,129.524H239.315V33.766A25.766,25.766,0,0,1,265.081,8a27.092,27.092,0,0,1,27.093,27.093v94.431Z"
              transform="translate(-239.315 -8)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4382"
              data-name="Path 4382"
              d="M287.286,130.477V36.542A20.467,20.467,0,0,0,266.82,16.075h0a20.466,20.466,0,0,0-20.456,20.467v93.95"
              transform="translate(-240.395 -9.237)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4383"
              data-name="Path 4383"
              d="M270.533,8V129.382"
              transform="translate(-244.097 -8)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4384"
              data-name="Path 4384"
              d="M291.965,35.612H239.732"
              transform="translate(-239.379 -12.23)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4385"
              data-name="Path 4385"
              d="M291.965,55.081H239.732"
              transform="translate(-239.379 -15.212)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4386"
              data-name="Path 4386"
              d="M291.965,74.549H239.732"
              transform="translate(-239.379 -18.195)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4387"
              data-name="Path 4387"
              d="M291.965,94.023H239.732"
              transform="translate(-239.379 -21.178)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4388"
              data-name="Path 4388"
              d="M291.965,113.493H239.732"
              transform="translate(-239.379 -24.16)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4389"
              data-name="Path 4389"
              d="M291.965,132.962H239.732"
              transform="translate(-239.379 -27.143)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4390"
              data-name="Path 4390"
              d="M292.311,17.741l-4.735,4.315"
              transform="translate(-246.708 -9.492)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4391"
              data-name="Path 4391"
              d="M248.13,17.741l4.738,4.315"
              transform="translate(-240.665 -9.492)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
          </g>
          <g
            id="Group_5428"
            data-name="Group 5428"
            transform="translate(8.468 7.234)"
            opacity="0.3"
          >
            <path
              id="Path_4392"
              data-name="Path 4392"
              d="M62.87,129.524H10V33.766A25.766,25.766,0,0,1,35.766,8,27.093,27.093,0,0,1,62.859,35.093v94.431Z"
              transform="translate(-10 -8)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4393"
              data-name="Path 4393"
              d="M57.975,130.474V36.539A20.467,20.467,0,0,0,37.509,16.057h0A20.467,20.467,0,0,0,17.026,36.539v93.95"
              transform="translate(-11.076 -9.234)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4394"
              data-name="Path 4394"
              d="M41.214,8V129.382"
              transform="translate(-14.781 -8)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4395"
              data-name="Path 4395"
              d="M62.649,35.612H10.413"
              transform="translate(-10.063 -12.23)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4396"
              data-name="Path 4396"
              d="M62.649,55.081H10.413"
              transform="translate(-10.063 -15.212)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4397"
              data-name="Path 4397"
              d="M62.649,74.549H10.413"
              transform="translate(-10.063 -18.195)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4398"
              data-name="Path 4398"
              d="M62.649,94.023H10.413"
              transform="translate(-10.063 -21.178)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4399"
              data-name="Path 4399"
              d="M62.649,113.492H10.413"
              transform="translate(-10.063 -24.16)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4400"
              data-name="Path 4400"
              d="M62.649,132.961H10.413"
              transform="translate(-10.063 -27.143)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4401"
              data-name="Path 4401"
              d="M62.995,17.741l-4.738,4.315"
              transform="translate(-17.392 -9.492)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
            <path
              id="Path_4402"
              data-name="Path 4402"
              d="M18.815,17.741l4.734,4.315"
              transform="translate(-11.35 -9.492)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1"
              opacity="0.3"
            />
          </g>
          <path
            id="Path_4403"
            data-name="Path 4403"
            d="M73.463,136.164l26.09-1.79s8.7-1.709,14.1-2.374,7.487-.288,7.487-.288l5.765,3.05s1.464,1.943.656,7.39c-.567,3.823-2,9.064-3.071,13.78-.992,4.385-1.641,8.393-1.641,8.393a8.845,8.845,0,0,1-3.564.4,10.219,10.219,0,0,1-3.511-1.32s.042-4.27-.191-8.7c-.119-2.247-.414-3.984-.572-5.695a15.858,15.858,0,0,1,.082-3.283l-19.216,5.739s4.687,8.062,8.195,15.762c2.443,5.363,4.494,10.259,4.033,13.666a3.325,3.325,0,0,1-1.265,1.993c-1.28,1.3-5.4,2.924-8.476,2.4-4.058-.689-8.679-3.346-12.9-5.6-6.069-3.239-11.157-6.225-11.157-6.225a6.192,6.192,0,0,1-.221-3.47,12.673,12.673,0,0,1,2.026-3.854s2.836.842,5.583,1.429,5.407.92,5.407.92-2.054-2.17-4.859-4.937c-3.731-3.68-8.664-8.65-10.61-13.263a13.978,13.978,0,0,1,1.836-14.122Z"
            transform="translate(-10.796 -19.701)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            id="Path_4404"
            data-name="Path 4404"
            d="M168.335,125.863c1.528-.814,4.642-.9,8.26-.981,4.689-.111,10.3-.052,15.207.191a244.229,244.229,0,0,1,34.679,4.8l11.048,16.4,1.333,1.458a6.282,6.282,0,0,1,2.543.253c1.558.456,8.449,4.215,8.482,5.73.206,9.751-7.724,11.482-7.724,11.482l-8.6-4.827L217.89,149.8l-10.529-7.477s-1.127-.094-2.427-.058c-2.316.064-5.95.263-10.2.154-6.641-.169-13.93-.774-13.93-.774l.6,3.034,1.034,9.887s-1.5,2.02-6.068,2.195c-6.918.264-7.846-1.551-7.846-1.551a48.564,48.564,0,0,0-.953-6.687c-.832-4.09-2.374-9.671-2.374-9.671s.08-4.851-.391-6.237c-.741-2.181,1.47-5.651,3.533-6.751Z"
            transform="translate(-25.224 -18.663)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            id="Path_4405"
            data-name="Path 4405"
            d="M121.579,74.908s-9.775.52-11.052,1.2-4.345,9.113-4.345,9.113A20.1,20.1,0,0,1,104.7,87.2c-.853,1-1.934,2.007-1.934,2.007l-3.047.644s-.843,2-6.226.586c-1.3-.342-3.309.513-5.231,1.934-3.707,2.742-6.91,4.888-8.321,6.065C78.4,99.721,69.685,106.5,68.97,109.058c-.67,2.392,1.446,6.094,3.281,8.629a29.634,29.634,0,0,0,4.322,4.734l-1.166,1.807a15.716,15.716,0,0,0,8.461,4.491,34.411,34.411,0,0,0,13.258-.081l1.115-2.175,3.6-4.331.822-1.47,6.856-11.837,8.161,10.357s2.028,2.324,3.493,3.7a10.643,10.643,0,0,0,2.367,1.8s2.043,1.324,8.77,3,18.141,3.716,18.141,3.716a18.913,18.913,0,0,0,5.752-.126,3.6,3.6,0,0,0,2.541-2.233,11.1,11.1,0,0,0,2.907-1.528c.647-.607.278-1.1.278-1.1s.665-.655.53-1.005-1.063-.395-1.063-.395-.1-.738-2.111-.53c-1.528.158-4.325,1.46-8.057.548-.267-.066.049-.624.6-.887a14.351,14.351,0,0,0,2.643-1.028c.638-.471.931-1.462.59-1.562-.77-.226-1.825.347-2.765.6a16.385,16.385,0,0,0-3.634,1.106c-1.327.677-2.468,1.853-3.909,1.594-3.4-.611-7.281-3.162-10.29-4.663-4.59-2.291-6.069-2.319-7.15-3.52-2.342-2.6-2.1-2.507-3.629-5.426-1.711-3.272-3.428-7.246-5.26-10.021-3.464-5.251-5.45-5.669-5.45-5.669L111.1,94l2.256-2.329,1.07-.82s2.623,2.066,4.219,1.435c1.648-.652,2.269-4.016,2.607-4.922.562-1.51,1.948-1.211,2.037-2.256.043-.507-.6-1.081-1.07-1.759a2.5,2.5,0,0,1-.484-1.377c.134-1.2.75-2.7.894-3.589.213-1.319-1.055-3.472-1.055-3.472ZM83.327,108.163a39.2,39.2,0,0,1-1.155,4.439,36.879,36.879,0,0,1-2.036,4.661c-.006-.026-2.653-5.591-2.659-5.618-.031-.125,5.725-3.449,5.85-3.48Z"
            transform="translate(-10.546 -11.016)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4406"
            data-name="Path 4406"
            d="M97.944,92.725a18.605,18.605,0,0,1,8.824-.211,17,17,0,0,1,5.737,3.161,20.118,20.118,0,0,1,1.841,1.653,9.8,9.8,0,0,0-4.967,3.02,17.7,17.7,0,0,0-3.352,6.924c-.215,1.365.053,4.634,1.114,5.378,2.116,1.484,4.961-1.07,4.961-1.07l.75.6s-.444,4.215-2.1,6.6-2.475,1.362-3.843,2.407a4.709,4.709,0,0,0-1.625,1.773,20.281,20.281,0,0,1-4.119-.141,43.314,43.314,0,0,1-9.583-2.413c-5.426-2.148-6.905-5.3-6.905-5.3a40.228,40.228,0,0,1,1.491-5.7c1.006-2.9,1.46-6.725,3.029-9.373,3.165-5.338,7.047-7.019,7.047-7.019l1.693-.286Z"
            transform="translate(-12.972 -13.642)"
            fill="#7a67d9"
            fillRule="evenodd"
          />
          <path
            id="Path_4407"
            data-name="Path 4407"
            d="M115.988,68.126a6.873,6.873,0,0,0-1.919.264,7.515,7.515,0,0,0-2.872,1.7,2.417,2.417,0,0,0-2.462-.352c-1.28.459-3.049,2.2-4.263,3.809-1.482,1.966-2.215,4.775-3.048,7.838-.767,2.823-1.673,5.89-2.037,8.1-.808,4.913-5.366,10.628-5.948,13.757a7.48,7.48,0,0,0,.879,4.571,16.14,16.14,0,0,1,1.26,6.065A7.573,7.573,0,0,1,93.53,118.3a3.5,3.5,0,0,0,2.388-.924,7.542,7.542,0,0,0,1.407-2.96,5.079,5.079,0,0,0,.879,1.348,4.659,4.659,0,0,0,1.3.893,5.459,5.459,0,0,1-.571-4.527c.846-2.452,3.956-5.274,3.956-5.274s2.418-1.49,2.784-3.18c.549-2.534-.6-6.8-.191-10.68a36.71,36.71,0,0,1,2.842-10.226l1.51,1.421a7.208,7.208,0,0,0,2.783-.7,11.029,11.029,0,0,0,2.579-2.007,5.128,5.128,0,0,1-.777-1.847,2.311,2.311,0,0,1,.308-1.758c1.937-1.669,4.067,1.111,5.508.483a11.117,11.117,0,0,0,5.083-4.454,7.221,7.221,0,0,1,.981,3.106,37.694,37.694,0,0,1-.718,4.542,2.754,2.754,0,0,0,1.216-1,8,8,0,0,0,.864-2.021l.484,1.129-.044,1.3s1.133-.442,1.391-2.491c.13-1.027-.556-2.249-1.23-3.707a35.351,35.351,0,0,0-1.626-3.575c-1.008-1.327-2.664-1.012-4.059-1.553a18.724,18.724,0,0,0-6.592-1.524Zm-14.049,31.6a4.615,4.615,0,0,1,.139,3.2,6.934,6.934,0,0,1-1.871,3.388A59.985,59.985,0,0,1,101.939,99.727Z"
            transform="translate(-14.301 -9.976)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            id="Path_4408"
            data-name="Path 4408"
            d="M193.156,47.845a3.487,3.487,0,0,1,.855-1.613c.632-.59,1.68-.768,3.35-.607,1.85.178,4.758-.612,6.863-.035a7.233,7.233,0,0,1,3.59,2.578,5.913,5.913,0,0,1,2.5,2.235,11.431,11.431,0,0,1,1.115,3.974l-.579.364a9.571,9.571,0,0,1-.375,2.688c-.437,1.683-1.37,4.041-1.37,4.041l-.086,1.443-17.879-6.925s-2.561-1.977-2.058-4.014a8.285,8.285,0,0,1,2.042-3.449,2.575,2.575,0,0,1,2.031-.682Z"
            transform="translate(-28.956 -6.491)"
            fill="#263238"
            fillRule="evenodd"
          />
          <path
            id="Path_4409"
            data-name="Path 4409"
            d="M236.313,148.853a7.288,7.288,0,0,1,4.03-.552,7.434,7.434,0,0,1,4.015,2.73,14.433,14.433,0,0,1,1.926,8.68,7.242,7.242,0,0,1-8.676,5.831,8.594,8.594,0,0,1-4.005-2.978l2.711-13.711Z"
            transform="translate(-35.785 -22.244)"
            fill="#838fa5"
            fillRule="evenodd"
          />
          <path
            id="Path_4410"
            data-name="Path 4410"
            d="M184.089,145.592a5.735,5.735,0,0,1,2.489,1.284,11.28,11.28,0,0,1,2.015,2.805l6.611-1.376-.4-2.577,11.863-.195a16.758,16.758,0,0,1,.564,6.424,6.561,6.561,0,0,1-2.559,4.124c-1.4.926-4.4,2.334-6.426,1.528-2.314-.92-4.461-3.918-4.461-3.918l-4.168.514a10.481,10.481,0,0,1-1.086,4.919,8.334,8.334,0,0,1-3.655,2.923l-.252-3.356.736-.96s-.146-3.258-.464-6.292-.81-5.848-.81-5.848Z"
            transform="translate(-28.2 -21.835)"
            fill="#838fa5"
            fillRule="evenodd"
          />
          <path
            id="Path_4411"
            data-name="Path 4411"
            d="M225.728,159.222l11.1-3.223a4.014,4.014,0,0,1,1.385,1.884,4.372,4.372,0,0,1-.307,2.385l-10.887,3.039Z"
            transform="translate(-34.579 -23.438)"
            fill="#acb9d3"
            fillRule="evenodd"
          />
          <path
            id="Path_4412"
            data-name="Path 4412"
            d="M191.349,61.012s-.467-3.761-.427-4.809c.053-1.322-.267-3.234,1.705-3.9a7.5,7.5,0,0,1,3.384-.238c1.2.275,1.883,1.291,2.872,1.865a16.3,16.3,0,0,0,3.1,1.357,3.833,3.833,0,0,0,1.931,1.962c.882.3,2.418-.452,2.846-.393a2.06,2.06,0,0,1,1.749,2.391,4.334,4.334,0,0,1-1.877,2.509l1.263,1.668s1.077,5.422,2.128,6.326c1.757,1.508,2.607,1.5,5.776,2.174,3.311.7,9.1,2.44,10.752,5.533,1.918,3.6,1.9,11.885,2.107,18.833.175,5.763.725,10.667.725,10.667a71.391,71.391,0,0,1,.465,12.731c-.221,3.117-.569,7.25-.745,10.9-.15,3.13.18,6.478.218,9.7a20.764,20.764,0,0,1-.615,6.273c-.426.987-1.367.646-1.928.748-.261.047-.611.8-1.248,1.086-.26.116-1.219.228-1.49.37-.285.151-.721.656-1,.752a5.249,5.249,0,0,1-2.06-.268l-.029-1.559.751-.207a4.677,4.677,0,0,0,.378-2.059,10.77,10.77,0,0,0-.587-2.644l-1.711.386-.821-1.181.619-1.527,1.575-1.769a6.984,6.984,0,0,0,1.578-2.206,5.626,5.626,0,0,0,.262-2.52s-.186-3.022-.684-6.066c-.447-2.735-1.191-5.343-1.512-8.238a70.294,70.294,0,0,1-.46-8.416,27.463,27.463,0,0,0-.5-3.205,76.594,76.594,0,0,1-1.548-7.544c-.641-4.19-1.018-9.217-1.018-9.217l-11.067-1.52L194.731,113.8l-6.688-.3s-.331-9.235-.567-17.7c-.174-6.22-.5-11.268.428-15.775.683-3.3,3.97-4.8,6.7-5.831a18.953,18.953,0,0,0,4.65-2.7l-.319-1.072a3.479,3.479,0,0,1-4.479-.815,16.041,16.041,0,0,1-2.49-4.509,12.84,12.84,0,0,1-.612-4.085Z"
            transform="translate(-28.688 -7.5)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4413"
            data-name="Path 4413"
            d="M173.684,179.727s1.067-1.452,3.236-.424,5.585,2.363,5.585,2.363,1.745,6.143,1.71,9.087c-.014,1.095-2.26.668-5.348,1.236-2.532.465-4.093,1.192-6.94,1.469-3.017.295-7.29.105-8.819-.67-1.374-.7-.648-2.843.686-3.885,1.81-1.415,4.943-1.858,7.363-3.767a8.14,8.14,0,0,0,2.18-3.114A5.021,5.021,0,0,0,173.684,179.727Z"
            transform="translate(-24.873 -26.951)"
            fill="#57507b"
            fillRule="evenodd"
          />
          <path
            id="Path_4414"
            data-name="Path 4414"
            d="M276.371,179.434a10.9,10.9,0,0,1,6.035-4.266s4.714.833,6.27,2.025a.923.923,0,0,1,.3.882,29.092,29.092,0,0,1-1.622,5.56l-.068,6.3a3.125,3.125,0,0,1-2.623,2.67c-3.26.608-8.777.31-10.111-.854-.872-.761-.047-1.657.8-2.76.777-1.009,2.375-1.518,3.021-2.7.528-.963.221-2.584-.036-3.548-.626-2.355-2.647-2.28-1.969-3.318Z"
            transform="translate(-42.002 -26.374)"
            fill="#57507b"
            fillRule="evenodd"
          />
          <path
            id="Path_4415"
            data-name="Path 4415"
            d="M189.509,150.064l10.591-2.1a2.957,2.957,0,0,1,1.391,1.661,4.547,4.547,0,0,1-.533,2.438l-10.518,2.5-.931-4.506Z"
            transform="translate(-29.031 -22.208)"
            fill="#acb9d3"
            fillRule="evenodd"
          />
          <path
            id="Path_4416"
            data-name="Path 4416"
            d="M188.084,144.981l7.167.6.547,2.6-2.2.556.375,1.526.04,3.073a9.122,9.122,0,0,1,1.268-.845c.5-.241.749-.119.749-.119a3.4,3.4,0,0,1,.773-.948.492.492,0,0,1,.62.121s.536-.8.838-.409a4.479,4.479,0,0,1,.276,2.33,1.029,1.029,0,0,1-1.3.635l-.512.652-1.144.116-1.086.89-1.2.184a3.815,3.815,0,0,1-1.671.751,2.511,2.511,0,0,1-1.522-.493l.005-2.028,1.971-.625-.517-2.62-1.226-1.6-1.2.347-1.5-2.509.454-2.189Z"
            transform="translate(-28.743 -21.75)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4417"
            data-name="Path 4417"
            d="M172.875,162.2a42.024,42.024,0,0,0,6-.117,12.716,12.716,0,0,0,4.033-1.109l.59,17.645a2.853,2.853,0,0,1-1.883,1.349,5.726,5.726,0,0,1-2.776-.9,3.052,3.052,0,0,0-.5-2.064,3.466,3.466,0,0,0-2.093-.731L172.876,162.2Z"
            transform="translate(-26.483 -24.2)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4418"
            data-name="Path 4418"
            d="M61.012,168.239c.509-.7,2.924-.129,2.924-.129a20.023,20.023,0,0,1,3.72.409,3.812,3.812,0,0,1,1.983,1.076l-1.148,6.97L70.773,178s-.967,1.569,0,5.376c.359,1.41,1.8,2.105,2.706,3.2.978,1.191,1.354,2.75-.153,3.275-1.982.689-10.424.644-11.735-1.1-1.032-1.376-.154-6.66-.425-11.495-.148-2.634-.839-4.729-.9-6.4a4.323,4.323,0,0,1,.748-2.617Z"
            transform="translate(-9.231 -25.26)"
            fill="#57507b"
            fillRule="evenodd"
          />
          <path
            id="Path_4419"
            data-name="Path 4419"
            d="M122.532,175.651l6.364-2.784,1.3-.024a1.731,1.731,0,0,1,.653.763c.515,1.375.133,3.148,2.726,5.329,1.71,1.44,3.87,1.983,5.574,2.645,1.641.637,2.912,1.78,3.05,2.469.185.926,1.458,1.538-.766,2.789-1.741.981-5.566.865-5.566.865a53.062,53.062,0,0,1-5.779-.427c-1.244-.277-2.455-.842-4.048-1.084-1.855-.281-4,.055-4.836-.47-.884-.556-.609-1.894-.306-3.626a61.136,61.136,0,0,1,1.631-6.448Z"
            transform="translate(-18.476 -26.018)"
            fill="#57507b"
            fillRule="evenodd"
          />
          <path
            id="Path_4420"
            data-name="Path 4420"
            d="M264.724,159.887s.885.119,4.676,3.36,10.493,9.609,10.493,9.609a7.768,7.768,0,0,1,.256,2.594,2.188,2.188,0,0,1-.942,1.463,3.776,3.776,0,0,0-2.163-.954,5.6,5.6,0,0,0-2.554.826l-14.541-7.7a23.913,23.913,0,0,0,3.851-4.873,7.956,7.956,0,0,0,.923-4.323Z"
            transform="translate(-39.822 -24.033)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4421"
            data-name="Path 4421"
            d="M71.084,170.113l4.8,1.954a9.607,9.607,0,0,0-1.734,3.342,10.755,10.755,0,0,0-.076,3.9l-4.328-2.4s.285,0-.05-1.678a12.239,12.239,0,0,1-.58-2.979,2.122,2.122,0,0,1,1.97-2.139Z"
            transform="translate(-10.586 -25.6)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4422"
            data-name="Path 4422"
            d="M123.793,169.331a12.915,12.915,0,0,0,3.692,1.189,8.672,8.672,0,0,0,3.416-.356l-.352,2.27a3.2,3.2,0,0,0-2.176.676,3.782,3.782,0,0,0-.6,2.333,5.684,5.684,0,0,1-2.778.941,2.8,2.8,0,0,1-1.864-1.375l.666-5.679Z"
            transform="translate(-18.862 -25.48)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            fillRule="evenodd"
          />
          <path
            id="Path_4423"
            data-name="Path 4423"
            d="M194.667,78.1l2.509-1a13.928,13.928,0,0,0-1.182,4.579c-.168,1.888-.216,4.457,1.616,5.867,1.874,1.444,8.055,2.2,11.482-.544,2.5-1.994,3.429-5.589,4.475-8.128a13.65,13.65,0,0,1,2.108-3.575l2.43.6a21.95,21.95,0,0,0-2.678,9.476,16.847,16.847,0,0,0,2.341,8.664l1.556,11.615,1.145,4.892.826,4.674.324,8.658a34.572,34.572,0,0,1-8.858,1.383,34.138,34.138,0,0,1-8.829-1.355s-9.186-4.458-8.4-7.953a11.087,11.087,0,0,0,.423-2.693c-.03-1.8-1.023-4.806-1.353-6.716-.977-5.653-2.053-10.487-2.053-15.748a40.306,40.306,0,0,1,2.12-12.693Z"
            transform="translate(-29.496 -11.075)"
            fill="#7a67d9"
            fillRule="evenodd"
          />
          <path
            id="Path_4424"
            data-name="Path 4424"
            d="M75.976,132.919a17.108,17.108,0,0,0,8.9,4.751c5.66,1.1,12.819,0,12.819,0l-.942,2.787s-7.33,1.915-13.171.865a19.51,19.51,0,0,1-9.727-5.15l2.122-3.25Z"
            transform="translate(-11.314 -19.902)"
            fill="#7a67d9"
            fillRule="evenodd"
          />
          <path
            id="Path_4425"
            data-name="Path 4425"
            d="M162.706,192.687a1.8,1.8,0,0,0,1.138.8,17.767,17.767,0,0,0,6.491.4,73.549,73.549,0,0,0,7.763-1.7c.887-.2,2.765-.243,3.47-.4,2.253-.487,2.456-.862,2.456-.862s.809,1.768-.173,2.23a13.63,13.63,0,0,1-3.983.539,11.164,11.164,0,0,0-1.708.288,27.738,27.738,0,0,1-5.4,1.213,29.945,29.945,0,0,1-8.25.043c-3.139-.8-1.8-2.56-1.8-2.56Z"
            transform="translate(-24.882 -28.789)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_4426"
            data-name="Path 4426"
            d="M287.326,176.951s1.618.113,1.73.865a10.491,10.491,0,0,1-.653,3.4l-1.008,2.865-.237,6.544s.91,1.257-2.747,2.218c-4.635,1.218-9.851-.65-10.113-1.116a1.558,1.558,0,0,1,.378-1.312s.4.826,2.027,1.116c2.483.443,6.637.513,8.6-.195,1.854-.67,1.018-7.952,1.018-7.952s.6-2.4.822-3.961a14.729,14.729,0,0,0,.182-2.468Z"
            transform="translate(-42.015 -26.647)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_4427"
            data-name="Path 4427"
            d="M210.517,156.948c1.982-2.484,5.771-3.021,8.553-2.094a8.278,8.278,0,0,1,3.2,2.494l.846,1.444,1.779-.246.423,2.577-.232,1.969-.778.3a14.511,14.511,0,0,1-.229,2.859,7.921,7.921,0,0,1-1.241,2.944c-1.483,2.124-5.5,2.782-6.744,2.769a7.967,7.967,0,0,1-3.143-1.268,12.148,12.148,0,0,1-3.517-4.807c-1.058-2.983-.565-6.874,1.083-8.939Z"
            transform="translate(-31.997 -23.197)"
            fill="#838fa5"
            fillRule="evenodd"
          />
          <path
            id="Path_4428"
            data-name="Path 4428"
            d="M225.958,159.608l1.529-.478.442,2.495-.232,2.1-.765.24-.976-4.355Z"
            transform="translate(-34.614 -23.917)"
            fill="#acb9d3"
            fillRule="evenodd"
          />
          <path
            id="Path_4429"
            data-name="Path 4429"
            d="M216.5,154.736a5.567,5.567,0,0,1,4.606.529c2.4,1.41,3.921,5.468,3.921,5.468s.946,4.361-.216,7.056-4.43,3.724-4.43,3.724a9.47,9.47,0,0,0,2.634-3.889,11.94,11.94,0,0,0,.03-5.97,9.3,9.3,0,0,0-2.26-4.306,11.8,11.8,0,0,0-4.287-2.612Z"
            transform="translate(-33.165 -23.203)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            id="Path_4430"
            data-name="Path 4430"
            d="M236.163,148.988a3.323,3.323,0,0,1,2.422-.158A7.632,7.632,0,0,1,243,152.792a13.706,13.706,0,0,1,1.418,5.337c.042,2.191-.605,4.679-1.81,5.777a5.833,5.833,0,0,1-4.592,1.705,7.342,7.342,0,0,1-4.5-2.991l.466-.558,1.744-.529.621-1.547,2.607-.736a4.052,4.052,0,0,0,.477-2.342,4.7,4.7,0,0,0-1.316-2.135l-1.656.31-.3-6.094Z"
            transform="translate(-35.773 -22.317)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            id="Path_4431"
            data-name="Path 4431"
            d="M202.113,151.693a4.354,4.354,0,0,0,.5-2.423,3.155,3.155,0,0,0-1.442-1.694l-3.984.8-.334-2.871,9.625.167a14.747,14.747,0,0,1,.892,5.107,8.907,8.907,0,0,1-1.943,5.42,4.789,4.789,0,0,1-4.729,1.4,11.047,11.047,0,0,1-3.679-2.275l1.589-.986a1.179,1.179,0,0,0,1.094-.373,5.1,5.1,0,0,0,.6-1.794l1.816-.48Z"
            transform="translate(-30.156 -21.83)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            id="Path_4432"
            data-name="Path 4432"
            d="M187.609,155.294a14.605,14.605,0,0,0-1.488-5.458,6.448,6.448,0,0,0-1.54-2.077l-.552-2.244a5.271,5.271,0,0,1,3.451,2.337,14.3,14.3,0,0,1,2.124,5.8,11.339,11.339,0,0,1-1.183,5.654,6.188,6.188,0,0,1-3.413,2.629l-.071-.57s2.761-2.672,2.672-6.073Z"
            transform="translate(-28.191 -21.832)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            id="Path_4433"
            data-name="Path 4433"
            d="M223.946,145.657a.357.357,0,0,1-.079-.009.309.309,0,0,1-.22-.377,3.881,3.881,0,0,1,1-1.688c.145-.151.293-.3.44-.45,1.346-1.363,2.618-2.651,2.553-4.894a51.148,51.148,0,0,0-1.473-10.859,30.872,30.872,0,0,1-.658-3.458c-.309-2.922-.372-4.916-.421-6.519-.034-1.107-.061-1.982-.16-2.818a47.786,47.786,0,0,0-.954-4.844c-.3-1.287-.579-2.5-.735-3.519-.389-2.54-.6-4.817-.77-6.646-.258-2.784-.445-4.8-1.039-5.653-1.839-2.65-4.141-10.548.484-18.049a.308.308,0,0,1,.525.323c-4.464,7.24-2.266,14.831-.5,17.373.688.991.871,2.962,1.147,5.947.169,1.822.379,4.088.766,6.61.152.992.431,2.2.726,3.474a48.549,48.549,0,0,1,.966,4.91c.1.863.13,1.75.163,2.871.049,1.592.111,3.574.418,6.473a30.4,30.4,0,0,0,.645,3.386,51.622,51.622,0,0,1,1.489,10.978c.074,2.507-1.352,3.95-2.73,5.345-.146.149-.293.3-.436.445a3.286,3.286,0,0,0-.843,1.415.307.307,0,0,1-.3.23Z"
            transform="translate(-33.579 -11.141)"
          />
          <path
            id="Path_4434"
            data-name="Path 4434"
            d="M226.034,151.913a3.9,3.9,0,0,1-1.222-.23.309.309,0,0,1,.2-.584c.464.159,1.312.365,1.77-.041a2.222,2.222,0,0,1,1.548-.719,4.319,4.319,0,0,0,.469-.06,1.285,1.285,0,0,0,.888-.6c.083-.1.173-.213.281-.331a1.873,1.873,0,0,1,1.174-.488c.535-.086.872-.158,1.083-.57.482-.939.648-4.416.5-7.073l-.057-1.015c-.12-2.133-.225-3.975-.212-6.68.014-2.6.243-5.517.465-8.339.23-2.933.448-5.7.426-8.018a77.625,77.625,0,0,0-.627-8.59c-.071-.6-.133-1.127-.174-1.558-.5-5.278-.563-11.672-.6-15.108-.068-7.041-.954-11.282-2.786-13.346-2.314-2.6-6.576-3.575-10-4.356-2.623-.6-4.889-1.114-5.79-2.214-1.734-2.114-2.1-6.205-2.111-6.379a.308.308,0,0,1,.281-.333.311.311,0,0,1,.334.282c0,.041.361,4.074,1.974,6.04.767.936,2.938,1.431,5.451,2,3.511.8,7.879,1.8,10.323,4.548,1.965,2.212,2.872,6.452,2.943,13.75.032,3.427.092,9.8.594,15.056.041.427.1.946.172,1.545a78.013,78.013,0,0,1,.633,8.656c.021,2.344-.2,5.127-.428,8.072-.222,2.811-.45,5.718-.463,8.293-.014,2.685.086,4.431.211,6.642l.057,1.015c.15,2.728-.025,6.327-.569,7.389a1.8,1.8,0,0,1-1.535.9,1.379,1.379,0,0,0-.816.295c-.1.108-.181.21-.257.3a1.87,1.87,0,0,1-1.247.814,4.5,4.5,0,0,1-.537.07,1.636,1.636,0,0,0-1.192.567,1.7,1.7,0,0,1-1.157.393Z"
            transform="translate(-32.363 -9.541)"
          />
          <path
            id="Path_4435"
            data-name="Path 4435"
            d="M225.644,159.894a.309.309,0,0,1-.092-.6l1.715-.534a.308.308,0,1,1,.184.589l-1.716.534a.287.287,0,0,1-.091.014Z"
            transform="translate(-34.519 -23.858)"
          />
          <path
            id="Path_4436"
            data-name="Path 4436"
            d="M236.869,161.3a.309.309,0,0,1-.088-.6l2.374-.7c.241-.073.614-.742.372-1.956a2.738,2.738,0,0,0-.881-1.712.485.485,0,0,0-.371-.095c-.269.057-.627.144-1.049.253a.308.308,0,0,1-.156-.6c.434-.113.8-.2,1.08-.261a1.1,1.1,0,0,1,.837.185,3.269,3.269,0,0,1,1.144,2.1c.3,1.5-.176,2.48-.8,2.668l-2.376.7a.283.283,0,0,1-.087.013Z"
            transform="translate(-36.239 -23.378)"
          />
          <path
            id="Path_4437"
            data-name="Path 4437"
            d="M226.975,165.052a.309.309,0,0,1-.086-.6l.733-.213a.308.308,0,1,1,.171.592l-.733.213a.336.336,0,0,1-.086.012Z"
            transform="translate(-34.723 -24.697)"
          />
          <path
            id="Path_4438"
            data-name="Path 4438"
            d="M227.707,164.436a.308.308,0,0,1-.265-.464c.579-.993.511-3.133-.166-5.2a.309.309,0,1,1,.587-.192c.739,2.259.785,4.552.113,5.7a.308.308,0,0,1-.267.152Z"
            transform="translate(-34.814 -23.8)"
          />
          <path
            id="Path_4439"
            data-name="Path 4439"
            d="M216.5,172.366c-3.249,0-6.462-2.934-7.548-7.155-1.233-4.793.739-9.459,4.4-10.4s7.637,2.194,8.87,6.988-.739,9.46-4.4,10.4A5.284,5.284,0,0,1,216.5,172.366Zm-1.821-17.106a4.725,4.725,0,0,0-1.176.149c-3.328.855-5.1,5.184-3.954,9.649s4.789,7.4,8.119,6.543,5.1-5.185,3.953-9.649c-1.013-3.942-3.972-6.693-6.942-6.693Z"
            transform="translate(-31.952 -23.23)"
          />
          <path
            id="Path_4440"
            data-name="Path 4440"
            d="M214.293,165.152c-.4-1.567.1-3.054,1.132-3.317s2.187.793,2.591,2.359-.1,3.054-1.131,3.319S214.7,166.72,214.293,165.152Z"
            transform="translate(-32.806 -24.326)"
            fill="#566072"
            fillRule="evenodd"
          />
          <path
            id="Path_4441"
            data-name="Path 4441"
            d="M216.5,167.806c-1.085,0-2.159-1.07-2.562-2.634-.451-1.759.142-3.38,1.354-3.693s2.514.823,2.967,2.583-.142,3.381-1.353,3.694A1.66,1.66,0,0,1,216.5,167.806Zm-1.964-2.787c.355,1.377,1.371,2.357,2.217,2.138s1.263-1.566.909-2.943-1.365-2.358-2.215-2.139-1.264,1.567-.91,2.944Z"
            transform="translate(-32.75 -24.269)"
          />
          <path
            id="Path_4442"
            data-name="Path 4442"
            d="M218.483,172.14a.309.309,0,0,1-.061-.611,15.059,15.059,0,0,0,2.6-.876c3.093-1.316,4.423-5.1,3.312-9.428-1.164-4.529-4.091-7.018-7.641-6.486a17.753,17.753,0,0,0-2.632.64.309.309,0,1,1-.2-.585,18.318,18.318,0,0,1,2.738-.665c3.886-.577,7.078,2.081,8.329,6.943,1.191,4.63-.284,8.709-3.668,10.149a15.231,15.231,0,0,1-2.717.912.373.373,0,0,1-.061.007Z"
            transform="translate(-32.729 -23.139)"
          />
          <path
            id="Path_4443"
            data-name="Path 4443"
            d="M238.881,166.1a7.05,7.05,0,0,1-5.58-3.372.309.309,0,0,1,.506-.353c1.671,2.4,4.048,3.535,6.2,2.96,3.2-.856,4.908-5.186,3.8-9.654-1.065-4.3-4.344-7.2-7.48-6.614a.308.308,0,1,1-.113-.606c3.453-.647,7.05,2.458,8.192,7.073,1.187,4.791-.716,9.455-4.24,10.4a5,5,0,0,1-1.291.169Z"
            transform="translate(-35.731 -22.269)"
          />
          <path
            id="Path_4444"
            data-name="Path 4444"
            d="M240.56,165.867a.309.309,0,0,1-.063-.611,14.074,14.074,0,0,0,2.5-.875c2.977-1.316,4.257-5.105,3.185-9.433-1.121-4.527-3.934-7.012-7.342-6.483a15.376,15.376,0,0,0-1.919.445.309.309,0,0,1-.175-.592,15.988,15.988,0,0,1,2-.463c3.751-.579,6.83,2.08,8.035,6.945,1.147,4.628-.274,8.7-3.535,10.146a14.542,14.542,0,0,1-2.619.915.332.332,0,0,1-.064.006Z"
            transform="translate(-36.233 -22.178)"
          />
          <path
            id="Path_4445"
            data-name="Path 4445"
            d="M224.516,152.684a.307.307,0,0,1-.191-.066c-6.241-4.941-11.062-8.372-15.8-10.21a.309.309,0,1,1,.224-.575c4.812,1.866,9.675,5.324,15.962,10.3a.308.308,0,0,1-.191.55Z"
            transform="translate(-31.913 -21.264)"
          />
          <path
            id="Path_4446"
            data-name="Path 4446"
            d="M253.532,166.3a1.684,1.684,0,0,1-.885-.229l-.041-.025c-.98-.594-3.272-1.986-5.011-2.936-.893-.489-1.633-.856-2.351-1.21-.256-.127-.511-.253-.77-.384a.308.308,0,1,1,.277-.55c.258.13.512.255.766.381.722.358,1.47.727,2.373,1.222,1.75.957,4.052,2.353,5.034,2.95l.042.025a1.737,1.737,0,0,0,1.439-.044c2.083-.791,5.118-3.988,6.143-7.309.167-.545.638-3.358-.243-4.132a38.063,38.063,0,0,0-7.8-4.845,2.482,2.482,0,0,0-1.333-.21c-.72.038-1.468.07-2.508-1.363s-2.37-3.466-3.778-5.619c-2.326-3.557-4.963-7.59-7.468-10.768a.308.308,0,1,1,.484-.381c2.522,3.2,5.167,7.244,7.5,10.812,1.4,2.147,2.729,4.174,3.761,5.595.845,1.163,1.321,1.141,1.98,1.109a3.07,3.07,0,0,1,1.627.269,38.7,38.7,0,0,1,7.94,4.939c1.332,1.169.437,4.741.426,4.777-1.093,3.544-4.251,6.844-6.514,7.7a3.082,3.082,0,0,1-1.092.225Z"
            transform="translate(-36.36 -19.571)"
          />
          <path
            id="Path_4447"
            data-name="Path 4447"
            d="M164.845,130.495a.337.337,0,0,1-.107-.019.309.309,0,0,1-.184-.4c.941-2.567,2.684-4.467,4.439-4.84,5.051-1.072,17.165-.805,22.138-.642a.309.309,0,1,1-.019.617c-4.952-.164-17-.429-21.99.629-1.553.329-3.119,2.075-3.988,4.447A.31.31,0,0,1,164.845,130.495Z"
            transform="translate(-25.205 -18.604)"
          />
          <path
            id="Path_4448"
            data-name="Path 4448"
            d="M174.974,158.919c-2.987,0-6.534-.522-6.707-2.117-.023-.213-.044-.451-.067-.721a55.743,55.743,0,0,0-1.817-9.97c-.541-2.109-.991-3.73-1.354-5.033l-.046-.164a.309.309,0,1,1,.6-.165l.046.165c.362,1.306.815,2.931,1.356,5.045a56.129,56.129,0,0,1,1.834,10.069c.024.265.044.5.067.708.112,1.032,3.584,1.75,7.437,1.529,3.288-.187,5.795-1.093,5.829-2.109a61.9,61.9,0,0,0-1.395-11.915,41.874,41.874,0,0,0-2.812-7.456.308.308,0,1,1,.544-.289,42.4,42.4,0,0,1,2.861,7.578,61.525,61.525,0,0,1,1.418,12.1c-.059,1.731-3.491,2.539-6.411,2.7-.434.025-.9.038-1.378.038Z"
            transform="translate(-25.272 -20.425)"
          />
          <path
            id="Path_4449"
            data-name="Path 4449"
            d="M199.257,145.789a104.5,104.5,0,0,1-15.683-1.21.309.309,0,0,1,.091-.611,104.841,104.841,0,0,0,21.4,1.064,35.492,35.492,0,0,1,5.475.024.31.31,0,0,1,.267.345.313.313,0,0,1-.346.267,35.041,35.041,0,0,0-5.372-.019c-1.628.064-3.557.141-5.834.141Z"
            transform="translate(-28.081 -21.594)"
          />
          <path
            id="Path_4450"
            data-name="Path 4450"
            d="M185.278,179.025a.307.307,0,0,1-.307-.285c-.22-2.965-.233-5.21-.247-7.586-.015-2.615-.032-5.58-.34-10a.309.309,0,1,1,.616-.043c.309,4.436.326,7.41.341,10.035.014,2.366.027,4.6.246,7.544a.309.309,0,0,1-.285.33h-.025Z"
            transform="translate(-28.246 -24.178)"
          />
          <path
            id="Path_4451"
            data-name="Path 4451"
            d="M176.075,176.511a.308.308,0,0,1-.3-.256c-.008-.048-.85-4.876-3.429-13.764a.309.309,0,1,1,.593-.172c2.59,8.925,3.436,13.783,3.445,13.831a.308.308,0,0,1-.252.357.387.387,0,0,1-.053,0Z"
            transform="translate(-26.399 -24.372)"
          />
          <path
            id="Path_4452"
            data-name="Path 4452"
            d="M280.636,173.027a.308.308,0,0,1-.213-.085c-.027-.025-2.726-2.576-5.682-5.281a110.231,110.231,0,0,0-9.465-7.924.308.308,0,0,1,.359-.5,109.637,109.637,0,0,1,9.522,7.97c2.96,2.709,5.663,5.262,5.691,5.288a.309.309,0,0,1-.213.533Z"
            transform="translate(-40.618 -23.925)"
          />
          <path
            id="Path_4453"
            data-name="Path 4453"
            d="M274.383,178.519a.313.313,0,0,1-.155-.041c-.081-.047-8.118-4.707-14.359-7.453a.308.308,0,1,1,.248-.565c6.272,2.759,14.34,7.437,14.421,7.484a.309.309,0,0,1-.156.576Z"
            transform="translate(-39.781 -25.649)"
          />
          <path
            id="Path_4454"
            data-name="Path 4454"
            d="M168.529,192.4a20.705,20.705,0,0,1-4.557-.443c-.984-.235-1.261-.771-1.319-1.18-.146-1.01.9-2.18,2.006-2.816a20.04,20.04,0,0,1,2.7-1.228,10.322,10.322,0,0,0,4.093-2.4,6.3,6.3,0,0,0,2.02-4.5,1.288,1.288,0,0,1,1.1-1.186,2.455,2.455,0,0,1,2.647,1.135,3.784,3.784,0,0,1,.3,1.73c2.407,1.779,3.313.748,3.915.063.246-.281.457-.525.76-.475a.682.682,0,0,1,.473.459,24.31,24.31,0,0,1,1.557,6.821,1.3,1.3,0,0,1-.268,1.009c-.487.572-1.707.861-4.5,1.068a19.346,19.346,0,0,0-3.447.773c-.634.174-1.371.377-2.246.607a22,22,0,0,1-5.24.561Zm6.583-13.2a1.685,1.685,0,0,0-.388.044c-.185.045-.616.192-.632.609a6.97,6.97,0,0,1-2.185,4.895,10.791,10.791,0,0,1-4.319,2.556,19.615,19.615,0,0,0-2.624,1.189c-1.028.589-1.791,1.572-1.7,2.192.047.319.334.544.853.668a23.942,23.942,0,0,0,9.5-.114c.349-.091.677-.18.985-.262-.321-.47-.611-.844-.847-1.151-.519-.672-.863-1.115-.8-1.667.082-.664.8-1.255,1.559-1.882a6.243,6.243,0,0,0,1.56-1.6,5.878,5.878,0,0,0,.615-4.594,1.8,1.8,0,0,0-1.578-.881Zm2.363,3.03a7.917,7.917,0,0,1-.855,2.731,6.613,6.613,0,0,1-1.714,1.792c-.633.522-1.287,1.061-1.339,1.482-.035.286.192.6.671,1.213.266.345.6.774.97,1.331.007.009.011.018.017.027l.627-.172a19.862,19.862,0,0,1,3.565-.793c2.507-.186,3.726-.441,4.077-.854a.7.7,0,0,0,.122-.558,24.059,24.059,0,0,0-1.506-6.625c-.006-.012-.011-.022-.015-.032-.058.058-.132.141-.191.208-.589.671-1.787,2.032-4.426.251Z"
            transform="translate(-24.915 -26.899)"
          />
          <path
            id="Path_4455"
            data-name="Path 4455"
            d="M169.005,195.607c-.981,0-1.871-.041-2.645-.091-2.441-.158-3.883-.731-4.283-1.7a2.1,2.1,0,0,1,.467-2,.308.308,0,1,1,.462.409c-.005.007-.621.719-.356,1.357.172.414.887,1.136,3.751,1.32a29.145,29.145,0,0,0,10.782-1.1,17.171,17.171,0,0,1,4.41-.705,4.468,4.468,0,0,0,2.024-.359c.561-.438.113-2.039-.088-2.567a.308.308,0,0,1,.577-.219c.1.251.909,2.478-.11,3.273a4.512,4.512,0,0,1-2.366.488,16.667,16.667,0,0,0-4.26.677A27.531,27.531,0,0,1,169,195.606Z"
            transform="translate(-24.811 -28.608)"
          />
          <path
            id="Path_4456"
            data-name="Path 4456"
            d="M280.67,191.857c-1.556,0-4.323-.1-5.346-.782a1.392,1.392,0,0,1-.683-1.059,2.556,2.556,0,0,1,1.106-1.919,10.907,10.907,0,0,1,1.1-.832,2.936,2.936,0,0,0,1.634-2.217,4.423,4.423,0,0,0-2.006-4.3.948.948,0,0,1-.412-1.128c.313-.929,1.9-1.753,3.264-1.693a3.244,3.244,0,0,1,2.066.931,2.355,2.355,0,0,0,.585-2.683c-.118-.524-.221-.977.141-1.194.49-.293,2.954.147,5.066,1.247.907.473.5,2.521-.162,5.362-.095.4-.184.778-.254,1.108a15.865,15.865,0,0,0-.019,2.5,19.985,19.985,0,0,1-.207,4.949c-.3,1.088-1.923,1.628-5.094,1.7-.191.005-.459.008-.777.008Zm-1.485-13.316a2.981,2.981,0,0,0-2.537,1.276c-.041.121-.051.266.179.425a5.031,5.031,0,0,1,2.263,4.894,3.54,3.54,0,0,1-1.894,2.636,10.175,10.175,0,0,0-1.038.785c-.777.69-.919,1.151-.9,1.416a.8.8,0,0,0,.41.589c.707.472,2.971.734,5.766.67,3.647-.083,4.394-.819,4.515-1.25a7.1,7.1,0,0,0,.2-1.437.34.34,0,0,1-.022-.026,3.418,3.418,0,0,0-1.772-1.275c-.579-.214-1.127-.417-1.077-1.462a15.421,15.421,0,0,0-.586-3.723c-.616-1.655-1.83-3.447-3.388-3.513-.038,0-.076,0-.115,0Zm2.638.766a8.858,8.858,0,0,1,1.445,2.535,15.8,15.8,0,0,1,.623,3.968c-.028.594.135.655.675.854a4.014,4.014,0,0,1,1.61.972c.008-.8-.019-1.653-.043-2.418a14.9,14.9,0,0,1,.033-2.649c.071-.334.161-.715.256-1.12.334-1.423,1.029-4.386.478-4.674a10.571,10.571,0,0,0-4.415-1.267,3.71,3.71,0,0,0,.1.532,2.946,2.946,0,0,1-.757,3.265Z"
            transform="translate(-42.072 -26.332)"
          />
          <path
            id="Path_4457"
            data-name="Path 4457"
            d="M280.924,193.424a16.659,16.659,0,0,1-5.725-.869c-.746-.314-1.158-.683-1.263-1.127a1.461,1.461,0,0,1,.483-1.253,1.4,1.4,0,0,0,.113-.14.309.309,0,1,1,.533.312,1.974,1.974,0,0,1-.179.231c-.172.2-.406.47-.351.71s.374.477.9.7c2.569,1.08,8.82,1.15,10.614-.22,1.029-.786.983-2.971.938-5.082-.019-.845-.037-1.719.01-2.527a6.534,6.534,0,0,1,.585-2.07,9.878,9.878,0,0,0,.365-.992,12.251,12.251,0,0,0,.639-3.295c-.047-.465-1.029-.657-1.5-.677a.308.308,0,1,1,.025-.616c.2.008,1.971.113,2.086,1.23a13.154,13.154,0,0,1-.66,3.527,10.364,10.364,0,0,1-.387,1.056,6.069,6.069,0,0,0-.54,1.874c-.046.783-.026,1.645-.009,2.478.049,2.371.1,4.609-1.181,5.586-1.08.824-3.269,1.168-5.5,1.168Z"
            transform="translate(-41.96 -26.579)"
          />
          <path
            id="Path_4458"
            data-name="Path 4458"
            d="M201.916,77.371a.31.31,0,0,1-.3-.239,23.036,23.036,0,0,0-1.1-3.143.308.308,0,1,1,.565-.247,23.06,23.06,0,0,1,1.14,3.252.31.31,0,0,1-.232.37.3.3,0,0,1-.069.008Z"
            transform="translate(-30.712 -10.809)"
          />
          <path
            id="Path_4459"
            data-name="Path 4459"
            d="M188.038,117.008a.31.31,0,0,1-.307-.289c-.387-6.233-.469-10.44-.555-14.9-.047-2.414-.095-4.912-.194-7.865-.155-4.646-.144-10.26,1.325-12.45,1.531-2.281,3.71-3.162,5.818-4.013a13.373,13.373,0,0,0,4.819-2.8.309.309,0,0,1,.44.433,13.845,13.845,0,0,1-5.028,2.942c-2.114.854-4.111,1.66-5.536,3.785-1.387,2.066-1.361,7.887-1.221,12.086.1,2.958.146,5.457.193,7.874.086,4.448.168,8.649.555,14.868a.309.309,0,0,1-.289.328h-.021Z"
            transform="translate(-28.634 -10.968)"
          />
          <path
            id="Path_4460"
            data-name="Path 4460"
            d="M212.62,126.1a23.817,23.817,0,0,1-12.915-3.646c-2.764-1.776-4.389-3.738-4.513-4.684a4.892,4.892,0,0,1,.208-2.509c.233-.727.453-1.415-.141-3.708-.607-2.34-2.381-11.477-2.884-15.377-.878-6.811.468-14.278,2.182-17.846a.308.308,0,0,1,.556.266c-1.675,3.488-2.989,10.807-2.126,17.5.5,3.883,2.265,12.974,2.869,15.3.64,2.467.382,3.272.132,4.051a4.317,4.317,0,0,0-.185,2.24c.077.582,1.4,2.423,4.237,4.245,3.432,2.2,10.771,5.416,21.345,2.165a.309.309,0,0,1,.181.59,30.4,30.4,0,0,1-8.947,1.411Z"
            transform="translate(-29.427 -11.512)"
          />
          <path
            id="Path_4461"
            data-name="Path 4461"
            d="M203.4,89.062a18.373,18.373,0,0,1-3-.265,4.691,4.691,0,0,1-3.442-2.147c-1.742-2.877-.179-7.629.335-9.191.061-.186.124-.38.134-.426a.308.308,0,1,1,.606.112,5.091,5.091,0,0,1-.153.508c-.492,1.495-1.988,6.044-.394,8.678a4.1,4.1,0,0,0,3.016,1.858c9.341,1.55,11.518-4.2,13.266-8.823.688-1.819,1.282-3.389,2.23-4.261a.308.308,0,1,1,.417.454,11.232,11.232,0,0,0-2.07,4.025c-1.539,4.07-3.585,9.478-10.94,9.478Z"
            transform="translate(-30.049 -11.033)"
          />
          <path
            id="Path_4462"
            data-name="Path 4462"
            d="M209.943,126.479c-3.468,0-8.529-1.452-11.446-4.641a.308.308,0,1,1,.455-.417c2.792,3.05,7.654,4.44,10.992,4.44a.309.309,0,0,1,0,.617Z"
            transform="translate(-30.395 -18.126)"
          />
          <path
            id="Path_4463"
            data-name="Path 4463"
            d="M187.558,147.345a.312.312,0,0,1-.125-.027.308.308,0,0,1-.156-.407A6.083,6.083,0,0,0,187.71,145a.312.312,0,0,1,.324-.291.309.309,0,0,1,.291.324,6.552,6.552,0,0,1-.486,2.13.309.309,0,0,1-.282.183Z"
            transform="translate(-28.685 -21.708)"
          />
          <path
            id="Path_4464"
            data-name="Path 4464"
            d="M191.718,158.471a1.9,1.9,0,0,1-1.364-.527.309.309,0,1,1,.409-.462,1.6,1.6,0,0,0,1.589.307,5.848,5.848,0,0,0,2.058-1.8c.356-.575.3-.8.275-.861a.17.17,0,0,0-.1-.086.309.309,0,0,1,.107-.608.781.781,0,0,1,.555.44,1.587,1.587,0,0,1-.314,1.439,6.073,6.073,0,0,1-2.474,2.08,4.354,4.354,0,0,1-.74.075Z"
            transform="translate(-29.144 -23.198)"
          />
          <path
            id="Path_4465"
            data-name="Path 4465"
            d="M194.745,157.486a1.108,1.108,0,0,1-.519-.113.308.308,0,1,1,.289-.544.933.933,0,0,0,.648-.036,2.363,2.363,0,0,0,1.323-1.424c.4-.929.275-1.374.2-1.417-.035-.023-.351.022-.894.711a.308.308,0,1,1-.484-.381c.871-1.107,1.435-1.014,1.694-.86.489.291.506,1.131.047,2.192a2.965,2.965,0,0,1-1.684,1.761,1.908,1.908,0,0,1-.622.11Z"
            transform="translate(-29.728 -23.029)"
          />
          <path
            id="Path_4466"
            data-name="Path 4466"
            d="M197.389,156.327a1.911,1.911,0,0,1-.552-.088.309.309,0,0,1,.18-.591.893.893,0,0,0,.8-.067c.288-.2.655-.735.775-2.193.03-.374-.059-.542-.124-.559-.107-.028-.422.138-.672.653a.309.309,0,0,1-.556-.269c.348-.718.907-1.11,1.39-.979.155.042.653.253.577,1.2-.113,1.385-.454,2.253-1.042,2.653a1.345,1.345,0,0,1-.774.235Z"
            transform="translate(-30.12 -22.857)"
          />
          <path
            id="Path_4467"
            data-name="Path 4467"
            d="M199.393,155.467a1.5,1.5,0,0,1-.514-.1.309.309,0,0,1,.215-.579.534.534,0,0,0,.636-.079,2.5,2.5,0,0,0,.207-2.164c-.063-.166-.137-.223-.163-.224h0c-.041,0-.163.08-.288.329a.309.309,0,0,1-.553-.275c.3-.606.672-.684.872-.671a.843.843,0,0,1,.709.622,3.079,3.079,0,0,1-.346,2.817,1.066,1.066,0,0,1-.774.323Z"
            transform="translate(-30.435 -22.78)"
          />
          <path
            id="Path_4468"
            data-name="Path 4468"
            d="M193.361,155.231a1.093,1.093,0,0,1-.489-.126c-.791-.4-.979-1.51-1.144-2.491a7.779,7.779,0,0,0-.244-1.13,3.861,3.861,0,0,0-.868-1.358,5.491,5.491,0,0,1-1.477-3.092.308.308,0,1,1,.608-.1,4.915,4.915,0,0,0,1.336,2.79,4.463,4.463,0,0,1,.984,1.562,8.124,8.124,0,0,1,.268,1.226c.142.837.3,1.787.813,2.042.207.1.288.052.319.03.135-.086.57-.577.479-3.242a5.516,5.516,0,0,0-.411-2.043c-.127-.357-.284-.8-.467-1.44a.309.309,0,0,1,.594-.17c.177.621.331,1.055.454,1.4a6.067,6.067,0,0,1,.447,2.229c.1,2.889-.389,3.542-.763,3.782a.8.8,0,0,1-.439.129Z"
            transform="translate(-28.973 -22.009)"
          />
          <path
            id="Path_4469"
            data-name="Path 4469"
            d="M197.028,148.461a.308.308,0,0,1-.307-.276,11.843,11.843,0,0,0-.214-1.215,6.064,6.064,0,0,1-.173-1.1.309.309,0,1,1,.617,0,5.865,5.865,0,0,0,.159.97,12.494,12.494,0,0,1,.224,1.28.308.308,0,0,1-.275.338l-.033,0Z"
            transform="translate(-30.076 -21.839)"
          />
          <path
            id="Path_4470"
            data-name="Path 4470"
            d="M190.656,155.882a.309.309,0,0,1-.069-.61l1.7-.385a.317.317,0,0,1,.375.228.3.3,0,0,1-.217.368l-1.724.39a.276.276,0,0,1-.069.008Z"
            transform="translate(-29.159 -23.266)"
          />
          <path
            id="Path_4471"
            data-name="Path 4471"
            d="M199.784,152.817a.308.308,0,0,1-.071-.608c.642-.153,1.171-.285,1.511-.373.738-.2.916-1.184.711-2.059-.2-.857-.78-1.645-1.625-1.47l-5.507,1.1a.328.328,0,0,1-.382-.238.292.292,0,0,1,.222-.359l5.544-1.11c1.241-.253,2.088.825,2.348,1.934.273,1.166-.036,2.5-1.155,2.8-.342.091-.877.223-1.524.378a.348.348,0,0,1-.072.008Z"
            transform="translate(-29.782 -22.161)"
          />
          <path
            id="Path_4472"
            data-name="Path 4472"
            d="M189.485,150.633a.308.308,0,0,1-.06-.61l1.093-.219a.308.308,0,0,1,.12.6l-1.092.219a.3.3,0,0,1-.061.006Z"
            transform="translate(-28.98 -22.488)"
          />
          <path
            id="Path_4473"
            data-name="Path 4473"
            d="M185.1,161.967a.312.312,0,0,1-.23-.1.309.309,0,0,1,.026-.436c1.965-1.748,2.827-4.977,2.192-8.227a10.057,10.057,0,0,0-2.719-5.254.309.309,0,0,1,.431-.442,10.679,10.679,0,0,1,2.894,5.579c.675,3.461-.263,6.918-2.388,8.806a.306.306,0,0,1-.206.079Z"
            transform="translate(-28.229 -22.123)"
          />
          <path
            id="Path_4474"
            data-name="Path 4474"
            d="M185.029,162.182a.308.308,0,0,1-.1-.6l.184-.064c3.162-1.13,4.714-4.834,3.859-9.215-.692-3.546-2.53-6-5.045-6.726a.309.309,0,0,1,.172-.593c2.745.794,4.741,3.42,5.48,7.2.915,4.692-.8,8.677-4.261,9.915l-.186.064a.3.3,0,0,1-.1.017Z"
            transform="translate(-28.141 -21.749)"
          />
          <path
            id="Path_4475"
            data-name="Path 4475"
            d="M201.776,158.144a6.822,6.822,0,0,1-5.232-2.921.308.308,0,1,1,.485-.379c1.666,2.126,3.867,3.073,5.89,2.533,3.2-.854,4.907-5.185,3.8-9.653a11.32,11.32,0,0,0-.646-1.888.309.309,0,0,1,.565-.251,12.107,12.107,0,0,1,.68,1.99c1.187,4.792-.716,9.456-4.241,10.4a5.009,5.009,0,0,1-1.3.171Z"
            transform="translate(-30.098 -21.814)"
          />
          <path
            id="Path_4476"
            data-name="Path 4476"
            d="M204.084,157.993a.309.309,0,0,1-.063-.611,14.158,14.158,0,0,0,2.5-.875c2.977-1.314,4.256-5.105,3.185-9.433-.115-.464-.251-.915-.4-1.342a.309.309,0,1,1,.582-.207c.159.445.3.917.421,1.4,1.147,4.629-.274,8.7-3.535,10.146a14.387,14.387,0,0,1-2.619.914.276.276,0,0,1-.064.007Z"
            transform="translate(-31.216 -21.802)"
          />
          <path
            id="Path_4477"
            data-name="Path 4477"
            d="M191.912,157a.308.308,0,0,1-.178-.561l1-.7a.309.309,0,1,1,.354.506l-1,.7a.306.306,0,0,1-.176.056Z"
            transform="translate(-29.351 -23.389)"
          />
          <path
            id="Path_4478"
            data-name="Path 4478"
            d="M120.392,99.342a.307.307,0,0,1-.2-.07c-.89-.733-1.916-1.527-3.139-2.429-.245-.18-.5-.38-.781-.593a22.325,22.325,0,0,0-4.307-2.767,9.635,9.635,0,0,0-3.37-.85.309.309,0,1,1,.047-.616,10.217,10.217,0,0,1,3.582.905,22.777,22.777,0,0,1,4.424,2.839c.274.211.529.408.771.586,1.232.908,2.267,1.709,3.165,2.449a.308.308,0,0,1-.2.546Z"
            transform="translate(-16.592 -13.636)"
          />
          <path
            id="Path_4479"
            data-name="Path 4479"
            d="M76.324,125.191a.308.308,0,0,1-.218-.09c-.889-.884-5.405-5.507-7.021-9.71-.963-2.5-.991-3.956,1.327-6.465,2.84-3.071,8.81-7.736,13.155-10.771,1.321-.923,2.245-1.654,2.988-2.241A12.253,12.253,0,0,1,95,92.615l.507-.04a.308.308,0,0,1,.052.615l-.509.04a14.414,14.414,0,0,0-4.168.727,14.105,14.105,0,0,0-3.94,2.443c-.749.592-1.68,1.329-3.018,2.263-4.318,3.015-10.246,7.646-13.055,10.683-2.1,2.268-2.141,3.388-1.2,5.824,1.218,3.169,4.467,7.095,6.879,9.493a.309.309,0,0,1-.218.528Z"
            transform="translate(-10.489 -13.722)"
          />
          <path
            id="Path_4480"
            data-name="Path 4480"
            d="M135.484,120.937a.312.312,0,0,1-.224-.1c-1.781-1.9-3.633-5.5-5.592-9.3l-.381-.738c-1.939-3.766-3.221-6.254-4.866-8.2a16.519,16.519,0,0,0-2.363-2.363.308.308,0,1,1,.392-.475,17.093,17.093,0,0,1,2.441,2.441c1.69,2,2.985,4.514,4.944,8.317l.381.738c1.94,3.767,3.773,7.324,5.494,9.162a.309.309,0,0,1-.014.436.306.306,0,0,1-.211.084Z"
            transform="translate(-18.681 -14.812)"
          />
          <path
            id="Path_4481"
            data-name="Path 4481"
            d="M164.625,134.946a.308.308,0,0,1-.025-.616c3.258-.27,6.552-1.385,6.875-1.842a.222.222,0,0,0-.073-.161c-.1-.089-.389-.172-1.156-.065-.672.094-1.379.223-2.064.348-.889.162-1.728.315-2.463.39-.036,0-3.759.334-4.309-.34a.431.431,0,0,1-.081-.409c.264-.844,1.51-1.191,2.335-1.421a4.374,4.374,0,0,0,.481-.15c.966-.455,1.232-.7,1.291-1.192a.234.234,0,0,0,0-.094,4.937,4.937,0,0,0-1.645.348c-.326.1-.671.2-1.02.293-.5.131-.946.224-1.339.307a6.551,6.551,0,0,0-2.247.752c-.272.164-.525.343-.77.516a4.039,4.039,0,0,1-4.038.843c-2.24-.641-8.9-4.077-10.363-4.889a21.465,21.465,0,0,0-3.447-1.5,7.1,7.1,0,0,1-3.032-1.635.308.308,0,0,1,.451-.42,6.682,6.682,0,0,0,2.789,1.474,21.918,21.918,0,0,1,3.538,1.538c1.4.777,8.078,4.218,10.234,4.835a3.461,3.461,0,0,0,3.513-.754c.254-.18.516-.365.806-.54a7.117,7.117,0,0,1,2.44-.828c.384-.08.821-.172,1.308-.3.343-.09.68-.191,1-.287,1.064-.319,1.831-.55,2.229-.217a.667.667,0,0,1,.207.628c-.107.89-.748,1.257-1.641,1.677a4.23,4.23,0,0,1-.578.185c-.56.157-1.562.435-1.851.885a13.375,13.375,0,0,0,3.679.077c.71-.072,1.538-.223,2.414-.384.691-.125,1.4-.257,2.089-.351a2.082,2.082,0,0,1,1.639.2.851.851,0,0,1,.294.65c.031,1.109-4.87,2.225-7.443,2.438l-.026,0Z"
            transform="translate(-21.056 -18.523)"
          />
          <path
            id="Path_4482"
            data-name="Path 4482"
            d="M81.333,123.644a.307.307,0,0,1-.271-.161,50.173,50.173,0,0,1-2.373-5.019,19.683,19.683,0,0,0-1.446-3.006.308.308,0,1,1,.531-.314,20.029,20.029,0,0,1,1.489,3.092,49.415,49.415,0,0,0,2.342,4.953.308.308,0,0,1-.122.418.3.3,0,0,1-.148.037Z"
            transform="translate(-11.826 -17.156)"
          />
          <path
            id="Path_4483"
            data-name="Path 4483"
            d="M79.119,117.8a.309.309,0,0,1-.185-.556c1.217-.913,5.7-3.582,5.89-3.695a.309.309,0,0,1,.316.53c-.046.028-4.645,2.766-5.835,3.659a.315.315,0,0,1-.185.062Z"
            transform="translate(-12.073 -16.928)"
          />
          <path
            id="Path_4484"
            data-name="Path 4484"
            d="M94.65,170.578a.3.3,0,0,1-.219-.092c-.067-.067-6.841-6.907-13.931-14.161-4.93-5.045-9.1-9.657-10.146-14.994-.776-3.944.252-7.957,3.143-12.264.84-1.251,1.485-2.084,2.169-2.966.856-1.1,1.826-2.354,3.422-4.729,2.114-3.146,2.476-4.43,3.82-9.2l.428-1.515q.373-1.312.7-2.472a64.086,64.086,0,0,1,2.285-7.281,18.445,18.445,0,0,1,7.628-8.043.309.309,0,1,1,.283.549,18.164,18.164,0,0,0-7.349,7.748,63.993,63.993,0,0,0-2.253,7.194q-.325,1.16-.7,2.473l-.428,1.515c-1.331,4.726-1.733,6.152-3.9,9.381-1.607,2.393-2.584,3.652-3.446,4.763-.706.911-1.317,1.7-2.145,2.932-2.8,4.165-3.792,8.025-3.05,11.8,1.019,5.179,4.95,9.531,9.982,14.681,7.087,7.253,13.86,14.092,13.928,14.16a.308.308,0,0,1-.219.526Z"
            transform="translate(-10.739 -13.76)"
          />
          <path
            id="Path_4485"
            data-name="Path 4485"
            d="M87.331,174.8a.256.256,0,0,1-.036,0,65.106,65.106,0,0,1-13.984-3.508c-.275-.108-.662-.284-1.111-.488-.259-.119-.544-.248-.847-.383a.309.309,0,1,1,.251-.564c.305.135.591.265.851.384.44.2.821.373,1.078.474a65.312,65.312,0,0,0,13.832,3.472.308.308,0,0,1-.035.614Z"
            transform="translate(-10.903 -25.557)"
          />
          <path
            id="Path_4486"
            data-name="Path 4486"
            d="M69.26,189.264c-3.007,0-6.24-.448-6.878-1.85-.574-1.261-.4-3.32-.193-5.7.088-1.031.18-2.1.217-3.169a34.826,34.826,0,0,0-.283-5.212c-.2-1.8-.343-3.1.13-3.977.829-1.54,2.789-1.92,5.377-1.043.452.152.828.262,1.138.355.872.256,1.4.411,1.41,1.022.009.515-.432.588-.67.627-.349.058-.744.123-1.038.9a3.535,3.535,0,0,0,.185,2.231,6.577,6.577,0,0,1,.335,3.074.309.309,0,0,1-.608-.1,6,6,0,0,0-.32-2.8,4.033,4.033,0,0,1-.17-2.62,1.733,1.733,0,0,1,1.515-1.295c.047-.007.105-.017.148-.027-.035-.133-.258-.214-.961-.421-.316-.093-.7-.207-1.161-.362-1.076-.365-3.683-1.02-4.637.751-.381.707-.247,1.927-.059,3.616a35.372,35.372,0,0,1,.286,5.3c-.037,1.087-.129,2.161-.219,3.2-.189,2.2-.368,4.283.139,5.4.643,1.412,6.041,1.832,10.083,1.242.356-.052.8-.2.914-.592a1.674,1.674,0,0,0-.782-1.515l-.313-.258A5.307,5.307,0,0,1,70.988,184a14.674,14.674,0,0,1-.677-4.022,3.342,3.342,0,0,1,.462-2.015.309.309,0,0,1,.5.36,2.824,2.824,0,0,0-.346,1.631,14.272,14.272,0,0,0,.644,3.85c.181.54.8,1.052,1.665,1.759l.315.259a2.221,2.221,0,0,1,.984,2.156,1.524,1.524,0,0,1-1.419,1.036,28.038,28.038,0,0,1-3.855.252Z"
            transform="translate(-9.488 -25.253)"
          />
          <path
            id="Path_4487"
            data-name="Path 4487"
            d="M98.632,188.332a11.6,11.6,0,0,1-3.811-.61c-6.57-2.314-19.516-9.84-25.044-13.053l-1.165-.676c-.174-.1-.243-.068-.265-.057-.364.175-.566,1.528-.714,2.516-.2,1.344-.391,2.613-.976,3.12a3.478,3.478,0,0,1-1.469.694,3.587,3.587,0,0,0-2.446,1.855.308.308,0,1,1-.522-.329,4.155,4.155,0,0,1,2.8-2.12,2.9,2.9,0,0,0,1.231-.566c.413-.357.6-1.626.77-2.745.213-1.429.4-2.662,1.057-2.98a.867.867,0,0,1,.841.08l1.165.677c5.513,3.205,18.423,10.709,24.939,13,4.326,1.523,9.847.032,11.359-3.069.286-.586.423-1.976-.554-5.274a113.59,113.59,0,0,0-7.074-16.556c-2.037-4.077-6.056-10.613-7.388-12.651a.308.308,0,0,1,.517-.336c1.338,2.048,5.375,8.614,7.423,12.712,2.445,4.893,5.663,11.753,7.115,16.658.84,2.839,1.009,4.711.516,5.719-1.291,2.647-4.866,3.989-8.309,3.989Z"
            transform="translate(-9.524 -22.383)"
          />
          <path
            id="Path_4488"
            data-name="Path 4488"
            d="M100.771,139.544a.189.189,0,0,1-.038,0,.309.309,0,0,1-.268-.346,14.469,14.469,0,0,1,2.374-6.483,29.881,29.881,0,0,1,1.977-2.543,19.54,19.54,0,0,0,2.376-3.26,5.516,5.516,0,0,1,3.2-2.8,6.544,6.544,0,0,0,1.893-1.082c1.689-1.466,2.564-6.8,2.573-6.85a.309.309,0,0,1,.61.1c-.037.229-.922,5.608-2.778,7.217a7.051,7.051,0,0,1-2.059,1.186,4.883,4.883,0,0,0-2.9,2.528,20.025,20.025,0,0,1-2.446,3.364,29.062,29.062,0,0,0-1.937,2.49,13.868,13.868,0,0,0-2.275,6.217.309.309,0,0,1-.306.27Z"
            transform="translate(-15.39 -17.297)"
          />
          <path
            id="Path_4489"
            data-name="Path 4489"
            d="M169.466,138.146a.308.308,0,0,1-.064-.61,41.4,41.4,0,0,0,6.31-1.706c1.577-.658,1.822-1.146,1.784-1.264s-.347-.228-.663-.156a.308.308,0,1,1-.136-.6,1.162,1.162,0,0,1,1.387.569c.146.455-.107,1.175-2.135,2.021a41.779,41.779,0,0,1-6.419,1.74.341.341,0,0,1-.065.007Z"
            transform="translate(-25.913 -20.033)"
          />
          <path
            id="Path_4490"
            data-name="Path 4490"
            d="M169.619,139.77a.308.308,0,0,1-.047-.613,17.1,17.1,0,0,0,5.357-1.6c.181-.084.355-.166.525-.241,1.6-.715,1.758-1.153,1.772-1.234a.072.072,0,0,0-.013-.062.3.3,0,0,1-.06-.427.315.315,0,0,1,.437-.062.668.668,0,0,1,.252.6c-.06.559-.759,1.129-2.137,1.743-.168.075-.337.154-.513.236a17.651,17.651,0,0,1-5.525,1.647.3.3,0,0,1-.047,0Z"
            transform="translate(-25.937 -20.293)"
          />
          <path
            id="Path_4491"
            data-name="Path 4491"
            d="M130.34,130.825a.31.31,0,0,1-.165-.047c-3-1.9-6.065-5.965-9.024-9.9-2.629-3.491-5.11-6.788-7.024-7.736a.308.308,0,1,1,.274-.553c2.046,1.014,4.57,4.368,7.243,7.919,2.79,3.707,5.952,7.909,8.861,9.748a.309.309,0,0,1-.166.57Z"
            transform="translate(-17.457 -16.783)"
          />
          <path
            id="Path_4492"
            data-name="Path 4492"
            d="M163.438,140.685c-.83,0-1.839-.048-3.115-.143a46.989,46.989,0,0,1-5.716-1.014c-.548-.12-1.426-.285-2.538-.492-4.309-.8-12.33-2.3-17.66-4.423a9.093,9.093,0,0,1-1.551-.793.309.309,0,0,1,.351-.508,8.5,8.5,0,0,0,1.429.728c5.274,2.1,13.257,3.59,17.545,4.391,1.117.208,2,.373,2.557.5a46.347,46.347,0,0,0,5.63,1,18.36,18.36,0,0,0,5.424-.085,5.465,5.465,0,0,0,2.947-2.274.309.309,0,1,1,.522.329,6.118,6.118,0,0,1-3.32,2.545,10.264,10.264,0,0,1-2.5.244Z"
            transform="translate(-20.332 -19.954)"
          />
          <path
            id="Path_4493"
            data-name="Path 4493"
            d="M112.517,114.265a2.586,2.586,0,0,1-1.42-.4c-1.532-.984-2.011-3.546-1.219-6.528,1.13-4.261,5.149-9.408,8.443-9.408a.309.309,0,1,1,0,.617c-2.947,0-6.778,4.921-7.847,8.95-.71,2.677-.326,5.028.957,5.851,1,.643,2.444.266,4.062-1.064a.308.308,0,0,1,.391.476A5.448,5.448,0,0,1,112.517,114.265Z"
            transform="translate(-16.774 -14.542)"
          />
          <path
            id="Path_4494"
            data-name="Path 4494"
            d="M92.944,125.313a.318.318,0,0,1-.1-.017c-7.6-2.6-8.549-5.875-8.586-6.014a.308.308,0,0,1,.6-.16c.014.05.977,3.119,8.19,5.591a.309.309,0,0,1-.1.6Z"
            transform="translate(-12.906 -17.754)"
          />
          <path
            id="Path_4495"
            data-name="Path 4495"
            d="M106.683,128.682h-.014a42.079,42.079,0,0,1-10.663-1.814.309.309,0,0,1,.173-.593,41.425,41.425,0,0,0,10.518,1.791.308.308,0,0,1-.014.616Z"
            transform="translate(-14.673 -18.883)"
          />
          <path
            id="Path_4496"
            data-name="Path 4496"
            d="M94.356,108.388a.307.307,0,0,1-.244-.12,6.336,6.336,0,0,1-.84-5.827,16.008,16.008,0,0,1,2.02-4.036,24.479,24.479,0,0,0,2.288-4.335,80.627,80.627,0,0,0,3.035-10.6l.031-.129c1.361-5.549,2.109-8.606,5.191-11.891,1.507-1.607,3.128-2.334,4.447-2a2.235,2.235,0,0,1,1.638,1.669c.431,1.7-1.136,5.867-2.794,10.283a61.3,61.3,0,0,0-3.091,9.634,36.594,36.594,0,0,0-.112,8.654c.087,1.243.17,2.417.162,3.453-.019,2.41-3.2,4.157-3.341,4.231a.308.308,0,1,1-.292-.542c.03-.017,3-1.648,3.016-3.693.008-1.013-.074-2.175-.16-3.406a37.065,37.065,0,0,1,.118-8.8,61.584,61.584,0,0,1,3.123-9.751c1.552-4.133,3.157-8.407,2.774-9.914a1.635,1.635,0,0,0-1.195-1.224c-1.092-.282-2.494.382-3.843,1.821-2.97,3.167-3.706,6.168-5.041,11.617l-.032.129a82.237,82.237,0,0,1-3.057,10.671,25.259,25.259,0,0,1-2.34,4.441,15.545,15.545,0,0,0-1.951,3.878,5.736,5.736,0,0,0,.733,5.281.309.309,0,0,1-.244.5Z"
            transform="translate(-14.238 -10.168)"
          />
          <path
            id="Path_4497"
            data-name="Path 4497"
            d="M98.75,100.558a.3.3,0,0,1-.2-.075.307.307,0,0,1-.032-.434,19.04,19.04,0,0,0,4.323-9.89.308.308,0,1,1,.612.069,19.678,19.678,0,0,1-4.468,10.223.307.307,0,0,1-.234.107Z"
            transform="translate(-15.08 -13.31)"
          />
          <path
            id="Path_4498"
            data-name="Path 4498"
            d="M93.541,124.4a2.95,2.95,0,0,1-.426-.026.308.308,0,0,1-.122-.562,5.431,5.431,0,0,0,2.184-3.375,9.959,9.959,0,0,0-.614-4.817c-.124-.41-.255-.842-.385-1.313-.553-2,0-4.591,1.7-7.927a.309.309,0,0,1,.55.28c-1.622,3.191-2.162,5.639-1.651,7.482.129.466.258.894.382,1.3a10.58,10.58,0,0,1,.634,5.082,5.633,5.633,0,0,1-1.747,3.22,2.963,2.963,0,0,0,1.509-.668,4.665,4.665,0,0,0,1.26-3.694.308.308,0,0,1,.616,0,5.224,5.224,0,0,1-1.481,4.169,3.7,3.7,0,0,1-2.4.852Z"
            transform="translate(-14.224 -15.811)"
          />
          <path
            id="Path_4499"
            data-name="Path 4499"
            d="M100.568,123.067a.342.342,0,0,1-.082-.011c-.038-.01-3.718-1.091-2.967-6.294a.308.308,0,0,1,.61.088c-.421,2.921.631,4.373,1.5,5.057a5.335,5.335,0,0,1-.416-4.327,7.652,7.652,0,0,1,1.989-2.83c1.451-1.5,3.1-3.2,3.115-8.234a.307.307,0,0,1,.308-.307h0a.308.308,0,0,1,.307.31c-.021,5.284-1.757,7.077-3.289,8.659a7.065,7.065,0,0,0-1.851,2.607,5.211,5.211,0,0,0,1,4.77.309.309,0,0,1-.231.512Z"
            transform="translate(-14.923 -15.811)"
          />
          <path
            id="Path_4500"
            data-name="Path 4500"
            d="M101.259,112.206a.328.328,0,0,1-.189-.054c-.2-.145-.321-.233.5-3.072.435-1.5,1.009-3.3,1.463-4.58a.26.26,0,0,1,.032-.065c-.024-.158-.049-.309-.077-.451a.308.308,0,1,1,.605-.118c.115.592,1.038,5.857-2.12,8.274a.367.367,0,0,1-.218.068Zm1.934-6.26c-.636,1.917-1.277,4.09-1.535,5.193A7.584,7.584,0,0,0,103.193,105.946Z"
            transform="translate(-15.46 -15.413)"
          />
          <path
            id="Path_4501"
            data-name="Path 4501"
            d="M109.01,91.18a.308.308,0,0,1-.2-.546,20.9,20.9,0,0,0,3.3-3.846.308.308,0,0,1,.509.348A21.6,21.6,0,0,1,109.2,91.11a.31.31,0,0,1-.195.07Z"
            transform="translate(-16.652 -12.815)"
          />
          <path
            id="Path_4502"
            data-name="Path 4502"
            d="M120.053,84.408a.3.3,0,0,1-.156-.042c-1.539-.9-2.459-2.92-1.968-4.321a2.119,2.119,0,0,1,1.377-1.346,2.455,2.455,0,0,1,2.18.436.308.308,0,0,1-.366.5,1.849,1.849,0,0,0-1.633-.343,1.511,1.511,0,0,0-.976.961,3.419,3.419,0,0,0,1.7,3.584.309.309,0,0,1-.156.575Z"
            transform="translate(-18.045 -11.581)"
          />
          <path
            id="Path_4503"
            data-name="Path 4503"
            d="M120.627,82.608a.31.31,0,0,1-.307-.279A1.356,1.356,0,0,0,119.8,81.3a.308.308,0,1,1,.341-.514,1.942,1.942,0,0,1,.792,1.48.309.309,0,0,1-.277.337l-.03,0Z"
            transform="translate(-18.331 -11.909)"
          />
          <path
            id="Path_4504"
            data-name="Path 4504"
            d="M129.916,83.009c.163-.5.022-.994-.315-1.105s-.743.206-.906.706-.022.994.316,1.105.743-.206.906-.706Z"
            transform="translate(-19.704 -12.084)"
            fillRule="evenodd"
          />
          <path
            id="Path_4505"
            data-name="Path 4505"
            d="M130.512,80.3a.308.308,0,0,1-.188-.064,1.763,1.763,0,0,0-2-.075.308.308,0,1,1-.32-.527,2.376,2.376,0,0,1,2.7.112.309.309,0,0,1-.188.553Z"
            transform="translate(-19.586 -11.683)"
          />
          <path
            id="Path_4506"
            data-name="Path 4506"
            d="M126,94.605a7.416,7.416,0,0,1-3.239-1.558,17.651,17.651,0,0,1-2.112-2.062,4.232,4.232,0,0,0-.015,1.713,4.728,4.728,0,0,0,.482,1.678l1.07-.688,3.813.917Z"
            transform="translate(-18.469 -13.478)"
            fillRule="evenodd"
          />
          <path
            id="Path_4507"
            data-name="Path 4507"
            d="M118.884,94.168a.309.309,0,0,1-.253-.485c.078-.111,1.919-2.713,3.537-2.8a2.79,2.79,0,0,1,1.467.452,4.475,4.475,0,0,0,1.6.574c.946.12,1.5-.062,2.1-1.412.3-.687.563-1.363.793-1.961.237-.618.442-1.152.645-1.574a3.169,3.169,0,0,1,1.009-1.07,2.006,2.006,0,0,0,.746-.791c.069-.211-.116-.436-.45-.814a2.989,2.989,0,0,1-.963-2.619c.072-.451.19-.919.315-1.415a15.8,15.8,0,0,0,.4-1.936,4.856,4.856,0,0,0-.893-3.137.309.309,0,0,1,.523-.328,5.453,5.453,0,0,1,.981,3.54,16.254,16.254,0,0,1-.416,2.011c-.121.481-.235.937-.3,1.361a2.411,2.411,0,0,0,.817,2.114c.371.421.755.858.573,1.414a2.447,2.447,0,0,1-.958,1.089,2.679,2.679,0,0,0-.83.848c-.191.4-.392.922-.625,1.527s-.495,1.288-.8,1.989c-.645,1.463-1.388,1.945-2.738,1.776a5.05,5.05,0,0,1-1.815-.64A2.266,2.266,0,0,0,122.2,91.5c-1.095.06-2.584,1.855-3.065,2.541a.31.31,0,0,1-.253.131Z"
            transform="translate(-18.164 -10.984)"
          />
          <path
            id="Path_4508"
            data-name="Path 4508"
            d="M128.882,89.348s-.782,2.344-2.4,1.553c-1.292-.629-1.011-2.807-1.011-2.807a13.73,13.73,0,0,0,1.756.808,12.135,12.135,0,0,0,1.66.446Z"
            transform="translate(-19.216 -13.036)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_4509"
            data-name="Path 4509"
            d="M127.073,91.316a1.783,1.783,0,0,1-.786-.2c-1.474-.718-1.194-3.027-1.181-3.124a.307.307,0,0,1,.168-.237.31.31,0,0,1,.29.007,13.423,13.423,0,0,0,1.712.788,11.942,11.942,0,0,0,1.609.433.309.309,0,0,1,.236.4,3.256,3.256,0,0,1-1.455,1.806,1.514,1.514,0,0,1-.593.122Zm-1.379-2.782c0,.614.114,1.668.863,2.032a1.009,1.009,0,0,0,.867.06,2.241,2.241,0,0,0,.975-1.111,10.942,10.942,0,0,1-1.338-.383A13.6,13.6,0,0,1,125.694,88.535Z"
            transform="translate(-19.16 -12.979)"
          />
          <path
            id="Path_4510"
            data-name="Path 4510"
            d="M124.028,79.567a4.03,4.03,0,0,1-1.151-.17.308.308,0,1,1,.175-.591c3.025.9,5.662-2.629,6.743-4.859a.309.309,0,0,1,.556.269c-1.033,2.129-3.416,5.35-6.324,5.35Z"
            transform="translate(-18.79 -10.842)"
          />
          <path
            id="Path_4511"
            data-name="Path 4511"
            d="M133.049,82.13a.309.309,0,0,1-.252-.488,2.5,2.5,0,0,0,.019-2.841.308.308,0,1,1,.495-.367,2.858,2.858,0,0,1,.52,2.239,3.634,3.634,0,0,0,.65-1.86,4.044,4.044,0,0,0-.715-2.653A8.227,8.227,0,0,1,133,74.494c-.86-2.738-1.208-3.462-4.185-3.657a.309.309,0,0,1,.041-.616c3.351.22,3.832,1.222,4.733,4.088a7.647,7.647,0,0,0,.719,1.545,4.654,4.654,0,0,1,.793,3,4.021,4.021,0,0,1-1.9,3.234.309.309,0,0,1-.145.036Z"
            transform="translate(-19.688 -10.297)"
          />
          <path
            id="Path_4512"
            data-name="Path 4512"
            d="M114.455,70.269a.309.309,0,0,1-.213-.533,7.338,7.338,0,0,1,2-1.372c2.594-1.175,5.748-.9,8.885.789l.1.055a.309.309,0,0,1-.284.548l-.111-.059c-3.005-1.615-5.889-1.881-8.338-.771a6.726,6.726,0,0,0-1.829,1.259.308.308,0,0,1-.213.085Z"
            transform="translate(-17.486 -9.903)"
          />
          <path
            id="Path_4513"
            data-name="Path 4513"
            d="M112.739,86.685a1.224,1.224,0,0,1-.627-.115,5.237,5.237,0,0,1-1.147-1.122.309.309,0,0,1,.494-.371,4.588,4.588,0,0,0,1.011.99,6.68,6.68,0,0,0,5.05-2.412.308.308,0,1,1,.456.415,7.674,7.674,0,0,1-5.238,2.615Z"
            transform="translate(-16.989 -12.34)"
          />
          <path
            id="Path_4514"
            data-name="Path 4514"
            d="M131.585,83.361a.308.308,0,0,1-.089-.6c1.073-.326,1.855-2.887,1.7-4.189a.309.309,0,0,1,.613-.073c.187,1.566-.714,4.422-2.133,4.853a.311.311,0,0,1-.09.014Z"
            transform="translate(-20.11 -11.523)"
          />
          <path
            id="Path_4515"
            data-name="Path 4515"
            d="M91.332,138.5c-4.69,0-10.8-.983-15.074-5.284a.308.308,0,1,1,.437-.434c7.592,7.636,21.243,4.456,21.379,4.422a.309.309,0,0,1,.144.6,33.1,33.1,0,0,1-6.887.7Z"
            transform="translate(-11.668 -19.867)"
          />
          <path
            id="Path_4516"
            data-name="Path 4516"
            d="M88.155,142.584c-4.543,0-10.016-1.116-14.265-5.41a.309.309,0,0,1,.439-.434c8.531,8.621,22.232,4,22.37,3.953a.308.308,0,0,1,.2.583,29.9,29.9,0,0,1-8.745,1.309Z"
            transform="translate(-11.305 -20.473)"
            fill="#7a67d9"
          />
          <path
            id="Path_4517"
            data-name="Path 4517"
            d="M100.633,153.881a.308.308,0,0,1-.124-.59,77.382,77.382,0,0,1,9.188-2.82c5.013-1.347,10.7-2.875,13.1-4.5a.309.309,0,1,1,.345.511c-2.486,1.68-7.974,3.155-13.282,4.582a76.96,76.96,0,0,0-9.1,2.789.3.3,0,0,1-.123.026Z"
            transform="translate(-15.369 -21.894)"
          />
          <path
            id="Path_4518"
            data-name="Path 4518"
            d="M123.125,172.055a.389.389,0,0,1-.053,0,.308.308,0,0,1-.252-.357,69.861,69.861,0,0,0,.6-10.565,56.667,56.667,0,0,0-.484-7.186,32.536,32.536,0,0,1-.325-5.562.3.3,0,0,1,.322-.295.307.307,0,0,1,.295.321,32.039,32.039,0,0,0,.322,5.464,57.242,57.242,0,0,1,.489,7.257,70.375,70.375,0,0,1-.614,10.671A.308.308,0,0,1,123.125,172.055Z"
            transform="translate(-18.78 -22.225)"
          />
          <path
            id="Path_4519"
            data-name="Path 4519"
            d="M104.261,134.64a.308.308,0,0,1-.07-.609,174.858,174.858,0,0,1,17.9-2.73,19.858,19.858,0,0,1,4.352-.008.308.308,0,1,1-.075.612,19.355,19.355,0,0,0-4.215.011,174.23,174.23,0,0,0-17.823,2.717.337.337,0,0,1-.07.008Z"
            transform="translate(-15.924 -19.635)"
          />
          <path
            id="Path_4520"
            data-name="Path 4520"
            d="M131.85,167.5a.246.246,0,0,1-.043,0,.308.308,0,0,1-.263-.348,139.37,139.37,0,0,1,2.908-14.8c.279-1.158.557-2.318.835-3.529,1.271-5.549,1.978-9.705,1.292-11.944a7.678,7.678,0,0,0-.52-1.241.309.309,0,0,1,.545-.291,8.343,8.343,0,0,1,.566,1.352c.727,2.37.014,6.616-1.28,12.264-.279,1.213-.557,2.375-.837,3.535a138.8,138.8,0,0,0-2.9,14.746.308.308,0,0,1-.3.265Z"
            transform="translate(-20.151 -20.248)"
          />
          <path
            id="Path_4521"
            data-name="Path 4521"
            d="M135.825,186.285a20.866,20.866,0,0,1-4.518-.433c-.888-.209-1.635-.393-2.279-.55a19.382,19.382,0,0,0-3.5-.685c-2.821-.134-4.058-.392-4.564-.953a1.307,1.307,0,0,1-.295-1.009,24.885,24.885,0,0,1,1.383-6.916.686.686,0,0,1,.462-.475c.3-.058.522.182.777.457.626.674,1.568,1.692,3.949-.169a3.828,3.828,0,0,1,.251-1.752,2.475,2.475,0,0,1,2.635-1.214,1.3,1.3,0,0,1,1.142,1.164,6.361,6.361,0,0,0,2.159,4.48,10.407,10.407,0,0,0,4.192,2.309,20.419,20.419,0,0,1,2.76,1.165c1.132.609,2.216,1.76,2.1,2.78-.049.413-.312.96-1.3,1.223a22.23,22.23,0,0,1-5.359.58Zm-5.38-1.273c.313.076.647.155,1,.239a24.152,24.152,0,0,0,9.577-.142c.521-.14.8-.373.843-.7.073-.628-.724-1.6-1.777-2.166a19.728,19.728,0,0,0-2.679-1.127,10.879,10.879,0,0,1-4.42-2.457,7.019,7.019,0,0,1-2.334-4.873c-.027-.421-.467-.56-.655-.6a1.842,1.842,0,0,0-1.96.9,5.928,5.928,0,0,0,.744,4.617,6.293,6.293,0,0,0,1.616,1.573c.782.611,1.521,1.186,1.622,1.852.084.553-.25,1.01-.755,1.7-.231.315-.513.7-.824,1.184Zm-7.8-9.08c0,.011-.01.024-.015.037a24.2,24.2,0,0,0-1.339,6.719.708.708,0,0,0,.138.561c.366.407,1.6.631,4.135.751a20.02,20.02,0,0,1,3.615.7l.638.157a.318.318,0,0,1,.016-.029c.359-.571.682-1.012.941-1.367.478-.653.688-.954.644-1.243-.064-.423-.738-.95-1.39-1.458A6.7,6.7,0,0,1,128.249,179a7.97,7.97,0,0,1-.936-2.733c-2.615,1.87-3.857.529-4.469-.13-.062-.068-.139-.15-.2-.208Z"
            transform="translate(-18.485 -25.972)"
          />
          <path
            id="Path_4522"
            data-name="Path 4522"
            d="M135.093,189.577a27.191,27.191,0,0,1-7.552-1.013,16.769,16.769,0,0,0-4.315-.567,4.553,4.553,0,0,1-2.4-.427c-1.048-.773-.289-3.038-.2-3.294a.309.309,0,0,1,.583.206c-.188.537-.6,2.166-.018,2.592a4.5,4.5,0,0,0,2.049.307,17.282,17.282,0,0,1,4.466.591,29.354,29.354,0,0,0,10.9.815c2.137-.2,3.467-.705,3.746-1.434.251-.651-.39-1.354-.4-1.361a.309.309,0,0,1,.451-.421,2.12,2.12,0,0,1,.523,2c-.377.991-1.812,1.607-4.268,1.833-1.013.092-2.224.176-3.574.176Z"
            transform="translate(-18.426 -27.738)"
          />
          <path
            id="Path_4523"
            data-name="Path 4523"
            d="M69.017,190.41a21.5,21.5,0,0,1-6.869-.952c-1.4-.535-1.426-2.56-1.435-3.321l0-.094c-.032-1.774.023-3.66.073-5.325.051-1.739.1-3.24.023-4.069a23.157,23.157,0,0,0-.488-2.95,9.22,9.22,0,0,1-.253-4.156,2.52,2.52,0,0,1,1.039-1.7,3.455,3.455,0,0,1,2.622-.045c.136.033.268.065.4.093a.308.308,0,1,1-.132.6c-.132-.029-.269-.062-.409-.1a3,3,0,0,0-2.152-.03,1.958,1.958,0,0,0-.761,1.313,8.754,8.754,0,0,0,.255,3.89,23.966,23.966,0,0,1,.5,3.025c.076.865.031,2.382-.021,4.14-.049,1.658-.1,3.537-.072,5.3l0,.1c.008.647.031,2.368,1.039,2.754a23.325,23.325,0,0,0,10.809.51,1.193,1.193,0,0,0,.848-.55,1.7,1.7,0,0,0-.276-1.364.308.308,0,0,1,.548-.282,2.194,2.194,0,0,1,.292,1.9,1.754,1.754,0,0,1-1.253.9,18.287,18.287,0,0,1-4.32.423Z"
            transform="translate(-9.179 -25.208)"
          />
          <path
            id="Path_4524"
            data-name="Path 4524"
            d="M74.782,179.812a.308.308,0,0,1-.3-.246c-1.006-4.856,2.027-7.227,2.156-7.325a.308.308,0,0,1,.374.49c-.117.09-2.851,2.248-1.927,6.709a.308.308,0,0,1-.239.364.267.267,0,0,1-.063.007Z"
            transform="translate(-11.378 -25.916)"
          />
          <path
            id="Path_4525"
            data-name="Path 4525"
            d="M128.419,170.8a8.235,8.235,0,0,1-4.765-1.576.308.308,0,1,1,.353-.506,7.052,7.052,0,0,0,6.631,1.076.308.308,0,0,1,.249.564,6.553,6.553,0,0,1-2.468.441Z"
            transform="translate(-18.922 -25.378)"
            fill="#fff"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_4526"
            data-name="Path 4526"
            d="M208.883,63.052a.309.309,0,0,1-.029-.616,3.03,3.03,0,0,0,2.553-2.228,2.266,2.266,0,0,0-.532-1.823,1.81,1.81,0,0,0-1.673-.178.309.309,0,0,1-.157-.6,2.376,2.376,0,0,1,2.229.3,2.866,2.866,0,0,1,.748,2.35,3.612,3.612,0,0,1-3.11,2.786l-.03,0Z"
            transform="translate(-31.952 -8.345)"
          />
          <path
            id="Path_4527"
            data-name="Path 4527"
            d="M209.618,61.187a.308.308,0,0,1-.252-.484,4.9,4.9,0,0,1,.719-.838.309.309,0,0,1,.386.481,4.365,4.365,0,0,0-.6.709.308.308,0,0,1-.254.132Z"
            transform="translate(-32.064 -8.701)"
          />
          <path
            id="Path_4528"
            data-name="Path 4528"
            d="M197.543,71.087a2.937,2.937,0,0,1-1.454-.372c-1.762-.983-3.282-4.332-3.449-4.71a10.864,10.864,0,0,1-.945-3.579c-.014-.264-.019-.58-.025-.93-.012-.715-.027-1.606-.126-2.475-.055-.481-.122-.876-.188-1.258a13.093,13.093,0,0,1-.235-2.163,8.033,8.033,0,0,1,.759-3.411c.218-.464.483-.911.941-1.028a1.326,1.326,0,0,1,1.108.322.309.309,0,0,1-.364.5.857.857,0,0,0-.591-.223c-.213.054-.4.4-.536.693a7.363,7.363,0,0,0-.7,3.135,12.6,12.6,0,0,0,.228,2.073c.067.391.136.8.193,1.293.1.9.117,1.805.13,2.534.005.342.011.651.025.909a9.94,9.94,0,0,0,.893,3.361c.748,1.69,2.064,3.8,3.186,4.421,1.17.653,2.75.219,4.972-1.365a14.025,14.025,0,0,0,1.888-1.7,9.925,9.925,0,0,0,1.9-3.455.308.308,0,1,1,.579.212,10.448,10.448,0,0,1-2.021,3.654,14.678,14.678,0,0,1-1.987,1.793,7.7,7.7,0,0,1-4.177,1.774Z"
            transform="translate(-29.277 -7.374)"
          />
          <path
            id="Path_4529"
            data-name="Path 4529"
            d="M196.172,64.778a.311.311,0,0,1-.172-.052c-.757-.509-1.175-.958-.916-1.629.037-.1.1-.216.163-.354a3.809,3.809,0,0,0,.435-1.272,2.961,2.961,0,0,0-.635-1.856.308.308,0,1,1,.517-.337,3.54,3.54,0,0,1,.732,2.252,4.291,4.291,0,0,1-.5,1.485c-.058.118-.108.219-.141.3-.063.163-.133.347.684.9a.309.309,0,0,1-.173.565Z"
            transform="translate(-29.871 -8.6)"
          />
          <path
            id="Path_4530"
            data-name="Path 4530"
            d="M199.983,66.512a19.976,19.976,0,0,1-2.6.629,14.637,14.637,0,0,1-2.516.173s.97,2.671,2.907,2.188,2.21-2.99,2.21-2.99Z"
            transform="translate(-29.851 -9.729)"
            fill="#fff"
            fillRule="evenodd"
          />
          <path
            id="Path_4531"
            data-name="Path 4531"
            d="M197.263,69.811c-1.451,0-2.413-1.541-2.743-2.449a.306.306,0,0,1,.041-.286.289.289,0,0,1,.26-.127,14.579,14.579,0,0,0,2.456-.169,19.7,19.7,0,0,0,2.556-.618.308.308,0,0,1,.4.327c-.012.111-.32,2.728-2.442,3.256a2.163,2.163,0,0,1-.528.067Zm-1.975-2.244c.342.669,1.141,1.879,2.355,1.579a2.912,2.912,0,0,0,1.882-2.247,19.289,19.289,0,0,1-2.15.49,15.052,15.052,0,0,1-2.086.178Z"
            transform="translate(-29.796 -9.673)"
          />
          <path
            id="Path_4532"
            data-name="Path 4532"
            d="M200.367,60.452a1.2,1.2,0,0,0-.9-1.138c-.445-.041-.764.4-.713.992a1.2,1.2,0,0,0,.9,1.138C200.1,61.484,200.418,61.039,200.367,60.452Z"
            transform="translate(-30.446 -8.626)"
            fillRule="evenodd"
          />
          <path
            id="Path_4533"
            data-name="Path 4533"
            d="M200.624,57.388a.316.316,0,0,1-.141-.033c-.015-.008-1.611-.808-2.678-.086a.308.308,0,1,1-.346-.511c1.368-.927,3.226.008,3.3.049a.309.309,0,0,1-.141.583Z"
            transform="translate(-30.228 -8.172)"
          />
          <path
            id="Path_4534"
            data-name="Path 4534"
            d="M191.787,57.875a.308.308,0,0,1-.169-.566,2.216,2.216,0,0,1,2.156-.2.308.308,0,0,1-.281.549,1.6,1.6,0,0,0-1.537.164.307.307,0,0,1-.169.05Z"
            transform="translate(-29.332 -8.26)"
          />
          <path
            id="Path_4535"
            data-name="Path 4535"
            d="M212.109,64.511c-.7,0-1.785-1.076-2.324-2.371a.309.309,0,0,1,.57-.237,3.679,3.679,0,0,0,1.672,1.979.965.965,0,0,0-.025-.112c-.247-.822.171-1.86.657-3.062a15.927,15.927,0,0,0,.746-2.13,6.569,6.569,0,0,0-.2-3.54.309.309,0,0,1,.575-.225,7.091,7.091,0,0,1,.229,3.911,16.586,16.586,0,0,1-.774,2.214,5.053,5.053,0,0,0-.639,2.653c.2.656-.169.844-.285.886a.588.588,0,0,1-.2.032Z"
            transform="translate(-32.133 -7.908)"
          />
          <path
            id="Path_4536"
            data-name="Path 4536"
            d="M208.627,47.36a.308.308,0,0,1-.229-.1c-1.888-2.1-5.668-1.58-5.708-1.574a.309.309,0,0,1-.088-.611c.169-.024,4.143-.574,6.255,1.772a.308.308,0,0,1-.229.515Z"
            transform="translate(-30.996 -6.434)"
          />
          <path
            id="Path_4537"
            data-name="Path 4537"
            d="M206.965,58.041c-1.106,0-1.825-.793-2.684-1.884a.309.309,0,1,1,.484-.383c1,1.273,1.578,1.781,2.526,1.62a.308.308,0,0,1,.1.608,2.583,2.583,0,0,1-.429.037Z"
            transform="translate(-31.283 -8.067)"
          />
          <path
            id="Path_4538"
            data-name="Path 4538"
            d="M194.269,61.177a1.386,1.386,0,0,0-.6-1.346c-.395-.194-.766.1-.826.647a1.387,1.387,0,0,0,.6,1.346c.395.193.766-.1.827-.646Z"
            transform="translate(-29.54 -8.697)"
            fillRule="evenodd"
          />
          <path
            id="Path_4539"
            data-name="Path 4539"
            d="M204.054,55.33a6.888,6.888,0,0,1-1.138-.1c-2.682-.453-4.717-2.714-5.586-3.681-.109-.121-.2-.223-.275-.3-.66-.692-.93-.725-1.012-.707-.184.038-.364.523-.451.756a.309.309,0,0,1-.579-.216c.2-.547.428-1.047.906-1.145.426-.089.914.186,1.582.887.078.082.174.189.288.315.9,1,2.759,3.068,5.229,3.485a4.854,4.854,0,0,0,2.945-.3c-1.271-.2-3.618-.7-4.889-2.325a.308.308,0,0,1,.486-.38c1.291,1.651,4.039,2.034,4.942,2.16a2.548,2.548,0,0,1,.388.067.311.311,0,0,1,.2.369,3.726,3.726,0,0,1-3.038,1.115Z"
            transform="translate(-29.871 -7.188)"
          />
          <path
            id="Path_4540"
            data-name="Path 4540"
            d="M191.229,57.491a.307.307,0,0,1-.293-.212,4.924,4.924,0,0,0-1.2-1.988c-.125-.14-.25-.279-.373-.429a2.731,2.731,0,0,1-.552-2.761,10.814,10.814,0,0,1,2.025-3.373,2.59,2.59,0,0,1,2.328-.822.308.308,0,1,1-.091.61,1.98,1.98,0,0,0-1.8.644,10.278,10.278,0,0,0-1.883,3.144,2.123,2.123,0,0,0,.448,2.167c.117.142.235.274.353.407a5.5,5.5,0,0,1,1.331,2.207.308.308,0,0,1-.2.39.3.3,0,0,1-.1.015Z"
            transform="translate(-28.898 -6.874)"
          />
          <path
            id="Path_4541"
            data-name="Path 4541"
            d="M193.967,49.236h0a.31.31,0,0,1-.307-.311,4.289,4.289,0,0,1,.97-3.162c.55-.5,1.653-.5,2.928-.49a15.3,15.3,0,0,0,2.639-.139.308.308,0,0,1,.108.608,15.837,15.837,0,0,1-2.749.148,4.758,4.758,0,0,0-2.508.328,3.806,3.806,0,0,0-.771,2.713A.309.309,0,0,1,193.967,49.236Z"
            transform="translate(-29.666 -6.454)"
          />
          <path
            id="Path_4542"
            data-name="Path 4542"
            d="M214.643,56.815h-.012a.31.31,0,0,1-.3-.291,7,7,0,0,0-2.212-4.083.309.309,0,0,1,.433-.44,8.786,8.786,0,0,1,1.861,2.618,6.25,6.25,0,0,0-.369-2.075,7.173,7.173,0,0,0-3.136-3.907.309.309,0,0,1,.351-.509,7.762,7.762,0,0,1,3.358,4.182,9.919,9.919,0,0,1,.329,4.236.308.308,0,0,1-.306.266Z"
            transform="translate(-32.289 -6.905)"
          />
          <path
            id="Path_4543"
            data-name="Path 4543"
            d="M207.636,53.322a7.029,7.029,0,0,1-2.75-.587.308.308,0,0,1,.251-.563,5.487,5.487,0,0,0,3.908.293.309.309,0,0,1,.229.573,4.445,4.445,0,0,1-1.637.284Z"
            transform="translate(-31.358 -7.528)"
          />
          <path
            id="Path_4544"
            data-name="Path 4544"
            d="M206.4,67.938a14.818,14.818,0,0,1-2.83,3.289,12.226,12.226,0,0,1-2.624,1.782l.664,1.768a5.984,5.984,0,0,0,1.57-.7,6.074,6.074,0,0,0,1.327-1.228c1.326-1.617,1.893-4.913,1.893-4.913Z"
            transform="translate(-30.782 -9.948)"
            fillRule="evenodd"
          />
          <path
            id="Path_4545"
            data-name="Path 4545"
            d="M217.261,180.63a16.563,16.563,0,0,1-2.027-.124c-3.826-.471-6.857-2.2-8.532-4.867a.308.308,0,0,1,.522-.328c1.574,2.507,4.446,4.135,8.085,4.583,4.212.52,8.664-.687,11.074-3a.309.309,0,0,1,.428.446C224.663,179.4,221,180.63,217.261,180.63Z"
            transform="translate(-31.657 -26.374)"
          />
          <path
            id="Path_4546"
            data-name="Path 4546"
            d="M220.886,183.264a.308.308,0,0,1-.005-.617c4.687-.06,8.709-2.7,11.036-7.251a.308.308,0,1,1,.549.281,13.221,13.221,0,0,1-11.577,7.588h0Z"
            transform="translate(-33.79 -26.384)"
          />
          <path
            id="Path_4547"
            data-name="Path 4547"
            d="M63.6,122.95a.309.309,0,0,1-.247-.123,13.238,13.238,0,0,1-2.176-9.908,14.7,14.7,0,0,1,6.175-9.837.308.308,0,0,1,.353.506,14.091,14.091,0,0,0-5.918,9.428,12.614,12.614,0,0,0,2.059,9.439.31.31,0,0,1-.247.5Z"
            transform="translate(-9.344 -15.323)"
          />
          <path
            id="Path_4548"
            data-name="Path 4548"
            d="M63.76,128.4a.315.315,0,0,1-.134-.03c-4.479-2.173-6.679-8.014-6.218-12.407a.315.315,0,0,1,.339-.274.309.309,0,0,1,.274.34c-.438,4.18,1.639,9.732,5.873,11.787a.308.308,0,0,1-.135.586Z"
            transform="translate(-8.785 -17.262)"
          />
          <path
            id="Path_4549"
            data-name="Path 4549"
            d="M240.121,87.577a.314.314,0,0,1-.086-.012.308.308,0,0,1-.212-.382,12.242,12.242,0,0,0-1.43-9.264,13.671,13.671,0,0,0-8.649-6.471.309.309,0,1,1,.147-.6,14.287,14.287,0,0,1,9.037,6.761,12.862,12.862,0,0,1,1.488,9.744.307.307,0,0,1-.3.223Z"
            transform="translate(-35.158 -10.392)"
          />
          <path
            id="Path_4550"
            data-name="Path 4550"
            d="M242.666,92.177a.308.308,0,0,1-.226-.518c3.116-3.338,3.059-9.09,1.2-12.721a.309.309,0,1,1,.55-.281c1.953,3.821,2,9.886-1.3,13.422a.307.307,0,0,1-.224.1Z"
            transform="translate(-37.127 -11.564)"
          />
          <path
            id="Path_4551"
            data-name="Path 4551"
            d="M204.464,62.3a.467.467,0,0,1-.322-.135,3.764,3.764,0,0,1-.329-2.476.309.309,0,0,1,.6.15,4.283,4.283,0,0,0,.1,1.77,1.919,1.919,0,0,0,.123-1.08.308.308,0,1,1,.616-.036c.025.427.092,1.563-.656,1.787a.463.463,0,0,1-.13.02Z"
            transform="translate(-31.212 -8.648)"
          />
          <path
            id="Path_4552"
            data-name="Path 4552"
            d="M236.529,196.249h55.033"
            transform="translate(-36.234 -29.604)"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
          <path
            id="Path_4553"
            data-name="Path 4553"
            d="M10,196.249H196.325"
            transform="translate(-1.532 -29.604)"
            fill="none"
            stroke="#263238"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function ChoosePlanHistroyImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 78,
    height: 70.003,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 78 70.003"
      {...rest}
      sx={rootSx}
    >
      <g id="history" transform="translate(-45.04 -36.813)">
        <g id="OBJECTS" transform="translate(45.04 36.816)">
          <g
            id="Group_106187"
            data-name="Group 106187"
            transform="translate(0 66.147)"
          >
            <ellipse
              id="Ellipse_129831"
              data-name="Ellipse 129831"
              cx="39"
              cy="1.927"
              rx="39"
              ry="1.927"
              fill="#f5f5f5"
            />
          </g>
          <g
            id="Group_106189"
            data-name="Group 106189"
            transform="translate(25.014 0)"
          >
            <path
              id="Path_101440"
              data-name="Path 101440"
              d="M16.731,0A16.7,16.7,0,1,1,0,16.731,16.642,16.642,0,0,1,16.731,0Z"
              transform="translate(0 23.619) rotate(-45)"
              fill="#f7f6fe"
            />
            <path
              id="Path_101441"
              data-name="Path 101441"
              d="M6.313,0A6.3,6.3,0,1,1,0,6.313,6.28,6.28,0,0,1,6.313,0Z"
              transform="translate(18.39 16.519) rotate(-45)"
              fill="#fff"
            />
            <path
              id="Path_20985"
              data-name="Path 20985"
              d="M226.242,63.39a18.738,18.738,0,1,0,18.682,18.738A18.711,18.711,0,0,0,226.242,63.39Zm0,35.466A16.728,16.728,0,1,1,242.92,82.128,16.7,16.7,0,0,1,226.242,98.856Z"
              transform="translate(-202.617 -58.508)"
              fill="#7a67d9"
            />
            <path
              id="Path_20986"
              data-name="Path 20986"
              d="M305.38,125.556h1.108l-.555-9.856Z"
              transform="translate(-282.406 -101.147)"
              fill="#94c8e3"
              opacity="0.23"
            />
            <path
              id="Path_20987"
              data-name="Path 20987"
              d="M304.49,124.334H305.6l-.555-9.854Z"
              transform="translate(-281.68 -100.153)"
              fill="#6552cc"
            />
            <path
              id="Path_20988"
              data-name="Path 20988"
              d="M305.56,125.539l.839.727,8.086-10.235Z"
              transform="translate(-282.553 -101.416)"
              fill="#94c8e3"
              opacity="0.23"
            />
            <path
              id="Path_20989"
              data-name="Path 20989"
              d="M304.67,124.319l.839.727L313.6,114.81Z"
              transform="translate(-281.827 -100.422)"
              fill="#6552cc"
            />
            <ellipse
              id="Ellipse_129834"
              data-name="Ellipse 129834"
              cx="1.384"
              cy="1.388"
              rx="1.384"
              ry="1.388"
              transform="translate(21.978 22.496)"
              fill="#94c8e3"
              opacity="0.23"
            />
            <path
              id="Path_101442"
              data-name="Path 101442"
              d="M1.389,0A1.385,1.385,0,1,1,0,1.386,1.384,1.384,0,0,1,1.389,0Z"
              transform="matrix(0.231, -0.973, 0.973, 0.231, 21.699, 25.447)"
              fill="#94c8e3"
              opacity="0.23"
            />
            <ellipse
              id="Ellipse_129836"
              data-name="Ellipse 129836"
              cx="1.384"
              cy="1.388"
              rx="1.384"
              ry="1.388"
              transform="translate(21.978 22.793)"
              fill="#6552cc"
            />
            <path
              id="Path_20990"
              data-name="Path 20990"
              d="M304.037,166.3a.666.666,0,0,0,.8.446.722.722,0,0,0,.352-1.058.658.658,0,0,0-.772-.189.67.67,0,0,0-.374.8Z"
              transform="translate(-281.29 -141.7)"
              fill="#94c8e3"
              opacity="0.23"
            />
            <g
              id="Group_106188"
              data-name="Group 106188"
              transform="translate(7.813 7.762)"
            >
              <path
                id="Path_20991"
                data-name="Path 20991"
                d="M308.026,78.97a1.7,1.7,0,0,1,0,1.6,1.7,1.7,0,0,1,0-1.6Z"
                transform="translate(-292.214 -78.97)"
                fill="#7a67d9"
              />
              <path
                id="Path_20992"
                data-name="Path 20992"
                d="M266.02,90.46a1.691,1.691,0,0,1,.8,1.385,1.693,1.693,0,0,1-.8-1.385Z"
                transform="translate(-258.114 -88.336)"
                fill="#7a67d9"
              />
              <path
                id="Path_20993"
                data-name="Path 20993"
                d="M234.63,121.86a1.691,1.691,0,0,1,1.381.8,1.688,1.688,0,0,1-1.381-.8Z"
                transform="translate(-232.51 -113.93)"
                fill="#7a67d9"
              />
              <path
                id="Path_20994"
                data-name="Path 20994"
                d="M223.13,163.857a1.686,1.686,0,0,1,1.594,0,1.686,1.686,0,0,1-1.594,0Z"
                transform="translate(-223.13 -147.999)"
                fill="#7a67d9"
              />
              <path
                id="Path_20995"
                data-name="Path 20995"
                d="M234.63,204.109a1.684,1.684,0,0,1,1.381-.8,1.686,1.686,0,0,1-1.381.8Z"
                transform="translate(-232.51 -180.321)"
                fill="#7a67d9"
              />
              <path
                id="Path_20996"
                data-name="Path 20996"
                d="M266.02,232.915a1.7,1.7,0,0,1,.8-1.385,1.7,1.7,0,0,1-.8,1.385Z"
                transform="translate(-258.114 -203.324)"
                fill="#7a67d9"
              />
              <path
                id="Path_20997"
                data-name="Path 20997"
                d="M308.026,243.459a1.7,1.7,0,0,1,0-1.6,1.7,1.7,0,0,1,0,1.6Z"
                transform="translate(-292.214 -211.744)"
                fill="#7a67d9"
              />
              <path
                id="Path_20998"
                data-name="Path 20998"
                d="M348.266,232.915a1.691,1.691,0,0,1-.8-1.385,1.691,1.691,0,0,1,.8,1.385Z"
                transform="translate(-324.551 -203.324)"
                fill="#7a67d9"
              />
              <path
                id="Path_20999"
                data-name="Path 20999"
                d="M377.081,204.109a1.691,1.691,0,0,1-1.381-.8,1.688,1.688,0,0,1,1.381.8Z"
                transform="translate(-347.577 -180.321)"
                fill="#7a67d9"
              />
              <path
                id="Path_21000"
                data-name="Path 21000"
                d="M387.624,163.857a1.686,1.686,0,0,1-1.594,0,1.686,1.686,0,0,1,1.594,0Z"
                transform="translate(-356.003 -147.999)"
                fill="#7a67d9"
              />
              <path
                id="Path_21001"
                data-name="Path 21001"
                d="M377.081,121.86a1.684,1.684,0,0,1-1.381.8,1.687,1.687,0,0,1,1.381-.8Z"
                transform="translate(-347.577 -113.93)"
                fill="#7a67d9"
              />
              <path
                id="Path_21002"
                data-name="Path 21002"
                d="M348.266,90.46a1.7,1.7,0,0,1-.8,1.385,1.7,1.7,0,0,1,.8-1.385Z"
                transform="translate(-324.551 -88.336)"
                fill="#7a67d9"
              />
            </g>
            <path
              id="Path_21003"
              data-name="Path 21003"
              d="M235.1,75.129A16.7,16.7,0,0,1,251.77,91.406c0-.139.006-.277.006-.418a16.678,16.678,0,1,0-33.356,0c0,.139,0,.279.006.418A16.7,16.7,0,0,1,235.1,75.129Z"
              transform="translate(-211.475 -67.369)"
              fill="#9590af"
              opacity="0.23"
            />
            <path
              id="Path_21004"
              data-name="Path 21004"
              d="M304.037,165.095a.666.666,0,0,0,.8.446.722.722,0,0,0,.352-1.058.658.658,0,0,0-.772-.189.67.67,0,0,0-.374.8Z"
              transform="translate(-281.29 -140.713)"
              fill="#4c649e"
            />
            <path
              id="Path_21005"
              data-name="Path 21005"
              d="M328.88,68.08A16.528,16.528,0,0,1,340.6,76.72a16.712,16.712,0,0,0-1-1.594A17.923,17.923,0,0,0,328.88,68.08Z"
              transform="translate(-301.574 -62.331)"
              fill="#94c8e3"
            />
            <path
              id="Path_21006"
              data-name="Path 21006"
              d="M249.439,231.346a16.508,16.508,0,0,1-13.089-6.366,17.03,17.03,0,0,0,1.268,1.387,17.9,17.9,0,0,0,11.821,4.979Z"
              transform="translate(-226.1 -190.223)"
              fill="#94c8e3"
            />
          </g>
          <g
            id="Group_106241"
            data-name="Group 106241"
            transform="translate(7.543 25.968)"
          >
            <g id="Group_106202" data-name="Group 106202">
              <g
                id="Group_106192"
                data-name="Group 106192"
                transform="translate(0 1.779)"
              >
                <g id="Group_106191" data-name="Group 106191">
                  <rect
                    id="Rectangle_56185"
                    data-name="Rectangle 56185"
                    width="53.816"
                    height="40.275"
                    rx="4"
                    transform="translate(53.816 40.275) rotate(180)"
                    fill="#d7d5e2"
                  />
                  <path
                    id="Path_21009"
                    data-name="Path 21009"
                    d="M1.558,0H48.191a1.558,1.558,0,0,1,1.556,1.56V31.268H0V1.56A1.558,1.558,0,0,1,1.556,0Z"
                    transform="translate(51.781 37.933) rotate(180)"
                    fill="#f7f7f7"
                  />
                </g>
              </g>
              <g
                id="Group_106201"
                data-name="Group 106201"
                transform="translate(4.466)"
              >
                <g id="Group_106195" data-name="Group 106195">
                  <ellipse
                    id="Ellipse_129837"
                    data-name="Ellipse 129837"
                    cx="1.81"
                    cy="1.816"
                    rx="1.81"
                    ry="1.816"
                    transform="translate(0 4.027)"
                    fill="#f7f7f7"
                  />
                  <line
                    id="Line_1594"
                    data-name="Line 1594"
                    y2="5.587"
                    transform="translate(1.81)"
                    fill="none"
                    stroke="#9590af"
                    stroke-linecap="round"
                    stroke-width="3"
                  />
                </g>
                <g
                  id="Group_106196"
                  data-name="Group 106196"
                  transform="translate(8.252)"
                >
                  <ellipse
                    id="Ellipse_129838"
                    data-name="Ellipse 129838"
                    cx="1.81"
                    cy="1.816"
                    rx="1.81"
                    ry="1.816"
                    transform="translate(0 4.027)"
                    fill="#f7f7f7"
                  />
                  <line
                    id="Line_1595"
                    data-name="Line 1595"
                    y2="5.587"
                    transform="translate(1.81)"
                    fill="none"
                    stroke="#9590af"
                    stroke-linecap="round"
                    stroke-width="3"
                  />
                </g>
                <g
                  id="Group_106197"
                  data-name="Group 106197"
                  transform="translate(16.505)"
                >
                  <ellipse
                    id="Ellipse_129839"
                    data-name="Ellipse 129839"
                    cx="1.81"
                    cy="1.816"
                    rx="1.81"
                    ry="1.816"
                    transform="translate(0 4.027)"
                    fill="#f7f7f7"
                  />
                  <line
                    id="Line_1596"
                    data-name="Line 1596"
                    y2="5.587"
                    transform="translate(1.81)"
                    fill="none"
                    stroke="#9590af"
                    stroke-linecap="round"
                    stroke-width="3"
                  />
                </g>
                <g
                  id="Group_106198"
                  data-name="Group 106198"
                  transform="translate(24.757)"
                >
                  <ellipse
                    id="Ellipse_129840"
                    data-name="Ellipse 129840"
                    cx="1.81"
                    cy="1.816"
                    rx="1.81"
                    ry="1.816"
                    transform="translate(0 4.027)"
                    fill="#f7f7f7"
                  />
                  <line
                    id="Line_1597"
                    data-name="Line 1597"
                    y2="5.587"
                    transform="translate(1.81)"
                    fill="none"
                    stroke="#9590af"
                    stroke-linecap="round"
                    stroke-width="3"
                  />
                </g>
                <g
                  id="Group_106199"
                  data-name="Group 106199"
                  transform="translate(33.009)"
                >
                  <ellipse
                    id="Ellipse_129841"
                    data-name="Ellipse 129841"
                    cx="1.81"
                    cy="1.816"
                    rx="1.81"
                    ry="1.816"
                    transform="translate(0 4.027)"
                    fill="#f7f7f7"
                  />
                  <line
                    id="Line_1598"
                    data-name="Line 1598"
                    y2="5.587"
                    transform="translate(1.81)"
                    fill="none"
                    stroke="#9590af"
                    stroke-linecap="round"
                    stroke-width="3"
                  />
                </g>
                <g
                  id="Group_106200"
                  data-name="Group 106200"
                  transform="translate(41.262)"
                >
                  <ellipse
                    id="Ellipse_129842"
                    data-name="Ellipse 129842"
                    cx="1.81"
                    cy="1.816"
                    rx="1.81"
                    ry="1.816"
                    transform="translate(0 4.027)"
                    fill="#f7f7f7"
                  />
                  <line
                    id="Line_1599"
                    data-name="Line 1599"
                    y2="5.587"
                    transform="translate(1.81)"
                    fill="none"
                    stroke="#9590af"
                    stroke-linecap="round"
                    stroke-width="3"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_106240"
              data-name="Group 106240"
              transform="translate(3.399 9.442)"
            >
              <g
                id="Group_106212"
                data-name="Group 106212"
                transform="translate(0.367)"
              >
                <g
                  id="Group_106210"
                  data-name="Group 106210"
                  transform="translate(0 1.065)"
                >
                  <g
                    id="Group_106203"
                    data-name="Group 106203"
                    transform="translate(6.739)"
                  >
                    <line
                      id="Line_1600"
                      data-name="Line 1600"
                      x2="4.968"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1601"
                      data-name="Line 1601"
                      x2="4.968"
                      transform="translate(0 0.948)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1602"
                      data-name="Line 1602"
                      x2="4.968"
                      transform="translate(0 1.897)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1603"
                      data-name="Line 1603"
                      x2="4.968"
                      transform="translate(0 2.847)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1604"
                      data-name="Line 1604"
                      x2="4.968"
                      transform="translate(0 3.796)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1605"
                      data-name="Line 1605"
                      x2="4.968"
                      transform="translate(0 4.744)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1606"
                      data-name="Line 1606"
                      x2="4.968"
                      transform="translate(0 5.694)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1607"
                      data-name="Line 1607"
                      x2="3.163"
                      transform="translate(0 6.643)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                  <g
                    id="Group_106204"
                    data-name="Group 106204"
                    transform="translate(0 6.741)"
                  >
                    <line
                      id="Line_1608"
                      data-name="Line 1608"
                      x2="4.969"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1609"
                      data-name="Line 1609"
                      x2="4.969"
                      transform="translate(0 0.95)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1610"
                      data-name="Line 1610"
                      x2="4.969"
                      transform="translate(0 1.899)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1611"
                      data-name="Line 1611"
                      x2="4.969"
                      transform="translate(0 2.849)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1612"
                      data-name="Line 1612"
                      x2="4.969"
                      transform="translate(0 3.798)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1613"
                      data-name="Line 1613"
                      x2="4.969"
                      transform="translate(0 4.746)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1614"
                      data-name="Line 1614"
                      x2="4.969"
                      transform="translate(0 5.696)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1615"
                      data-name="Line 1615"
                      x2="3.163"
                      transform="translate(0 6.645)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                  <g
                    id="Group_106205"
                    data-name="Group 106205"
                    transform="translate(14.212 8.886)"
                  >
                    <line
                      id="Line_1616"
                      data-name="Line 1616"
                      x2="4.968"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1617"
                      data-name="Line 1617"
                      x2="4.968"
                      transform="translate(0 0.95)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1618"
                      data-name="Line 1618"
                      x2="4.968"
                      transform="translate(0 1.899)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1619"
                      data-name="Line 1619"
                      x2="4.968"
                      transform="translate(0 2.847)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1620"
                      data-name="Line 1620"
                      x2="4.968"
                      transform="translate(0 3.798)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1621"
                      data-name="Line 1621"
                      x2="4.968"
                      transform="translate(0 4.746)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1622"
                      data-name="Line 1622"
                      x2="4.968"
                      transform="translate(0 5.694)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1623"
                      data-name="Line 1623"
                      x2="3.163"
                      transform="translate(0 6.645)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                  <g
                    id="Group_106206"
                    data-name="Group 106206"
                    transform="translate(20.658 13.192)"
                  >
                    <line
                      id="Line_1624"
                      data-name="Line 1624"
                      x2="4.968"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1625"
                      data-name="Line 1625"
                      x2="4.968"
                      transform="translate(0 0.948)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1626"
                      data-name="Line 1626"
                      x2="4.968"
                      transform="translate(0 1.899)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1627"
                      data-name="Line 1627"
                      x2="4.968"
                      transform="translate(0 2.847)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1628"
                      data-name="Line 1628"
                      x2="4.968"
                      transform="translate(0 3.796)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1629"
                      data-name="Line 1629"
                      x2="4.968"
                      transform="translate(0 4.746)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1630"
                      data-name="Line 1630"
                      x2="4.968"
                      transform="translate(0 5.694)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1631"
                      data-name="Line 1631"
                      x2="3.163"
                      transform="translate(0 6.643)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                  <g
                    id="Group_106207"
                    data-name="Group 106207"
                    transform="translate(27.916 8.165)"
                  >
                    <line
                      id="Line_1632"
                      data-name="Line 1632"
                      x2="4.968"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1633"
                      data-name="Line 1633"
                      x2="4.968"
                      transform="translate(0 0.95)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1634"
                      data-name="Line 1634"
                      x2="4.968"
                      transform="translate(0 1.899)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1635"
                      data-name="Line 1635"
                      x2="4.968"
                      transform="translate(0 2.849)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1636"
                      data-name="Line 1636"
                      x2="4.968"
                      transform="translate(0 3.798)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1637"
                      data-name="Line 1637"
                      x2="4.968"
                      transform="translate(0 4.746)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1638"
                      data-name="Line 1638"
                      x2="4.968"
                      transform="translate(0 5.696)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1639"
                      data-name="Line 1639"
                      x2="3.163"
                      transform="translate(0 6.645)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                  <g
                    id="Group_106208"
                    data-name="Group 106208"
                    transform="translate(34.539 0.473)"
                  >
                    <line
                      id="Line_1640"
                      data-name="Line 1640"
                      x2="4.969"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1641"
                      data-name="Line 1641"
                      x2="4.969"
                      transform="translate(0 0.95)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1642"
                      data-name="Line 1642"
                      x2="4.969"
                      transform="translate(0 1.899)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1643"
                      data-name="Line 1643"
                      x2="4.969"
                      transform="translate(0 2.847)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1644"
                      data-name="Line 1644"
                      x2="4.969"
                      transform="translate(0 3.798)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1645"
                      data-name="Line 1645"
                      x2="4.969"
                      transform="translate(0 4.746)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1646"
                      data-name="Line 1646"
                      x2="4.969"
                      transform="translate(0 5.694)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1647"
                      data-name="Line 1647"
                      x2="3.163"
                      transform="translate(0 6.645)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                  <g
                    id="Group_106209"
                    data-name="Group 106209"
                    transform="translate(41.791 19.047)"
                  >
                    <line
                      id="Line_1648"
                      data-name="Line 1648"
                      x2="4.968"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1649"
                      data-name="Line 1649"
                      x2="4.968"
                      transform="translate(0 0.948)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1650"
                      data-name="Line 1650"
                      x2="4.968"
                      transform="translate(0 1.899)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1651"
                      data-name="Line 1651"
                      x2="4.968"
                      transform="translate(0 2.847)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1652"
                      data-name="Line 1652"
                      x2="4.968"
                      transform="translate(0 3.796)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1653"
                      data-name="Line 1653"
                      x2="4.968"
                      transform="translate(0 4.746)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1654"
                      data-name="Line 1654"
                      x2="4.968"
                      transform="translate(0 5.694)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                    <line
                      id="Line_1655"
                      data-name="Line 1655"
                      x2="3.163"
                      transform="translate(0 6.643)"
                      fill="none"
                      stroke="#d1d7e0"
                      stroke-width="0.3"
                    />
                  </g>
                </g>
                <g
                  id="Group_106211"
                  data-name="Group 106211"
                  transform="translate(5.893)"
                >
                  <line
                    id="Line_1656"
                    data-name="Line 1656"
                    y2="28.162"
                    fill="none"
                    stroke="#d1d7e0"
                    stroke-width="0.3"
                  />
                  <line
                    id="Line_1657"
                    data-name="Line 1657"
                    y2="28.162"
                    transform="translate(6.899)"
                    fill="none"
                    stroke="#d1d7e0"
                    stroke-width="0.3"
                  />
                  <line
                    id="Line_1658"
                    data-name="Line 1658"
                    y2="28.162"
                    transform="translate(13.799)"
                    fill="none"
                    stroke="#d1d7e0"
                    stroke-width="0.3"
                  />
                  <line
                    id="Line_1659"
                    data-name="Line 1659"
                    y2="28.162"
                    transform="translate(20.698)"
                    fill="none"
                    stroke="#d1d7e0"
                    stroke-width="0.3"
                  />
                  <line
                    id="Line_1660"
                    data-name="Line 1660"
                    y2="28.162"
                    transform="translate(27.598)"
                    fill="none"
                    stroke="#d1d7e0"
                    stroke-width="0.3"
                  />
                  <line
                    id="Line_1661"
                    data-name="Line 1661"
                    y2="28.162"
                    transform="translate(34.497)"
                    fill="none"
                    stroke="#d1d7e0"
                    stroke-width="0.3"
                  />
                </g>
              </g>
              <g
                id="Group_106239"
                data-name="Group 106239"
                transform="translate(0 0.444)"
              >
                <g id="Group_106238" data-name="Group 106238">
                  <g id="Group_106227" data-name="Group 106227">
                    <g id="Group_106219" data-name="Group 106219">
                      <rect
                        id="Rectangle_56186"
                        data-name="Rectangle 56186"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21034"
                        data-name="Path 21034"
                        d="M104.467,230.91h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,104.467,230.91Z"
                        transform="translate(-104.399 -230.91)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106220"
                      data-name="Group 106220"
                      transform="translate(7.038 10.065)"
                    >
                      <rect
                        id="Rectangle_56187"
                        data-name="Rectangle 56187"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21035"
                        data-name="Path 21035"
                        d="M142.647,285.35h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,142.647,285.35Z"
                        transform="translate(-142.579 -285.35)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106221"
                      data-name="Group 106221"
                      transform="translate(20.586 1.416)"
                    >
                      <rect
                        id="Rectangle_56188"
                        data-name="Rectangle 56188"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21036"
                        data-name="Path 21036"
                        d="M216.147,238.57h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,216.147,238.57Z"
                        transform="translate(-216.079 -238.57)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106222"
                      data-name="Group 106222"
                      transform="translate(27.634 19.842)"
                    >
                      <rect
                        id="Rectangle_56189"
                        data-name="Rectangle 56189"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21037"
                        data-name="Path 21037"
                        d="M254.387,338.23h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,254.387,338.23Z"
                        transform="translate(-254.319 -338.23)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106223"
                      data-name="Group 106223"
                      transform="translate(34.773 9.102)"
                    >
                      <rect
                        id="Rectangle_56190"
                        data-name="Rectangle 56190"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21038"
                        data-name="Path 21038"
                        d="M293.117,280.14h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,293.117,280.14Z"
                        transform="translate(-293.049 -280.14)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106224"
                      data-name="Group 106224"
                      transform="translate(41.719 1.096)"
                    >
                      <rect
                        id="Rectangle_56191"
                        data-name="Rectangle 56191"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21039"
                        data-name="Path 21039"
                        d="M330.8,236.84H336s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,330.8,236.84Z"
                        transform="translate(-330.729 -236.84)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106225"
                      data-name="Group 106225"
                      transform="translate(42.331 12.665)"
                    >
                      <rect
                        id="Rectangle_56192"
                        data-name="Rectangle 56192"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21040"
                        data-name="Path 21040"
                        d="M334.117,299.41h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,334.117,299.41Z"
                        transform="translate(-334.049 -299.41)"
                        fill="#cbc6e9"
                      />
                    </g>
                    <g
                      id="Group_106226"
                      data-name="Group 106226"
                      transform="translate(0 15.922)"
                    >
                      <rect
                        id="Rectangle_56193"
                        data-name="Rectangle 56193"
                        width="5.237"
                        height="5.857"
                        transform="translate(0.068)"
                        fill="#dfe3e8"
                      />
                      <path
                        id="Path_21041"
                        data-name="Path 21041"
                        d="M104.467,317.03h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,104.467,317.03Z"
                        transform="translate(-104.399 -317.03)"
                        fill="#cbc6e9"
                      />
                    </g>
                  </g>
                  <g
                    id="Group_106228"
                    data-name="Group 106228"
                    transform="translate(13.786 19.677)"
                  >
                    <rect
                      id="Rectangle_56194"
                      data-name="Rectangle 56194"
                      width="5.237"
                      height="5.857"
                      transform="translate(0.068)"
                      fill="#dfe3e8"
                    />
                    <path
                      id="Path_21042"
                      data-name="Path 21042"
                      d="M179.257,337.34h5.205s.157,5.073.571,5.53h-5.205A17.4,17.4,0,0,1,179.257,337.34Z"
                      transform="translate(-179.189 -337.34)"
                      fill="#cbc6e9"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export function ChoosePlanTemplateImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 78,
    height: 70.021,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 78 70.021"
      {...rest}
      sx={rootSx}
    >
      <g id="Checklist-rafiki" transform="translate(-62.426 -78.369)">
        <g id="freepik--Shadow--inject-2" transform="translate(72.11 143.851)">
          <ellipse
            id="freepik--path--inject-2"
            cx="29.656"
            cy="2.27"
            rx="29.656"
            ry="2.27"
            transform="translate(0 0)"
            fill="#f5f5f5"
          />
        </g>
        <g
          id="freepik--Checklist--inject-2"
          transform="translate(74.891 78.369)"
        >
          <rect
            id="Rectangle_56265"
            data-name="Rectangle 56265"
            width="78"
            height="70"
            transform="translate(-12.465)"
            fill="none"
          />
          <path
            id="Path_20957"
            data-name="Path 20957"
            d="M132.2,99.3H85.98l3.042,62.953h46.225Z"
            transform="translate(-85.98 -95.103)"
            fill="#407bff"
          />
          <path
            id="Path_20958"
            data-name="Path 20958"
            d="M132.2,99.3H85.98l3.042,62.953h46.225Z"
            transform="translate(-85.98 -95.103)"
            fill="#aca8bf"
          />
          <path
            id="Path_20959"
            data-name="Path 20959"
            d="M134.335,99.3H88.11l3.044,62.953h46.225Z"
            transform="translate(-87.683 -95.103)"
            fill="#d7d5e2"
          />
          <path
            id="Path_20960"
            data-name="Path 20960"
            d="M140.321,109.86H98.65l2.912,57.99L137.8,167.8l6.022-5.338Z"
            transform="translate(-96.109 -103.545)"
            opacity="0.2"
          />
          <path
            id="Path_20961"
            data-name="Path 20961"
            d="M140.64,109.85a472.155,472.155,0,0,0,4.2,51.908q-4.953,3.409-9.856,6.818H103.82A473.375,473.375,0,0,1,98.65,109.85Z"
            transform="translate(-96.109 -103.537)"
            fill="#fff"
          />
          <path
            id="Path_20962"
            data-name="Path 20962"
            d="M289.706,359.916q-4.953,3.409-9.856,6.818,1.071-4.512,2.232-9.024Z"
            transform="translate(-240.974 -301.695)"
            fill="#ebebeb"
          />
          <path
            id="Path_20963"
            data-name="Path 20963"
            d="M126.826,133.632q.118,3.184.277,6.373h-6.371q-.16-3.188-.277-6.373h6.371m.65-.672H119.76q.134,3.856.335,7.716h7.718q-.2-3.858-.335-7.716Z"
            transform="translate(-112.986 -122.013)"
            fill="#7a67d9"
          />
          <path
            id="Path_20964"
            data-name="Path 20964"
            d="M197.6,142.5H175.776c-.02-.479-.038-.961-.056-1.44h21.819C197.557,141.539,197.577,142.021,197.6,142.5Z"
            transform="translate(-157.725 -128.489)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20965"
            data-name="Path 20965"
            d="M193.483,157.6H176.406c-.022-.481-.046-.961-.066-1.44h17.075Z"
            transform="translate(-158.221 -140.561)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20966"
            data-name="Path 20966"
            d="M129.867,195.872q.2,3.188.447,6.377h-6.373q-.247-3.188-.447-6.377h6.373m.63-.672H122.78q.237,3.86.539,7.72h7.726q-.3-3.858-.541-7.72Z"
            transform="translate(-115.401 -171.773)"
            fill="#7a67d9"
          />
          <path
            id="Path_20967"
            data-name="Path 20967"
            d="M187.037,204.742h-8.021c-.032-.481-.066-.961-.1-1.442h8.021C186.971,203.781,187,204.261,187.037,204.742Z"
            transform="translate(-160.283 -178.248)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20968"
            data-name="Path 20968"
            d="M233.374,204.742h-5.9c-.032-.481-.066-.961-.1-1.442h5.9C233.308,203.781,233.34,204.261,233.374,204.742Z"
            transform="translate(-199.026 -178.248)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20969"
            data-name="Path 20969"
            d="M199.172,219.852h-19.1c-.036-.481-.07-.961-.106-1.442h19.1C199.1,218.891,199.136,219.371,199.172,219.852Z"
            transform="translate(-161.123 -190.328)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20970"
            data-name="Path 20970"
            d="M134.565,258.142q.287,3.188.618,6.377H128.81q-.331-3.188-.618-6.377h6.373m.614-.672H127.46q.341,3.862.746,7.722h7.718Q135.523,261.33,135.178,257.47Z"
            transform="translate(-119.142 -221.556)"
            fill="#7a67d9"
          />
          <path
            id="Path_20971"
            data-name="Path 20971"
            d="M207.093,280.69H185.27l.144,1.44h21.823Z"
            transform="translate(-165.36 -240.12)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20972"
            data-name="Path 20972"
            d="M200.917,265.58H183.84c.044.479.088.961.134,1.44h17.075C201,266.54,200.959,266.065,200.917,265.58Z"
            transform="translate(-164.217 -228.04)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20973"
            data-name="Path 20973"
            d="M140.923,320.412q.373,3.188.788,6.375h-6.373q-.415-3.184-.788-6.375h6.373m.6-.672H133.8q.441,3.862.952,7.718h7.71q-.507-3.856-.952-7.718Z"
            transform="translate(-124.211 -271.339)"
            fill="#7a67d9"
          />
          <path
            id="Path_20974"
            data-name="Path 20974"
            d="M212.4,329.252H190.572c-.058-.481-.116-.961-.172-1.442h21.821C212.279,328.3,212.335,328.777,212.4,329.252Z"
            transform="translate(-169.461 -277.791)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20975"
            data-name="Path 20975"
            d="M202.356,344.39h-9.934c-.062-.479-.122-.961-.182-1.44h9.934C202.234,343.429,202.294,343.911,202.356,344.39Z"
            transform="translate(-170.932 -289.895)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20976"
            data-name="Path 20976"
            d="M254.442,344.39h-4.289c-.062-.479-.122-.961-.182-1.44h4.289C254.319,343.429,254.388,343.911,254.442,344.39Z"
            transform="translate(-217.086 -289.895)"
            fill="#e0e0e0"
          />
          <path
            id="Path_20977"
            data-name="Path 20977"
            d="M130.655,142.2l-.283-.449a7.842,7.842,0,0,0-2.312-2.116l.325-.576a9.124,9.124,0,0,1,2.258,1.939,20.828,20.828,0,0,1,4.371-4.155l.415.541a19.069,19.069,0,0,0-4.492,4.391Z"
            transform="translate(-119.622 -125.115)"
            fill="#7a67d9"
          />
          <path
            id="Path_20978"
            data-name="Path 20978"
            d="M134.191,204.44l-.295-.449a8.149,8.149,0,0,0-2.366-2.118l.307-.576a9.425,9.425,0,0,1,2.312,1.941,19.966,19.966,0,0,1,4.259-4.159c.142.18.287.361.429.543a18.3,18.3,0,0,0-4.373,4.393C134.371,204.157,134.281,204.3,134.191,204.44Z"
            transform="translate(-122.396 -174.875)"
            fill="#7a67d9"
          />
          <path
            id="Path_20979"
            data-name="Path 20979"
            d="M139.431,266.87l-.307-.449a8.466,8.466,0,0,0-2.424-2.116c.1-.2.2-.385.293-.576a9.844,9.844,0,0,1,2.362,1.939,19.318,19.318,0,0,1,4.147-4.159l.445.543a17.692,17.692,0,0,0-4.257,4.393Z"
            transform="translate(-126.529 -224.786)"
            fill="#7a67d9"
          />
          <path
            id="Path_20980"
            data-name="Path 20980"
            d="M162.932,377.018a4.146,4.146,0,0,1-2.466-.822,3.456,3.456,0,0,0-2.118-.718,2.684,2.684,0,0,0-1.915.718,3.209,3.209,0,0,1-2.232.822,4.134,4.134,0,0,1-2.464-.822,3.446,3.446,0,0,0-2.118-.718,2.68,2.68,0,0,0-1.915.718,3.207,3.207,0,0,1-2.23.822,4.151,4.151,0,0,1-2.466-.822,3.451,3.451,0,0,0-2.118-.718c-.026-.2-.054-.385-.08-.578a4.139,4.139,0,0,1,2.464.822,3.449,3.449,0,0,0,2.116.718,2.684,2.684,0,0,0,1.915-.718,3.214,3.214,0,0,1,2.234-.822,4.132,4.132,0,0,1,2.462.822,3.456,3.456,0,0,0,2.118.718,2.684,2.684,0,0,0,1.915-.718,3.215,3.215,0,0,1,2.234-.822,4.139,4.139,0,0,1,2.464.822,3.451,3.451,0,0,0,2.118.718C162.876,376.633,162.906,376.825,162.932,377.018Z"
            transform="translate(-129.815 -315.438)"
            fill="#ebebeb"
          />
          <path
            id="Path_20981"
            data-name="Path 20981"
            d="M169.505,84.124a4.348,4.348,0,0,0-3.928-2.99h-3.433a1.305,1.305,0,0,1-1.193-.8,3.208,3.208,0,0,0-2.922-1.963,2.841,2.841,0,0,0-2.731,1.963,1.159,1.159,0,0,1-1.117.8H150.75a3.85,3.85,0,0,0-3.64,2.99l-.2.716h22.86Z"
            transform="translate(-134.692 -78.369)"
            fill="#5c6266"
          />
          <path
            id="Path_20982"
            data-name="Path 20982"
            d="M167.545,108.54h-22.5a.75.75,0,0,1-.74-.706h0a.668.668,0,0,1,.672-.7h22.5a.75.75,0,0,1,.74.7h0a.668.668,0,0,1-.672.706Z"
            transform="translate(-132.609 -101.363)"
            fill="#407bff"
          />
          <path
            id="Path_20983"
            data-name="Path 20983"
            d="M167.545,108.54h-22.5a.75.75,0,0,1-.74-.706h0a.668.668,0,0,1,.672-.7h22.5a.75.75,0,0,1,.74.7h0a.668.668,0,0,1-.672.706Z"
            transform="translate(-132.609 -101.363)"
            fill="#7a67d9"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export function ChoosePlanNewImage(props) {
  const { rootStyle, ...rest } = props;
  const rootSx = {
    width: 78,
    height: 70,
    ...rootStyle,
  };
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 78 70"
      {...rest}
      sx={rootSx}
    >
      <g id="scratch" transform="translate(-171.5 -81.854)">
        <g id="OBJECTS" transform="translate(183.5 81.854)">
          <g
            id="Group_106182"
            data-name="Group 106182"
            transform="translate(10.675 4.096)"
          >
            <rect
              id="Rectangle_56264"
              data-name="Rectangle 56264"
              width="78"
              height="70"
              transform="translate(-22.675 -4.096)"
              fill="none"
            />
            <line
              id="Line_1592"
              data-name="Line 1592"
              y1="65.05"
              x2="6.073"
              transform="translate(12.251)"
              fill="none"
              stroke="#b0b0b0"
              stroke-width="2"
            />
            <path
              id="Path_20947"
              data-name="Path 20947"
              d="M260.06,397.145l9.247-10.865,9.249,10.865"
              transform="translate(-256.078 -332.095)"
              fill="none"
              stroke="#b0b0b0"
              stroke-width="2"
            />
            <path
              id="Path_20948"
              data-name="Path 20948"
              d="M276.234,153.193H250.22l3.258-34.9h26.014Z"
              transform="translate(-248.122 -115.411)"
              fill="#fafafa"
              stroke="#d7d5e2"
              stroke-width="1"
            />
            <g
              id="Group_106181"
              data-name="Group 106181"
              transform="translate(0 37.782)"
            >
              <rect
                id="Rectangle_56182"
                data-name="Rectangle 56182"
                width="29.131"
                height="1.953"
                transform="translate(2.205)"
                fill="#b0b0b0"
              />
              <rect
                id="Rectangle_56183"
                data-name="Rectangle 56183"
                width="26.431"
                height="1.953"
                fill="#bababa"
              />
            </g>
          </g>
          <g
            id="Group_106183"
            data-name="Group 106183"
            transform="translate(11.362 0)"
          >
            <path
              id="Path_20949"
              data-name="Path 20949"
              d="M249.666,96.732a2.253,2.253,0,0,1,.657-3.13,2.276,2.276,0,0,1,2.941.433,2.23,2.23,0,0,1,.469.917h0l2.156-1.421-5.179-7.861-7.861,5.179,5.179,7.861,2.156-1.421v0a2.244,2.244,0,0,1-.521-.553Z"
              transform="translate(-242.85 -84.939)"
              fill="#7a67d9"
            />
            <circle
              id="Ellipse_129826"
              data-name="Ellipse 129826"
              cx="2.253"
              cy="2.253"
              r="2.253"
              transform="translate(0.826 4.396) rotate(-77.27)"
              fill="#7a67d9"
            />
            <circle
              id="Ellipse_129827"
              data-name="Ellipse 129827"
              cx="2.253"
              cy="2.253"
              r="2.253"
              transform="translate(8.677 6.343) rotate(-86.12)"
              fill="#7a67d9"
            />
          </g>
          <g
            id="Group_106184"
            data-name="Group 106184"
            transform="translate(17.072 12.348)"
          >
            <path
              id="Path_20950"
              data-name="Path 20950"
              d="M276.74,178.479a2.28,2.28,0,0,1-2.221,2.029,1.816,1.816,0,0,1-1.838-2.029,2.28,2.28,0,0,1,2.221-2.029A1.816,1.816,0,0,1,276.74,178.479Z"
              transform="translate(-272.673 -170.688)"
              fill="#bfbcb5"
            />
            <path
              id="Path_20951"
              data-name="Path 20951"
              d="M328.09,178.479a2.28,2.28,0,0,1-2.221,2.029,1.816,1.816,0,0,1-1.838-2.029,2.28,2.28,0,0,1,2.221-2.029A1.816,1.816,0,0,1,328.09,178.479Z"
              transform="translate(-314.192 -170.688)"
              fill="#bfbcb5"
            />
            <ellipse
              id="Ellipse_129828"
              data-name="Ellipse 129828"
              cx="2.127"
              cy="1.936"
              rx="2.127"
              ry="1.936"
              transform="translate(4.543 2.936) rotate(-43.65)"
              fill="#bfbcb5"
            />
            <path
              id="Path_20952"
              data-name="Path 20952"
              d="M285.562,164.91l-.8,8.477h2.326v0a1.955,1.955,0,0,1-.054-.674,2.28,2.28,0,0,1,2.221-2.029,1.816,1.816,0,0,1,1.838,2.029,2.166,2.166,0,0,1-.18.674v0h2.326l.8-8.477Z"
              transform="translate(-282.446 -161.357)"
              fill="#bfbcb5"
            />
          </g>
          <g
            id="Group_106185"
            data-name="Group 106185"
            transform="translate(15.432 21.671)"
          >
            <path
              id="Path_20953"
              data-name="Path 20953"
              d="M288.58,215.458a1.816,1.816,0,0,1-1.838-2.029,2.278,2.278,0,0,1,2.221-2.029,1.91,1.91,0,0,1,.662.117h0l.22-2.326h-8.477l-.8,8.477h8.477l.22-2.326h0A2.112,2.112,0,0,1,288.58,215.458Z"
              transform="translate(-277.418 -206.483)"
              fill="#d6d3cc"
            />
            <ellipse
              id="Ellipse_129829"
              data-name="Ellipse 129829"
              cx="2.127"
              cy="1.936"
              rx="2.127"
              ry="1.936"
              transform="translate(0 7.01) rotate(-43.65)"
              fill="#d6d3cc"
            />
            <path
              id="Path_20954"
              data-name="Path 20954"
              d="M296.6,197.079a1.815,1.815,0,0,0,1.838,2.029,2.277,2.277,0,0,0,2.221-2.029,1.815,1.815,0,0,0-1.838-2.029A2.276,2.276,0,0,0,296.6,197.079Z"
              transform="translate(-290.374 -195.05)"
              fill="#d6d3cc"
            />
          </g>
          <g
            id="Group_106186"
            data-name="Group 106186"
            transform="translate(27.865 15.901)"
          >
            <path
              id="Path_20955"
              data-name="Path 20955"
              d="M330.319,167.119a1.816,1.816,0,0,1,1.838,2.029,2.28,2.28,0,0,1-2.221,2.029,1.91,1.91,0,0,1-.662-.117h0l-.22,2.326h8.477l.8-8.477h-8.477l-.22,2.326h0a2.112,2.112,0,0,1,.685-.117Z"
              transform="translate(-329.05 -164.91)"
              fill="#d6d3cc"
            />
            <ellipse
              id="Ellipse_129830"
              data-name="Ellipse 129830"
              cx="2.127"
              cy="1.936"
              rx="2.127"
              ry="1.936"
              transform="translate(6.68 4.313) rotate(-43.64)"
              fill="#d6d3cc"
            />
            <path
              id="Path_20956"
              data-name="Path 20956"
              d="M344.27,204.149a1.815,1.815,0,0,0-1.838-2.029,2.276,2.276,0,0,0-2.221,2.029,1.815,1.815,0,0,0,1.838,2.029A2.277,2.277,0,0,0,344.27,204.149Z"
              transform="translate(-338.067 -194.996)"
              fill="#d6d3cc"
            />
          </g>
          <line
            id="Line_1593"
            data-name="Line 1593"
            x2="48.679"
            transform="translate(0 69.146)"
            fill="none"
            stroke="#4e505d"
            stroke-width="1"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
